
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return import.meta.resolve($parcel$distDir + url);
}

      var $parcel$global = globalThis;
    
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireef1d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireef1d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hJF0o", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $lzNIT = parcelRequire("lzNIT");

var $elmMK = parcelRequire("elmMK");



var $RXYi2 = parcelRequire("RXYi2");

var $2DcdH = parcelRequire("2DcdH");

var $aRPiL = parcelRequire("aRPiL");
const $70fc9a727fa662ae$var$container = document.getElementById('app');
const $70fc9a727fa662ae$var$root = (0, $aRPiL.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.BrowserRouter), {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2DcdH.PreviousPathProvider), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $RXYi2.DataLayerInfoProvider), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elmMK.default), {})
        })
    })
}));

});
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("lzNIT", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $040dbb9c344a508d$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $040dbb9c344a508d$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("aphAM")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("aphAM")).useNavigate);
/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $2vsP7 = parcelRequire("2vsP7");
var $aphAM = parcelRequire("aphAM");

var $2vsP7 = parcelRequire("2vsP7");
function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2vsP7.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aphAM.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2vsP7.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aphAM.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aphAM.useLocation)();
    let routerState = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $2vsP7.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterContext));
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aphAM.useNavigate)();
    let location = (0, $aphAM.useLocation)();
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2vsP7.createPath)(location) === (0, $2vsP7.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $aphAM.useLocation)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aphAM.useNavigate)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let currentRouteId = (0, $aphAM.UNSAFE_useRouteId)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let routeContext = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !routeContext && (0, $2vsP7.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $aphAM.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aphAM.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2vsP7.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2vsP7.UNSAFE_invariant)(false);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $2vsP7.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let location = (0, $aphAM.useLocation)();
    let matches = (0, $aphAM.useMatches)();
    let navigation = (0, $aphAM.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $2vsP7.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $aphAM.useBlocker)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $2vsP7.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $2vsP7.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2vsP7.matchPath)(path.pathname, nextPath) != null || (0, $2vsP7.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("2vsP7", function(module, exports) {

$parcel$export(module.exports, "Action", () => $1d34d5c4a288b213$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $1d34d5c4a288b213$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $1d34d5c4a288b213$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $1d34d5c4a288b213$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $1d34d5c4a288b213$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $1d34d5c4a288b213$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $1d34d5c4a288b213$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $1d34d5c4a288b213$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $1d34d5c4a288b213$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $1d34d5c4a288b213$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $1d34d5c4a288b213$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $1d34d5c4a288b213$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $1d34d5c4a288b213$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $1d34d5c4a288b213$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $1d34d5c4a288b213$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $1d34d5c4a288b213$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $1d34d5c4a288b213$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $1d34d5c4a288b213$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $1d34d5c4a288b213$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $1d34d5c4a288b213$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $1d34d5c4a288b213$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isAbsoluteUrl = (url)=>$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1d34d5c4a288b213$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("aphAM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $7939e29d663dd3ed$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $7939e29d663dd3ed$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $7939e29d663dd3ed$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $7939e29d663dd3ed$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $7939e29d663dd3ed$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $7939e29d663dd3ed$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $7939e29d663dd3ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $7939e29d663dd3ed$export$9770f232ac06a008);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $7939e29d663dd3ed$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $7939e29d663dd3ed$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $7939e29d663dd3ed$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $7939e29d663dd3ed$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $7939e29d663dd3ed$export$b273b3273281a049);
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", () => $7939e29d663dd3ed$export$db5148ec97d6af7a);
$parcel$export(module.exports, "Router", () => $7939e29d663dd3ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $7939e29d663dd3ed$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Route", () => $7939e29d663dd3ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $7939e29d663dd3ed$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $7939e29d663dd3ed$export$52b333d321859367);
/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $2vsP7 = parcelRequire("2vsP7");
function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $2vsP7.matchPath)(pattern, (0, $2vsP7.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2vsP7.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2vsP7.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $2vsP7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2vsP7.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $2vsP7.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $2vsP7.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2vsP7.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $2vsP7.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $2vsP7.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $2vsP7.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2vsP7.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2vsP7.resolveTo)(to, (0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $2vsP7.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2vsP7.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2vsP7.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $2vsP7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $2vsP7.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $2vsP7.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2vsP7.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("elmMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3e01433251629d$export$2e2bcd8739ae039);
/* eslint-disable no-nested-ternary */ /* eslint-disable no-use-before-define */ /* eslint-disable func-names */ /* eslint-disable no-bitwise */ /* eslint-disable no-unused-expressions */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");


var $hDrpw = parcelRequire("hDrpw");

var $k1YKR = parcelRequire("k1YKR");

var $4KZVo = parcelRequire("4KZVo");

var $iGWsk = parcelRequire("iGWsk");

var $cDDaL = parcelRequire("cDDaL");

var $atdSF = parcelRequire("atdSF");

var $a77Be = parcelRequire("a77Be");

var $cLiYZ = parcelRequire("cLiYZ");

var $cb4KN = parcelRequire("cb4KN");

var $g7KiT = parcelRequire("g7KiT");

var $1sS9G = parcelRequire("1sS9G");

var $2nkQQ = parcelRequire("2nkQQ");

var $9Ryut = parcelRequire("9Ryut");

var $6Pn7K = parcelRequire("6Pn7K");

var $58ODK = parcelRequire("58ODK");

var $lGrX9 = parcelRequire("lGrX9");

var $jVt2v = parcelRequire("jVt2v");

var $iJxY6 = parcelRequire("iJxY6");

var $4zYrm = parcelRequire("4zYrm");

var $tL0U5 = parcelRequire("tL0U5");

var $RXYi2 = parcelRequire("RXYi2");

var $7vUZe = parcelRequire("7vUZe");

var $l19uC = parcelRequire("l19uC");

var $kMrYv = parcelRequire("kMrYv");

var $7mmdw = parcelRequire("7mmdw");

var $bbCv6 = parcelRequire("bbCv6");
/**
 * App should render the main content/component/container for an application
 */ const $7e3e01433251629d$var$App = ()=>{
    const { setDataLayerInfo: setDataLayerInfo } = (0, $RXYi2.useDataLayerInfo)();
    const [sessionId, setSessionId] = (0, $acw62.useState)('');
    const [contactID, setContactID] = (0, $acw62.useState)(null);
    const [financialAdvisorID, setFinancialAdvisorID] = (0, $acw62.useState)(null);
    const [entityID, setEntityID] = (0, $acw62.useState)(null);
    const [timestamp, setTimestamp] = (0, $acw62.useState)(null);
    const [utmSource, setUtmSource] = (0, $acw62.useState)(null);
    const [utmContent, setUtmContent] = (0, $acw62.useState)(null);
    const [callerApp, setCallerApp] = (0, $acw62.useState)(null);
    // eslint-disable-next-line no-unused-vars
    const [contactName, setContactName] = (0, $acw62.useState)({
        firstName: '',
        lastName: ''
    });
    const [initialValuePair, setInitialValuePair] = (0, $acw62.useState)([]);
    const [quizIsStarted, setQuizStarted] = (0, $acw62.useState)(false);
    const [isLoading, setLoading] = (0, $acw62.useState)(true);
    const [isErrorReceivedFromAPI, setIsErrorReceivedFromAPI] = (0, $acw62.useState)(false);
    const [finalResultsIndex, setFinalResultsIndex] = (0, $acw62.useState)([]);
    const [paramsFetched, setParamsFetched] = (0, $acw62.useState)(false);
    const [activeValueList, setActiveValueList] = (0, $acw62.useState)([]);
    const [quizRestarted, setQuizRestarted] = (0, $acw62.useState)(false);
    const [displaySendToFAButton, setDisplaySendToFAButton] = (0, $acw62.useState)(false);
    const [faInfo, setFaInfo] = (0, $acw62.useState)({
        faFirstName: null,
        faLastName: null,
        faPrimaryEmail: null,
        faTeamEmail: null,
        branchNo: null,
        faNo: null,
        faPhoto: null,
        entityIdBase64: null
    });
    const [featureFlags, setFeatureFlags] = (0, $acw62.useState)(null);
    const location = (0, $aphAM.useLocation)();
    const navigate = (0, $aphAM.useNavigate)();
    const urlQuery = (0, $58ODK.default)();
    const [userPersona, setUserPersona] = (0, $acw62.useState)(null);
    const personaTypeArrayUS = Array.of((0, $kMrYv.default).WORD_POWER, (0, $kMrYv.default).NEWS_LETTER, (0, $kMrYv.default).PERSONAL_LINK, (0, $kMrYv.default).PERSONAL_LINK_FA_PROFILE, (0, $kMrYv.default).FINANCIAL_FOUNDATION, (0, $kMrYv.default).DIRECT_URL);
    const [financialPlanningContent, setFinancialPlanningContent] = (0, $acw62.useState)(undefined);
    const locId = (()=>{
        const localeRegex = /^(fr_(CA|ca))|(en_(US|us|CA|ca))$/;
        let locale = (0, $l19uC.LOCALE_EN_US);
        const localeQueryParam = urlQuery.get('locale');
        if (localeQueryParam && localeQueryParam.length === 5 && localeRegex.test(localeQueryParam)) {
            if (localeQueryParam.toLowerCase() === (0, $l19uC.LOCALE_FR_CA).toLowerCase()) locale = (0, $l19uC.LOCALE_FR_CA);
            else if (localeQueryParam.toLowerCase() === (0, $l19uC.LOCALE_EN_CA).toLowerCase()) locale = (0, $l19uC.LOCALE_EN_CA);
            else if (localeQueryParam.toLowerCase() === (0, $l19uC.LOCALE_EN_US).toLowerCase()) locale = (0, $l19uC.LOCALE_EN_US);
        }
        if (window.location.href.includes('.ca')) {
            if (window.location.href.includes((0, $l19uC.MY_PRIORITIES_APP_NAME_FRENCH))) locale = (0, $l19uC.LOCALE_FR_CA);
            else locale = (0, $l19uC.LOCALE_EN_CA);
        }
        return locale;
    })();
    // Prevent React from recreating this function reference when re-rendering
    const handleBeforeUnload = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const removeBeforeUnloadEventListener = ()=>{
        window.removeEventListener('beforeunload', handleBeforeUnload);
    };
    const addBeforeUnloadEventListener = ()=>{
        window.addEventListener('beforeunload', handleBeforeUnload);
    };
    (0, $acw62.useEffect)(()=>{
        getURLParams();
        addBeforeUnloadEventListener();
        const newSessionId = (0, $bbCv6.default)();
        const dataLayerInfo = {
            page_type: 'home-page',
            locale: locId,
            environment: window.ENVIRONMENT,
            sessionId: newSessionId,
            fa_no: urlQuery.get('faNo') ?? undefined,
            fa_entity_id: urlQuery.get('EID') ?? undefined
        };
        setSessionId(newSessionId);
        setDataLayerInfo(dataLayerInfo);
        return ()=>{
            removeBeforeUnloadEventListener();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (paramsFetched) {
            initialFetch();
            getFeaturesFlags();
        }
    }, [
        paramsFetched
    ]);
    (0, $acw62.useEffect)(()=>{
        if (activeValueList.length > 0) setInitialValuePair(determineFirstPair(activeValueList));
    }, [
        activeValueList
    ]);
    (0, $acw62.useEffect)(()=>{
        setQuizStarted(false);
    }, [
        finalResultsIndex
    ]);
    function getURLParams() {
        const queryFaNumber = urlQuery.get('faNo');
        const queryEntityID = urlQuery.get('EID');
        const queryContactID = urlQuery.get('conId');
        const queryCreatedTimestamp = urlQuery.get('creTS');
        const queryUtmSource = urlQuery.get('utm_source');
        const queryUtmContent = urlQuery.get('utm_content');
        const queryCallerAppName = urlQuery.get('callerAppName');
        const queryContactType = !urlQuery.get('conType') ? (0, $jVt2v.default)(queryUtmSource, queryUtmContent) : urlQuery.get('conType');
        setTimestamp(queryCreatedTimestamp);
        setUtmSource(queryUtmSource);
        setUtmContent(queryUtmContent);
        setCallerApp(queryCallerAppName);
        if (queryContactID) setContactID(queryContactID);
        if (queryFaNumber) setFinancialAdvisorID(queryFaNumber);
        if (queryEntityID) setEntityID(queryEntityID);
        setParamsFetched(true);
        setUserPersona((0, $7vUZe.default)(queryFaNumber, queryEntityID, queryContactID, queryContactType, queryCreatedTimestamp, queryUtmSource, locId));
    }
    function initialFetch() {
        (0, $tL0U5.getSchema)(locId, contactID, (0, $lGrX9.default)(utmSource, entityID, financialAdvisorID, contactID), (0, $jVt2v.default)(utmSource, utmContent), financialAdvisorID, entityID).then((res)=>{
            setContactName({
                firstName: res.mpContact.firstName,
                lastName: res.mpContact.lastName
            });
            setActiveValueList(res.fullAssessment.map((value)=>{
                const newValue = {
                    statementId: value.statementId,
                    statementRank: value.statementRank,
                    statementText: value.statementText,
                    learnMoreContent: value.learnMoreContent,
                    learnMoreLinks: value.learnMoreLinks,
                    isActive: value.isDefault || value.isDefault === null,
                    indexId: value.statementId,
                    additionalInfo: value.additionalInfo
                };
                setDisplaySendToFAButton(res.isSendToFAButtonDisplayed);
                res.faInfo && setFaInfo(res.faInfo);
                if (res.faInfo && res.faInfo.entityIdBase64) {
                    // update DataLayer Context with FA info
                    setDataLayerInfo((prev)=>({
                            ...prev,
                            fa_no: res.faInfo.faNo,
                            fa_entity_id: res.faInfo.entityIdBase64,
                            sessionId: sessionId,
                            locale: locId
                        }));
                    setEntityID(res.faInfo.entityIdBase64);
                } else setDataLayerInfo((prev)=>({
                        ...prev,
                        sessionId: sessionId
                    }));
                return newValue;
            }));
            setLoading(false);
        }).catch((error)=>{
            if (error.response && error.response.status === 403) (0, $tL0U5.handleAVIError)(error, locId);
            errorPageCallback();
        });
    }
    function showFPContent() {
        return featureFlags && featureFlags.usFinancialPlanningContentActive && userPersona && personaTypeArrayUS.includes(userPersona);
    }
    function getFeaturesFlags() {
        (0, $tL0U5.isMpUsFinancialPlanningContentActive)().then((res)=>{
            setFeatureFlags({
                ...featureFlags,
                usFinancialPlanningContentActive: res
            });
        }).catch((err)=>/* eslint-disable no-console */ console.error(`Error occured getting features: ${err}\nServing up base model...`));
    }
    function determineFirstPair(valueList) {
        let largest = 0;
        let secondLargest = 0;
        const firstPair = [
            {},
            {}
        ];
        valueList.forEach((value)=>{
            if (value.isActive) {
                if (value.statementRank > secondLargest) {
                    if (value.statementRank > largest) {
                        secondLargest = largest;
                        largest = value.statementRank;
                        firstPair.unshift(value); // add value.statemendId as first ele
                        firstPair.pop(); // remove last ele, keeping 2 elements
                    } else {
                        secondLargest = value.statementRank;
                        firstPair.pop(); // remove last ele
                        firstPair.push(value); // add value.statementId as last ele
                    }
                }
            }
        });
        return firstPair;
    }
    function errorPageCallback() {
        setIsErrorReceivedFromAPI(true);
        navigate((0, $iJxY6.default)(locId, 'errorPath', 'app') + location.search);
    }
    function resetWelcomePage() {
        setQuizStarted(false);
        setIsErrorReceivedFromAPI(false);
    }
    const restartCallback = ()=>{
        window.scroll(0, 0);
        setFinalResultsIndex([]);
        setQuizStarted(false);
        setQuizRestarted(true);
        navigate((0, $iJxY6.default)(locId, 'customizePath', 'app') + location.search);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Pn7K.default).Provider, {
        value: featureFlags,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7mmdw.default).Provider, {
            value: userPersona,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Ryut.default).Provider, {
                value: locId,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    id: "content",
                    "data-testid": "content-wrapper",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "skip-container",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                className: "skip-link",
                                href: "#main-content",
                                children: (0, $iJxY6.default)(locId, 'skipLinkText', 'app')
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4zYrm.default), {
                            addBeforeUnloadEventListener: addBeforeUnloadEventListener,
                            removeBeforeUnloadEventListener: removeBeforeUnloadEventListener
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDrpw.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            id: "main-content",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
                                location: location,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "/",
                                        element: showFPContent() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4KZVo.default), {
                                            customizeBtnCallback: ()=>{
                                                navigate({
                                                    pathname: (0, $iJxY6.default)(locId, 'customizePath', 'app'),
                                                    search: location.search
                                                });
                                            },
                                            isLoading: isLoading
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k1YKR.default), {
                                            contactName: contactName,
                                            customizeBtnCallback: ()=>{
                                                navigate({
                                                    pathname: (0, $iJxY6.default)(locId, 'customizePath', 'app'),
                                                    search: location.search
                                                });
                                            },
                                            isLoading: isLoading
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: (0, $iJxY6.default)(locId, 'customizePath', 'app'),
                                        element: showFPContent() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a77Be.default), {
                                            valueList: activeValueList,
                                            setInitialValuePair: setInitialValuePair,
                                            customizePageBtnCallback: (valueList)=>{
                                                setQuizStarted(true);
                                                setActiveValueList(valueList);
                                                navigate((0, $iJxY6.default)(locId, 'quizPath', 'app') + location.search);
                                            },
                                            restart: quizRestarted,
                                            isLoading: isLoading
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $atdSF.default), {
                                            valueList: activeValueList,
                                            setInitialValuePair: setInitialValuePair,
                                            customizePageBtnCallback: (valueList)=>{
                                                setQuizStarted(true);
                                                setActiveValueList(valueList);
                                                navigate((0, $iJxY6.default)(locId, 'quizPath', 'app') + location.search);
                                            },
                                            restart: quizRestarted,
                                            isLoading: isLoading
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: (0, $iJxY6.default)(locId, 'quizPath', 'app'),
                                        element: quizIsStarted ? showFPContent() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cDDaL.default), {
                                            initialValuePair: initialValuePair,
                                            valueList: activeValueList.filter((value)=>value.isActive),
                                            errorPageCallback: ()=>{
                                                errorPageCallback();
                                            },
                                            finalResultsCallBack: (results)=>{
                                                setFinalResultsIndex(results);
                                                navigate((userPersona !== (0, $kMrYv.default).DIRECT_URL ? (0, $iJxY6.default)(locId, 'planningPath', 'app') : (0, $iJxY6.default)(locId, 'resultsPath', 'app')) + location.search);
                                            }
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iGWsk.default), {
                                            initialValuePair: initialValuePair,
                                            valueList: activeValueList.filter((value)=>value.isActive),
                                            errorPageCallback: ()=>{
                                                errorPageCallback();
                                            },
                                            finalResultsCallBack: (results)=>{
                                                setFinalResultsIndex(results);
                                                navigate((0, $iJxY6.default)(locId, 'resultsPath', 'app') + location.search);
                                            }
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                                            to: {
                                                pathname: (0, $iJxY6.default)(locId, 'resultsPath', 'app'),
                                                search: location.search
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: (0, $iJxY6.default)(locId, 'planningPath', 'app'),
                                        element: (()=>{
                                            if (finalResultsIndex.length !== 0) {
                                                if (showFPContent() && userPersona !== (0, $kMrYv.default).DIRECT_URL) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cLiYZ.default), {
                                                    planningTopicsBtnCallback: ()=>{
                                                        navigate({
                                                            pathname: (0, $iJxY6.default)(locId, 'resultsPath', 'app'),
                                                            search: location.search
                                                        });
                                                    },
                                                    isLoading: isLoading,
                                                    updateFinancialPlanningContent: setFinancialPlanningContent,
                                                    financialPlanningContent: financialPlanningContent ?? undefined
                                                });
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                                                    to: {
                                                        pathname: (0, $iJxY6.default)(locId, 'resultsPath', 'app'),
                                                        search: location.search
                                                    }
                                                });
                                            }
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                                                to: {
                                                    pathname: '/',
                                                    search: location.search
                                                }
                                            });
                                        })()
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: (0, $iJxY6.default)(locId, 'resultsPath', 'app'),
                                        element: finalResultsIndex.length !== 0 ? showFPContent() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sS9G.default), {
                                            contactID: contactID,
                                            contactName: contactName,
                                            financialAdvisorID: financialAdvisorID,
                                            entityID: entityID,
                                            timestamp: timestamp,
                                            callerApp: callerApp,
                                            finalResultsIndex: finalResultsIndex,
                                            valueList: activeValueList.filter((value)=>value.isActive),
                                            sessionId: sessionId,
                                            displaySendToFAButton: displaySendToFAButton,
                                            faInfo: faInfo,
                                            restartCallback: ()=>{
                                                restartCallback();
                                            },
                                            financialPlanningContent: financialPlanningContent,
                                            userPersona: userPersona ?? (0, $kMrYv.default).DIRECT_URL
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g7KiT.default), {
                                            contactID: contactID,
                                            contactName: contactName,
                                            financialAdvisorID: financialAdvisorID,
                                            entityID: entityID,
                                            timestamp: timestamp,
                                            callerApp: callerApp,
                                            finalResultsIndex: finalResultsIndex,
                                            valueList: activeValueList.filter((value)=>value.isActive),
                                            sessionId: sessionId,
                                            displaySendToFAButton: displaySendToFAButton,
                                            faInfo: faInfo,
                                            restartCallback: ()=>{
                                                restartCallback();
                                            }
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                                            to: {
                                                pathname: '/',
                                                search: location.search
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: (0, $iJxY6.default)(locId, 'errorPath', 'app'),
                                        element: isErrorReceivedFromAPI ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb4KN.default), {
                                            quizIsStarted: quizIsStarted,
                                            resetWelcomePage: ()=>{
                                                resetWelcomePage();
                                            }
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                                            to: {
                                                pathname: '/',
                                                search: location.search
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                                            to: {
                                                pathname: '/',
                                                search: location.search
                                            }
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            "data-testid": "footer",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2nkQQ.default), {})
                        })
                    ]
                })
            })
        })
    });
};
var $7e3e01433251629d$export$2e2bcd8739ae039 = $7e3e01433251629d$var$App;

});
parcelRegister("hDrpw", function(module, exports) {

$parcel$export(module.exports, "default", () => $193714fcc8f30367$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $iJxY6 = parcelRequire("iJxY6");

var $9Ryut = parcelRequire("9Ryut");

var $fUEMe = parcelRequire("fUEMe");
/**
 * Header is the top header bar consistent across all screens
 */ const $193714fcc8f30367$var$Header = ()=>{
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
        className: "vp-header",
        "data-testid": "header",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "jonesLogoContainer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: (0, $iJxY6.default)(locId, 'link', 'header'),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    onClick: ()=>(0, $fUEMe.default)('edward_jones_click', {}),
                    "data-testid": "edward-jones-link",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "jonesLogo",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: "/public/images/ej-logo.png",
                            alt: "Edward Jones"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "heading",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: (0, $iJxY6.default)(locId, 'title', 'header')
                })
            })
        ]
    });
};
var $193714fcc8f30367$export$2e2bcd8739ae039 = $193714fcc8f30367$var$Header;

});
parcelRegister("iJxY6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b13152ab32b0d8c$export$2e2bcd8739ae039);
const $6b13152ab32b0d8c$var$enUS = {
    header: {
        title: `My Priorities Quiz`,
        link: `https://www.edwardjones.com`
    },
    app: {
        skipLinkText: 'Skip to main content',
        customizePath: '/customize',
        quizPath: '/quiz',
        resultsPath: '/results',
        errorPath: '/error',
        planningPath: '/planning'
    },
    defaultDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice, financial planning services, or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
    styleModalButton: `Okay, got it!`,
    welcomePage: {
        pageTitle: `My Priorities - Home`,
        header: `Welcome`,
        introPa: `The "My Priorities" quiz helps you compare your priorities.   The results help us get to know you better and dig deeper into the "whys."`,
        customizeInstr: `This three-minute quiz begins with customizing your choices to remove priorities least relevant to you. The quiz will then show you two priorities at a time, and you'll select the one that matters most to you. You may encounter two that feel equally important or some that don't feel applicable at all \u{2013} but don't worry. What you value most will rise to the top.`,
        startBtnLabel: `Start the quiz`,
        customizeBtnLabel: `Customize your quiz`,
        welcomePageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`
    },
    fpWelcomePage: {
        pageTitle: `My Priorities - Home`,
        mainHeader: `What's your ideal life?`,
        mainHeaderParagraph: `Understanding your priorities is the first step to creating your ideal life. This activity will prepare you and your financial advisor to get the most value out of your time together.`,
        ctaSectionHeader: `Get started`,
        ctaSectionHeaderParagraphOneDefault: `This three-minute quiz begins with customizing your choices to remove priorities least relevant to you. The quiz will then show you two priorities at a time, and you'll select the one that matters most to you. You may encounter two that feel equally important or some that don't feel applicable at all \u{2013} but don't worry. What you value most will rise to the top.`,
        ctaSectionHeaderParagraphOneAlternate: `In this quiz, you will complete a short activity to help us understand your ideal lifestyle and how your priorities contribute to a well-rounded life. Then, you will let us know what financial topics interest you, allowing us to have deeper conversations about your needs.`,
        ctaSectionHeaderParagraphTwo: `It is best to do this activity in a quiet place without distractions.`,
        startBtnLabel: `Start`,
        welcomePageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice, financial planning services, or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`
    },
    customizePage: {
        pageTitle: `My Priorities - Customize Quiz`,
        header: `Customize your quiz`,
        description: `Deselect five of the below priorities that are least relevant to you. The quiz uses exactly 11 priorities, so you'll remove exactly five to start the quiz.`,
        startQuiz: `Next`,
        disabledBtnDefault: `Remove 5 more`,
        disabledBtnRemove: `Remove`,
        disabledBtnAdd: `Add`,
        disabledBtnMore: `more`,
        iconButton: 'Why 11?',
        modalTitle: `Why do I need exactly 11 priorities to start the quiz?`,
        modalParagraph1: `You may see more than 11 priorities that you value or you may see less. That's okay!`,
        modalParagraph2: `In order for our quiz to give you your most accurate ranking, it has to have exactly 11, so go with your gut, and do your best to narrow it down to that magic number.`,
        customPriorityInfoModalTitle: `Provide your own customized priority to be included in the quiz.`,
        writeInPlaceHolderText: `add your own priority`
    },
    fpCustomizePage: {
        pageTitle: `My Priorities - Customize Quiz`,
        header: `Your Lifestyle Priorities`,
        description: `Select the 5 priorities that matter least to you and then select Next. This quiz uses exactly 11 lifestyle priorities, so you\u{2019}ll remove five to get started.`,
        startQuiz: `Next`,
        disabledBtnDefault: `Remove 5 more`,
        disabledBtnRemove: `Remove`,
        disabledBtnAdd: `Add`,
        disabledBtnMore: `more`,
        iconButton: 'Why 11?',
        modalTitle: `Why do I need exactly 11 priorities to start the quiz?`,
        modalParagraph1: `You may see more than 11 priorities that you value or you may see less. That's okay!`,
        modalParagraph2: `In order for our quiz to give you your most accurate ranking, it has to have exactly 11, so go with your gut, and do your best to narrow it down to that magic number.`,
        customPriorityInfoModalTitle: `Provide your own customized priority to be included in the quiz.`,
        writeInPlaceHolderText: `add your own priority`,
        customizePageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice, financial planning services, or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`
    },
    modalTitle: 'How does this quiz work?',
    modalParagraph1: "You'll compare two priorities by selecting the one that matters most to you. You may see priorities appear more than once or you may have to choose between two that feel equally important or may not be applicable right now - don't worry. What you value the most will rise to the top.",
    modalParagraph2: "It takes about 25 clicks to complete the quiz. When you're done, your financial advisor and you can discuss how your top priorities can ladder up to your long-term goals.",
    quizPage: {
        pageTitle: `My Priorities - Quiz`,
        header: `Which is a higher priority to you?`,
        tooltipDescription: `Compare the scenarios and click the square that feels more important to you. It's okay if neither one feels applicable. Just choose one and keep going. And don't worry if you see a priority appear more than once - that's how we get to what's most important to you.`,
        chooseOneBoldText: `Choose one priority. `,
        goWithText: `Go with your first reaction! Try to choose in less than 10 seconds.`,
        quizPageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice, financial planning services, or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
        ariaLabelChoiceNumberOne: `Choice number one is `,
        ariaLabelChoiceNumberTwo: `Choice number two is `,
        changePreviousAnswerButtonLabel: `Change Previous Answer`,
        changePreviousAnswerAriaLabel: `Change Previous Answer`,
        progressBarAriaLabel: `Question %QUESTION_NUMBER% of %MAX_QUESTIONS%.`
    },
    planningTopicsPage: {
        pageTitle: `My Priorities - Financial Priorities`,
        header: `Financial priorities`,
        description: `Select at least one topic you would like to discuss with your financial advisor`,
        saveBtnLabel: `Save & Continue`,
        selectInvestmentDecision: `Select one option that best describes how involved you want to be with your investment decisions`,
        advisorOnlyOption: `I like to have investment professionals do it for me`,
        togetherWithAdvisorOption: `I like to work with my advisor and select investments together`,
        myselfOnlyOption: `I like to make investment decisions myself`,
        itDependsOption: `It depends on the type or purpose of my account`,
        unsureOption: `I am unsure about this`,
        planningTopicsPageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice, financial planning services, or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`
    },
    resultsPage: {
        pageTitle: `My Priorities - Results`,
        howYouRankedHeading: `%CONTACT_FIRSTNAME%, here's how you ranked!`,
        howYouRankedHeadingContactUnkown: `Here's how you ranked!`,
        topThreePriorities: `Your top three priorities:`,
        resultsHeading: `Here is your full list of priorities, ranked in order:`,
        whyTheseHeading: `Why are these priorities important to you?`,
        whyTheseLine1: `Take some time to think about how these priorities made it to the top of your list:`,
        whyTheseLine2: `What does this mean for you and/or your family?`,
        whyTheseLine3: `What is missing from the list that is important to you?`,
        whyTheseLine4: `How do these priorities affect you financially?`,
        nowWhatHeading: `So, what can you do with these results?`,
        nowWhatText: `Now that you\u{2019}ve identified your top priorities, we can explore them further to learn how they relate to your financial strategy. You can send me/us a copy of your results and together we'll figure out how your top priorities can ladder up to your long-term goals.`,
        nowWhatText2: `Please feel free to reach out if you have any questions or if you\u{2019}d like to set up a time for us to discuss these results.`,
        faDefaultText: `financial advisor`,
        sendResultsToFA: `Send results to %FA_NAME%`,
        successButton: 'Your results have been sent',
        saveResultsFF: `Go to My Priorities Overview`,
        downloadPdf: `Download as PDF`,
        downloadResults: `Download results`,
        printResults: `Print Results`,
        restartQuiz: `Restart quiz`,
        successMessage: `Thank you for sending your results \u{2013} they have been shared with your financial advisor.`,
        coldContactSuccessMessage: `Thank you for sending your results \u{2013} %FA_NAME% will review them and be in touch.`,
        yourFaDefaultText: 'your financial advisor',
        errorMessage: `We ran into a problem trying to send your results. Please download your results and contact your financial advisor.`,
        saveResultsErrorMessage: `We're sorry, we are unable to save your results at this time. Please try again later.`,
        coldContactErrorMessage: `Oh no! We ran into a problem trying to send your results.  Please download your results and contact %FA_FIRSTNAME%.`,
        timestampErrorTitle: '',
        timestampErrorMessage: "Sorry we can't automatically send out your results at this time. Please download your results and discuss with your local Financial Advisor, or request a new link.",
        resultsPageDisclosure: `The My Priorities quiz is for illustrative purposes only and based on the selections you have made and may vary depending upon how you answer the questions. The results from the quiz may not account for your unique circumstances and do not constitute a recommendation of any investment or strategy type. This information is not intended to offer any financial advice, and additional factors should be considered when determining your goals and financial strategy. The results will have no impact on your financial strategy until you discuss them with your financial advisor. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within your results, please contact your branch to discuss.`,
        learnMoreButton: `Learn more`,
        learnMoreLink: `https://www.edwardjones.com/preparing-for-your-future/index.html`,
        learnMoreText: `Learn more about how your priorities can ladder up to long-term goals.`,
        pdfErrorMessage: `Something went wrong, please try downloading your results again.`,
        findFAButton: `Find a financial advisor`,
        findFALink: `https://www.edwardjones.com/us-en/search/financial-advisor/results`,
        dndHeading: `All 11 priorities: (in order of importance)`,
        dndMessage: `Don't agree with how they're ranked? Drag and drop them in the order you prefer before downloading or sharing them with us.`,
        whatNext: `What's next?`,
        whatNextSendToFaHeading: `Send your results to %FA_NAME%`,
        whatNextDownloadHeading: `Download your results`,
        whatNextSendToFA: `Share your results with %FA_NAME% to discuss how they relate to your financial strategy.`,
        whatNextDownload: `Save your quiz results to look back on later.`,
        shareQuizHeading: 'Share the My Priorities quiz link',
        shareQuizMessage: 'Send the quiz to friends or family, then compare your results.',
        copyLinkButton: 'Copy link',
        linkCopiedSuccessfully: 'Link copied',
        copiedUrl: `${window.location.origin}`,
        shareLink: 'Share link:',
        defaultEmailText: `mailto:?subject=I think you'd like the My Priorities quiz&body=Check out this quiz to compare your priorities and how they relate to your financial strategy: ${window.location.origin}`,
        emailButtonTitle: 'Share via email',
        linkedInUrl: `https://linkedin.com/sharing/share-offsite/?url=${window.location.origin}`,
        faceBookUrl: `https://www.facebook.com/share.php?u=${window.location.origin}`,
        socialMediaTitle: 'Share to %APP_NAME%'
    },
    fpResultsPage: {
        pageTitle: `My Priorities - Results`,
        howYouRankedHeading: `%CONTACT_FIRSTNAME%, here are your rankings!`,
        howYouRankedHeadingContactUnkown: `Here are your rankings!`,
        topThreePriorities: `Your top priorities:`,
        resultsHeading: `Here is your full list of priorities, ranked in order:`,
        whyTheseHeading: `Why are these priorities important to you?`,
        whyTheseLine1: `Take some time to think about how these priorities made it to the top of your list:`,
        whyTheseLine2: `What does this mean for you and/or your family?`,
        whyTheseLine3: `What is missing from the list that is important to you?`,
        whyTheseLine4: `How do these priorities affect you financially?`,
        nowWhatHeading: `So, what can you do with these results?`,
        nowWhatText: `Now that you\u{2019}ve identified your top priorities, we can explore them further to learn how they relate to your financial strategy. You can send me/us a copy of your results and together we'll figure out how your top priorities can ladder up to your long-term goals.`,
        nowWhatText2: `Please feel free to reach out if you have any questions or if you\u{2019}d like to set up a time for us to discuss these results.`,
        faDefaultText: `financial advisor`,
        sendResultsToFA: `Send results to %FA_NAME%`,
        successButton: 'Your results have been sent',
        saveResultsFF: `Go to My Priorities Overview`,
        downloadPdf: `Download as PDF`,
        downloadResults: `Download results`,
        printResults: `Print Results`,
        restartQuiz: `Restart quiz`,
        successMessage: `Thank you for sending your results \u{2013} they have been shared with your financial advisor.`,
        coldContactSuccessMessage: `Thank you for sending your results \u{2013} %FA_NAME% will review them and be in touch.`,
        yourFaDefaultText: 'your financial advisor',
        errorMessage: `We ran into a problem trying to send your results. Please download your results and contact your financial advisor.`,
        saveResultsErrorMessage: `We're sorry, we are unable to save your results at this time. Please try again later.`,
        coldContactErrorMessage: `Oh no! We ran into a problem trying to send your results.  Please download your results and contact %FA_FIRSTNAME%.`,
        timestampErrorTitle: '',
        timestampErrorMessage: "Sorry we can't automatically send out your results at this time. Please download your results and discuss with your local Financial Advisor, or request a new link.",
        resultsPageDisclosure: `The My Priorities quiz is for illustrative purposes only and based on the selections you have made and may vary depending upon how you answer the questions. The results from the quiz may not account for your unique circumstances and do not constitute a recommendation of any investment or strategy type. This information is not intended to offer any financial advice or financial planning services, and additional factors should be considered when determining your goals and financial strategy. The results will have no impact on your financial strategy until you discuss them with your financial advisor. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within your results, please contact your branch to discuss.`,
        learnMoreButton: `Learn more`,
        learnMoreLink: `https://www.edwardjones.com/preparing-for-your-future/index.html`,
        learnMoreText: `Learn more about how your priorities can ladder up to long-term goals.`,
        pdfErrorMessage: `Something went wrong, please try downloading your results again.`,
        findFAButton: `Find a financial advisor`,
        findFALink: `https://www.edwardjones.com/us-en/search/financial-advisor/results`,
        dndHeading: `All 11 priorities: (in order of importance)`,
        dndMessage: `Don't agree with how they're ranked? Drag and drop them in the order you prefer before downloading or sharing them with us.`,
        whatNext: `What's next?`,
        whatNextSendToFaHeading: `Send your results to %FA_NAME%`,
        whatNextDownloadHeading: `Download your results`,
        whatNextGetMatchedHeading: `Get Matched with Advisors Near You`,
        whatNextSendToFA: `Share your results with %FA_NAME% to discuss how they relate to your financial strategy.`,
        whatNextDownload: `Save your quiz results to look back on later.`,
        whatNextGetMatched: `Take three minutes to help us understand your needs and goals and match with financial advisors personalized for you.`,
        whatNextMatchLink: `https://match.edwardjones.com/`,
        whatNextMatchButton: `Start Now`,
        shareQuizHeading: 'Share the My Priorities quiz link',
        shareQuizMessage: 'Send the quiz to friends or family.',
        copyLinkButton: 'Copy link',
        linkCopiedSuccessfully: 'Link copied',
        copiedUrl: `${window.location.origin}`,
        shareLink: 'Share link:',
        defaultEmailText: `mailto:?subject=I think you'd like the My Priorities quiz&body=Check out this quiz to compare your priorities and how they relate to your financial strategy: ${window.location.origin}`,
        emailButtonTitle: 'Share via email',
        linkedInUrl: `https://linkedin.com/sharing/share-offsite/?url=${window.location.origin}`,
        faceBookUrl: `https://www.facebook.com/share.php?u=${window.location.origin}`,
        socialMediaTitle: 'Share to %APP_NAME%',
        selectedPlanningTopis: 'Selected Financial Priorities',
        investmentSelection: 'Based on your investment involvement selection, this statement describes you best:',
        sharedComments: 'What you shared with us:',
        editBtnLabel: 'Edit financial priorities'
    },
    contactFormModal: {
        header: `Share your results with %FA_NAME%`,
        paragraphText: `By providing your name and email, you can share your My Priorities quiz results with %FA_NAME%. They will be in touch to discuss how your priorities can shape your financial strategy.`,
        footerText: `If the advisor you've selected is unavailable, you may hear back from a different Edward Jones financial advisor.`,
        firstNameLabel: 'First Name*',
        lastNameLabel: 'Last Name*',
        missingFirstNameError: 'Please provide your first name',
        missingLastNameError: 'Please provide your last name',
        validFirstNameError: 'Please provide a valid first name.  It can contain the following characters: ',
        validLastNameError: 'Please provide a valid last name.  It can contain the following characters: ',
        emailError: 'Please provide a valid email or phone',
        missingEmailError: 'Please provide a valid email',
        phoneError: 'Please provide a valid phone or email',
        emailLabel: 'Email',
        phoneLabel: 'Phone',
        phoneMask: '(999) 999-9999',
        phoneMaskHelperText: '(999) 999-9999',
        validNameChars: "\u2018\u2019\xb4' -",
        consentLabel: 'I give Edward Jones permission to contact me by email and/or phone*',
        consentError: 'Please provide consent',
        emailMeLabel: 'Email a copy of results to the email address provided above',
        requiredLabel: '*Email or Phone is required',
        defaultText: 'your financial advisor',
        cancelButton: 'Cancel',
        shareResultsButton: 'Share my results'
    },
    commentModal: {
        header: `%CONTACT_FIRSTNAME%, you are sharing your results with %FA_NAME%.`,
        paragraphOneText: `%FA_NAME% will review your My Priorities quiz results and be in touch.`,
        paragraphTwoText: `Anything else you'd like them to know about these results? Leave a comment below.`,
        label: `Comment (optional)`,
        subTextOne: `Max length: %MAX_LENGTH%`,
        subTextTwo: `Characters left: %CHARS_LEFT%`,
        commentError: `Comments cannot contain: `,
        invalidChars: '`~*^[]{}',
        defaultText: `your financial advisor`,
        cancelButton: 'Cancel',
        shareResultsButton: 'Share my results'
    },
    writeInModal: {
        modalTitle: `Enter a priority`,
        modalTextValuelabel: `Add your own priority to be included in the My Priorities quiz`,
        modalParagraph: `Add your own priority to be included in the My Priorities quiz`,
        modalSubTextOne: `Max length: %MAX_LENGTH%`,
        modalSubTextTwo: `Characters left: %CHARS_LEFT%`,
        modalMissingTextValueError: `Please add a priority.`,
        modalTextValueError: `Value cannot contain numbers or special characters.`,
        cancelButton: 'Cancel',
        submitButton: 'Submit',
        writeInPlaceHolderText: `add your own priority`
    },
    errorPage: {
        errorTextLine1: `We're sorry, but something went wrong.`,
        errorTextLine2: `We are working to fix it, please try again later.`,
        returnToWelcomePage: `Return to the `,
        welcomePageLinkText: `Welcome Page`,
        fourOhFour: `404: Page Not Found`
    },
    footer: {
        careersLink: `https://careers.edwardjones.com/`,
        careersText: `Careers`,
        personalFinanceLink: `https://www.edwardjones.com/hidden-assets/active-blog-articles.html`,
        personalFinanceText: `Personal Finance`,
        feedbackLink: `https://www.edwardjones.com/feedback-form.html`,
        feedbackText: `Feedback`,
        privacyLink: `https://www.edwardjones.com/privacy/index.html`,
        privacyText: `Privacy`,
        revenueSharingLink: `https://www.edwardjones.com/sites/default/files/acquiadam/2021-02/revenue-sharing-disclosure.pdf`,
        revenueSharingText: `Revenue Sharing (pdf)`,
        formCrsLink: `https://www.edwardjones.com/us-en/disclosures/best-interest-relationship-summary`,
        formCrsText: `Form CRS`,
        disclosuresLink: `https://www.edwardjones.com/disclosures/index.html`,
        disclosuresText: `Disclosures`,
        accessibilityLink: `https://www.edwardjones.com/us-en/accessibility-policy`,
        accessibilityText: `Accessibility Policy`,
        copyrightParagraph: `Copyright \xa9 %CURRENT_YEAR% Edward Jones. All rights reserved. Member `,
        sipcLink: `https://www.sipc.org/`,
        sipcText: `SIPC`,
        disclaimerParagraph: `This site is designed for U.S. residents only. The services offered within this site are available exclusively through our U.S. financial advisors. Edward Jones' U.S. financial advisors may only conduct business with residents of the states for which they are properly registered. Please note that not all of the investments and services mentioned are available in every state.`
    }
};
const $6b13152ab32b0d8c$var$enCA = {
    header: {
        title: `My Priorities Quiz`,
        link: `https://www.edwardjones.ca`
    },
    app: {
        skipLinkText: 'Skip to main content',
        customizePath: '/customize',
        quizPath: '/quiz',
        resultsPath: '/results',
        errorPath: '/error',
        planningPath: '/planning'
    },
    LanguageSelect: {
        languageSelectLabel: 'Country: ',
        languageSelectTexts: "Canada | English,Canada | Fran\xe7ais",
        languageSelectTextDefault: 'Canada | English',
        languageDialogCancel: 'Cancel/Annuler',
        languageDialogLeave: 'Leave/Sortir',
        languageDialogTitle2: 'Vous perdrez votre progression.',
        languageDialogTitle1: 'You will lose your quiz progress.',
        languageDialogQuestion1: 'Do you want to leave your quiz?',
        languageDialogQuestion2: 'Que souhaitez-vous sortir du questionnaire?'
    },
    defaultDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
    styleModalButton: `Okay, got it!`,
    welcomePage: {
        pageTitle: `My Priorities - Home`,
        header: `Welcome`,
        introPa: `The "My Priorities" quiz helps you compare your priorities.   The results help us get to know you better and dig deeper into the "whys."`,
        customizeInstr: `This three-minute quiz begins with customizing your choices to remove priorities least relevant to you. The quiz will then show you two priorities at a time, and you'll select the one that matters most to you. You may encounter two that feel equally important or some that don't feel applicable at all \u{2013} but don't worry. What you value most will rise to the top.`,
        startBtnLabel: `Start the quiz`,
        customizeBtnLabel: `Customize your quiz`,
        welcomePageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`
    },
    customizePage: {
        pageTitle: `My Priorities - Customize Quiz`,
        header: `Customize your quiz`,
        description: `Deselect five of the below priorities that are least relevant to you. The quiz uses exactly 11 priorities, so you'll remove exactly five to start the quiz.`,
        startQuiz: `Next`,
        disabledBtnDefault: `Remove 5 more`,
        disabledBtnRemove: `Remove`,
        disabledBtnAdd: `Add`,
        disabledBtnMore: `more`,
        iconButton: 'Why 11?',
        modalTitle: `Why do I need exactly 11 priorities to start the quiz?`,
        modalParagraph1: `You may see more than 11 priorities that you value or you may see less. That's okay!`,
        modalParagraph2: `In order for our quiz to give you your most accurate ranking, it has to have exactly 11, so go with your gut, and do your best to narrow it down to that magic number.`,
        customPriorityInfoModalTitle: `Provide your own customized priority to be included in the quiz.`,
        writeInPlaceHolderText: `add your own priority`
    },
    modalTitle: 'How does this quiz work?',
    modalParagraph1: "You'll compare two priorities by selecting the one that matters most to you. You may see priorities appear more than once or you may have to choose between two that feel equally important or may not be applicable right now - don't worry. What you value the most will rise to the top.",
    modalParagraph2: "It takes about 25 clicks to complete the quiz. When you're done, your financial advisor and you can discuss how your top priorities can ladder up to your long-term goals.",
    quizPage: {
        pageTitle: `My Priorities - Quiz`,
        header: `Which is a higher priority to you?`,
        tooltipDescription: `Compare the scenarios and click the square that feels more important to you. It's okay if neither one feels applicable. Just choose one and keep going. And don't worry if you see a priority appear more than once - that's how we get to what's most important to you.`,
        chooseOneBoldText: `Choose one priority. `,
        goWithText: `Go with your first reaction! Try to choose in less than 10 seconds.`,
        quizPageDisclosure: `The My Priorities quiz is meant to help you start a conversation with your financial advisor about what matters most to you. It is intended to be used for illustrative purposes only, and the results will be based on the selections you make. The results are not intended to offer any financial advice or constitute any recommendations. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within the quiz or results, please contact your branch to discuss.`,
        ariaLabelChoiceNumberOne: `Choice number one is `,
        ariaLabelChoiceNumberTwo: `Choice number two is `,
        changePreviousAnswerButtonLabel: `Change Previous Answer`,
        changePreviousAnswerAriaLabel: `Change Previous Answer`,
        progressBarAriaLabel: `Question %QUESTION_NUMBER% of %MAX_QUESTIONS%.`
    },
    resultsPage: {
        pageTitle: `My Priorities - Results`,
        youDidItText: `Based on your selections, here are your top three priorities.`,
        howYouRankedHeading: `%CONTACT_FIRSTNAME%, here's how you ranked!`,
        howYouRankedHeadingContactUnkown: `Here's how you ranked!`,
        topThreePriorities: `Your top three priorities:`,
        resultsHeading: `Here is your full list of priorities, ranked in order:`,
        whyTheseHeading: `Why are these priorities important to you?`,
        whyTheseLine1: `Take some time to think about how these priorities made it to the top of your list:`,
        whyTheseLine2: `What does this mean for you and/or your family?`,
        whyTheseLine3: `What is missing from the list that is important to you?`,
        whyTheseLine4: `How do these priorities affect you financially?`,
        nowWhatHeading: `So, what can you do with these results?`,
        nowWhatText: `Now that you\u{2019}ve identified your top priorities, we can explore them further to learn how they relate to your financial strategy. You can send me/us a copy of your results and together we'll figure out how your top priorities can ladder up to your long-term goals.`,
        nowWhatText2: `Please feel free to reach out if you have any questions or if you\u{2019}d like to set up a time for us to discuss these results.`,
        faDefaultText: `financial advisor`,
        sendResultsToFA: `Send results to %FA_NAME%`,
        successButton: 'Your results have been sent',
        saveResultsFF: `Go to My Priorities Overview`,
        downloadPdf: `Download as PDF`,
        downloadResults: `Download results`,
        printResults: `Print Results`,
        restartQuiz: `Restart quiz`,
        successMessage: `Thank you for sending your results \u{2013} they have been shared with your financial advisor.`,
        saveResultsErrorMessage: `We're sorry, we are unable to save your results at this time. Please try again later.`,
        coldContactSuccessMessage: `Thank you for sending your results \u{2013} %FA_NAME% will review them and be in touch.`,
        yourFaDefaultText: 'your financial advisor',
        errorMessage: `We ran into a problem trying to send your results. Please download your results and contact your financial advisor.`,
        coldContactErrorMessage: `Oh no! We ran into a problem trying to send your results.  Please download your results and contact %FA_FIRSTNAME%.`,
        timestampErrorTitle: '',
        timestampErrorMessage: "Sorry we can't automatically send out your results at this time. Please download your results and discuss with your local Financial Advisor, or request a new link.",
        resultsPageDisclosure: `The My Priorities quiz is for illustrative purposes only and based on the selections you have made and may vary depending upon how you answer the questions. The results from the quiz may not account for your unique circumstances and do not constitute a recommendation of any investment or strategy type. This information is not intended to offer any financial advice, and additional factors should be considered when determining your goals and financial strategy. The results will have no impact on your financial strategy until you discuss them with your financial advisor. The My Priorities quiz does not reflect all possible values you may have in your unique situation. If you believe you have a value not reflected within your results, please contact your branch to discuss.`,
        learnMoreButton: `Learn more`,
        learnMoreLink: `https://www.edwardjones.ca/preparing-for-your-future/index.html`,
        learnMoreText: `Learn more about how your priorities can ladder up to long-term goals.`,
        pdfErrorMessage: `Something went wrong, please try downloading your results again.`,
        findFAButton: `Find a financial advisor`,
        findFALink: `https://www.edwardjones.ca/ca-en/search/financial-advisor/results?query=&distance=50&page=1&view=list`,
        dndHeading: `All 11 priorities: (in order of importance)`,
        dndMessage: `Don't agree with how they're ranked? Drag and drop them in the order you prefer before downloading or sharing them with us.`,
        whatNext: `What's next?`,
        whatNextSendToFaHeading: `Send your results to %FA_NAME%`,
        whatNextDownloadHeading: `Download your results`,
        whatNextSendToFA: `Share your results to %FA_NAME% to discuss how they relate to your financial strategy.`,
        whatNextDownload: `Save your quiz results to look back on later.`,
        shareQuizHeading: 'Share the My Priorities quiz link',
        shareQuizMessage: 'Send the quiz to friends or family, then compare your results.',
        copyLinkButton: 'Copy link',
        linkCopiedSuccessfully: 'Link copied',
        copiedUrl: 'https://mypriorities.edwardjones.ca/',
        shareLink: 'Share link:',
        defaultEmailText: `mailto:?subject=I think you'd like the My Priorities quiz&body=Check out this quiz to compare your priorities and how they relate to your financial strategy: ${window.location.origin}`,
        emailButtonTitle: 'Share via email',
        linkedInUrl: `https://linkedin.com/sharing/share-offsite/?url=${window.location.origin}`,
        faceBookUrl: `https://www.facebook.com/share.php?u=${window.location.origin}`,
        socialMediaTitle: 'Share to %APP_NAME%'
    },
    contactFormModal: {
        header: `Share your results with %FA_NAME%`,
        paragraphText: `By providing your name and email, you can share your My Priorities quiz results with %FA_NAME%. They will be in touch to discuss how your priorities can shape your financial strategy.`,
        footerText: `If the advisor you've selected is unavailable, you may hear back from a different Edward Jones financial advisor.`,
        firstNameLabel: 'First Name*',
        lastNameLabel: 'Last Name*',
        missingFirstNameError: 'Please provide your first name',
        missingLastNameError: 'Please provide your last name',
        validFirstNameError: 'Please provide a valid first name.  It can contain the following characters: ',
        validLastNameError: 'Please provide a valid last name.  It can contain the following characters: ',
        emailError: 'Please provide a valid email or phone',
        missingEmailError: 'Please provide a valid email',
        phoneError: 'Please provide a valid phone or email',
        emailLabel: 'Email',
        phoneLabel: 'Phone',
        phoneMask: '(999) 999-9999',
        phoneMaskHelperText: '(999) 999-9999',
        validNameChars: "\u2018\u2019\xb4' -",
        consentLabel: 'I give Edward Jones permission to contact me by email and/or phone*',
        consentError: 'Please provide consent',
        emailMeLabel: 'Email a copy of results to the email address provided above',
        requiredLabel: '*Email or Phone is required',
        defaultText: 'your financial advisor',
        cancelButton: 'Cancel',
        shareResultsButton: 'Share my results'
    },
    commentModal: {
        header: `%CONTACT_FIRSTNAME%, you are sharing your results with %FA_NAME%.`,
        paragraphOneText: `%FA_NAME% will review your My Priorities quiz results and be in touch.`,
        paragraphTwoText: `Anything else you'd like them to know about these results? Leave a comment below.`,
        label: `Comment (optional)`,
        subTextOne: `Max length: %MAX_LENGTH%`,
        subTextTwo: `Characters left: %CHARS_LEFT%`,
        commentError: `Comments cannot contain: `,
        invalidChars: '`~*^[]{}',
        defaultText: 'your financial advisor',
        cancelButton: 'Cancel',
        shareResultsButton: 'Share my results'
    },
    writeInModal: {
        modalTitle: `Enter a priority`,
        modalTextValuelabel: `Add your own priority to be included in the My Priorities quiz`,
        modalParagraph: `Add your own priority to be included in the My Priorities quiz`,
        modalSubTextOne: `Max length: %MAX_LENGTH%`,
        modalSubTextTwo: `Characters left: %CHARS_LEFT%`,
        modalMissingTextValueError: `Please add a priority.`,
        modalTextValueError: `Value cannot contain numbers or special characters.`,
        cancelButton: 'Cancel',
        submitButton: 'Submit',
        writeInPlaceHolderText: `add your own priority`
    },
    errorPage: {
        errorTextLine1: `We're sorry, but something went wrong.`,
        errorTextLine2: `We are working to fix it, please try again later.`,
        returnToWelcomePage: `Return to the `,
        welcomePageLinkText: `Welcome Page`,
        fourOhFour: `404: Page Not Found`
    },
    footer: {
        careersLink: `https://careers.edwardjones.ca/`,
        careersText: `Careers`,
        feedbackLink: `https://www.edwardjones.ca/feedback-form.html`,
        feedbackText: `Feedback`,
        privacyLink: `https://www.edwardjones.ca/disclosures/account-protection-privacy/privacy-notice.html`,
        privacyText: `Privacy`,
        disclosuresLink: `https://www.edwardjones.ca/disclosures/index.html`,
        disclosuresText: `Disclosures`,
        accessibilityLink: `https://www.edwardjones.ca/ca-en/accessibility-policy`,
        accessibilityText: `Accessibility Policy`,
        member: `Member - `,
        CIPFLink: `https://www.cipf.ca/`,
        CIPFText: `Canadian Investor Protection Fund`,
        member2: `. Member - `,
        IIROCLink: `https://www.ciro.ca/`,
        IIROCText: `Canadian Investment Regulatory Organization`,
        line1: `Welcome to the Edward Jones Website. This site is published in Canada exclusively for residents of Canadian jurisdictions where our products and services may be legally offered. The services offered within this site are available exclusively through our Canadian advisors. Edward Jones' Canadian advisors may only conduct business with residents of the province(s) in which they are registered.`,
        line2: `Copyright \xa9 %CURRENT_YEAR% Edward D. Jones & Co., L.P. Single copies of our Internet pages may be downloaded or printed solely for personal use. It is otherwise prohibited to modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information, software, products or services obtained from this site. Edward Jones\xae is a registered trademark of Edward D. Jones & Co., L.P.`,
        line3: `Edward Jones is a limited partnership in Canada and is a wholly owned subsidiary of Edward D. Jones & Co., LP, a Missouri limited partnership. Edward D. Jones & Co., LP is a wholly owned subsidiary of The Jones Financial Companies, LLLP, a limited liability limited partnership.`,
        line4: `Edward Jones and its independent affiliate in the United States, collectively, serve nearly 7 million investors.`,
        line5: `*In Quebec, our advisors are known as Investment Advisors.`
    }
};
const $6b13152ab32b0d8c$var$frCA = {
    header: {
        title: `Questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb`,
        link: `https://www.edwardjones.ca/ca-fr`
    },
    app: {
        skipLinkText: 'Passer au contenu principal',
        customizePath: '/customisez',
        quizPath: '/questionnaire',
        resultsPath: '/resultats',
        errorPath: '/erreur',
        planningPath: '/planning'
    },
    LanguageSelect: {
        languageSelectLabel: 'Pays: ',
        languageSelectTexts: "Canada | English,Canada | Fran\xe7ais",
        languageSelectTextDefault: "Canada | Fran\xe7ais",
        languageDialogCancel: 'Annuler/Cancel',
        languageDialogLeave: 'Sortir/Leave',
        languageDialogTitle2: 'You will lose your quiz progress.',
        languageDialogTitle1: 'Vous perdrez votre progression.',
        languageDialogQuestion1: 'Que souhaitez-vous sortir du questionnaire',
        languageDialogQuestion2: 'Do you want to leave your quiz?'
    },
    defaultDisclosure: `Le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb a pour but de vous aider \xe0 engager une conversation avec votre conseiller en investissement \xe0 propos de ce qui est le plus important pour vous. Il est destin\xe9 \xe0 \xeatre utilis\xe9 \xe0 titre purement illustratif, et les r\xe9sultats seront bas\xe9s sur les choix que vous ferez. Les r\xe9sultats ne sont pas destin\xe9s \xe0 fournir des conseils financiers ni \xe0 donner une quelconque recommandation. Le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb ne refl\xe8te pas toutes les priorit\xe9s possibles dans votre situation. Si vous pensez avoir une priorit\xe9 qui n\u{2019}est pas refl\xe9t\xe9e dans le questionnaire ou les r\xe9sultats, veuillez prendre contact avec votre succursale pour en discuter.`,
    styleModalButton: `Allons-y!`,
    welcomePage: {
        pageTitle: `Mes priorit\xe9s - accueil`,
        header: `Bienvenue`,
        introPa: `Le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb vous aide \xe0 comparer vos priorit\xe9s. Les r\xe9sultats nous aident \xe0 mieux vous conna\xeetre et \xe0 approfondir les pourquois.`,
        customizeInstr: `Ce questionnaire de trois minutes commence par la personnalisation de vos choix afin de supprimer les priorit\xe9s les moins pertinentes pour vous. Le questionnaire vous montrera ensuite deux priorit\xe9s \xe0 la fois et vous choisirez celle qui compte le plus pour vous. Il se peut que vous en rencontriez deux qui paraissent aussi importantes l\u{2019}une que l\u{2019}autre ou certaines qui ne vous semblent pas applicables du tout \u{2013} mais ne vous inqui\xe9tez pas. Ce qui vous importe le plus se retrouvera au premier plan.`,
        startBtnLabel: `Commencer le questionnaire`,
        customizeBtnLabel: `Personnalisez votre questionnaire`,
        welcomePageDisclosure: `Le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb a pour but de vous aider \xe0 engager une conversation avec votre conseiller en investissement \xe0 propos de ce qui est le plus important pour vous. Il est destin\xe9 \xe0 \xeatre utilis\xe9 \xe0 titre purement illustratif, et les r\xe9sultats seront bas\xe9s sur les choix que vous ferez. Les r\xe9sultats ne sont pas destin\xe9s \xe0 fournir des conseils financiers ni \xe0 donner une quelconque recommandation. Le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb ne refl\xe8te pas toutes les priorit\xe9s possibles dans votre situation. Si vous pensez avoir une priorit\xe9 qui n\u{2019}est pas refl\xe9t\xe9e dans le questionnaire ou les r\xe9sultats, veuillez prendre contact avec votre succursale pour en discuter.`
    },
    customizePage: {
        pageTitle: `Mes priorit\xe9s - personnalisez`,
        header: `Personnalisez votre questionnaire`,
        description: `S\xe9lectionnez cinq des priorit\xe9s ci-dessous qui sont les moins pertinentes pour vous. Le questionnaire utilise exactement 11 priorit\xe9s, vous devrez donc en retirer exactement cinq pour commencer le questionnaire.`,
        startQuiz: `Suivant`,
        disabledBtnDefault: `Retirez 5 de plus`,
        disabledBtnRemove: `Retirez`,
        disabledBtnAdd: `Ajoutez`,
        disabledBtnMore: `de plus`,
        iconButton: 'Pourquoi 11?',
        modalTitle: `Pourquoi faut-il exactement 11 priorit\xe9s pour lancer le questionnaire?`,
        modalParagraph1: `Il se peut que vous voyiez plus de 11 priorit\xe9s auxquelles vous accordez de l\u{2019}importance ou que vous en voyiez moins. D\u{2019}accord!`,
        modalParagraph2: `Pour que notre questionnaire vous donne le classement le plus pr\xe9cis, il doit comporter exactement 11 \xe9l\xe9ments, alors fiez-vous \xe0 votre instinct et faites de votre mieux pour le ramener \xe0 ce chiffre magique.`,
        customPriorityInfoModalTitle: `Indiquez votre priorit\xe9 personnalis\xe9e \xe0 inclure dans le questionnaire.`,
        writeInPlaceHolderText: `ajoutez votre propre priorit\xe9`
    },
    modalTitle: 'Comment ce questionnaire fonctionne-t-il?',
    modalParagraph1: "Vous comparerez deux priorit\xe9s en s\xe9lectionnant celle qui vous semble la plus importante. Il se peut que vous voyiez des priorit\xe9s appara\xeetre plus d\u2019une fois ou que vous deviez choisir entre deux qui vous semblent aussi importantes l\u2019une que l\u2019autre ou qui ne sont pas n\xe9cessairement applicables dans l\u2019imm\xe9diat \u2013 ne vous inqui\xe9tez pas. Ce qui vous importe le plus se retrouvera au premier plan.",
    modalParagraph2: "Il faut environ 25 \xe9tapes pour compl\xe9ter le questionnaire. Lorsque vous aurez termin\xe9, votre conseiller en investissement et vous pourrez discuter de la mani\xe8re dont vos principales priorit\xe9s peuvent vous permettre d\u2019atteindre vos objectifs \xe0 long terme.",
    quizPage: {
        pageTitle: `Mes priorit\xe9s - questionnaire`,
        header: `Quelle est la priorit\xe9 la plus importante pour vous?`,
        tooltipDescription: `Comparez les sc\xe9narios et cochez la case qui vous semble la plus importante. Ce n\u{2019}est pas grave si aucun des deux ne semble pertinent. Choisissez-en une et continuez. Et ne vous inqui\xe9tez pas si une m\xeame priorit\xe9 appara\xeet plus qu\u{2019}une fois \u{2013} c\u{2019}est ainsi que nous arrivons \xe0 ce qui est le plus important pour vous.`,
        chooseOneBoldText: `Choisissez une priorit\xe9. `,
        goWithText: `Allez-y avec votre premier instinct! Faites un choix en moins de 10 secondes.`,
        quizPageDisclosure: `Le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb a pour but de vous aider \xe0 engager une conversation avec votre conseiller en investissement \xe0 propos de ce qui est le plus important pour vous. Il est destin\xe9 \xe0 \xeatre utilis\xe9 \xe0 titre purement illustratif, et les r\xe9sultats seront bas\xe9s sur les choix que vous ferez. Les r\xe9sultats ne sont pas destin\xe9s \xe0 fournir des conseils financiers ni \xe0 donner une quelconque recommandation. Le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb ne refl\xe8te pas toutes les priorit\xe9s possibles dans votre situation. Si vous pensez avoir une priorit\xe9 qui n\u{2019}est pas refl\xe9t\xe9e dans le questionnaire ou les r\xe9sultats, veuillez prendre contact avec votre succursale pour en discuter.`,
        ariaLabelChoiceNumberOne: `Le premier choix est `,
        ariaLabelChoiceNumberTwo: `Le deuxi\xe8me choix est `,
        changePreviousAnswerButtonLabel: `Modifier la r\xe9ponse pr\xe9c\xe9dente`,
        changePreviousAnswerAriaLabel: `Modifier la r\xe9ponse pr\xe9c\xe9dente`,
        progressBarAriaLabel: `Question %QUESTION_NUMBER% de %MAX_QUESTIONS%.`
    },
    resultsPage: {
        pageTitle: `Mes priorit\xe9s - r\xe9sultats`,
        youDidItText: `D\u{2019}apr\xe8s choix, voici vos trois principales priorit\xe9s.`,
        howYouRankedHeading: `%CONTACT_FIRSTNAME%, voici votre classement!`,
        howYouRankedHeadingContactUnkown: `Voici votre classement!`,
        topThreePriorities: `Vos trois principales priorit\xe9s\xa0:`,
        resultsHeading: `Voici la liste compl\xe8te de vos priorit\xe9s class\xe9es selon leur rang\xa0:`,
        whyTheseHeading: `Pourquoi ces priorit\xe9s sont-elles importantes pour vous?`,
        whyTheseLine1: `Prenez le temps de r\xe9fl\xe9chir \xe0 la raison pour laquelle ces priorit\xe9s se sont retrouv\xe9es en t\xeate de liste\xa0:`,
        whyTheseLine2: `Qu\u{2019}est-ce que cela signifie pour vous et votre famille?`,
        whyTheseLine3: `Qu\u{2019}est-ce qui manque dans la liste et qui a de l\u{2019}importance pour vous?`,
        whyTheseLine4: `Quel impact ces priorit\xe9s ont-elles sur votre situation financi\xe8re?`,
        nowWhatHeading: `Et maintenant, que pouvez-vous faire avec ces r\xe9sultats?`,
        nowWhatText: `Maintenant que vous avez d\xe9termin\xe9 vos principales priorit\xe9s, nous pouvons les explorer davantage pour mieux comprendre leur lien avec votre strat\xe9gie financi\xe8re. Vous pouvez me/nous faire parvenir une copie de vos r\xe9sultats et, ensemble, nous pourrons comment vos principales priorit\xe9s peuvent vous permettre d\u{2019}atteindre vos objectifs \xe0 long terme.`,
        nowWhatText2: `N\u{2019}h\xe9sitez pas \xe0 communiquer avec nous si vous avez des questions ou pour prendre rendez-vous afin de discuter de ces r\xe9sultats.`,
        faDefaultText: `un conseiller en investissement`,
        sendResultsToFA: `Envoyer les r\xe9sultats \xe0 %FA_NAME%`,
        successButton: "Vos r\xe9sultats ont \xe9t\xe9 envoy\xe9s",
        saveResultsFF: `Go to My Priorities Overview`,
        downloadPdf: `T\xe9l\xe9chargez en format PDF`,
        downloadResults: `T\xe9l\xe9chargez les r\xe9sultats`,
        printResults: `Imprimer les r\xe9sultats`,
        restartQuiz: `Red\xe9marrer le questionnaire`,
        successMessage: `Merci d\u{2019}avoir envoy\xe9 vos r\xe9sultats \u{2013} ils ont \xe9t\xe9 communiqu\xe9s \xe0 votre conseiller en investissement.`,
        saveResultsErrorMessage: `Nous sommes d\xe9sol\xe9s, mais nous ne sommes pas en mesure d\u{2019}enregistrer vos r\xe9sultats pour le moment. Veuillez r\xe9essayer plus tard.`,
        coldContactSuccessMessage: `Merci d\u{2019}avoir envoy\xe9 vos r\xe9sultats \u{2013} %FA_NAME% en prendra connaissance et communiquera avec vous.`,
        yourFaDefaultText: 'votre conseiller en investissement',
        errorMessage: `Nous avons rencontr\xe9 un probl\xe8me lors de l\u{2019}envoi de vos r\xe9sultats. Veuillez t\xe9l\xe9chargez vos r\xe9sultats et communiquer avec votre conseiller en investissement.`,
        coldContactErrorMessage: `Oh, non! Nous avons rencontr\xe9 un probl\xe8me lors de l\u{2019}envoi de vos r\xe9sultats. Veuillez t\xe9l\xe9chargez vos r\xe9sultats et communiquer avec %FA_FIRSTNAME%.`,
        timestampErrorTitle: '',
        timestampErrorMessage: "Nous sommes d\xe9sol\xe9s, mais il nous est impossible d\u2019envoyer vos r\xe9sultats automatiquement pour le moment. Veuillez t\xe9l\xe9chargez vos r\xe9sultats pour en discuter avec votre conseiller en investissement local ou demandez un nouveau lien.",
        resultsPageDisclosure: `Le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb a pour but de vous aider \xe0 engager une conversation avec votre conseiller en investissement \xe0 propos de ce qui est le plus important pour vous. Il est destin\xe9 \xe0 \xeatre utilis\xe9 \xe0 titre purement illustratif, et les r\xe9sultats seront bas\xe9s sur les choix que vous ferez. Les r\xe9sultats ne sont pas destin\xe9s \xe0 fournir des conseils financiers ni \xe0 donner une quelconque recommandation. Le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb ne refl\xe8te pas toutes les priorit\xe9s possibles dans votre situation.  Si vous pensez avoir une priorit\xe9 qui n\u{2019}est pas refl\xe9t\xe9e dans le questionnaire ou les r\xe9sultats, veuillez prendre contact avec votre succursale pour en discuter.`,
        learnMoreButton: `En savoir plus`,
        learnMoreLink: `https://www.edwardjones.ca/ca-fr/pourquoi-choisir-edward-jones/notre-approche-en-matiere-de-placement`,
        learnMoreText: `Apprenez-en davantage sur la fa\xe7on dont vos priorit\xe9s peuvent vous permettre d\u{2019}atteindre vos objectifs \xe0 long terme.`,
        pdfErrorMessage: `Un probl\xe8me est survenu; veuillez r\xe9essayer de t\xe9l\xe9chargez vos r\xe9sultats.`,
        findFAButton: `Trouver un conseiller en investissement`,
        findFALink: `https://www.edwardjones.ca/ca-fr/search/financial-advisor/results`,
        dndHeading: `Les 11 priorit\xe9s\xa0: (par ordre d\u{2019}importance)`,
        dndMessage: `Vous n\u{2019}\xeates pas d\u{2019}accord avec la fa\xe7on dont elles sont class\xe9es? Faites-les glisser et d\xe9posez-les dans l\u{2019}ordre que vous pr\xe9f\xe9rez avant de les t\xe9l\xe9charger ou de les partager avec nous.`,
        whatNext: `Quelle est la prochaine \xe9tape?`,
        whatNextSendToFaHeading: `Envoyez vos r\xe9sultats \xe0 %FA_NAME%`,
        whatNextDownloadHeading: `T\xe9l\xe9chargez vos r\xe9sultats`,
        whatNextSendToFA: `Veuillez envoyer vos r\xe9sultats \xe0 %FA_NAME% pour discuter de leur lien avec votre strat\xe9gie financi\xe8re.`,
        whatNextDownload: `Enregistrez vos r\xe9sultats du questionnaire pour y revoir vos priorit\xe9s.`,
        shareQuizHeading: "Partagez le lien vers le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb",
        shareQuizMessage: "Envoyez le questionnaire \xe0 vos amis ou \xe0 votre famille et comparez vos r\xe9sultats.",
        copyLinkButton: 'Copier le lien',
        linkCopiedSuccessfully: "Lien copi\xe9",
        copiedUrl: 'https://mespriorites.edwardjones.ca',
        shareLink: 'Partager le lien\xa0:',
        defaultEmailText: `mailto:?subject=Je crois que le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb pourrait vous int\xe9resser.&body=Utilisez ce questionnaire pour comparer vos priorit\xe9s et examiner leur lien avec votre strat\xe9gie financi\xe8re\xa0: ${window.location.origin}`,
        emailButtonTitle: 'Partager par courriel',
        linkedInUrl: `https://linkedin.com/sharing/share-offsite/?url=${window.location.origin}`,
        faceBookUrl: `https://www.facebook.com/share.php?u=${window.location.origin}`,
        socialMediaTitle: 'Partager sur %APP_NAME%'
    },
    contactFormModal: {
        header: `Partagez vos r\xe9sultats avec %FA_NAME%`,
        paragraphText: `En indiquant votre nom et votre adresse courriel, vous pouvez partager vos r\xe9sultats du questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb avec %FA_NAME%. Ce conseiller communiquera avec vous pour discuter de la fa\xe7on dont vos priorit\xe9s peuvent orienter votre strat\xe9gie financi\xe8re.`,
        footerText: `Si le conseiller que vous avez choisi n\u{2019}est pas disponible, il est possible qu\u{2019}un autre conseiller en investissement Edward Jones communique avec vous.`,
        firstNameLabel: "Pr\xe9nom*",
        lastNameLabel: 'Nom de famille*',
        missingFirstNameError: "Veuillez entrer votre pr\xe9nom",
        missingLastNameError: 'Veuillez entrer votre nom de famille',
        validFirstNameError: "Veuillez entrer votre pr\xe9nom. Vous pouvez utiliser les caract\xe8res suivants\xa0: ",
        validLastNameError: "Veuillez entrer votre nom de famille. Vous pouvez utiliser les caract\xe8res suivants\xa0: ",
        emailError: "Veuillez fournir une adresse courriel ou un num\xe9ro de t\xe9l\xe9phone valide",
        missingEmailError: 'Veuillez fournir une adresse courriel valide',
        phoneError: "Veuillez fournir une adresse courriel ou un num\xe9ro de t\xe9l\xe9phone valide",
        emailLabel: 'Adresse courriel',
        phoneLabel: "T\xe9l\xe9phone",
        phoneMask: '(999) 999-9999',
        phoneMaskHelperText: '(999) 999-9999',
        validNameChars: "\u2018\u2019\xb4' -",
        consentLabel: "J\u2019autorise Edward Jones \xe0 communiquer avec moi par courriel ou par t\xe9l\xe9phone*",
        consentError: 'Veuillez donner votre consentement',
        emailMeLabel: "Envoyez une copie des r\xe9sultats par courriel \xe0 l\u2019adresse indiqu\xe9e ci-dessus",
        requiredLabel: "*Adresse courriel ou num\xe9ro de t\xe9l\xe9phone requis",
        defaultText: 'votre conseiller en investissement',
        cancelButton: 'Annuler',
        shareResultsButton: "Partager mes r\xe9sultats"
    },
    commentModal: {
        header: `%CONTACT_FIRSTNAME%, vous partagez vos r\xe9sultats avec %FA_NAME%.`,
        paragraphOneText: `%FA_NAME% passera en revue les r\xe9sultats de votre questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb et communiquera avec vous.`,
        paragraphTwoText: `Y a-t-il autre chose que vous aimeriez qu\u{2019}il sache \xe0 propos de ces r\xe9sultats? Laissez un commentaire ci-dessous.`,
        label: `Commentaire (facultatif)`,
        subTextOne: `Longueur maximum\xa0: %MAX_LENGTH%`,
        subTextTwo: `Caract\xe8res restants\xa0: %CHARS_LEFT%`,
        commentError: `Les commentaires ne peuvent pas contenir\xa0: `,
        invalidChars: '`~*^[]{}',
        defaultText: 'votre conseiller en investissement',
        cancelButton: 'Annuler',
        shareResultsButton: "Partager mes r\xe9sultats"
    },
    writeInModal: {
        modalTitle: `Entrez une priorit\xe9`,
        modalTextValuelabel: `Ajoutez votre propre priorit\xe9 \xe0 inclure dans le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb`,
        modalParagraph: `Ajoutez votre propre priorit\xe9 \xe0 inclure dans le questionnaire \xab\xa0\xa0Mes priorit\xe9s\xa0\xa0\xbb`,
        modalSubTextOne: `Longueur maximum\xa0: %MAX_LENGTH%`,
        modalSubTextTwo: `Caract\xe8res restants\xa0: %CHARS_LEFT%`,
        modalMissingTextValueError: `Veuillez ajouter un priorit\xe9.`,
        modalTextValueError: `La valeur ne peut contenir ni chiffres ni caract\xe8res sp\xe9ciaux.`,
        cancelButton: 'Annuler',
        submitButton: 'Soumettre',
        writeInPlaceHolderText: `ajoutez votre propre priorit\xe9`
    },
    errorPage: {
        errorTextLine1: `Nous sommes d\xe9sol\xe9s, mais un probl\xe8me est survenu.`,
        errorTextLine2: `Nous travaillons \xe0 le r\xe9soudre. Veuillez r\xe9essayer plus tard.`,
        returnToWelcomePage: `Retour \xe0 la `,
        welcomePageLinkText: `Page d\u{2019}accueil`,
        fourOhFour: `404: Page non trouv\xe9e`
    },
    footer: {
        careersLink: `https://careers.edwardjones.com/fr-CA/`,
        careersText: `Carri\xe8res`,
        feedbackLink: `https://www.edwardjones.ca/ca-fr/nous-contacter`,
        feedbackText: `Commentaires`,
        privacyLink: `https://www.edwardjones.ca/ca-fr/divulgations/protection-du-compte-et-confidentialite/avis-de-confidentialite`,
        privacyText: `Confidentialit\xe9`,
        disclosuresLink: `https://www.edwardjones.ca/ca-fr/divulgations`,
        disclosuresText: `Divulgations`,
        accessibilityLink: `https://www.edwardjones.ca/ca-fr/politique-surlaccessibilite`,
        accessibilityText: `Politique sur l\u{2019}accessibilit\xe9`,
        member: `Membre - `,
        CIPFLink: `https://www.fcpi.ca/accueil`,
        CIPFText: `le Fonds canadien de protection des \xe9pargnants`,
        member2: `. Membre - `,
        IIROCLink: `https://www.ocri.ca/`,
        IIROCText: `Organisme canadien de r\xe9glementation des investissements`,
        line1: `Bienvenue au site Web Edward Jones. Ce site est publi\xe9 au Canada uniquement \xe0 l'intention des r\xe9sidents des comp\xe9tences territoriales du Canada o\xf9 la loi nous autorise \xe0 offrir nos produits et services. Les services offerts dans ce site peuvent \xeatre obtenus exclusivement par l'entremise des conseillers en investissement Edward Jones du Canada, lesquels ne peuvent entrer en relation d'affaires qu'avec les r\xe9sidents de la ou des provinces o\xf9 ils sont autoris\xe9s.`,
        line2: `Tous droits r\xe9serv\xe9s \xa9 %CURRENT_YEAR% Edward D. Jones & Co., L.P. Des copies uniques de nos pages Internet peuvent \xeatre t\xe9l\xe9charg\xe9es ou imprim\xe9es pour usage personnel seulement. Autrement, il est interdit de modifier, copier, distribuer, transmettre, afficher, ex\xe9cuter, reproduire, publier, c\xe9der ou consentir une licence, cr\xe9er des \u{153}uvres d\xe9riv\xe9es \xe0 partir de, transf\xe9rer ou vendre toute information, tout logiciel, tout produit ou service obtenu \xe0 partir de ce site.`,
        line3: `Edward Jones, soci\xe9t\xe9 en commandite \xe9tablie au Canada, est une filiale en propri\xe9t\xe9 exclusive de Edward D. Jones & Co., LP, soci\xe9t\xe9 en commandite du Missouri. Edward D. Jones & Co., L.P. est une filiale en propri\xe9t\xe9 exclusive de The Jones Financial Companies, LLLP, une soci\xe9t\xe9 en commandite \xe0 responsabilit\xe9 limit\xe9e.`,
        line4: `Edward Jones MD est une marque d\xe9pos\xe9e de Edward D. Jones & Co., L.P. Edward Jones et sa soci\xe9t\xe9 affili\xe9e ind\xe9pendante aux \xc9tats-Unis desservent ensemble pr\xe8s de 7 millions d'investisseurs.`,
        line5: `*Au Qu\xe9bec, nos conseillers sont d\xe9sign\xe9s sous le nom de conseillers en investissement.`
    }
};
function $6b13152ab32b0d8c$export$2e2bcd8739ae039(locId, component, page) {
    switch(locId){
        case 'en_US':
            return page ? $6b13152ab32b0d8c$var$enUS[page][component] : $6b13152ab32b0d8c$var$enUS[component];
        case 'en_CA':
            return page ? $6b13152ab32b0d8c$var$enCA[page][component] : $6b13152ab32b0d8c$var$enCA[component];
        case 'fr_CA':
            return page ? $6b13152ab32b0d8c$var$frCA[page][component] : $6b13152ab32b0d8c$var$frCA[component];
        default:
            return page ? $6b13152ab32b0d8c$var$enUS[page][component] : $6b13152ab32b0d8c$var$enUS[component];
    }
}

});

parcelRegister("9Ryut", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2593508866c240$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $1c2593508866c240$var$LocaleContext = (0, $acw62.createContext)('');
var $1c2593508866c240$export$2e2bcd8739ae039 = $1c2593508866c240$var$LocaleContext;

});

parcelRegister("fUEMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $584a046a042f6e68$export$2e2bcd8739ae039);
const $584a046a042f6e68$var$addDataLayerTrigger = (name, props)=>{
    if ('dataLayer' in window && Array.isArray(window.dataLayer)) window.dataLayer.push({
        event: name,
        ...props
    });
};
var $584a046a042f6e68$export$2e2bcd8739ae039 = $584a046a042f6e68$var$addDataLayerTrigger;

});


parcelRegister("k1YKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd8c393f73dc911b$export$2e2bcd8739ae039);
/* eslint-disable no-use-before-define */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $4dB0L = parcelRequire("4dB0L");

var $iJxY6 = parcelRequire("iJxY6");

var $9Ryut = parcelRequire("9Ryut");


var $fUEMe = parcelRequire("fUEMe");

var $3qYM8 = parcelRequire("3qYM8");

var $2DcdH = parcelRequire("2DcdH");

var $RXYi2 = parcelRequire("RXYi2");
/**
 * WelcomePage is the introductory screen for the quiz
 */ const $dd8c393f73dc911b$var$WelcomePage = (props)=>{
    const { contactName: contactName, customizeBtnCallback: customizeBtnCallback, isLoading: isLoading } = props;
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const [showModal, setShowModal] = (0, $acw62.useState)(false);
    const modalHeaderText = (0, $iJxY6.default)(locId, 'modalTitle', null);
    const modalParagraphText1 = (0, $iJxY6.default)(locId, 'modalParagraph1', null);
    const modalParagraphText2 = (0, $iJxY6.default)(locId, 'modalParagraph2', null);
    const { setPreviousPath: setPreviousPath, previousPath: previousPath } = (0, $2DcdH.usePreviousPath)();
    const currentLocation = (0, $aphAM.useLocation)();
    const pageTitle = (0, $iJxY6.default)(locId, 'pageTitle', 'welcomePage');
    const pageReferrer = previousPath ? `${window.location.origin}${previousPath}${currentLocation.search}` : undefined;
    const pageURL = `${window.location.origin}${currentLocation.pathname}${currentLocation.search}`;
    const virtualPageInfo = {
        'pagePath': currentLocation.pathname,
        'pageTitle': pageTitle,
        'page_referrer': pageReferrer,
        'external_referrer': window.document.referrer && window.document.referrer.trim() !== '' ? window.document.referrer : undefined,
        'page_url': pageURL
    };
    const { dataLayerInfo: dataLayerInfo } = (0, $RXYi2.useDataLayerInfo)();
    const updatesFPPlanningTopics = {
        ...dataLayerInfo,
        'page_type': 'welcome-page'
    };
    (0, $acw62.useEffect)(()=>{
        document.title = pageTitle;
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!isLoading) {
            setPreviousPath(currentLocation.pathname);
            (0, $fUEMe.default)('dataLayer-initialized', updatesFPPlanningTopics);
            (0, $fUEMe.default)('VirtualPageview', virtualPageInfo);
            dataLayerScroll();
        }
    }, [
        isLoading
    ]);
    function dataLayerScroll() {
        let timeout;
        window.addEventListener('scroll', ()=>{
            if (timeout) window.clearTimeout(timeout);
            timeout = window.setTimeout(scrollEvent, 100);
        }, true);
    }
    function scrollEvent() {
        const footerLocation = document.querySelector('footer').getBoundingClientRect();
        if (footerLocation.top >= 0 && footerLocation.left >= 0 && footerLocation.bottom <= (window.innerHeight || document.documentElement.clientHeight) && footerLocation.right <= (window.innerWidth || document.documentElement.clientWidth)) (0, $fUEMe.default)('footer-visible', {});
    }
    return isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: "spinner",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dB0L.default), {
            animation: "border"
        })
    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "WelcomePage",
                "data-testid": "WelcomePage",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "WelcomePage_content",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "WelcomePage_left",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "WelcomePage_left_container",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                        id: "heading-no-focus",
                                        className: "heading--semi-bold",
                                        children: [
                                            (0, $iJxY6.default)(locId, 'header', 'welcomePage'),
                                            contactName.firstName ? ` ${contactName.firstName}` : null,
                                            "!"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "WelcomePage_p",
                                        children: (0, $iJxY6.default)(locId, 'introPa', 'welcomePage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "WelcomePage_p WelcomePage_p--secondary",
                                        children: (0, $iJxY6.default)(locId, 'customizeInstr', 'welcomePage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                                        label: (0, $iJxY6.default)(locId, 'startBtnLabel', 'welcomePage'),
                                        styleVariant: "primary",
                                        onClick: ()=>{
                                            (0, $fUEMe.default)('to-customize-page', {});
                                            customizeBtnCallback();
                                        },
                                        attributes: {
                                            value: '',
                                            id: 'customize-quiz-button'
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "WelcomePage_right",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "image-frame",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: "/public/images/welcome_image.png",
                                            alt: "",
                                            role: "presentation"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "modal-button-wrapper",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "modal-button",
                                                role: "button",
                                                onClick: ()=>{
                                                    setShowModal(true);
                                                },
                                                onKeyDown: (event)=>{
                                                    if (event.keyCode === 13 || event.keyCode === 32) setShowModal(true);
                                                },
                                                tabIndex: 0,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Icon), {
                                                        name: "help-question-mark"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "modal-button-text",
                                                        children: (0, $iJxY6.default)(locId, 'modalTitle', null)
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3qYM8.default), {
                                    displayModal: showModal,
                                    closeModalHandler: ()=>setShowModal(false),
                                    headerText: modalHeaderText,
                                    paragraphText1: modalParagraphText1,
                                    paragraphText2: modalParagraphText2
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "footer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "disclaimer",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "microcopy--2",
                        children: (0, $iJxY6.default)(locId, 'welcomePageDisclosure', 'welcomePage')
                    })
                })
            })
        ]
    });
};
$dd8c393f73dc911b$var$WelcomePage.defaultProps = {
    contactName: {
        firstNa: '',
        lastNa: ''
    }
};
$dd8c393f73dc911b$var$WelcomePage.propTypes = {
    contactName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    // eslint-disable-next-line react/no-unused-prop-types
    customizeBtnCallback: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};
var $dd8c393f73dc911b$export$2e2bcd8739ae039 = $dd8c393f73dc911b$var$WelcomePage;

});
parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("7lk71", function(module, exports) {

$parcel$export(module.exports, "Button", () => $558a1874964eed3d$export$353f5b6fc5456de1);
$parcel$export(module.exports, "Checkbox", () => $558a1874964eed3d$export$48513f6b9f8ce62d);
$parcel$export(module.exports, "Dialog", () => $558a1874964eed3d$export$3ddf2d174ce01153);
$parcel$export(module.exports, "Icon", () => $558a1874964eed3d$export$f04a61298a47a40f);
$parcel$export(module.exports, "InfoTooltip", () => $558a1874964eed3d$export$dbdcde5ca046596e);
$parcel$export(module.exports, "InlineNotification", () => $558a1874964eed3d$export$cae1c58733dbe1ed);
$parcel$export(module.exports, "MaskedInput", () => $558a1874964eed3d$export$dec03dc0f3ef8025);
$parcel$export(module.exports, "RadioGroup", () => $558a1874964eed3d$export$a98f0dcb43a68a25);
$parcel$export(module.exports, "SelectInput", () => $558a1874964eed3d$export$d6701e98ab1a6725);
$parcel$export(module.exports, "TextArea", () => $558a1874964eed3d$export$f5c9f3c2c4054eec);
$parcel$export(module.exports, "TextInput", () => $558a1874964eed3d$export$c86715117507e8e5);

var $ayMG0 = parcelRequire("ayMG0");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $a3QyA = parcelRequire("a3QyA");

var $gmF1g = parcelRequire("gmF1g");

var $6IdRn = parcelRequire("6IdRn");

var $5sKyw = parcelRequire("5sKyw");

var $b5weT = parcelRequire("b5weT");

var $1u0KT = parcelRequire("1u0KT");

var $dHBXt = parcelRequire("dHBXt");
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$AiSparkleSm = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.53,9.38c.28,0,.52.19.58.46,0,0,0,0,0,0,0,0,0,.01,0,.03,0,.02.02.06.03.1.03.09.07.21.12.35.11.29.25.55.37.67.12.12.38.26.67.37.13.05.26.09.35.12.04.01.08.02.1.03.01,0,.02,0,.03,0,0,0,0,0,0,0,.27.07.45.31.46.58,0,.24-.14.46-.36.55l-.1.03s-.01,0-.03,0c-.02,0-.06.02-.1.03-.09.03-.21.07-.35.12-.29.11-.55.25-.67.37-.12.12-.26.38-.37.67-.05.13-.09.26-.12.35-.01.04-.02.08-.03.1,0,.01,0,.02,0,.03l-.03.1c-.09.22-.31.36-.55.36-.28,0-.52-.19-.58-.46,0,0,0,0,0,0,0,0,0-.01,0-.03,0-.02-.02-.06-.03-.1-.03-.09-.07-.21-.12-.35-.11-.29-.25-.55-.37-.67-.12-.12-.38-.26-.67-.37-.13-.05-.26-.09-.35-.12-.04-.01-.08-.02-.1-.03-.01,0-.02,0-.03,0,0,0,0,0,0,0h0c-.27-.07-.46-.31-.46-.58,0-.28.19-.52.46-.58h0s.01,0,.03,0c.02,0,.06-.02.1-.03.09-.03.21-.07.35-.12.29-.11.55-.25.67-.37.12-.12.26-.38.37-.67.05-.13.09-.26.12-.35.01-.04.02-.08.03-.1,0-.01,0-.02,0-.03h0s.03-.1.03-.1c.09-.22.31-.36.55-.36ZM6.19,3.03c.28,0,.52.19.58.46,0,0,0,0,0,0,0,0,0,0,0,.02,0,.02.01.04.02.07.02.06.04.16.08.27.07.23.17.55.3.89.28.72.65,1.48,1.08,1.91.43.43,1.19.81,1.91,1.08.35.13.66.24.89.3.11.03.21.06.27.08.03,0,.06.02.07.02,0,0,.01,0,.02,0,0,0,0,0,0,0l.1.03c.21.09.36.31.36.55,0,.28-.19.52-.46.58h0s0,0-.02,0c-.02,0-.04.01-.07.02-.06.02-.16.04-.27.08-.23.07-.55.17-.89.3-.72.28-1.48.65-1.91,1.08-.43.43-.81,1.19-1.08,1.91-.13.35-.24.66-.3.89-.03.11-.06.21-.08.27,0,.03-.01.06-.02.07,0,0,0,.01,0,.02,0,0,0,0,0,0l-.03.1c-.09.22-.31.36-.55.36-.28,0-.52-.19-.58-.46,0,0,0,0,0,0,0,0,0,0,0-.02,0-.02-.01-.04-.02-.07-.02-.06-.04-.16-.08-.27-.07-.23-.17-.55-.3-.89-.28-.72-.65-1.48-1.08-1.91-.43-.43-1.19-.81-1.91-1.08-.35-.13-.66-.23-.89-.3-.11-.03-.21-.06-.27-.08-.03,0-.06-.02-.07-.02,0,0-.01,0-.02,0,0,0,0,0,0,0-.27-.07-.46-.31-.46-.58,0-.28.19-.52.46-.58,0,0,0,0,0,0,0,0,0,0,.02,0,.02,0,.04-.01.07-.02.06-.02.16-.04.27-.08.23-.07.55-.17.89-.3.72-.28,1.48-.65,1.91-1.08.43-.43.81-1.19,1.08-1.91.13-.35.24-.66.3-.89.03-.11.06-.21.08-.27,0-.03.01-.06.02-.07,0,0,0-.01,0-.02,0,0,0,0,0,0l.03-.1c.09-.22.31-.36.55-.36ZM11.88,1.18c.28,0,.52.19.58.46h0s0,0,0,0c0,0,0,.02,0,.03,0,.03.02.07.04.13.03.11.08.26.14.42.14.35.3.68.47.85.17.17.5.34.85.47.16.06.32.11.43.14.05.02.1.03.13.04.01,0,.03,0,.03,0h0c.27.07.46.31.46.58,0,.28-.19.52-.46.58,0,0,0,0,0,0,0,0-.02,0-.03,0-.03,0-.07.02-.13.04-.11.03-.26.08-.42.14-.35.14-.68.3-.85.47-.17.17-.34.5-.47.85-.06.16-.11.32-.14.42-.02.05-.03.1-.04.13,0,.01,0,.03,0,.03,0,0,0,0,0,0h0c-.07.27-.31.46-.58.46-.28,0-.52-.19-.58-.46,0,0,0,0,0,0,0,0,0-.02,0-.03,0-.03-.02-.07-.04-.13-.03-.11-.08-.26-.14-.42-.14-.35-.3-.68-.47-.85-.17-.17-.5-.34-.85-.47-.16-.06-.32-.11-.43-.14-.05-.02-.1-.03-.13-.04-.01,0-.03,0-.03,0,0,0,0,0,0,0-.27-.07-.46-.31-.46-.58,0-.28.19-.52.46-.58h0s.02,0,.03,0c.03,0,.07-.02.13-.04.11-.03.26-.08.42-.14.35-.14.68-.3.85-.47.17-.17.34-.5.47-.85.06-.16.11-.32.14-.42.02-.05.03-.1.04-.13,0-.01,0-.03,0-.03,0,0,0,0,0,0h0s0,0,0,0c.07-.27.31-.46.58-.46Z"
        })
    });
var $558a1874964eed3d$var$AiSparkleSm$1 = $558a1874964eed3d$var$AiSparkleSm;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$AiSparkle = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M19.42,14.44c.41,0,.77.28.87.68,0,0,0,0,0,0,0,0,0,.02.01.04,0,.04.02.09.04.15.04.13.1.32.18.52.17.44.37.82.56,1.01.19.19.57.39,1.01.56.2.08.39.14.52.18.07.02.12.04.16.05h.05c.4.11.68.47.68.89,0,.41-.28.77-.68.87h0s-.05.01-.05.01c-.04,0-.09.03-.16.05-.13.04-.32.1-.52.18-.44.17-.82.37-1.01.56-.19.19-.39.57-.56,1.01-.08.2-.14.39-.18.52-.02.07-.04.12-.04.16,0,.02,0,.03,0,.04,0,0,0,0,0,0h0c-.1.4-.46.68-.87.68-.41,0-.77-.28-.87-.68h0s0,0,0,0c0,0,0-.02-.01-.04,0-.04-.02-.09-.04-.16-.04-.13-.1-.32-.18-.52-.17-.44-.37-.82-.56-1.01-.19-.19-.57-.39-1.01-.56-.2-.08-.39-.14-.52-.18-.07-.02-.12-.04-.15-.05-.02,0-.03,0-.04,0,0,0,0,0,0,0h0c-.4-.1-.68-.46-.68-.87,0-.41.28-.77.68-.87h0s.02,0,.04-.01c.04,0,.09-.03.16-.05.13-.04.32-.1.52-.18.44-.17.82-.37,1.01-.56.19-.19.39-.57.56-1.01.08-.2.14-.39.18-.52.02-.07.03-.12.04-.15,0-.02,0-.03.01-.04h0s.05-.15.05-.15c.14-.32.46-.54.82-.54ZM9.53,4.55c.41,0,.77.28.87.68h0s0,0,0,0c0,0,0,.01,0,.03,0,.02.02.06.03.11.03.09.06.23.11.4.1.34.26.82.46,1.34.41,1.08.97,2.21,1.62,2.86.65.65,1.78,1.21,2.86,1.62.52.2,1,.35,1.34.46.17.05.31.09.41.12l.13.03s0,0,0,0l.14.05c.32.14.54.46.54.82,0,.41-.28.77-.68.87h0s-.01,0-.03,0c-.02,0-.06.02-.11.03-.09.03-.23.06-.41.12-.34.1-.82.26-1.34.46-1.08.41-2.21.97-2.86,1.62-.65.65-1.21,1.78-1.62,2.86-.2.52-.35,1-.46,1.34-.05.17-.09.31-.11.4-.01.05-.02.08-.03.11,0,.01,0,.02,0,.03,0,0,0,0,0,0l-.05.14c-.14.32-.46.54-.82.54-.41,0-.77-.28-.87-.68,0,0,0,0,0,0,0,0,0-.01,0-.03,0-.02-.02-.06-.03-.11-.03-.09-.06-.23-.12-.4-.1-.34-.26-.82-.46-1.34-.41-1.08-.98-2.21-1.62-2.86-.65-.65-1.78-1.21-2.86-1.62-.52-.2-1-.35-1.34-.46-.17-.05-.31-.09-.4-.12-.05-.01-.08-.02-.11-.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.4-.1-.68-.46-.68-.87,0-.41.28-.77.68-.87h0s.01,0,.03,0c.02,0,.06-.01.11-.03.09-.03.23-.06.4-.12.34-.1.82-.26,1.34-.46,1.08-.41,2.21-.98,2.86-1.62.65-.65,1.21-1.78,1.62-2.86.2-.52.35-1,.46-1.34.05-.17.09-.31.12-.4.01-.05.02-.08.03-.11,0-.01,0-.02,0-.03,0,0,0,0,0,0h0s.05-.14.05-.14c.14-.32.46-.54.82-.54ZM19.42,17.64c-.12.18-.25.34-.39.49-.15.15-.31.27-.49.39.18.12.34.25.49.39s.28.31.39.49c.12-.17.25-.34.39-.49.15-.15.31-.28.49-.39-.17-.12-.34-.24-.49-.39-.15-.15-.28-.32-.39-.49ZM9.53,8.25c-.43,1.02-1.03,2.19-1.83,2.99-.8.8-1.98,1.41-2.99,1.83,1.02.43,2.19,1.03,2.99,1.83.8.8,1.4,1.97,1.83,2.99.43-1.02,1.03-2.19,1.83-2.99.8-.8,1.97-1.41,2.99-1.83-1.02-.43-2.19-1.03-2.99-1.83-.8-.8-1.41-1.97-1.83-2.99ZM18.07,1.4c.41,0,.77.28.87.68h0s0,0,0,.01c0,.01,0,.03.01.05.01.04.03.11.05.19.05.16.12.39.22.64.2.53.46,1.02.71,1.27.25.25.74.51,1.27.71.25.09.47.17.64.22.08.02.15.04.19.05.02,0,.04,0,.05.01h.01c.4.1.68.46.68.88,0,.41-.28.77-.68.87h0s0,0-.01,0c-.01,0-.03,0-.05.01-.04.01-.11.03-.19.05-.16.05-.39.12-.64.22-.53.2-1.02.46-1.27.71-.25.25-.51.74-.71,1.27-.09.25-.17.47-.22.64-.02.08-.04.15-.05.19,0,.02,0,.04-.01.05,0,0,0,0,0,0h0c-.1.4-.46.69-.87.69-.41,0-.77-.28-.87-.68h0s0,0,0-.01c0-.01,0-.03-.01-.05-.01-.04-.03-.11-.05-.19-.05-.16-.12-.39-.22-.64-.2-.53-.46-1.02-.71-1.27-.25-.25-.74-.51-1.27-.71-.25-.09-.47-.17-.64-.22-.08-.02-.15-.04-.19-.05-.02,0-.04-.01-.05-.01,0,0,0,0,0,0h0c-.4-.1-.68-.46-.68-.87,0-.41.28-.77.68-.87h0s0,0,0,0c.01,0,.03,0,.05-.01.04-.01.11-.03.19-.05.16-.05.39-.12.64-.22.53-.2,1.02-.46,1.27-.71.25-.25.51-.74.71-1.27.09-.25.17-.47.22-.64.02-.08.04-.15.05-.19,0-.02.01-.04.01-.05,0,0,0,0,0-.01h0s0,0,0,0c.1-.4.46-.68.87-.68ZM18.07,4.72c-.17.29-.37.57-.6.8-.23.23-.51.43-.8.6.29.17.57.37.8.6.23.23.43.51.6.8.17-.29.37-.57.6-.8.23-.23.51-.43.8-.6-.29-.17-.57-.37-.8-.6-.23-.23-.43-.51-.6-.8Z"
        })
    });
var $558a1874964eed3d$var$AiSparkle$1 = $558a1874964eed3d$var$AiSparkle;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$AttachmentPaperclip = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M20.845 9.72l-9.148 9.148a4.875 4.875 0 0 1-6.894-6.894l7.513-7.513a3 3 0 1 1 4.251 4.233L9.045 16.22a1.125 1.125 0 0 1-1.582-1.6l7.505-7.506a.75.75 0 0 0-1.06-1.06l-7.514 7.515a2.625 2.625 0 1 0 3.703 3.72l7.522-7.525a4.5 4.5 0 1 0-6.372-6.354l-7.505 7.503a6.375 6.375 0 1 0 9.016 9.016l9.147-9.149a.75.75 0 1 0-1.06-1.06z"
        })
    });
var $558a1874964eed3d$var$AttachmentPaperclip$1 = $558a1874964eed3d$var$AttachmentPaperclip;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Avatar$2 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 12.5a8.875 8.875 0 0 1 8.875 8.875.75.75 0 1 1-1.5 0 7.375 7.375 0 0 0-14.75 0 .75.75 0 1 1-1.5 0A8.875 8.875 0 0 1 12 12.5zm0-10.625a5.125 5.125 0 1 1 0 10.25 5.125 5.125 0 0 1 0-10.25zm0 1.5a3.625 3.625 0 1 0 0 7.25 3.625 3.625 0 0 0 0-7.25z"
        })
    });
var $558a1874964eed3d$var$Avatar$3 = $558a1874964eed3d$var$Avatar$2;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$BuildingGeneric = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.10901 7.078C2.10901 6.66379 2.4448 6.328 2.85901 6.328H21.14C21.5542 6.328 21.89 6.66379 21.89 7.078V22.547C21.89 22.9612 21.5542 23.297 21.14 23.297H2.85901C2.4448 23.297 2.10901 22.9612 2.10901 22.547V7.078ZM3.60901 7.828V21.797H20.39V7.828H3.60901Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.77247 18.2095C10.1768 17.8052 10.7252 17.578 11.297 17.578H12.704C13.2758 17.578 13.8242 17.8052 14.2285 18.2095C14.6328 18.6138 14.86 19.1622 14.86 19.734V22.547C14.86 22.9612 14.5242 23.297 14.11 23.297H9.89099C9.47678 23.297 9.14099 22.9612 9.14099 22.547V19.734C9.14099 19.1622 9.36814 18.6138 9.77247 18.2095ZM11.297 19.078C11.123 19.078 10.9562 19.1471 10.8331 19.2701C10.7101 19.3932 10.641 19.56 10.641 19.734V21.797H13.36V19.734C13.36 19.56 13.2909 19.3932 13.1679 19.2701C13.0448 19.1471 12.878 19.078 12.704 19.078H11.297Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.672 9.14099C6.08621 9.14099 6.422 9.47678 6.422 9.89099V11.297C6.422 11.7112 6.08621 12.047 5.672 12.047C5.25778 12.047 4.922 11.7112 4.922 11.297V9.89099C4.922 9.47678 5.25778 9.14099 5.672 9.14099Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.89099 9.14099C10.3052 9.14099 10.641 9.47678 10.641 9.89099V11.297C10.641 11.7112 10.3052 12.047 9.89099 12.047C9.47678 12.047 9.14099 11.7112 9.14099 11.297V9.89099C9.14099 9.47678 9.47678 9.14099 9.89099 9.14099Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.109 9.14099C14.5232 9.14099 14.859 9.47678 14.859 9.89099V11.297C14.859 11.7112 14.5232 12.047 14.109 12.047C13.6948 12.047 13.359 11.7112 13.359 11.297V9.89099C13.359 9.47678 13.6948 9.14099 14.109 9.14099Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.328 9.14099C18.7422 9.14099 19.078 9.47678 19.078 9.89099V11.297C19.078 11.7112 18.7422 12.047 18.328 12.047C17.9138 12.047 17.578 11.7112 17.578 11.297V9.89099C17.578 9.47678 17.9138 9.14099 18.328 9.14099Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.672 13.359C6.08621 13.359 6.422 13.6948 6.422 14.109V15.515C6.422 15.9292 6.08621 16.265 5.672 16.265C5.25778 16.265 4.922 15.9292 4.922 15.515V14.109C4.922 13.6948 5.25778 13.359 5.672 13.359Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.89099 13.359C10.3052 13.359 10.641 13.6948 10.641 14.109V15.515C10.641 15.9292 10.3052 16.265 9.89099 16.265C9.47678 16.265 9.14099 15.9292 9.14099 15.515V14.109C9.14099 13.6948 9.47678 13.359 9.89099 13.359Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.109 13.359C14.5232 13.359 14.859 13.6948 14.859 14.109V15.515C14.859 15.9292 14.5232 16.265 14.109 16.265C13.6948 16.265 13.359 15.9292 13.359 15.515V14.109C13.359 13.6948 13.6948 13.359 14.109 13.359Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.328 13.359C18.7422 13.359 19.078 13.6948 19.078 14.109V15.515C19.078 15.9292 18.7422 16.265 18.328 16.265C17.9138 16.265 17.578 15.9292 17.578 15.515V14.109C17.578 13.6948 17.9138 13.359 18.328 13.359Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.703003 7.078C0.703003 6.66379 1.03879 6.328 1.453 6.328H22.547C22.9612 6.328 23.297 6.66379 23.297 7.078C23.297 7.49222 22.9612 7.828 22.547 7.828H1.453C1.03879 7.828 0.703003 7.49222 0.703003 7.078Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.03619 1.15964C4.41517 0.863741 4.88219 0.70301 5.363 0.703003H18.637C19.1176 0.703352 19.5848 0.864239 19.9634 1.16012C20.3421 1.45599 20.6111 1.8699 20.7276 2.3361L21.8676 6.8961C21.9236 7.12016 21.8733 7.35752 21.7312 7.53956C21.589 7.7216 21.371 7.828 21.14 7.828H2.85902C2.62806 7.828 2.40999 7.7216 2.26786 7.53956C2.12573 7.35752 2.07539 7.12016 2.13141 6.8961L3.27141 2.3361C3.27141 2.3361 3.27141 2.3361 3.27141 2.3361C3.38802 1.86964 3.65721 1.45555 4.03619 1.15964ZM5.36302 2.203C5.21672 2.20301 5.07463 2.25191 4.95932 2.34194C4.84401 2.43198 4.7621 2.55797 4.72662 2.6999L3.8196 6.328H20.1794L19.2724 2.6999C19.2369 2.55805 19.1551 2.43211 19.0399 2.34209C18.9247 2.2521 18.7828 2.20315 18.6367 2.203H5.36302C5.36301 2.203 5.36302 2.203 5.36302 2.203Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.672 17.578C6.08621 17.578 6.422 17.9138 6.422 18.328V19.734C6.422 20.1482 6.08621 20.484 5.672 20.484C5.25778 20.484 4.922 20.1482 4.922 19.734V18.328C4.922 17.9138 5.25778 17.578 5.672 17.578Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.328 17.578C18.7422 17.578 19.078 17.9138 19.078 18.328V19.734C19.078 20.1482 18.7422 20.484 18.328 20.484C17.9138 20.484 17.578 20.1482 17.578 19.734V18.328C17.578 17.9138 17.9138 17.578 18.328 17.578Z"
            })
        ]
    });
var $558a1874964eed3d$var$BuildingGeneric$1 = $558a1874964eed3d$var$BuildingGeneric;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$BuildingInstitution = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20.71,21.42H.71C.32,21.42,0,21.1,0,20.7s.32-.71.71-.71h20c.39,0,.71.32.71.71s-.32.71-.71.71Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20.71,7.13H.71c-.32,0-.6-.21-.69-.52-.08-.31.05-.64.32-.8L9.58.32c.65-.42,1.6-.43,2.3.01l9.21,5.48c.28.16.41.49.32.8-.08.31-.37.52-.69.52ZM3.31,5.7h14.8L11.12,1.54c-.27-.17-.56-.16-.79-.01L3.31,5.7Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M19.29,18.56h-2.86c-.39,0-.71-.32-.71-.71v-8.57c0-.39.32-.71.71-.71s.71.32.71.71v7.86h1.43v-7.86c0-.39.32-.71.71-.71s.71.32.71.71v8.57c0,.39-.32.71-.71.71Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12.14,18.56h-2.86c-.39,0-.71-.32-.71-.71v-8.57c0-.39.32-.71.71-.71s.71.32.71.71v7.86h1.43v-7.86c0-.39.32-.71.71-.71s.71.32.71.71v8.57c0,.39-.32.71-.71.71Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M5,18.56h-2.86c-.39,0-.71-.32-.71-.71v-8.57c0-.39.32-.71.71-.71s.71.32.71.71v7.86h1.43v-7.86c0-.39.32-.71.71-.71s.71.32.71.71v8.57c0,.39-.32.71-.71.71Z"
            })
        ]
    });
var $558a1874964eed3d$var$BuildingInstitution$1 = $558a1874964eed3d$var$BuildingInstitution;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Calculator = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M18.125 1.875a2 2 0 0 1 2 2v16.25a2 2 0 0 1-2 2H6.875a2 2 0 0 1-2-2V3.875a2 2 0 0 1 2-2h11.25zm0 1.5H6.875a.5.5 0 0 0-.5.5v16.25a.5.5 0 0 0 .5.5h11.25a.5.5 0 0 0 .5-.5V3.875a.5.5 0 0 0-.5-.5zM9.062 17.5l.117.006a1.063 1.063 0 1 1-.117-.006zm3.568 0l.116.006a1.063 1.063 0 1 1-.116-.006zm3.307 0l.117.006a1.063 1.063 0 1 1-.116-.006zm-6.874-3.125l.116.006a1.063 1.063 0 1 1-.117-.006zm3.567 0l.116.006a1.063 1.063 0 1 1-.116-.006zm3.307 0l.117.006a1.063 1.063 0 1 1-.116-.006zM9.064 11.25l.116.006a1.063 1.063 0 1 1-.117-.006zm3.567 0l.116.006a1.063 1.063 0 1 1-.116-.006zm3.307 0l.117.006a1.063 1.063 0 1 1-.116-.006zm.313-6.875c.76 0 1.375.616 1.375 1.375v2.5c0 .76-.616 1.375-1.375 1.375h-7.5c-.76 0-1.375-.616-1.375-1.375v-2.5c0-.76.616-1.375 1.375-1.375h7.5zm-.125 1.5h-7.25v2.25h7.25v-2.25z"
        })
    });
var $558a1874964eed3d$var$Calculator$1 = $558a1874964eed3d$var$Calculator;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$CaretDown = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.93 15.75h.02c.2.01.42-.06.58-.22l5.86-5.86a.75.75 0 00-1.06-1.06l-5.4 5.4-5.4-5.4a.75.75 0 00-1.06 1.06l5.86 5.86c.16.16.38.24.6.22z"
        })
    });
var $558a1874964eed3d$var$CaretDown$1 = $558a1874964eed3d$var$CaretDown;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$CaretUp = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.93 8.25h.02c.2-.01.42.06.58.22l5.86 5.86a.75.75 0 11-1.06 1.06l-5.4-5.4-5.4 5.4a.75.75 0 01-1.06-1.06l5.86-5.86a.75.75 0 01.6-.22z"
        })
    });
var $558a1874964eed3d$var$CaretUp$1 = $558a1874964eed3d$var$CaretUp;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$CheckmarkCircle = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 1.874c5.592 0 10.125 4.533 10.125 10.125S17.592 22.124 12 22.124 1.875 17.591 1.875 12 6.408 1.874 12 1.874zm0 1.5a8.625 8.625 0 1 0 0 17.25 8.625 8.625 0 0 0 0-17.25zm4.412 3.85a.75.75 0 1 1 1.176.931l-6.527 8.258a1.624 1.624 0 0 1-2.632-.064L6.387 13.45a.75.75 0 1 1 1.226-.864L9.665 15.5c.022.034.06.054.1.055.04.002.078-.017.11-.06z"
        })
    });
var $558a1874964eed3d$var$CheckmarkCircle$1 = $558a1874964eed3d$var$CheckmarkCircle;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$CheckmarkFill = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        fill: "#000000",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
            stroke: "none",
            strokeWidth: 1,
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 0C5.373 0 0 5.373 0 12 0 18.627 5.373 24 12 24 18.627 24 24 18.627 24 12 23.992 5.376 18.624 0.008 12 0ZM18.927 8.2L12.082 17.489C11.919 17.706 11.675 17.848 11.406 17.883 11.138 17.918 10.866 17.844 10.652 17.677L5.764 13.769C5.333 13.424 5.263 12.794 5.608 12.363 5.953 11.932 6.583 11.862 7.014 12.207L11.09 15.468 17.317 7.017C17.521 6.711 17.877 6.541 18.244 6.576 18.61 6.611 18.928 6.844 19.071 7.184 19.214 7.523 19.158 7.914 18.927 8.2Z",
                id: "Shape"
            })
        })
    });
var $558a1874964eed3d$var$CheckmarkFill$1 = $558a1874964eed3d$var$CheckmarkFill;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$CheckmarkSquare = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M21.6079 2.23317C21.5002 2.14633 21.3765 2.08157 21.2438 2.04261C21.1111 2.00365 20.972 1.99124 20.8345 2.0061C20.697 2.02097 20.5638 2.0628 20.4424 2.12922C20.3211 2.19564 20.2141 2.28533 20.1275 2.39316L10.3375 14.5335L6.95481 11.1508C6.75738 10.9534 6.48961 10.8425 6.21041 10.8425C5.9312 10.8425 5.66344 10.9534 5.46601 11.1508C5.26858 11.3482 5.15767 11.616 5.15767 11.8952C5.15767 12.0335 5.1849 12.1704 5.2378 12.2981C5.29071 12.4258 5.36825 12.5419 5.46601 12.6396L9.67642 16.85C9.78172 16.9529 9.90722 17.0328 10.045 17.0846C10.1828 17.1365 10.3298 17.1591 10.4768 17.1512C10.6238 17.1433 10.7675 17.105 10.8989 17.0386C11.0303 16.9723 11.1465 16.8794 11.2402 16.7658L21.7662 3.71355C21.8531 3.606 21.918 3.48237 21.9571 3.34973C21.9962 3.21708 22.0087 3.07803 21.994 2.94053C21.9793 2.80302 21.9377 2.66977 21.8714 2.54839C21.8051 2.42701 21.7156 2.3199 21.6079 2.23317Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M17.9996 11.4742C17.7762 11.4742 17.562 11.5629 17.4041 11.7208C17.2462 11.8787 17.1575 12.0929 17.1575 12.3163V20.1055C17.1575 20.1613 17.1353 20.2149 17.0958 20.2544C17.0563 20.2939 17.0028 20.316 16.947 20.316H3.89468C3.83885 20.316 3.7853 20.2939 3.74582 20.2544C3.70634 20.2149 3.68416 20.1613 3.68416 20.1055V7.05324C3.68416 6.99741 3.70634 6.94386 3.74582 6.90438C3.7853 6.8649 3.83885 6.84272 3.89468 6.84272H13.3681C13.5914 6.84272 13.8056 6.754 13.9635 6.59608C14.1215 6.43816 14.2102 6.22397 14.2102 6.00064C14.2102 5.77731 14.1215 5.56312 13.9635 5.4052C13.8056 5.24728 13.5914 5.15856 13.3681 5.15856H3.68416C3.2375 5.15856 2.80912 5.336 2.49328 5.65184C2.17744 5.96768 2 6.39605 2 6.84272V20.316C2 20.7627 2.17744 21.1911 2.49328 21.5069C2.80912 21.8228 3.2375 22.0002 3.68416 22.0002H17.1575C17.6041 22.0002 18.0325 21.8228 18.3484 21.5069C18.6642 21.1911 18.8416 20.7627 18.8416 20.316V12.3163C18.8416 12.0929 18.7529 11.8787 18.595 11.7208C18.4371 11.5629 18.2229 11.4742 17.9996 11.4742Z"
            })
        ]
    });
var $558a1874964eed3d$var$CheckmarkSquare$1 = $558a1874964eed3d$var$CheckmarkSquare;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Checkmark = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M21.4784 2.23427C21.209 2.04101 20.8739 1.96274 20.5468 2.01668C20.2197 2.07063 19.9274 2.25238 19.7342 2.52194L8.03842 18.838L4.13427 14.9283C4.01821 14.8121 3.88042 14.7199 3.72877 14.657C3.57711 14.5941 3.41456 14.5618 3.2504 14.5617C3.08623 14.5617 2.92367 14.594 2.77198 14.6568C2.6203 14.7196 2.48247 14.8117 2.36636 14.9279C2.25024 15.044 2.15813 15.1819 2.09527 15.3336C2.03241 15.4853 2.00004 15.648 2 15.8122C1.99996 15.9765 2.03226 16.1392 2.09505 16.2909C2.15783 16.4427 2.24988 16.5806 2.36594 16.6968L7.31176 21.6447C7.44161 21.7697 7.59654 21.8656 7.76629 21.9262C7.93603 21.9867 8.1167 22.0104 8.2963 21.9958C8.47591 21.9811 8.65034 21.9284 8.80803 21.8411C8.96572 21.7538 9.10305 21.634 9.21092 21.4896L21.7659 3.97945C21.959 3.70987 22.0373 3.37456 21.9834 3.04728C21.9294 2.72 21.7478 2.42756 21.4784 2.23427V2.23427Z"
        })
    });
var $558a1874964eed3d$var$Checkmark$1 = $558a1874964eed3d$var$Checkmark;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ChevronDoubleDown = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.553 16.7821L17.2538 11.209C17.5388 10.9304 18.001 10.9303 18.2861 11.2089C18.5711 11.4875 18.5712 11.9393 18.2861 12.2179L12.5854 17.791C12.3004 18.0696 11.8382 18.0697 11.5531 17.7911C11.268 17.5125 11.268 17.0607 11.553 16.7821Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12.4468 16.7821L6.7461 11.209C6.46107 10.9304 5.9989 10.9303 5.71383 11.2089C5.42875 11.4875 5.42872 11.9393 5.71375 12.2179L11.4145 17.791C11.6995 18.0696 12.1617 18.0697 12.4468 17.7911C12.7318 17.5125 12.7319 17.0607 12.4468 16.7821Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.553 11.7821L17.2538 6.20901C17.5388 5.93036 18.001 5.93033 18.2861 6.20894C18.5711 6.48755 18.5712 6.93929 18.2861 7.21795L12.5854 12.791C12.3004 13.0696 11.8382 13.0697 11.5531 12.7911C11.268 12.5125 11.268 12.0607 11.553 11.7821Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12.4468 11.7821L6.7461 6.20901C6.46107 5.93036 5.9989 5.93033 5.71383 6.20894C5.42875 6.48755 5.42872 6.93929 5.71375 7.21795L11.4145 12.791C11.6995 13.0696 12.1617 13.0697 12.4468 12.7911C12.7318 12.5125 12.7319 12.0607 12.4468 11.7821Z"
            })
        ]
    });
var $558a1874964eed3d$var$ChevronDoubleDown$1 = $558a1874964eed3d$var$ChevronDoubleDown;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ChevronDoubleUp = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12.4468 7.21795L6.7461 12.791C6.46106 13.0696 5.9989 13.0697 5.71383 12.7911C5.42875 12.5125 5.42872 12.0607 5.71375 11.7821L11.4145 6.20901C11.6995 5.93036 12.1617 5.93033 12.4468 6.20894C12.7318 6.48755 12.7319 6.9393 12.4468 7.21795Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.5529 7.21795L17.2537 12.791C17.5387 13.0696 18.0009 13.0697 18.2859 12.7911C18.571 12.5125 18.571 12.0607 18.286 11.7821L12.5853 6.20901C12.3002 5.93036 11.8381 5.93033 11.553 6.20894C11.2679 6.48755 11.2679 6.9393 11.5529 7.21795Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12.4468 12.2179L6.7461 17.791C6.46106 18.0696 5.9989 18.0697 5.71383 17.7911C5.42875 17.5125 5.42872 17.0607 5.71375 16.7821L11.4145 11.209C11.6995 10.9304 12.1617 10.9303 12.4468 11.2089C12.7318 11.4875 12.7319 11.9393 12.4468 12.2179Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.5529 12.2179L17.2537 17.791C17.5387 18.0696 18.0009 18.0697 18.2859 17.7911C18.571 17.5125 18.571 17.0607 18.286 16.7821L12.5853 11.209C12.3002 10.9304 11.8381 10.9303 11.553 11.2089C11.2679 11.4875 11.2679 11.9393 11.5529 12.2179Z"
            })
        ]
    });
var $558a1874964eed3d$var$ChevronDoubleUp$1 = $558a1874964eed3d$var$ChevronDoubleUp;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ChevronLeft = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M7.227 12l8.845-8.845a.75.75 0 0 0-1.06-1.06l-8.934 8.933a1.374 1.374 0 0 0 0 1.944l8.933 8.933a.75.75 0 0 0 1.061-1.06L7.227 12z"
        })
    });
var $558a1874964eed3d$var$ChevronLeft$1 = $558a1874964eed3d$var$ChevronLeft;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ChevronRight = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M6.053 20.845a.75.75 0 0 0 1.06 1.06l8.934-8.933a1.374 1.374 0 0 0 0-1.944L7.114 2.095a.75.75 0 0 0-1.061 1.06L14.898 12l-8.845 8.845z"
        })
    });
var $558a1874964eed3d$var$ChevronRight$1 = $558a1874964eed3d$var$ChevronRight;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$CloseSm = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.15187 1.15187C1.35436 0.949376 1.68267 0.949376 1.88517 1.15187L8 7.26635L14.1148 1.15187C14.2989 0.967785 14.587 0.95105 14.79 1.10167L14.8481 1.15187C15.0506 1.35436 15.0506 1.68267 14.8481 1.88517L8.73353 7.99988L14.8481 14.1148C15.0322 14.2989 15.0489 14.587 14.8983 14.79L14.8481 14.8481C14.6456 15.0506 14.3173 15.0506 14.1148 14.8481L8 8.73342L1.88517 14.8481C1.70108 15.0322 1.41302 15.0489 1.21003 14.8983L1.15187 14.8481C0.949376 14.6456 0.949376 14.3173 1.15187 14.1148L7.26647 7.99988L1.15187 1.88517C0.967785 1.70108 0.95105 1.41302 1.10167 1.21003L1.15187 1.15187Z"
        })
    });
var $558a1874964eed3d$var$CloseSm$1 = $558a1874964eed3d$var$CloseSm;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Close = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M2.095 2.094a.75.75 0 0 1 1.06 0L12 10.938l8.845-8.844a.75.75 0 0 1 .976-.073l.084.073a.75.75 0 0 1 0 1.06L13.061 12l8.844 8.845a.75.75 0 0 1 .073.976l-.073.084a.75.75 0 0 1-1.06 0L12 13.06l-8.845 8.844a.75.75 0 0 1-.976.073l-.084-.073a.75.75 0 0 1 0-1.06l8.844-8.845-8.844-8.845a.75.75 0 0 1-.073-.976l.073-.084z"
        })
    });
var $558a1874964eed3d$var$Close$1 = $558a1874964eed3d$var$Close;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ComposeSm = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M9.575 3.182a.146.146 0 0 1 .102.249L6.242 6.865c-.112.112-.2.246-.259.393l-.824 2.06c-.173.434-.071.93.259 1.26.332.325.824.426 1.258.257l2.062-.827c.147-.058.28-.146.392-.258l3.434-3.432a.146.146 0 0 1 .249.104v6.608a1.818 1.818 0 0 1-1.819 1.818h-8.03a1.818 1.818 0 0 1-1.818-1.818V5c0-1.004.814-1.818 1.819-1.818zm1.844-.257a.3.3 0 0 1 .412 0l1.238 1.238a.292.292 0 0 1 0 .413L8.511 9.133a.292.292 0 0 1-.098.065l-2.062.825a.303.303 0 0 1-.314-.064.292.292 0 0 1-.065-.315l.825-2.063a.296.296 0 0 1 .064-.098zm1.444-1.443a1.195 1.195 0 0 1 1.65 0 1.167 1.167 0 0 1 0 1.65l-.617.618a.264.264 0 0 1-.034.023.282.282 0 0 1-.379-.023l-1.239-1.237a.292.292 0 0 1-.085-.206.286.286 0 0 1 .06-.17.31.31 0 0 1 .025-.036z"
        })
    });
var $558a1874964eed3d$var$ComposeSm$1 = $558a1874964eed3d$var$ComposeSm;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Compose = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M10.125 5.625a.75.75 0 1 1 0 1.5h-6.25a.5.5 0 0 0-.5.5v12.5a.5.5 0 0 0 .5.5h12.5a.5.5 0 0 0 .5-.5v-6.25a.75.75 0 1 1 1.5 0v6.25a2 2 0 0 1-2 2h-12.5a2 2 0 0 1-2-2v-12.5a2 2 0 0 1 2-2zm11.231-2.982a2.625 2.625 0 0 1 0 3.712l-7.955 7.955a.75.75 0 0 1-.424.212l-3.093.443a.75.75 0 0 1-.849-.848l.442-3.095a.75.75 0 0 1 .212-.424l7.955-7.955a2.625 2.625 0 0 1 3.712 0zM17.29 5.118l-6.364 6.364-.265 1.856 1.856-.265 6.364-6.364-1.591-1.59zm1.414-1.414l-.354.353 1.591 1.591.355-.353a1.125 1.125 0 1 0-1.592-1.591z"
        })
    });
var $558a1874964eed3d$var$Compose$1 = $558a1874964eed3d$var$Compose;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Configure = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 22 22",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.71109 2.34005V19.6668C1.71109 19.8757 1.76126 19.985 1.79996 20.0431C1.84163 20.1056 1.90228 20.1561 1.98456 20.1973C2.06962 20.2398 2.1633 20.2646 2.2417 20.2777C2.27922 20.2839 2.30893 20.2868 2.32648 20.2881C2.33295 20.2885 2.33755 20.2887 2.34003 20.2888H19.6668C19.8757 20.2888 19.985 20.2387 20.0431 20.2C20.1056 20.1583 20.1561 20.0977 20.1973 20.0154C20.2398 19.9303 20.2646 19.8366 20.2777 19.7582C20.2839 19.7207 20.2868 19.691 20.288 19.6735C20.2885 19.667 20.2887 19.6624 20.2888 19.6599V2.33313C20.2888 2.12428 20.2386 2.01492 20.1999 1.95687C20.1583 1.89437 20.0976 1.84383 20.0154 1.80269C19.9303 1.76016 19.8366 1.73534 19.7582 1.72228C19.7207 1.71602 19.691 1.71317 19.6734 1.71192C19.667 1.71146 19.6624 1.71123 19.6599 1.71112H2.3331C2.12425 1.71112 2.01489 1.76129 1.95684 1.79999C1.89434 1.84166 1.8438 1.90231 1.80266 1.98459C1.76012 2.06965 1.73531 2.16333 1.72225 2.24174C1.71599 2.27925 1.71314 2.30896 1.71189 2.32651C1.71143 2.33297 1.7112 2.33756 1.71109 2.34005ZM19.6668 0.999985V0.288849H2.3331C1.87537 0.288849 1.4848 0.405323 1.16791 0.616588C0.855462 0.824884 0.65604 1.09752 0.530538 1.34853C0.406428 1.59675 0.347917 1.83636 0.319324 2.00792C0.304747 2.09538 0.297184 2.16982 0.293229 2.22518C0.291244 2.25298 0.290144 2.27631 0.289539 2.29447L0.288952 2.31784L0.288846 2.32652L0.288824 2.33009L0.28882 2.33167L0.288819 2.33242C0.288818 2.33278 0.288818 2.33313 0.999235 2.33313H0.288818V19.6668C0.288818 20.1246 0.405293 20.5151 0.616557 20.832C0.824854 21.1445 1.09749 21.3439 1.3485 21.4694C1.59672 21.5935 1.83633 21.652 2.00788 21.6806C2.09535 21.6952 2.16979 21.7028 2.22515 21.7067C2.25295 21.7087 2.27628 21.7098 2.29444 21.7104L2.31781 21.711L2.32649 21.7111L2.33006 21.7111L2.33164 21.7111H2.33239C2.33275 21.7111 2.3331 21.7111 2.3331 21V21.7111H19.6668C20.1245 21.7111 20.5151 21.5946 20.832 21.3834C21.1444 21.1751 21.3439 20.9024 21.4694 20.6514C21.5935 20.4032 21.652 20.1636 21.6806 19.9921C21.6952 19.9046 21.7027 19.8302 21.7067 19.7748C21.7087 19.747 21.7098 19.7237 21.7104 19.7055L21.711 19.6821L21.7111 19.6735L21.7111 19.6699L21.7111 19.6683V19.6676C21.7111 19.6672 21.7111 19.6668 21 19.6668H21.7111V2.33313C21.7111 1.87541 21.5946 1.48483 21.3834 1.16794C21.1751 0.855493 20.9024 0.656071 20.6514 0.530568C20.4032 0.406458 20.1636 0.347948 19.992 0.319355C19.9046 0.304778 19.8301 0.297214 19.7748 0.29326C19.747 0.291274 19.7236 0.290174 19.7055 0.289569L19.6821 0.288982L19.6734 0.288876L19.6699 0.288855L19.6683 0.28885L19.6675 0.288849C19.6672 0.288849 19.6668 0.288849 19.6668 0.999985Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.1787 14.3343C11.1787 13.9415 11.4971 13.6231 11.8898 13.6231H17.0015C17.3942 13.6231 17.7126 13.9415 17.7126 14.3343C17.7126 14.727 17.3942 15.0454 17.0015 15.0454H11.8898C11.4971 15.0454 11.1787 14.727 11.1787 14.3343Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.28918 14.3343C4.28918 13.9415 4.60757 13.6231 5.00032 13.6231H7.44473C7.83748 13.6231 8.15587 13.9415 8.15587 14.3343C8.15587 14.727 7.83748 15.0454 7.44473 15.0454H5.00032C4.60757 15.0454 4.28918 14.727 4.28918 14.3343Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.66732 12.8229C9.36839 12.8229 9.07618 12.9115 8.82763 13.0776C8.57908 13.2437 8.38536 13.4797 8.27097 13.7559C8.15657 14.032 8.12664 14.3359 8.18496 14.6291C8.24328 14.9223 8.38722 15.1916 8.5986 15.403C8.80997 15.6144 9.07928 15.7583 9.37246 15.8166C9.66564 15.8749 9.96953 15.845 10.2457 15.7306C10.5219 15.6162 10.7579 15.4225 10.924 15.174C11.0901 14.9254 11.1787 14.6332 11.1787 14.3343C11.1787 13.9334 11.0195 13.549 10.736 13.2655C10.4526 12.9821 10.0682 12.8229 9.66732 12.8229ZM8.03746 11.895C8.5199 11.5726 9.08709 11.4006 9.66732 11.4006C10.4454 11.4006 11.1916 11.7097 11.7417 12.2598C12.2919 12.81 12.601 13.5562 12.601 14.3343C12.601 14.9145 12.4289 15.4817 12.1066 15.9641C11.7842 16.4466 11.326 16.8226 10.79 17.0446C10.2539 17.2667 9.66406 17.3248 9.09499 17.2116C8.52591 17.0984 8.00318 16.819 7.5929 16.4087C7.18262 15.9984 6.90321 15.4757 6.79001 14.9066C6.67682 14.3375 6.73491 13.7477 6.95696 13.2116C7.179 12.6755 7.55502 12.2174 8.03746 11.895Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.28918 7.66664C4.28918 7.27389 4.60757 6.95551 5.00032 6.95551H12.7783C13.171 6.95551 13.4894 7.27389 13.4894 7.66664C13.4894 8.05939 13.171 8.37778 12.7783 8.37778H5.00032C4.60757 8.37778 4.28918 8.05939 4.28918 7.66664Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.4285 4.78934C14.9976 4.67615 15.5874 4.73424 16.1235 4.95629C16.6595 5.17833 17.1177 5.55434 17.4401 6.03678C17.7624 6.51923 17.9345 7.08642 17.9345 7.66665C17.9345 8.44471 17.6254 9.1909 17.0752 9.74107C16.5251 10.2912 15.7789 10.6003 15.0008 10.6003C14.4206 10.6003 13.8534 10.4283 13.371 10.1059C12.8885 9.78355 12.5125 9.32537 12.2905 8.78932C12.0684 8.25326 12.0103 7.66339 12.1235 7.09432C12.2367 6.52524 12.5161 6.00251 12.9264 5.59223C13.3367 5.18194 13.8594 4.90254 14.4285 4.78934ZM15.5792 6.27029C15.303 6.1559 14.9991 6.12597 14.706 6.18429C14.4128 6.2426 14.1435 6.38655 13.9321 6.59792C13.7207 6.8093 13.5768 7.0786 13.5185 7.37179C13.4601 7.66497 13.4901 7.96886 13.6045 8.24504C13.7189 8.52121 13.9126 8.75726 14.1611 8.92333C14.4097 9.08941 14.7019 9.17805 15.0008 9.17805C15.4017 9.17805 15.7861 9.01881 16.0695 8.73537C16.353 8.45193 16.5122 8.0675 16.5122 7.66665C16.5122 7.36772 16.4236 7.07551 16.2575 6.82696C16.0914 6.57841 15.8554 6.38469 15.5792 6.27029Z"
            })
        ]
    });
var $558a1874964eed3d$var$Configure$1 = $558a1874964eed3d$var$Configure;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ContactCard = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M20.125 4.25A2 2 0 0 1 22.12 6.1l.005.15v12.5a2 2 0 0 1-1.85 1.995l-.15.005h-2.5a.75.75 0 0 1-.75-.75.5.5 0 0 0-.992-.09l-.008.09-.007.102a.75.75 0 0 1-.641.641l-.102.007h-6.25a.75.75 0 0 1-.75-.75.5.5 0 0 0-.992-.09l-.008.09-.007.102a.75.75 0 0 1-.641.641l-.102.007h-2.5A2 2 0 0 1 1.88 18.9l-.005-.15V6.25a2 2 0 0 1 1.85-1.995l.15-.005h16.25zm0 1.5H3.875a.5.5 0 0 0-.492.41l-.008.09v12.5a.5.5 0 0 0 .41.492l.09.008h1.896l.04-.093a2.003 2.003 0 0 1 1.496-1.132l.169-.02.149-.005a2 2 0 0 1 1.746 1.023l.068.134.039.093h5.043l.04-.093a2.003 2.003 0 0 1 1.496-1.132l.169-.02.149-.005a2 2 0 0 1 1.746 1.023l.068.134.039.093h1.897a.5.5 0 0 0 .469-.326l.023-.084.008-.09V6.25a.5.5 0 0 0-.5-.5zm-11.25 1a2.937 2.937 0 0 1 1.7 5.334 4.499 4.499 0 0 1 2.8 4.166.75.75 0 0 1-.648.743l-.102.007h-7.5a.75.75 0 0 1-.75-.75 4.502 4.502 0 0 1 2.8-4.168 2.937 2.937 0 0 1 1.7-5.332zm0 6.5a3.002 3.002 0 0 0-2.822 1.981l-.055.167-.028.102h5.809l-.027-.102a3.004 3.004 0 0 0-2.51-2.126l-.19-.017-.177-.005zm10-1.5a.75.75 0 0 1 .102 1.493l-.102.007h-5a.75.75 0 0 1-.102-1.493l.102-.007h5zm-10-3.5a1.437 1.437 0 1 0 0 2.874 1.437 1.437 0 0 0 0-2.874zm8.75 1a.75.75 0 0 1 .102 1.493l-.102.007h-3.75a.75.75 0 0 1-.102-1.493l.102-.007h3.75z"
        })
    });
var $558a1874964eed3d$var$ContactCard$1 = $558a1874964eed3d$var$ContactCard;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$CreditCard = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 22 22",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.58579 0.919038C3.96086 0.543966 4.46957 0.333252 5 0.333252H19.6667C20.1971 0.333252 20.7058 0.543966 21.0809 0.919038C21.456 1.29411 21.6667 1.80282 21.6667 2.33325V12.3333C21.6667 12.7014 21.3682 12.9999 21 12.9999C20.6318 12.9999 20.3333 12.7014 20.3333 12.3333V2.33325C20.3333 2.15644 20.2631 1.98687 20.1381 1.86185C20.013 1.73682 19.8435 1.66659 19.6667 1.66659H5C4.82319 1.66659 4.65362 1.73682 4.5286 1.86185C4.40357 1.98687 4.33333 2.15644 4.33333 2.33325V5.66658C4.33333 6.03477 4.03486 6.33325 3.66667 6.33325C3.29848 6.33325 3 6.03477 3 5.66658V2.33325C3 1.80282 3.21071 1.29411 3.58579 0.919038Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3 4.99992C3 4.63173 3.29848 4.33325 3.66667 4.33325H21C21.3682 4.33325 21.6667 4.63173 21.6667 4.99992C21.6667 5.36811 21.3682 5.66659 21 5.66659H3.66667C3.29848 5.66659 3 5.36811 3 4.99992Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.66667 9.67252V19.6665C1.66667 19.8832 1.71892 20.0014 1.76303 20.0675C1.80993 20.1379 1.87723 20.1931 1.96481 20.2369C2.055 20.282 2.15326 20.3079 2.2346 20.3214C2.27369 20.3279 2.3048 20.3309 2.32354 20.3323C2.3313 20.3328 2.33669 20.3331 2.33934 20.3332H17C17.2167 20.3332 17.3349 20.2809 17.401 20.2368C17.4714 20.1899 17.5266 20.1226 17.5704 20.035C17.6155 19.9448 17.6413 19.8466 17.6549 19.7652C17.6614 19.7261 17.6644 19.695 17.6658 19.6763C17.6663 19.6685 17.6666 19.6632 17.6667 19.6605V9.6665C17.6667 9.44983 17.6144 9.33164 17.5703 9.26547C17.5234 9.19513 17.4561 9.13991 17.3685 9.09612C17.2783 9.05103 17.1801 9.02516 17.0987 9.0116C17.0596 9.00508 17.0285 9.00209 17.0098 9.00075C17.002 9.00019 16.9966 8.99994 16.994 8.99984H2.33333C2.11666 8.99984 1.99847 9.05209 1.9323 9.0962C1.86196 9.1431 1.80674 9.2104 1.76295 9.29798C1.71786 9.38817 1.69198 9.48643 1.67843 9.56777C1.67191 9.60686 1.66891 9.63798 1.66758 9.65671C1.66702 9.66448 1.66677 9.66986 1.66667 9.67252ZM17 8.33317V7.6665H2.33333C1.88334 7.6665 1.50153 7.78092 1.1927 7.9868C0.888042 8.18991 0.693257 8.45594 0.570381 8.70169C0.448809 8.94484 0.391346 9.17991 0.363236 9.34857C0.348918 9.43448 0.341501 9.50753 0.33763 9.56171C0.335687 9.58892 0.334615 9.61169 0.334028 9.62932L0.333459 9.65193L0.333358 9.66025L0.333338 9.66364L0.333333 9.66514C0.333333 9.66547 0.333332 9.6665 0.999999 9.6665H0.333332V19.6665C0.333332 20.1165 0.447745 20.4983 0.653632 20.8071C0.856736 21.1118 1.12277 21.3066 1.36852 21.4295C1.61167 21.551 1.84674 21.6085 2.0154 21.6366C2.10131 21.6509 2.17436 21.6583 2.22854 21.6622C2.25575 21.6641 2.27852 21.6652 2.29615 21.6658L2.31876 21.6664L2.32707 21.6665L2.33046 21.6665L2.33196 21.6665C2.3323 21.6665 2.33333 21.6665 2.33333 20.9998V21.6665H17C17.45 21.6665 17.8318 21.5521 18.1406 21.3462C18.4453 21.1431 18.6401 20.8771 18.7629 20.6313C18.8845 20.3882 18.942 20.1531 18.9701 19.9844C18.9844 19.8985 18.9918 19.8255 18.9957 19.7713C18.9976 19.7441 18.9987 19.7213 18.9993 19.7037L18.9999 19.6811L19 19.6728L19 19.6694L19 19.6679C19 19.6675 19 19.6665 18.3333 19.6665H19V9.6665C19 9.21651 18.8856 8.8347 18.6797 8.52587C18.4766 8.22121 18.2106 8.02643 17.9648 7.90355C17.7217 7.78198 17.4866 7.72452 17.3179 7.69641C17.232 7.68209 17.159 7.67467 17.1048 7.6708C17.0776 7.66886 17.0548 7.66779 17.0372 7.6672L17.0146 7.66663L17.0063 7.66653L17.0029 7.66651L17.0014 7.66651C17.001 7.6665 17 7.6665 17 8.33317Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.333332 12.3332C0.333332 11.965 0.631809 11.6665 0.999999 11.6665H18.3333C18.7015 11.6665 19 11.965 19 12.3332C19 12.7014 18.7015 12.9998 18.3333 12.9998H0.999999C0.631809 12.9998 0.333332 12.7014 0.333332 12.3332Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3 16.3332C3 15.965 3.29848 15.6665 3.66667 15.6665H5.66667C6.03486 15.6665 6.33333 15.965 6.33333 16.3332C6.33333 16.7014 6.03486 16.9998 5.66667 16.9998H3.66667C3.29848 16.9998 3 16.7014 3 16.3332Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.5955 14.453C11.0601 14.2981 11.5616 14.2934 12.0291 14.4394C12.2577 14.5108 12.4725 14.6165 12.6667 14.7517C12.8609 14.6165 13.0757 14.5108 13.3043 14.4394C13.7717 14.2934 14.2733 14.2981 14.7379 14.453C15.2025 14.6079 15.6066 14.905 15.8929 15.3023C16.1792 15.6995 16.3333 16.1769 16.3333 16.6666C16.3333 17.1563 16.1792 17.6336 15.8929 18.0309C15.6066 18.4282 15.2025 18.7253 14.7379 18.8802C14.2733 19.035 13.7717 19.0398 13.3043 18.8938C13.0757 18.8224 12.8609 18.7167 12.6667 18.5814C12.4725 18.7167 12.2577 18.8224 12.0291 18.8938C11.5616 19.0398 11.0601 19.035 10.5955 18.8802C10.1309 18.7253 9.72678 18.4282 9.44043 18.0309C9.15409 17.6336 9 17.1563 9 16.6666C9 16.1769 9.15409 15.6995 9.44043 15.3023C9.72678 14.905 10.1309 14.6079 10.5955 14.453ZM11.6315 15.7121C11.4312 15.6495 11.2162 15.6515 11.0171 15.7179C10.818 15.7843 10.6448 15.9116 10.5221 16.0819C10.3994 16.2521 10.3333 16.4567 10.3333 16.6666C10.3333 16.8765 10.3994 17.081 10.5221 17.2513C10.6448 17.4216 10.818 17.5489 11.0171 17.6153C11.2162 17.6816 11.4312 17.6837 11.6315 17.6211C11.8318 17.5585 12.0074 17.4345 12.1333 17.2666C12.2592 17.0987 12.4568 16.9999 12.6667 16.9999C12.8765 16.9999 13.0741 17.0987 13.2 17.2666C13.3259 17.4345 13.5015 17.5585 13.7018 17.6211C13.9022 17.6837 14.1171 17.6816 14.3162 17.6153C14.5153 17.5489 14.6885 17.4216 14.8112 17.2513C14.934 17.081 15 16.8765 15 16.6666C15 16.4567 14.934 16.2521 14.8112 16.0819C14.6885 15.9116 14.5153 15.7843 14.3162 15.7179C14.1171 15.6515 13.9022 15.6495 13.7018 15.7121C13.5015 15.7747 13.3259 15.8987 13.2 16.0666C13.0741 16.2345 12.8765 16.3333 12.6667 16.3333C12.4568 16.3333 12.2592 16.2345 12.1333 16.0666C12.0074 15.8987 11.8318 15.7747 11.6315 15.7121Z"
            })
        ]
    });
var $558a1874964eed3d$var$CreditCard$1 = $558a1874964eed3d$var$CreditCard;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DataDownload = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M8.875 5a.75.75 0 0 1 0 1.5H7a1.75 1.75 0 0 0-1.75 1.75v10.625c0 .966.784 1.75 1.75 1.75h10a1.75 1.75 0 0 0 1.75-1.75V8.25A1.75 1.75 0 0 0 17 6.5h-1.873a.75.75 0 1 1 0-1.5H17a3.25 3.25 0 0 1 3.25 3.25v10.625a3.25 3.25 0 0 1-3.25 3.25H7a3.25 3.25 0 0 1-3.25-3.25V8.25A3.25 3.25 0 0 1 7 5zm3.127-3.124a.75.75 0 0 1 .75.75l-.001 10.689 2.47-2.47a.75.75 0 0 1 .977-.072l.084.073a.75.75 0 0 1 0 1.06l-3.75 3.75a.754.754 0 0 1-.53.22l.073-.004a.754.754 0 0 1-.044.003H12a.763.763 0 0 1-.413-.123.747.747 0 0 1-.117-.096l.079.069a.754.754 0 0 1-.079-.069l-3.75-3.75a.75.75 0 0 1 1.061-1.06l2.469 2.469V2.625a.75.75 0 0 1 .649-.742z"
        })
    });
var $558a1874964eed3d$var$DataDownload$1 = $558a1874964eed3d$var$DataDownload;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DataUpload = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.002 8.126a.763.763 0 0 1 .424.131.748.748 0 0 1 .106.089l-.079-.07a.752.752 0 0 1 .007.006l.072.064 3.75 3.75a.75.75 0 0 1-1.06 1.06l-2.471-2.47v10.69a.75.75 0 0 1-.648.743l-.101.007a.75.75 0 0 1-.75-.75l-.001-10.69-2.469 2.47a.75.75 0 0 1-.977.073l-.084-.073a.75.75 0 0 1 0-1.06l3.75-3.75.072-.064a.754.754 0 0 1 .459-.156l-.074.003a.754.754 0 0 1 .044-.003zM17 1.876a3.25 3.25 0 0 1 3.25 3.25V15.75A3.25 3.25 0 0 1 17 19h-1.875a.75.75 0 1 1 0-1.5H17a1.75 1.75 0 0 0 1.75-1.75V5.126A1.75 1.75 0 0 0 17 3.376H7a1.75 1.75 0 0 0-1.75 1.75V15.75c0 .966.784 1.75 1.75 1.75h1.877a.75.75 0 1 1 0 1.5H7a3.25 3.25 0 0 1-3.25-3.25V5.126A3.25 3.25 0 0 1 7 1.876z"
        })
    });
var $558a1874964eed3d$var$DataUpload$1 = $558a1874964eed3d$var$DataUpload;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DataVisBarChart = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M2 1.25a.75.75 0 0 1 .743.648L2.75 2l-.001.119h10.337c.378 0 .726.168.981.45l.092.11c.226.302.345.687.345 1.08v1.7c0 .393-.12.777-.345 1.078-.26.348-.647.56-1.072.56H2.749v1.326h10.337c.378 0 .726.169.981.45l.092.111c.226.301.345.687.345 1.08v1.699c0 .393-.12.778-.345 1.079-.26.347-.647.56-1.072.56H2.749v1.108h15.54c.378 0 .725.169.981.45l.091.111c.227.301.346.686.346 1.08v1.699c0 .866-.58 1.64-1.417 1.64l-15.541-.001.001 1.326h18.815a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.648.743l-.102.007H2a.75.75 0 0 1-.743-.648l-.007-.102V2A.75.75 0 0 1 2 1.25zm16.181 14.76H2.75v1.979h15.54c-.084 0-.086-.016-.084-.089v-1.75a.43.43 0 0 0-.006-.075l-.019-.065zm-5.202-6.087H2.749v1.979h10.23a.302.302 0 0 0 .019-.065l.006-.074v-1.7a.432.432 0 0 0-.006-.075l-.019-.065zm0-6.304H2.749v1.978h10.23a.286.286 0 0 0 .019-.064l.006-.074v-1.7a.432.432 0 0 0-.006-.075l-.019-.065z"
        })
    });
var $558a1874964eed3d$var$DataVisBarChart$1 = $558a1874964eed3d$var$DataVisBarChart;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DataVisColumnChart = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M2.625 20.208a.75.75 0 1 1 0-1.5h.5v-7.375c0-.759.616-1.375 1.375-1.375H7c.76 0 1.375.616 1.375 1.375v7.375h1V3.833c0-.759.616-1.375 1.375-1.375h2.5c.76 0 1.375.616 1.375 1.375v14.875h1V7.583c0-.759.616-1.375 1.375-1.375h2.5c.76 0 1.375.616 1.375 1.375v11.125h.5a.75.75 0 0 1 .743.649l.007.101a.75.75 0 0 1-.75.75zm4.25-8.75h-2.25v7.25h2.25v-7.25zm12.5-3.75h-2.25v11h2.25v-11zm-6.25-3.75h-2.25v14.75h2.25V3.958z"
        })
    });
var $558a1874964eed3d$var$DataVisColumnChart$1 = $558a1874964eed3d$var$DataVisColumnChart;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DataVisComboChart = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M13.25 9.05c.753 0 1.375.597 1.375 1.35v9.45h1V14c0-.708.551-1.28 1.244-1.344L17 12.65h2.5c.753 0 1.375.597 1.375 1.35v5.85h.5a.75.75 0 0 1 .102 1.493l-.102.007H2.625a.75.75 0 0 1-.102-1.493l.102-.007h.5V16.4c0-.708.551-1.28 1.244-1.344l.131-.006H7c.753 0 1.375.597 1.375 1.35v3.45h1V10.4c0-.708.551-1.28 1.244-1.344l.131-.006zm6.125 5.099h-2.25v5.701h2.25v-5.701zm-12.5 2.4h-2.25v3.301h2.25v-3.301zm6.25-6h-2.25v9.301h2.25v-9.301zM9.5 1.85c1.023 0 1.876.752 1.988 1.731l7.076 1.999c.368-.446.932-.73 1.561-.73 1.098 0 2 .866 2 1.95s-.902 1.95-2 1.95c-1.023 0-1.876-.752-1.988-1.732L11.061 5.02c-.368.446-.932.73-1.561.73-.209 0-.41-.031-.6-.09L5.641 9.485c.15.272.234.584.234.916 0 1.084-.902 1.95-2 1.95-1.098 0-2-.866-2-1.95s.902-1.95 2-1.95c.209 0 .41.031.6.09l3.259-3.824A1.902 1.902 0 0 1 7.5 3.8c0-1.084.902-1.95 2-1.95zm-5.625 8.1c-.283 0-.5.208-.5.45 0 .242.217.45.5.45.283 0 .5-.208.5-.45 0-.242-.217-.45-.5-.45zm16.25-3.6c-.283 0-.5.208-.5.45 0 .242.217.45.5.45.283 0 .5-.208.5-.45 0-.242-.217-.45-.5-.45zM9.5 3.35c-.283 0-.5.208-.5.45 0 .242.217.45.5.45.283 0 .5-.208.5-.45 0-.242-.217-.45-.5-.45z"
        })
    });
var $558a1874964eed3d$var$DataVisComboChart$1 = $558a1874964eed3d$var$DataVisComboChart;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DataVisGain = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.9993 22C12.5931 22 13.078 21.525 13.078 20.9312V5.66155L16.601 9.18456C16.9869 9.57051 17.5807 9.6002 17.9963 9.28352L18.1151 9.18456C18.5406 8.76893 18.5406 8.09599 18.1151 7.67046L12.7613 2.30678C12.7242 2.27092 12.6845 2.23784 12.6426 2.20782L12.603 2.18803C12.5773 2.17038 12.5509 2.15387 12.5238 2.13855L12.4644 2.10886C12.4383 2.09505 12.412 2.08185 12.3853 2.06927L12.3457 2.04948C12.313 2.03862 12.28 2.02872 12.2467 2.01979H12.1972C12.1319 2.00767 12.0657 2.00105 11.9993 2H12.0983H11.9004L11.8113 2.01979H11.7717L11.6727 2.04948L11.6332 2.06927L11.5441 2.09896L11.4847 2.13855L11.4154 2.17813C11.366 2.21771 11.3066 2.2573 11.2571 2.31667L5.88353 7.67046C5.68274 7.87124 5.56995 8.14356 5.56995 8.42751C5.56995 8.71146 5.68274 8.98378 5.88353 9.18456C6.08431 9.38535 6.35663 9.49814 6.64058 9.49814C6.92453 9.49814 7.19685 9.38535 7.39763 9.18456L10.9305 5.66155V20.9312C10.9305 21.4755 11.3264 21.9208 11.8608 22H11.9993Z"
        })
    });
var $558a1874964eed3d$var$DataVisGain$1 = $558a1874964eed3d$var$DataVisGain;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DataVisHierarchy = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M17.783 1.466c.774 0 1.402.628 1.402 1.402v2.609c0 .774-.628 1.402-1.402 1.402h-5.12v5.02l4.467.001c1.083 0 1.97.839 2.05 1.902l.005.153v3.268a2.707 2.707 0 1 1-1.5 0v-3.268a.555.555 0 0 0-.465-.547l-.09-.008h-4.467l.001 3.823a2.708 2.708 0 0 1 1.95 2.43l.006.171a2.706 2.706 0 1 1-3.457-2.601V13.4H6.696a.555.555 0 0 0-.547.465l-.008.09v3.268a2.707 2.707 0 1 1-1.5 0v-3.268c0-1.083.839-1.97 1.901-2.049l.154-.006h4.467V6.879h-5.12a1.403 1.403 0 0 1-1.395-1.267l-.007-.135v-2.61c0-.773.628-1.401 1.402-1.401zM5.39 18.618a1.206 1.206 0 1 0 0 2.412 1.206 1.206 0 0 0 0-2.412zm6.522 0a1.206 1.206 0 1 0 0 2.412 1.206 1.206 0 0 0 0-2.412zm6.522 0a1.206 1.206 0 1 0-.001 2.412 1.206 1.206 0 0 0 0-2.412zm-.751-15.653H6.141v2.413h11.543V2.965z"
        })
    });
var $558a1874964eed3d$var$DataVisHierarchy$1 = $558a1874964eed3d$var$DataVisHierarchy;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DataVisLineGraph = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M9.48 17.126a2 2 0 0 1-3.177.75l-2.928 1.462v1.287h18a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.648.743l-.102.007H2.625a.75.75 0 0 1-.743-.648l-.007-.102V2.625a.75.75 0 0 1 1.493-.102l.007.102v7.425l3.524-2.113a2.004 2.004 0 0 1-.019-.163l-.005-.149a2 2 0 1 1 3.999.067l2.237.994a1.993 1.993 0 0 1 1.962-.478l3.103-3.88a2 2 0 1 1 .914 1.259l-2.846 3.558a2 2 0 1 1-3.743.912l-2.236-.994c-.36.348-.85.562-1.39.562-.452 0-.869-.15-1.204-.403L3.375 11.8v5.862l2.256-1.128v-.009l-.006-.149a2 2 0 0 1 3.855-.75h2.54a2 2 0 0 1 3.11-.807l2.997-1.665a2 2 0 1 1 .51 1.434L15.86 16.13a2 2 0 0 1-3.84.996zm4.395-1.251a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-6.25 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm12.5-3.125a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM14.5 9.625a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-5.625-2.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm11.25-3.75a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
        })
    });
var $558a1874964eed3d$var$DataVisLineGraph$1 = $558a1874964eed3d$var$DataVisLineGraph;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DataVisLoss = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.0049 2C11.4111 2 10.9262 2.47501 10.9262 3.06878L10.9262 18.3384L7.4032 14.8154C7.01725 14.4295 6.42349 14.3998 6.00785 14.7165L5.8891 14.8154C5.46356 15.2311 5.46356 15.904 5.8891 16.3295L11.2429 21.6932C11.28 21.7291 11.3197 21.7622 11.3616 21.7922L11.4012 21.812C11.4269 21.8296 11.4533 21.8461 11.4804 21.8615L11.5398 21.8911C11.5658 21.9049 11.5922 21.9181 11.6189 21.9307L11.6585 21.9505C11.6912 21.9614 11.7242 21.9713 11.7575 21.9802H11.807C11.8723 21.9923 11.9385 21.9989 12.0049 22H11.9059H12.1038L12.1929 21.9802H12.2325L12.3315 21.9505L12.371 21.9307L12.4601 21.901L12.5195 21.8615L12.5888 21.8219C12.6382 21.7823 12.6976 21.7427 12.7471 21.6833L18.1207 16.3295C18.3214 16.1288 18.4342 15.8564 18.4342 15.5725C18.4342 15.2885 18.3214 15.0162 18.1207 14.8154C17.9199 14.6147 17.6476 14.5019 17.3636 14.5019C17.0797 14.5019 16.8073 14.6147 16.6066 14.8154L13.0737 18.3384L13.0737 3.06878C13.0737 2.52449 12.6778 2.07917 12.1434 2L12.0049 2Z"
        })
    });
var $558a1874964eed3d$var$DataVisLoss$1 = $558a1874964eed3d$var$DataVisLoss;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DataVisPieChart = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M10.38 4.354c.402 0 .729.326.729.728v7.219h7.218c.402 0 .729.326.729.728a8.675 8.675 0 0 1-8.676 8.676 8.675 8.675 0 0 1-8.675-8.676 8.675 8.675 0 0 1 8.675-8.675zm-.728 1.493l-.237.027a7.22 7.22 0 1 0 8.147 7.884H10.38a.728.728 0 0 1-.728-.729V5.847zm3.377-4.142a8.675 8.675 0 0 1 8.676 8.675.728.728 0 0 1-.729.729H13.03a.728.728 0 0 1-.728-.729V2.433c0-.402.326-.728.728-.728zm.729 1.493v6.454h6.453a7.22 7.22 0 0 0-6.453-6.454z"
        })
    });
var $558a1874964eed3d$var$DataVisPieChart$1 = $558a1874964eed3d$var$DataVisPieChart;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DataVisTrendAsc = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M13.25 9.05c.753 0 1.375.597 1.375 1.35v9.45h1V12.8c0-.708.551-1.28 1.244-1.344L17 11.45h2.5c.753 0 1.375.597 1.375 1.35v7.05h.5a.75.75 0 0 1 .102 1.493l-.102.007H2.625a.75.75 0 0 1-.102-1.493l.102-.007h.5V16.4c0-.708.551-1.28 1.244-1.344l.131-.006H7c.753 0 1.375.597 1.375 1.35v3.45h1V10.4c0-.708.551-1.28 1.244-1.344l.131-.006zm6.125 3.9h-2.25v6.9h2.25v-6.9zm-12.5 3.599h-2.25v3.301h2.25v-3.301zm6.25-6h-2.25v9.301h2.25v-9.301zm8.791-8.468l.017.018a.754.754 0 0 1 .053.066l-.07-.084a.754.754 0 0 1 .206.447l.003.072v3.6a.75.75 0 0 1-1.493.102l-.007-.102V4.359l-2.939 2.822a2.672 2.672 0 0 1-2.39.682L10.36 6.597a1.187 1.187 0 0 0-1.005.196l-.1.085-4.86 4.665a.75.75 0 0 1-1.113-.999l.075-.083 4.86-4.665a2.677 2.677 0 0 1 2.335-.692l.18.04 4.78 1.227c.359.103.746.03 1.033-.185l.103-.087 2.863-2.75-1.885.001a.75.75 0 0 1-.743-.648l-.007-.102a.75.75 0 0 1 .648-.743l.102-.007h3.786l.042.004-.078-.004a.754.754 0 0 1 .53.22l.011.01z"
        })
    });
var $558a1874964eed3d$var$DataVisTrendAsc$1 = $558a1874964eed3d$var$DataVisTrendAsc;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DataVisTrendDesc = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M13.25 9.05c.753 0 1.375.597 1.375 1.35v9.45h1V16.4c0-.708.551-1.28 1.244-1.344L17 15.05h2.5c.753 0 1.375.597 1.375 1.35v3.45h.5a.75.75 0 0 1 .102 1.493l-.102.007H2.625a.75.75 0 0 1-.102-1.493l.102-.007h.5V12.8c0-.708.551-1.28 1.244-1.344l.131-.006H7c.753 0 1.375.597 1.375 1.35v7.05h1V10.4c0-.708.551-1.28 1.244-1.344l.131-.006zm6.125 7.499h-2.25v3.301h2.25v-3.301zm-6.25-6h-2.25v9.301h2.25v-9.301zm-6.25 2.401h-2.25v6.9h2.25v-6.9zM4.309 1.988l.085.071 4.86 4.666c.254.243.616.356.971.307l.133-.026 4.737-1.218a2.684 2.684 0 0 1 2.45.506l.141.125 2.939 2.823v-1.84a.75.75 0 0 1 .648-.743l.102-.007a.75.75 0 0 1 .743.649l.007.101v3.622a.754.754 0 0 1-.003.043l.003-.065a.755.755 0 0 1-.147.446.755.755 0 0 1-.501.298l-.017.002a.754.754 0 0 1-.05.004h-3.785a.75.75 0 0 1-.102-1.493l.102-.007h1.886l-2.864-2.751a1.177 1.177 0 0 0-1.016-.298l-.142.032-4.758 1.224a2.684 2.684 0 0 1-2.38-.53l-.135-.122-4.86-4.666a.75.75 0 0 1 .953-1.153z"
        })
    });
var $558a1874964eed3d$var$DataVisTrendDesc$1 = $558a1874964eed3d$var$DataVisTrendDesc;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DateCalendar = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M16.377 1.875a.75.75 0 0 1 .75.75v1.75h2.75a2.25 2.25 0 0 1 2.25 2.25v13.25a2.25 2.25 0 0 1-2.25 2.25H4.127a2.25 2.25 0 0 1-2.25-2.25V6.625a2.25 2.25 0 0 1 2.25-2.25h2.75v-1.75a.75.75 0 0 1 .648-.743l.102-.007a.75.75 0 0 1 .75.75v1.75h7.25v-1.75a.75.75 0 0 1 .648-.743zm4.25 9H3.377v9c0 .414.335.75.75.75h15.75a.75.75 0 0 0 .75-.75v-9zm-13.75-5h-2.75a.75.75 0 0 0-.75.75v2.75h17.25v-2.75a.75.75 0 0 0-.75-.75h-2.75V7a.75.75 0 0 1-.649.743l-.101.007a.75.75 0 0 1-.75-.75V5.875h-7.25V7a.75.75 0 0 1-.649.743l-.101.007a.75.75 0 0 1-.75-.75V5.875z"
        })
    });
var $558a1874964eed3d$var$DateCalendar$1 = $558a1874964eed3d$var$DateCalendar;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DateClock = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 1.705c5.686 0 10.295 4.609 10.295 10.295S17.686 22.295 12 22.295 1.705 17.686 1.705 12 6.314 1.705 12 1.705zm0 1.5a8.795 8.795 0 1 0 0 17.59 8.795 8.795 0 0 0 0-17.59zm0 4.636a.75.75 0 0 1 .75.75v3.099l4.041 4.042a.75.75 0 0 1 .073.976l-.073.084a.75.75 0 0 1-1.06 0L11.47 12.53l-.064-.072A.75.75 0 0 1 11.25 12l.004.076a.754.754 0 0 1-.003-.047L11.25 12V8.59a.75.75 0 0 1 .75-.75z"
        })
    });
var $558a1874964eed3d$var$DateClock$1 = $558a1874964eed3d$var$DateClock;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DirectoryFolder = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M10.792 5.667h9.625c1.15 0 2.083.933 2.083 2.083v12c0 1.15-.933 2.083-2.083 2.083H3.083A2.084 2.084 0 0 1 1 19.75V5.083C1 3.933 1.933 3 3.083 3H7.75c.656 0 1.274.309 1.667.833l1.375 1.834zM3.083 4.5a.584.584 0 0 0-.583.583V19.75c0 .322.262.583.583.583h17.334A.584.584 0 0 0 21 19.75v-12a.584.584 0 0 0-.583-.583h-10a.75.75 0 0 1-.6-.3l-1.6-2.134A.582.582 0 0 0 7.75 4.5H3.083z"
        })
    });
var $558a1874964eed3d$var$DirectoryFolder$1 = $558a1874964eed3d$var$DirectoryFolder;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Document = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M18.6,22.8H5.6c-1,0-1.8-.8-1.8-1.8V3c0-1,.8-1.8,1.8-1.8h8.1c.5,0,.9.2,1.3.6l4.9,5.3c.3.3.5.8.5,1.2v12.8c0,1-.8,1.8-1.7,1.8ZM5.6,2.7c-.1,0-.2.1-.2.2v18c0,.1.1.2.2.2h13c.1,0,.2-.1.2-.2v-12.8c0,0,0-.1,0-.2l-4.9-5.2c0,0-.1,0-.2,0H5.6Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M19.6,8.7h-4.5c-1,0-1.8-.8-1.8-1.8V2.5h1.5v4.5c0,.1.1.2.2.2h4.5v1.5Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.1,8.7h-3.5c-.4,0-.8-.3-.8-.8s.3-.8.8-.8h3.5c.4,0,.8.3.8.8s-.3.8-.8.8Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16.6,14.8H7.6c-.4,0-.8-.3-.8-.8s.3-.8.8-.8h9c.4,0,.8.3.8.8s-.3.8-.8.8Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16.6,11.7H7.6c-.4,0-.8-.3-.8-.8s.3-.8.8-.8h9c.4,0,.8.3.8.8s-.3.8-.8.8Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16.6,17.8H7.6c-.4,0-.8-.3-.8-.8s.3-.8.8-.8h9c.4,0,.8.3.8.8s-.3.8-.8.8Z"
            })
        ]
    });
var $558a1874964eed3d$var$Document$1 = $558a1874964eed3d$var$Document;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Drag = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 8.19095,
                cy: 4.38095,
                r: 2.38095
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 8.19095,
                cy: 12,
                r: 2.38095
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 8.19095,
                cy: 19.619,
                r: 2.38095
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 15.81,
                cy: 4.38095,
                r: 2.38095
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 15.81,
                cy: 12,
                r: 2.38095
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 15.81,
                cy: 19.619,
                r: 2.38095
            })
        ]
    });
var $558a1874964eed3d$var$Drag$1 = $558a1874964eed3d$var$Drag;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Duplicate = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.25 1.5C2.05109 1.5 1.86032 1.57902 1.71967 1.71967C1.57902 1.86032 1.5 2.05109 1.5 2.25V17.25C1.5 17.4489 1.57902 17.6397 1.71967 17.7803C1.86032 17.921 2.05109 18 2.25 18C2.66421 18 3 18.3358 3 18.75C3 19.1642 2.66421 19.5 2.25 19.5C1.65326 19.5 1.08097 19.2629 0.65901 18.841C0.237053 18.419 0 17.8467 0 17.25V2.25C0 1.65326 0.237053 1.08097 0.65901 0.65901C1.08097 0.237053 1.65326 0 2.25 0H17.25C17.8467 0 18.419 0.237053 18.841 0.65901C19.2629 1.08097 19.5 1.65326 19.5 2.25C19.5 2.66421 19.1642 3 18.75 3C18.3358 3 18 2.66421 18 2.25C18 2.05109 17.921 1.86032 17.7803 1.71967C17.6397 1.57902 17.4489 1.5 17.25 1.5H2.25ZM6 6.75677V21.75C6 21.9938 6.05879 22.1267 6.10841 22.2012C6.16117 22.2803 6.23688 22.3424 6.33541 22.3917C6.43687 22.4424 6.54742 22.4715 6.63892 22.4868C6.6829 22.4941 6.71791 22.4975 6.73898 22.499C6.74502 22.4994 6.74977 22.4997 6.75312 22.4998L6.75679 22.5H21.75C21.9938 22.5 22.1267 22.4412 22.2012 22.3916C22.2803 22.3388 22.3424 22.2631 22.3917 22.1646C22.4424 22.0631 22.4715 21.9526 22.4868 21.8611C22.4941 21.8171 22.4975 21.7821 22.499 21.761C22.4996 21.7523 22.4999 21.7462 22.5 21.7432V6.75C22.5 6.50624 22.4412 6.37328 22.3916 6.29884C22.3388 6.2197 22.2631 6.15758 22.1646 6.10832C22.0631 6.05759 21.9526 6.02848 21.8611 6.01323C21.8171 6.0059 21.7821 6.00253 21.761 6.00102C21.7523 6.0004 21.7462 6.00012 21.7432 6H6.75C6.50624 6 6.37328 6.05879 6.29884 6.10841C6.2197 6.16117 6.15758 6.23688 6.10832 6.33541C6.05759 6.43687 6.02848 6.54742 6.01323 6.63892C6.0059 6.6829 6.00253 6.71791 6.00102 6.73898C6.0004 6.74772 6.00012 6.75378 6 6.75677ZM21.75 5.25C21.75 4.5 21.7508 4.5 21.7508 4.5L21.7532 4.50001L21.757 4.50003L21.7664 4.50014L21.7918 4.50078C21.8117 4.50144 21.8373 4.50265 21.8679 4.50484C21.9288 4.50919 22.011 4.51753 22.1077 4.53364C22.2974 4.56527 22.5619 4.62991 22.8354 4.76668C23.1119 4.90492 23.4112 5.12405 23.6397 5.46679C23.8713 5.81422 24 6.24376 24 6.75V21.75H23.25C24 21.75 24 21.75 24 21.75L24 21.7532L24 21.757L23.9999 21.7664L23.9992 21.7918C23.9986 21.8117 23.9974 21.8373 23.9952 21.8679C23.9908 21.9288 23.9825 22.011 23.9664 22.1077C23.9347 22.2974 23.8701 22.5619 23.7333 22.8354C23.5951 23.1119 23.376 23.4112 23.0332 23.6397C22.6858 23.8713 22.2562 24 21.75 24H6.75V23.25C6.75 24 6.75 24 6.75 24L6.74677 24L6.74296 24L6.7336 23.9999L6.70817 23.9992C6.68834 23.9986 6.66272 23.9974 6.63211 23.9952C6.57116 23.9908 6.48898 23.9825 6.39233 23.9664C6.20258 23.9347 5.93813 23.8701 5.66459 23.7333C5.38812 23.5951 5.08883 23.376 4.86034 23.0332C4.62871 22.6858 4.5 22.2562 4.5 21.75V6.75H5.25C4.5 6.75 4.5 6.75 4.5 6.75L4.5 6.74846L4.50001 6.74677L4.50003 6.74296L4.50014 6.7336L4.50078 6.70817C4.50144 6.68834 4.50265 6.66272 4.50484 6.63211C4.50919 6.57116 4.51753 6.48898 4.53364 6.39233C4.56527 6.20258 4.62991 5.93813 4.76668 5.66459C4.90492 5.38812 5.12405 5.08883 5.46679 4.86034C5.81422 4.62871 6.24376 4.5 6.75 4.5L21.7508 4.5L21.75 5.25Z"
        })
    });
var $558a1874964eed3d$var$Duplicate$1 = $558a1874964eed3d$var$Duplicate;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$EditDisabledPencil = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M8.429 11.306a.75.75 0 0 1 .072.976l-.072.084-2.973 2.97 1.504.643 2.426-2.426a.75.75 0 0 1 .977-.073l.084.073a.75.75 0 0 1 0 1.06L8.022 17.04l.644 1.503 3.15-3.149a.75.75 0 0 1 1.134.977l-.073.084L8.94 20.39a.75.75 0 0 1-.246.163l-.094.032L2.815 22.1a.75.75 0 0 1-.935-.819l.02-.097L3.416 15.4l.002-.008.012-.037.018-.049a.75.75 0 0 1 .043-.088l.004-.007a.71.71 0 0 1 .051-.076l.009-.012a.744.744 0 0 1 .038-.044l.018-.019 3.757-3.755a.75.75 0 0 1 1.06 0zm-6.126-8.17a.75.75 0 0 1 1.06 0l17.5 17.5a.75.75 0 0 1-1.06 1.061l-17.5-17.5a.75.75 0 0 1 0-1.06zm2.343 13.486l-.97 3.702 3.706-.971-.82-1.913-1.916-.818zM18.333 1.88a3.778 3.778 0 0 1 2.692 1.101 3.774 3.774 0 0 1 .129 5.191l-.16.166-5.23 5.228a.75.75 0 0 1-1.133-.977l.073-.084 2.613-2.613-1.074-1.074-2.463 2.462a.75.75 0 0 1-.977.072l-.084-.073a.75.75 0 0 1 .001-1.06l2.462-2.461-1.073-1.073-2.83 2.831a.75.75 0 0 1-1.134-.977l.073-.084 5.442-5.44a3.777 3.777 0 0 1 2.673-1.135zM15.85 4.946l-.68.68 3.208 3.206.68-.68-3.208-3.206zm2.494-1.565c-.52.003-1.02.184-1.424.513l3.192 3.19a2.274 2.274 0 0 0-.148-3.04 2.276 2.276 0 0 0-1.62-.663z"
        })
    });
var $558a1874964eed3d$var$EditDisabledPencil$1 = $558a1874964eed3d$var$EditDisabledPencil;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$EditPencilSm = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M2.476 10.67a.292.292 0 0 1 .274.078l2.499 2.5a.292.292 0 0 1-.117.483l-3.745 1.247a.292.292 0 0 1-.369-.37v.001l1.249-3.745a.292.292 0 0 1 .209-.193zm7.554-7.622a.3.3 0 0 1 .412 0l2.497 2.498a.292.292 0 0 1 0 .412l-6.657 6.657a.292.292 0 0 1-.413 0l-2.497-2.497a.292.292 0 0 1 0-.412zm1.458-1.455a2.108 2.108 0 0 1 2.91 0c.8.804.8 2.103 0 2.907l-.416.418a.292.292 0 0 1-.413 0l-2.496-2.496a.292.292 0 0 1 0-.413z"
        })
    });
var $558a1874964eed3d$var$EditPencilSm$1 = $558a1874964eed3d$var$EditPencilSm;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$EditPencil = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M18.333 1.88a3.777 3.777 0 0 1 2.69 1.1l.16.171a3.774 3.774 0 0 1-.189 5.188L8.94 20.389a.75.75 0 0 1-.34.196L2.815 22.1a.75.75 0 0 1-.915-.916L3.416 15.4a.75.75 0 0 1 .195-.34l-.056.063a.744.744 0 0 1 .038-.044l.018-.019L15.66 3.016a3.777 3.777 0 0 1 2.673-1.135zM4.646 16.623l-.97 3.702 3.706-.971-.82-1.913-1.916-.818zM16.244 8.82l-8.222 8.219.644 1.503 8.651-8.65-1.073-1.072zM14.11 6.686l-8.653 8.65 1.504.643 8.223-8.22-1.074-1.073zm4.27 2.147l.68-.68-3.209-3.207-.68.68 1.6 1.599.005.004 1.603 1.604zm-.035-5.452c-.52.003-1.02.184-1.424.513l3.192 3.19a2.274 2.274 0 0 0-.149-3.042l-.149-.135a2.277 2.277 0 0 0-1.47-.526z"
        })
    });
var $558a1874964eed3d$var$EditPencil$1 = $558a1874964eed3d$var$EditPencil;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$EditRedo = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M21.1243 2.03216C21.0474 2.00024 20.9627 1.99184 20.8811 2.00802C20.7994 2.02421 20.7243 2.06426 20.6654 2.12311L18.4835 4.30498C18.4519 4.3366 18.411 4.35732 18.3668 4.36413C18.3225 4.37095 18.2773 4.3635 18.2376 4.34287C16.5248 3.45509 14.6015 3.0536 12.6766 3.18202C10.7516 3.31043 8.89871 3.96385 7.31902 5.07128C5.99115 6.0207 4.90735 7.27147 4.15658 8.72094C3.40581 10.1704 3.00948 11.7773 3.00011 13.4096C2.99074 15.042 3.3686 16.6532 4.10268 18.1112C4.83676 19.5692 5.90613 20.8324 7.22302 21.797C7.44837 21.9618 7.72996 22.0303 8.00585 21.9875C8.28174 21.9447 8.52934 21.7941 8.69416 21.5688C8.85898 21.3434 8.92754 21.0618 8.88474 20.7859C8.84194 20.51 8.6913 20.2624 8.46595 20.0976C7.41805 19.3297 6.56714 18.3242 5.98305 17.1638C5.39895 16.0033 5.09831 14.7209 5.10579 13.4217C5.11327 12.1226 5.42865 10.8437 6.02607 9.69003C6.62348 8.53637 7.4859 7.54078 8.54258 6.78495C9.68928 5.9795 11.0188 5.47295 12.4108 5.3112C13.8027 5.14945 15.213 5.33761 16.5138 5.85864C16.5462 5.87157 16.5749 5.89233 16.5972 5.91906C16.6196 5.94579 16.635 5.97766 16.642 6.0118C16.649 6.04594 16.6474 6.08128 16.6374 6.11467C16.6274 6.14805 16.6092 6.17842 16.5846 6.20306L15.0267 7.76093C14.968 7.81987 14.928 7.89488 14.9119 7.97651C14.8957 8.05814 14.9041 8.14273 14.936 8.21958C14.9679 8.29644 15.0219 8.36212 15.0911 8.40834C15.1603 8.45455 15.2416 8.47922 15.3248 8.47924H20.9668C21.0785 8.47924 21.1856 8.43488 21.2646 8.35592C21.3435 8.27696 21.3879 8.16986 21.3879 8.05819V2.42121C21.3876 2.33751 21.3624 2.25579 21.3154 2.1865C21.2685 2.1172 21.2019 2.06347 21.1243 2.03216Z"
        })
    });
var $558a1874964eed3d$var$EditRedo$1 = $558a1874964eed3d$var$EditRedo;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$EditUndo = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M17.0872 5.07579C15.5049 3.96718 13.6491 3.31308 11.7214 3.18447C9.79366 3.05585 7.86751 3.45763 6.15194 4.34622C6.11222 4.36701 6.06688 4.37454 6.02256 4.36771C5.97825 4.36088 5.93728 4.34005 5.90566 4.30826L3.71946 2.1229C3.66011 2.06448 3.585 2.02466 3.50334 2.00833C3.42168 1.992 3.33703 1.99987 3.25978 2.03097C3.18282 2.06297 3.11706 2.11707 3.07083 2.18643C3.02459 2.25578 2.99994 2.33728 3 2.42064V8.0717C3 8.18355 3.04443 8.29081 3.12352 8.3699C3.20261 8.44899 3.30987 8.49342 3.42172 8.49342H9.07278C9.1563 8.49357 9.23798 8.46892 9.30747 8.42259C9.37696 8.37626 9.43113 8.31034 9.46312 8.23319C9.4951 8.15604 9.50345 8.07112 9.48712 7.98922C9.47078 7.90731 9.43049 7.8321 9.37136 7.77312L7.80678 6.21022C7.78218 6.18533 7.76409 6.15477 7.75408 6.12123C7.74408 6.0877 7.74248 6.05222 7.74942 6.01792C7.75647 5.98384 7.77188 5.95205 7.79426 5.92541C7.81663 5.89876 7.84528 5.87809 7.87763 5.86525C9.18055 5.34339 10.5931 5.15493 11.9873 5.31693C13.3814 5.47894 14.7131 5.98631 15.8617 6.79304C16.9202 7.54988 17.7842 8.5469 18.3828 9.7023C18.9813 10.8577 19.2975 12.1386 19.3052 13.4398C19.313 14.741 19.0121 16.0255 18.4273 17.188C17.8425 18.3504 16.9904 19.3576 15.9409 20.127C15.731 20.2974 15.5945 20.5419 15.5597 20.81C15.5249 21.0781 15.5944 21.3494 15.7539 21.5677C15.9135 21.786 16.1507 21.9347 16.4168 21.983C16.6828 22.0314 16.9572 21.9757 17.1833 21.8274C18.5091 20.8677 19.5851 19.6037 20.3209 18.1417C21.0566 16.6797 21.4306 15.0624 21.4115 13.4259C21.4113 11.7896 21.0184 10.1773 20.266 8.72434C19.5135 7.27137 18.4234 6.02016 17.0872 5.07579V5.07579Z"
        })
    });
var $558a1874964eed3d$var$EditUndo$1 = $558a1874964eed3d$var$EditUndo;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$FeedbackBubble = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M21.75,0 L2.25,0 C1.00735931,0 0,1.00735931 0,2.25 L0,17.25 L0.00519081254,17.4040488 C0.084355084,18.5748384 1.05913601,19.5 2.25,19.5 L4.5,19.5 L4.5,23.25 L4.50713769,23.3562181 C4.58227796,23.9070344 5.23465676,24.1990074 5.7,23.85 L11.5,19.5 L21.75,19.5 C22.9926407,19.5 24,18.4926407 24,17.25 L24,2.25 C24,1.00735931 22.9926407,0 21.75,0 Z M2.25,1.5 L21.75,1.5 C22.1642136,1.5 22.5,1.83578644 22.5,2.25 L22.5,17.25 C22.5,17.6642136 22.1642136,18 21.75,18 L11.25,18 L11.1533483,18.0062528 C11.0256854,18.0228427 10.9038577,18.0721067 10.8,18.15 L6,21.75 L6,18.75 C6,18.3357864 5.66421356,18 5.25,18 L2.25,18 C1.83578644,18 1.5,17.6642136 1.5,17.25 L1.5,2.25 C1.5,1.83578644 1.83578644,1.5 2.25,1.5 Z"
        })
    });
var $558a1874964eed3d$var$FeedbackBubble$1 = $558a1874964eed3d$var$FeedbackBubble;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$FileTextAdd = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.33,21.33c-1.6,0-3.11-.62-4.24-1.76-1.13-1.13-1.76-2.64-1.76-4.24s.62-3.11,1.76-4.24c1.13-1.13,2.64-1.76,4.24-1.76s3.11.62,4.24,1.76c1.13,1.13,1.76,2.64,1.76,4.24s-.62,3.11-1.76,4.24c-1.13,1.13-2.64,1.76-4.24,1.76ZM15.33,10.67c-1.25,0-2.42.49-3.3,1.37-.88.88-1.37,2.05-1.37,3.3s.49,2.42,1.37,3.3c.88.88,2.05,1.37,3.3,1.37s2.42-.49,3.3-1.37,1.37-2.05,1.37-3.3-.49-2.42-1.37-3.3-2.05-1.37-3.3-1.37Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.33,18.67c-.37,0-.67-.3-.67-.67v-5.33c0-.37.3-.67.67-.67s.67.3.67.67v5.33c0,.37-.3.67-.67.67Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M18,16h-5.33c-.37,0-.67-.3-.67-.67s.3-.67.67-.67h5.33c.37,0,.67.3.67.67s-.3.67-.67.67Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12.67,6.67H3.33c-.37,0-.67-.3-.67-.67s.3-.67.67-.67h9.33c.37,0,.67.3.67.67s-.3.67-.67.67Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M8.67,10.67H3.33c-.37,0-.67-.3-.67-.67s.3-.67.67-.67h5.33c.37,0,.67.3.67.67s-.3.67-.67.67Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M6.67,14.67h-3.33c-.37,0-.67-.3-.67-.67s.3-.67.67-.67h3.33c.37,0,.67.3.67.67s-.3.67-.67.67Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M6.67,18.67H2c-.54,0-1.04-.21-1.42-.59-.38-.38-.58-.88-.58-1.41V2C0,1.47.21.96.59.59c.38-.38.88-.59,1.41-.59h9.45c.53,0,1.04.21,1.41.58l2.55,2.55c.38.38.59.88.59,1.41v2.11c0,.37-.3.67-.67.67s-.67-.3-.67-.67v-2.11c0-.18-.07-.35-.2-.47l-2.55-2.55c-.12-.13-.29-.19-.47-.19H2c-.18,0-.35.07-.47.2s-.2.29-.2.47v14.67c0,.18.07.34.2.47.13.13.29.2.47.2h4.67c.37,0,.67.3.67.67s-.3.67-.67.67Z"
            })
        ]
    });
var $558a1874964eed3d$var$FileTextAdd$1 = $558a1874964eed3d$var$FileTextAdd;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$FileText = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 21 22",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.1422 1.88749C16.0258 1.77423 15.8698 1.71094 15.7075 1.71115L2.33309 1.71115C2.16813 1.71115 2.00993 1.77668 1.89329 1.89332C1.77664 2.00996 1.71112 2.16817 1.71112 2.33312V19.667C1.71112 19.8319 1.77664 19.9901 1.89329 20.1068C2.00993 20.2234 2.16813 20.2889 2.33309 20.2889H18.3329C18.4979 20.2889 18.6561 20.2234 18.7727 20.1068C18.8894 19.9901 18.9549 19.8319 18.9549 19.667L18.9558 4.89604C18.9558 4.81305 18.9392 4.73075 18.9069 4.65429C18.8746 4.57779 18.8273 4.50852 18.7678 4.45057L16.1422 1.88749C16.1422 1.88755 16.1421 1.88744 16.1422 1.88749ZM15.7062 0.288941C16.2399 0.288402 16.7526 0.496594 17.1348 0.869048L19.7601 3.43175C19.9556 3.62218 20.111 3.84984 20.2172 4.10129C20.3233 4.35275 20.378 4.6229 20.378 4.89583L20.3771 19.667C20.3771 19.6669 20.3771 19.667 20.3771 19.667C20.3771 20.2091 20.1617 20.7291 19.7784 21.1124C19.395 21.4958 18.8751 21.7111 18.3329 21.7111H2.33309C1.79094 21.7111 1.271 21.4958 0.887637 21.1124C0.504279 20.7291 0.28891 20.2091 0.28891 19.667V2.33312C0.28891 1.79097 0.504279 1.27103 0.887637 0.887669C1.271 0.50431 1.79094 0.288941 2.33309 0.288941H15.7062Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.328 7.66642C4.328 7.27369 4.64637 6.95532 5.0391 6.95532H15.7056C16.0984 6.95532 16.4167 7.27369 16.4167 7.66642C16.4167 8.05916 16.0984 8.37753 15.7056 8.37753H5.0391C4.64637 8.37753 4.328 8.05916 4.328 7.66642Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.328 11.6665C4.328 11.2738 4.64637 10.9554 5.0391 10.9554H15.7056C16.0984 10.9554 16.4167 11.2738 16.4167 11.6665C16.4167 12.0593 16.0984 12.3776 15.7056 12.3776H5.0391C4.64637 12.3776 4.328 12.0593 4.328 11.6665Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.328 15.6668C4.328 15.2741 4.64637 14.9557 5.0391 14.9557H10.3724C10.7651 14.9557 11.0835 15.2741 11.0835 15.6668C11.0835 16.0595 10.7651 16.3779 10.3724 16.3779H5.0391C4.64637 16.3779 4.328 16.0595 4.328 15.6668Z"
            })
        ]
    });
var $558a1874964eed3d$var$FileText$1 = $558a1874964eed3d$var$FileText;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Filter = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M21.9117 2.46C21.8424 2.32175 21.736 2.20551 21.6044 2.12427C21.4729 2.04303 21.3213 2.00001 21.1667 2H2.83333C2.67857 2 2.52687 2.0431 2.39522 2.12446C2.26358 2.20582 2.15719 2.32223 2.08798 2.46066C2.01877 2.59908 1.98947 2.75404 2.00337 2.90817C2.01727 3.06231 2.07381 3.20953 2.16667 3.33333L9.5 13.1858V20.3333C9.50327 20.7744 9.67992 21.1964 9.99177 21.5082C10.3036 21.8201 10.7257 21.9967 11.1667 22C11.5274 22.0004 11.8784 21.8834 12.1667 21.6667L13.8333 20.4167C14.04 20.2611 14.2078 20.0597 14.3234 19.8284C14.4391 19.597 14.4995 19.342 14.5 19.0833V13.1858L21.8333 3.33333C21.9263 3.20942 21.9828 3.06207 21.9967 2.9078C22.0105 2.75354 21.9811 2.59847 21.9117 2.46ZM6.51417 3.83333L9.79667 8.20833C9.85076 8.28046 9.88 8.36818 9.88 8.45833V9.5C9.88 9.58745 9.85248 9.67269 9.80135 9.74363C9.75022 9.81457 9.67806 9.86763 9.5951 9.89528C9.51213 9.92294 9.42257 9.92379 9.3391 9.89771C9.25562 9.87164 9.18247 9.81996 9.13 9.75L5.01667 4.33333C4.97024 4.27143 4.94197 4.19782 4.93502 4.12075C4.92807 4.04369 4.94272 3.96621 4.97732 3.89699C5.01193 3.82778 5.06512 3.76958 5.13095 3.7289C5.19677 3.68821 5.27262 3.66667 5.35 3.66667H6.18333C6.2476 3.66705 6.3109 3.6823 6.36829 3.71121C6.42568 3.74012 6.47561 3.78192 6.51417 3.83333Z"
        })
    });
var $558a1874964eed3d$var$Filter$1 = $558a1874964eed3d$var$Filter;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$FullscreenExpand = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7.08369 5.83386H12.9162C12.9162 5.83386 14.166 5.83386 14.166 7.08369V12.9162C14.166 12.9162 14.166 14.166 12.9162 14.166H7.08369C7.08369 14.166 5.83386 14.166 5.83386 12.9162V7.08369C5.83386 7.08369 5.83386 5.83386 7.08369 5.83386Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M0.00136826 19.582C0.00136826 19.6925 0.0452609 19.7984 0.12339 19.8766C0.20152 19.9547 0.307486 19.9986 0.417978 19.9986H4.58407C4.6719 20.0051 4.75953 19.9836 4.83438 19.9372C4.90924 19.8908 4.96745 19.8218 5.00068 19.7403C5.03471 19.6652 5.04417 19.5813 5.02772 19.5005C5.01126 19.4197 4.96972 19.3461 4.90903 19.2903L3.67586 18.0905C3.63897 18.0493 3.61858 17.9959 3.61858 17.9405C3.61858 17.8852 3.63897 17.8318 3.67586 17.7905L5.3423 16.1241C5.53677 15.9296 5.64601 15.6659 5.64601 15.3909C5.64601 15.1159 5.53677 14.8521 5.3423 14.6576C5.14783 14.4632 4.88408 14.3539 4.60907 14.3539C4.33405 14.3539 4.0703 14.4632 3.87584 14.6576L2.2094 16.3241C2.18997 16.3442 2.16667 16.3603 2.1409 16.3712C2.11513 16.3822 2.08742 16.3878 2.05942 16.3878C2.03142 16.3878 2.00371 16.3822 1.97794 16.3712C1.95217 16.3603 1.92887 16.3442 1.90944 16.3241L0.709604 15.1242C0.657969 15.0579 0.586335 15.0099 0.505302 14.9874C0.424269 14.9648 0.338142 14.969 0.259666 14.9993C0.177316 15.0314 0.107615 15.0894 0.0610376 15.1645C0.0144598 15.2396 -0.00647878 15.3278 0.00136826 15.4159V19.582Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M19.9986 0.417932C19.9986 0.30744 19.9547 0.201474 19.8766 0.123344C19.7985 0.0452151 19.6925 0.00132242 19.582 0.00132242H15.4159C15.3281 -0.00518554 15.2405 0.0163076 15.1656 0.0627154C15.0908 0.109123 15.0325 0.178058 14.9993 0.25962C14.9665 0.334951 14.9577 0.418551 14.9741 0.499053C14.9905 0.579556 15.0313 0.653055 15.091 0.709558L16.2908 1.90939C16.3277 1.95064 16.3481 2.00404 16.3481 2.05937C16.3481 2.11471 16.3277 2.16811 16.2908 2.20935L14.6244 3.87579C14.5276 3.97183 14.4509 4.08606 14.3985 4.2119C14.3461 4.33774 14.3191 4.47271 14.3191 4.60902C14.3191 4.74534 14.3461 4.8803 14.3985 5.00614C14.4509 5.13199 14.5276 5.24622 14.6244 5.34225C14.7198 5.44001 14.8339 5.51769 14.9598 5.57072C15.0857 5.62376 15.221 5.65108 15.3576 5.65108C15.4942 5.65108 15.6295 5.62376 15.7554 5.57072C15.8813 5.51769 15.9954 5.44001 16.0908 5.34225L17.7573 3.67582C17.7985 3.63893 17.8519 3.61853 17.9073 3.61853C17.9626 3.61853 18.016 3.63893 18.0572 3.67582L19.2571 4.87565C19.2979 4.92013 19.3485 4.95456 19.4049 4.97624C19.4613 4.99792 19.5219 5.00627 19.582 5.00063C19.6341 5.01244 19.6882 5.01244 19.7403 5.00063C19.8219 4.96741 19.8908 4.90919 19.9372 4.83434C19.9836 4.75949 20.0051 4.67185 19.9986 4.58403V0.417932Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M0.418359 0.0013682C0.307867 0.0013682 0.201901 0.0452608 0.123772 0.12339C0.0456423 0.20152 0.00174967 0.307486 0.00174967 0.417978V4.58407C-0.00475829 4.6719 0.0167349 4.75953 0.0631426 4.83438C0.10955 4.90924 0.178485 4.96745 0.260047 5.00068C0.312158 5.01249 0.366249 5.01249 0.418359 5.00068C0.472998 5.00135 0.527172 4.99057 0.577396 4.96905C0.627621 4.94752 0.672786 4.91572 0.709985 4.8757L1.90982 3.67586C1.95107 3.63897 2.00446 3.61858 2.0598 3.61858C2.11514 3.61858 2.16853 3.63897 2.20978 3.67586L3.87622 5.3423C3.97168 5.44005 4.08572 5.51773 4.21164 5.57077C4.33756 5.6238 4.47282 5.65112 4.60945 5.65112C4.74608 5.65112 4.88134 5.6238 5.00726 5.57077C5.13318 5.51773 5.24722 5.44005 5.34268 5.3423C5.43942 5.24626 5.5162 5.13203 5.56859 5.00619C5.62099 4.88035 5.64796 4.74538 5.64796 4.60907C5.64796 4.47275 5.62099 4.33779 5.56859 4.21195C5.5162 4.0861 5.43942 3.97187 5.34268 3.87584L3.67624 2.2094C3.63935 2.16815 3.61896 2.11476 3.61896 2.05942C3.61896 2.00408 3.63935 1.95068 3.67624 1.90944L4.87608 0.709604C4.94142 0.65715 4.98863 0.585501 5.01106 0.50477C5.03348 0.424039 5.02998 0.338303 5.00106 0.259666C4.96783 0.178104 4.90962 0.109169 4.83476 0.0627611C4.75991 0.0163534 4.67228 -0.00513976 4.58445 0.0013682H0.418359Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M19.9986 19.582V15.4159C19.9994 15.3334 19.9751 15.2526 19.929 15.1842C19.8828 15.1157 19.8171 15.0629 19.7404 15.0326C19.6653 14.9986 19.5813 14.9891 19.5005 15.0056C19.4198 15.022 19.3462 15.0635 19.2904 15.1242L18.0906 16.3157C18.0711 16.3359 18.0479 16.3519 18.0221 16.3629C17.9963 16.3739 17.9686 16.3795 17.9406 16.3795C17.9126 16.3795 17.8849 16.3739 17.8591 16.3629C17.8333 16.3519 17.8101 16.3359 17.7906 16.3157L16.1242 14.6493C15.9297 14.4548 15.666 14.3456 15.391 14.3456C15.1159 14.3456 14.8522 14.4548 14.6577 14.6493C14.4633 14.8438 14.354 15.1075 14.354 15.3825C14.354 15.6576 14.4633 15.9213 14.6577 16.1158L16.3242 17.7822C16.361 17.8235 16.3814 17.8769 16.3814 17.9322C16.3814 17.9875 16.361 18.0409 16.3242 18.0822L15.1243 19.282C15.0636 19.3378 15.0221 19.4113 15.0056 19.4921C14.9892 19.5729 14.9986 19.6568 15.0327 19.7319C15.0639 19.808 15.117 19.8732 15.1852 19.9191C15.2534 19.9651 15.3337 19.9898 15.4159 19.9902H19.582C19.6911 19.9903 19.7958 19.9475 19.8737 19.8712C19.9516 19.7948 19.9965 19.691 19.9986 19.582Z"
            })
        ]
    });
var $558a1874964eed3d$var$FullscreenExpand$1 = $558a1874964eed3d$var$FullscreenExpand;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$GridThree = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7.3,7.3H2V2h5.3V7.3z M3.5,5.8h2.3V3.5H3.5V5.8z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14.6,7.3H9.4V2h5.3V7.3z M10.9,5.8h2.3V3.5h-2.3C10.9,3.5,10.9,5.8,10.9,5.8z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M22,7.3h-5.3V2H22V7.3z M18.2,5.8h2.3V3.5h-2.3C18.2,3.5,18.2,5.8,18.2,5.8z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7.3,22H2v-5.3h5.3V22z M3.5,20.5h2.3v-2.3H3.5C3.5,18.2,3.5,20.5,3.5,20.5z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14.6,22H9.4v-5.3h5.3V22z M10.9,20.5h2.3v-2.3h-2.3V20.5z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M22,22h-5.3v-5.3H22V22z M18.2,20.5h2.3v-2.3h-2.3V20.5z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7.3,14.6H2V9.4h5.3V14.6z M3.5,13.1h2.3v-2.3H3.5C3.5,10.9,3.5,13.1,3.5,13.1z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14.6,14.6H9.4V9.4h5.3V14.6z M10.9,13.1h2.3v-2.3h-2.3V13.1z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M22,14.6h-5.3V9.4H22V14.6z M18.2,13.1h2.3v-2.3h-2.3V13.1z"
            })
        ]
    });
var $558a1874964eed3d$var$GridThree$1 = $558a1874964eed3d$var$GridThree;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$GridTwo = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.5,22H2v-8.5h8.5V22z M3.5,20.5H9V15H3.5V20.5z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M22,22h-8.5v-8.5H22V22z M15,20.5h5.5V15H15V20.5z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.5,10.5H2V2h8.5V10.5z M3.5,9H9V3.5H3.5V9z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M22,10.5h-8.5V2H22V10.5z M15,9h5.5V3.5H15V9z"
            })
        ]
    });
var $558a1874964eed3d$var$GridTwo$1 = $558a1874964eed3d$var$GridTwo;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Hamburger = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 20 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M0.869565 0H19.1304C19.1304 0 20 0 20 0.842105V1.68421C20 1.68421 20 2.52632 19.1304 2.52632H0.869565C0.869565 2.52632 0 2.52632 0 1.68421V0.842105C0 0.842105 0 0 0.869565 0Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M0.869565 6.7368H19.1304C19.1304 6.7368 20 6.7368 20 7.57891V8.42101C20 8.42101 20 9.26312 19.1304 9.26312H0.869565C0.869565 9.26312 0 9.26312 0 8.42101V7.57891C0 7.57891 0 6.7368 0.869565 6.7368Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M0.869565 13.4737H19.1304C19.1304 13.4737 20 13.4737 20 14.3158V15.1579C20 15.1579 20 16 19.1304 16H0.869565C0.869565 16 0 16 0 15.1579V14.3158C0 14.3158 0 13.4737 0.869565 13.4737Z"
            })
        ]
    });
var $558a1874964eed3d$var$Hamburger$1 = $558a1874964eed3d$var$Hamburger;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$HeartFilled = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M2.0691 9.48006C1.88909 8.41184 2.0629 7.31618 2.56589 6.34844C2.94522 5.61819 3.49938 4.98501 4.18257 4.50138C4.86582 4.01772 5.65863 3.6973 6.49569 3.56652C7.33275 3.43575 8.19011 3.49837 8.9971 3.74922C9.80406 4.00005 10.5377 4.43202 11.1373 5.00933L12.0004 5.83984L12.8635 5.00921C13.4632 4.43191 14.1967 4.00005 15.0036 3.74922C15.8107 3.49837 16.668 3.43575 17.505 3.56652C18.3421 3.6973 19.135 4.01772 19.8182 4.50138C20.5014 4.98505 21.0556 5.61817 21.4349 6.34849C21.9372 7.31587 22.1108 8.41093 21.931 9.47857C21.7515 10.5441 21.2292 11.5283 20.4377 12.2926L12.4515 20.3146C12.3336 20.433 12.1707 20.5 12.0004 20.5C11.8301 20.5 11.6672 20.4331 11.5492 20.3146L3.56402 12.2951C2.77171 11.5308 2.24875 10.5461 2.0691 9.48006Z"
        })
    });
var $558a1874964eed3d$var$HeartFilled$1 = $558a1874964eed3d$var$HeartFilled;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Heart = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M14.7638 3.82986C14.0512 4.08789 13.4031 4.48969 12.8634 5.00933L12.0004 5.839L11.1371 5.00922C10.5376 4.43198 9.80404 4.00007 8.99702 3.74921C8.19 3.49837 7.33264 3.43575 6.49558 3.56653C5.65852 3.69729 4.86569 4.01772 4.18245 4.50138C3.49921 4.98505 2.9451 5.61812 2.56576 6.34844L2.46188 6.56056C2.03759 7.48566 1.903 8.49525 2.06896 9.48007C2.23612 10.472 2.70052 11.3936 3.40258 12.1326L11.5492 20.3147C11.7952 20.5618 12.2054 20.5618 12.4515 20.3147L20.4421 12.2882C21.227 11.5323 21.7511 10.5462 21.931 9.47858C22.1108 8.41089 21.9372 7.31583 21.4349 6.34847C21.0556 5.61814 20.5015 4.98505 19.8182 4.50138C19.1349 4.01771 18.3421 3.69729 17.5051 3.56652C16.6679 3.43575 15.8106 3.49837 15.0036 3.74921L14.7638 3.82986ZM17.3049 4.75459C17.9464 4.85482 18.5541 5.10041 19.0778 5.47113C19.6015 5.84184 20.0262 6.32706 20.3169 6.8868C20.7019 7.62822 20.8349 8.46753 20.6971 9.28589L20.6572 9.4891C20.4909 10.229 20.1069 10.9088 19.5489 11.4463L11.9996 19.0281L4.46166 11.4577C3.84294 10.8622 3.44076 10.106 3.30279 9.28729C3.17559 8.5325 3.27874 7.75872 3.59912 7.05986L3.69021 6.87391C3.97445 6.32707 4.39916 5.84184 4.92284 5.47113C5.44651 5.10041 6.05418 4.85482 6.69576 4.75459C7.33734 4.65436 7.99448 4.70235 8.61304 4.89462C9.23157 5.08688 9.79382 5.41792 10.2534 5.86045L11.5585 7.11633C11.8025 7.35117 12.198 7.35117 12.4421 7.11633L13.747 5.86057C14.2068 5.41791 14.769 5.08688 15.3876 4.89462C15.9288 4.72638 16.4996 4.66861 17.0637 4.72395L17.3049 4.75459Z"
        })
    });
var $558a1874964eed3d$var$Heart$1 = $558a1874964eed3d$var$Heart;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$HelpQuestionMark = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 1.875c5.592 0 10.125 4.533 10.125 10.125S17.592 22.125 12 22.125 1.875 17.592 1.875 12 6.408 1.875 12 1.875zm0 1.5a8.625 8.625 0 1 0 0 17.25 8.625 8.625 0 0 0 0-17.25zm0 12.25a1.063 1.063 0 1 1 0 2.125 1.063 1.063 0 0 1 0-2.125zm-.367-9.354a3.25 3.25 0 0 1 1.45 6.294.5.5 0 0 0-.333.472v.838a.75.75 0 1 1-1.5 0v-.838a2 2 0 0 1 1.333-1.887A1.75 1.75 0 1 0 10.25 9.5a.75.75 0 0 1-1.5 0 3.25 3.25 0 0 1 2.883-3.229z"
        })
    });
var $558a1874964eed3d$var$HelpQuestionMark$1 = $558a1874964eed3d$var$HelpQuestionMark;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Home = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M18.878 12.852a.75.75 0 0 1 .75.75v6.875a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1-.75-.75v-5a.5.5 0 0 0-.5-.5h-1.25a.5.5 0 0 0-.5.5v5a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1-.75-.75v-6.875a.75.75 0 1 1 1.5 0v6.125h3.5v-4.25a2 2 0 0 1 2-2h1.25a2 2 0 0 1 2 2v4.25h3.5v-6.125a.75.75 0 0 1 .75-.75zm-8.288-9.52a2 2 0 0 1 2.828 0l1.719 1.718a.75.75 0 0 1 .616-.322h3.125a.75.75 0 0 1 .75.75v4.064l2.28 2.28a.75.75 0 0 1 .073.977l-.072.084a.75.75 0 0 1-1.061 0l-8.49-8.49a.5.5 0 0 0-.708-.001l-8.491 8.49a.75.75 0 1 1-1.061-1.06zm7.538 2.896h-1.625v.189l1.625 1.625V6.228z"
        })
    });
var $558a1874964eed3d$var$Home$1 = $558a1874964eed3d$var$Home;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$HyperlinkLink = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 22 22",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.81665 8.23707C8.7508 7.73994 7.53155 7.68462 6.42502 8.08323C5.31831 8.48191 4.4143 9.30229 3.91039 10.3652C3.91024 10.3655 3.91008 10.3659 3.90993 10.3662L2.29547 13.7972C2.29529 13.7976 2.29511 13.798 2.29493 13.7984C1.79757 14.8645 1.74215 16.0841 2.14082 17.191C2.53934 18.2974 3.35924 19.2013 4.42161 19.7056C5.48748 20.2025 6.70663 20.2577 7.81312 19.8592C8.92038 19.4604 9.82482 18.6396 10.3289 17.5761C10.5364 17.1382 11.0595 16.9515 11.4974 17.159C11.9352 17.3665 12.1219 17.8897 11.9144 18.3275C11.2118 19.8099 9.95112 20.9541 8.4077 21.51C6.86427 22.0659 5.16357 21.9884 3.67709 21.2944L3.67249 21.2923C2.19007 20.5897 1.04594 19.329 0.490029 17.7856C-0.0658801 16.2421 0.011617 14.5414 0.705592 13.0549L0.706714 13.0525L2.32428 9.61492C3.02661 8.13255 4.2871 6.98841 5.83036 6.43247C7.37361 5.87653 9.07417 5.95399 10.5605 6.64793L10.5637 6.64942C11.4323 7.05921 12.1937 7.66546 12.7876 8.42024C13.3816 9.17502 13.7918 10.0576 13.9858 10.9983C14.0837 11.4728 13.7783 11.9368 13.3038 12.0347C12.8293 12.1326 12.3652 11.8273 12.2673 11.3527C12.1283 10.6787 11.8344 10.0462 11.4087 9.50529C10.9835 8.96488 10.4384 8.53072 9.81665 8.23707Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.8752 2.29439C15.8094 1.79754 14.5903 1.74232 13.4838 2.14084C12.3765 2.53965 11.4721 3.36046 10.9681 4.42396C10.7606 4.8618 10.2374 5.04852 9.79956 4.84101C9.36172 4.6335 9.175 4.11035 9.38251 3.67251C10.0851 2.19008 11.3458 1.04595 12.8892 0.490044C14.4326 -0.0658649 16.1333 0.0116324 17.6198 0.705607L17.6245 0.707793L17.6245 0.707807C19.1066 1.41039 20.2504 2.67086 20.8063 4.21396C21.3622 5.75706 21.2849 7.45743 20.5914 8.94375L20.5902 8.94631L18.9736 12.3818L18.9726 12.384C18.27 13.8665 17.0093 15.0106 15.4659 15.5665C13.9224 16.1224 12.2217 16.0449 10.7353 15.3509L10.7325 15.3496C9.98695 14.9984 9.3192 14.5015 8.76854 13.8884C8.21789 13.2752 7.79544 12.5581 7.52606 11.7792C7.36769 11.3213 7.61051 10.8217 8.06842 10.6633C8.52632 10.505 9.02592 10.7478 9.18429 11.2057C9.37718 11.7634 9.67969 12.2769 10.074 12.716C10.468 13.1547 10.9457 13.5103 11.479 13.7617C12.5451 14.259 13.7645 14.3143 14.8713 13.9157C15.9782 13.517 16.8825 12.6966 17.3866 11.6335C17.3867 11.6332 17.3869 11.6329 17.387 11.6326L19.0014 8.20182C19.0016 8.20138 19.0018 8.20093 19.002 8.20049C19.499 7.13451 19.5542 5.9152 19.1556 4.80862C18.7571 3.7024 17.9373 2.79865 16.8752 2.29439Z"
            })
        ]
    });
var $558a1874964eed3d$var$HyperlinkLink$1 = $558a1874964eed3d$var$HyperlinkLink;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$IndentLeft = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M18.6667 18.6667H13.25C13.029 18.6667 12.817 18.7545 12.6607 18.9107C12.5045 19.067 12.4167 19.279 12.4167 19.5C12.4167 19.721 12.5045 19.933 12.6607 20.0893C12.817 20.2455 13.029 20.3333 13.25 20.3333H18.6667C18.8877 20.3333 19.0996 20.2455 19.2559 20.0893C19.4122 19.933 19.5 19.721 19.5 19.5C19.5 19.279 19.4122 19.067 19.2559 18.9107C19.0996 18.7545 18.8877 18.6667 18.6667 18.6667Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M21.1667 14.9167H13.25C13.029 14.9167 12.817 15.0045 12.6607 15.1607C12.5045 15.317 12.4167 15.529 12.4167 15.75C12.4167 15.971 12.5045 16.183 12.6607 16.3393C12.817 16.4955 13.029 16.5833 13.25 16.5833H21.1667C21.3877 16.5833 21.5996 16.4955 21.7559 16.3393C21.9122 16.183 22 15.971 22 15.75C22 15.529 21.9122 15.317 21.7559 15.1607C21.5996 15.0045 21.3877 14.9167 21.1667 14.9167Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.25 12.8333H18.6667C18.8877 12.8333 19.0996 12.7455 19.2559 12.5893C19.4122 12.433 19.5 12.221 19.5 12C19.5 11.779 19.4122 11.567 19.2559 11.4107C19.0996 11.2545 18.8877 11.1667 18.6667 11.1667H13.25C13.029 11.1667 12.817 11.2545 12.6607 11.4107C12.5045 11.567 12.4167 11.779 12.4167 12C12.4167 12.221 12.5045 12.433 12.6607 12.5893C12.817 12.7455 13.029 12.8333 13.25 12.8333Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.25 9.08333H21.1667C21.3877 9.08333 21.5996 8.99554 21.7559 8.83926C21.9122 8.68298 22 8.47101 22 8.25C22 8.02899 21.9122 7.81702 21.7559 7.66074C21.5996 7.50446 21.3877 7.41667 21.1667 7.41667H13.25C13.029 7.41667 12.817 7.50446 12.6607 7.66074C12.5045 7.81702 12.4167 8.02899 12.4167 8.25C12.4167 8.47101 12.5045 8.68298 12.6607 8.83926C12.817 8.99554 13.029 9.08333 13.25 9.08333Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.25 5.33333H18.6667C18.8877 5.33333 19.0996 5.24554 19.2559 5.08926C19.4122 4.93298 19.5 4.72101 19.5 4.5C19.5 4.27899 19.4122 4.06702 19.2559 3.91074C19.0996 3.75446 18.8877 3.66667 18.6667 3.66667H13.25C13.029 3.66667 12.817 3.75446 12.6607 3.91074C12.5045 4.06702 12.4167 4.27899 12.4167 4.5C12.4167 4.72101 12.5045 4.93298 12.6607 5.08926C12.817 5.24554 13.029 5.33333 13.25 5.33333Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.3333 2C10.1123 2 9.90036 2.0878 9.74408 2.24408C9.5878 2.40036 9.5 2.61232 9.5 2.83333V21.1667C9.5 21.3877 9.5878 21.5996 9.74408 21.7559C9.90036 21.9122 10.1123 22 10.3333 22C10.5543 22 10.7663 21.9122 10.9226 21.7559C11.0789 21.5996 11.1667 21.3877 11.1667 21.1667V2.83333C11.1667 2.61232 11.0789 2.40036 10.9226 2.24408C10.7663 2.0878 10.5543 2 10.3333 2Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M5.08333 9.20583C4.9904 9.13651 4.88003 9.09438 4.76454 9.08412C4.64905 9.07386 4.53299 9.09588 4.42928 9.14773C4.32558 9.19958 4.23832 9.27922 4.17724 9.37777C4.11615 9.47631 4.08364 9.58989 4.08333 9.70583V10.9558C4.08333 11.0111 4.06138 11.0641 4.02231 11.1031C3.98324 11.1422 3.93025 11.1642 3.875 11.1642H2.83333C2.61232 11.1642 2.40036 11.252 2.24408 11.4082C2.0878 11.5645 2 11.7765 2 11.9975C2 12.2185 2.0878 12.4305 2.24408 12.5868C2.40036 12.743 2.61232 12.8308 2.83333 12.8308H3.87417C3.92942 12.8308 3.98241 12.8528 4.02148 12.8919C4.06055 12.9309 4.0825 12.9839 4.0825 13.0392V14.2892C4.08187 14.4055 4.11381 14.5197 4.17471 14.6188C4.2356 14.7179 4.32301 14.798 4.42706 14.85C4.53111 14.9021 4.64764 14.9239 4.76347 14.9132C4.8793 14.9024 4.98981 14.8595 5.0825 14.7892L8.13833 12.5C8.21581 12.4417 8.27867 12.3662 8.32196 12.2794C8.36525 12.1926 8.38778 12.097 8.38778 12C8.38778 11.903 8.36525 11.8074 8.32196 11.7206C8.27867 11.6338 8.21581 11.5583 8.13833 11.5L5.08333 9.20583Z"
            })
        ]
    });
var $558a1874964eed3d$var$IndentLeft$1 = $558a1874964eed3d$var$IndentLeft;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$IndentRight = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.75 18.6667H5.33333C5.11232 18.6667 4.90036 18.7545 4.74408 18.9107C4.5878 19.067 4.5 19.279 4.5 19.5C4.5 19.721 4.5878 19.933 4.74408 20.0893C4.90036 20.2455 5.11232 20.3333 5.33333 20.3333H10.75C10.971 20.3333 11.183 20.2455 11.3393 20.0893C11.4955 19.933 11.5833 19.721 11.5833 19.5C11.5833 19.279 11.4955 19.067 11.3393 18.9107C11.183 18.7545 10.971 18.6667 10.75 18.6667Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.5833 15.75C11.5833 15.529 11.4955 15.317 11.3393 15.1607C11.183 15.0045 10.971 14.9167 10.75 14.9167H2.83333C2.61232 14.9167 2.40036 15.0045 2.24408 15.1607C2.0878 15.317 2 15.529 2 15.75C2 15.971 2.0878 16.183 2.24408 16.3393C2.40036 16.4955 2.61232 16.5833 2.83333 16.5833H10.75C10.971 16.5833 11.183 16.4955 11.3393 16.3393C11.4955 16.183 11.5833 15.971 11.5833 15.75Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.75 11.1667H5.33333C5.11232 11.1667 4.90036 11.2545 4.74408 11.4107C4.5878 11.567 4.5 11.779 4.5 12C4.5 12.221 4.5878 12.433 4.74408 12.5893C4.90036 12.7455 5.11232 12.8333 5.33333 12.8333H10.75C10.971 12.8333 11.183 12.7455 11.3393 12.5893C11.4955 12.433 11.5833 12.221 11.5833 12C11.5833 11.779 11.4955 11.567 11.3393 11.4107C11.183 11.2545 10.971 11.1667 10.75 11.1667Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.75 7.41667H2.83333C2.61232 7.41667 2.40036 7.50446 2.24408 7.66074C2.0878 7.81702 2 8.02899 2 8.25C2 8.47101 2.0878 8.68298 2.24408 8.83926C2.40036 8.99554 2.61232 9.08333 2.83333 9.08333H10.75C10.971 9.08333 11.183 8.99554 11.3393 8.83926C11.4955 8.68298 11.5833 8.47101 11.5833 8.25C11.5833 8.02899 11.4955 7.81702 11.3393 7.66074C11.183 7.50446 10.971 7.41667 10.75 7.41667Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.75 3.66667H5.33333C5.11232 3.66667 4.90036 3.75446 4.74408 3.91074C4.5878 4.06702 4.5 4.27899 4.5 4.5C4.5 4.72101 4.5878 4.93298 4.74408 5.08926C4.90036 5.24554 5.11232 5.33333 5.33333 5.33333H10.75C10.971 5.33333 11.183 5.24554 11.3393 5.08926C11.4955 4.93298 11.5833 4.72101 11.5833 4.5C11.5833 4.27899 11.4955 4.06702 11.3393 3.91074C11.183 3.75446 10.971 3.66667 10.75 3.66667Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.6667 2C13.4457 2 13.2337 2.0878 13.0774 2.24408C12.9211 2.40036 12.8333 2.61232 12.8333 2.83333V21.1667C12.8333 21.3877 12.9211 21.5996 13.0774 21.7559C13.2337 21.9122 13.4457 22 13.6667 22C13.8877 22 14.0996 21.9122 14.2559 21.7559C14.4122 21.5996 14.5 21.3877 14.5 21.1667V2.83333C14.5 2.61232 14.4122 2.40036 14.2559 2.24408C14.0996 2.0878 13.8877 2 13.6667 2Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M21.1667 11.1667H20.1242C20.0968 11.1668 20.0696 11.1615 20.0443 11.151C20.019 11.1406 19.996 11.1253 19.9766 11.1059C19.9572 11.0865 19.9419 11.0635 19.9315 11.0382C19.921 11.0129 19.9157 10.9857 19.9158 10.9583V9.70833C19.9155 9.59239 19.883 9.47881 19.8219 9.38027C19.7608 9.28172 19.6736 9.20208 19.5699 9.15023C19.4662 9.09838 19.3501 9.07636 19.2346 9.08662C19.1191 9.09688 19.0088 9.13901 18.9158 9.20833L15.86 11.5C15.7824 11.5582 15.7194 11.6337 15.676 11.7205C15.6326 11.8073 15.61 11.903 15.61 12C15.61 12.097 15.6326 12.1927 15.676 12.2795C15.7194 12.3663 15.7824 12.4418 15.86 12.5L18.915 14.7917C19.0079 14.8613 19.1183 14.9037 19.2339 14.9141C19.3495 14.9246 19.4657 14.9026 19.5695 14.8507C19.6733 14.7988 19.7606 14.719 19.8217 14.6202C19.8827 14.5215 19.915 14.4077 19.915 14.2917V13.0417C19.9149 13.0143 19.9202 12.9871 19.9306 12.9618C19.9411 12.9365 19.9564 12.9135 19.9758 12.8941C19.9951 12.8747 20.0182 12.8594 20.0435 12.849C20.0688 12.8385 20.0959 12.8332 20.1233 12.8333H21.1667C21.3877 12.8333 21.5996 12.7455 21.7559 12.5893C21.9122 12.433 22 12.221 22 12C22 11.779 21.9122 11.567 21.7559 11.4107C21.5996 11.2545 21.3877 11.1667 21.1667 11.1667Z"
            })
        ]
    });
var $558a1874964eed3d$var$IndentRight$1 = $558a1874964eed3d$var$IndentRight;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Lightbulb = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 23 23",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.3025 20.6045H9.69949C9.61816 20.6047 9.53827 20.626 9.46763 20.6663C9.39699 20.7066 9.33802 20.7646 9.29649 20.8345C9.25612 20.9044 9.23486 20.9838 9.23486 21.0645C9.23486 21.1453 9.25612 21.2246 9.29649 21.2945L9.61249 21.9365C9.76968 22.2529 10.0113 22.5197 10.3106 22.7075C10.6098 22.8953 10.9552 22.9967 11.3085 23.0005H11.6915C12.0497 23.002 12.4012 22.9032 12.7061 22.7151C13.011 22.527 13.2571 22.2573 13.4165 21.9365L13.7325 21.2945C13.7729 21.2246 13.7941 21.1453 13.7941 21.0645C13.7941 20.9838 13.7729 20.9044 13.7325 20.8345C13.6886 20.7603 13.6252 20.6997 13.5492 20.6591C13.4732 20.6185 13.3875 20.5997 13.3015 20.6045H13.3025Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.5005 4.3135C11.7546 4.3135 11.9983 4.21257 12.1779 4.03291C12.3576 3.85325 12.4585 3.60958 12.4585 3.3555V0.9585C12.4585 0.70429 12.3575 0.460492 12.1778 0.280738C11.998 0.100985 11.7542 0 11.5 0C11.2458 0 11.002 0.100985 10.8222 0.280738C10.6425 0.460492 10.5415 0.70429 10.5415 0.9585V3.3545C10.5415 3.60858 10.6424 3.85225 10.8221 4.03191C11.0018 4.21157 11.2454 4.3125 11.4995 4.3125L11.5005 4.3135Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20.3075 3.65149C20.128 3.473 19.8851 3.3728 19.632 3.3728C19.3788 3.3728 19.136 3.473 18.9565 3.65149L17.2505 5.34849C17.1607 5.43754 17.0895 5.54348 17.0409 5.66019C16.9923 5.77689 16.9673 5.90207 16.9673 6.02849C16.9673 6.15492 16.9923 6.28009 17.0409 6.3968C17.0895 6.51351 17.1607 6.61944 17.2505 6.70849C17.34 6.79729 17.4461 6.86756 17.5628 6.91526C17.6795 6.96297 17.8044 6.98717 17.9305 6.98649C18.182 6.98549 18.423 6.88564 18.6015 6.70849L20.2975 5.01249C20.388 4.92408 20.4602 4.81861 20.5097 4.70217C20.5593 4.58573 20.5853 4.46062 20.5862 4.33408C20.5871 4.20753 20.563 4.08206 20.5151 3.9649C20.4673 3.84774 20.3967 3.74122 20.3075 3.65149Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M23.0005 12.4585C23.0005 12.2044 22.8996 11.9607 22.7199 11.7811C22.5402 11.6014 22.2966 11.5005 22.0425 11.5005H20.1255C19.8713 11.5005 19.6275 11.6015 19.4477 11.7812C19.268 11.961 19.167 12.2048 19.167 12.459C19.167 12.7132 19.268 12.957 19.4477 13.1368C19.6275 13.3165 19.8713 13.4175 20.1255 13.4175H22.0425C22.2966 13.4175 22.5402 13.3166 22.7199 13.1369C22.8996 12.9572 23.0005 12.7126 23.0005 12.4585Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M5.75048 5.34849L4.04448 3.65149C3.86128 3.49392 3.62531 3.41141 3.38384 3.42048C3.14237 3.42954 2.91325 3.52953 2.74238 3.70039C2.57152 3.87126 2.47154 4.10038 2.46247 4.34185C2.4534 4.58331 2.53592 4.81929 2.69348 5.00249L4.38948 6.70849C4.56799 6.88564 4.809 6.98549 5.06048 6.98649C5.18822 6.9885 5.31507 6.96494 5.43357 6.9172C5.55206 6.86946 5.65982 6.79849 5.75048 6.70849C5.84037 6.61942 5.91172 6.51342 5.96041 6.39662C6.00911 6.27982 6.03418 6.15453 6.03418 6.02799C6.03418 5.90145 6.00911 5.77616 5.96041 5.65936C5.91172 5.54256 5.84037 5.43756 5.75048 5.34849Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2.8755 11.5005H0.9585C0.70429 11.5005 0.460492 11.6015 0.280738 11.7812C0.100985 11.961 0 12.2048 0 12.459C0 12.7132 0.100985 12.957 0.280738 13.1368C0.460492 13.3165 0.70429 13.4175 0.9585 13.4175H2.8755C3.12971 13.4175 3.37351 13.3165 3.55326 13.1368C3.73302 12.957 3.834 12.7132 3.834 12.459C3.834 12.2048 3.73302 11.961 3.55326 11.7812C3.37351 11.6015 3.12971 11.5005 2.8755 11.5005Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.5005 5.75057C9.83816 5.75057 8.24387 6.41095 7.06839 7.58643C5.89291 8.76191 5.23253 10.3562 5.23253 12.0186C5.22674 12.9738 5.44382 13.9173 5.86652 14.774C6.28922 15.6307 6.90589 16.377 7.66753 16.9536C7.72651 16.9987 7.77445 17.0566 7.80771 17.1229C7.84098 17.1893 7.8587 17.2623 7.85954 17.3366V17.7676C7.86071 17.9534 7.89861 18.1371 7.97108 18.3082C8.04354 18.4793 8.14912 18.6344 8.28175 18.7645C8.41439 18.8946 8.57144 18.9972 8.74388 19.0664C8.91633 19.1356 9.10075 19.17 9.28654 19.1676H13.7145C14.0823 19.1676 14.4353 19.0228 14.6971 18.7646C14.9589 18.5063 15.1085 18.1553 15.1135 17.7876C15.1135 17.7876 15.1135 17.7876 15.1135 17.4136C15.1098 17.3345 15.1253 17.2557 15.1588 17.1839C15.1922 17.1121 15.2426 17.0496 15.3055 17.0016C16.3542 16.2093 17.1268 15.1069 17.5137 13.8508C17.9007 12.5947 17.8823 11.2487 17.4612 10.0036C17.0401 8.75857 16.2378 7.6777 15.1679 6.9143C14.0979 6.1509 12.8148 5.74374 11.5005 5.75057ZM13.9825 15.5826C13.7409 15.7525 13.5434 15.9777 13.4067 16.2396C13.2699 16.5014 13.1979 16.7922 13.1965 17.0876C13.198 17.1094 13.1948 17.1312 13.1871 17.1517C13.1795 17.1721 13.1675 17.1907 13.1521 17.2061C13.1366 17.2216 13.1181 17.2335 13.0976 17.2412C13.0772 17.2488 13.0553 17.2521 13.0335 17.2506H9.96653C9.9233 17.2506 9.88184 17.2334 9.85128 17.2028C9.82071 17.1723 9.80354 17.1308 9.80354 17.0876C9.80219 16.7922 9.73013 16.5014 9.59339 16.2396C9.45664 15.9777 9.25919 15.7525 9.01754 15.5826C8.25636 15.0539 7.68387 14.296 7.38347 13.4193C7.08306 12.5426 7.07043 11.5929 7.34742 10.7085C7.62441 9.82411 8.17655 9.05126 8.9234 8.50255C9.67025 7.95385 10.5728 7.65794 11.4995 7.65794C12.4263 7.65794 13.3288 7.95385 14.0757 8.50255C14.8225 9.05126 15.3747 9.82411 15.6516 10.7085C15.9286 11.5929 15.916 12.5426 15.6156 13.4193C15.3152 14.296 14.7427 15.0539 13.9815 15.5826H13.9825Z"
            })
        ]
    });
var $558a1874964eed3d$var$Lightbulb$1 = $558a1874964eed3d$var$Lightbulb;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$List = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M5.704 16.815c.818 0 1.481.663 1.481 1.481v2.223c0 .818-.663 1.481-1.481 1.481H3.48A1.481 1.481 0 0 1 2 20.519v-2.223c0-.818.663-1.481 1.481-1.481h2.223zm15.555 2.469a.74.74 0 0 1 0 1.481H8.914a.74.74 0 1 1 0-1.481zm-15.555-.988H3.48v2.223h2.223v-2.223zm0-8.889c.818 0 1.481.664 1.481 1.482v2.222c0 .818-.663 1.482-1.481 1.482H3.48A1.481 1.481 0 0 1 2 13.11V10.89c0-.818.663-1.482 1.481-1.482h2.223zm15.555 2.47a.74.74 0 0 1 0 1.481H8.914a.74.74 0 1 1 0-1.481zm-15.555-.988H3.48v2.222h2.223V10.89zm0-8.889c.818 0 1.481.663 1.481 1.481v2.223c0 .818-.663 1.481-1.481 1.481H3.48A1.481 1.481 0 0 1 2 5.704V3.48C2 2.663 2.663 2 3.481 2h2.223zm15.555 2.47a.74.74 0 0 1 0 1.48H8.914a.74.74 0 1 1 0-1.48zM5.704 3.48H3.48v2.223h2.223V3.48z"
        })
    });
var $558a1874964eed3d$var$List$1 = $558a1874964eed3d$var$List;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$LiveChatAssociate = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 2C13.9891 2 15.8968 2.79018 17.3033 4.1967C18.576 5.46936 19.344 7.15231 19.4787 8.93466C20.864 9.20414 21.9221 10.3912 21.9959 11.8382L22 12V14.5C22 16.0117 20.9266 17.2727 19.5004 17.5624L19.5 17.625C19.5 19.2952 18.1897 20.6594 16.541 20.7457L16.375 20.75L15.0182 20.7502C14.7759 21.4355 14.1465 21.9379 13.3927 21.9946L13.25 22H12C11.0756 22 10.2988 21.3284 10.1486 20.4082L10.1314 20.2751L10.125 20.125C10.125 19.1326 10.896 18.3203 11.8716 18.2543L12 18.25H13.25C14.0555 18.25 14.749 18.76 15.0134 19.5L16.375 19.5C17.3674 19.5 18.1797 18.729 18.2457 17.7534L18.25 17.625L18.1296 17.6193C17.5354 17.5625 17.0625 17.0896 17.0057 16.4954L17 16.375V10.125C17 9.47525 17.4957 8.94129 18.1296 8.88072L18.2189 8.87664C18.0757 7.44797 17.4437 6.10483 16.4194 5.08058C15.2473 3.90848 13.6576 3.25 12 3.25C8.75844 3.25 6.09325 5.71777 5.78065 8.87711C6.41735 8.89107 6.93567 9.38187 6.99445 10.0064L7 10.125V16.375C7 17.0247 6.50426 17.5587 5.87038 17.6193L5.75 17.625H5.125C3.45478 17.625 2.09061 16.3147 2.00433 14.666L2 14.5V12C2 10.4804 3.08464 9.21412 4.52198 8.93313C4.81016 5.05644 8.04815 2 12 2ZM13.25 19.5H12C11.6836 19.5 11.4221 19.7351 11.3802 20.0173L11.3743 20.0953L11.3779 20.1859C11.4055 20.4751 11.6304 20.7047 11.9135 20.744L12 20.75H13.25C13.5664 20.75 13.8279 20.5149 13.8698 20.2327L13.8757 20.1547L13.8721 20.0641C13.8445 19.7749 13.6196 19.5453 13.3365 19.506L13.25 19.5ZM14.921 15.3303C15.1761 15.0978 15.1945 14.7025 14.962 14.4474C14.7295 14.1922 14.3342 14.1739 14.079 14.4064C12.9009 15.48 11.0991 15.48 9.92097 14.4064C9.66583 14.1739 9.27053 14.1922 9.03804 14.4474C8.80554 14.7025 8.82389 15.0978 9.07903 15.3303C10.7343 16.8386 13.2657 16.8386 14.921 15.3303ZM5.75 10.125H5.125C4.13261 10.125 3.3203 10.896 3.25433 11.8716L3.25 12V14.5C3.25 15.4924 4.02097 16.3047 4.99663 16.3707L5.125 16.375H5.75V10.125ZM18.25 10.125H18.875L19.0034 10.1293C19.979 10.1953 20.75 11.0076 20.75 12V14.5L20.7457 14.6284C20.6797 15.604 19.8674 16.375 18.875 16.375H18.25V10.125ZM9.5 9.69583C9.81641 9.69583 10.0779 9.93096 10.1193 10.236L10.125 10.3208V11.4142C10.125 11.7593 9.84518 12.0392 9.5 12.0392C9.18359 12.0392 8.92209 11.804 8.88071 11.499L8.875 11.4142V10.3208C8.875 9.97566 9.15482 9.69583 9.5 9.69583ZM15.1193 10.236C15.0779 9.93096 14.8164 9.69583 14.5 9.69583C14.1548 9.69583 13.875 9.97566 13.875 10.3208V11.4142L13.8807 11.499C13.9221 11.804 14.1836 12.0392 14.5 12.0392C14.8452 12.0392 15.125 11.7593 15.125 11.4142V10.3208L15.1193 10.236Z"
        })
    });
var $558a1874964eed3d$var$LiveChatAssociate$1 = $558a1874964eed3d$var$LiveChatAssociate;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$LiveChatChatbot = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.1779 8.87431C19.0789 4.42967 16.1013 2.001 11.9993 2C7.89705 2 4.91918 4.42915 4.82042 8.87454L2.625 8.87497L2.54019 8.88068C2.23513 8.92206 2 9.18356 2 9.49997C2 9.84515 2.27982 10.125 2.625 10.125L4.86506 10.1242C4.9522 11.089 5.16175 12.1334 5.50792 13.2544L5.29167 13.2727C4.52355 13.3658 3.81231 13.741 3.30068 14.3327C2.70684 15.0194 2.44045 15.9302 2.57062 16.8287L3.25333 21.466L3.27133 21.549C3.35671 21.8448 3.64966 22.0393 3.9627 21.9933C4.3042 21.943 4.54028 21.6254 4.49 21.2839L3.8075 16.6481L3.79121 16.4865C3.76349 16.0017 3.92519 15.5215 4.24621 15.1503C4.6029 14.7378 5.12112 14.5005 5.66645 14.4999H18.3325L18.4804 14.5057C18.9706 14.5443 19.4283 14.7743 19.7522 15.1492C20.1085 15.5617 20.2677 16.1088 20.1883 16.6481L19.5066 21.284L19.5 21.3687C19.4965 21.6766 19.721 21.9472 20.0341 21.9933C20.3756 22.0435 20.6931 21.8073 20.7434 21.4658L21.425 16.83L21.4462 16.6502C21.5205 15.8108 21.2524 14.9737 20.6982 14.3321C20.1835 13.7363 19.4662 13.3602 18.6927 13.2707L18.4904 13.2544C18.8366 12.1334 19.0461 11.0889 19.1333 10.1242L21.375 10.125L21.4598 10.1193C21.7649 10.0779 22 9.81638 22 9.49997C22 9.15479 21.7202 8.87497 21.375 8.87497L19.1779 8.87431ZM13.2443 18.1296C13.1837 17.4957 12.6497 16.9999 12 16.9999H7L6.87962 17.0057C6.24574 17.0662 5.75 17.6002 5.75 18.2499V20.7499L5.75572 20.8703C5.81629 21.5042 6.35025 21.9999 7 21.9999H12L12.1204 21.9942C12.7543 21.9336 13.25 21.3997 13.25 20.7499V18.2499L13.2443 18.1296ZM17.625 19.4999C17.9702 19.4999 18.25 19.7797 18.25 20.1249C18.25 20.4413 18.0149 20.7028 17.7098 20.7442L17.625 20.7499H15.125C14.7798 20.7499 14.5 20.4701 14.5 20.1249C14.5 19.8085 14.7351 19.547 15.0402 19.5056L15.125 19.4999H17.625ZM7 20.7499V18.2499H12V20.7499H7ZM17.625 16.9999C17.9702 16.9999 18.25 17.2798 18.25 17.6249C18.25 17.9413 18.0149 18.2028 17.7098 18.2442L17.625 18.2499H15.125C14.7798 18.2499 14.5 17.9701 14.5 17.6249C14.5 17.3085 14.7351 17.047 15.0402 17.0056L15.125 16.9999H17.625ZM6.81854 13.249C4.62335 6.64798 7.42723 3.24999 11.9992 3.24999C16.5712 3.25111 19.3748 6.6484 17.1798 13.249L6.81854 13.249ZM14.5 6.99998C15.5355 6.99998 16.375 7.83944 16.375 8.87497C16.375 9.9105 15.5355 10.75 14.5 10.75C13.4645 10.75 12.625 9.9105 12.625 8.87497C12.625 7.83944 13.4645 6.99998 14.5 6.99998ZM11.375 8.87497C11.375 7.83944 10.5355 6.99998 9.5 6.99998C8.46447 6.99998 7.625 7.83944 7.625 8.87497C7.625 9.9105 8.46447 10.75 9.5 10.75C10.5355 10.75 11.375 9.9105 11.375 8.87497ZM14.5 8.24997C14.1548 8.24997 13.875 8.5298 13.875 8.87497C13.875 9.22015 14.1548 9.49997 14.5 9.49997C14.8452 9.49997 15.125 9.22015 15.125 8.87497C15.125 8.5298 14.8452 8.24997 14.5 8.24997ZM8.875 8.87497C8.875 8.5298 9.15482 8.24997 9.5 8.24997C9.84518 8.24997 10.125 8.5298 10.125 8.87497C10.125 9.22015 9.84518 9.49997 9.5 9.49997C9.15482 9.49997 8.875 9.22015 8.875 8.87497Z"
        })
    });
var $558a1874964eed3d$var$LiveChatChatbot$1 = $558a1874964eed3d$var$LiveChatChatbot;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$LockLocked = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 1.875A5.125 5.125 0 0 1 17.125 7v2.375h.25a2.25 2.25 0 0 1 2.25 2.25v8.25a2.25 2.25 0 0 1-2.25 2.25H6.625a2.25 2.25 0 0 1-2.25-2.25v-8.25a2.25 2.25 0 0 1 2.25-2.25h.25V7a5.125 5.125 0 0 1 4.908-5.12zm5.375 9H6.625a.75.75 0 0 0-.75.75v8.25c0 .414.336.75.75.75h10.75a.75.75 0 0 0 .75-.75v-8.25a.75.75 0 0 0-.75-.75zM12 13.75a.75.75 0 0 1 .75.75V17a.75.75 0 1 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75zm0-10.375A3.625 3.625 0 0 0 8.375 7v2.375h7.25V7c0-1.937-1.52-3.52-3.432-3.62z"
        })
    });
var $558a1874964eed3d$var$LockLocked$1 = $558a1874964eed3d$var$LockLocked;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$LockUnlocked = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M7 1.875A5.125 5.125 0 0 1 12.125 7v2.375h7.75a2.25 2.25 0 0 1 2.25 2.25v8.25a2.25 2.25 0 0 1-2.25 2.25H9.125a2.25 2.25 0 0 1-2.25-2.25v-8.25a2.25 2.25 0 0 1 2.25-2.25h1.5V7c0-1.937-1.52-3.52-3.432-3.62L7 3.375A3.625 3.625 0 0 0 3.375 7v3.125a.75.75 0 1 1-1.5 0V7A5.125 5.125 0 0 1 7 1.875zm12.875 9H9.125a.75.75 0 0 0-.75.75v8.25c0 .414.336.75.75.75h10.75a.75.75 0 0 0 .75-.75v-8.25a.75.75 0 0 0-.75-.75zM14.5 13.75a.75.75 0 0 1 .75.75V17a.75.75 0 1 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75z"
        })
    });
var $558a1874964eed3d$var$LockUnlocked$1 = $558a1874964eed3d$var$LockUnlocked;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$MapPinLarge = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.34835 4.84835C10.0516 4.14509 11.0054 3.75 12 3.75C12.9946 3.75 13.9484 4.14509 14.6517 4.84835C15.3549 5.55161 15.75 6.50544 15.75 7.5C15.75 8.49456 15.3549 9.44839 14.6517 10.1517C13.9484 10.8549 12.9946 11.25 12 11.25C11.0054 11.25 10.0516 10.8549 9.34835 10.1517C8.64509 9.44839 8.25 8.49456 8.25 7.5C8.25 6.50544 8.64509 5.55161 9.34835 4.84835ZM12 5.25C11.4033 5.25 10.831 5.48705 10.409 5.90901C9.98705 6.33097 9.75 6.90326 9.75 7.5C9.75 8.09674 9.98705 8.66903 10.409 9.09099C10.831 9.51295 11.4033 9.75 12 9.75C12.5967 9.75 13.169 9.51295 13.591 9.09099C14.0129 8.66903 14.25 8.09674 14.25 7.5C14.25 6.90326 14.0129 6.33097 13.591 5.90901C13.169 5.48705 12.5967 5.25 12 5.25Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 1.5C10.4087 1.5 8.88258 2.13214 7.75736 3.25736C6.63214 4.38258 6 5.9087 6 7.5C6 8.15274 6.26787 9.0997 6.76149 10.2486C7.24569 11.3755 7.91089 12.616 8.62611 13.8276C9.86804 15.9314 11.2353 17.9052 12 18.9757C12.7647 17.9052 14.132 15.9314 15.3739 13.8276C16.0891 12.616 16.7543 11.3755 17.2385 10.2486C17.7321 9.0997 18 8.15274 18 7.5C18 5.9087 17.3679 4.38258 16.2426 3.25736C15.1174 2.13214 13.5913 1.5 12 1.5ZM6.6967 2.1967C8.10322 0.790176 10.0109 0 12 0C13.9891 0 15.8968 0.790176 17.3033 2.1967C18.7098 3.60322 19.5 5.51088 19.5 7.5C19.5 8.47276 19.1264 9.65443 18.6167 10.8407C18.0976 12.0489 17.3976 13.3501 16.6656 14.5901C15.2007 17.0716 13.5734 19.3651 12.9109 20.2776L12.9088 20.2806C12.8041 20.4233 12.6673 20.5393 12.5094 20.6193C12.3515 20.6993 12.177 20.741 12 20.741C11.823 20.741 11.6485 20.6993 11.4906 20.6193C11.3327 20.5393 11.1959 20.4233 11.0912 20.2806L11.0891 20.2776C10.4266 19.3651 8.79927 17.0716 7.33439 14.5901C6.60236 13.3501 5.90243 12.0489 5.38332 10.8407C4.87363 9.65443 4.5 8.47276 4.5 7.5C4.5 5.51088 5.29018 3.60322 6.6967 2.1967Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.2433 17.6383C17.3237 17.2319 17.7184 16.9678 18.1247 17.0482C19.5267 17.3259 20.7371 17.7051 21.6172 18.175C22.0569 18.4097 22.4486 18.6851 22.7385 19.0114C23.0325 19.3424 23.25 19.7604 23.25 20.25C23.25 21.0447 22.6924 21.6355 22.0949 22.0392C21.4712 22.4606 20.618 22.8105 19.631 23.0925C17.6469 23.6594 14.9493 24 12 24C9.05069 24 6.35308 23.6594 4.36895 23.0925C3.38199 22.8105 2.5288 22.4606 1.90513 22.0392C1.30759 21.6355 0.75 21.0447 0.75 20.25C0.75 19.7615 0.966439 19.3443 1.25943 19.0136C1.54825 18.6877 1.93843 18.4126 2.37628 18.1781C3.25276 17.7086 4.45796 17.3296 5.85338 17.0514C6.2596 16.9705 6.65455 17.2341 6.73553 17.6403C6.8165 18.0466 6.55284 18.4415 6.14662 18.5225C4.82304 18.7863 3.77824 19.1288 3.08447 19.5004C2.7372 19.6863 2.51218 19.8616 2.3821 20.0084C2.25619 20.1505 2.25 20.2284 2.25 20.25C2.25 20.2837 2.27991 20.4822 2.74487 20.7963C3.1837 21.0928 3.868 21.3893 4.78105 21.6502C6.59692 22.169 9.14931 22.5 12 22.5C14.8507 22.5 17.4031 22.169 19.219 21.6502C20.132 21.3893 20.8163 21.0928 21.2551 20.7963C21.7201 20.4822 21.75 20.2837 21.75 20.25C21.75 20.2285 21.7438 20.1504 21.6171 20.0077C21.4862 19.8604 21.2599 19.6846 20.9108 19.4982C20.2134 19.1259 19.1633 18.783 17.8333 18.5197C17.427 18.4392 17.1628 18.0446 17.2433 17.6383Z"
            })
        ]
    });
var $558a1874964eed3d$var$MapPinLarge$1 = $558a1874964eed3d$var$MapPinLarge;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$MembersPeople = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M8.25 4.875a4.188 4.188 0 0 1 1.118 8.224 6.374 6.374 0 0 1 5.257 6.276.75.75 0 1 1-1.5 0 4.875 4.875 0 1 0-9.75 0 .75.75 0 1 1-1.5 0c0-3.14 2.27-5.749 5.257-6.277A4.186 4.186 0 0 1 8.25 4.875zm8.523 2.5a3.562 3.562 0 0 1 1.406 6.837 5.356 5.356 0 0 1 3.946 5.163.75.75 0 0 1-1.5 0 3.856 3.856 0 0 0-5.188-3.615.75.75 0 0 1-.519-1.407c.148-.055.297-.102.448-.143a3.562 3.562 0 0 1 1.407-6.835zm0 1.5a2.062 2.062 0 1 0 0 4.125 2.062 2.062 0 0 0 0-4.125zm-8.523-2.5a2.688 2.688 0 1 0 0 5.375 2.688 2.688 0 0 0 0-5.375z"
        })
    });
var $558a1874964eed3d$var$MembersPeople$1 = $558a1874964eed3d$var$MembersPeople;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$MessageEnvelope = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M20 5c.626 0 1.186.288 1.552.739l.008.01A1.99 1.99 0 0 1 22 7v10.668a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-.47.163-.904.435-1.245l.013-.017C2.814 5.288 3.374 5 4 5h16zm.666 2.277l-6.467 4.975a3.607 3.607 0 0 1-4.398 0L3.333 7.277v10.39c0 .368.299.666.667.666h16a.667.667 0 0 0 .667-.666l-.001-10.39zm-.959-.944H4.292l6.322 4.862c.769.592 1.822.627 2.625.105l.147-.105 6.321-4.862z"
        })
    });
var $558a1874964eed3d$var$MessageEnvelope$1 = $558a1874964eed3d$var$MessageEnvelope;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$MessageForward = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M13.16,15.88H8.91a5.5,5.5,0,0,0-5.5,5.5H1.91v-5a7,7,0,0,1,7-7h4.25V7.7a2,2,0,0,1,1.27-1.86,2,2,0,0,1,2.2.5l4.55,4.93a2,2,0,0,1,0,2.71l-4.55,4.93a2,2,0,0,1-3.47-1.36Zm-9.75,5.5a.75.75,0,0,1-1.5,0Zm5.5-7h5a.74.74,0,0,1,.75.74v2.43a.5.5,0,0,0,.87.34L20.08,13a.5.5,0,0,0,0-.67L15.52,7.36A.49.49,0,0,0,15,7.23a.51.51,0,0,0-.32.47v2.42a.75.75,0,0,1-.75.76h-5a5.5,5.5,0,0,0-5.5,5.5V17A7,7,0,0,1,8.91,14.38Z"
        })
    });
var $558a1874964eed3d$var$MessageForward$1 = $558a1874964eed3d$var$MessageForward;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$MessageReplyAll = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M20.6189661,20.1537929 C20.5028725,17.21878 18.0868125,14.875 15.1233333,14.875 L15.1233333,14.875 L14.3733332,14.875 L14.3733328,16.5534014 C14.3723446,17.3756713 13.8681836,18.113545 13.102511,18.4133353 C12.3368384,18.7131256 11.4657019,18.5137337 10.9055605,17.9095395 L10.9055605,17.9095395 L6.35620357,12.981 C5.64970198,12.2150377 5.64970198,11.0349623 6.35648673,10.2686932 L6.35648673,10.2686932 L10.9083328,5.3392653 C11.4673686,4.73626634 12.3385051,4.53687443 13.1041777,4.83666471 C13.8698503,5.13645499 14.3740112,5.87432873 14.3749995,6.69659863 L14.3749995,6.69659863 L14.3738484,8.375 L15.1233333,8.375 C18.9893266,8.375 22.1233333,11.5090068 22.1233333,15.375 L22.1233333,15.375 L22.1233333,20.375 C22.1233333,21.375 20.6233333,21.375 20.6233333,20.375 L20.6233333,20.375 Z M12.5572951,6.23341789 C12.3658769,6.15847032 12.1480928,6.20831829 12.0093466,6.35797348 L12.0093466,6.35797348 L7.45879643,11.286 C7.28217103,11.4774906 7.28217103,11.7725094 7.45860616,11.9637938 L7.45860616,11.9637938 L12.0066672,16.890932 C12.1464262,17.0416817 12.3642103,17.0915297 12.5556284,17.0165821 C12.7470466,16.9416345 12.8730868,16.7571661 12.8733333,16.5525 L12.8733333,16.5525 L12.8733333,14.125 C12.8733333,13.7107864 13.2091198,13.375 13.6233333,13.375 L13.6233333,13.375 L15.1233333,13.375 C17.3542971,13.375 19.3414989,14.418669 20.6233333,16.0444015 L20.6233333,16.0444015 L20.6233333,15.375 C20.6233333,12.3374339 18.1608995,9.875 15.1233333,9.875 L15.1233333,9.875 L13.6233333,9.875 C13.2089187,9.875 12.873049,9.53889964 12.8733335,9.12448507 L12.8733335,9.12448507 L12.8750002,6.69698507 L12.8673692,6.61185059 C12.8374077,6.44236374 12.7213678,6.29765866 12.5572951,6.23341789 Z M6.9538474,5.34051078 L2.40551406,10.2688441 C1.69886865,11.0349623 1.69886865,12.2150377 2.40537024,12.981 L6.9538474,17.9094892 C7.23477029,18.2138824 7.70926271,18.2329088 8.01365588,17.9519859 C8.31804906,17.671063 8.33707549,17.1965706 8.0561526,16.8921774 L3.50781927,11.9638441 C3.33133769,11.7725094 3.33133769,11.4774906 3.50796309,11.286 L8.0561526,6.35782255 C8.33707549,6.05342937 8.31804906,5.57893695 8.01365588,5.29801406 C7.70926271,5.01709118 7.23477029,5.0361176 6.9538474,5.34051078 Z"
        })
    });
var $558a1874964eed3d$var$MessageReplyAll$1 = $558a1874964eed3d$var$MessageReplyAll;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$MessageReply = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M10.838 15.875h4.25a5.5 5.5 0 0 1 5.5 5.5h1.5v-5a7 7 0 0 0-7-7H10.84l.002-1.677A2 2 0 0 0 7.374 6.34l-4.552 4.93a2 2 0 0 0 0 2.712l4.549 4.928a2 2 0 0 0 3.467-1.356v-1.678zm9.75 5.5c0 1 1.5 1 1.5 0h-1.5zm-5.5-7h-5a.75.75 0 0 0-.75.75v2.427a.5.5 0 0 1-.866.339l-4.548-4.927a.5.5 0 0 1 0-.678l4.551-4.928a.5.5 0 0 1 .866.34l-.003 2.426c0 .415.336.751.75.751h5a5.5 5.5 0 0 1 5.5 5.5v.67a6.988 6.988 0 0 0-5.5-2.67z"
        })
    });
var $558a1874964eed3d$var$MessageReply$1 = $558a1874964eed3d$var$MessageReply;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$MessageSend = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M21.426 2.35l.032.03a.756.756 0 0 1 .118.108l-.035-.035c.366.364.497.903.339 1.398l-5.453 16.74a1.988 1.988 0 0 1-1.935 1.359 1.996 1.996 0 0 1-1.873-1.48l-1.764-7.329-7.322-1.756-.028-.007a1.99 1.99 0 0 1-.087-3.803L20.144 2.12a1.376 1.376 0 0 1 1.282.23zm-1.56 2.84l-7.562 7.562 1.767 7.341a.488.488 0 0 0 .932.028l4.863-14.93zm-1.068-1.054L3.889 9a.49.49 0 0 0 .012.932l7.342 1.76 7.555-7.555z"
        })
    });
var $558a1874964eed3d$var$MessageSend$1 = $558a1874964eed3d$var$MessageSend;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$MoreEllipsisVertical = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.5238 17.2381C12.8387 17.2381 13.9047 18.3041 13.9047 19.619C13.9047 20.934 12.8387 22 11.5238 22C10.2088 22 9.14282 20.934 9.14282 19.619C9.14282 18.3041 10.2088 17.2381 11.5238 17.2381Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.5238 9.61905C12.8387 9.61905 13.9047 10.685 13.9047 12C13.9047 13.315 12.8387 14.381 11.5238 14.381C10.2088 14.381 9.14282 13.315 9.14282 12C9.14282 10.685 10.2088 9.61905 11.5238 9.61905Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.5238 2C12.8387 2 13.9047 3.06599 13.9047 4.38095C13.9047 5.69592 12.8387 6.7619 11.5238 6.7619C10.2088 6.7619 9.14282 5.69592 9.14282 4.38095C9.14282 3.06599 10.2088 2 11.5238 2Z"
            })
        ]
    });
var $558a1874964eed3d$var$MoreEllipsisVertical$1 = $558a1874964eed3d$var$MoreEllipsisVertical;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$MoreEllipsis = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4.70833 14.7084C6.2041 14.7084 7.41667 13.4958 7.41667 12C7.41667 10.5042 6.2041 9.29169 4.70833 9.29169C3.21256 9.29169 2 10.5042 2 12C2 13.4958 3.21256 14.7084 4.70833 14.7084Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 14.7084C13.4958 14.7084 14.7083 13.4958 14.7083 12C14.7083 10.5042 13.4958 9.29169 12 9.29169C10.5042 9.29169 9.29167 10.5042 9.29167 12C9.29167 13.4958 10.5042 14.7084 12 14.7084Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M19.2917 14.7084C20.7874 14.7084 22 13.4958 22 12C22 10.5042 20.7874 9.29169 19.2917 9.29169C17.7959 9.29169 16.5833 10.5042 16.5833 12C16.5833 13.4958 17.7959 14.7084 19.2917 14.7084Z"
            })
        ]
    });
var $558a1874964eed3d$var$MoreEllipsis$1 = $558a1874964eed3d$var$MoreEllipsis;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$NewWindowSm = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.1875 1.4375C10.1875 1.19588 10.3834 1 10.625 1H14.5625C14.8041 1 15 1.19588 15 1.4375V5.375C15 5.61662 14.8041 5.8125 14.5625 5.8125C14.3209 5.8125 14.125 5.61662 14.125 5.375V2.49372L6.12186 10.4969C5.951 10.6677 5.674 10.6677 5.50314 10.4969C5.33229 10.326 5.33229 10.049 5.50314 9.87814L13.5063 1.875H10.625C10.3834 1.875 10.1875 1.67912 10.1875 1.4375ZM1.38442 4.00942C1.63056 3.76328 1.9644 3.625 2.3125 3.625H7.5625C7.80412 3.625 8 3.82088 8 4.0625C8 4.30412 7.80412 4.5 7.5625 4.5H2.3125C2.19647 4.5 2.08519 4.54609 2.00314 4.62814C1.92109 4.71019 1.875 4.82147 1.875 4.9375V13.6875C1.875 13.8035 1.92109 13.9148 2.00314 13.9969C2.08519 14.0789 2.19647 14.125 2.3125 14.125H11.0625C11.1785 14.125 11.2898 14.0789 11.3719 13.9969C11.4539 13.9148 11.5 13.8035 11.5 13.6875V8.4375C11.5 8.19588 11.6959 8 11.9375 8C12.1791 8 12.375 8.19588 12.375 8.4375V13.6875C12.375 14.0356 12.2367 14.3694 11.9906 14.6156C11.7444 14.8617 11.4106 15 11.0625 15H2.3125C1.9644 15 1.63056 14.8617 1.38442 14.6156C1.13828 14.3694 1 14.0356 1 13.6875V4.9375C1 4.5894 1.13828 4.25556 1.38442 4.00942Z"
        })
    });
var $558a1874964eed3d$var$NewWindowSm$1 = $558a1874964eed3d$var$NewWindowSm;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$NewWindow = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.376 5.623a.75.75 0 1 1 0 1.5h-7.5a.5.5 0 0 0-.5.5v12.5a.5.5 0 0 0 .5.5h12.5a.5.5 0 0 0 .5-.5v-7.5a.75.75 0 0 1 1.5 0v7.5a2 2 0 0 1-2 2h-12.5a2 2 0 0 1-2-2v-12.5a2 2 0 0 1 2-2zm10-3.75a.765.765 0 0 1 .42.13.748.748 0 0 1 .11.09l-.079-.069a.754.754 0 0 1 .299.6l-.004-.074.003.044v5.654a.75.75 0 1 1-1.5 0V4.433L9.407 15.653a.75.75 0 0 1-.976.073l-.084-.072a.75.75 0 0 1 0-1.061l11.219-11.22H15.75a.75.75 0 0 1-.743-.648L15 2.623a.75.75 0 0 1 .75-.75z"
        })
    });
var $558a1874964eed3d$var$NewWindow$1 = $558a1874964eed3d$var$NewWindow;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$NoticeErrorFill = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.25 0.571C17.449 0.571 17.64 0.647 17.78 0.781L23.78 6.495C23.921 6.629 24 6.811 24 7V17C24 17.189 23.921 17.371 23.78 17.505L17.78 23.219C17.64 23.353 17.449 23.429 17.25 23.429H6.75C6.551 23.429 6.36 23.353 6.22 23.219L0.22 17.505C0.079 17.371 0 17.189 0 17V7C0 6.811 0.079 6.629 0.22 6.495L6.22 0.781C6.36 0.647 6.551 0.571 6.75 0.571H17.25ZM11.865 16.882L11.76 16.876C11.23 16.876 10.8 17.286 10.8 17.791 10.8 18.295 11.23 18.705 11.76 18.705 12.29 18.705 12.72 18.295 12.72 17.791 12.72 17.319 12.346 16.931 11.865 16.882ZM12.72 6.21C12.72 5.789 12.29 5.448 11.76 5.448 11.23 5.448 10.8 5.789 10.8 6.21V13.829C10.8 14.249 11.23 14.591 11.76 14.591 12.29 14.591 12.72 14.249 12.72 13.829V6.21Z"
        })
    });
var $558a1874964eed3d$var$NoticeErrorFill$1 = $558a1874964eed3d$var$NoticeErrorFill;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$NoticeError = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M16.375 2c.166 0 .325.066.442.183l5 5a.625.625 0 0 1 .183.442v8.75a.625.625 0 0 1-.183.442l-5 5a.625.625 0 0 1-.442.183h-8.75a.625.625 0 0 1-.442-.183l-5-5A.625.625 0 0 1 2 16.375v-8.75c0-.166.066-.325.183-.442l5-5A.625.625 0 0 1 7.625 2zm-.455 1.667H8.08L3.667 8.08v7.84l4.413 4.413h7.84l4.413-4.413V8.08L15.92 3.667zm-3.954 12.6l.088.004a.8.8 0 1 1-.088-.004zm0-10c.442 0 .8.298.8.666V13.6c0 .368-.358.667-.8.667-.441 0-.8-.299-.8-.667V6.933c0-.368.359-.666.8-.666z"
        })
    });
var $558a1874964eed3d$var$NoticeError$1 = $558a1874964eed3d$var$NoticeError;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$NoticeImportant = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 1.875c5.592 0 10.125 4.533 10.125 10.125S17.592 22.125 12 22.125 1.875 17.592 1.875 12 6.408 1.875 12 1.875zm0 1.5a8.625 8.625 0 1 0 0 17.25 8.625 8.625 0 0 0 0-17.25zM12 15a1.063 1.063 0 1 1 0 2.125A1.063 1.063 0 0 1 12 15zm0-9.375a.75.75 0 0 1 .75.75v6.875a.75.75 0 1 1-1.5 0V6.375a.75.75 0 0 1 .75-.75z"
        })
    });
var $558a1874964eed3d$var$NoticeImportant$1 = $558a1874964eed3d$var$NoticeImportant;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$NoticeInfo = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.9636 8.97914C12.7579 8.97914 13.4019 8.33519 13.4019 7.54084C13.4019 6.74649 12.7579 6.10254 11.9636 6.10254C11.1692 6.10254 10.5253 6.74649 10.5253 7.54084C10.5253 8.33519 11.1692 8.97914 11.9636 8.97914Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9.8626 10.8918C10.0659 10.2894 11.1277 10.0861 11.8807 10.0861C12.9124 10.0861 13.6202 10.8918 13.4772 11.788C13.0931 14.1224 12.694 15.139 12.4907 16.148C12.3326 16.9237 14.1097 16.5547 14.1097 17.1571C14.1097 17.7595 13.191 17.9628 12.2949 17.9628C11.2858 17.9628 10.3521 17.2399 10.4801 16.3438C10.6834 14.9281 11.8054 12.0214 11.4892 11.6976C11.1051 11.2909 9.60657 11.6825 9.87013 10.8918H9.8626Z"
            })
        ]
    });
var $558a1874964eed3d$var$NoticeInfo$1 = $558a1874964eed3d$var$NoticeInfo;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$NoticeWarning = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 2c.793 0 1.52.42 1.919 1.097l.08.148 7.797 15.883a1.993 1.993 0 0 1-1.619 2.865l-.17.007H3.994a1.993 1.993 0 0 1-1.859-2.715l.07-.157L10 3.245A2.227 2.227 0 0 1 12 2zm0 1.481a.746.746 0 0 0-.616.326l-.053.091-7.797 15.884a.511.511 0 0 0 .372.729l.087.007h16.014a.511.511 0 0 0 .495-.638l-.036-.099-7.797-15.883A.746.746 0 0 0 12 3.481zm0 13.334a1.05 1.05 0 1 1 0 2.098 1.05 1.05 0 0 1 0-2.098zm0-8.642a.74.74 0 0 1 .734.64l.007.1v6.173a.74.74 0 0 1-1.475.1l-.007-.1V8.913c0-.409.332-.74.741-.74z"
        })
    });
var $558a1874964eed3d$var$NoticeWarning$1 = $558a1874964eed3d$var$NoticeWarning;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$NotifyOff = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.8619 19.5H10.1344C10.0832 19.5001 10.0339 19.519 9.9958 19.5531C9.95769 19.5872 9.93346 19.6342 9.92773 19.685C9.91795 19.7619 9.91239 19.8392 9.91107 19.9167C9.91107 20.4692 10.1306 20.9991 10.5213 21.3898C10.912 21.7805 11.4419 22 11.9944 22C12.5469 22 13.0768 21.7805 13.4675 21.3898C13.8582 20.9991 14.0777 20.4692 14.0777 19.9167C14.0778 19.8393 14.0736 19.7619 14.0652 19.685C14.0597 19.6347 14.036 19.5881 13.9986 19.554C13.9611 19.5199 13.9125 19.5007 13.8619 19.5Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9.5994 17.4167H19.4944C19.5656 17.4167 19.6356 17.3986 19.6977 17.3639C19.7599 17.3293 19.8121 17.2793 19.8495 17.2187C19.8868 17.1581 19.908 17.089 19.9111 17.0179C19.9141 16.9468 19.8989 16.8761 19.8669 16.8125C18.913 14.9171 18.4145 12.8252 18.4111 10.7033V10.0633C18.4145 9.61447 18.3729 9.1664 18.2869 8.72583L9.5994 17.4167Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2.82773 21.9942C2.93682 21.9959 3.04514 21.9758 3.14633 21.935C3.24751 21.8942 3.33951 21.8336 3.4169 21.7567L21.7502 3.42333C21.9021 3.26479 21.9869 3.05372 21.9869 2.83417C21.9869 2.61461 21.9021 2.40354 21.7502 2.245C21.6728 2.16752 21.5809 2.10605 21.4798 2.06412C21.3786 2.02218 21.2702 2.00059 21.1606 2.00059C21.0511 2.00059 20.9427 2.02218 20.8415 2.06412C20.7404 2.10605 20.6485 2.16752 20.5711 2.245L16.7277 6.0925C16.2437 5.67984 15.731 5.30196 15.1936 4.96167C14.601 4.57992 13.9384 4.31987 13.2444 4.19667V3.25C13.2444 2.91848 13.1127 2.60054 12.8783 2.36612C12.6439 2.1317 12.3259 2 11.9944 2C11.6629 2 11.3449 2.1317 11.1105 2.36612C10.8761 2.60054 10.7444 2.91848 10.7444 3.25V4.2075C9.88045 4.37175 9.06703 4.73622 8.3694 5.27167C6.81273 6.49333 5.57773 7.45917 5.57773 10.0633V11.9533C5.57773 13.9367 5.13773 14.8067 4.26023 16.5417L4.12273 16.8133C4.09093 16.8768 4.07587 16.9473 4.07898 17.0182C4.08209 17.0892 4.10326 17.1581 4.14049 17.2185C4.17772 17.279 4.22977 17.3289 4.29171 17.3636C4.35365 17.3982 4.42342 17.4165 4.4944 17.4167H5.40273L2.2444 20.5783C2.12809 20.6939 2.04871 20.8415 2.01632 21.0022C1.98393 21.163 1.99999 21.3298 2.06246 21.4814C2.12493 21.633 2.231 21.7627 2.36724 21.854C2.50347 21.9453 2.66374 21.994 2.82773 21.9942Z"
            })
        ]
    });
var $558a1874964eed3d$var$NotifyOff$1 = $558a1874964eed3d$var$NotifyOff;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$NotifyOn = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.7792 19.5H10.0525C10.0013 19.5001 9.952 19.519 9.91389 19.5531C9.87578 19.5872 9.85155 19.6342 9.84582 19.685C9.83674 19.7619 9.83229 19.8392 9.83249 19.9167C9.83249 20.4692 10.052 20.9991 10.4427 21.3898C10.8334 21.7805 11.3633 22 11.9158 22C12.4684 22 12.9983 21.7805 13.389 21.3898C13.7797 20.9991 13.9992 20.4692 13.9992 19.9167C13.9994 19.8392 13.9949 19.7619 13.9858 19.685C13.9804 19.634 13.9563 19.5869 13.9181 19.5527C13.8799 19.5185 13.8304 19.4997 13.7792 19.5Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M19.7875 18.0633C18.8337 16.1676 18.3355 14.0755 18.3325 11.9533V11.3133C18.3556 10.0719 18.074 8.84379 17.5123 7.73647C16.9507 6.62914 16.1261 5.6764 15.1108 4.96167C14.5195 4.58047 13.8584 4.32045 13.1658 4.19667V3.25C13.1658 2.91848 13.0341 2.60054 12.7997 2.36612C12.5653 2.1317 12.2473 2 11.9158 2C11.5843 2 11.2664 2.1317 11.0319 2.36612C10.7975 2.60054 10.6658 2.91848 10.6658 3.25V4.2075C9.80145 4.37121 8.98763 4.73572 8.28999 5.27167C7.40071 6.00428 6.688 6.92791 6.20483 7.97389C5.72166 9.01987 5.48046 10.1613 5.49915 11.3133V11.9533C5.49612 14.0755 4.99791 16.1676 4.04415 18.0633C4.01235 18.1268 3.99729 18.1973 4.0004 18.2682C4.00351 18.3392 4.02468 18.4081 4.06191 18.4685C4.09914 18.529 4.15119 18.5789 4.21313 18.6136C4.27507 18.6482 4.34484 18.6665 4.41582 18.6667H19.4158C19.4869 18.6666 19.5568 18.6483 19.6189 18.6136C19.6809 18.5789 19.733 18.5289 19.7703 18.4683C19.8075 18.4078 19.8287 18.3387 19.8317 18.2676C19.8347 18.1966 19.8195 18.1268 19.7875 18.0633Z"
            })
        ]
    });
var $558a1874964eed3d$var$NotifyOn$1 = $558a1874964eed3d$var$NotifyOn;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ObjectAddSm = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M8 1.146a6.854 6.854 0 0 1 0 13.708A6.862 6.862 0 0 1 1.146 8 6.854 6.854 0 0 1 8 1.146zm0 1.458a5.396 5.396 0 1 0 0 10.792A5.396 5.396 0 0 0 8 2.604zM8 3.93a.73.73 0 0 1 .73.73v2.466c0 .08.064.146.145.146h2.466a.73.73 0 0 1 0 1.458H8.875a.146.146 0 0 0-.146.146v2.466a.73.73 0 0 1-1.458 0V8.875a.146.146 0 0 0-.146-.146H4.659a.73.73 0 0 1 0-1.458h2.466c.08 0 .146-.065.146-.146V4.659A.73.73 0 0 1 8 3.929z"
        })
    });
var $558a1874964eed3d$var$ObjectAddSm$1 = $558a1874964eed3d$var$ObjectAddSm;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ObjectAdd = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 1.875c5.592 0 10.125 4.533 10.125 10.125S17.592 22.125 12 22.125 1.875 17.592 1.875 12 6.408 1.875 12 1.875zm0 1.5a8.625 8.625 0 1 0 0 17.25 8.625 8.625 0 0 0 0-17.25zM12 7.5a.75.75 0 0 1 .75.75v3h3a.75.75 0 0 1 .743.648L16.5 12a.75.75 0 0 1-.75.75h-3v3a.75.75 0 0 1-.648.743L12 16.5a.75.75 0 0 1-.75-.75v-3h-3a.75.75 0 0 1-.743-.648L7.5 12a.75.75 0 0 1 .75-.75h3v-3a.75.75 0 0 1 .648-.743z"
        })
    });
var $558a1874964eed3d$var$ObjectAdd$1 = $558a1874964eed3d$var$ObjectAdd;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ObjectSubtractSm = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M8 1.146A6.862 6.862 0 0 1 14.854 8 6.854 6.854 0 1 1 8 1.146zm0 1.458a5.396 5.396 0 1 0 0 10.792A5.396 5.396 0 0 0 8 2.604zm3.34 4.667a.73.73 0 0 1 0 1.458H4.66a.73.73 0 0 1 0-1.458z"
        })
    });
var $558a1874964eed3d$var$ObjectSubtractSm$1 = $558a1874964eed3d$var$ObjectSubtractSm;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ObjectSubtract = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 1.875c5.592 0 10.125 4.533 10.125 10.125S17.592 22.125 12 22.125 1.875 17.592 1.875 12 6.408 1.875 12 1.875zm0 1.5a8.625 8.625 0 1 0 0 17.25 8.625 8.625 0 0 0 0-17.25zm3.75 7.875a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 1 1 0-1.5z"
        })
    });
var $558a1874964eed3d$var$ObjectSubtract$1 = $558a1874964eed3d$var$ObjectSubtract;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$PhoneMobile = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M15.8333 2H7.5C6.83696 2 6.20107 2.26414 5.73223 2.73432C5.26339 3.20449 5 3.84218 5 4.50711V19.4929C5 20.1578 5.26339 20.7955 5.73223 21.2657C6.20107 21.7359 6.83696 22 7.5 22H15.8333C16.4964 22 17.1323 21.7359 17.6011 21.2657C18.0699 20.7955 18.3333 20.1578 18.3333 19.4929V4.50711C18.3333 3.84218 18.0699 3.20449 17.6011 2.73432C17.1323 2.26414 16.4964 2 15.8333 2V2ZM11.6667 20.7465C11.5018 20.7465 11.3407 20.6974 11.2037 20.6056C11.0667 20.5138 10.9598 20.3833 10.8968 20.2306C10.8337 20.0779 10.8172 19.9098 10.8493 19.7477C10.8815 19.5856 10.9609 19.4367 11.0774 19.3198C11.194 19.2029 11.3424 19.1234 11.5041 19.0911C11.6657 19.0589 11.8333 19.0754 11.9856 19.1387C12.1378 19.2019 12.268 19.309 12.3596 19.4465C12.4511 19.5839 12.5 19.7455 12.5 19.9108C12.5 20.1324 12.4122 20.345 12.2559 20.5017C12.0996 20.6584 11.8877 20.7465 11.6667 20.7465ZM16.6667 16.9858C16.6667 17.2074 16.5789 17.42 16.4226 17.5767C16.2663 17.7335 16.0543 17.8215 15.8333 17.8215H7.5C7.27899 17.8215 7.06702 17.7335 6.91074 17.5767C6.75446 17.42 6.66667 17.2074 6.66667 16.9858V4.92496C6.66667 4.70332 6.75446 4.49075 6.91074 4.33403C7.06702 4.1773 7.27899 4.08926 7.5 4.08926H15.8333C16.0543 4.08926 16.2663 4.1773 16.4226 4.33403C16.5789 4.49075 16.6667 4.70332 16.6667 4.92496V16.9858Z"
        })
    });
var $558a1874964eed3d$var$PhoneMobile$1 = $558a1874964eed3d$var$PhoneMobile;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Phone = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M21.2774 16.3624L19.1452 14.226C18.9182 13.9982 18.6485 13.8174 18.3517 13.6941C18.0548 13.5708 17.7366 13.5073 17.4152 13.5073C17.0938 13.5073 16.7756 13.5708 16.4788 13.6941C16.1819 13.8174 15.9123 13.9982 15.6852 14.226L15.2504 14.6615C13.1076 12.8631 11.1283 10.878 9.33566 8.72936L9.77044 8.29388C10.2283 7.83397 10.4854 7.211 10.4854 6.56154C10.4854 5.91208 10.2283 5.28912 9.77044 4.82921L7.63392 2.69536C7.16749 2.24905 6.54724 2 5.90218 2C5.25711 2 4.63687 2.24905 4.17044 2.69536L3.00522 3.86767C2.44529 4.43253 2.09646 5.17316 2.01729 5.96518C1.93812 6.75721 2.13343 7.5524 2.57044 8.21724C6.04443 13.4603 10.5304 17.9543 15.7644 21.4349C16.4304 21.8686 17.2242 22.0618 18.0147 21.9826C18.8052 21.9035 19.5451 21.5566 20.1122 20.9994L21.2817 19.8271C21.5091 19.5999 21.6896 19.3299 21.8127 19.0327C21.9358 18.7355 21.9991 18.417 21.9991 18.0952C21.9991 17.7735 21.9358 17.4549 21.8127 17.1577C21.6896 16.8605 21.5091 16.5906 21.2817 16.3633L21.2774 16.3624Z"
        })
    });
var $558a1874964eed3d$var$Phone$1 = $558a1874964eed3d$var$Phone;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Print = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M16.375 1.874a2 2 0 0 1 2 2v3h1.75a2 2 0 0 1 1.995 1.85l.005.15v6.25a2 2 0 0 1-2 2h-1.75v4.25a.75.75 0 0 1-.75.75H6.375a.75.75 0 0 1-.75-.75v-4.25h-1.75a2 2 0 0 1-1.995-1.85l-.005-.15v-6.25a2 2 0 0 1 2-2h1.75v-3a2 2 0 0 1 2-2h8.75zm.5 11.5h-9.75v7.25h9.75v-7.25zm-3.625 3.5a.75.75 0 1 1 0 1.5H8.875a.75.75 0 0 1 0-1.5zm1.875-2.5a.75.75 0 1 1 0 1.5h-6.25a.75.75 0 0 1 0-1.5zm5-6H3.875a.5.5 0 0 0-.5.5v6.25a.5.5 0 0 0 .5.5h1.75v-3a.75.75 0 0 1 .75-.75h11.25a.75.75 0 0 1 .75.75v3h1.75a.5.5 0 0 0 .492-.41l.008-.09v-6.25a.5.5 0 0 0-.5-.5zm-13.75 1a.75.75 0 0 1 0 1.5h-1.25a.75.75 0 0 1 0-1.5zm10-6h-8.75a.5.5 0 0 0-.5.5v3h9.75v-3a.5.5 0 0 0-.5-.5z"
        })
    });
var $558a1874964eed3d$var$Print$1 = $558a1874964eed3d$var$Print;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ProtectionShield = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.875 2l.497.002c2.48.044 4.93.577 7.217 1.575a1.988 1.988 0 0 1 1.161 1.817v6.345c0 1.613-.363 3.165-1.024 4.563l.145-.321a10.667 10.667 0 0 1-.298.63l-.045.086c-.158.302-.331.597-.518.883l-.038.057a9.215 9.215 0 0 1-.158.232l-.046.064c-.266.375-.557.732-.87 1.07l-.067.07c-.235.249-.482.486-.741.712l-.029.024-.008.008A10.659 10.659 0 0 1 13.91 21.7l-.867.333c-.75.29-1.583.29-2.333 0L9.84 21.7A10.673 10.673 0 0 1 3 11.74V5.4a1.993 1.993 0 0 1 1.167-1.824c.869-.39 1.768-.705 2.688-.942l.02-.004c1.467-.39 2.98-.601 4.504-.628L11.875 2zM4.5 8.238v3.501a9.173 9.173 0 0 0 5.88 8.56l.867.335c.404.155.852.155 1.257 0l.867-.334a9.168 9.168 0 0 0 2.073-1.122L4.5 8.238zm.733-3.485l-.384.16-.064.028a.491.491 0 0 0-.285.453v.722L16.588 18.2l.01-.01a9.178 9.178 0 0 0 .46-.5l-.188.213c.077-.084.152-.17.225-.257l-.038.044a9.19 9.19 0 0 0 .499-.64l-.038.053c.063-.088.124-.176.184-.265l-.146.212c.068-.096.134-.193.199-.291l-.053.079a9.18 9.18 0 0 0 .44-.73l-.047.086c.06-.107.117-.216.173-.326l.015-.03L6.82 4.202c-.537.158-1.067.342-1.587.551zM11.882 3.5l-.502.002c-.961.019-1.917.117-2.857.292l10.36 10.516c.24-.822.367-1.686.367-2.57V5.39a.486.486 0 0 0-.273-.443A17.34 17.34 0 0 0 11.882 3.5z"
        })
    });
var $558a1874964eed3d$var$ProtectionShield$1 = $558a1874964eed3d$var$ProtectionShield;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$RatingStarEmpty = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.9978 2.66661C11.9865 2.66661 11.9754 2.66972 11.9658 2.67561C11.9564 2.68134 11.9488 2.68948 11.9436 2.69918C11.9435 2.69945 11.9437 2.6989 11.9436 2.69918L8.97548 8.5848C8.87275 8.78849 8.673 8.92551 8.44598 8.948L2.71146 9.51611C2.70214 9.51688 2.69324 9.52023 2.68582 9.5259C2.6784 9.53157 2.67275 9.53925 2.66956 9.54803C2.66637 9.55681 2.66575 9.56632 2.6678 9.57543C2.66984 9.58455 2.67445 9.59289 2.68109 9.59947L7.39524 14.2683C7.56643 14.4378 7.63281 14.6866 7.56886 14.9189L5.8239 21.2574C5.82379 21.2579 5.82368 21.2583 5.82358 21.2587C5.82116 21.2688 5.82157 21.2793 5.82477 21.2891C5.82811 21.2994 5.83434 21.3085 5.84272 21.3153C5.85109 21.3221 5.86125 21.3263 5.87198 21.3275C5.8827 21.3286 5.89353 21.3267 5.90318 21.3218L5.9068 21.32L11.7019 18.45C11.8883 18.3577 12.1072 18.3577 12.2936 18.45L18.1004 21.3254C18.11 21.3302 18.1208 21.3322 18.1316 21.331C18.1423 21.3299 18.1525 21.3256 18.1608 21.3188C18.1692 21.312 18.1754 21.3029 18.1788 21.2927C18.182 21.2828 18.1824 21.2723 18.18 21.2622C18.1799 21.2618 18.1798 21.2614 18.1796 21.261L16.4347 14.9224C16.3708 14.6902 16.4371 14.4416 16.6081 14.272L21.3189 9.60303C21.3255 9.59645 21.3302 9.5881 21.3322 9.57899C21.3342 9.56988 21.3336 9.56037 21.3304 9.55158C21.3272 9.54281 21.3216 9.53513 21.3142 9.52945C21.3067 9.52378 21.2979 9.52036 21.2885 9.51958L21.278 9.51871L15.554 8.95156C15.3271 8.92907 15.1274 8.79215 15.0246 8.58857L12.0524 2.69999C12.0522 2.69973 12.0525 2.70024 12.0524 2.69999C12.0472 2.69027 12.0392 2.68135 12.0298 2.67561C12.0201 2.66972 12.0091 2.66661 11.9978 2.66661ZM11.2703 1.53816C11.4893 1.40424 11.7411 1.33337 11.9978 1.33337C12.2545 1.33337 12.5062 1.40424 12.7253 1.53816C12.9443 1.67208 13.1221 1.86386 13.2391 2.09237L13.2408 2.09579L16.0498 7.66092L21.4051 8.19145C21.6661 8.21431 21.9153 8.31089 22.1235 8.46999C22.3334 8.63033 22.493 8.84745 22.5833 9.09567C22.6736 9.34387 22.6909 9.61276 22.6332 9.87051C22.5754 10.1283 22.445 10.364 22.2574 10.55L17.8236 14.9445L19.4683 20.9188C19.5369 21.1775 19.5294 21.4506 19.4466 21.7051C19.3638 21.9597 19.2092 22.1849 19.0015 22.3536C18.7937 22.5224 18.5416 22.6276 18.2755 22.6565C18.0101 22.6853 17.7421 22.637 17.5035 22.5176C17.5028 22.5172 17.5021 22.5169 17.5014 22.5165L11.9978 19.7913L6.50212 22.513C6.50147 22.5133 6.50081 22.5136 6.50016 22.5139C6.26151 22.6335 5.99346 22.6817 5.72807 22.6529C5.46195 22.624 5.20985 22.5189 5.00209 22.3501C4.79432 22.1813 4.63974 21.9561 4.55694 21.7016C4.47413 21.447 4.46663 21.174 4.53532 20.9153L4.53688 20.9094L6.17991 14.9411L1.74275 10.5466C1.55514 10.3607 1.42458 10.1247 1.36682 9.86695C1.30907 9.60921 1.32638 9.34032 1.4167 9.09211C1.50702 8.8439 1.66658 8.62677 1.87647 8.46643C2.08474 8.30733 2.33392 8.21075 2.59492 8.1879L7.95 7.65738L10.7546 2.09601L10.7565 2.09237C10.8735 1.86386 11.0513 1.67208 11.2703 1.53816Z"
        })
    });
var $558a1874964eed3d$var$RatingStarEmpty$1 = $558a1874964eed3d$var$RatingStarEmpty;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$RatingStarFull = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M21.9223 9.11975C21.8327 8.87271 21.6686 8.65883 21.4522 8.507C21.2358 8.35517 20.9775 8.2727 20.7122 8.27074H15.4857C15.3976 8.2707 15.3115 8.24379 15.2393 8.19366C15.1672 8.14352 15.1124 8.07261 15.0824 7.99057L13.2115 2.72672C13.114 2.4883 12.9467 2.28413 12.7311 2.14042C12.5155 1.99671 12.2614 1.92001 12.0014 1.92017C11.737 1.92142 11.4795 2.00374 11.2643 2.15578C11.0491 2.30783 10.8869 2.52213 10.7999 2.76917L8.92046 8.00755C8.89047 8.08959 8.83567 8.1605 8.76349 8.21064C8.69132 8.26077 8.60529 8.28768 8.5171 8.28772H3.29062C3.02503 8.28846 2.76617 8.37045 2.54953 8.52244C2.33289 8.67444 2.16908 8.88901 2.08055 9.13673C1.99541 9.3816 1.98672 9.64616 2.05559 9.89599C2.12447 10.1458 2.26772 10.3694 2.46674 10.5376L6.91225 14.1883C6.97905 14.2422 7.02787 14.3148 7.05237 14.3966C7.07686 14.4784 7.07588 14.5656 7.04957 14.6468L5.17867 20.1908C5.09056 20.4475 5.08755 20.7253 5.17008 20.9838C5.2526 21.2423 5.41636 21.468 5.63753 21.6281C5.85869 21.7882 6.12571 21.8742 6.39974 21.8738C6.67377 21.8733 6.9405 21.7864 7.16113 21.6256L11.744 18.2975C11.8169 18.2431 11.9058 18.2137 11.9971 18.2137C12.0885 18.2137 12.1774 18.2431 12.2503 18.2975L16.8417 21.6256C17.0606 21.8058 17.3338 21.9091 17.6184 21.9193C17.903 21.9295 18.183 21.8461 18.4146 21.6821C18.6461 21.518 18.8161 21.2827 18.898 21.0128C18.9799 20.743 18.969 20.4539 18.8671 20.1908L16.9962 14.6468C16.9699 14.5656 16.9689 14.4784 16.9934 14.3966C17.0179 14.3148 17.0667 14.2422 17.1335 14.1883L21.5876 10.5291C21.7804 10.3549 21.9156 10.1271 21.9753 9.87563C22.035 9.62414 22.0165 9.36067 21.9223 9.11975Z"
        })
    });
var $558a1874964eed3d$var$RatingStarFull$1 = $558a1874964eed3d$var$RatingStarFull;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$RatingStarHalf = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.2249 2.0011C10.9603 2.00235 10.7025 2.08486 10.4872 2.23726C10.2718 2.38966 10.1095 2.60446 10.0224 2.85208L8.14142 8.10263C8.11141 8.18486 8.05656 8.25594 7.98433 8.30619C7.9121 8.35643 7.82599 8.38341 7.73773 8.38345H2.50696C2.24115 8.38419 1.98208 8.46637 1.76526 8.61872C1.54844 8.77107 1.38449 8.98614 1.29589 9.23443C1.21069 9.47988 1.20199 9.74504 1.27092 9.99546C1.33985 10.2459 1.48322 10.4699 1.6824 10.6385L6.13157 14.2978C6.19842 14.3518 6.24728 14.4246 6.2718 14.5065C6.29631 14.5885 6.29533 14.6759 6.26899 14.7573L4.39656 20.3142C4.30838 20.5715 4.30537 20.8499 4.38796 21.1091C4.47056 21.3682 4.63445 21.5944 4.85579 21.7548C5.07713 21.9153 5.34438 22.0015 5.61863 22.0011C5.89289 22.0007 6.15984 21.9135 6.38065 21.7523L10.9672 18.4165C11.0413 18.3607 11.1319 18.3308 11.2249 18.3314V2.0011Z"
        })
    });
var $558a1874964eed3d$var$RatingStarHalf$1 = $558a1874964eed3d$var$RatingStarHalf;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$RefreshSync = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M18.875 10.206a.763.763 0 0 1 .404.118.748.748 0 0 1 .126.102l2.5 2.5a.75.75 0 0 1-1.06 1.06l-1.24-1.238a7.625 7.625 0 0 1-13.15 4.69.75.75 0 0 1 1.09-1.03 6.125 6.125 0 0 0 10.552-3.612l-1.192 1.19a.75.75 0 0 1-1.06-1.06l2.5-2.5a.753.753 0 0 1 .53-.22l-.073.003a.754.754 0 0 1 .044-.003zM9.423 5.034a7.625 7.625 0 0 1 8.457 2.322.75.75 0 0 1-1.157.955 6.125 6.125 0 0 0-10.848 3.895l-.001.065 1.22-1.22a.75.75 0 0 1 .977-.073l.084.073a.75.75 0 0 1 0 1.06l-2.483 2.485a.748.748 0 0 1-1.094 0l-2.483-2.485a.75.75 0 0 1 1.06-1.06l1.219 1.218.001-.064a7.625 7.625 0 0 1 4.791-7.074z"
        })
    });
var $558a1874964eed3d$var$RefreshSync$1 = $558a1874964eed3d$var$RefreshSync;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Search = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M9.99 1.567a8.422 8.422 0 0 1 6.462 13.824l5.443 5.444a.75.75 0 1 1-1.06 1.06l-5.444-5.443A8.422 8.422 0 1 1 9.99 1.567zm0 1.5a6.922 6.922 0 1 0 4.884 11.828l.01-.012a6.897 6.897 0 0 0 2.028-4.894c0-3.823-3.099-6.922-6.922-6.922z"
        })
    });
var $558a1874964eed3d$var$Search$1 = $558a1874964eed3d$var$Search;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$SettingsCogSm = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M14.079 6.695l-.739-.262a.802.802 0 0 1-.455-1.1l.336-.708a1.386 1.386 0 0 0-1.846-1.846l-.707.337a.802.802 0 0 1-1.1-.456l-.262-.738a1.386 1.386 0 0 0-2.611 0l-.263.738a.802.802 0 0 1-1.1.456l-.707-.337a1.386 1.386 0 0 0-1.846 1.846l.336.708a.802.802 0 0 1-.455 1.1l-.739.263a1.385 1.385 0 0 0 0 2.61l.739.263a.802.802 0 0 1 .455 1.1l-.336.707a1.386 1.386 0 0 0 1.846 1.846l.707-.336a.8.8 0 0 1 1.1.456l.262.737a1.386 1.386 0 0 0 2.612 0l.262-.738a.801.801 0 0 1 1.1-.455l.707.336a1.386 1.386 0 0 0 1.846-1.846l-.336-.708a.802.802 0 0 1 .455-1.1l.739-.262a1.385 1.385 0 0 0 0-2.61zM8 10.791a2.876 2.876 0 0 1-2.59-1.717A2.808 2.808 0 0 1 6.925 5.41a2.84 2.84 0 0 1 3.664 1.517 2.808 2.808 0 0 1-1.517 3.664c-.34.14-.705.208-1.073.2z"
        })
    });
var $558a1874964eed3d$var$SettingsCogSm$1 = $558a1874964eed3d$var$SettingsCogSm;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$SettingsCog = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M16.123 2.06a2.382 2.382 0 0 1 1.468 2.322l-.06 1.166a.882.882 0 0 0 .923.925l1.167-.059a2.383 2.383 0 0 1 1.715 4.148l-.868.783a.883.883 0 0 0 0 1.31l.868.784a2.382 2.382 0 0 1-1.718 4.148l-1.167-.06a.882.882 0 0 0-.926.927l.06 1.171a2.383 2.383 0 0 1-4.141 1.711l-.785-.868a.882.882 0 0 0-1.311.002l-.788.868a2.383 2.383 0 0 1-4.142-1.717l.06-1.166a.882.882 0 0 0-.927-.926l-1.165.06a2.382 2.382 0 0 1-1.722-4.146l.867-.783a.883.883 0 0 0 0-1.312l-.868-.787a2.382 2.382 0 0 1 1.716-4.143l1.168.059a.882.882 0 0 0 .926-.932l-.056-1.168a2.382 2.382 0 0 1 4.144-1.714l.783.865.002.002a.88.88 0 0 0 1.311-.004l.787-.862a2.383 2.383 0 0 1 2.68-.604zm-1.569 1.612l-.785.862a2.38 2.38 0 0 1-3.41.131l-.127-.13-.782-.864a.882.882 0 0 0-1.534.635l.055 1.163A2.382 2.382 0 0 1 5.47 7.975l-1.165-.06a.882.882 0 0 0-.634 1.535l.866.786a2.383 2.383 0 0 1 0 3.537l-.867.783a.882.882 0 0 0 .639 1.534l1.166-.059a2.382 2.382 0 0 1 2.5 2.5l-.06 1.163a.882.882 0 0 0 1.535.635l.786-.866a2.383 2.383 0 0 1 3.536 0l.781.864a.883.883 0 0 0 1.533-.63l-.06-1.167a2.382 2.382 0 0 1 2.501-2.5l1.167.058a.883.883 0 0 0 .637-1.535l-.869-.784a2.383 2.383 0 0 1 0-3.538l.868-.782a.883.883 0 0 0-.634-1.537l-1.168.06a2.382 2.382 0 0 1-2.495-2.5l.06-1.166a.882.882 0 0 0-1.539-.634zM12 7.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
        })
    });
var $558a1874964eed3d$var$SettingsCog$1 = $558a1874964eed3d$var$SettingsCog;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Share = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M15.8357 11.6681C15.2777 11.6685 14.7255 11.7817 14.2123 12.0007C13.6991 12.2198 13.2354 12.5404 12.849 12.9431L8.27404 10.6539C8.31325 10.4385 8.33526 10.2203 8.33984 10.0014C8.3353 9.78253 8.3133 9.56434 8.27404 9.34894L12.849 7.05977C13.5216 7.75142 14.4137 8.1875 15.3725 8.29329C16.3312 8.39909 17.2968 8.16801 18.1039 7.63966C18.9111 7.1113 19.5095 6.31856 19.7966 5.39724C20.0837 4.47592 20.0416 3.48338 19.6777 2.58967C19.3137 1.69596 18.6504 0.956705 17.8015 0.498566C16.9526 0.0404271 15.9709 -0.108081 15.0245 0.0784862C14.0782 0.265053 13.2262 0.775082 12.6144 1.52119C12.0027 2.2673 11.6692 3.20304 11.6713 4.1681C11.6759 4.38729 11.6979 4.60576 11.7371 4.82144L7.16216 7.10894C6.58599 6.51104 5.84438 6.09907 5.03253 5.92591C4.22067 5.75276 3.37562 5.82632 2.60585 6.13715C1.83608 6.44798 1.17671 6.98191 0.712398 7.67038C0.248081 8.35885 0 9.17046 0 10.001C0 10.8316 0.248081 11.6432 0.712398 12.3317C1.17671 13.0201 1.83608 13.5541 2.60585 13.8649C3.37562 14.1757 4.22067 14.2493 5.03253 14.0761C5.84438 13.903 6.58599 13.491 7.16216 12.8931L11.7371 15.1814C11.6978 15.3971 11.6758 15.6156 11.6713 15.8348C11.6713 16.6589 11.9155 17.4644 12.3731 18.1496C12.8307 18.8349 13.4811 19.3689 14.242 19.6843C15.003 19.9996 15.8403 20.0821 16.6481 19.9214C17.4559 19.7606 18.1979 19.3638 18.7803 18.781C19.3627 18.1983 19.7593 17.4559 19.92 16.6476C20.0807 15.8394 19.9982 15.0016 19.683 14.2403C19.3678 13.4789 18.8341 12.8282 18.1492 12.3703C17.4644 11.9125 16.6593 11.6681 15.8357 11.6681Z"
        })
    });
var $558a1874964eed3d$var$Share$1 = $558a1874964eed3d$var$Share;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$SortAsc = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.993 8.00363L12.0128 8.00195C12.1952 7.98895 12.3811 8.041 12.5348 8.15811L12.6228 8.23617L18.7559 14.5335C18.861 14.6414 18.93 14.7723 18.9631 14.9104L18.9811 15.015C18.9933 15.0727 19 15.1325 19 15.1938C19 15.6019 18.7046 15.9393 18.3213 15.9926L18.2147 16H5.79943C5.40187 16 5.07331 15.6967 5.02131 15.3032L5.01921 15.2813C4.96209 15.0206 5.03234 14.7365 5.22996 14.5335L11.363 8.23617C11.5354 8.0592 11.7679 7.98168 11.993 8.00363Z"
        })
    });
var $558a1874964eed3d$var$SortAsc$1 = $558a1874964eed3d$var$SortAsc;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$SortDesc = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.993 15.9964L12.0128 15.9981C12.1952 16.011 12.3811 15.959 12.5348 15.8419L12.6228 15.7638L18.7559 9.46646C18.861 9.35857 18.93 9.22771 18.9631 9.08963L18.9811 8.98496C18.9933 8.92728 19 8.86754 19 8.80621C19 8.39806 18.7046 8.06074 18.3213 8.00736L18.2147 8H5.79943C5.40187 8 5.07331 8.3033 5.02131 8.69681L5.01921 8.71871C4.96209 8.97938 5.03234 9.26354 5.22996 9.46646L11.363 15.7638C11.5354 15.9408 11.7679 16.0183 11.993 15.9964Z"
        })
    });
var $558a1874964eed3d$var$SortDesc$1 = $558a1874964eed3d$var$SortDesc;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Sortable = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.01769 8.7696C4.96479 8.52822 5.03218 8.26576 5.21988 8.07804L11.0774 2.21971C11.242 2.05509 11.464 1.98298 11.679 2.00337C11.8939 1.98298 12.116 2.05509 12.2806 2.21971L18.1381 8.07804C18.2646 8.20456 18.3365 8.36503 18.3537 8.53011C18.3652 8.58233 18.3713 8.63658 18.3713 8.69226C18.3713 9.10647 18.0355 9.44226 17.6213 9.44226L5.76375 9.44226C5.37565 9.44226 5.05641 9.14748 5.01769 8.7696Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.01769 15.2304C4.96479 15.4718 5.03218 15.7342 5.21988 15.922L11.0774 21.7803C11.242 21.9449 11.464 22.017 11.679 21.9966C11.8939 22.017 12.116 21.9449 12.2806 21.7803L18.1381 15.922C18.2646 15.7954 18.3365 15.635 18.3537 15.4699C18.3652 15.4177 18.3713 15.3634 18.3713 15.3077C18.3713 14.8935 18.0355 14.5577 17.6213 14.5577H5.76375C5.37565 14.5577 5.05641 14.8525 5.01769 15.2304Z"
            })
        ]
    });
var $558a1874964eed3d$var$Sortable$1 = $558a1874964eed3d$var$Sortable;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Table$2 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M20.182 1.702c1.167 0 2.113.947 2.113 2.113V20.18a2.114 2.114 0 0 1-2.113 2.114H3.818a2.114 2.114 0 0 1-2.113-2.114V3.815c0-1.166.946-2.113 2.113-2.113zM11.25 12.747H3.204v7.432c0 .305.223.558.515.606l.1.008 7.43-.001v-8.045zm9.545 0H12.75v8.045h7.432a.614.614 0 0 0 .605-.513l.008-.1v-7.432zM11.25 3.2H3.818a.614.614 0 0 0-.613.614l-.001 7.432h8.046V3.2zm8.932 0H12.75v8.046h8.045V3.815a.614.614 0 0 0-.514-.605l-.1-.008z"
        })
    });
var $558a1874964eed3d$var$Table$3 = $558a1874964eed3d$var$Table$2;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Tag$2 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M8.798 1.737c.89 0 1.744.354 2.375.983l10.053 10.053a2.054 2.054 0 0 1 0 2.905l-5.982 5.983a2.054 2.054 0 0 1-2.905 0L2.286 11.606a3.361 3.361 0 0 1-.983-2.374v-5.44c0-1.135.92-2.055 2.054-2.055h5.441zm0 1.5h-5.44a.555.555 0 0 0-.555.554v5.441c0 .493.196.966.544 1.314L13.4 20.6a.554.554 0 0 0 .784 0l5.981-5.983a.554.554 0 0 0 0-.783L10.113 3.78a1.861 1.861 0 0 0-1.315-.544zm-2.18 1.76a2.055 2.055 0 1 1 0 4.11 2.055 2.055 0 0 1 0-4.11zm0 1.5a.555.555 0 1 0 .001 1.11.555.555 0 0 0 0-1.11z"
        })
    });
var $558a1874964eed3d$var$Tag$3 = $558a1874964eed3d$var$Tag$2;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$TimeSensitive = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 4.5C7.45287 4.5 3.76669 8.13766 3.76669 12.6249C3.76669 17.1122 7.45286 20.7499 12 20.7499C16.5472 20.7499 20.2333 17.1122 20.2333 12.6249C20.2333 8.13765 16.5472 4.5 12 4.5ZM12 5.74999C15.8476 5.74999 18.9667 8.828 18.9667 12.6249C18.9667 16.4219 15.8476 19.4999 12 19.4999C8.15242 19.4999 5.03335 16.4219 5.03335 12.6249C5.03335 8.82801 8.15243 5.74999 12 5.74999Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7.53731 18.7861C7.69379 18.4774 8.07423 18.3523 8.38706 18.5067C8.67382 18.6483 8.80422 18.9756 8.70344 19.2669L8.67017 19.3453L7.49977 21.6545C7.3433 21.9632 6.96286 22.0883 6.65003 21.9338C6.36327 21.7923 6.23286 21.465 6.33364 21.1737L6.36692 21.0953L7.53731 18.7861Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 11.9999C12.3498 11.9999 12.6333 12.2798 12.6333 12.6249C12.6333 12.9413 12.3951 13.2028 12.0859 13.2442L12 13.2499H9.1365C8.78672 13.2499 8.50317 12.9701 8.50317 12.6249C8.50317 12.3085 8.74143 12.047 9.05056 12.0056L9.1365 11.9999H12Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 7.62498C12.3206 7.62498 12.5856 7.8601 12.6276 8.16516L12.6333 8.24997L12.6333 12.6249C12.6333 12.9701 12.3498 13.2499 12 13.2499C11.6794 13.2499 11.4144 13.0148 11.3724 12.7097L11.3667 12.6249V8.24997C11.3667 7.9048 11.6502 7.62498 12 7.62498Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M5.90437 2.13698C6.17751 1.92135 6.57606 1.96505 6.79456 2.23459C6.9932 2.47962 6.97466 2.82694 6.76444 3.05007L6.69565 3.11306L3.52899 5.61304C3.25586 5.82867 2.85731 5.78497 2.63881 5.51543C2.44016 5.2704 2.4587 4.92308 2.66892 4.69995L2.73772 4.63696L5.90437 2.13698Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.613 18.5059C15.8998 18.3644 16.2434 18.4577 16.4191 18.7121L16.4627 18.7854L17.6331 21.0954C17.7895 21.4041 17.6627 21.7795 17.3499 21.9339C17.0631 22.0754 16.7195 21.982 16.5438 21.7277L16.5002 21.6544L15.3298 19.3444C15.1734 19.0357 15.3002 18.6602 15.613 18.5059Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M17.2054 2.23459C17.4041 1.98955 17.7515 1.93116 18.0183 2.08458L18.0956 2.13698L21.2623 4.63696C21.5354 4.85259 21.5797 5.24589 21.3612 5.51543C21.1626 5.76046 20.8151 5.81885 20.5484 5.66544L20.471 5.61304L17.3043 3.11306C17.0312 2.89743 16.9869 2.50412 17.2054 2.23459Z"
            })
        ]
    });
var $558a1874964eed3d$var$TimeSensitive$1 = $558a1874964eed3d$var$TimeSensitive;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$TransferArrows = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M18.345 11.47a.75.75 0 0 1 1.06 0l2.5 2.5a.754.754 0 0 1 .22.53l-.004-.074c.002.015.003.03.003.046l.001.028a.763.763 0 0 1-.129.42.748.748 0 0 1-.09.11l.068-.078a.75.75 0 0 1-.005.006l-.064.072-2.5 2.5a.75.75 0 0 1-1.06-1.06l1.219-1.22H10.75a.75.75 0 0 1-.743-.648L10 14.5a.75.75 0 0 1 .75-.75h8.814l-1.22-1.22a.75.75 0 0 1-.072-.976zm-13.75-5a.75.75 0 0 1 1.06 1.06l-1.22 1.22h8.815a.75.75 0 0 1 .743.648L14 9.5a.75.75 0 0 1-.75.75H4.435l1.22 1.22a.75.75 0 0 1 .073.976l-.073.084a.75.75 0 0 1-1.06 0l-2.5-2.5-.064-.072a.753.753 0 0 1-.156-.458l.004.077a.754.754 0 0 1-.004-.06V9.5a.765.765 0 0 1 .129-.42.748.748 0 0 1 .09-.11l-.068.078a.754.754 0 0 1 .069-.078z"
        })
    });
var $558a1874964eed3d$var$TransferArrows$1 = $558a1874964eed3d$var$TransferArrows;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$TrashSm = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1597 5.79996H3.84898C3.77048 5.79964 3.69548 5.83243 3.64241 5.89027C3.58935 5.94812 3.56312 6.02565 3.57019 6.10384L4.28779 13.9858C4.34 14.5602 4.82167 15.0001 5.39849 15H10.6102C11.187 15.0001 11.6687 14.5602 11.7209 13.9858L12.4374 6.10384C12.4443 6.02589 12.4182 5.9486 12.3654 5.89084C12.3127 5.833 12.238 5.80001 12.1597 5.79996ZM7.02992 13.0485C7.02992 13.2794 6.8427 13.4667 6.61174 13.4667C6.38078 13.4667 6.19356 13.2794 6.19356 13.0485V8.03028C6.19356 7.79932 6.38078 7.61209 6.61174 7.61209C6.8427 7.61209 7.02992 7.79932 7.02992 8.03028V13.0485ZM9.39971 13.4667C9.63067 13.4667 9.8179 13.2794 9.8179 13.0485V8.03028C9.8179 7.79932 9.63067 7.61209 9.39971 7.61209C9.16876 7.61209 8.98153 7.79932 8.98153 8.03028V13.0485C8.98153 13.2794 9.16876 13.4667 9.39971 13.4667Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12.7413 3.57178C12.052 3.25091 11.31 3.05814 10.5517 3.00287C10.412 2.43157 10.0846 1.92367 9.62201 1.56052C9.15938 1.19738 8.58826 1 8.00012 1C7.41199 1 6.84087 1.19738 6.37824 1.56052C5.9156 1.92367 5.58823 2.43157 5.44854 3.00287C4.71226 3.06124 3.99144 3.24539 3.31739 3.54734C3.14061 3.62229 2.98824 3.74508 2.87741 3.90188C2.76659 4.05869 2.7017 4.2433 2.69005 4.43497C2.68907 4.50535 2.70208 4.57522 2.72833 4.64053C2.75459 4.70584 2.79356 4.76528 2.84298 4.81539C2.89241 4.86551 2.9513 4.9053 3.01623 4.93246C3.08117 4.95962 3.15086 4.9736 3.22125 4.9736H12.7827C12.9222 4.97361 13.0562 4.91874 13.1555 4.82084C13.2549 4.72294 13.3118 4.58987 13.3139 4.45037C13.3097 4.26514 13.2538 4.08477 13.1527 3.92955C13.0515 3.77433 12.909 3.65043 12.7413 3.57178ZM7.98977 2.06266C8.27677 2.05709 8.55956 2.13227 8.80591 2.27963C9.05226 2.42698 9.25225 2.64059 9.38309 2.8961C8.46313 2.84247 7.54083 2.84247 6.62088 2.8961C6.74741 2.64237 6.94302 2.42953 7.1852 2.28208C7.42737 2.13463 7.70626 2.05857 7.98977 2.06266Z"
            })
        ]
    });
var $558a1874964eed3d$var$TrashSm$1 = $558a1874964eed3d$var$TrashSm;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Trash = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.5207 8.0625H5.4788C5.35561 8.062 5.23792 8.11346 5.15464 8.20424C5.07136 8.29501 5.03021 8.41669 5.0413 8.53938L6.16743 20.9084C6.24935 21.8099 7.00523 22.5001 7.91043 22.5H16.0891C16.9943 22.5001 17.7501 21.8099 17.8321 20.9084L18.9564 8.53938C18.9674 8.41706 18.9264 8.29576 18.8436 8.20513C18.7607 8.11435 18.6436 8.06259 18.5207 8.0625ZM10.4706 19.4375C10.4706 19.8 10.1768 20.0938 9.81436 20.0938C9.45193 20.0938 9.15811 19.8 9.15811 19.4375V11.5625C9.15811 11.2001 9.45193 10.9063 9.81436 10.9063C10.1768 10.9063 10.4706 11.2001 10.4706 11.5625V19.4375ZM14.1895 20.0938C14.5519 20.0938 14.8457 19.8 14.8457 19.4375V11.5625C14.8457 11.2001 14.5519 10.9063 14.1895 10.9063C13.8271 10.9063 13.5332 11.2001 13.5332 11.5625V19.4375C13.5332 19.8 13.8271 20.0938 14.1895 20.0938Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M19.4334 4.56586C18.3516 4.06232 17.1873 3.7598 15.9973 3.67308C15.7781 2.77653 15.2643 1.9795 14.5383 1.40962C13.8123 0.839742 12.9161 0.529999 11.9931 0.529999C11.0702 0.529999 10.1739 0.839742 9.44793 1.40962C8.72193 1.9795 8.20818 2.77653 7.98897 3.67308C6.83354 3.76467 5.70236 4.05366 4.64459 4.52751C4.36716 4.64513 4.12805 4.83781 3.95413 5.08388C3.78022 5.32996 3.6784 5.61967 3.66012 5.92044C3.65857 6.03089 3.67899 6.14055 3.72019 6.24303C3.76139 6.34552 3.82254 6.4388 3.90011 6.51744C3.97767 6.59609 4.07008 6.65854 4.17199 6.70116C4.27389 6.74378 4.38325 6.76572 4.49371 6.76571H19.4984C19.7173 6.76573 19.9275 6.67963 20.0835 6.52599C20.2394 6.37236 20.3287 6.16353 20.332 5.94462C20.3254 5.65394 20.2377 5.37089 20.079 5.12731C19.9202 4.88372 19.6966 4.68928 19.4334 4.56586ZM11.9769 2.19762C12.4273 2.18887 12.8711 2.30685 13.2576 2.5381C13.6442 2.76935 13.9581 3.10456 14.1634 3.50552C12.7197 3.42136 11.2724 3.42136 9.82871 3.50552C10.0273 3.10735 10.3342 2.77334 10.7143 2.54195C11.0943 2.31056 11.532 2.1912 11.9769 2.19762Z"
            })
        ]
    });
var $558a1874964eed3d$var$Trash$1 = $558a1874964eed3d$var$Trash;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$UserHousehold = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.84835 11.5983C5.55161 10.8951 6.50544 10.5 7.5 10.5C8.49456 10.5 9.44839 10.8951 10.1517 11.5983C10.8549 12.3016 11.25 13.2554 11.25 14.25C11.25 15.2446 10.8549 16.1984 10.1517 16.9017C9.44839 17.6049 8.49456 18 7.5 18C6.50544 18 5.55161 17.6049 4.84835 16.9017C4.14509 16.1984 3.75 15.2446 3.75 14.25C3.75 13.2554 4.14509 12.3016 4.84835 11.5983ZM7.5 12C6.90326 12 6.33097 12.2371 5.90901 12.659C5.48705 13.081 5.25 13.6533 5.25 14.25C5.25 14.8467 5.48705 15.419 5.90901 15.841C6.33097 16.2629 6.90326 16.5 7.5 16.5C8.09674 16.5 8.66903 16.2629 9.09099 15.841C9.51295 15.419 9.75 14.8467 9.75 14.25C9.75 13.6533 9.51295 13.081 9.09099 12.659C8.66903 12.2371 8.09674 12 7.5 12Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.31802 19.318C5.16193 18.4741 6.30653 18 7.5 18C8.69347 18 9.83807 18.4741 10.682 19.318C11.5259 20.1619 12 21.3065 12 22.5V23.25C12 23.6642 11.6642 24 11.25 24C10.8358 24 10.5 23.6642 10.5 23.25V22.5C10.5 21.7044 10.1839 20.9413 9.62132 20.3787C9.05871 19.8161 8.29565 19.5 7.5 19.5C6.70435 19.5 5.94129 19.8161 5.37868 20.3787C4.81607 20.9413 4.5 21.7044 4.5 22.5V23.25C4.5 23.6642 4.16421 24 3.75 24C3.33579 24 3 23.6642 3 23.25V22.5C3 21.3065 3.47411 20.1619 4.31802 19.318Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.8483 11.5983C14.5516 10.8951 15.5054 10.5 16.5 10.5C17.4946 10.5 18.4484 10.8951 19.1517 11.5983C19.8549 12.3016 20.25 13.2554 20.25 14.25C20.25 15.2446 19.8549 16.1984 19.1517 16.9017C18.4484 17.6049 17.4946 18 16.5 18C15.5054 18 14.5516 17.6049 13.8483 16.9017C13.1451 16.1984 12.75 15.2446 12.75 14.25C12.75 13.2554 13.1451 12.3016 13.8483 11.5983ZM16.5 12C15.9033 12 15.331 12.2371 14.909 12.659C14.4871 13.081 14.25 13.6533 14.25 14.25C14.25 14.8467 14.4871 15.419 14.909 15.841C15.331 16.2629 15.9033 16.5 16.5 16.5C17.0967 16.5 17.669 16.2629 18.091 15.841C18.5129 15.419 18.75 14.8467 18.75 14.25C18.75 13.6533 18.5129 13.081 18.091 12.659C17.669 12.2371 17.0967 12 16.5 12Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.6237 18.0874C16.4964 17.9141 17.4007 18.0034 18.2226 18.344C19.0445 18.6846 19.747 19.2611 20.2413 20.0008C20.7357 20.7404 20.9997 21.61 21 22.4997V23.2499C21 23.6641 20.6642 23.9999 20.25 23.9999C19.8358 23.9999 19.5 23.6641 19.5 23.2499V22.5002C19.5 22.5001 19.5 22.5003 19.5 22.5002C19.4997 21.9072 19.3237 21.3273 18.9942 20.8343C18.6647 20.3411 18.1963 19.9568 17.6484 19.7297C17.1005 19.5027 16.4976 19.4432 15.9158 19.5586C15.3341 19.6741 14.7996 19.9595 14.38 20.3786C14.0869 20.6713 13.612 20.671 13.3193 20.3779C13.0266 20.0848 13.0269 19.61 13.32 19.3173C13.9494 18.6886 14.7511 18.2606 15.6237 18.0874Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4697 0.21967C11.7626 -0.0732233 12.2374 -0.0732233 12.5303 0.21967L23.7803 11.4697C23.921 11.6103 24 11.8011 24 12V23.25C24 23.6642 23.6642 24 23.25 24C22.8358 24 22.5 23.6642 22.5 23.25V12.3107L12 1.81066L1.5 12.3107V23.25C1.5 23.6642 1.16421 24 0.75 24C0.335786 24 0 23.6642 0 23.25V12C0 11.8011 0.0790176 11.6103 0.21967 11.4697L11.4697 0.21967Z"
            })
        ]
    });
var $558a1874964eed3d$var$UserHousehold$1 = $558a1874964eed3d$var$UserHousehold;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ZoomIn = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M10.178 1.874a8.303 8.303 0 0 1 6.377 13.618l5.35 5.352a.75.75 0 0 1-1.06 1.06l-5.35-5.351a8.303 8.303 0 1 1-5.317-14.679zm0 1.5a6.803 6.803 0 1 0-.002 13.605 6.803 6.803 0 0 0 .001-13.605zm-.053 2.25a.75.75 0 0 1 .75.75v3h3a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.75.75h-3v3a.75.75 0 0 1-.648.743l-.102.007a.75.75 0 0 1-.75-.75v-3h-3a.75.75 0 0 1-.743-.648l-.007-.102a.75.75 0 0 1 .75-.75h3v-3a.75.75 0 0 1 .648-.743z"
        })
    });
var $558a1874964eed3d$var$ZoomIn$1 = $558a1874964eed3d$var$ZoomIn;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$ZoomOut = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M10.177 1.874a8.303 8.303 0 0 1 6.378 13.618l5.35 5.352a.75.75 0 0 1-1.06 1.06l-5.35-5.351a8.303 8.303 0 1 1-5.318-14.679zm0 1.5a6.802 6.802 0 1 0 0 13.605 6.802 6.802 0 0 0 0-13.605zm3.698 6a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5z"
        })
    });
var $558a1874964eed3d$var$ZoomOut$1 = $558a1874964eed3d$var$ZoomOut;
var $558a1874964eed3d$var$icons = {
    'ai-sparkle-sm': $558a1874964eed3d$var$AiSparkleSm$1(),
    'ai-sparkle': $558a1874964eed3d$var$AiSparkle$1(),
    'attachment-paperclip': $558a1874964eed3d$var$AttachmentPaperclip$1(),
    'avatar': $558a1874964eed3d$var$Avatar$3(),
    'building-generic': $558a1874964eed3d$var$BuildingGeneric$1(),
    'building-institution': $558a1874964eed3d$var$BuildingInstitution$1(),
    'calculator': $558a1874964eed3d$var$Calculator$1(),
    'caret-down': $558a1874964eed3d$var$CaretDown$1(),
    'caret-up': $558a1874964eed3d$var$CaretUp$1(),
    'checkmark-circle': $558a1874964eed3d$var$CheckmarkCircle$1(),
    'checkmark-fill': $558a1874964eed3d$var$CheckmarkFill$1(),
    'checkmark-square': $558a1874964eed3d$var$CheckmarkSquare$1(),
    'checkmark': $558a1874964eed3d$var$Checkmark$1(),
    'chevron-double-down': $558a1874964eed3d$var$ChevronDoubleDown$1(),
    'chevron-double-up': $558a1874964eed3d$var$ChevronDoubleUp$1(),
    'chevron-left': $558a1874964eed3d$var$ChevronLeft$1(),
    'chevron-right': $558a1874964eed3d$var$ChevronRight$1(),
    'close-sm': $558a1874964eed3d$var$CloseSm$1(),
    'close': $558a1874964eed3d$var$Close$1(),
    'compose-sm': $558a1874964eed3d$var$ComposeSm$1(),
    'compose': $558a1874964eed3d$var$Compose$1(),
    'configure': $558a1874964eed3d$var$Configure$1(),
    'contact-card': $558a1874964eed3d$var$ContactCard$1(),
    'credit-card': $558a1874964eed3d$var$CreditCard$1(),
    'data-download': $558a1874964eed3d$var$DataDownload$1(),
    'data-upload': $558a1874964eed3d$var$DataUpload$1(),
    'data-vis-bar-chart': $558a1874964eed3d$var$DataVisBarChart$1(),
    'data-vis-column-chart': $558a1874964eed3d$var$DataVisColumnChart$1(),
    'data-vis-combo-chart': $558a1874964eed3d$var$DataVisComboChart$1(),
    'data-vis-gain': $558a1874964eed3d$var$DataVisGain$1(),
    'data-vis-hierarchy': $558a1874964eed3d$var$DataVisHierarchy$1(),
    'data-vis-line-graph': $558a1874964eed3d$var$DataVisLineGraph$1(),
    'data-vis-loss': $558a1874964eed3d$var$DataVisLoss$1(),
    'data-vis-pie-chart': $558a1874964eed3d$var$DataVisPieChart$1(),
    'data-vis-trend-asc': $558a1874964eed3d$var$DataVisTrendAsc$1(),
    'data-vis-trend-desc': $558a1874964eed3d$var$DataVisTrendDesc$1(),
    'date-calendar': $558a1874964eed3d$var$DateCalendar$1(),
    'date-clock': $558a1874964eed3d$var$DateClock$1(),
    'directory-folder': $558a1874964eed3d$var$DirectoryFolder$1(),
    'document': $558a1874964eed3d$var$Document$1(),
    'drag': $558a1874964eed3d$var$Drag$1(),
    'duplicate': $558a1874964eed3d$var$Duplicate$1(),
    'edit-disabled-pencil': $558a1874964eed3d$var$EditDisabledPencil$1(),
    'edit-pencil-sm': $558a1874964eed3d$var$EditPencilSm$1(),
    'edit-pencil': $558a1874964eed3d$var$EditPencil$1(),
    'edit-redo': $558a1874964eed3d$var$EditRedo$1(),
    'edit-undo': $558a1874964eed3d$var$EditUndo$1(),
    'feedback-bubble': $558a1874964eed3d$var$FeedbackBubble$1(),
    'file-text-add': $558a1874964eed3d$var$FileTextAdd$1(),
    'file-text': $558a1874964eed3d$var$FileText$1(),
    'filter': $558a1874964eed3d$var$Filter$1(),
    'fullscreen-expand': $558a1874964eed3d$var$FullscreenExpand$1(),
    'grid-three': $558a1874964eed3d$var$GridThree$1(),
    'grid-two': $558a1874964eed3d$var$GridTwo$1(),
    'hamburger': $558a1874964eed3d$var$Hamburger$1(),
    'heart-filled': $558a1874964eed3d$var$HeartFilled$1(),
    'heart': $558a1874964eed3d$var$Heart$1(),
    'help-question-mark': $558a1874964eed3d$var$HelpQuestionMark$1(),
    'home': $558a1874964eed3d$var$Home$1(),
    'hyperlink-link': $558a1874964eed3d$var$HyperlinkLink$1(),
    'indent-left': $558a1874964eed3d$var$IndentLeft$1(),
    'indent-right': $558a1874964eed3d$var$IndentRight$1(),
    'lightbulb': $558a1874964eed3d$var$Lightbulb$1(),
    'list': $558a1874964eed3d$var$List$1(),
    'live-chat-associate': $558a1874964eed3d$var$LiveChatAssociate$1(),
    'live-chat-chatbot': $558a1874964eed3d$var$LiveChatChatbot$1(),
    'lock-locked': $558a1874964eed3d$var$LockLocked$1(),
    'lock-unlocked': $558a1874964eed3d$var$LockUnlocked$1(),
    'map-pin-large': $558a1874964eed3d$var$MapPinLarge$1(),
    'members-people': $558a1874964eed3d$var$MembersPeople$1(),
    'message-envelope': $558a1874964eed3d$var$MessageEnvelope$1(),
    'message-forward': $558a1874964eed3d$var$MessageForward$1(),
    'message-reply-all': $558a1874964eed3d$var$MessageReplyAll$1(),
    'message-reply': $558a1874964eed3d$var$MessageReply$1(),
    'message-send': $558a1874964eed3d$var$MessageSend$1(),
    'more-ellipsis-vertical': $558a1874964eed3d$var$MoreEllipsisVertical$1(),
    'more-ellipsis': $558a1874964eed3d$var$MoreEllipsis$1(),
    'new-window-sm': $558a1874964eed3d$var$NewWindowSm$1(),
    'new-window': $558a1874964eed3d$var$NewWindow$1(),
    'notice-error-fill': $558a1874964eed3d$var$NoticeErrorFill$1(),
    'notice-error': $558a1874964eed3d$var$NoticeError$1(),
    'notice-important': $558a1874964eed3d$var$NoticeImportant$1(),
    'notice-info': $558a1874964eed3d$var$NoticeInfo$1(),
    'notice-warning': $558a1874964eed3d$var$NoticeWarning$1(),
    'notify-off': $558a1874964eed3d$var$NotifyOff$1(),
    'notify-on': $558a1874964eed3d$var$NotifyOn$1(),
    'object-add-sm': $558a1874964eed3d$var$ObjectAddSm$1(),
    'object-add': $558a1874964eed3d$var$ObjectAdd$1(),
    'object-subtract-sm': $558a1874964eed3d$var$ObjectSubtractSm$1(),
    'object-subtract': $558a1874964eed3d$var$ObjectSubtract$1(),
    'phone-mobile': $558a1874964eed3d$var$PhoneMobile$1(),
    'phone': $558a1874964eed3d$var$Phone$1(),
    'print': $558a1874964eed3d$var$Print$1(),
    'protection-shield': $558a1874964eed3d$var$ProtectionShield$1(),
    'rating-star-empty': $558a1874964eed3d$var$RatingStarEmpty$1(),
    'rating-star-full': $558a1874964eed3d$var$RatingStarFull$1(),
    'rating-star-half': $558a1874964eed3d$var$RatingStarHalf$1(),
    'refresh-sync': $558a1874964eed3d$var$RefreshSync$1(),
    'search': $558a1874964eed3d$var$Search$1(),
    'settings-cog-sm': $558a1874964eed3d$var$SettingsCogSm$1(),
    'settings-cog': $558a1874964eed3d$var$SettingsCog$1(),
    'share': $558a1874964eed3d$var$Share$1(),
    'sort-asc': $558a1874964eed3d$var$SortAsc$1(),
    'sort-desc': $558a1874964eed3d$var$SortDesc$1(),
    'sortable': $558a1874964eed3d$var$Sortable$1(),
    'table': $558a1874964eed3d$var$Table$3(),
    'tag': $558a1874964eed3d$var$Tag$3(),
    'time-sensitive': $558a1874964eed3d$var$TimeSensitive$1(),
    'transfer-arrows': $558a1874964eed3d$var$TransferArrows$1(),
    'trash-sm': $558a1874964eed3d$var$TrashSm$1(),
    'trash': $558a1874964eed3d$var$Trash$1(),
    'user-household': $558a1874964eed3d$var$UserHousehold$1(),
    'zoom-in': $558a1874964eed3d$var$ZoomIn$1(),
    'zoom-out': $558a1874964eed3d$var$ZoomOut$1()
};
/* eslint-disable import/prefer-default-export */ const $558a1874964eed3d$var$defaultFilter = (className)=>typeof className === 'string';
const $558a1874964eed3d$var$normalizeClassList = (classList)=>{
    const isArray = classList instanceof Array;
    if (typeof classList === 'object' && !isArray) {
        const defaultClasses = $558a1874964eed3d$var$normalizeClassList(classList.default);
        const customClasses = $558a1874964eed3d$var$normalizeClassList(classList.custom);
        const requiredClasses = $558a1874964eed3d$var$normalizeClassList(classList.required);
        return [
            ...defaultClasses,
            ...customClasses,
            ...requiredClasses
        ];
    }
    if (typeof classList === 'undefined') return [
        ''
    ];
    return classList instanceof Array ? classList : [
        classList
    ];
};
const $558a1874964eed3d$var$createClassList = (classList, filter)=>{
    const modifiedClassList = $558a1874964eed3d$var$normalizeClassList(classList);
    const classFilter = typeof filter !== 'function' ? $558a1874964eed3d$var$defaultFilter : filter;
    return modifiedClassList.filter(classFilter).join(' ').trim();
};
const $558a1874964eed3d$var$Icon$1 = ({ name: name, id: id, seenByAssistiveTechnology: seenByAssistiveTechnology = false, altText: altText = null, classes: classes = [] })=>{
    const classNames = [
        'axiom-icon',
        'icon',
        `axiom-icon--${name}`,
        `icon--${name}`
    ];
    const a11yText = altText || `${name} icon`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        id: id,
        "data-testid": "uxd-icon",
        role: !seenByAssistiveTechnology ? 'presentation' : 'img',
        className: $558a1874964eed3d$var$createClassList({
            default: classNames,
            custom: classes,
            required: []
        }),
        ...!seenByAssistiveTechnology ? {
            'aria-hidden': 'true'
        } : {
            'aria-label': a11yText
        },
        children: $558a1874964eed3d$var$icons[name] || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: "Icon Not Found"
        })
    });
};
$558a1874964eed3d$var$Icon$1.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    seenByAssistiveTechnology: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    altText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$Icon$2 = $558a1874964eed3d$var$Icon$1;
const $558a1874964eed3d$var$Label$1 = ({ label: label, labelForId: labelForId, error: error, hideLabel: hideLabel = false, labelModifier: labelModifier = null, ariaLabel: ariaLabel, className: className, classes: classes = [], labelClickHandler: labelClickHandler })=>{
    let requiredClasses = [];
    if (error) requiredClasses = [
        ...requiredClasses,
        'input-label--error'
    ];
    if (hideLabel) requiredClasses = [
        ...requiredClasses,
        'input-label--hidden'
    ];
    function validateLabel() {
        if (!label.trim()) throw new Error('Empty label not valid, label must contain actual text.');
        return label;
    }
    return /*#__PURE__*/ /* eslint-disable jsx-a11y/click-events-have-key-events  */ /* eslint-disable jsx-a11y/no-noninteractive-element-interactions  */ (0, $ayMG0.jsxs)("label", {
        htmlFor: labelForId,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-input-label input-label',
                `${className || ''}`
            ],
            // Note: className prop included to avoid breaking change
            custom: classes,
            required: requiredClasses
        }),
        "aria-label": ariaLabel,
        onClick: labelClickHandler,
        children: [
            error && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                name: "notice-error"
            }),
            labelModifier === 'required' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "input-label--required",
                "aria-hidden": "true",
                children: "*"
            }),
            validateLabel(),
            labelModifier === 'optional' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "input-label--optional",
                children: ' (Optional)'
            })
        ]
    });
};
$558a1874964eed3d$var$Label$1.propTypes = {
    labelForId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    labelClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$LabelJSX = $558a1874964eed3d$var$Label$1;
const $558a1874964eed3d$var$InputControl = ({ id: id, label: label, children: children, error: error, hideLabel: hideLabel, classes: classes = [], labelModifier: labelModifier = null, microcopy: microcopy, microcopyScreenReader: microcopyScreenReader, ariaLabel: ariaLabel })=>{
    let requiredClasses = [];
    if (error) requiredClasses = [
        ...requiredClasses,
        'input-control--error'
    ];
    // Store a reference to the element whose "id" attribute corresponds to the "htmlFor" prop on the <Label> component. We'll only use this in the uncommon case where we need to replicate the browser default behavior on non-native input elements.
    const [labelTarget, setLabelTarget] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const domField = document.getElementById(id);
        setLabelTarget(domField);
    }, []);
    const handleLabelClick = ()=>{
        // Replicate browser default behavior where clicking on a <label> with a 'for' attribute corresponding to an input 'id' focuses that input.
        if (labelTarget !== null) // Only do something if the associated input is not an actual input element but needs to behave like one (e.g. SelectInput).
        {
            if (labelTarget.nodeName !== 'INPUT') labelTarget.focus();
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "input-control",
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'input-control'
            ],
            custom: classes || [],
            required: requiredClasses
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$LabelJSX, {
                error: error,
                hideLabel: hideLabel,
                label: label,
                labelForId: id,
                labelModifier: labelModifier,
                ariaLabel: ariaLabel,
                labelClickHandler: handleLabelClick
            }),
            children,
            error || microcopy ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                id: `${id}_messages`,
                className: "input-control--messages",
                children: [
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        id: `${id}_error`,
                        className: "input-control--error--message",
                        children: error
                    }, `${id}_error`),
                    !error && microcopy && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": !!microcopyScreenReader,
                                id: `${id}_microcopy`,
                                className: "input-control--microcopy",
                                children: microcopy
                            }, `${id}_microcopy`),
                            microcopyScreenReader && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                id: `${id}-microcopy-sr-only`,
                                className: "screen-reader-only",
                                children: microcopyScreenReader
                            }, `${id}-microcopy-sr-only`)
                        ]
                    })
                ]
            }) : null
        ]
    });
};
$558a1874964eed3d$var$InputControl.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopyScreenReader: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$InputControl$1 = $558a1874964eed3d$var$InputControl;
const $558a1874964eed3d$var$AutocompleteInputSingleValue = ({ condensed: condensed, data: data, onClear: onClear })=>{
    const singleValueClasses = [
        'axiom-search-input--single-value search-input--single-value'
    ];
    const buttonClasses = [
        'axiom-search-input--button search-input--button'
    ];
    if (condensed) {
        singleValueClasses.push('search-input--condensed');
        buttonClasses.push('button-condensed');
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: singleValueClasses.join(' '),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: data.label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                "data-testid": "close-button",
                onClick: onClear,
                "aria-label": `delete ${data.label}`,
                className: buttonClasses.join(' '),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                    name: "trash-sm"
                })
            })
        ]
    });
};
$558a1874964eed3d$var$AutocompleteInputSingleValue.propTypes = {
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }).isRequired,
    onClear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $558a1874964eed3d$var$AutocompleteInputSingleValue$1 = $558a1874964eed3d$var$AutocompleteInputSingleValue;
/**
 * NOTICE NOTICE NOTICE
 *
 * ESLint rule 'react/no-unstable-nested-components' was disabled for the line where prop `components.SingleValue` is passed to <Select> to prevent breaking the AutocompleteInput component. Please consider refactoring the code to fix the issue that ESLint flagged. The error message is pasted below:
 *
 * Do not define components during render. React will see a new component type on every render and destroy the entire subtree’s DOM nodes and state (https://reactjs.org/docs/reconciliation.html#elements-of-different-types). Instead, move this component definition out of the parent component “AutocompleteInput” and pass data as props. If you want to allow component creation in props, set allowAsProps option to true  react/no-unstable-nested-components
 *
 */ const $558a1874964eed3d$var$Select = (0, $a3QyA.default).default ? (0, $a3QyA.default).default : (0, $a3QyA.default);
const $558a1874964eed3d$var$AutocompleteInput$1 = ({ id: id, label: label, name: name, value: value, options: options, onChange: onChange, labelModifier: labelModifier, disabled: disabled = false, condensed: condensed = false, readOnly: readOnly = false, error: error, microcopy: microcopy, inputRef: inputRef, hideLabel: hideLabel = false, attributes: attributes = {}, classes: modifierClasses = [] })=>{
    const [minCharLimitMet, setMinCharLimitMet] = (0, $acw62.useState)(false);
    const customStyles = {
        valueContainer: ()=>({}),
        option: ()=>({}),
        control: ()=>({}),
        input: ()=>({})
    };
    (0, $acw62.useEffect)(()=>{
        setMinCharLimitMet(value.length >= 2);
    }, []);
    const isDisplaySelect = !readOnly && !disabled;
    const formatOptions = typeof options[0] === 'string' ? options.map((option)=>({
            value: option,
            label: option
        })) : options;
    const newValue = formatOptions.find((option)=>option.value === value);
    const checkValueTypeObject = typeof newValue === 'object' ? newValue : null;
    const checkValueTypeString = typeof value === 'string' ? value : null;
    const displayValueObject = checkValueTypeObject === null ? {
        value: value.value,
        label: value.label
    } : checkValueTypeObject;
    const displayValueString = checkValueTypeString === null ? value : {
        value: value,
        label: value
    };
    const displayValueOrString = checkValueTypeObject !== null ? displayValueObject : displayValueString;
    const inputClasses = condensed ? 'input-control--input--wrap input-control--condensed' : 'input-control--input--wrap';
    const normalizedPropClasses = modifierClasses instanceof Array ? modifierClasses : [
        modifierClasses
    ];
    const controllerClasses = [
        'axiom-autocomplete-input',
        ...normalizedPropClasses
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$InputControl$1, {
        id: id,
        classes: controllerClasses,
        label: label,
        labelModifier: labelModifier,
        error: error,
        microcopy: microcopy,
        hideLabel: hideLabel,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            "data-testid": "wrap",
            className: inputClasses,
            children: isDisplaySelect ? /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Select, {
                styles: customStyles,
                onChange: (opt)=>{
                    if (opt != null) onChange(opt.value);
                },
                placeholder: microcopy,
                className: "axiom-autocomplete-input--select-container react-select-container",
                classNamePrefix: "react-select",
                value: displayValueOrString.label !== '' ? displayValueOrString : null,
                inputId: id,
                options: minCharLimitMet ? formatOptions : [],
                onInputChange: (s)=>setMinCharLimitMet(s.length >= 2),
                noOptionsMessage: ()=>!minCharLimitMet ? null : 'No Results',
                "aria-errormessage": `${id}_messages`,
                isClearable: true,
                isDisabled: disabled,
                "aria-invalid": error ? true : undefined,
                components: {
                    // eslint-disable-next-line react/no-unstable-nested-components, react/prop-types
                    SingleValue: ({ data: data })=>/*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$AutocompleteInputSingleValue$1, {
                            condensed: condensed,
                            data: data,
                            onClear: ()=>{
                                onChange('');
                            }
                        })
                },
                ref: inputRef
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                id: id,
                "data-testid": "input",
                name: name,
                value: checkValueTypeObject !== null ? displayValueObject.label : displayValueString.label,
                "aria-invalid": error ? true : undefined,
                disabled: disabled,
                readOnly: readOnly,
                "aria-describedby": `${id}_messages`,
                type: "search",
                className: "axiom-autocomplete-input--input",
                ref: inputRef,
                ...attributes
            })
        })
    });
};
$558a1874964eed3d$var$AutocompleteInput$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ]).isRequired,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ])).isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$AutocompleteInputJSX = $558a1874964eed3d$var$AutocompleteInput$1;
var $558a1874964eed3d$export$909904bdb4cb4458 = function(_a) {
    var id = _a.id, label = _a.label, name = _a.name, value = _a.value, options = _a.options, onChange = _a.onChange, _b = _a.labelModifier, labelModifier = _b === void 0 ? undefined : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.condensed, condensed = _d === void 0 ? false : _d, _e = _a.readOnly, readOnly = _e === void 0 ? false : _e, _f = _a.error, error = _f === void 0 ? undefined : _f, _g = _a.microcopy, microcopy = _g === void 0 ? undefined : _g, _h = _a.inputRef, inputRef = _h === void 0 ? undefined : _h, _j = _a.hideLabel, hideLabel = _j === void 0 ? false : _j, _k = _a.attributes, attributes = _k === void 0 ? {} : _k, _l = _a.classes, classes = _l === void 0 ? [] : _l;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$AutocompleteInputJSX, {
        id: id,
        classes: classes,
        label: label,
        name: name,
        value: value,
        labelModifier: labelModifier,
        condensed: condensed,
        disabled: disabled,
        readOnly: readOnly,
        error: error,
        microcopy: microcopy,
        options: options,
        onChange: onChange,
        inputRef: inputRef,
        hideLabel: hideLabel,
        attributes: attributes
    });
};
$558a1874964eed3d$export$909904bdb4cb4458.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ]).isRequired,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ])).isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$renderInitials = (name)=>name.split(/\s/).map((subName)=>subName.substring(0, 1).toUpperCase()).filter((sn)=>!!sn).slice(0, 2).join('').toUpperCase();
const $558a1874964eed3d$var$Avatar$1 = ({ variant: variant = 'icon', name: name = '', size: size = 'default', image: image, standalone: standalone = true, customAriaLabel: customAriaLabel, classes: classes = [] })=>{
    const imageUrl = {
        backgroundImage: `url(${image})`
    };
    const ariaLabel = standalone ? customAriaLabel || `${name}'s avatar` : undefined;
    const avatarAltText = customAriaLabel || `avatar component's avatar`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "avatar-wrap",
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-avatar',
                'avatar-container',
                `avatar-${size}`,
                `avatar-container-${variant}`
            ],
            custom: classes,
            required: []
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "axiom-avatar--wrapper avatar-wrapper",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "axiom-avatar--wrapper-inner avatar-wrapper-inner",
                style: variant === 'image' ? imageUrl : {},
                children: [
                    variant === 'icon' && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                        seenByAssistiveTechnology: true,
                        altText: avatarAltText,
                        name: "avatar"
                    }),
                    variant === 'entity' && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                        seenByAssistiveTechnology: true,
                        altText: avatarAltText,
                        name: "building-generic"
                    }),
                    [
                        'name',
                        'entity-name'
                    ].includes(variant) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                "aria-hidden": true,
                                className: "axiom-avatar--initial avatar-initial",
                                children: $558a1874964eed3d$var$renderInitials(name)
                            }),
                            standalone && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "data-testid": "aria-label",
                                className: "screen-reader-only",
                                children: ariaLabel
                            })
                        ]
                    }),
                    variant === 'image' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: image,
                        "aria-label": ariaLabel,
                        className: "axiom-avatar--image"
                    })
                ]
            })
        })
    });
};
$558a1874964eed3d$var$Avatar$1.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'default',
        'x-large',
        'xx-large'
    ]),
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'icon',
        'name',
        'image',
        'entity',
        'entity-name'
    ]),
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    image: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    standalone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    customAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$AvatarJSX = $558a1874964eed3d$var$Avatar$1;
var $558a1874964eed3d$export$e2255cf6045e8d47 = function(_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'icon' : _b, _c = _a.name, name = _c === void 0 ? '' : _c, _d = _a.size, size = _d === void 0 ? 'default' : _d, _e = _a.image, image = _e === void 0 ? undefined : _e, _f = _a.standalone, standalone = _f === void 0 ? true : _f, _g = _a.customAriaLabel, customAriaLabel = _g === void 0 ? undefined : _g, _h = _a.classes, classes = _h === void 0 ? [] : _h;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$AvatarJSX, {
        variant: variant,
        name: name,
        size: size,
        image: image,
        standalone: standalone,
        customAriaLabel: customAriaLabel,
        classes: classes
    });
};
$558a1874964eed3d$export$e2255cf6045e8d47.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'default',
        'x-large',
        'xx-large'
    ]),
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'icon',
        'name',
        'image',
        'entity',
        'entity-name'
    ]),
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    image: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    standalone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    customAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$DataVizLegend = /*#__PURE__*/ (0, $acw62.forwardRef)(({ title: title, description: description, classes: classes = [] }, refs)=>{
    const titleRef = refs ? refs.titleRef : null;
    const descriptionRef = refs ? refs.descriptionRef : null;
    const HeadingLevel = `h${title.headingSize === undefined ? '3' : title.headingSize}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
        "data-testid": "dataViz-legend",
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-data-viz-legend',
                'dataViz-legend'
            ],
            custom: classes,
            required: []
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(HeadingLevel, {
                className: "axiom-data-viz-legend--title dataViz-title",
                id: title.id,
                ref: titleRef,
                children: title.label === undefined ? title : title.label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "axiom-data-viz-legend--description dataViz-description",
                id: description.id,
                ref: descriptionRef,
                children: description.label === undefined ? description : description.label
            })
        ]
    });
});
$558a1874964eed3d$var$DataVizLegend.displayName = 'DataVizLegend';
$558a1874964eed3d$var$DataVizLegend.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            headingSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                1,
                2,
                3,
                4,
                5,
                6
            ]),
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
        })
    ]),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
        })
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$DataVizLegend$1 = $558a1874964eed3d$var$DataVizLegend;
const $558a1874964eed3d$var$EMPTY_CHART_DIMENSIONS = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
};
/**
 * Initialize the "valueFields" prop from Data-Viz components so that the field produces a consistent property map that subsequent functions can utilitze.
 * 
 * @param { String | { 
 *    id: String, 
 *    label?: String 
 * }[]} valueFields: The passed in valueField prop sent to the DataViz component to be normalized into the object variant (with id and label)
 * 
 * @returns {{
 *    id: String,
 *    label: String
 * }[]}
 */ const $558a1874964eed3d$var$initializeValueFields = (valueFields)=>valueFields.map((field)=>{
        if (typeof field === 'string') return {
            id: field,
            label: field
        };
        return field;
    });
/**
 * Returns the central position of the DOM label, used for calculating the position of data points relative to a given label. 
 * 
 * @returns The position of the label along it's respective axis
 */ const $558a1874964eed3d$var$getCentralLabelPosition = ({ orientation: orientation, label: label, offset: offset })=>{
    if (label) {
        if (orientation === 'horizontal') return label.x + label.width / 2 - offset;
        if (orientation === 'vertical') return label.y + label.height / 2 - offset;
    }
    return 0;
};
/**
 * Returns the width of current chart, used for calculations that depend on getting an accurate size of the current chart. 
 * 
 * @returns the width of the current chart
 */ const $558a1874964eed3d$var$getChartWidth = ({ horizontalLabels: horizontalLabels, horizontalOffset: horizontalOffset })=>{
    const firstLabel = horizontalLabels[0];
    const lastLabel = horizontalLabels[horizontalLabels.length - 1];
    const width = $558a1874964eed3d$var$getCentralLabelPosition({
        orientation: 'horizontal',
        label: lastLabel,
        offset: horizontalOffset
    }) - $558a1874964eed3d$var$getCentralLabelPosition({
        orientation: 'horizontal',
        label: firstLabel,
        offset: horizontalOffset
    });
    return width;
};
/**
 * Internal Utility Function that assists in returning chart meta data tied to the chart's segment labels.
 *
 * @param {{
 *  adjustedRange:
 * }}
 */ const $558a1874964eed3d$var$getSegmentLabels = ({ adjustedRange: adjustedRange, orientation: orientation, horizontalLabels: horizontalLabels, verticalLabels: verticalLabels, horizontalOffset: horizontalOffset, verticalOffset: verticalOffset })=>{
    const segmentLabels = [];
    const plotSegments = adjustedRange.segments.length - 1;
    const offset = orientation === 'horizontal' ? verticalOffset : horizontalOffset;
    for(let index = 0; index <= plotSegments; index++){
        const position = $558a1874964eed3d$var$getCentralLabelPosition({
            orientation: orientation === 'horizontal' ? 'vertical' : 'horizontal',
            offset: offset,
            label: orientation === 'horizontal' ? verticalLabels[index] : horizontalLabels[index]
        });
        segmentLabels.push({
            value: adjustedRange.segments[index],
            position: position
        });
    }
    return segmentLabels;
};
const $558a1874964eed3d$var$getSeriesOffset = ({ orientation: orientation, horizontalLabels: horizontalLabels })=>{
    if (orientation === 'vertical' && horizontalLabels[0]) return horizontalLabels[0].width / 2;
    return 0;
};
/**
 * Extracts the plot data to be passed back to the main data viz chart component
 * 
 * @returns {{
 *  xLabel: Object,
 *  yLabel: Object,
 *  plotPoints: Array,
 *  dataValues: Array
 * }}
 */ const $558a1874964eed3d$var$extractPlotData = ({ adjustedRange: adjustedRange, data: data, labelField: labelField, valueFields: valueFields, width: width, height: height, horizontalLabels: horizontalLabels, horizontalOffset: horizontalOffset, verticalLabels: verticalLabels, verticalOffset: verticalOffset, orientation: orientation, segmentLabels: segmentLabels })=>{
    let xLabels;
    let yLabels;
    const plotPoints = {};
    const seriesLabels = [];
    const dataValues = {};
    const valueFieldList = $558a1874964eed3d$var$initializeValueFields(valueFields);
    const segmentAxisLabel = orientation === 'horizontal' ? horizontalLabels : verticalLabels;
    const segmentOffset = orientation === 'horizontal' ? horizontalOffset : verticalOffset;
    const segmentPositionType = orientation === 'horizontal' ? 'x' : 'y';
    const seriesPositionType = orientation === 'horizontal' ? 'y' : 'x';
    const segmentSizeType = orientation === 'horizontal' ? 'width' : 'height';
    const seriesChartSize = orientation === 'horizontal' ? height : width;
    const dataSize = data.length;
    const seriesOffset = $558a1874964eed3d$var$getSeriesOffset({
        orientation: orientation,
        horizontalLabels: horizontalLabels
    });
    data.forEach((entry, index)=>{
        const segmentIndex = orientation === 'horizontal' ? index : dataSize - index - 1;
        const segmentLabel = segmentAxisLabel[segmentIndex] || $558a1874964eed3d$var$EMPTY_CHART_DIMENSIONS;
        const segmentPosition = segmentLabel[segmentPositionType] + segmentLabel[segmentSizeType] / 2 - segmentOffset;
        seriesLabels.push(entry[labelField]);
        valueFieldList.forEach((field)=>{
            if (typeof plotPoints[field.id] === 'undefined') plotPoints[field.id] = [];
            if (typeof dataValues[field.id] === 'undefined') dataValues[field.id] = [];
            const seriesPosition = seriesChartSize * (entry[field.id] - adjustedRange.min) / adjustedRange.distance + seriesOffset;
            const plotPoint = {};
            plotPoint[segmentPositionType] = segmentPosition;
            plotPoint[seriesPositionType] = seriesPosition;
            plotPoints[field.id].push(plotPoint);
            dataValues[field.id].push(entry[field.id]);
        });
    });
    if (orientation === 'horizontal') {
        xLabels = seriesLabels;
        yLabels = segmentLabels;
    } else if (orientation === 'vertical') {
        xLabels = segmentLabels;
        yLabels = seriesLabels;
    }
    return {
        xLabels: xLabels,
        yLabels: yLabels,
        plotPoints: plotPoints,
        dataValues: dataValues
    };
};
/**
 * Returns plot metadata to be passed back to the main data viz chart component. This is used to help construct the axis labels and 
 * organize the chart data into relevant data points that power the chart renderers.
 * 
 * @returns {{
 *  xLabel: Object,
 *  yLabel: Object,
 *  plotPoints: Array,
 *  dataValues: Array
 * }}
 */ const $558a1874964eed3d$var$getChartMetadata = ({ adjustedRange: adjustedRange, data: data, labelField: labelField, valueFields: valueFields, chartPadding: chartPadding = 0, height: height = 0, horizontalLabels: horizontalLabels = [], horizontalOffset: horizontalOffset = 0, verticalLabels: verticalLabels = [], verticalOffset: verticalOffset = 0, orientation: orientation = 'horizontal' })=>{
    const props = {
        adjustedRange: adjustedRange,
        data: data,
        labelField: labelField,
        valueFields: valueFields,
        chartPadding: chartPadding,
        height: height,
        horizontalLabels: horizontalLabels,
        horizontalOffset: horizontalOffset,
        verticalLabels: verticalLabels,
        verticalOffset: verticalOffset,
        orientation: orientation
    };
    const width = $558a1874964eed3d$var$getChartWidth(props);
    const segmentLabels = $558a1874964eed3d$var$getSegmentLabels({
        ...props,
        width: width
    });
    const plotData = $558a1874964eed3d$var$extractPlotData({
        ...props,
        width: width,
        segmentLabels: segmentLabels
    });
    return plotData;
};
const $558a1874964eed3d$var$UNIT_SCALARS = [
    '',
    'K',
    'M',
    'B',
    'T'
];
const $558a1874964eed3d$var$UNIT_DECORATORS = [
    '$',
    '%',
    ','
];
const $558a1874964eed3d$var$getValueWithUnits = (value, valueType)=>{
    let returnValue = value;
    switch(valueType){
        case 'percent':
            returnValue = `${value}%`;
            break;
        case 'dollar':
        case 'currency':
            if (String(value).charAt(0) === '-') returnValue = `-$${value.substring(1)}`;
            else returnValue = `$${value}`;
            break;
        default:
            returnValue = value;
            break;
    }
    return returnValue;
};
const $558a1874964eed3d$var$getScaledValue = (value, valueType)=>{
    const digitCount = String(Math.round(value)).length;
    const segmentLabelIndex = Math.floor((digitCount - 1) / 3);
    const valueLabel = $558a1874964eed3d$var$UNIT_SCALARS[segmentLabelIndex];
    const scaledValue = value / 10 ** (3 * segmentLabelIndex);
    const scaledValueText = `${scaledValue}${valueLabel}`;
    if (typeof valueType !== 'undefined') return $558a1874964eed3d$var$getValueWithUnits(scaledValueText, valueType);
    return scaledValueText;
};
const $558a1874964eed3d$var$getNumericStringValue = (value)=>{
    const decoratorRegexFragment = $558a1874964eed3d$var$UNIT_DECORATORS.join('|');
    const decoratorRegex = new RegExp(`[${decoratorRegexFragment}]`, 'g');
    return String(value).replace(decoratorRegex, '');
};
const $558a1874964eed3d$var$getRawValue = (value)=>{
    if (typeof value === 'undefined') return Number.NaN;
    const rawValue = $558a1874964eed3d$var$getNumericStringValue(value);
    const scalarUnit = rawValue.slice(-1);
    if ($558a1874964eed3d$var$UNIT_SCALARS.includes(scalarUnit)) {
        const number = parseFloat(rawValue.slice(0, -1), 10);
        const scalarPower = 3 * $558a1874964eed3d$var$UNIT_SCALARS.indexOf(scalarUnit);
        return number * 10 ** scalarPower;
    }
    return parseFloat(rawValue, 10);
};
const $558a1874964eed3d$var$preciseRound = (value, precision)=>{
    if (value === '') return null;
    const roundingScale = 10 ** precision;
    return Math.round(value * roundingScale) / roundingScale;
};
const $558a1874964eed3d$var$zeroFill = (number, precision)=>{
    let leadingZeroes = '';
    for(let zeroCount = precision; zeroCount > 0; zeroCount--)leadingZeroes += '0';
    return `${leadingZeroes}${number}`.slice(precision * -1);
};
const $558a1874964eed3d$var$formatValue = (value, valueType, precision)=>{
    if (value === '') return '';
    const formattedValue = Number(value).toLocaleString('en-US', {
        minimumFractionDigits: precision
    });
    return $558a1874964eed3d$var$getValueWithUnits(formattedValue, valueType);
};
const $558a1874964eed3d$var$EXPANSION_PRIORITY = [
    'no-limit',
    'loose',
    'strict'
];
const $558a1874964eed3d$var$CHART_CONTENT_RATIO = 3 / 4;
const $558a1874964eed3d$var$PRECISION_ROUNDING = 1;
const $558a1874964eed3d$var$DEFAULT_RANGE_PROPS = {
    expansionRule: 'loose'
};
/**
 * Internal helper function used to calculate the range of data points within the current graph.
 *
 * @param {Object} data: The raw used to calculate the data range of the DataViz component
 * @param {Array<{
 *    id: String,
 *    label: String
 * }>} valueFieldList: A normalized list of value fields (usually passed in from the initializeValueFields() function)
 *
 * @returns {{
 *    min: number,
 *    max: number
 * }}
 */ const $558a1874964eed3d$var$getDataRange = (data, valueFieldList)=>{
    const dataRange = {
        min: null,
        max: null
    };
    data.forEach((entry)=>{
        valueFieldList.forEach((field)=>{
            const value = entry[field.id];
            // If no range has been set yet, then we set the min and max to the current value
            // (this will usually be the first entry of our data collection)
            if (dataRange.min === null) // eslint-disable-next-line no-multi-assign
            dataRange.min = dataRange.max = value;
            else {
                dataRange.min = Math.min(dataRange.min, value);
                dataRange.max = Math.max(dataRange.max, value);
            }
        });
    });
    return dataRange;
};
/**
 * Internal function used to capture the min/max value of the supplied ranges.
 *
 * @param {'min'|'max'} propName: The type of value we are attempting to collect from the passed in range collection
 * @param {{
 *    min?: number,
 *    max?: number
 * }} dataRange: The range calculated from the data points passed into the DataViz component
 * @param {{
 *    min?: number,
 *    max?: number
 * }} initRange: The range calcuated using the range properties passed into the DataViz component that places limitations
 *               on how graph is allowed to expand
 *
 * @returns {number}
 */ const $558a1874964eed3d$var$getRangeProp = (propName, dataRange, initRange)=>{
    // If no restrictions are passed in from the initial range, that we pass forward the computed range from the dataset
    if (typeof initRange[propName].value === 'undefined') return dataRange[propName];
    return Math[propName](initRange[propName].value, dataRange[propName]);
};
/**
 * Internal function used to assign a weight for the passed in expansion rule
 *
 * @param {String} expansionRule: The name of the expansion rule being translated into it's assigned expansion priority weight
 *                                (lower weight = higher expansion priority)
 * @returns {Number}
 */ const $558a1874964eed3d$var$getExpansionPriority = (expansionRule)=>$558a1874964eed3d$var$EXPANSION_PRIORITY.indexOf(expansionRule);
/**
 * Internal function used to determine the power scale of the projected range. This function returns a number used to determine the
 * overall size of each segment such that:
 *
 *    segmentSize = 10 ^ n; where n is the returned value of this function
 *
 * @param {{
 *    min: number,
 *    max: number,
 *    distance: number
 * }} adjustedRange: The adjusted chart range after factoring expansion rules and dataset restrictions
 *
 * @returns {number}
 */ const $558a1874964eed3d$var$getSegmentScalePower = (adjustedRange)=>{
    let segmentScalePower;
    const segmentScaleValue = adjustedRange.distance > 0 ? adjustedRange.distance : adjustedRange.max;
    if (segmentScaleValue >= 1) segmentScalePower = String(Math.round(segmentScaleValue)).length - $558a1874964eed3d$var$PRECISION_ROUNDING;
    else if (segmentScaleValue > 0) segmentScalePower = -1 * (Array.from(String(segmentScaleValue).split('.')[1]).findIndex((distanceChar)=>distanceChar !== '0') + 1);
    // if the resulting power scale would produce only 2 segments for the current chart, we reduce the scale by 1, effectively
    // increasing our segment count 10-fold
    if (adjustedRange.distance / 10 ** segmentScalePower < 2) // eslint-disable-next-line no-plusplus
    segmentScalePower--;
    return segmentScalePower;
};
/**
 * Internal helper function used to expand the range to the target chart:content ratio, using expansion rules to determine how the range should expand to
 * accomodate all data points while attempting to preserve the expected range for our chart.
 *
 * @param {{
 *    dataRange: {
 *      min: number,
 *      max: number
 *    },
 *    adjustedRange: {
 *      min: number,
 *      max: number
 *    },
 *    initRange: {
 *      min?: {
 *        value: number,
 *        expansionRule: String
 *      },
 *      max?: {
 *        value: number,
 *        expansionRule: String
 *      },
 *    }
 * }}
 *
 * @returns {{
 *    min: number,
 *    max: number,
 *    distance: number
 * }}
 */ const $558a1874964eed3d$var$expandToContentRatio = ({ dataRange: dataRange, adjustedRange: adjustedRange, initRange: initRange })=>{
    const dataRangeDistance = dataRange.max - dataRange.min;
    const targetRangeDistance = dataRangeDistance / $558a1874964eed3d$var$CHART_CONTENT_RATIO;
    const rangeDistance = adjustedRange.max - adjustedRange.min;
    // if the current range distance falls below are target range, we need to expand it to (or above) the target
    if (rangeDistance < targetRangeDistance) {
        const rangeShortfall = targetRangeDistance - rangeDistance;
        const minExpansionPriority = $558a1874964eed3d$var$getExpansionPriority(initRange.min.expansionRule);
        const maxExpansionPriority = $558a1874964eed3d$var$getExpansionPriority(initRange.max.expansionRule);
        // Expansion direction will determine how the chart will expand to accomodate our targeted range distance.
        //    -1: Favors Upward (Positive) expansion
        //     0: Favors Equal expansion
        //     1: Favors Downward (Negative) expansion
        const expansionDirection = minExpansionPriority - maxExpansionPriority;
        if (expansionDirection > -1) {
            let maxAdjustment = rangeShortfall;
            if (expansionDirection === 0) maxAdjustment /= 2;
            adjustedRange.max += maxAdjustment;
        }
        if (expansionDirection < 1) {
            let minAdjustment = rangeShortfall;
            if (expansionDirection === 0) minAdjustment /= 2;
            adjustedRange.min -= minAdjustment;
        }
        adjustedRange.distance = targetRangeDistance;
    } else adjustedRange.distance = rangeDistance;
    return adjustedRange;
};
/**
 * Internal function that rounds out expansion so that all segments should have a size of
 *
 *    10 ^ n; where n is any whole number (ie. no fractions)
 *
 * @param {{
 *    range: {
 *      min: number,
 *      max: number,
 *      distance: number
 *    },
 *    adjustedRange: {
 *      min: number,
 *      max: number,
 *      distance: number
 *    },
 *    valueType: String
 * }}
 *
 * @returns {{
 *    min: number,
 *    max: number,
 *    distance: number,
 *    segments: Array<String|number>,
 * }}
 */ const $558a1874964eed3d$var$expandRounded = ({ range: range, adjustedRange: adjustedRange, valueType: valueType })=>{
    const segmentScalePower = $558a1874964eed3d$var$getSegmentScalePower(range);
    const segmentScale = 10 ** segmentScalePower;
    const adjustedRangeMin = Math.floor(adjustedRange.min / segmentScale) * segmentScale;
    const adjustedRangeMax = Math.ceil(adjustedRange.max / segmentScale) * segmentScale;
    const adjustedRangeDistance = adjustedRangeMax - adjustedRangeMin;
    const plotSegments = Math.round(adjustedRangeDistance / segmentScale);
    return {
        min: adjustedRangeMin,
        max: adjustedRangeMax,
        distance: adjustedRangeDistance,
        segments: Array.from(Array(plotSegments + 1)).map((_, index)=>{
            let segmentValue = adjustedRangeMin + segmentScale * index;
            if (segmentScalePower < 0) segmentValue = $558a1874964eed3d$var$preciseRound(segmentValue, -1 * segmentScalePower);
            return $558a1874964eed3d$var$getScaledValue(segmentValue, valueType);
        })
    };
};
/**
 * Initialize the passed in range prop so that the range is normalized to the object format.
 *
 * @param { number | {
 *    value: number,
 *    expansionRule?: string
 * }} prop: The properties of the range prop to be normalized
 *
 * @returns {{
 *    value: number,
 *    expansionRule: string
 * }}
 */ const $558a1874964eed3d$var$initializeRangeProp = (prop)=>{
    let rangeProp = prop;
    if (typeof prop === 'number') rangeProp = {
        expansionRule: 'loose',
        value: prop
    };
    if (typeof prop === 'undefined') return {
        expansionRule: 'no-limit'
    };
    return {
        ...$558a1874964eed3d$var$DEFAULT_RANGE_PROPS,
        ...rangeProp
    };
};
/**
 * Returns the adjusted range after factoring in expansion rules and dataset restrictions.
 *
 * @param {
 *    data: <Object>,
 *    range: {
 *      min: { number | {
 *        value: number,
 *        expansionRule?: string
 *      }},
 *      max: { number | {
 *        value: number,
 *        expansionRule?: string
 *      }},
 *    },
 *    valueFields: Array<{
 *      id: string,
 *      label: string
 *    }>,
 *    valueType: String
 * } : The list of properties used to set the new chart range
 *
 * @returns {{
 *    min: number,
 *    max: number,
 *    distance: number,
 *    segments: Array<String|number>,
 * }}
 */ const $558a1874964eed3d$var$getAdjustedRange = ({ data: data, range: range = {}, valueFields: valueFields, valueType: valueType })=>{
    const initRange = {
        min: $558a1874964eed3d$var$initializeRangeProp(range.min),
        max: $558a1874964eed3d$var$initializeRangeProp(range.max)
    };
    const valueFieldList = $558a1874964eed3d$var$initializeValueFields(valueFields);
    const dataRange = $558a1874964eed3d$var$getDataRange(data, valueFieldList);
    const adjustedRange = {
        min: $558a1874964eed3d$var$getRangeProp('min', dataRange, initRange),
        max: $558a1874964eed3d$var$getRangeProp('max', dataRange, initRange)
    };
    const expandedRange = $558a1874964eed3d$var$expandToContentRatio({
        dataRange: dataRange,
        adjustedRange: adjustedRange,
        initRange: initRange
    });
    return $558a1874964eed3d$var$expandRounded({
        range: expandedRange,
        adjustedRange: adjustedRange,
        valueType: valueType
    });
};
// eslint-disable-next-line func-names
const $558a1874964eed3d$var$PathBuilder = function() {
    let path = [];
    this.moveTo = (destination)=>{
        path = path.concat([
            'M',
            destination.x,
            destination.y
        ]);
        return this;
    };
    this.lineTo = (destination)=>{
        path = path.concat([
            'L',
            destination.x,
            destination.y
        ]);
        return this;
    };
    this.createArc = (destination, radiusProp, optionalProps = {})=>{
        const { rotation: rotation = 0, largeArcFlag: largeArcFlag = false, rotateClockwise: rotateClockwise = false } = optionalProps;
        let radius = radiusProp;
        if (typeof radiusProp === 'number') radius = {
            x: radiusProp,
            y: radiusProp
        };
        path = path.concat([
            'A',
            radius.x,
            radius.y,
            rotation,
            +largeArcFlag,
            +rotateClockwise,
            destination.x,
            destination.y
        ]);
        return this;
    };
    this.getPath = ()=>path.join(' ');
};
var $558a1874964eed3d$var$PathBuilder$1 = $558a1874964eed3d$var$PathBuilder;
const $558a1874964eed3d$var$CHART_POINT_RADIUS = 4;
const $558a1874964eed3d$var$CHART_POINT_ORDER = [
    'circle',
    'square',
    'triangle',
    'diamond'
];
/**
 * Renders a point in the DataViz component.
 *
 * @param {{
 *    type: String,
 *    key: String,
 *    className: String,
 *    position: {
 *      x: number,
 *      y: number
 *    },
 *    radius: number
 * }}
 */ const $558a1874964eed3d$var$renderPoint = ({ type: type, key: key, className: className, position: position, radius: radius })=>{
    if (type === 'triangle') {
        const points = [
            `${position.x},${position.y + radius * 1.5}`,
            `${position.x + radius * 1.5},${position.y - radius}`,
            `${position.x - radius * 1.5},${position.y - radius}`
        ];
        return /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
            className: className,
            points: points
        }, key);
    }
    if (type === 'square') {
        const points = [
            `${position.x + radius},${position.y + radius}`,
            `${position.x - radius},${position.y + radius}`,
            `${position.x - radius},${position.y - radius}`,
            `${position.x + radius},${position.y - radius}`
        ];
        return /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
            className: className,
            points: points
        }, key);
    }
    if (type === 'diamond') {
        const points = [
            `${position.x + radius * 1.35},${position.y}`,
            `${position.x},${position.y + radius * 1.35}`,
            `${position.x - radius * 1.35},${position.y}`,
            `${position.x},${position.y - radius * 1.35}`
        ];
        return /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
            className: className,
            points: points
        }, key);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        className: className,
        cx: position.x,
        cy: position.y,
        r: radius
    }, key);
};
/**
 * Renders an icon representing the line used for the legend key
 *
 * @param {number} index: An index used to determine which series the legend key belongs to
 */ const $558a1874964eed3d$var$renderLineKeyIcon = (index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: $558a1874964eed3d$var$CHART_POINT_RADIUS * 6,
        height: $558a1874964eed3d$var$CHART_POINT_RADIUS * 2,
        transform: "scale(1 -1)",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                className: `data-viz--plot-line data-viz--plot-line-${index}`,
                x1: "0%",
                x2: "100%",
                y1: "50%",
                y2: "50%"
            }),
            $558a1874964eed3d$var$renderPoint({
                type: $558a1874964eed3d$var$CHART_POINT_ORDER[index],
                className: `data-viz--plot-point data-viz--plot-point-${index}`,
                position: {
                    x: $558a1874964eed3d$var$CHART_POINT_RADIUS * 3,
                    y: $558a1874964eed3d$var$CHART_POINT_RADIUS
                },
                radius: $558a1874964eed3d$var$CHART_POINT_RADIUS
            })
        ]
    });
/**
 * Renders an icon representing the palette used for the legend key
 *
 * @param {number} index: An index used to determine which series the legend key belongs to
 */ const $558a1874964eed3d$var$renderPaletteKeyIcon = (index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: `data-viz--palette data-viz--palette-${index}`
    });
/**
 * Renders an icon for the current legend key entry
 *
 * @param {number} index: An index used to determine which series the legend key belongs to
 * @param {String} renderStyle: The rendering style used to represent the current legend key entry
 */ const $558a1874964eed3d$var$renderLegendKeyIcon = (index, renderStyle)=>{
    switch(renderStyle){
        case 'line':
            return $558a1874964eed3d$var$renderLineKeyIcon(index);
        case 'bar':
        default:
            return $558a1874964eed3d$var$renderPaletteKeyIcon(index);
    }
};
/**
 * Renders a plot line in the current DataViz component
 *
 * @param {{
 *    field: {
 *      id: String,
 *      label: String
 *    },
 *    index: number,
 *    plotPoints: Object<String>
 * }}
 */ const $558a1874964eed3d$var$renderPlotLine = ({ field: field, index: index, plotPoints: plotPoints })=>{
    const dataPoints = plotPoints[field.id];
    const plotLinePoints = [];
    const domPoints = [];
    dataPoints.forEach((point, pointIndex)=>{
        const { x: x, y: y } = point;
        plotLinePoints.push(`${x},${y}`);
        domPoints.push($558a1874964eed3d$var$renderPoint({
            type: $558a1874964eed3d$var$CHART_POINT_ORDER[index],
            key: `data-viz--plot-point-${field.id}-${pointIndex}`,
            className: `data-viz--plot-point data-viz--plot-point-${index}`,
            position: {
                x: x,
                y: y
            },
            radius: $558a1874964eed3d$var$CHART_POINT_RADIUS
        }));
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
        className: "data-viz--plot-line-group",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                className: `data-viz--plot-line data-viz--plot-line-${index}`,
                points: plotLinePoints.join(' '),
                fill: "none"
            }, `data-viz--plot-line-${field.id}`),
            domPoints
        ]
    }, `data-viz--plot-line-group-${field.id}`);
};
/**
 * Renders a bar in the current DataViz component
 *
 * @param {{
 *    x: number,
 *    y: number,
 *    width: number,
 *    height: number,
 *    index: number,
 *    isPositive: boolean
 * }}
 */ const $558a1874964eed3d$var$renderBar = ({ x: x, y: y, width: width, height: height, index: index, radius: radius = 0, isPositive: isPositive = true, color: color = 'luna' })=>{
    const classList = [
        'data-viz--bar',
        `data-viz--bar-${color}`
    ];
    const xStart = isPositive ? x : x + width;
    const yStart = y - height / 2;
    const direction = isPositive ? 1 : -1;
    const barWidth = width * direction;
    const barRadius = Math.min(radius, width, height / 2) * direction;
    const barPath = new $558a1874964eed3d$var$PathBuilder$1();
    barPath.moveTo({
        x: xStart,
        y: yStart
    }).lineTo({
        x: xStart + barWidth - barRadius,
        y: yStart
    }).createArc({
        x: xStart + barWidth,
        y: yStart + Math.abs(barRadius)
    }, barRadius, {
        rotation: 90,
        rotateClockwise: isPositive
    }).lineTo({
        x: xStart + barWidth,
        y: yStart + height - Math.abs(barRadius)
    }).createArc({
        x: xStart + barWidth - barRadius,
        y: yStart + height
    }, barRadius, {
        rotation: 90,
        rotateClockwise: isPositive
    }).lineTo({
        x: xStart,
        y: yStart + height
    }).moveTo({
        x: xStart,
        y: yStart
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        className: classList.join(' '),
        d: barPath.getPath()
    }, `data-viz--bar-${index}`);
};
/**
 * Renders a legend for the current DataViz component
 *
 * @param { String | {
 *    id: String,
 *    label?: String
 * }} valueFields: The passed in valueField prop sent to the DataViz component to be normalized into the object variant (with id and label)
 * @param {String} renderStyle: The rendering style used to represent all legend key entries
 */ const $558a1874964eed3d$var$renderLegend = (valueFields, renderStyle = 'bar')=>$558a1874964eed3d$var$initializeValueFields(valueFields).map((field, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "data-viz--legend-entry",
            children: [
                $558a1874964eed3d$var$renderLegendKeyIcon(index, renderStyle),
                " ",
                field.label
            ]
        }, `data-viz--legend-${field.id}`));
const $558a1874964eed3d$var$CHART_WIDTH_PADDING$1 = 10;
const $558a1874964eed3d$var$defaultBarRadius$1 = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($gmF1g))).lightmodeBarchartBarBorderRadius, 10);
const $558a1874964eed3d$var$calcChartHeight = ({ barWidth: barWidth, barPadding: barPadding, data: data })=>(barWidth + 2 * barPadding) * data.length;
const $558a1874964eed3d$var$getChartOrigin = (chartMetadata)=>{
    const xAxisOrigin = chartMetadata.xLabels.find((xLabel)=>$558a1874964eed3d$var$getRawValue(xLabel.value) === 0);
    if (typeof xAxisOrigin === 'undefined') {
        const isPositive = $558a1874964eed3d$var$getRawValue(chartMetadata.xLabels[0].value) > 0;
        return isPositive ? chartMetadata.xLabels[0] : chartMetadata.xLabels[chartMetadata.xLabels.length - 1];
    }
    return xAxisOrigin;
};
const $558a1874964eed3d$var$BarChart$1 = ({ data: data, labelField: labelField, valueField: valueField, figureAlt: figureAlt, title: title = {
    headingSize: undefined,
    id: undefined
}, description: description = {
    id: undefined
}, valueType: valueType = 'number', range: range = {
    min: undefined,
    max: undefined
}, xAxisLabel: xAxisLabel, yAxisLabel: yAxisLabel, barRadius: barRadius = $558a1874964eed3d$var$defaultBarRadius$1, barHeight: barHeight = 40, barColor: barColor = 'luna', classes: classes = [] })=>{
    const [horizontalOffset, setHorizontalOffset] = (0, $acw62.useState)(0);
    const [horizontalLabels, setHorizontalLabels] = (0, $acw62.useState)([]);
    const [verticalOffset, setVerticalOffset] = (0, $acw62.useState)(0);
    const [verticalLabels, setVerticalLabels] = (0, $acw62.useState)([]);
    const figureRef = (0, $acw62.useRef)();
    const plotRef = (0, $acw62.useRef)();
    const horizontalLabelRef = (0, $acw62.useRef)();
    const verticalLabelRef = (0, $acw62.useRef)();
    const height = $558a1874964eed3d$var$calcChartHeight({
        barPadding: $558a1874964eed3d$var$CHART_WIDTH_PADDING$1,
        barWidth: barHeight,
        data: data
    });
    const valueFieldList = $558a1874964eed3d$var$initializeValueFields([
        valueField
    ]);
    const plotRange = $558a1874964eed3d$var$getAdjustedRange({
        data: data,
        range: range,
        valueType: valueType,
        valueFields: valueFieldList
    });
    const chartMetadata = $558a1874964eed3d$var$getChartMetadata({
        data: data,
        labelField: labelField,
        height: height,
        horizontalLabels: horizontalLabels,
        horizontalOffset: horizontalOffset,
        verticalOffset: verticalOffset,
        verticalLabels: verticalLabels,
        orientation: 'vertical',
        valueFields: valueFieldList,
        adjustedRange: plotRange,
        chartPadding: $558a1874964eed3d$var$CHART_WIDTH_PADDING$1
    });
    const plotPoints = chartMetadata.plotPoints[valueField];
    const xAxisOrigin = $558a1874964eed3d$var$getChartOrigin(chartMetadata);
    const setPlotDimensions = ()=>{
        setHorizontalOffset(horizontalLabelRef.current.getBoundingClientRect().x);
        setVerticalOffset(verticalLabelRef.current.getBoundingClientRect().y);
        setHorizontalLabels(Array.from(figureRef.current.querySelectorAll('.data-viz--horizontal-label')).map((domColumn)=>domColumn.getBoundingClientRect()));
        setVerticalLabels(Array.from(figureRef.current.querySelectorAll('.data-viz--vertical-label')).map((domColumn)=>domColumn.getBoundingClientRect()));
    };
    (0, $acw62.useEffect)(setPlotDimensions, [
        plotRef.current,
        xAxisLabel,
        yAxisLabel,
        barHeight,
        data
    ]);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener('resize', setPlotDimensions);
        return ()=>{
            window.removeEventListener('resize', setPlotDimensions);
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        ref: figureRef,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-bar-chart',
                'bar-chart',
                'data-viz',
                'data-viz--horizontal'
            ],
            custom: classes,
            required: []
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "axiom-bar-chart--legend data-viz--legend",
                "aria-hidden": "false",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$DataVizLegend$1, {
                    title: title,
                    description: description
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                ref: verticalLabelRef,
                className: "axiom-bar-chart--y-labels data-viz--y-labels",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-bar-chart--y-title data-viz--y-title",
                        children: yAxisLabel
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-bar-chart--vertical-labels data-viz--vertical-labels",
                        children: chartMetadata.yLabels.map((yLabel)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "axiom-bar-chart--vertical-label data-viz--vertical-label",
                                children: yLabel
                            }, `data-viz--vertical-label-${yLabel}`))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "img",
                className: "axiom-bar-chart--plot data-viz--plot",
                "aria-label": figureAlt,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    ref: plotRef,
                    height: height,
                    style: {
                        minWidth: `${chartMetadata.totalColumnWidth}px`,
                        height: `${height}px`
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        transform: `scale(1 -1) translate(0 -${height})`,
                        children: [
                            chartMetadata.xLabels.map((xLabel)=>{
                                const lineClasses = [
                                    'axiom-bar-chart--vertical-line',
                                    'data-viz--vertical-line'
                                ];
                                if (parseFloat(xLabel.value, 10) === 0) lineClasses.push('data-viz--origin-line');
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                    className: lineClasses.join(' '),
                                    x1: xLabel.position,
                                    x2: xLabel.position,
                                    y1: "0%",
                                    y2: "100%"
                                }, `data-viz--vertical-line-${xLabel.value}`);
                            }),
                            plotPoints.map((point, index)=>{
                                const barWidth = point.x - xAxisOrigin.position;
                                const isPositive = barWidth >= 0;
                                const posX = isPositive ? xAxisOrigin.position : xAxisOrigin.position + barWidth;
                                return $558a1874964eed3d$var$renderBar({
                                    index: index,
                                    isPositive: isPositive,
                                    x: posX,
                                    y: point.y,
                                    width: Math.abs(barWidth),
                                    height: barHeight,
                                    radius: barRadius,
                                    color: barColor
                                });
                            })
                        ]
                    }, 'data-viz--origin-transform')
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                ref: horizontalLabelRef,
                className: "axiom-bar-chart--x-labels data-viz--x-labels",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-bar-chart--horizontal-labels data-viz--horizontal-labels",
                        children: chartMetadata.xLabels.map((xLabels)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "axiom-bar-chart--horizontal-label data-viz--horizontal-label",
                                children: xLabels.value
                            }, `data-viz--horizontal-label-${xLabels.value}`))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-bar-chart--x-title data-viz--x-title",
                        children: xAxisLabel || labelField
                    })
                ]
            })
        ]
    });
};
$558a1874964eed3d$var$BarChart$1.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any).isRequired,
    labelField: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    valueField: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    figureAlt: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            headingSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                1,
                2,
                3,
                4,
                5,
                6
            ]),
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ]),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
        })
    ]),
    valueType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'percent',
        'dollar',
        'number'
    ]),
    range: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        min: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                expansionRule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                    'strict',
                    'loose'
                ])
            })
        ]),
        max: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                expansionRule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                    'strict',
                    'loose'
                ])
            })
        ])
    }),
    xAxisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    yAxisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    barRadius: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    barHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    barColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'luna',
        'sunflower',
        'sienna',
        'jade',
        'vividCerulean',
        'brick',
        'mardiGras',
        'rose'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$BarChartJSX = $558a1874964eed3d$var$BarChart$1;
var $558a1874964eed3d$export$94aefc399ef206a9 = function(_a) {
    var data = _a.data, labelField = _a.labelField, valueField = _a.valueField, figureAlt = _a.figureAlt, _b = _a.title, title = _b === void 0 ? undefined : _b, _c = _a.description, description = _c === void 0 ? undefined : _c, _d = _a.valueType, valueType = _d === void 0 ? 'number' : _d, _e = _a.range, range = _e === void 0 ? {
        min: undefined,
        max: undefined
    } : _e, _f = _a.xAxisLabel, xAxisLabel = _f === void 0 ? undefined : _f, _g = _a.yAxisLabel, yAxisLabel = _g === void 0 ? undefined : _g, _h = _a.barRadius, barRadius = _h === void 0 ? 4 : _h, _j = _a.barHeight, barHeight = _j === void 0 ? 40 : _j, _k = _a.barColor, barColor = _k === void 0 ? 'luna' : _k, _l = _a.classes, classes = _l === void 0 ? [] : _l;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$BarChartJSX, {
        title: title,
        description: description,
        data: data,
        labelField: labelField,
        valueField: valueField,
        valueType: valueType,
        figureAlt: figureAlt,
        range: range,
        xAxisLabel: xAxisLabel,
        yAxisLabel: yAxisLabel,
        barRadius: barRadius,
        barHeight: barHeight,
        barColor: barColor,
        classes: classes
    });
};
$558a1874964eed3d$export$94aefc399ef206a9.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any).isRequired,
    labelField: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    valueField: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    figureAlt: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            headingSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                1,
                2,
                3,
                4,
                5,
                6
            ]),
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ]),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
        })
    ]),
    valueType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'percent',
        'dollar',
        'number'
    ]),
    range: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        min: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                expansionRule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                    'strict',
                    'loose'
                ])
            })
        ]),
        max: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                expansionRule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                    'strict',
                    'loose'
                ])
            })
        ])
    }),
    xAxisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    yAxisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    barRadius: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    barHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    barColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'luna',
        'sunflower',
        'sienna',
        'jade',
        'vividCerulean',
        'brick',
        'mardiGras',
        'rose'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$Link$1 = ({ children: children, href: href, newWindow: newWindow = false, utilityFunction: utilityFunction, hideUnderline: hideUnderline = false, attributes: attributes = {}, onClick: onClick, configObj: configObj = {}, classes: classes = [] })=>{
    const handleClick = (event)=>{
        if (event && utilityFunction) event.preventDefault();
        if (utilityFunction === 'ums') (0, $6IdRn.openUMSWin)(configObj.id, configObj.winName, configObj.parms, configObj.width, configObj.height, configObj.left, configObj.top, configObj.pdf);
        else if (utilityFunction === 'window') (0, $6IdRn.openWindow)(configObj);
        else if (utilityFunction === 'pdf') (0, $6IdRn.openPdfWin)(configObj.url, configObj.winName, configObj.width, configObj.height);
        else if (utilityFunction === 'relWkspc') (0, $6IdRn.displayRelWkspc)(configObj.appId, configObj.parmSet, configObj.authorizedUser);
    };
    const handleKeyDown = (event)=>{
        if (event.code === 'Enter') handleClick();
    };
    const defaultClasses = [
        'axiom-link',
        'link',
        hideUnderline && 'axiom-link--hide-underline link__hide-underline',
        newWindow && 'axiom-link--new-window link__new-window'
    ].filter((className)=>typeof className === 'string');
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-is-valid
    (0, $ayMG0.jsxs)("a", {
        href: utilityFunction ? '' : href,
        className: $558a1874964eed3d$var$createClassList({
            default: defaultClasses,
            custom: classes,
            required: []
        }),
        target: newWindow ? '_blank' : null,
        rel: "noopener noreferrer",
        onClick: utilityFunction ? handleClick : onClick,
        onKeyDown: handleKeyDown,
        ...attributes,
        children: [
            children,
            newWindow && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                name: "new-window",
                altText: " opens in a new window",
                seenByAssistiveTechnology: true
            })
        ]
    }));
};
$558a1874964eed3d$var$Link$1.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    newWindow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    utilityFunction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'window',
        'ums',
        'pdf',
        'relWkspc'
    ]),
    hideUnderline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    configObj: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$LinkJSX = $558a1874964eed3d$var$Link$1;
const $558a1874964eed3d$var$Breadcrumbs$1 = ({ pages: pages, onClick: onClick, classes: classes = [] })=>{
    if (!pages.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
        "aria-label": "breadcrumb",
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-breadcrumbs'
            ],
            custom: classes,
            required: []
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
            className: "axiom-breadcrumbs--list breadcrumbs",
            children: [
                pages.slice(0, -1).map(({ name: name, url: url })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        className: "axiom-breadcrumbs--breadcrumb breadcrumbs--breadcrumb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$LinkJSX, {
                                href: url,
                                onClick: onClick,
                                hideUnderline: true,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                                name: "chevron-right"
                            })
                        ]
                    }, name)),
                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    "aria-current": "page",
                    className: "axiom-breadcrumbs--breadcrumb--current breadcrumbs--breadcrumb--current",
                    children: pages[pages.length - 1].name
                })
            ]
        })
    });
};
$558a1874964eed3d$var$Breadcrumbs$1.propTypes = {
    pages: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        url: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    })).isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$BreadcrumbsJSX = $558a1874964eed3d$var$Breadcrumbs$1;
var $558a1874964eed3d$export$2dc68d50d56fbbd = function(_a) {
    var pages = _a.pages, _b = _a.onClick, onClick = _b === void 0 ? undefined : _b, _c = _a.classes, classes = _c === void 0 ? [] : _c;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$BreadcrumbsJSX, {
        pages: pages,
        onClick: onClick,
        classes: classes
    });
};
$558a1874964eed3d$export$2dc68d50d56fbbd.propTypes = {
    pages: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        url: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    })).isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$ASSIST_TEXT_DURATION$1 = 10000;
const $558a1874964eed3d$var$Spinner$1 = ({ id: id = null, mode: mode = 'dark', classes: classes = [], attributes: attributes = {}, assistiveText: assistiveText = 'loading' })=>{
    const [currentAssistiveText, setCurrentAssistiveText] = (0, $acw62.useState)(Array.isArray(assistiveText) ? assistiveText[0] : assistiveText);
    (0, $acw62.useEffect)(()=>{
        if (Array.isArray(assistiveText) && assistiveText.length > 1) setTimeout(()=>{
            const newIndex = assistiveText.indexOf(currentAssistiveText) + 1;
            const newAssistiveText = newIndex < assistiveText.length ? assistiveText[newIndex] : assistiveText[0];
            setCurrentAssistiveText(newAssistiveText);
            return newAssistiveText;
        }, $558a1874964eed3d$var$ASSIST_TEXT_DURATION$1);
    }, [
        currentAssistiveText
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: id,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-spinner',
                `spinner ${mode === 'light' ? 'spinner--light' : ''}`
            ],
            custom: classes,
            required: []
        }),
        "data-testid": "spinner",
        ...attributes,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                id: "spinner-assistive-text",
                className: "spinner--assistive-text screen-reader-only",
                "aria-live": "polite",
                children: currentAssistiveText
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: "61",
                height: "61",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 61 61",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                    fillRule: "evenodd",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            x: "28",
                            width: "5",
                            height: "18",
                            rx: "2"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            fillOpacity: ".52",
                            x: "28",
                            y: "43",
                            width: "5",
                            height: "18",
                            rx: "2"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M14.815 4.313l.637-.364a2 2 0 012.683.669l7.748 12.264a2 2 0 01-.698 2.805l-.637.364a2 2 0 01-2.683-.669L14.117 7.118a2 2 0 01.698-2.805z",
                            fillOpacity: ".92"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M35.815 41.313l.637-.364a2 2 0 012.683.669l7.748 12.264a2 2 0 01-.698 2.805l-.637.364a2 2 0 01-2.683-.669l-7.748-12.264a2 2 0 01.698-2.805z",
                            fillOpacity: ".44"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M3.888 15.576l.375-.699a2 2 0 012.817-.753l12.325 7.655a2 2 0 01.707 2.645l-.375.699a2 2 0 01-2.817.753L4.595 18.22a2 2 0 01-.707-2.645z",
                            fillOpacity: ".84"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M40.888 36.576l.375-.699a2 2 0 012.817-.753l12.325 7.655a2 2 0 01.707 2.645l-.375.699a2 2 0 01-2.817.753L41.595 39.22a2 2 0 01-.707-2.645z",
                            fillOpacity: ".36"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            fillOpacity: ".76",
                            transform: "rotate(-90 9 30.5)",
                            x: "6.5",
                            y: "21.5",
                            width: "5",
                            height: "18",
                            rx: "2"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            fillOpacity: ".28",
                            transform: "rotate(-90 52 30.5)",
                            x: "49.5",
                            y: "21.5",
                            width: "5",
                            height: "18",
                            rx: "2"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M4.263 46.123l-.375-.7a2 2 0 01.707-2.644l12.325-7.655a2 2 0 012.817.753l.375.7a2 2 0 01-.707 2.644L7.08 46.876a2 2 0 01-2.817-.753z",
                            fillOpacity: ".68"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M41.263 25.123l-.375-.7a2 2 0 01.707-2.644l12.325-7.655a2 2 0 012.817.753l.375.7a2 2 0 01-.707 2.644L44.08 25.876a2 2 0 01-2.817-.753z",
                            fillOpacity: ".2"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M15.576 57.112l-.699-.375a2 2 0 01-.753-2.817l7.655-12.325a2 2 0 012.645-.707l.699.375a2 2 0 01.753 2.817L18.22 56.405a2 2 0 01-2.645.707z",
                            fillOpacity: ".6"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M36.576 20.112l-.699-.375a2 2 0 01-.753-2.817L42.78 4.595a2 2 0 012.645-.707l.699.375a2 2 0 01.753 2.817L39.22 19.405a2 2 0 01-2.645.707z",
                            fillOpacity: ".12"
                        })
                    ]
                })
            })
        ]
    });
};
$558a1874964eed3d$var$Spinner$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'light',
        'dark'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    assistiveText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$SpinnerJSX = $558a1874964eed3d$var$Spinner$1;
const $558a1874964eed3d$var$Button$1 = ({ label: label, onClick: onClick, id: id, type: type = 'button', icon: icon, condensed: condensed = false, disabled: disabled = false, loading: loading = false, styleVariant: styleVariant = 'primary', attributes: attributes = {}, inputRef: inputRef, iconPosition: iconPosition = 'left', iconOnly: iconOnly = false, customAriaLabel: customAriaLabel, classes: classes = [], ariaCurrent: ariaCurrent })=>{
    let standardClasses = [
        'axiom-button button'
    ];
    if (condensed) standardClasses = [
        ...standardClasses,
        'button--condensed'
    ];
    if (icon) {
        standardClasses = [
            ...standardClasses,
            'button--icon'
        ];
        if (iconOnly) standardClasses = [
            ...standardClasses,
            'button--icon-only'
        ];
        else standardClasses = [
            ...standardClasses,
            `button--icon-${iconPosition}`
        ];
    }
    if (styleVariant !== 'primary') standardClasses = [
        ...standardClasses,
        `button--${styleVariant}`
    ];
    if (loading) standardClasses = [
        ...standardClasses,
        'button--loading'
    ];
    const [currentPosition, setCurrentPosition] = (0, $acw62.useState)({
        x: 0,
        y: 0,
        size: 0
    });
    const [showRipple, setShowRipple] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        let timer;
        if (showRipple) timer = setTimeout(()=>{
            setShowRipple(false);
        }, 700);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        showRipple
    ]);
    function assignSpinnerMode() {
        if (styleVariant === 'primary' || styleVariant === 'reversed-secondary') return 'light';
        return 'dark';
    }
    const setAnimatePosition = (event)=>{
        const currentBtn = event.currentTarget.getBoundingClientRect();
        const size = currentBtn.width > currentBtn.height ? currentBtn.width : currentBtn.height;
        const x = event.pageX > 0 ? event.pageX - currentBtn.left - size / 2 : (event.pageX + event.pageY) / 2;
        const y = event.pageY > 0 ? event.pageY - currentBtn.top - size / 2 : (event.pageX + event.pageY) / 2;
        return {
            x: x,
            y: y,
            size: size
        };
    };
    const handleClick = (event)=>{
        onClick(event);
        if (!disabled) {
            const position = setAnimatePosition(event);
            setCurrentPosition(position);
            setShowRipple(true);
        }
    };
    function validateLabel() {
        if (!label.trim()) throw new Error('Empty label not valid, label must contain actual text.');
        return label;
    }
    // @todo: research to see if react treats button types differently under the hood; if so, we should fork render based on button type
    // https://github.com/yannickcr/eslint-plugin-react/issues/1846#issuecomment-401849676
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        className: $558a1874964eed3d$var$createClassList({
            default: standardClasses,
            custom: classes,
            required: []
        }),
        type: type,
        disabled: disabled || loading,
        onClick: (e)=>handleClick(e),
        "data-testid": "button",
        id: id,
        ref: inputRef,
        ...attributes,
        "aria-current": ariaCurrent || null,
        "aria-label": customAriaLabel,
        "aria-atomic": "true",
        children: [
            showRipple && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "data-testid": "ripple-effect",
                className: "axiom-ripple ripple",
                style: {
                    left: `${currentPosition.x}px`,
                    top: `${currentPosition.y}px`,
                    width: currentPosition.size,
                    height: currentPosition.size
                }
            }),
            !!icon && !loading && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                name: icon
            }),
            loading && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$SpinnerJSX, {
                mode: assignSpinnerMode(),
                assistiveText: [
                    'loading',
                    'please wait'
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: `axiom-button--label button--label${iconOnly ? ' screen-reader-only' : ''}`,
                children: validateLabel()
            })
        ]
    });
};
$558a1874964eed3d$var$Button$1.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'button',
        'submit'
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    styleVariant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'primary',
        'secondary',
        'tertiary',
        'reversed-primary',
        'reversed-secondary',
        'destructive-primary',
        'destructive-secondary',
        'destructive-tertiary'
    ]),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    iconPosition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'left',
        'right'
    ]),
    iconOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    customAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    ariaCurrent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $558a1874964eed3d$var$Button$2 = $558a1874964eed3d$var$Button$1;
var $558a1874964eed3d$export$353f5b6fc5456de1 = function(_a) {
    var label = _a.label, onClick = _a.onClick, _b = _a.id, id = _b === void 0 ? undefined : _b, _c = _a.type, type = _c === void 0 ? 'button' : _c, _d = _a.icon, icon = _d === void 0 ? undefined : _d, _e = _a.condensed, condensed = _e === void 0 ? false : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.loading, loading = _g === void 0 ? false : _g, _h = _a.styleVariant, styleVariant = _h === void 0 ? 'primary' : _h, _j = _a.attributes, attributes = _j === void 0 ? {} : _j, _k = _a.inputRef, inputRef = _k === void 0 ? undefined : _k, _l = _a.iconPosition, iconPosition = _l === void 0 ? 'left' : _l, _m = _a.iconOnly, iconOnly = _m === void 0 ? false : _m, _o = _a.customAriaLabel, customAriaLabel = _o === void 0 ? undefined : _o, _p = _a.classes, classes = _p === void 0 ? [] : _p, _q = _a.ariaCurrent, ariaCurrent = _q === void 0 ? undefined : _q;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
        id: id,
        label: label,
        onClick: onClick,
        type: type,
        icon: icon,
        condensed: condensed,
        disabled: disabled,
        loading: loading,
        styleVariant: styleVariant,
        attributes: attributes,
        inputRef: inputRef,
        iconPosition: iconPosition,
        iconOnly: iconOnly,
        customAriaLabel: customAriaLabel,
        classes: classes,
        ariaCurrent: ariaCurrent
    });
};
$558a1874964eed3d$export$353f5b6fc5456de1.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'button',
        'submit'
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    styleVariant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'primary',
        'secondary',
        'tertiary',
        'reversed-primary',
        'reversed-secondary',
        'destructive-primary',
        'destructive-secondary',
        'destructive-tertiary'
    ]),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    iconPosition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'left',
        'right'
    ]),
    iconOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    customAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    ariaCurrent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
/* eslint-disable react/destructuring-assignment */ const $558a1874964eed3d$var$Card$1 = ({ title: title, children: children, classes: classes = [], hideTitle: hideTitle = false, collapsible: collapsible = false, description: description, icon: icon, headingSize: headingSize = 3, expanded: expanded = true, onChange: onChange = ()=>{} })=>{
    const id = (0, $acw62.useId)();
    const [contentHeight, setContentHeight] = (0, $acw62.useState)('auto');
    const [hasBeenToggled, setHasBeenToggled] = (0, $acw62.useState)(false);
    const [isExpanded, setExpanded] = (0, $acw62.useState)(expanded);
    const contentContainerRef = (0, $acw62.useRef)();
    const cardContentRef = (0, $acw62.useRef)();
    const toggleExpand = (isExpanding)=>{
        if (isExpanding) {
            setExpanded(true);
            setContentHeight(contentContainerRef.current.offsetHeight);
            setHasBeenToggled(true);
        } else {
            setExpanded(false);
            setContentHeight(0);
            setHasBeenToggled(true);
            cardContentRef.current.classList.remove('card-content--opened');
        }
    };
    const renderIcon = ()=>icon && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "card-header-icon-wrapper",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                name: icon
            })
        });
    (0, $acw62.useEffect)(()=>{
        let offsetHeight = 0;
        if (isExpanded) offsetHeight = contentContainerRef.current.offsetHeight;
        setContentHeight(offsetHeight);
    }, [
        isExpanded
    ]);
    (0, $acw62.useEffect)(()=>{
        if (window.ResizeObserver) {
            const resizeObs = new ResizeObserver(()=>{
                if (isExpanded && contentContainerRef.current && contentHeight !== contentContainerRef.current.offsetHeight) setContentHeight(contentContainerRef.current.offsetHeight);
            });
            const manageClasses = ()=>{
                if (!isExpanded) contentContainerRef.current.classList.add('card-content-container-closed');
                else cardContentRef.current.classList.add('card-content--opened');
            };
            // 'transitionend' is the event that calls after the CSS transition happened
            if (cardContentRef.current) cardContentRef.current.addEventListener('transitionend', manageClasses);
            resizeObs.observe(contentContainerRef.current);
            return ()=>{
                resizeObs.disconnect();
                if (cardContentRef.current) cardContentRef.current.removeEventListener('transitionend', manageClasses);
            };
        }
        return ()=>{};
    }, [
        isExpanded,
        contentContainerRef.current
    ]);
    (0, $acw62.useEffect)(()=>{
        if (window.MutationObserver) {
            const mutationObs = new MutationObserver(()=>{
                if (isExpanded) setContentHeight(contentContainerRef.current.offsetHeight);
            });
            mutationObs.observe(contentContainerRef.current, {
                childList: true,
                subtree: true,
                characterData: true
            });
            return ()=>{
                mutationObs.disconnect();
            };
        }
        return ()=>{};
    }, [
        isExpanded,
        contentContainerRef.current
    ]);
    (0, $acw62.useEffect)(()=>{
        onChange(isExpanded);
    }, [
        isExpanded
    ]);
    (0, $acw62.useEffect)(()=>{
        setExpanded(expanded);
        toggleExpand(expanded);
    }, [
        expanded
    ]);
    const renderCollapsibleHeader = ()=>{
        const HEADING = `h${headingSize}`;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(HEADING, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                // eslint-disable-line
                "data-testid": "card-content-header",
                onClick: collapsible ? ()=>toggleExpand(!isExpanded) : undefined,
                className: `axiom-card--header-collapser cardHeader collapsible ${isExpanded ? 'open' : 'closed'}`,
                "aria-expanded": isExpanded,
                "aria-controls": id,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "axiom-card--header cardHeaderText",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card-header-title-wrapper",
                                children: [
                                    renderIcon(),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "axiom-card--header-title card-header-title",
                                        children: title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "axiom-card--description description-container",
                                children: description && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "description",
                                    children: description
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "data-testid": "open-close-button",
                        className: "axiom-card--toggle-button open-close-button",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                            name: isExpanded ? 'caret-up' : 'caret-down'
                        })
                    })
                ]
            })
        });
    };
    const renderNonCollapsibleHeader = ()=>{
        const HEADING = `h${headingSize}`;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(HEADING, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "axiom-card--header cardHeader open",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "cardHeaderText",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "card-header-title-wrapper",
                            children: [
                                renderIcon(),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "axiom-card--header-title card-header-title",
                                    children: title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "axiom-card--description description-container",
                            children: description && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "description",
                                children: description
                            })
                        })
                    ]
                })
            })
        });
    };
    // Setting container class based on state.
    // [NOTE] The 'card-content-container-closed' is ONLY set during the initial render to fix a bug which allowed
    // users to tab into focusable elements in it's initalized state
    const cardContentClasses = [
        'axiom-card--content',
        'card-content'
    ];
    const cardContainerClasses = [
        'card-content-container'
    ];
    if (isExpanded) {
        cardContainerClasses.push('card-content-container-open');
        if (!hasBeenToggled) cardContentClasses.push('card-content--opened');
    } else if (!hasBeenToggled) cardContainerClasses.push('card-content-container-closed');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        "data-testid": "card",
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-card cardContainer'
            ],
            custom: classes,
            required: []
        }),
        "aria-label": title,
        children: [
            !hideTitle && (collapsible ? renderCollapsibleHeader() : renderNonCollapsibleHeader()),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: id,
                "data-testid": "card-contents",
                className: cardContentClasses.join(' '),
                ref: cardContentRef,
                style: {
                    height: contentHeight
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: cardContainerClasses.join(' '),
                    "data-testid": "card-content-container",
                    ref: contentContainerRef,
                    "aria-hidden": !isExpanded,
                    children: children
                })
            })
        ]
    });
};
$558a1874964eed3d$var$Card$1.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    hideTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    collapsible: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    headingSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    expanded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$CardJSX = $558a1874964eed3d$var$Card$1;
var $558a1874964eed3d$export$60332b2344f7fe41 = function(_a) {
    var title = _a.title, children = _a.children, _b = _a.classes, classes = _b === void 0 ? [] : _b, _c = _a.hideTitle, hideTitle = _c === void 0 ? false : _c, _d = _a.collapsible, collapsible = _d === void 0 ? false : _d, _e = _a.description, description = _e === void 0 ? undefined : _e, _f = _a.icon, icon = _f === void 0 ? undefined : _f, _g = _a.headingSize, headingSize = _g === void 0 ? 3 : _g, _h = _a.expanded, expanded = _h === void 0 ? true : _h, _j = _a.onChange, onChange = _j === void 0 ? function() {} : _j;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$CardJSX, {
        title: title,
        classes: classes,
        hideTitle: hideTitle,
        collapsible: collapsible,
        description: description,
        icon: icon,
        headingSize: headingSize,
        expanded: expanded,
        onChange: onChange,
        children: children
    });
};
$558a1874964eed3d$export$60332b2344f7fe41.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    hideTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    collapsible: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    headingSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    expanded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
const $558a1874964eed3d$var$CardRadio$1 = ({ id: id, name: name, label: label, value: value, onChange: onChange, title: title, disabled: disabled = false, inputRef: inputRef, checked: checked = false, icon: icon, subtext: subtext, subtitle: subtitle, footerText: footerText, footerList: footerList, attributes: attributes = {}, classes: classes = [] })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const propValidation = title || icon ? undefined : 'You have not provided content for the CardRadio.';
    if (propValidation) throw new Error(propValidation);
    const [currentPosition, setCurrentPosition] = (0, $acw62.useState)({
        x: 0,
        y: 0,
        size: 0
    });
    const [collapseHeight, setCollapseHeight] = (0, $acw62.useState)(null);
    const [showRipple, setShowRipple] = (0, $acw62.useState)(false);
    const [ref] = (0, $acw62.useState)((0, $acw62.useRef)());
    (0, $acw62.useEffect)(()=>{
        let timer;
        if (showRipple) timer = setTimeout(()=>{
            setShowRipple(false);
        }, 700);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        showRipple
    ]);
    const standardClasses = [
        'axiom-card-radio--icon-container',
        'icon-container'
    ];
    const titleClasses = [
        'axiom-card-radio--heading',
        'heading--semi-bold'
    ];
    const mobileSubTitle = [
        'axiom-card-radio--subtitle',
        'subtitle',
        'microcopy'
    ];
    const mobileSubText = [
        'axiom-card-radio--subtext',
        'subtext',
        'microcopy--2'
    ];
    const radioSetSelect = [
        'axiom-card-radio-set',
        'card-radio-set'
    ];
    if (checked) radioSetSelect.push('set-focus');
    if (!checked) radioSetSelect.push('set-radio-focus');
    if (disabled) radioSetSelect.push('set-disabled');
    if (checked && disabled) radioSetSelect.push('set-focus-disabled');
    if (icon && !title && !subtext && !subtitle) {
        standardClasses.push('icon-only');
        titleClasses.push('with-icon');
    }
    if (icon && (title || subtext || subtitle)) standardClasses.push('icon-with-title');
    if (title && !icon && !subtext) titleClasses.push('only-heading');
    if (title && !icon && (subtext || subtitle)) titleClasses.push('only-heading-subtext');
    if (title && icon) titleClasses.push('with-icon-title');
    if (title && icon && (subtext || subtitle)) {
        mobileSubTitle.push('with-icon');
        mobileSubText.push('with-icon');
        titleClasses.push('with-icon-all');
    }
    const cardClasses = [
        'axiom-card-radio--input',
        'card-input'
    ];
    if (footerText || footerList) cardClasses.push('has-footer');
    const collapseContent = (0, $acw62.useRef)(null);
    const setAnimatePosition = (event)=>{
        const currentEle = ref.current.getBoundingClientRect();
        const size = currentEle.width > currentEle.height ? currentEle.width : currentEle.height;
        const x = event.clientX - currentEle.left - size / 2;
        const y = event.clientY - currentEle.top - size / 2;
        return {
            x: x,
            y: y,
            size: size
        };
    };
    const handleClick = (event)=>{
        const { target: target } = event;
        const collapsibleIsClicked = target.closest('.collapsible--content') !== null;
        if (!disabled && !collapsibleIsClicked) {
            const position = setAnimatePosition(event);
            setCurrentPosition(position);
            setShowRipple(true);
        }
    };
    const handleChange = (e)=>{
        if (e.target && e.target.nodeName !== 'BUTTON' && e.target.nodeName !== 'svg' && e.target.nodeName !== 'use' && !e.target.classList.contains('axiom-button--label') && !e.target.classList.contains('axiom-button') && !e.target.classList.contains('axiom-ripple') && !disabled) {
            onChange(value);
            handleClick(e);
        }
    };
    const handleKeyEvent = (event)=>{
        if ([
            'Enter',
            'Space'
        ].includes(event.code) && document.activeElement === ref.current && !disabled) {
            onChange(value);
            handleClick(event);
            return;
        }
        if (event.code === 'ArrowRight' && ref.current.parentElement.nextSibling) ref.current.parentElement.nextSibling.children[0].focus();
        if (event.code === 'ArrowLeft' && ref.current.parentElement.previousSibling) ref.current.parentElement.previousSibling.children[0].focus();
    };
    const getCollapseHeight = ()=>{
        if (collapseContent.current) setCollapseHeight(collapseContent.current.getBoundingClientRect().height);
    };
    const handleButtonClick = ()=>{
        setCollapseHeight(collapseContent.current.getBoundingClientRect().height);
        setIsOpen(!isOpen);
    };
    const resizeTimerRef = (0, $acw62.useRef)();
    const handleResize = ()=>{
        clearTimeout(resizeTimerRef.current);
        resizeTimerRef.current = setTimeout(getCollapseHeight, 500);
    };
    (0, $acw62.useEffect)(()=>{
        const options = {
            passive: true
        };
        window.addEventListener('resize', handleResize, options);
        return ()=>{
            clearTimeout(resizeTimerRef.current);
            window.removeEventListener('resize', handleResize, options);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const { current: current } = ref;
        current.addEventListener('click', handleChange);
        current.addEventListener('keydown', handleKeyEvent);
        return ()=>{
            current.removeEventListener('click', handleChange);
            current.removeEventListener('keydown', handleKeyEvent);
        };
    }, [
        disabled
    ]);
    const tabIndex = -1;
    const renderFooterList = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            children: footerList && Array.isArray(footerList) ? footerList.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    className: "microcopy",
                    children: item
                }, item)) : /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "microcopy",
                children: footerList
            })
        });
    const renderFooterText = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "microcopy--2",
            children: footerText
        });
    const renderFooter = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "axiom-card-radio--footer card-input--footer",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                    icon: isOpen ? 'caret-up' : 'caret-down',
                    styleVariant: "tertiary",
                    iconPosition: "right",
                    label: isOpen ? 'Hide details' : 'Learn more',
                    onClick: handleButtonClick,
                    classes: "axiom-card-radio--footer-button",
                    attributes: {
                        'data-testid': 'footerButton',
                        'tabIndex': tabIndex + 1,
                        'aria-expanded': !!isOpen
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `axiom-card-radio--collapsible collapsible ${isOpen ? 'axiom-card-radio--collapsible-open open' : 'axiom-card-radio--collapsible-close close'}`,
                    "aria-hidden": !isOpen,
                    style: {
                        maxHeight: isOpen ? collapseHeight : 0
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "axiom-card-radio--collapsible-content collapsible--content",
                        ref: collapseContent,
                        children: [
                            footerList && renderFooterList(),
                            footerText && renderFooterText()
                        ]
                    })
                })
            ]
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: $558a1874964eed3d$var$createClassList({
            default: radioSetSelect,
            custom: classes,
            required: []
        }),
        "data-testid": "radioCard_parent",
        ref: ref,
        tabIndex: tabIndex + 1,
        "aria-disabled": disabled,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                className: "screen-reader-only",
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "radio",
                "data-testid": "CardRadio",
                id: id,
                name: name,
                value: value,
                disabled: disabled,
                checked: checked,
                ref: inputRef,
                className: "axiom-card-radio--input-element card-input-element",
                tabIndex: tabIndex,
                onChange: onChange,
                ...attributes
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: cardClasses.join(' '),
                children: [
                    showRipple && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "ripple--effect",
                        "data-testid": "ripple-effect",
                        style: {
                            width: currentPosition.size,
                            height: currentPosition.size,
                            left: `${currentPosition.x}px`,
                            top: `${currentPosition.y}px`
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "axiom-card-radio--input-main-content card-input--main-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: standardClasses.join(' '),
                                children: [
                                    icon && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                                        name: icon
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: titleClasses.join(' '),
                                        children: title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: mobileSubTitle.join(' '),
                                children: subtitle
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: mobileSubText.join(' '),
                                children: subtext && Array.isArray(subtext) ? subtext.map((obj)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: obj
                                    }, obj)) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: subtext
                                })
                            })
                        ]
                    })
                ]
            }),
            footerText || footerList ? renderFooter() : null
        ]
    });
};
$558a1874964eed3d$var$CardRadio$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    subtext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    subtitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    footerText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    footerList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$CardRadio$2 = $558a1874964eed3d$var$CardRadio$1;
var $558a1874964eed3d$export$55667ff3e8e3f359 = function(_a) {
    var id = _a.id, name = _a.name, label = _a.label, value = _a.value, onChange = _a.onChange, _b = _a.title, title = _b === void 0 ? undefined : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.inputRef, inputRef = _d === void 0 ? undefined : _d, _e = _a.checked, checked = _e === void 0 ? false : _e, _f = _a.icon, icon = _f === void 0 ? undefined : _f, _g = _a.subtext, subtext = _g === void 0 ? undefined : _g, _h = _a.subtitle, subtitle = _h === void 0 ? undefined : _h, _j = _a.footerText, footerText = _j === void 0 ? undefined : _j, _k = _a.footerList, footerList = _k === void 0 ? undefined : _k, _l = _a.attributes, attributes = _l === void 0 ? {} : _l, _m = _a.classes, classes = _m === void 0 ? [] : _m;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$CardRadio$2, {
        id: id,
        name: name,
        title: title,
        value: value,
        disabled: disabled,
        onChange: onChange,
        inputRef: inputRef,
        checked: checked,
        icon: icon,
        subtext: subtext,
        subtitle: subtitle,
        footerText: footerText,
        footerList: footerList,
        label: label,
        attributes: attributes,
        classes: classes
    });
};
$558a1874964eed3d$export$55667ff3e8e3f359.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    subtext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    subtitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    footerText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    footerList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$CardRadioGroup$1 = ({ name: name, cards: cards, onChange: onChange, gridColClasses: gridColClasses = [
    'col__4'
], classes: classes = [] })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "CardRadioGroup",
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-grid',
                'axiom-card-radio-group'
            ],
            custom: classes,
            required: []
        }),
        children: cards.map((card)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: gridColClasses.concat([
                    'grid--col'
                ]).join(' '),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$CardRadio$2, {
                    id: card.id,
                    name: name,
                    label: card.label,
                    title: card.title,
                    subtext: card.subtext,
                    subtitle: card.subtitle,
                    value: card.value,
                    disabled: card.disabled,
                    onChange: onChange,
                    inputRef: card.inputRef,
                    checked: card.checked,
                    icon: card.icon,
                    footerText: card.footerText,
                    footerList: card.footerList,
                    attributes: card.attributes
                })
            }, card.value))
    });
$558a1874964eed3d$var$CardRadioGroup$1.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    cards: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        subtext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
        ]),
        subtitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
            })
        ]),
        checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        footerText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        footerList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
    })).isRequired,
    gridColClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$CardRadioGroupJSX = $558a1874964eed3d$var$CardRadioGroup$1;
var $558a1874964eed3d$export$1d9493806cb71db5 = function(_a) {
    var name = _a.name, cards = _a.cards, onChange = _a.onChange, _b = _a.gridColClasses, gridColClasses = _b === void 0 ? [
        'col__4'
    ] : _b, _c = _a.classes, classes = _c === void 0 ? [] : _c;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$CardRadioGroupJSX, {
        name: name,
        cards: cards,
        onChange: onChange,
        gridColClasses: gridColClasses,
        classes: classes
    });
};
$558a1874964eed3d$export$1d9493806cb71db5.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    cards: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        subtext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
        ]),
        subtitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
            })
        ]),
        checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        footerText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        footerList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
        ]),
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
    })).isRequired,
    gridColClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$Checkbox$1 = ({ id: id, name: name, label: label, checked: checked, onChange: onChange, disabled: disabled = false, inputRef: inputRef, hideLabel: hideLabel = false, indeterminate: indeterminate = false, attributes: attributes = {}, condensed: condensed = false, classes: classes = [] })=>{
    const defaultClasses = [
        'axiom-checkbox-set checkbox-set'
    ];
    if (indeterminate === true) defaultClasses.push('indeterminate');
    if (condensed === true) defaultClasses.push('condensed');
    const [isChecked, setIsChecked] = (0, $acw62.useState)(checked);
    const handleChange = (e)=>{
        const stopPropagation = onChange(e.target.value);
        if (!stopPropagation) setIsChecked(!isChecked);
    };
    (0, $acw62.useEffect)(()=>setIsChecked(checked), [
        checked
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "checkbox-input-container",
        className: $558a1874964eed3d$var$createClassList({
            default: defaultClasses,
            custom: classes,
            required: []
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "checkbox",
                id: id,
                name: name,
                value: label,
                disabled: disabled,
                onChange: handleChange,
                checked: isChecked,
                "aria-checked": // eslint-disable-next-line no-nested-ternary
                indeterminate ? 'mixed' : isChecked ? 'true' : 'false',
                "data-testid": "checkbox-input",
                ref: inputRef,
                ...attributes
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                htmlFor: id,
                className: "axiom-input-label--checkbox",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "axiom-checkbox--box",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "22px",
                            height: "22px",
                            viewBox: "0 0 22 22",
                            children: indeterminate ? /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M15 10C15.8284 10 16.5 10.6716 16.5 11.5C16.5 12.2797 15.9051 12.9204 15.1445 12.9931L15 13H7C6.17157 13 5.5 12.3284 5.5 11.5C5.5 10.7203 6.09489 10.0796 6.85554 10.0069L7 10H15Z",
                                stroke: "none"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M4.40002 12.5345L7.09392 16.3625C7.31392 16.676 7.65492 16.8641 8.02012 16.874C8.38642 16.885 8.73622 16.7178 8.97162 16.4197L17.6 5.5",
                                strokeWidth: "3",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                fill: "none"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: hideLabel ? 'screen-reader-only' : null,
                        children: label
                    })
                ]
            })
        ]
    });
};
$558a1874964eed3d$var$Checkbox$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    indeterminate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$Checkbox$2 = $558a1874964eed3d$var$Checkbox$1;
var $558a1874964eed3d$export$48513f6b9f8ce62d = function(_a) {
    var id = _a.id, name = _a.name, label = _a.label, checked = _a.checked, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.inputRef, inputRef = _c === void 0 ? undefined : _c, _d = _a.hideLabel, hideLabel = _d === void 0 ? false : _d, _e = _a.indeterminate, indeterminate = _e === void 0 ? false : _e, _f = _a.attributes, attributes = _f === void 0 ? {} : _f, _g = _a.condensed, condensed = _g === void 0 ? false : _g, _h = _a.classes, classes = _h === void 0 ? [] : _h;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$Checkbox$2, {
        id: id,
        name: name,
        label: label,
        checked: checked,
        disabled: disabled,
        onChange: onChange,
        inputRef: inputRef,
        hideLabel: hideLabel,
        indeterminate: indeterminate,
        attributes: attributes,
        condensed: condensed,
        classes: classes
    });
};
$558a1874964eed3d$export$48513f6b9f8ce62d.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    indeterminate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$Fieldset = ({ children: children, id: id, legend: legend, legendModifier: legendModifier, error: error = {
    code: undefined,
    message: undefined
}, microcopy: microcopy, horizontal: horizontal = false, condensed: condensed = false, classes: classes = [], role: role })=>{
    const generatededId = (0, $acw62.useId)();
    const elementId = id || generatededId;
    const defaultClasses = [
        'field-set'
    ];
    // NOTE:
    // Error logic and structure carried directly from InputControl
    // to maintain consistency in use of errors. .input-control named
    // classes maintained to minimize the reproduction of styling.
    let errorContent = '';
    let microcopyContent = '';
    let requiredClasses = [];
    let legendClasses = [
        'field-set--legend',
        'input-label'
    ];
    if (error.message) {
        requiredClasses = [
            ...requiredClasses,
            'field-set--error',
            'input-control--error'
        ];
        legendClasses = [
            ...legendClasses,
            'input-label--error'
        ];
        errorContent = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            id: `${elementId}_error`,
            className: "input-control--error--message error--message",
            children: error.message
        }, `${elementId}_error`);
    }
    if (!error.message && microcopy) {
        const microcopyClasses = [
            'input-control--microcopy'
        ];
        microcopyContent = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            id: `${elementId}_microcopy`,
            className: microcopyClasses.join(' '),
            children: microcopy
        }, `${elementId}_microcopy`);
    }
    const messages = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "field-set--messages input-control--messages",
            id: `${elementId}_messages`,
            children: [
                errorContent,
                microcopyContent
            ]
        });
    if (horizontal) defaultClasses.push('field-set--horizontal');
    if (condensed) defaultClasses.push('field-set--condensed');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
        className: $558a1874964eed3d$var$createClassList({
            default: defaultClasses,
            custom: classes,
            required: requiredClasses
        }),
        id: elementId,
        "data-testid": "field-set",
        "aria-required": legendModifier === 'required' ? true : null,
        "aria-describedby": error.message || microcopy ? `${elementId}_messages` : null,
        "aria-invalid": error.message ? true : null,
        role: role,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("legend", {
                className: legendClasses.join(' '),
                children: [
                    error.message && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                        name: "notice-error"
                    }),
                    legendModifier === 'required' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "field-set--required input-label--required",
                        "aria-hidden": "true",
                        children: "*"
                    }),
                    legend,
                    legendModifier === 'optional' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "field-set--optional input-label--optional",
                        children: ' (Optional)'
                    })
                ]
            }),
            children,
            (errorContent || microcopyContent) && messages()
        ]
    });
};
$558a1874964eed3d$var$Fieldset.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    legendModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        code: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        message: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $558a1874964eed3d$var$Fieldset$1 = $558a1874964eed3d$var$Fieldset;
const $558a1874964eed3d$var$useIsMounted = ()=>{
    const isMounted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted.current;
};
var $558a1874964eed3d$var$useIsMounted$1 = $558a1874964eed3d$var$useIsMounted;
const $558a1874964eed3d$var$ChecklistGroup$1 = ({ options: options, onChange: onChange, groupLabel: groupLabel, groupName: groupName, id: id, legend: legend, legendModifier: legendModifier, error: error = {
    code: undefined,
    message: undefined
}, microcopy: microcopy, horizontal: horizontal = false, condensed: condensed = false, classes: classes = [], removeIndeterminateParent: removeIndeterminateParent = false })=>{
    const [parentCheck, setParentCheck] = (0, $acw62.useState)(false);
    const [indeterminate, setIndeterminate] = (0, $acw62.useState)(false);
    const [disabledGroup, setDisabledGroup] = (0, $acw62.useState)(false);
    const [childOptions, setChildOptions] = (0, $acw62.useState)(options);
    const isMounted = $558a1874964eed3d$var$useIsMounted$1();
    const parentRef = (0, $acw62.useRef)();
    const checkAndSetIndeterminateAndParent = (indeterminateOptions)=>{
        const checkedOptions = indeterminateOptions.filter((option)=>option.checked === true);
        if (checkedOptions.length === 0) {
            // Nothing is checked
            setIndeterminate(false);
            setParentCheck(false);
            parentRef.current.indeterminate = false;
        } else if (indeterminateOptions.length === checkedOptions.length) {
            // Everything is checked
            setIndeterminate(false);
            setParentCheck(true);
            parentRef.current.indeterminate = false;
        } else {
            // Few is checked
            setIndeterminate(true);
            setParentCheck(false);
            parentRef.current.indeterminate = true;
        }
    };
    const checkAndSetDisabledGroup = (disabledOptions)=>{
        const allOptionsDisabled = disabledOptions.every((option)=>option.disabled === true);
        allOptionsDisabled ? setDisabledGroup(true) : setDisabledGroup(false);
    };
    /**
   * Common functionality for both parent and child options events.
   */ const changeOptionCheck = (value)=>{
        const reassignedOptions = [];
        childOptions.forEach((element)=>{
            const newElement = element;
            if (!element.disabled) {
                if (value === groupLabel) /**
           * This block executes when parent checkbox event is fired.
           */ newElement.checked = !parentCheck;
                else if (element.label === value) /**
           * This block executes when child option checkbox event is fired.
           */ newElement.checked = !newElement.checked;
            }
            reassignedOptions.push(newElement);
        });
        setChildOptions(reassignedOptions);
        return true;
    };
    (0, $acw62.useEffect)(()=>{
        if (childOptions) {
            if (!removeIndeterminateParent) {
                checkAndSetIndeterminateAndParent(childOptions);
                checkAndSetDisabledGroup(childOptions);
            }
            isMounted && onChange(childOptions);
        }
    }, [
        childOptions
    ]);
    (0, $acw62.useEffect)(()=>{
        options !== childOptions && setChildOptions(options);
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Fieldset$1, {
        id: id,
        legend: legend,
        legendModifier: legendModifier,
        error: error,
        microcopy: microcopy,
        horizontal: horizontal,
        classes: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-checklist-group--set'
            ],
            custom: classes
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "axiom-checklist--set field-set--checklist-group",
            children: [
                !removeIndeterminateParent && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Checkbox$2, {
                    id: [
                        id,
                        'parent'
                    ].join(''),
                    label: groupLabel,
                    name: groupName,
                    checked: parentCheck,
                    indeterminate: indeterminate,
                    onChange: changeOptionCheck,
                    condensed: condensed,
                    classes: "axiom-checklist--parent",
                    disabled: disabledGroup,
                    inputRef: parentRef
                }),
                childOptions && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: $558a1874964eed3d$var$createClassList({
                        default: [
                            'axiom-checklist--group',
                            'checklist--group'
                        ],
                        required: []
                    }),
                    children: childOptions.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Checkbox$2, {
                            id: [
                                id,
                                option.id
                            ].join(''),
                            label: option.label,
                            name: option.name,
                            checked: option.checked,
                            disabled: option.disabled,
                            hideLabel: option.hideLabel,
                            onChange: changeOptionCheck,
                            inputRef: option.inputRef,
                            attributes: option.attributes,
                            condensed: condensed
                        }, option.id))
                })
            ]
        })
    });
};
$558a1874964eed3d$var$ChecklistGroup$1.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    groupLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
            })
        ]),
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
    })).isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    groupName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    legendModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        code: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        message: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    removeIndeterminateParent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $558a1874964eed3d$var$ChecklistGroupJSX = $558a1874964eed3d$var$ChecklistGroup$1;
var $558a1874964eed3d$export$29aba383c962bde8 = function(_a) {
    var options = _a.options, onChange = _a.onChange, groupLabel = _a.groupLabel, groupName = _a.groupName, _b = _a.id, id = _b === void 0 ? undefined : _b, _c = _a.legend, legend = _c === void 0 ? undefined : _c, _d = _a.legendModifier, legendModifier = _d === void 0 ? undefined : _d, _e = _a.error, error = _e === void 0 ? {
        code: undefined,
        message: undefined
    } : _e, _f = _a.microcopy, microcopy = _f === void 0 ? undefined : _f, _g = _a.horizontal, horizontal = _g === void 0 ? false : _g, _h = _a.condensed, condensed = _h === void 0 ? false : _h, _j = _a.classes, classes = _j === void 0 ? [] : _j, _k = _a.removeIndeterminateParent, removeIndeterminateParent = _k === void 0 ? true : _k;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$ChecklistGroupJSX, {
        id: id,
        groupName: groupName,
        legend: legend,
        onChange: onChange,
        groupLabel: groupLabel,
        options: options,
        legendModifier: legendModifier,
        error: error,
        microcopy: microcopy,
        horizontal: horizontal,
        condensed: condensed,
        classes: classes,
        removeIndeterminateParent: removeIndeterminateParent
    });
};
$558a1874964eed3d$export$29aba383c962bde8.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    groupLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
            })
        ]),
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
    })).isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    groupName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    legendModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        code: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        message: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    removeIndeterminateParent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
/* eslint-disable max-len */ const $558a1874964eed3d$var$defaultBarRadius = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($gmF1g))).lightmodeBarchartBarBorderRadius, 10);
const $558a1874964eed3d$var$ColumnChart$1 = ({ data: data, labelField: labelField, valueField: valueField, figureAlt: figureAlt, title: title = {
    headingSize: undefined,
    id: undefined
}, description: description = {
    id: undefined
}, xAxisLabel: xAxisLabel = null, yAxisLabel: yAxisLabel = null, range: range = {
    min: undefined,
    max: undefined
}, valueType: valueType = 'number', height: height = 400, columnColor: columnColor = 'luna', columnGap: columnGap = 30, columnRadius: columnRadius = $558a1874964eed3d$var$defaultBarRadius, classes: classes = [] })=>{
    const [horizontalOffset, setHorizontalOffset] = (0, $acw62.useState)(0);
    const [horizontalLabels, setHorizontalLabels] = (0, $acw62.useState)([]);
    const [verticalOffset, setVerticalOffset] = (0, $acw62.useState)(0);
    const [verticalLabels, setVerticalLabels] = (0, $acw62.useState)([]);
    const [plotWidth, setPlotWidth] = (0, $acw62.useState)(0);
    const horizontalLabelRef = (0, $acw62.useRef)();
    let columnWidth;
    let actualPlotWidth;
    let actualColumnGap = columnGap;
    let svgPadding = actualColumnGap;
    const svgHeight = height;
    const chartRef = (0, $acw62.useRef)();
    const plotRef = (0, $acw62.useRef)();
    const columnRefs = (0, $acw62.useRef)([]);
    const valueFieldList = $558a1874964eed3d$var$initializeValueFields([
        valueField
    ]);
    const plotRange = $558a1874964eed3d$var$getAdjustedRange({
        data: data,
        range: range,
        valueType: valueType,
        valueFields: valueFieldList
    });
    const chartMetadata = $558a1874964eed3d$var$getChartMetadata({
        data: data,
        labelField: labelField,
        height: height,
        horizontalLabels: horizontalLabels,
        horizontalOffset: horizontalOffset,
        verticalOffset: verticalOffset,
        verticalLabels: verticalLabels,
        valueFields: valueFieldList,
        adjustedRange: plotRange,
        chartPadding: svgPadding
    });
    const setPlotDimensions = ()=>{
        setHorizontalOffset(horizontalLabelRef.current.getBoundingClientRect().x);
        setVerticalOffset(plotRef.current.getBoundingClientRect().y);
        setHorizontalLabels(Array.from(chartRef.current.querySelectorAll('.column-chart--column-label')).map((domColumn)=>domColumn.getBoundingClientRect()));
        setVerticalLabels(Array.from(chartRef.current.querySelectorAll('.data-viz--horizontal-label')).map((domColumn)=>domColumn.getBoundingClientRect()));
        const renderedPlotWidth = plotRef.current.getBoundingClientRect().width;
        setPlotWidth(renderedPlotWidth);
    };
    const getColumnWidth = ()=>{
        const totalColumnGaps = actualColumnGap * (data.length - 1);
        const plotPadding = svgPadding * 2;
        actualPlotWidth = plotWidth - totalColumnGaps - plotPadding;
        columnWidth = actualPlotWidth / data.length;
        const minColumnWidth = columnRadius * 2 > 8 && columnRadius * 2 < actualPlotWidth / data.length > 8 ? columnRadius * 2 : 8;
        const maxColumnWidth = actualPlotWidth / data.length;
        let columnWidthDifference = null;
        if (columnWidth > maxColumnWidth) {
            columnWidthDifference = columnWidth - maxColumnWidth;
            columnWidth = maxColumnWidth;
        } else if (columnWidth < minColumnWidth) {
            columnWidthDifference = columnWidth - minColumnWidth;
            columnWidth = minColumnWidth;
        }
        actualColumnGap += columnWidthDifference;
        svgPadding += columnWidthDifference / 2;
    };
    const renderColumn = ({ position: position, id: id, width: width, colHeight: colHeight })=>{
        let columnRadiusFinal;
        if (columnRadius > columnWidth / 2) columnRadiusFinal = columnWidth / 2;
        else columnRadiusFinal = columnRadius;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
            className: [
                `axiom-plot-column plot--column plot--column--${columnColor}`
            ].join(' '),
            id: `column${id}`,
            ref: (column)=>{
                columnRefs.current[id] = column;
            },
            width: width,
            height: colHeight,
            x: position.x,
            y: position.y,
            rx: columnRadiusFinal,
            ry: columnRadiusFinal
        }, `column${id}`);
    };
    const renderColumnsGroup = ({ field: field, plotPoints: plotPoints, dataValues: dataValues })=>{
        const dataPoints = plotPoints[field.id];
        const values = dataValues[field.id];
        const columns = [];
        getColumnWidth();
        const columnsData = dataPoints.map((d, i)=>{
            const value = values[i];
            const columnX = svgPadding + (columnWidth + actualColumnGap) * i;
            const columnHeight = d.y;
            const columnY = svgHeight - columnHeight;
            return {
                id: i,
                x: columnX,
                y: columnY,
                width: columnWidth,
                colHeight: columnHeight,
                values: values,
                value: value
            };
        });
        columnsData.forEach((column)=>{
            const { x: x, y: y, id: id, width: width, colHeight: colHeight } = column;
            columns.push(renderColumn({
                position: {
                    x: x,
                    y: y
                },
                id: id,
                width: width,
                colHeight: colHeight
            }));
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
            className: "axiom-column-chart-group column-chart-group",
            children: columns
        }, 'columns');
    };
    (0, $acw62.useEffect)(()=>{
        if (plotRef.current) setPlotDimensions();
    }, [
        plotRef.current,
        xAxisLabel,
        yAxisLabel
    ]);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener('resize', setPlotDimensions);
        return ()=>{
            window.removeEventListener('resize', setPlotDimensions);
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        ref: chartRef,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-column-chart column-chart'
            ],
            custom: classes,
            required: []
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "axiom-data-viz--legend data-viz-legend",
                "aria-hidden": "false",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$DataVizLegend$1, {
                    title: title,
                    description: description
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "axiom-column-chart--y-label column-chart--y-label",
                "aria-hidden": "true",
                children: yAxisLabel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "axiom-column-chart--horizontal-line-labels column-chart--horizontal-line-labels",
                "aria-hidden": "true",
                children: chartMetadata.yLabels.map((yLabel)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-data-viz--horizontal-label data-viz--horizontal-label",
                        children: yLabel.value
                    }, `column-chart--horizontal-line-label-${yLabel.value}`))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "img",
                className: "axiom-column-chart--plot column-chart--plot",
                "aria-label": figureAlt,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    ref: plotRef,
                    height: height,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                            transform: `scale(1 -1) translate(0 -${height})`,
                            children: chartMetadata.yLabels.map((yLabel)=>/*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                    className: "axiom-column-chart--horizontal-line column-chart--horizontal-line",
                                    x1: "0%",
                                    x2: "100%",
                                    y1: yLabel.position,
                                    y2: yLabel.position
                                }, `column-chart--horizontal-line-${yLabel.value}`))
                        }, 'column-chart--origin-transform'),
                        valueFieldList.map((field)=>renderColumnsGroup({
                                field: field,
                                plotPoints: chartMetadata.plotPoints,
                                dataValues: chartMetadata.dataValues
                            }))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-hidden": "true",
                ref: horizontalLabelRef,
                className: "axiom-column-chart--x-labels column-chart--x-labels",
                style: {
                    padding: `0 ${svgPadding}px`
                },
                children: [
                    chartMetadata.xLabels.map((xLabel)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "axiom-column-chart--column-label column-chart--column-label",
                            style: {
                                width: columnWidth
                            },
                            children: xLabel
                        }, `column-chart--column-label-${xLabel}`)),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-column-chart--x-label column-chart--x-label",
                        children: xAxisLabel || labelField
                    })
                ]
            })
        ]
    });
};
var $558a1874964eed3d$var$ColumnChartJSX = $558a1874964eed3d$var$ColumnChart$1;
$558a1874964eed3d$var$ColumnChart$1.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any).isRequired,
    labelField: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    valueField: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    figureAlt: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            headingSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                1,
                2,
                3,
                4,
                5,
                6
            ]),
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ]),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
        })
    ]),
    xAxisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    yAxisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    valueType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'percent',
        'dollar',
        'number'
    ]),
    range: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        min: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                expansionRule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                    'strict',
                    'loose'
                ])
            })
        ]),
        max: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                expansionRule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                    'strict',
                    'loose'
                ])
            })
        ])
    }),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    columnColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'luna',
        'sunflower',
        'sienna',
        'jade',
        'vividCerulean',
        'brick',
        'mardiGras',
        'rose'
    ]),
    columnGap: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    columnRadius: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$export$c4ca08ccc3b89ec8 = function(_a) {
    var data = _a.data, labelField = _a.labelField, valueField = _a.valueField, figureAlt = _a.figureAlt, _b = _a.title, title = _b === void 0 ? undefined : _b, _c = _a.description, description = _c === void 0 ? undefined : _c, _d = _a.xAxisLabel, xAxisLabel = _d === void 0 ? null : _d, _e = _a.yAxisLabel, yAxisLabel = _e === void 0 ? null : _e, _f = _a.range, range = _f === void 0 ? {
        min: undefined,
        max: undefined
    } : _f, _g = _a.valueType, valueType = _g === void 0 ? 'number' : _g, _h = _a.height, height = _h === void 0 ? 400 : _h, _j = _a.columnColor, columnColor = _j === void 0 ? 'luna' : _j, _k = _a.columnGap, columnGap = _k === void 0 ? 30 : _k, _l = _a.columnRadius, columnRadius = _l === void 0 ? 4 : _l, _m = _a.classes, classes = _m === void 0 ? [] : _m;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$ColumnChartJSX, {
        data: data,
        labelField: labelField,
        title: title,
        description: description,
        xAxisLabel: xAxisLabel,
        yAxisLabel: yAxisLabel,
        valueField: valueField,
        valueType: valueType,
        figureAlt: figureAlt,
        range: range,
        height: height,
        columnColor: columnColor,
        columnGap: columnGap,
        columnRadius: columnRadius,
        classes: classes
    });
};
$558a1874964eed3d$export$c4ca08ccc3b89ec8.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any).isRequired,
    labelField: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    valueField: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    figureAlt: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            headingSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                1,
                2,
                3,
                4,
                5,
                6
            ]),
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ]),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
        })
    ]),
    xAxisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    yAxisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    valueType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'percent',
        'dollar',
        'number'
    ]),
    range: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        min: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                expansionRule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                    'strict',
                    'loose'
                ])
            })
        ]),
        max: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                expansionRule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                    'strict',
                    'loose'
                ])
            })
        ])
    }),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    columnColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'luna',
        'sunflower',
        'sienna',
        'jade',
        'vividCerulean',
        'brick',
        'mardiGras',
        'rose'
    ]),
    columnGap: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    columnRadius: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$Dialog$1 = ({ title: title, children: children, open: open, onRequestClose: onRequestClose, onAfterClose: onAfterClose, role: role = 'dialog', icon: icon, ariaDescribedBy: ariaDescribedBy, className: className, classes: classes = [], parentSelector: parentSelector, buttons: buttons = [] })=>{
    const dialogTitleId = (0, $5sKyw.default)();
    const standardClasses = className ? [
        'axiom-dialog',
        'dialog',
        className
    ] : [
        'axiom-dialog',
        'dialog'
    ];
    // Note: className prop included to avoid breaking change
    const classGroup = $558a1874964eed3d$var$createClassList({
        default: standardClasses,
        custom: classes,
        required: []
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: open,
        overlayClassName: "dialog--overlay",
        bodyOpenClassName: "ReactDialog__Body--open",
        className: classGroup,
        onRequestClose: onRequestClose,
        onAfterClose: onAfterClose,
        contentLabel: title,
        aria: {
            modal: true,
            labelledby: dialogTitleId,
            describedby: ariaDescribedBy
        },
        closeTimeoutMS: 300,
        ariaHideApp: false,
        parentSelector: parentSelector,
        role: role,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "axiom-dialog--body dialog--body",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: onRequestClose,
                            className: "axiom-dialog--body--close dialog--body--close",
                            "aria-label": "Close Dialog",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                                name: "close-sm"
                            })
                        }),
                        icon && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                            name: icon
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "axiom-dialog--body--content dialog--body--content",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("header", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        id: dialogTitleId,
                                        className: "axiom-dialog--body--content--title dialog--body--content--title",
                                        children: title
                                    })
                                }),
                                children
                            ]
                        })
                    ]
                }),
                buttons.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("footer", {
                    className: "axiom-dialog--actions dialog--actions",
                    "data-testid": "dialog-actions",
                    children: buttons.map(({ text: text, styleVariant: // TODO - Figure out why this is text instead of label to match ButtonProps
                    styleVariant, onClick: onClick, attributes: attributes, disabled: disabled, loading: loading, icon: buttonIconProperty, inputRef: // scope conflict
                    inputRef, iconPosition: iconPosition, iconOnly: iconOnly }, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                                label: text,
                                onClick: onClick,
                                styleVariant: styleVariant || 'secondary',
                                attributes: attributes,
                                disabled: disabled,
                                loading: loading,
                                icon: buttonIconProperty,
                                inputRef: inputRef,
                                iconPosition: iconPosition,
                                iconOnly: iconOnly,
                                classes: "axiom-dialog--actions-button"
                            })
                        }, `${text + index}`))
                })
            ]
        })
    });
};
$558a1874964eed3d$var$Dialog$1.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    onRequestClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    ariaDescribedBy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    parentSelector: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onAfterClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    buttons: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        text: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        styleVariant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'primary',
            'secondary',
            'tertiary',
            'reversed-primary',
            'reversed-secondary',
            'destructive-primary',
            'destructive-secondary',
            'destructive-tertiary'
        ]),
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
            })
        ]),
        iconPosition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'left',
            'right'
        ]),
        iconOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    }))
};
var $558a1874964eed3d$var$Dialog$2 = $558a1874964eed3d$var$Dialog$1;
const $558a1874964eed3d$var$ConfirmationDialog$1 = ({ title: title, message: message, open: open, leftButtonText: leftButtonText, onLeftButtonClick: onLeftButtonClick, rightButtonText: rightButtonText, onRightButtonClick: onRightButtonClick, onRequestClose: onRequestClose, parentSelector: parentSelector, className: className, classes: classes = [] })=>{
    const buttons = [
        {
            text: leftButtonText,
            onClick: onLeftButtonClick
        },
        {
            text: rightButtonText,
            onClick: onRightButtonClick
        }
    ];
    const standardClasses = className ? [
        'axiom-confirmation-dialog',
        'confirmation-dialog',
        className
    ] : [
        'axiom-confirmation-dialog',
        'confirmation-dialog'
    ];
    // Note: className prop included to avoid breaking change
    return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Dialog$2, {
        icon: "notice-warning",
        role: "alertdialog",
        title: title,
        open: open,
        buttons: buttons,
        onRequestClose: onRequestClose,
        className: $558a1874964eed3d$var$createClassList({
            default: standardClasses,
            custom: classes,
            required: []
        }),
        parentSelector: parentSelector,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: message
        })
    });
};
$558a1874964eed3d$var$ConfirmationDialog$1.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    message: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    leftButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onLeftButtonClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    rightButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onRightButtonClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    onRequestClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    parentSelector: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$ConfirmationDialogJSX = $558a1874964eed3d$var$ConfirmationDialog$1;
var $558a1874964eed3d$export$b8704437d11c7fe7 = function(_a) {
    var title = _a.title, message = _a.message, open = _a.open, leftButtonText = _a.leftButtonText, onLeftButtonClick = _a.onLeftButtonClick, rightButtonText = _a.rightButtonText, onRightButtonClick = _a.onRightButtonClick, onRequestClose = _a.onRequestClose, _b = _a.parentSelector, parentSelector = _b === void 0 ? undefined : _b, _c = _a.className, className = _c === void 0 ? undefined : _c, _d = _a.classes, classes = _d === void 0 ? [] : _d;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$ConfirmationDialogJSX, {
        title: title,
        message: message,
        open: open,
        className: className,
        leftButtonText: leftButtonText,
        onLeftButtonClick: onLeftButtonClick,
        rightButtonText: rightButtonText,
        onRightButtonClick: onRightButtonClick,
        onRequestClose: onRequestClose,
        parentSelector: parentSelector,
        classes: classes
    });
};
$558a1874964eed3d$export$b8704437d11c7fe7.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    message: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    leftButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onLeftButtonClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    rightButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onRightButtonClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    onRequestClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    parentSelector: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$isStaticDateHoliday = (holidays, month, date, dayOfWeek, year)=>{
    /* First check is to eliminate Juneteenth if it is prior to 2021. Note: this logic will need to be
  made more specific if a new holiday is ever added to the month of June. */ if (year < 2021 && month === 5) return false;
    /* Second check is for Fridays. */ if (dayOfWeek === 5) return holidays.some((holiday)=>{
        /* If a US holiday lands on a Saturday and has a saturdayAdjustment which moves it to a Friday,
      this will return true if the date equals the US holiday date plus the saturdayAdjustment. */ if (holiday.locale === 'en-us') return holiday.month === month && (holiday.date === date || holiday.date + holiday.saturdayAdjustment === date);
        /* Otherwise, if a holiday lands on a Friday it will return true. */ return holiday.month === month && holiday.date === date;
    });
    /* Third check is for Mondays. */ if (dayOfWeek === 1) /* If a US holiday lands on a Monday, this will return true, OR if a US holiday lands
    on a Sunday and has a sundayAdjustment that moves it to a Monday, this will return
    true if the date equals the US holiday date plus the sundayAdjustment. */ return holidays.some((holiday)=>holiday.locale === 'en-us' && holiday.month === month && (holiday.date === date || holiday.date + holiday.sundayAdjustment === date) || /* If a Canadian holiday lands on a Monday, this will return true, OR if a Canadian
    holiday lands on either a Saturday and has a saturdayAdjustment or a Sunday and has
    a sundayAdjustment that moves it to a Monday, this will return
    true if the date equals the US holiday date plus the adjustment. */ holiday.locale === 'en-ca' && holiday.month === month && (holiday.date === date || holiday.date + holiday.saturdayAdjustment === date || holiday.date + holiday.sundayAdjustment === date));
    /* Fourth check is for Tuesdays. */ if (dayOfWeek === 2) /* If Boxing Day in Canada lands on either a Sunday or a Monday, it needs to be moved to
    a Tuesday so as not to overlap with Christmas which will have been adjusted from
    Saturday or Sunday to Monday. Returns true if the date is Tuesday and is Boxing Day
    plus the applicable adjustment. */ return holidays.some((holiday)=>holiday.locale === 'en-ca' && ('boxingDaySundayAdjustment' in holiday || 'boxingDayMondayAdjustment' in holiday) && holiday.month === month && (holiday.date + holiday.boxingDaySundayAdjustment === date || holiday.date + holiday.boxingDayMondayAdjustment === date) || /* Otherwise, if a holiday lands on a Tuesday, it returns true. */ holiday.month === month && holiday.date === date);
    /* Fifth check is for Saturdays. */ if (dayOfWeek === 6) /* Returns true if a holiday lands on a Saturday and there is no saturdayAdjustment. */ return holidays.some((holiday)=>holiday.month === month && holiday.date === date && holiday.saturdayAdjustment === 0);
    /* Sixth check is for Sundays. */ if (dayOfWeek === 0) /* Returns true if a holiday lands on a Sunday and there is no sundayAdjustment. */ return holidays.some((holiday)=>holiday.month === month && holiday.date === date && holiday.sundayAdjustment === 0);
    /* Finally returns true for all other holidays that do not fall into one of the above. */ return holidays.some((holiday)=>holiday.month === month && holiday.date === date);
};
var $558a1874964eed3d$var$isStaticDateHoliday$1 = $558a1874964eed3d$var$isStaticDateHoliday;
const $558a1874964eed3d$var$isMovableDateHoliday = (holidays, month, dayOfWeek, weekOfMonth)=>holidays.some((holiday)=>holiday.month === month && holiday.dayOfWeek === dayOfWeek && holiday.weekOfMonth === weekOfMonth);
var $558a1874964eed3d$var$isMovableDateHoliday$1 = $558a1874964eed3d$var$isMovableDateHoliday;
const $558a1874964eed3d$var$getMemorialDayDate = (year)=>{
    const lastDayOfMay = new Date(year, 5, 0);
    const lastDayOfMayDayOfWeek = lastDayOfMay.getDay();
    if (lastDayOfMayDayOfWeek === 0) return 25;
    return 31 - (lastDayOfMayDayOfWeek - 1);
};
const $558a1874964eed3d$var$isMemorialDay = (month, date, dayOfWeek, year)=>month === 4 && dayOfWeek === 1 && date === $558a1874964eed3d$var$getMemorialDayDate(year);
var $558a1874964eed3d$var$isMemorialDay$1 = $558a1874964eed3d$var$isMemorialDay;
const $558a1874964eed3d$var$getWeekOfMonth$1 = (date)=>Math.ceil(date.getDate() / 7);
var $558a1874964eed3d$var$getWeekOfMonth$2 = $558a1874964eed3d$var$getWeekOfMonth$1;
/* Static holidays are days that have the same date every year. */ const $558a1874964eed3d$var$staticDateBankHolidays = [
    {
        month: 0,
        date: 1,
        saturdayAdjustment: 0,
        sundayAdjustment: 1,
        locale: 'en-us'
    },
    // New Years Day
    {
        month: 5,
        date: 19,
        saturdayAdjustment: 0,
        sundayAdjustment: 1,
        locale: 'en-us'
    },
    // Juneteenth
    {
        month: 6,
        date: 4,
        saturdayAdjustment: 0,
        sundayAdjustment: 1,
        locale: 'en-us'
    },
    // 4th of July
    {
        month: 10,
        date: 11,
        saturdayAdjustment: 0,
        sundayAdjustment: 1,
        locale: 'en-us'
    },
    // Veteran's Day
    {
        month: 11,
        date: 25,
        saturdayAdjustment: 0,
        sundayAdjustment: 1,
        locale: 'en-us'
    } // Christmas
];
/* Movable holidays are days that have a different date each year
and instead are determined by the day/week of the month. */ const $558a1874964eed3d$var$movableDateBankHolidays = [
    {
        month: 0,
        dayOfWeek: 1,
        weekOfMonth: 3
    },
    // Martin Luther King Jr Day
    {
        month: 1,
        dayOfWeek: 1,
        weekOfMonth: 3
    },
    // Presidents Day
    {
        month: 8,
        dayOfWeek: 1,
        weekOfMonth: 1
    },
    // Labor Day
    {
        month: 9,
        dayOfWeek: 1,
        weekOfMonth: 2
    },
    // Columbus Day
    {
        month: 10,
        dayOfWeek: 4,
        weekOfMonth: 4
    } // Thanksgiving
];
const $558a1874964eed3d$var$isBankHoliday = (day)=>{
    if (!day) return false;
    const month = day.getMonth();
    const date = day.getDate();
    const dayOfWeek = day.getDay();
    const weekOfMonth = $558a1874964eed3d$var$getWeekOfMonth$2(day);
    const year = day.getFullYear();
    return $558a1874964eed3d$var$isStaticDateHoliday$1($558a1874964eed3d$var$staticDateBankHolidays, month, date, dayOfWeek, year) || $558a1874964eed3d$var$isMovableDateHoliday$1($558a1874964eed3d$var$movableDateBankHolidays, month, dayOfWeek, weekOfMonth) || $558a1874964eed3d$var$isMemorialDay$1(month, date, dayOfWeek, year);
};
var $558a1874964eed3d$var$isBankHoliday$1 = $558a1874964eed3d$var$isBankHoliday;
const $558a1874964eed3d$var$getGoodFriday = (year)=>{
    let temp;
    let m;
    let d;
    let tA;
    let tC;
    const firstDig = Math.floor(year / 100);
    const remain19 = year % 19;
    // calculate Pascal Full Moon date
    temp = Math.floor((firstDig - 15) / 2) + 202 - 11 * remain19;
    if ([
        21,
        24,
        25,
        27,
        28,
        29,
        30,
        31,
        32,
        34,
        35,
        38
    ].indexOf(firstDig) > -1) temp -= 1;
    else if ([
        33,
        36,
        37,
        39,
        40
    ].indexOf(firstDig) > -1) temp -= 2;
    temp %= 30;
    tA = temp + 21;
    if (temp === 29) tA -= 1;
    if (temp === 28 && remain19 > 10) tA -= 1;
    // find the next Sunday
    const tB = (tA - 19) % 7;
    tC = (40 - firstDig) % 4;
    if (tC === 3) tC += 1;
    if (tC > 1) tC += 1;
    temp = year % 100;
    const tD = (temp + Math.floor(temp / 4)) % 7;
    const tE = (20 - tB - tC - tD) % 7 + 1;
    d = tA + tE;
    // we want Good Friday, not Easter (Sunday)
    d -= 2;
    if (d > 31) {
        d -= 31;
        m = 3;
    } else m = 2;
    return {
        month: m,
        date: d
    };
};
const $558a1874964eed3d$var$isGoodFriday = (month, date, dayOfWeek, year)=>{
    const goodFriday = $558a1874964eed3d$var$getGoodFriday(year);
    return month === goodFriday.month && date === goodFriday.date && dayOfWeek === 5;
};
var $558a1874964eed3d$var$isGoodFriday$1 = $558a1874964eed3d$var$isGoodFriday;
const $558a1874964eed3d$var$isVictoriaDay = (date)=>{
    if (date.getMonth() === 4) // It is May!
    {
        if (date.getDay() === 1) {
            // It is a monday!
            const dayOfMonth = date.getDate();
            if (dayOfMonth < 25 && dayOfMonth >= 18) // It is victoria day!
            return true;
        }
    }
    return false;
};
var $558a1874964eed3d$var$isVictoriaDay$1 = $558a1874964eed3d$var$isVictoriaDay;
const $558a1874964eed3d$var$jonesMarketStaticHolidaysCA = [
    {
        month: 0,
        date: 1,
        saturdayAdjustment: 2,
        sundayAdjustment: 1,
        locale: 'en-ca'
    },
    // New Years Day
    {
        month: 6,
        date: 1,
        saturdayAdjustment: 2,
        sundayAdjustment: 1,
        locale: 'en-ca'
    },
    // Canada Day
    {
        month: 11,
        date: 25,
        saturdayAdjustment: 2,
        sundayAdjustment: 1,
        locale: 'en-ca'
    },
    // Christmas
    {
        month: 11,
        date: 26,
        saturdayAdjustment: 2,
        sundayAdjustment: 2,
        locale: 'en-ca',
        boxingDaySundayAdjustment: 2,
        boxingDayMondayAdjustment: 1
    } // Boxing Day
];
const $558a1874964eed3d$var$jonesMarketStaticHolidaysUS = [
    {
        month: 0,
        date: 1,
        saturdayAdjustment: 0,
        sundayAdjustment: 1,
        locale: 'en-us'
    },
    // New Years Day
    {
        month: 5,
        date: 19,
        saturdayAdjustment: -1,
        sundayAdjustment: 1,
        locale: 'en-us'
    },
    // Juneteenth
    {
        month: 6,
        date: 4,
        saturdayAdjustment: -1,
        sundayAdjustment: 1,
        locale: 'en-us'
    },
    // 4th of July
    {
        month: 11,
        date: 25,
        saturdayAdjustment: -1,
        sundayAdjustment: 1,
        locale: 'en-us'
    } // Christmas
];
/* Static holidays are days that have the same date every year. */ const $558a1874964eed3d$var$staticDateHolidays = (holidayLocale)=>{
    let holidayList = [];
    if (holidayLocale === 'en-ca' || holidayLocale === 'all') holidayList = [].concat($558a1874964eed3d$var$jonesMarketStaticHolidaysCA);
    if (holidayLocale === 'en-us' || holidayLocale === 'all') holidayList = [].concat(holidayList, $558a1874964eed3d$var$jonesMarketStaticHolidaysUS);
    return holidayList;
};
const $558a1874964eed3d$var$movableUSDateJonesMarketHolidays = [
    {
        month: 0,
        dayOfWeek: 1,
        weekOfMonth: 3
    },
    // Martin Luther King Jr Day
    {
        month: 1,
        dayOfWeek: 1,
        weekOfMonth: 3
    },
    // Presidents Day
    {
        month: 8,
        dayOfWeek: 1,
        weekOfMonth: 1
    },
    // Labor Day
    {
        month: 10,
        dayOfWeek: 4,
        weekOfMonth: 4
    } // Thanksgiving
];
const $558a1874964eed3d$var$movableCanadaDateJonesMarketHolidays = [
    {
        month: 7,
        dayOfWeek: 1,
        weekOfMonth: 1
    },
    // Civic HoliDay
    {
        month: 1,
        dayOfWeek: 1,
        weekOfMonth: 3
    },
    // Family Day
    {
        month: 8,
        dayOfWeek: 1,
        weekOfMonth: 1
    },
    // Labor Day
    {
        month: 9,
        dayOfWeek: 1,
        weekOfMonth: 2
    } // Thanksgiving
];
/* Movable holidays are days that have a different date each year
and instead are determined by the day/week of the month. */ const $558a1874964eed3d$var$movableDateHolidays = (holidayLocale)=>{
    let holidayList = [];
    if (holidayLocale === 'en-ca' || holidayLocale === 'all') holidayList = [].concat($558a1874964eed3d$var$movableCanadaDateJonesMarketHolidays);
    if (holidayLocale === 'en-us' || holidayLocale === 'all') holidayList = [].concat(holidayList, $558a1874964eed3d$var$movableUSDateJonesMarketHolidays);
    return holidayList;
};
const $558a1874964eed3d$var$getWeekOfMonth = (day)=>Math.ceil(day.getDate() / 7);
// @TODO:
// christmas day fails in component test; need to isolate
const $558a1874964eed3d$var$isJonesMarketHoliday = (day, holidayLocale)=>{
    if (!day) return false;
    const month = day.getMonth();
    const date = day.getDate();
    const dayOfWeek = day.getDay();
    const weekOfMonth = $558a1874964eed3d$var$getWeekOfMonth(day);
    const year = day.getFullYear();
    return $558a1874964eed3d$var$isStaticDateHoliday$1($558a1874964eed3d$var$staticDateHolidays(holidayLocale), month, date, dayOfWeek, year) || $558a1874964eed3d$var$isMovableDateHoliday$1($558a1874964eed3d$var$movableDateHolidays(holidayLocale), month, dayOfWeek, weekOfMonth) || $558a1874964eed3d$var$isGoodFriday$1(month, date, dayOfWeek, year) || (holidayLocale === 'en-us' || holidayLocale === 'all') && $558a1874964eed3d$var$isMemorialDay$1(month, date, dayOfWeek, year) || (holidayLocale === 'en-ca' || holidayLocale === 'all') && $558a1874964eed3d$var$isVictoriaDay$1(day);
};
var $558a1874964eed3d$var$isJonesMarketHoliday$1 = $558a1874964eed3d$var$isJonesMarketHoliday;
const $558a1874964eed3d$var$isoRegexSegments = {
    year: '\\d{4}',
    month: '\\d{2}',
    day: '\\d{2}',
    hour: '\\d{2}',
    minute: '\\d{2}',
    second: '\\d{2}',
    milliseconds: '\\d{3}'
};
// Loose
const $558a1874964eed3d$var$looseISORegex = new RegExp([
    // Start of String
    '^',
    // Date ISO String
    `${$558a1874964eed3d$var$isoRegexSegments.year}-${$558a1874964eed3d$var$isoRegexSegments.month}-${$558a1874964eed3d$var$isoRegexSegments.day}`,
    // Optional Time ISO String Capture Group
    '(',
    // Time Stamp Denoter
    'T',
    // Time ISO String
    `${$558a1874964eed3d$var$isoRegexSegments.hour}:${$558a1874964eed3d$var$isoRegexSegments.minute}:${$558a1874964eed3d$var$isoRegexSegments.second}`,
    // Optional Millisecond Capture Group
    '(',
    `\\.${$558a1874964eed3d$var$isoRegexSegments.milliseconds}`,
    ')?',
    // Time Zone Denoter
    'Z',
    ')?',
    // End of String
    '$'
].join(''));
const $558a1874964eed3d$var$isISODate = (isoDate)=>$558a1874964eed3d$var$looseISORegex.test(isoDate);
var $558a1874964eed3d$var$isISODate$1 = $558a1874964eed3d$var$isISODate;
const $558a1874964eed3d$var$dateFormatByType = {
    partial: {
        'YYYY': 'year',
        'MM': 'month',
        'DD': 'day'
    },
    locale: {
        'en-us': 'MM/DD/YYYY',
        'en-ca': 'DD/MM/YYYY'
    },
    dataEntry: {
        iso: [
            'YYYY-MM-DD',
            'YYYYMMDD'
        ]
    }
};
const $558a1874964eed3d$var$getFormattedDate = (date, locale = 'en-us')=>{
    if (!(date instanceof Date)) return '';
    const dateObj = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    };
    const localeFormat = $558a1874964eed3d$var$dateFormatByType.locale[locale];
    const localeSegments = localeFormat.split('/').map((segment)=>{
        const segmentPartial = $558a1874964eed3d$var$dateFormatByType.partial[segment];
        return $558a1874964eed3d$var$zeroFill(dateObj[segmentPartial], segment.length);
    });
    return localeSegments.join('/');
};
// Day validation is dependant on the year and month, so we check it after validating the year and month first
const $558a1874964eed3d$var$dateCheckOrder = [
    'year',
    'month',
    'day'
];
const $558a1874964eed3d$var$dateValidator = {
    year: (dateSection)=>/^\d{4}$/.test(dateSection.string),
    month: (dateSection)=>/^\d{2}$/.test(dateSection.string) && parseInt(dateSection.string, 10) > 0 && parseInt(dateSection.string, 10) <= 12,
    day: (dateSection, dateMeta)=>/^\d{2}$/.test(dateSection.string) && parseInt(dateSection.string, 10) > 0 && parseInt(dateSection.string, 10) <= new Date(dateMeta.year, dateMeta.month, 0).getDate()
};
const $558a1874964eed3d$var$getDateFromISOString = (dateString)=>{
    const dateISO = dateString.split('T')[0];
    const [year, month, day] = dateISO.split('-');
    return new Date(year, month - 1, day, 0, 0, 0, 0);
};
const $558a1874964eed3d$var$getDateFromLocaleString = (dateString, locale = 'en-us')=>{
    let stringIndex = 0;
    const dateBySection = {};
    const dateMeta = {};
    const localeSections = $558a1874964eed3d$var$dateFormatByType.locale[locale].split('/');
    localeSections.forEach((localeSection)=>{
        const dateStringSection = dateString.substr(stringIndex, localeSection.length);
        const datePartial = $558a1874964eed3d$var$dateFormatByType.partial[localeSection];
        const dateSection = {
            index: stringIndex,
            length: localeSection.length,
            string: dateStringSection
        };
        dateBySection[datePartial] = dateSection;
        stringIndex += localeSection.length + 1;
    });
    const isValidDate = $558a1874964eed3d$var$dateCheckOrder.every((datePartial)=>{
        const dateSection = dateBySection[datePartial];
        const isValidSection = $558a1874964eed3d$var$dateValidator[datePartial](dateSection, dateMeta);
        if (isValidSection) dateMeta[datePartial] = parseInt(dateSection.string, 10);
        return isValidSection;
    });
    return isValidDate ? new Date(dateMeta.year, dateMeta.month - 1, dateMeta.day, 0, 0, 0, 0) : null;
};
const $558a1874964eed3d$var$getRawDate = (dateString, locale)=>{
    if ($558a1874964eed3d$var$isISODate$1(dateString)) return $558a1874964eed3d$var$getDateFromISOString(dateString);
    return $558a1874964eed3d$var$getDateFromLocaleString(dateString, locale);
};
const $558a1874964eed3d$var$getNormalizedDate = (date, locale = 'en-us')=>{
    if (date instanceof Date) {
        date.setHours(0, 0, 0, 0);
        return date;
    }
    if (typeof date === 'object' && date !== null) return new Date(date.year, date.month - 1, date.day, 0, 0, 0, 0);
    if (typeof date === 'string') return $558a1874964eed3d$var$getRawDate(date, locale);
    return null;
};
var $558a1874964eed3d$var$getNormalizedDate$1 = $558a1874964eed3d$var$getNormalizedDate;
const $558a1874964eed3d$var$isSameDay = (date1, date2)=>date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
var $558a1874964eed3d$var$isSameDay$1 = $558a1874964eed3d$var$isSameDay;
const $558a1874964eed3d$var$getLastDayOfMonth = (date)=>{
    const year = date.getFullYear();
    const month = date.getMonth();
    return new Date(year, month + 1, 0);
};
var $558a1874964eed3d$var$getLastDayOfMonth$1 = $558a1874964eed3d$var$getLastDayOfMonth;
const $558a1874964eed3d$var$dateAdjustmentDefaults = {
    year: 0,
    month: 0,
    day: 0
};
const $558a1874964eed3d$var$adjustDate = (date, adjustmentProp)=>{
    const adjustment = {
        ...$558a1874964eed3d$var$dateAdjustmentDefaults,
        ...adjustmentProp
    };
    const year = date.getFullYear() + adjustment.year;
    const month = date.getMonth() + adjustment.month;
    let day = date.getDate() + adjustment.day;
    const currentLastDay = $558a1874964eed3d$var$getLastDayOfMonth$1(new Date(year, month));
    // Accomodate monthly adjustments where the current day might be a higher value than what is available in the updated month (IE Jan 31st => Feb 31st, which doesn't exist)
    if (adjustment.day === 0 && day >= currentLastDay.getDate()) day = currentLastDay.getDate();
    return new Date(year, month, day);
};
const $558a1874964eed3d$var$adjustToFirstOfWeek = (date)=>{
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const dayOfWeek = date.getDay();
    return new Date(year, month, day - dayOfWeek);
};
const $558a1874964eed3d$var$adjustToLastOfWeek = (date)=>{
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const dayOfWeek = date.getDay();
    return new Date(year, month, day + (6 - dayOfWeek));
};
const $558a1874964eed3d$var$getLastSellingDay = (month, year, countryCode)=>{
    const lastDateOfMonth = new Date(year, month, 0).getDate();
    let lastSellingDay = $558a1874964eed3d$var$getNormalizedDate$1({
        year: year,
        month: month,
        day: lastDateOfMonth
    }, countryCode);
    if (countryCode === 'en-us') {
        /* In US, Last Selling Day is two business days prior to the last Friday of the month, except in
    December when the last selling day is two business days prior to the last day of the month.
    businessDays = days between last selling day and settlement day, now T + 2 */ let businessDays = 2;
        // If December
        if (month === 12) {
            // Keep moving back in week until businessDay is 0 to find last selling day
            while(businessDays > 0)if (lastSellingDay.getDay() === 0 || lastSellingDay.getDay() === 6 || $558a1874964eed3d$var$isBankHoliday$1(lastSellingDay) || $558a1874964eed3d$var$isJonesMarketHoliday$1(lastSellingDay, 'en-us')) // If lastSellingDay is Sunday or Saturday or Holiday, don't count as business day
            lastSellingDay = $558a1874964eed3d$var$adjustDate(lastSellingDay, {
                day: -1
            });
            else {
                lastSellingDay = $558a1874964eed3d$var$adjustDate(lastSellingDay, {
                    day: -1
                });
                businessDays -= 1;
            }
            // If lastSellingDay is Sunday, go back 2 days to Friday
            if (lastSellingDay.getDay() === 0) lastSellingDay = $558a1874964eed3d$var$adjustDate(lastSellingDay, {
                day: -2
            });
            // If lastSellingDay is Sunday, go back 1 day to Friday
            if (lastSellingDay.getDay() === 6) lastSellingDay = $558a1874964eed3d$var$adjustDate(lastSellingDay, {
                day: -1
            });
            return lastSellingDay;
        }
        // If not December, keep moving back in the month until you reach a Friday
        while(lastSellingDay.getDay() !== 5)lastSellingDay = $558a1874964eed3d$var$adjustDate(lastSellingDay, {
            day: -1
        });
        // If not December, move back in the week from Friday
        // Once businessDays is 0, that will be last selling day
        while(businessDays > 0)if ($558a1874964eed3d$var$isBankHoliday$1(lastSellingDay) || $558a1874964eed3d$var$isJonesMarketHoliday$1(lastSellingDay)) // Don't count holiday as business day
        lastSellingDay = $558a1874964eed3d$var$adjustDate(lastSellingDay, {
            day: -1
        });
        else {
            lastSellingDay = $558a1874964eed3d$var$adjustDate(lastSellingDay, {
                day: -1
            });
            businessDays -= 1;
        }
        return lastSellingDay;
    }
    // If locale is CA rather than US, the last selling day is the final business day of the month */
    while(lastSellingDay.getDay() === 0 || lastSellingDay.getDay() === 6 || $558a1874964eed3d$var$isBankHoliday$1(lastSellingDay) || $558a1874964eed3d$var$isJonesMarketHoliday$1(lastSellingDay))lastSellingDay = $558a1874964eed3d$var$adjustDate(lastSellingDay, {
        day: -1
    });
    return lastSellingDay;
};
var $558a1874964eed3d$var$getLastSellingDay$1 = $558a1874964eed3d$var$getLastSellingDay;
const $558a1874964eed3d$var$isLastSellingDay = (date, countryCode)=>{
    const normalizedDate = $558a1874964eed3d$var$getNormalizedDate$1(date);
    if (!normalizedDate) return false;
    const month = normalizedDate.getMonth() + 1;
    const year = normalizedDate.getFullYear();
    return $558a1874964eed3d$var$isSameDay$1(normalizedDate, $558a1874964eed3d$var$getLastSellingDay$1(month, year, countryCode));
};
var $558a1874964eed3d$var$isLastSellingDay$1 = $558a1874964eed3d$var$isLastSellingDay;
const $558a1874964eed3d$var$getToday = ()=>{
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};
var $558a1874964eed3d$var$getToday$1 = $558a1874964eed3d$var$getToday;
// eslint-disable-next-line import/no-cycle
const $558a1874964eed3d$var$monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const $558a1874964eed3d$var$dayNames = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];
const $558a1874964eed3d$var$abbreviatedDayNames = [
    'Su',
    'Mo',
    'Tu',
    'We',
    'Th',
    'Fr',
    'Sa'
];
const $558a1874964eed3d$var$CalendarDay = ({ date: date, locale: locale = 'en-us', children: children = null, selected: selected, disabled: disabled, showBankHolidays: showBankHolidays = false, showJonesMarketHolidays: showJonesMarketHolidays = false, showLastSellingDays: showLastSellingDays = false, onClick: onClick = ()=>{} })=>{
    const month = date.getMonth();
    const year = date.getFullYear();
    const day = date.getDate();
    const dayOfWeek = date.getDay();
    const monthName = $558a1874964eed3d$var$monthNames[month];
    const dayOfWeekName = $558a1874964eed3d$var$dayNames[dayOfWeek];
    const isButton = typeof onClick === 'function';
    const isVisibleLastSellingDay = showLastSellingDays && $558a1874964eed3d$var$isLastSellingDay$1(date, locale);
    const isVisibleHoliday = showBankHolidays && $558a1874964eed3d$var$isBankHoliday$1(date) || showJonesMarketHolidays && $558a1874964eed3d$var$isJonesMarketHoliday$1(date, locale);
    const cellClasses = $558a1874964eed3d$var$createClassList({
        default: [
            'axiom-calendar--date-cell'
        ],
        custom: [
            selected ? 'axiom-calendar--date-cell--selected' : null,
            disabled ? 'axiom-calendar--date-cell--disabled' : null,
            isVisibleHoliday ? 'axiom-calendar--date-cell--holiday' : null,
            isVisibleLastSellingDay ? 'axiom-calendar--date-cell--last-selling-day' : null
        ]
    });
    let ariaLabel = `${monthName} ${day}, ${year}, ${dayOfWeekName}`;
    if (isVisibleHoliday) ariaLabel += '. Holiday';
    if (isVisibleLastSellingDay) ariaLabel += '. Last Selling Day';
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    (0, $ayMG0.jsxs)("td", {
        role: isButton ? 'button' : 'gridcell',
        tabIndex: 0,
        className: cellClasses,
        "data-date": date,
        onClick: onClick,
        "aria-label": isButton ? ariaLabel : null,
        "aria-pressed": isButton ? selected : null,
        "aria-disabled": isButton ? disabled : null,
        children: [
            day,
            " ",
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            children
        ]
    }));
};
$558a1874964eed3d$var$CalendarDay.displayName = 'Calendar.Day';
$558a1874964eed3d$var$CalendarDay.propTypes = {
    date: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date).isRequired,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'en-us',
        'en-ca'
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showBankHolidays: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showJonesMarketHolidays: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showLastSellingDays: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $558a1874964eed3d$var$DayCell = $558a1874964eed3d$var$CalendarDay;
const $558a1874964eed3d$var$legendTypesOrder = [
    'holiday',
    'lastSellingDay'
];
const $558a1874964eed3d$var$legendTypes = {
    lastSellingDay: {
        label: 'Last Selling Day',
        class: 'last-selling-day'
    },
    holiday: {
        label: 'Holiday',
        class: 'holiday'
    }
};
const $558a1874964eed3d$var$dateLegendTypeMap = {
    lastSellingDay: 'lastSellingDay',
    jonesMarketHoliday: 'holiday',
    bankHoliday: 'holiday'
};
const $558a1874964eed3d$var$Legend = ({ dates: dates = [] })=>{
    if (dates.length === 0) return null;
    const uniqueDatesByLegendType = {};
    $558a1874964eed3d$var$legendTypesOrder.forEach((legendType)=>{
        uniqueDatesByLegendType[legendType] = [];
    });
    dates.forEach((dateInfo)=>{
        const { date: date, type: type } = dateInfo;
        const legendType = $558a1874964eed3d$var$dateLegendTypeMap[type];
        const isUnique = uniqueDatesByLegendType[legendType].every((uniqueDate)=>!$558a1874964eed3d$var$isSameDay$1(uniqueDate, date));
        if (isUnique) uniqueDatesByLegendType[legendType].push(date);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "axiom-calendar--legend",
        children: $558a1874964eed3d$var$legendTypesOrder.map((legendType)=>{
            const legendDates = uniqueDatesByLegendType[legendType];
            const classList = $558a1874964eed3d$var$createClassList({
                default: [
                    'axiom-calendar--legend--entry'
                ],
                custom: [
                    `axiom-calendar--legend--${$558a1874964eed3d$var$legendTypes[legendType].class}`
                ]
            });
            return legendDates.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: classList,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "axiom-calendar--legend--title",
                        children: $558a1874964eed3d$var$legendTypes[legendType].label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-calendar--legend--date-tray",
                        children: legendDates.map((date)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "axiom-calendar--legend--date-icon",
                                children: date.getDate()
                            }, date.toISOString()))
                    })
                ]
            }, legendType) : null;
        })
    });
};
$558a1874964eed3d$var$Legend.displayName = 'Calendar.Day';
$558a1874964eed3d$var$Legend.propTypes = {
    dates: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        date: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date).isRequired,
        type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'lastSellingDay',
            'jonesMarketHoliday',
            'bankHoliday'
        ])
    }))
};
var $558a1874964eed3d$var$Legend$1 = $558a1874964eed3d$var$Legend;
const $558a1874964eed3d$var$overridesByKey = {
    'ArrowLeft': {
        label: 'Left Arrow',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: "\u2190"
        })
    },
    'ArrowRight': {
        label: 'Right Arrow',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: "\u2192"
        })
    },
    'ArrowUp': {
        label: 'Up Arrow',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: "\u2191"
        })
    },
    'ArrowDown': {
        label: 'Down Arrow',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: "\u2193"
        })
    },
    'Enter': {
        label: 'Enter',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: "\u21B5"
        })
    },
    ' ': {
        label: 'Space',
        icon: 'Space'
    },
    '?': {
        label: 'Question mark',
        icon: '?'
    },
    'Escape': {
        label: 'Escape',
        icon: 'Esc'
    },
    'ctrlKey': {
        label: 'Control',
        icon: 'Ctrl'
    },
    'metaKey': {
        label: 'Apple',
        icon: "\u2318"
    }
};
const $558a1874964eed3d$var$getKeyLabels = (shortcut)=>{
    const { key: key, modifiers: modifiers = [
        null
    ] } = shortcut;
    return modifiers.map((modifierKey)=>{
        let keyLabel;
        let ariaLabel;
        const override = $558a1874964eed3d$var$overridesByKey[key];
        if (override) {
            keyLabel = override.icon;
            ariaLabel = override.label;
        } else {
            // Convert key from Pascal Case to Title Case
            keyLabel = key.replace(/([A-Z])/g, ' $1');
            ariaLabel = keyLabel;
        }
        if (modifierKey !== null) {
            keyLabel = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    $558a1874964eed3d$var$overridesByKey[modifierKey].icon,
                    " + ",
                    keyLabel
                ]
            });
            ariaLabel = `${$558a1874964eed3d$var$overridesByKey[modifierKey].label} plus ${ariaLabel}`;
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            role: "img",
            className: "axiom-shortcut-menu--key",
            "aria-label": ariaLabel,
            children: keyLabel
        }, modifierKey);
    });
};
const $558a1874964eed3d$var$ShortcutMenu = /*#__PURE__*/ (0, $acw62.forwardRef)(({ shortcuts: shortcuts = [], shown: shown = false, onClose: onClose = ()=>{}, id: id }, refs)=>{
    const defaultRefs = {
        closeButtonRef: (0, $acw62.useRef)(),
        menuRef: (0, $acw62.useRef)()
    };
    const { closeButtonRef: closeButtonRef, menuRef: menuRef } = {
        ...defaultRefs,
        ...refs
    };
    return shown ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "axiom-shortcut-menu",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "axiom-shortcut-menu--title-group",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                        inputRef: closeButtonRef,
                        onClick: onClose,
                        classes: "axiom-shortcut-menu--close-button",
                        label: "Close the shortcuts panel",
                        icon: "close",
                        iconOnly: true,
                        styleVariant: "reversed-primary"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "axiom-shortcut-menu--title",
                        id: id,
                        children: "Keyboard Shortcuts"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex: 0,
                ref: menuRef,
                className: "axiom-shortcut-menu--entries",
                children: shortcuts.map((shortcut)=>{
                    const modifiers = shortcut.modifiers || [
                        ''
                    ];
                    const shortcutKey = modifiers.map((modifier)=>`${modifier}-${shortcut.key}`).join();
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "axiom-shortcut-menu--entry",
                        children: [
                            $558a1874964eed3d$var$getKeyLabels(shortcut),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "axiom-shortcut-menu--description",
                                children: shortcut.description
                            })
                        ]
                    }, shortcutKey);
                })
            })
        ]
    }) : null;
});
$558a1874964eed3d$var$ShortcutMenu.displayName = 'Shortcut';
$558a1874964eed3d$var$ShortcutMenu.propTypes = {
    shortcuts: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        key: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'ctrlKey',
            'altKey',
            'metaKey'
        ])),
        description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    })),
    shown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $558a1874964eed3d$var$ShortcutMenu$1 = $558a1874964eed3d$var$ShortcutMenu;
// [HELPERS]
const $558a1874964eed3d$var$getComponentType$1 = (component)=>{
    if (component) {
        const componentType = component.type;
        return typeof componentType === 'string' ? componentType : componentType.displayName;
    }
    return 'null';
};
const $558a1874964eed3d$var$useSubComponentsByType$1 = (children)=>{
    const results = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
        const childType = $558a1874964eed3d$var$getComponentType$1(child);
        if (results[childType]) results[childType].push(child);
        else results[childType] = [
            child
        ];
    });
    return results;
};
const $558a1874964eed3d$var$noop = /* istanbul ignore next */ ()=>{};
const $558a1874964eed3d$var$today = $558a1874964eed3d$var$getToday$1();
const $558a1874964eed3d$var$getPressedKey = (event)=>event.key === '/' ? '?' : event.key;
const $558a1874964eed3d$var$gridFocusKeys = [
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'PageUp',
    'PageDown',
    'Home',
    'End'
];
const $558a1874964eed3d$var$defaultShortcuts = [
    {
        key: 'ArrowLeft',
        action: (event, focusDate)=>$558a1874964eed3d$var$adjustDate(focusDate, {
                day: -1
            }),
        description: 'Move backward (left) one day'
    },
    {
        key: 'ArrowRight',
        action: (event, focusDate)=>$558a1874964eed3d$var$adjustDate(focusDate, {
                day: 1
            }),
        description: 'Move forward (right) one day'
    },
    {
        key: 'ArrowDown',
        action: (event, focusDate)=>$558a1874964eed3d$var$adjustDate(focusDate, {
                day: 7
            }),
        description: 'Move backward (up) one week'
    },
    {
        key: 'ArrowUp',
        action: (event, focusDate)=>$558a1874964eed3d$var$adjustDate(focusDate, {
                day: -7
            }),
        description: 'Move forward (down) one week'
    },
    {
        key: 'PageUp',
        action: (event, focusDate)=>$558a1874964eed3d$var$adjustDate(focusDate, {
                month: -1
            }),
        description: 'Move to the previous month'
    },
    {
        key: 'PageDown',
        action: (event, focusDate)=>$558a1874964eed3d$var$adjustDate(focusDate, {
                month: 1
            }),
        description: 'Move to the next month'
    },
    {
        key: 'Home',
        action: (event, focusDate)=>$558a1874964eed3d$var$adjustToFirstOfWeek(focusDate),
        description: 'Move to the first day of the focused week'
    },
    {
        key: 'End',
        action: (event, focusDate)=>$558a1874964eed3d$var$adjustToLastOfWeek(focusDate),
        description: 'Move to the last day of the focused week'
    },
    {
        key: 'Enter',
        action: $558a1874964eed3d$var$noop,
        description: 'Select the focused date'
    },
    {
        key: ' ',
        action: $558a1874964eed3d$var$noop,
        description: 'Select the focused date'
    },
    {
        key: 'Enter',
        modifiers: [
            'ctrlKey',
            'metaKey'
        ],
        action: $558a1874964eed3d$var$noop,
        description: 'Select the focused date without deselecting the previous date(s)'
    },
    {
        key: '?',
        action: $558a1874964eed3d$var$noop,
        description: 'Toggle the shortcut panel'
    },
    {
        key: 'Escape',
        action: $558a1874964eed3d$var$noop,
        description: 'Close the shortcut panel'
    }
];
const $558a1874964eed3d$var$setInitialSelectedDate = (selectedDates, selectionMode)=>{
    const filteredDates = selectedDates.filter((date)=>date instanceof Date);
    if (selectionMode === 'single' && filteredDates[0]) return [
        filteredDates[0]
    ];
    return filteredDates;
};
const $558a1874964eed3d$var$Calendar = /*#__PURE__*/ (0, $acw62.forwardRef)((props, refs)=>{
    const { children: children, date: dateProp = $558a1874964eed3d$var$today, classes: classes = [], selectable: selectable = false, selectionMode: selectionMode = 'single', selectedDates: initialSelectedDates = [], keybinds: keybinds = [], customDateDisabler: customDateDisabler = ()=>{}, weekendsDisabled: weekendsDisabled = false, bankHolidaysDisabled: bankHolidaysDisabled = false, jonesMarketHolidaysDisabled: jonesMarketHolidaysDisabled = false, futureDatesDisabled: futureDatesDisabled = false, pastDatesDisabled: pastDatesDisabled = false, showBankHolidays: showBankHolidays = false, showJonesMarketHolidays: showJonesMarketHolidays = false, showLastSellingDays: showLastSellingDays = false, locale: locale = 'en-us', holidayLocale: holidayLocale = locale, onDateSelect: onDateSelect = ()=>{}, onShortcutToggle: onShortcutToggle = ()=>{}, keyboardManager: keyboardManager } = props;
    const defaultRefs = {
        previousMonthRef: (0, $acw62.useRef)(),
        nextMonthRef: (0, $acw62.useRef)(),
        gridRef: (0, $acw62.useRef)(),
        helpButtonRef: (0, $acw62.useRef)(),
        shortcutCloseButtonRef: (0, $acw62.useRef)(),
        menuRef: (0, $acw62.useRef)()
    };
    const { previousMonthRef: previousMonthRef, nextMonthRef: nextMonthRef, gridRef: gridRef, helpButtonRef: helpButtonRef, shortcutCloseButtonRef: shortcutCloseButtonRef, menuRef: menuRef } = {
        ...defaultRefs,
        ...refs
    };
    const isMounted = $558a1874964eed3d$var$useIsMounted$1();
    const calendarDays = $558a1874964eed3d$var$useSubComponentsByType$1(children)['Calendar.Day'] || [];
    const sectionTabOrder = [
        shortcutCloseButtonRef,
        menuRef
    ];
    const [date, setDate] = (0, $acw62.useState)(dateProp || $558a1874964eed3d$var$today);
    const [selectedDates, setSelectedDates] = (0, $acw62.useState)($558a1874964eed3d$var$setInitialSelectedDate(initialSelectedDates, selectionMode));
    const [focusDate, setFocusDate] = (0, $acw62.useState)(initialSelectedDates[0] || date);
    const [suppressFocusShifting, setSuppressFocusShifting] = (0, $acw62.useState)(false);
    const [overlayVisible, setOverlayVisible] = (0, $acw62.useState)(false);
    const [sectionFocusRef, setSectionFocusRef] = (0, $acw62.useState)(null);
    const calendarYear = date.getFullYear();
    const calendarMonth = date.getMonth();
    const firstDayOfMonth = new Date(calendarYear, calendarMonth, 1).getDay();
    const daysInMonth = new Date(calendarYear, calendarMonth + 1, 0).getDate();
    const prevMonth = $558a1874964eed3d$var$adjustDate(date, {
        month: -1
    });
    const nextMonth = $558a1874964eed3d$var$adjustDate(date, {
        month: 1
    });
    const setPrevMonth = ()=>setDate(prevMonth);
    const setNextMonth = ()=>setDate(nextMonth);
    const openOverlay = ()=>setOverlayVisible(true);
    const closeOverlay = ()=>setOverlayVisible(false);
    const toggleShortkeyOverlay = ()=>{
        setOverlayVisible(!overlayVisible);
    };
    const shortcuts = [
        ...$558a1874964eed3d$var$defaultShortcuts,
        ...keybinds
    ];
    const handleCalendarKeyPress = (event)=>{
        const isModifierKeyActive = event.altKey || event.ctrlKey || event.metaKey;
        const keyPressed = $558a1874964eed3d$var$getPressedKey(event);
        // Only attempt to override keyboard interactions if a modifier key isn't pressed
        if (!isModifierKeyActive && [
            '?'
        ].includes(keyPressed)) {
            event.preventDefault();
            event.stopPropagation();
            toggleShortkeyOverlay();
        }
        // Special Handling for Keyboard Overlay
        if (overlayVisible) // Handles Focus Redirecting for the Calendar Grid
        {
            if (!isModifierKeyActive && keyPressed === 'Tab') {
                event.preventDefault();
                event.stopPropagation();
                const sectionFocusIndex = sectionTabOrder.indexOf(sectionFocusRef);
                const tabDirection = event.shiftKey ? -1 : 1;
                const newFocusIndex = (sectionFocusIndex + tabDirection + sectionTabOrder.length) % sectionTabOrder.length;
                const newFocusRef = sectionTabOrder[newFocusIndex];
                setSectionFocusRef(newFocusRef);
            }
        }
    };
    // Handle Overlay Closing on Key Up (to prevent modals from closing in rapid succession when the Escape key is held down)
    const handleOverlayClosing = (event)=>{
        if (overlayVisible && event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            closeOverlay();
        }
    };
    const handleGridKeyPress = (event)=>{
        const domCell = event.target;
        const keyPressed = $558a1874964eed3d$var$getPressedKey(event);
        const isShiftKeyActive = event.shiftKey;
        const isModifierKeyActive = event.altKey || event.ctrlKey || event.metaKey;
        const isMultiSelectKeyActive = event.ctrlKey || event.metaKey;
        const isButtonKeyActive = [
            'Enter',
            ' '
        ].includes(keyPressed);
        const isDisabled = domCell.ariaDisabled === 'true';
        const keyboundShortcut = shortcuts.find((ks)=>ks.key === keyPressed && (typeof ks.modifiers === 'undefined' || ks.modifiers.includes(null)));
        // Attempt to override keyboard interactions if a modifier key isn't pressed
        if (!isModifierKeyActive && keyboundShortcut) {
            let stopEventBubbling = !isButtonKeyActive;
            const newFocusDate = keyboundShortcut.action(event, focusDate);
            const isDateCell = document.activeElement.classList.contains('axiom-calendar--date-cell');
            if (isButtonKeyActive && !isDisabled && isDateCell) {
                stopEventBubbling = true;
                setSelectedDates([
                    focusDate
                ]);
            }
            if (newFocusDate) setFocusDate(newFocusDate);
            if (stopEventBubbling) {
                event.stopPropagation();
                event.preventDefault();
            }
        }
        // If a multi-select key is pressed with Enter, we will also attemts to update our calendar selection
        if (isMultiSelectKeyActive && [
            'Enter',
            ' '
        ].includes(keyPressed) && !isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            if (selectionMode === 'multi') setSelectedDates([
                ...selectedDates,
                focusDate
            ]);
        }
        // Handles Focus Redirecting for the Calendar Grid
        if (!isModifierKeyActive && keyPressed === 'Tab') {
            event.stopPropagation();
            event.preventDefault();
            if (isShiftKeyActive) nextMonthRef.current.focus();
            else helpButtonRef.current.focus();
        }
    };
    const handleClick = (event)=>{
        const domCell = event.target;
        const isDisabled = domCell.ariaDisabled === 'true';
        if (!isDisabled) {
            const newDate = new Date(domCell.dataset.date);
            const isMultiSelectKeyActive = event.ctrlKey || event.metaKey;
            if (selectionMode === 'single' || !isMultiSelectKeyActive) setSelectedDates([
                newDate
            ]);
            else setSelectedDates([
                ...selectedDates,
                newDate
            ]);
            setFocusDate(newDate);
        }
    };
    // Focus on the date cell tracked by the calendar's internal state
    const focusDateCell = ()=>{
        if (!suppressFocusShifting) {
            const domGridCells = gridRef.current.querySelectorAll('td.axiom-calendar--date-cell');
            const focusIndex = focusDate.getDate() - 1;
            if (focusDate.getMonth() !== date.getMonth()) setDate(focusDate);
            else domGridCells[focusIndex].focus();
        }
    };
    // Render helper which creates the main body of the calendar grid
    const renderCalendarGrid = ()=>{
        const gridRows = [];
        const legendDates = [];
        let currentGridRow;
        let dayInWeek = 0;
        let blankCellIndex = 0;
        for(let indexDay = 0; indexDay <= daysInMonth || dayInWeek; dayInWeek = (dayInWeek + 1) % 7){
            if (indexDay || dayInWeek === firstDayOfMonth) indexDay += 1;
            blankCellIndex += 1;
            if (dayInWeek === 0) {
                currentGridRow = [];
                gridRows.push(currentGridRow);
            }
            const cellDate = new Date(calendarYear, calendarMonth, indexDay);
            const isDayInMonth = !!indexDay && indexDay <= daysInMonth;
            const isWeekend = [
                0,
                6
            ].includes(dayInWeek);
            const isSelected = selectable && selectedDates.some((selectedDate)=>$558a1874964eed3d$var$isSameDay$1(selectedDate, cellDate));
            const isDisabled = customDateDisabler(cellDate) || futureDatesDisabled && cellDate > $558a1874964eed3d$var$today || pastDatesDisabled && cellDate < $558a1874964eed3d$var$today || weekendsDisabled && isWeekend || bankHolidaysDisabled && $558a1874964eed3d$var$isBankHoliday$1(cellDate) || jonesMarketHolidaysDisabled && $558a1874964eed3d$var$isJonesMarketHoliday$1(cellDate, holidayLocale);
            if (isDayInMonth) {
                if (showJonesMarketHolidays && $558a1874964eed3d$var$isJonesMarketHoliday$1(cellDate, holidayLocale)) legendDates.push({
                    date: cellDate,
                    type: 'jonesMarketHoliday'
                });
                if (showBankHolidays && $558a1874964eed3d$var$isBankHoliday$1(cellDate)) legendDates.push({
                    date: cellDate,
                    type: 'bankHoliday'
                });
                if (showLastSellingDays && $558a1874964eed3d$var$isLastSellingDay$1(cellDate, holidayLocale)) legendDates.push({
                    date: cellDate,
                    type: 'lastSellingDay'
                });
                const currentDayCell = calendarDays.find((calendarDay)=>$558a1874964eed3d$var$isSameDay$1(calendarDay.props.date, cellDate));
                const cellProps = currentDayCell ? currentDayCell.props : {};
                const isCellSelected = typeof cellProps.selected !== 'undefined' ? cellProps.selected : isSelected;
                const isCellDisabled = typeof cellProps.disabled !== 'undefined' ? cellProps.disabled : isDisabled;
                currentGridRow.push(/*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$DayCell, {
                    date: cellDate,
                    locale: holidayLocale,
                    selected: isCellSelected,
                    disabled: isCellDisabled,
                    showBankHolidays: showBankHolidays,
                    showJonesMarketHolidays: showJonesMarketHolidays,
                    showLastSellingDays: showLastSellingDays,
                    onClick: selectable ? handleClick : null,
                    children: cellProps.children
                }, cellDate.toISOString()));
            } else currentGridRow.push(/*#__PURE__*/ (0, $ayMG0.jsx)("td", {}, blankCellIndex));
        }
        return [
            /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                role: "grid",
                tabIndex: 0,
                ref: gridRef,
                className: "axiom-calendar--date-grid",
                onKeyDown: keyboardManager ? $558a1874964eed3d$var$noop : handleGridKeyPress,
                onFocus: focusDateCell,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                    children: gridRows.map((row, rowIndex)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                        (0, $ayMG0.jsx)("tr", {
                            className: "axiom-calendar--date-row",
                            children: row.map((cell)=>cell)
                        }, rowIndex))
                })
            }, 'calendar-grid'),
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Legend$1, {
                dates: legendDates
            }, 'calendar-legend')
        ];
    };
    // If an external keyboard manager was passed along as part of our props, we'll use it to hook the Calendar keyboard manager to
    // our external keyboard manager
    if (keyboardManager) keyboardManager.subscribe('calendarKeyPress', (event)=>{
        if ($558a1874964eed3d$var$gridFocusKeys.includes(event.key)) focusDateCell();
        handleGridKeyPress(event);
    });
    (0, $acw62.useEffect)(()=>{
        if (isMounted) {
            const isGridFocused = document.activeElement.classList.contains('axiom-calendar--date-cell');
            const hasNoFocus = document.activeElement === document.body;
            if (isGridFocused || hasNoFocus) focusDateCell();
        }
    }, [
        focusDate
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMounted) {
            const year = date.getFullYear();
            const month = date.getMonth();
            const day = focusDate.getDate();
            const updatedFocusDate = $558a1874964eed3d$var$getNormalizedDate$1(new Date(year, month, day));
            setFocusDate(updatedFocusDate);
        }
    }, [
        date
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMounted) {
            const year = dateProp.getFullYear();
            const month = dateProp.getMonth();
            const day = dateProp.getDate();
            const updatedFocusDate = $558a1874964eed3d$var$getNormalizedDate$1(new Date(year, month, day));
            setSelectedDates([
                updatedFocusDate
            ]);
            setFocusDate(updatedFocusDate);
        }
    }, [
        dateProp
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMounted) {
            const callbackDates = selectionMode === 'single' ? selectedDates[0] : selectedDates;
            onDateSelect(callbackDates);
        }
    }, [
        selectedDates
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMounted) {
            onShortcutToggle(overlayVisible);
            setSectionFocusRef(overlayVisible ? shortcutCloseButtonRef : helpButtonRef);
        }
    }, [
        overlayVisible
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMounted && sectionFocusRef && sectionFocusRef.current) sectionFocusRef.current.focus();
    }, [
        sectionFocusRef
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleMouseDown = ()=>setSuppressFocusShifting(true);
        const handleMouseUp = ()=>setSuppressFocusShifting(false);
        window.addEventListener('mousedown', handleMouseDown);
        window.addEventListener('mouseup', handleMouseUp);
        return ()=>{
            window.removeEventListener('mousedown', handleMouseDown);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);
    const shortcutMenuTitleId = (0, $acw62.useId)();
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    (0, $ayMG0.jsxs)("div", {
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-calendar'
            ],
            custom: [
                selectable ? 'axiom-calendar--interactive' : null,
                classes
            ]
        }),
        onKeyDown: handleCalendarKeyPress,
        onKeyUp: handleOverlayClosing,
        children: [
            overlayVisible ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "dialog",
                className: "axiom-calendar--overlay",
                "aria-labelledby": shortcutMenuTitleId,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$ShortcutMenu$1, {
                    ref: {
                        closeButtonRef: shortcutCloseButtonRef,
                        menuRef: menuRef
                    },
                    id: shortcutMenuTitleId,
                    shown: true,
                    shortcuts: shortcuts,
                    onClose: closeOverlay
                })
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "axiom-calendar--navigator",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                        inputRef: previousMonthRef,
                        classes: "axiom-calendar--navigation-button",
                        label: `Previous Month, ${$558a1874964eed3d$var$monthNames[prevMonth.getMonth()]} ${prevMonth.getFullYear()}`,
                        iconOnly: true,
                        icon: "chevron-left",
                        styleVariant: "tertiary",
                        onClick: setPrevMonth
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "axiom-calendar--month-title",
                        children: [
                            $558a1874964eed3d$var$monthNames[calendarMonth],
                            " ",
                            calendarYear
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                        inputRef: nextMonthRef,
                        classes: "axiom-calendar--navigation-button",
                        label: `Next Month, ${$558a1874964eed3d$var$monthNames[nextMonth.getMonth()]} ${nextMonth.getFullYear()}`,
                        iconOnly: true,
                        icon: "chevron-right",
                        styleVariant: "tertiary",
                        onClick: setNextMonth
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": true,
                className: "axiom-calendar--day-header",
                children: $558a1874964eed3d$var$abbreviatedDayNames.map((dayName)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-calendar--day-cell",
                        children: dayName
                    }, dayName))
            }),
            renderCalendarGrid(),
            selectable && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "axiom-calendar--help-button-container",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                    inputRef: helpButtonRef,
                    classes: "axiom-calendar--help-button",
                    label: "Keyboard Shortcuts",
                    iconPosition: "left",
                    icon: "help-question-mark",
                    styleVariant: "tertiary",
                    onClick: openOverlay
                })
            })
        ]
    }));
});
$558a1874964eed3d$var$Calendar.displayName = 'Calendar';
$558a1874964eed3d$var$Calendar.Day = $558a1874964eed3d$var$DayCell;
$558a1874964eed3d$var$Calendar.gridFocusKeys = $558a1874964eed3d$var$gridFocusKeys;
$558a1874964eed3d$var$Calendar.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    selectable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    selectionMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'single',
        'multi'
    ]),
    selectedDates: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date)),
    keybinds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        key: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        action: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'ctrlKey',
            'altKey',
            'metaKey'
        ])),
        description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    })),
    customDateDisabler: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    weekendsDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    bankHolidaysDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    jonesMarketHolidaysDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    futureDatesDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    pastDatesDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showBankHolidays: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showJonesMarketHolidays: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showLastSellingDays: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'en-us',
        'en-ca'
    ]),
    holidayLocale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'en-us',
        'en-ca',
        'all'
    ]),
    onDateSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onShortcutToggle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    keyboardManager: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    })
};
var $558a1874964eed3d$var$Calendar$1 = $558a1874964eed3d$var$Calendar;
/* eslint-disable func-names */ const $558a1874964eed3d$var$CaretManager = function(domInput) {
    this.domInput = domInput;
    this.start = domInput.selectionStart;
    this.end = domInput.selectionEnd;
    this.length = this.end - this.start;
    const { maxLength: maxLength } = domInput;
    const getSanitizedPosition = (position)=>{
        if (position < 0) return 0;
        if (maxLength > 0 && position > maxLength) return maxLength;
        return position;
    };
    this.moveBy = (start, end)=>{
        this.start += start;
        if (typeof end !== 'undefined') this.end += end;
        else this.end = this.start;
        this.start = getSanitizedPosition(this.start);
        this.end = getSanitizedPosition(this.end);
        this.length = this.end - this.start;
    };
    this.jumpTo = (start, end)=>{
        this.start = getSanitizedPosition(start);
        this.end = getSanitizedPosition(typeof end === 'undefined' ? start : end);
        this.length = this.end - this.start;
    };
    this.collapse = ()=>{
        this.end = this.start;
        this.length = 0;
    };
};
var $558a1874964eed3d$var$CaretManager$1 = $558a1874964eed3d$var$CaretManager;
const $558a1874964eed3d$var$DATE_SEPARATOR = '/';
const $558a1874964eed3d$var$getSegmentTemplate = (localeFormat)=>{
    const separatorPositions = Array.from(localeFormat.matchAll(new RegExp($558a1874964eed3d$var$DATE_SEPARATOR, 'g'))).map((match)=>match.index);
    const template = [
        {
            position: 0,
            length: separatorPositions[0],
            isAutofillable: separatorPositions[0] === 2
        }
    ];
    separatorPositions.forEach((position, index)=>{
        const nextPosition = typeof separatorPositions[index + 1] === 'undefined' ? localeFormat.length : separatorPositions[index + 1];
        const length = nextPosition - separatorPositions[index] - 1;
        template.push({
            position: position + 1,
            length: length,
            // Month and Day segments will be auto-fillable by pressing the "forward-slash" key,
            // so we check to see if the current segment is a 2-digit segment
            isAutofillable: length === 2
        });
    });
    return template;
};
const $558a1874964eed3d$var$setClassName = (baseClass, hasError, condensed)=>{
    const inputClassList = [
        baseClass
    ];
    if (hasError) inputClassList.push(`${baseClass}--error`);
    if (condensed) inputClassList.push(`${baseClass}--condensed`);
    return inputClassList.join(' ');
};
const $558a1874964eed3d$var$DatePickerInput = /*#__PURE__*/ (0, $acw62.forwardRef)((props, refs)=>{
    const { id: id, name: name, value: value = '', onChange: onChange = ()=>{}, onFocus: onFocus = ()=>{}, onBlur: onBlur = ()=>{}, localeFormat: localeFormat, disabled: disabled = false, readOnly: readOnly = false, condensed: condensed = false, hasError: hasError = false, inputMicrocopyId: inputMicrocopyId, isRequired: isRequired = false } = props;
    const defaultRefs = {
        inputRef: (0, $acw62.useRef)()
    };
    const { inputRef: inputRef } = {
        ...defaultRefs,
        ...refs
    };
    const isMounted = $558a1874964eed3d$var$useIsMounted$1();
    const [inputValueSegments, setInputValueSegments] = (0, $acw62.useState)(value.split($558a1874964eed3d$var$DATE_SEPARATOR));
    const [caretPosition, setCaretPosition] = (0, $acw62.useState)(null);
    const segmentTemplate = $558a1874964eed3d$var$getSegmentTemplate(localeFormat);
    const templateSeparatorPositions = Array.from(localeFormat.matchAll(new RegExp($558a1874964eed3d$var$DATE_SEPARATOR, 'g'))).map((match)=>match.index);
    const formatDigitCount = segmentTemplate.reduce((total, segment)=>total + segment.length, 0);
    const formatRegex = new RegExp(`^\\d{0,${formatDigitCount}}$`);
    const getCurrentSegment = ({ inputValue: inputValue, editorCaret: editorCaret })=>{
        const separatorMatches = Array.from(inputValue.matchAll(new RegExp($558a1874964eed3d$var$DATE_SEPARATOR, 'g')));
        const segmentMatchIndex = separatorMatches.findIndex((matches)=>editorCaret.start <= matches.index);
        return segmentMatchIndex === -1 ? separatorMatches.length : segmentMatchIndex;
    };
    const updateSegment = ({ index: index, segments: segments, editorCaret: editorCaret, pressedKey: pressedKey, manipulationType: manipulationType = 'entry' })=>{
        const originalSegmentValue = segments[index] || '';
        const separatorPositions = Array.from(segments.join($558a1874964eed3d$var$DATE_SEPARATOR).matchAll(new RegExp($558a1874964eed3d$var$DATE_SEPARATOR, 'g'))).map((match)=>match.index);
        const caretOffset = index === 0 ? -1 : separatorPositions[index - 1];
        const segmentSplitPosition = editorCaret.start - caretOffset - 1;
        const segmentPartials = {
            start: originalSegmentValue.substring(0, segmentSplitPosition),
            end: originalSegmentValue.substring(segmentSplitPosition)
        };
        if (manipulationType === 'deletion') {
            if (pressedKey === 'Backspace') segmentPartials.start = segmentPartials.start.slice(0, -1);
            if (pressedKey === 'Delete') segmentPartials.end = segmentPartials.end.slice(1);
            const updatedSegmentValue = [
                segmentPartials.start,
                segmentPartials.end
            ].join('');
            return updatedSegmentValue;
        }
        const updatedSegmentValue = [
            segmentPartials.start,
            pressedKey,
            segmentPartials.end
        ].join('');
        return updatedSegmentValue;
    };
    const handleDataEntry = ({ domInput: domInput, editorCaret: editorCaret, pressedKey: pressedKey, isNumeric: isNumeric, isSeparator: isSeparator })=>{
        let updatedValue;
        let updatedValueSegments = [
            ...inputValueSegments
        ];
        const currentValue = String(updatedValueSegments.join($558a1874964eed3d$var$DATE_SEPARATOR));
        const newValue = {
            start: currentValue.substring(0, editorCaret.start),
            end: currentValue.substring(editorCaret.end),
            highlighted: currentValue.substring(editorCaret.start, editorCaret.end).replace(/[^/]/g, '')
        };
        updatedValue = `${newValue.start}${newValue.highlighted}${newValue.end}`;
        updatedValueSegments = updatedValue.split($558a1874964eed3d$var$DATE_SEPARATOR);
        editorCaret.collapse();
        const currentSegmentIndex = getCurrentSegment({
            inputValue: updatedValue,
            editorCaret: editorCaret
        });
        if (updatedValue.length < localeFormat.length) {
            if (isNumeric) {
                const expectedSeparatorPosition = templateSeparatorPositions[currentSegmentIndex];
                // Check to see if the editor caret is just before where we expect to see a separator
                if (editorCaret.start === expectedSeparatorPosition) {
                    if (editorCaret.start === templateSeparatorPositions.at(-1)) newValue.end = newValue.end.substring(1);
                    updatedValueSegments[currentSegmentIndex + 1] = updateSegment({
                        index: currentSegmentIndex + 1,
                        segments: updatedValueSegments,
                        editorCaret: editorCaret,
                        pressedKey: pressedKey
                    });
                    updatedValue = updatedValueSegments.join($558a1874964eed3d$var$DATE_SEPARATOR);
                    editorCaret.moveBy(2);
                } else {
                    updatedValueSegments[currentSegmentIndex] = updateSegment({
                        index: currentSegmentIndex,
                        segments: updatedValueSegments,
                        editorCaret: editorCaret,
                        pressedKey: pressedKey
                    });
                    updatedValue = updatedValueSegments.join($558a1874964eed3d$var$DATE_SEPARATOR);
                    editorCaret.moveBy(1);
                }
            }
            if (isSeparator) {
                const valueSegments = [];
                updatedValue.split($558a1874964eed3d$var$DATE_SEPARATOR).reduce((position, valueSegment)=>{
                    const { length: length } = valueSegment;
                    valueSegments.push({
                        value: valueSegment,
                        position: position + length + 1
                    });
                    return position + length + 1;
                }, 0);
                const previousSegment = currentSegmentIndex === 0 ? {
                    position: 0
                } : valueSegments[currentSegmentIndex - 1];
                const currentSegmentLength = segmentTemplate[currentSegmentIndex].length;
                // [User Action] The user attempted to type the "forward-slash" key to indicate the end of data entry
                // for the current segment.
                if (segmentTemplate[currentSegmentIndex].isAutofillable) {
                    updatedValueSegments[currentSegmentIndex] = $558a1874964eed3d$var$zeroFill(updatedValueSegments[currentSegmentIndex], currentSegmentLength);
                    updatedValue = updatedValueSegments.join($558a1874964eed3d$var$DATE_SEPARATOR);
                    editorCaret.jumpTo(previousSegment.position + updatedValueSegments[currentSegmentIndex].length + 1);
                    if (editorCaret.start >= updatedValue.length && updatedValueSegments.length !== segmentTemplate.length) {
                        updatedValueSegments.push('');
                        updatedValue = updatedValueSegments.join($558a1874964eed3d$var$DATE_SEPARATOR);
                    }
                }
            }
        // If the field as already hit it's maximum character limit, then suppress user input
        } else if (updatedValue.length === localeFormat.length) updatedValue = domInput.value;
        setInputValueSegments(updatedValueSegments);
    };
    const handleDataRemoval = ({ editorCaret: editorCaret, pressedKey: pressedKey })=>{
        let updatedValue;
        let updatedValueSegments = [
            ...inputValueSegments
        ];
        const currentValue = String(updatedValueSegments.join($558a1874964eed3d$var$DATE_SEPARATOR));
        const newValue = {
            start: currentValue.substring(0, editorCaret.start),
            end: currentValue.substring(editorCaret.end),
            highlighted: currentValue.substring(editorCaret.start, editorCaret.end).replace(/[^/]/g, '')
        };
        const isDeletingBlock = editorCaret.length > 0;
        updatedValue = `${newValue.start}${newValue.highlighted}${newValue.end}`;
        editorCaret.collapse();
        let currentSegmentIndex = getCurrentSegment({
            inputValue: updatedValue,
            editorCaret: editorCaret
        });
        if (!isDeletingBlock) {
            if (pressedKey === 'Delete') {
                if (updatedValue.charAt(editorCaret.start) === $558a1874964eed3d$var$DATE_SEPARATOR) {
                    editorCaret.moveBy(1);
                    // eslint-disable-next-line no-plusplus
                    currentSegmentIndex++;
                }
                updatedValueSegments[currentSegmentIndex] = updateSegment({
                    index: currentSegmentIndex,
                    segments: updatedValueSegments,
                    editorCaret: editorCaret,
                    pressedKey: pressedKey,
                    manipulationType: 'deletion'
                });
            }
            if (pressedKey === 'Backspace') {
                let charactersToDelete = 1;
                if (updatedValue.charAt(editorCaret.start - 1) === $558a1874964eed3d$var$DATE_SEPARATOR) {
                    if (editorCaret.start === updatedValue.length) // eslint-disable-next-line no-plusplus
                    charactersToDelete++;
                    else editorCaret.moveBy(-1);
                    // eslint-disable-next-line no-plusplus
                    currentSegmentIndex--;
                }
                updatedValueSegments[currentSegmentIndex] = updateSegment({
                    index: currentSegmentIndex,
                    segments: updatedValueSegments,
                    editorCaret: editorCaret,
                    pressedKey: pressedKey,
                    manipulationType: 'deletion'
                });
                editorCaret.moveBy(-1 * charactersToDelete);
            }
            // eslint-disable-next-line max-len
            for(let index = updatedValueSegments.length - 1; index > currentSegmentIndex; index--){
                if (updatedValueSegments[index] === '') updatedValueSegments.pop();
                else break;
            }
            updatedValue = updatedValueSegments.join($558a1874964eed3d$var$DATE_SEPARATOR);
        } else updatedValueSegments = updatedValue.split($558a1874964eed3d$var$DATE_SEPARATOR);
        if ([
            '//',
            '/'
        ].includes(updatedValue)) updatedValueSegments = [];
        setInputValueSegments(updatedValueSegments);
    };
    const moveToSegment = ({ pressedKey: pressedKey, domInput: domInput, editorCaret: editorCaret })=>{
        const isCaretMovingLeft = pressedKey === 'ArrowLeft';
        const isCaretMovingRight = pressedKey === 'ArrowRight';
        let movingIndex = 0;
        let newSegment;
        const inputSegments = domInput.value.split($558a1874964eed3d$var$DATE_SEPARATOR).map((segment)=>{
            const start = movingIndex;
            const end = movingIndex + segment.length;
            movingIndex = end + 1;
            return {
                start: start,
                end: end
            };
        });
        const currentSegmentIndex = inputSegments.findIndex((segment)=>segment.start <= editorCaret.start && segment.end >= editorCaret.end);
        const isFullyHighlighted = editorCaret.start === inputSegments[currentSegmentIndex].start && editorCaret.end === inputSegments[currentSegmentIndex].end;
        if (!isFullyHighlighted) newSegment = inputSegments[currentSegmentIndex];
        else if (isCaretMovingLeft) {
            const newSegmentIndex = Math.max(0, currentSegmentIndex - 1);
            newSegment = inputSegments[newSegmentIndex];
        } else if (isCaretMovingRight) {
            const newSegmentIndex = Math.min(2, currentSegmentIndex + 1);
            newSegment = inputSegments[newSegmentIndex];
        }
        setCaretPosition(newSegment);
    };
    const handleKeyPress = (event, key, caret)=>{
        const domInput = event.target;
        const isSynthetic = typeof key !== 'undefined';
        const pressedKey = isSynthetic ? key : event.key;
        const isNumeric = /^\d$/.test(pressedKey);
        const isSeparator = pressedKey === $558a1874964eed3d$var$DATE_SEPARATOR;
        const isDeleteKey = [
            'Backspace',
            'Delete'
        ].includes(pressedKey);
        const isNavigationKey = [
            'ArrowLeft',
            'ArrowRight'
        ].includes(pressedKey);
        const isEntryKey = isNumeric || isSeparator;
        const isDateManipulationKey = isEntryKey || isDeleteKey;
        const isModifierKeyActive = event.altKey || event.ctrlKey || event.metaKey;
        const editorCaret = typeof caret === 'undefined' ? new $558a1874964eed3d$var$CaretManager$1(domInput) : caret;
        // [User Action] User is attempting to manipulate the value into the date field
        if (isDateManipulationKey && !isModifierKeyActive) {
            if (isEntryKey) {
                handleDataEntry({
                    domInput: domInput,
                    editorCaret: editorCaret,
                    pressedKey: pressedKey,
                    isNumeric: isNumeric,
                    isSeparator: isSeparator
                });
                event.preventDefault();
            }
            if (isDeleteKey) {
                handleDataRemoval({
                    editorCaret: editorCaret,
                    event: event,
                    pressedKey: pressedKey
                });
                event.preventDefault();
            }
            setCaretPosition(editorCaret);
        }
        // [User Action] User is attempting to navigate to a specific segment within the field
        if (event.altKey && !event.shiftKey && isNavigationKey) moveToSegment({
            pressedKey: pressedKey,
            domInput: domInput,
            editorCaret: editorCaret
        });
    };
    /*
    The input's change handler will only be called if any of the following conditions are met:
       - The user attempts to perform a non-entry action that modifies the contents of the field (i.e. copy/paste, block-delete, etc)
      - The user is on a touch device or utilizing a virtual keyboard where the pressed key is not reported correctly
     In either case, the component will check for the incoming value changes and update it's state according.
  */ const handleChange = (event)=>{
        const domInput = event.target;
        const editorCaret = new $558a1874964eed3d$var$CaretManager$1(domInput);
        const currentValue = inputValueSegments.join($558a1874964eed3d$var$DATE_SEPARATOR);
        const valueLengthDiff = domInput.value.length - currentValue.length;
        const clipboardString = domInput.value.replace(new RegExp($558a1874964eed3d$var$DATE_SEPARATOR, 'g'), '').slice(0, 8);
        if (valueLengthDiff === -1) {
            editorCaret.moveBy(1);
            handleKeyPress(event, 'Backspace', editorCaret);
        } else if (valueLengthDiff === 1) {
            editorCaret.moveBy(-1);
            handleKeyPress(event, domInput.value.at(editorCaret.start), editorCaret);
            event.preventDefault();
        } else if (formatRegex.test(clipboardString)) {
            let segmentIndex = 0;
            let valueSegments = domInput.value.split($558a1874964eed3d$var$DATE_SEPARATOR).map((segment)=>{
                const returnValue = clipboardString.substr(segmentIndex, segment.length);
                segmentIndex += segment.length;
                return returnValue;
            });
            if ([
                '//',
                '/'
            ].includes(valueSegments.join($558a1874964eed3d$var$DATE_SEPARATOR))) valueSegments = [];
            setInputValueSegments(valueSegments);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (caretPosition !== null) window.requestAnimationFrame(()=>{
            // Check to see if the input reference is still active. In some rare cases, the input reference may be deleted before the
            // animation frame request resolves, resulting in errors being thrown
            if (inputRef.current) inputRef.current.setSelectionRange(caretPosition.start, caretPosition.end);
        });
    }, [
        caretPosition
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMounted) setInputValueSegments(value.split($558a1874964eed3d$var$DATE_SEPARATOR));
    }, [
        value
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMounted) onChange(inputValueSegments.join($558a1874964eed3d$var$DATE_SEPARATOR));
    }, [
        inputValueSegments
    ]);
    (0, $acw62.useImperativeHandle)(refs, ()=>({
            updateValue: (updatedValue)=>{
                if ([
                    null,
                    undefined
                ].includes(updatedValue)) setInputValueSegments([]);
                if (typeof updatedValue === 'string') setInputValueSegments(updatedValue.split($558a1874964eed3d$var$DATE_SEPARATOR));
            }
        }), []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
        id: id,
        name: name,
        ref: inputRef,
        disabled: disabled,
        readOnly: readOnly,
        value: inputValueSegments.join($558a1874964eed3d$var$DATE_SEPARATOR),
        onKeyDown: handleKeyPress,
        onChange: handleChange,
        onFocus: onFocus,
        onBlur: onBlur,
        className: $558a1874964eed3d$var$setClassName('axiom-datepicker--input', hasError, condensed),
        inputMode: "numeric",
        maxLength: 10,
        "aria-describedby": inputMicrocopyId,
        "aria-required": isRequired,
        "aria-invalid": hasError,
        autoComplete: "off"
    });
});
$558a1874964eed3d$var$DatePickerInput.displayName = 'DatePickerInput';
$558a1874964eed3d$var$DatePickerInput.propTypes = {
    localeFormat: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'MM/DD/YYYY',
        'DD/MM/YYYY'
    ]).isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    hasError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputMicrocopyId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isRequired: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $558a1874964eed3d$var$DatePickerInput$1 = $558a1874964eed3d$var$DatePickerInput;
const $558a1874964eed3d$var$CloseButton = ({ id: id, onClick: onClick, label: label = 'Close', inputRef: inputRef, condensed: condensed = true, customAriaLabel: customAriaLabel, classes: classes = [] })=>/*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
        id: id,
        label: label,
        onClick: onClick,
        inputRef: inputRef,
        condensed: condensed,
        customAriaLabel: customAriaLabel,
        classes: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-button--close'
            ],
            custom: [
                classes
            ],
            required: []
        }),
        iconOnly: true,
        icon: "close",
        styleVariant: "tertiary"
    });
$558a1874964eed3d$var$CloseButton.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    customAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $558a1874964eed3d$var$CloseButton$1 = $558a1874964eed3d$var$CloseButton;
const $558a1874964eed3d$var$tooltipPosition = (windowSize, scrollOffset, origTargetRect, tooltipSize, offsetParentRect, placement, align)=>{
    const targetRect = {
        ...origTargetRect
    };
    if (offsetParentRect) {
        targetRect.y -= offsetParentRect.top;
        targetRect.x -= offsetParentRect.left;
    }
    let positionVertical;
    let positionHorizontal;
    // can it fit below
    if (targetRect.y + targetRect.height + tooltipSize.height <= windowSize.height && placement === 'auto' || placement === 'below') positionVertical = 'below';
    else if (placement === 'center') positionVertical = 'center';
    else positionVertical = 'above';
    // can it center horizontally
    const tooltipCenteredX = targetRect.x + targetRect.width / 2 - tooltipSize.width / 2;
    if (tooltipCenteredX > 0 && tooltipCenteredX + tooltipSize.width <= windowSize.width && align === 'auto' || align === 'center') positionHorizontal = 'center';
    else if (tooltipCenteredX >= 0 && align === 'auto' || align === 'right') positionHorizontal = 'right';
    else positionHorizontal = 'left';
    let y = 0;
    if (positionVertical === 'below') y = targetRect.y + targetRect.height;
    else if (positionVertical === 'above') y = targetRect.y - tooltipSize.height;
    else y = targetRect.y - tooltipSize.height / 2 + targetRect.height / 2;
    let x = 0;
    if (positionHorizontal === 'center') x = targetRect.x + targetRect.width / 2 - tooltipSize.width / 2;
    else if (positionHorizontal === 'right') {
        if (positionVertical === 'center') x = targetRect.x + targetRect.width - tooltipSize.width + 16; // baseX(4)
        else /* eslint-disable no-lonely-if */ if (targetRect.isCustomAnchor) x = targetRect.x + targetRect.width - tooltipSize.width + 20;
        else x = targetRect.x + targetRect.width - tooltipSize.width + 8;
    } else if (positionVertical === 'center') x = targetRect.x - 16; // baseX(4)
    else /* eslint-disable no-lonely-if */ if (targetRect.isCustomAnchor) x = targetRect.x - 20;
    else x = targetRect.x - 8;
    if (!offsetParentRect) {
        x += scrollOffset.x;
        y += scrollOffset.y;
    }
    return {
        x: x,
        y: y,
        horizontal: positionHorizontal,
        vertical: positionVertical
    };
};
var $558a1874964eed3d$var$tooltipPosition$1 = $558a1874964eed3d$var$tooltipPosition;
const $558a1874964eed3d$var$windowSize = ()=>{
    const win = window;
    const doc = document;
    const docElem = doc.documentElement;
    const body = doc.getElementsByTagName('body')[0];
    /* istanbul ignore next */ const windowWidth = win.innerWidth || docElem.clientWidth || body.clientWidth;
    /* istanbul ignore next */ const windowHeight = win.innerHeight || docElem.clientHeight || body.clientHeight;
    return {
        width: windowWidth,
        height: windowHeight
    };
};
const $558a1874964eed3d$var$windowScrollPosition = ()=>({
        x: window.scrollX || document.documentElement.scrollLeft,
        y: window.scrollY || document.documentElement.scrollTop
    });
const $558a1874964eed3d$var$Tooltip$1 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ id: id, title: title, children: children, onClose: onClose, targetId: targetId, linkDecoration: linkDecoration = 'underline', linkText: linkText, linkUrl: linkUrl, shown: shown = false, modal: modal = false, closeLabel: closeLabel = 'Close tooltip', onKeyDown: onKeyDown = ()=>{}, placement: placement = 'auto', customAnchorId: customAnchorId, align: align = 'auto', classes: classes = [], ariaLabel: ariaLabel }, refs)=>{
    const defaultRefs = {
        tooltipRef: (0, $acw62.useRef)(),
        closeButtonRef: (0, $acw62.useRef)()
    };
    const scrollYRef = (0, $acw62.useRef)();
    const { tooltipRef: tooltipRef, closeButtonRef: closeButtonRef } = {
        ...defaultRefs,
        ...refs
    };
    const [position, setPosition] = (0, $acw62.useState)(undefined);
    const updatePosition = ()=>{
        /* istanbul ignore else */ if (tooltipRef.current != null) {
            const targetElement = document.getElementById(targetId);
            const customAnchor = customAnchorId ? document.getElementById(customAnchorId).getBoundingClientRect() : null;
            const targetRect = targetElement.getBoundingClientRect();
            const tooltipRect = tooltipRef.current.getBoundingClientRect();
            let offsetParentRect;
            const modalContent = targetElement.closest('.ReactModal__Content');
            /* istanbul ignore next */ if (targetElement.offsetParent !== null && targetElement.offsetParent.nodeName !== 'BODY' && targetElement.contains(tooltipRef.current)) /* istanbul ignore next */ offsetParentRect = targetElement.offsetParent.getBoundingClientRect();
            // If target is in a modal and tooltip will be portaled there,
            // use the modal content as the offset parent for proper coordinate calculations
            if (modalContent) offsetParentRect = modalContent.getBoundingClientRect();
            const computedPosition = ()=>{
                if (customAnchor != null) return {
                    x: customAnchor.left,
                    y: customAnchor.top,
                    width: customAnchor.width,
                    height: customAnchor.height,
                    isCustomAnchor: true
                };
                return {
                    x: targetRect.left,
                    y: targetRect.top,
                    width: targetRect.width,
                    height: targetRect.height,
                    isCustomAnchor: false
                };
            };
            const newPosition = $558a1874964eed3d$var$tooltipPosition$1($558a1874964eed3d$var$windowSize(), $558a1874964eed3d$var$windowScrollPosition(), computedPosition(), {
                width: tooltipRect.width,
                height: tooltipRect.height
            }, offsetParentRect, placement, align);
            setPosition(newPosition);
        }
    };
    (0, $acw62.useLayoutEffect)(()=>{
        if (!shown) return;
        // Check if target is inside a ReactModal
        const targetElement = document.getElementById(targetId);
        const isInModal = targetElement?.closest('.ReactModal__Content') !== null;
        // Only prevent body scrolling if we're NOT in a modal
        if (!isInModal) {
            scrollYRef.current = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `${scrollYRef.current}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
        }
    }, [
        shown,
        targetId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shown || scrollYRef.current === null) return;
        // Only restore scroll if we prevented it
        const targetElement = document.getElementById(targetId);
        const isInModal = targetElement?.closest('.ReactModal__Content') !== null;
        if (!isInModal) requestAnimationFrame(()=>{
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.width = '';
            window.scrollTo(0, scrollYRef.current);
            scrollYRef.current = null;
        });
    }, [
        shown,
        targetId
    ]);
    const handleBodyClick = (e)=>{
        let node = e.target;
        while(node !== document.body){
            if (node === tooltipRef.current) {
                e.stopPropagation();
                return;
            }
            /* istanbul ignore else */ if (node === document.getElementById(targetId)) return;
            /* istanbul ignore next */ node = node.parentNode;
        }
        onClose(e);
    };
    /* istanbul ignore next */ const handleMovement = ()=>{
        updatePosition();
    };
    const handleKeyUp = (e)=>{
        if (e.key === 'Escape' || e.key === 'Esc') onClose(e);
    };
    const cleanupListeners = ()=>{
        const targetElement = document.getElementById(targetId);
        const modalContent = targetElement?.closest('.ReactModal__Content');
        document.body.removeEventListener('click', handleBodyClick);
        window.removeEventListener('scroll', handleMovement);
        window.removeEventListener('resize', handleMovement);
        window.removeEventListener('keyup', handleKeyUp);
        // Remove modal scroll listener if it was added
        if (modalContent) modalContent.removeEventListener('scroll', handleMovement);
    };
    (0, $acw62.useEffect)(()=>{
        const targetElement = document.getElementById(targetId);
        const modalContent = targetElement?.closest('.ReactModal__Content');
        if (shown) {
            document.body.addEventListener('click', handleBodyClick);
            window.addEventListener('scroll', handleMovement);
            window.addEventListener('resize', handleMovement);
            window.addEventListener('keyup', handleKeyUp);
            // Also listen for modal scroll events
            if (modalContent) modalContent.addEventListener('scroll', handleMovement);
        } else cleanupListeners();
        return cleanupListeners;
    }, [
        shown,
        targetId
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (shown) handleMovement();
    }, [
        shown
    ]);
    const defaultClasses = [
        'axiom-tooltip',
        'tooltip'
    ];
    (0, $acw62.useEffect)(()=>{
        if (closeButtonRef.current) {
            // TooltipPosition.js ensure the tooltip is on screen when focus so scrolling causes extra issues
            const focusParameter = placement === 'auto' && align === 'auto' ? {
                preventScroll: true
            } : {
                focusVisible: true
            };
            closeButtonRef.current.focus(focusParameter);
        }
    }, [
        closeButtonRef.current
    ]);
    if (position) {
        defaultClasses.push(`tooltip--position--vertical--${position.vertical}`);
        defaultClasses.push(`tooltip--position--horizontal--${position.horizontal}`);
    }
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(shown && /*#__PURE__*/ // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    (0, $ayMG0.jsxs)("div", {
        role: modal ? 'dialog' : 'tooltip',
        ref: tooltipRef,
        className: $558a1874964eed3d$var$createClassList({
            default: defaultClasses,
            custom: classes,
            required: []
        }),
        style: position && {
            left: position.x,
            top: position.y,
            opacity: 1
        },
        "data-testid": "tooltip",
        id: id,
        onKeyDown: onKeyDown,
        "aria-label": ariaLabel,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$CloseButton$1, {
                id: `${id}-close`,
                label: closeLabel,
                classes: [
                    'axiom-tooltip--button--close',
                    'axiom-button--close'
                ],
                onClick: onClose,
                inputRef: closeButtonRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "axiom-tooltip--content tooltip-content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        className: "axiom-tooltip--title tooltip-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        className: "axiom-tooltip--description",
                        children: children
                    }),
                    linkText && linkUrl && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                                className: "axiom-tooltip--gradient-rule tooltip--gradient-rule",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "axiom-tooltip--link tooltip--link",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$LinkJSX, {
                                    href: linkUrl,
                                    newWindow: true,
                                    hideUnderline: linkDecoration === 'none',
                                    children: linkText
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }), (()=>{
        // If target is inside a ReactModal, portal to the modal content to maintain coordinate system
        const targetElement = document.getElementById(targetId);
        const modalContent = targetElement?.closest('.ReactModal__Content');
        return modalContent || document.body;
    })());
});
$558a1874964eed3d$var$Tooltip$1.displayName = 'Tooltip';
$558a1874964eed3d$var$Tooltip$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    targetId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    linkDecoration: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'underline',
        'none'
    ]),
    linkText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    linkUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    shown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    modal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    closeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    placement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'auto',
        'above',
        'center',
        'below'
    ]),
    customAnchorId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    align: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'auto',
        'left',
        'center',
        'right'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $558a1874964eed3d$var$TooltipJSX = $558a1874964eed3d$var$Tooltip$1;
const $558a1874964eed3d$var$setErrorMessage = (errorCode)=>{
    const errorCodes = {
        bankHolidaysDisabled: `The selected date is a bank holiday. Please enter or select another date.`,
        fallback: `The selected date is invalid or not eligible for selection. Please enter or select another date.`,
        futureDatesDisabled: `Future dates cannot be selected. Please enter or select another date.`,
        invalidFormat: `The selected date is invalid or does not match the required format. Please enter or select another date.`,
        jonesMarketHolidaysDisabled: `The selected date is a market holiday. Please enter or select another date.`,
        pastDatesDisabled: `Past dates cannot be selected. Please enter or select another date.`,
        weekendsDisabled: `Weekend dates cannot be selected. Please enter or select another date.`
    };
    return errorCodes[errorCode] || errorCodes.fallback;
};
var $558a1874964eed3d$var$setErrorMessage$1 = $558a1874964eed3d$var$setErrorMessage;
const $558a1874964eed3d$var$accessibleLocaleFormat = (localeFormat)=>localeFormat.replaceAll('/', ' slash ').replace('MM', '2 digit month').replace('DD', '2 digit day').replace('YYYY', '4 digit year');
const $558a1874964eed3d$var$setScreenReaderText = ({ errorCode: errorCode, errorMessage: errorMessage, localeFormat: localeFormat })=>{
    if (!!errorMessage || !!errorCode) return null;
    return `Format entry as ${$558a1874964eed3d$var$accessibleLocaleFormat(localeFormat)}`;
};
var $558a1874964eed3d$var$setScreenReaderText$1 = $558a1874964eed3d$var$setScreenReaderText;
const $558a1874964eed3d$var$setLocaleFormat = (locale = '')=>{
    switch(locale.toLowerCase()){
        case 'en-ca':
            return 'DD/MM/YYYY';
        default:
            return 'MM/DD/YYYY';
    }
};
var $558a1874964eed3d$var$setLocaleFormat$1 = $558a1874964eed3d$var$setLocaleFormat;
const $558a1874964eed3d$var$getErrorMessage = ({ date: date, holidayLocale: holidayLocale, errorCode: errorCode, errorMessage: errorMessage, weekendsDisabled: weekendsDisabled, bankHolidaysDisabled: bankHolidaysDisabled, jonesMarketHolidaysDisabled: jonesMarketHolidaysDisabled, futureDatesDisabled: futureDatesDisabled, pastDatesDisabled: pastDatesDisabled })=>{
    // First check to see if the user passed in an error manually so that we
    // can show customized errors (even if there are no errors internally)
    if (errorMessage) return errorMessage;
    if (errorCode) return $558a1874964eed3d$var$setErrorMessage$1(errorCode);
    // Next check to see if a date is set (we don't want to throw errors if the date is
    // either incomplete or blank)
    if (!date) return null;
    // If the prior flags aren't tripped, then we move on to our error handling suite
    const isWeekend = [
        0,
        6
    ].includes(date.getDay());
    if (weekendsDisabled && isWeekend) return $558a1874964eed3d$var$setErrorMessage$1('weekendsDisabled');
    if (bankHolidaysDisabled && $558a1874964eed3d$var$isBankHoliday$1(date)) return $558a1874964eed3d$var$setErrorMessage$1('bankHolidaysDisabled');
    if (jonesMarketHolidaysDisabled && $558a1874964eed3d$var$isJonesMarketHoliday$1(date, holidayLocale)) return $558a1874964eed3d$var$setErrorMessage$1('jonesMarketHolidaysDisabled');
    if (futureDatesDisabled && date > $558a1874964eed3d$var$getToday$1()) return $558a1874964eed3d$var$setErrorMessage$1('futureDatesDisabled');
    if (pastDatesDisabled && date < $558a1874964eed3d$var$getToday$1()) return $558a1874964eed3d$var$setErrorMessage$1('pastDatesDisabled');
    return null;
};
const $558a1874964eed3d$var$DatePicker$1 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, refs)=>{
    const { id: id, name: name, value: value, onInputChange: onInputChange = ()=>{}, onFocus: onFocus = ()=>{}, onBlur: onBlur = ()=>{}, onComponentFocus: onComponentFocus = ()=>{}, onComponentBlur: onComponentBlur = ()=>{}, disabled: disabled = false, readOnly: readOnly = false, condensed: condensed = false, hideLabel: hideLabel = false, errorCode: errorCode, errorMessage: errorMessage, labelModifier: labelModifier, label: label, classes: classes = [], customDateDisabler: customDateDisabler = ()=>{}, weekendsDisabled: weekendsDisabled = false, bankHolidaysDisabled: bankHolidaysDisabled = false, jonesMarketHolidaysDisabled: jonesMarketHolidaysDisabled = false, futureDatesDisabled: futureDatesDisabled = false, pastDatesDisabled: pastDatesDisabled = false, showBankHolidays: showBankHolidays = false, showJonesMarketHolidays: showJonesMarketHolidays = false, showLastSellingDays: showLastSellingDays = false, locale: locale = 'en-us', holidayLocale: holidayLocale = locale, positioning: positioning = 'below', onDateSelect: onDateSelect = ()=>{}, keyboardShortcutTreatment: keyboardShortcutTreatment = 'original' } = props;
    const defaultRefs = {
        calendarRef: (0, $acw62.useRef)(),
        containerRef: (0, $acw62.useRef)(),
        inputRef: (0, $acw62.useRef)(),
        calendarToggleRef: (0, $acw62.useRef)()
    };
    const { calendarRef: calendarRef, containerRef: containerRef, inputRef: inputRef, calendarToggleRef: calendarToggleRef } = {
        ...defaultRefs,
        ...refs
    };
    const isMounted = $558a1874964eed3d$var$useIsMounted$1();
    const tooltipCloseRef = (0, $acw62.useRef)();
    const previousMonthRef = (0, $acw62.useRef)();
    const nextMonthRef = (0, $acw62.useRef)();
    const gridRef = (0, $acw62.useRef)();
    const helpButtonRef = (0, $acw62.useRef)();
    const shortcutCloseButtonRef = (0, $acw62.useRef)();
    const dateInputRef = (0, $acw62.useRef)();
    const sectionTabOrder = [
        tooltipCloseRef,
        previousMonthRef,
        nextMonthRef,
        gridRef,
        helpButtonRef
    ];
    const localeFormat = $558a1874964eed3d$var$setLocaleFormat$1(locale);
    const rawDate = $558a1874964eed3d$var$getNormalizedDate$1(value, locale);
    const formattedDate = $558a1874964eed3d$var$getFormattedDate(rawDate, locale);
    const [modalVisible, setModalVisible] = (0, $acw62.useState)(false);
    const [shortcutModalVisible, setShortcutModalVisible] = (0, $acw62.useState)(false);
    const [date, setDate] = (0, $acw62.useState)(rawDate);
    const [fieldValue, setFieldValue] = (0, $acw62.useState)(formattedDate || '');
    const [sectionFocusRef, setSectionFocusRef] = (0, $acw62.useState)(tooltipCloseRef);
    const [keyboardManager] = (0, $acw62.useState)(new (0, $6IdRn.EventSubscriber)());
    const errorMicrocopy = $558a1874964eed3d$var$getErrorMessage({
        date: date,
        holidayLocale: holidayLocale,
        errorCode: errorCode,
        errorMessage: errorMessage,
        weekendsDisabled: weekendsDisabled,
        bankHolidaysDisabled: bankHolidaysDisabled,
        jonesMarketHolidaysDisabled: jonesMarketHolidaysDisabled,
        futureDatesDisabled: futureDatesDisabled,
        pastDatesDisabled: pastDatesDisabled
    });
    const hasError = errorMicrocopy !== null;
    const isRequired = labelModifier === 'required';
    dateInputRef.inputRef = inputRef;
    const isSubComponent = (component)=>{
        if (!(component instanceof Element)) return false;
        const staticSubcomponents = [
            inputRef.current,
            calendarToggleRef.current
        ];
        const isStaticSubcomponent = staticSubcomponents.includes(component);
        const isCalendarSubcomponent = calendarRef.current ? calendarRef.current.contains(component) : false;
        return isStaticSubcomponent || isCalendarSubcomponent;
    };
    const updateValue = (updatedValue)=>{
        const updatedRawDate = $558a1874964eed3d$var$getNormalizedDate$1(updatedValue, locale);
        const updatedFormattedDate = $558a1874964eed3d$var$getFormattedDate(updatedRawDate, locale);
        // Prevent the DatePicker from updating if an invalid date was supplied (blank dates are allowed)
        if (updatedRawDate !== null || [
            '',
            undefined,
            null
        ].includes(updatedValue)) {
            setDate(updatedRawDate);
            setFieldValue(updatedFormattedDate);
            dateInputRef.current.updateValue(updatedFormattedDate);
        }
    };
    const toggleCalendar = ()=>{
        setModalVisible(!modalVisible);
        setSectionFocusRef(tooltipCloseRef);
        if (modalVisible) calendarToggleRef.current.focus();
    };
    const toggleShortcutMenu = (isActive)=>{
        setShortcutModalVisible(isActive);
        setSectionFocusRef(isActive ? shortcutCloseButtonRef : helpButtonRef);
    };
    const handleComponentFocus = (event)=>{
        if (!isSubComponent(event.relatedTarget)) onComponentFocus(event);
    };
    const handleComponentBlur = (event)=>{
        if (!isSubComponent(event.relatedTarget) && (!modalVisible || !isSubComponent(event.target))) onComponentBlur(event);
    };
    const closeCalendar = (event, maintainFocus)=>{
        setModalVisible(false);
        if (maintainFocus) calendarToggleRef.current.focus();
        else handleComponentBlur(event);
    };
    const handleKeyPress = (event)=>{
        const isModifierKeyActive = event.altKey || event.ctrlKey || event.metaKey;
        // Only attempt to override keyboard interactions if the user is attempting to shift focus within the component
        if (!isModifierKeyActive && event.key === 'Tab') {
            event.preventDefault();
            event.stopPropagation();
            const sectionFocusIndex = sectionTabOrder.indexOf(sectionFocusRef);
            const tabDirection = event.shiftKey ? -1 : 1;
            const newFocusIndex = (sectionFocusIndex + tabDirection + sectionTabOrder.length) % sectionTabOrder.length;
            const newFocusRef = sectionTabOrder[newFocusIndex];
            setSectionFocusRef(newFocusRef);
        } else if (!shortcutModalVisible) {
            keyboardManager.evoke('calendarKeyPress', event);
            // If a key is pressed that shifts focus to the calendar grid, we need to track that internally so that we can
            // tab to the next element within the component correctly
            if ($558a1874964eed3d$var$Calendar$1.gridFocusKeys.includes(event.key)) setSectionFocusRef(gridRef);
        }
    };
    const handleDateSelect = (dateSelected)=>{
        const dateMeta = {
            year: $558a1874964eed3d$var$zeroFill(dateSelected.getFullYear(), 4),
            month: $558a1874964eed3d$var$zeroFill(dateSelected.getMonth() + 1, 2),
            day: $558a1874964eed3d$var$zeroFill(dateSelected.getDate(), 2)
        };
        const updatedFieldValue = $558a1874964eed3d$var$dateFormatByType.locale[locale].split('/').map((sectionPartial)=>{
            const datePartial = $558a1874964eed3d$var$dateFormatByType.partial[sectionPartial];
            return dateMeta[datePartial];
        }).join('/');
        setDate(dateSelected);
        setFieldValue(updatedFieldValue);
        closeCalendar(null, true);
        onDateSelect(dateSelected);
    };
    const handleInputChange = (updatedValue)=>{
        const updatedDate = $558a1874964eed3d$var$getNormalizedDate$1(updatedValue, locale);
        if (updatedDate) {
            setDate(updatedDate);
            onDateSelect(updatedDate);
        }
        onInputChange(updatedValue);
    };
    (0, $acw62.useEffect)(()=>{
        if (isMounted && sectionFocusRef.current) sectionFocusRef.current.focus();
    }, [
        sectionFocusRef
    ]);
    (0, $acw62.useEffect)(()=>updateValue(value), [
        value
    ]);
    (0, $acw62.useImperativeHandle)(refs, ()=>({
            updateValue: updateValue
        }), []);
    const inputMicrocopyId = hasError ? `${id}_error` : `${id}-microcopy-sr-only`;
    const ariaLabel = label ? `Open Calendar for ${label}` : 'Open Calendar';
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: containerRef,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-datepicker'
            ],
            custom: [
                classes
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$InputControl$1, {
                id: id,
                label: label,
                error: errorMicrocopy,
                microcopy: hasError ? errorMicrocopy : `Format as ${localeFormat.toLocaleLowerCase()}`,
                microcopyScreenReader: $558a1874964eed3d$var$setScreenReaderText$1({
                    errorCode: errorCode,
                    errorMessage: errorMessage,
                    localeFormat: localeFormat
                }),
                labelModifier: labelModifier,
                hideLabel: hideLabel,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "axiom-datepicker--field-group",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$DatePickerInput$1, {
                            id: id,
                            ref: dateInputRef,
                            name: name,
                            value: fieldValue,
                            onChange: handleInputChange,
                            onFocus: (event)=>{
                                handleComponentFocus(event);
                                onFocus(event);
                            },
                            onBlur: (event)=>{
                                handleComponentBlur(event);
                                onBlur(event);
                            },
                            localeFormat: localeFormat,
                            disabled: disabled,
                            readOnly: readOnly,
                            condensed: condensed,
                            hasError: hasError,
                            inputMicrocopyId: inputMicrocopyId,
                            isRequired: isRequired
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                            id: `${id}-toggle`,
                            inputRef: calendarToggleRef,
                            classes: $558a1874964eed3d$var$createClassList({
                                default: [
                                    'axiom-datepicker--calendar-toggle'
                                ],
                                custom: [
                                    condensed ? 'axiom-datepicker--calendar-toggle--condensed' : null
                                ]
                            }),
                            label: ariaLabel,
                            iconOnly: true,
                            condensed: condensed,
                            icon: "date-calendar",
                            styleVariant: hasError ? 'destructive-secondary' : 'secondary',
                            onClick: toggleCalendar,
                            attributes: {
                                onFocus: handleComponentFocus,
                                onBlur: handleComponentBlur
                            },
                            disabled: disabled
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$TooltipJSX, {
                ref: {
                    tooltipRef: calendarRef,
                    closeButtonRef: tooltipCloseRef
                },
                id: `${id}-tooltip`,
                title: "",
                shown: modalVisible,
                modal: true,
                closeLabel: "Close calendar",
                classes: "axiom-datepicker--calendar-modal",
                ariaLabel: `${label} calendar`,
                targetId: `${id}-toggle`,
                placement: positioning,
                align: "center",
                onClose: (event)=>closeCalendar(event, false),
                onKeyDown: handleKeyPress,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Calendar$1, {
                    ref: {
                        previousMonthRef: previousMonthRef,
                        nextMonthRef: nextMonthRef,
                        gridRef: gridRef,
                        helpButtonRef: helpButtonRef,
                        shortcutCloseButtonRef: shortcutCloseButtonRef
                    },
                    date: date,
                    classes: classes,
                    selectable: true,
                    selectionMode: "single",
                    selectedDates: [
                        date
                    ],
                    customDateDisabler: customDateDisabler,
                    weekendsDisabled: weekendsDisabled,
                    bankHolidaysDisabled: bankHolidaysDisabled,
                    jonesMarketHolidaysDisabled: jonesMarketHolidaysDisabled,
                    futureDatesDisabled: futureDatesDisabled,
                    pastDatesDisabled: pastDatesDisabled,
                    showBankHolidays: showBankHolidays,
                    showJonesMarketHolidays: showJonesMarketHolidays,
                    showLastSellingDays: showLastSellingDays,
                    locale: locale,
                    holidayLocale: holidayLocale,
                    onDateSelect: handleDateSelect,
                    onShortcutToggle: toggleShortcutMenu,
                    keyboardManager: keyboardManager,
                    keyboardShortcutTreatment: keyboardShortcutTreatment
                })
            })
        ]
    });
});
$558a1874964eed3d$var$DatePicker$1.displayName = 'DatePicker';
$558a1874964eed3d$var$DatePicker$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onComponentFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onComponentBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    errorCode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    errorMessage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    customDateDisabler: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    weekendsDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    bankHolidaysDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    jonesMarketHolidaysDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    futureDatesDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    pastDatesDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showBankHolidays: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showJonesMarketHolidays: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showLastSellingDays: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'en-us',
        'en-ca'
    ]),
    holidayLocale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'en-us',
        'en-ca',
        'all'
    ]),
    positioning: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'above',
        'below',
        'interactive'
    ]),
    onDateSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    keyboardShortcutTreatment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'original',
        'visibleLabel',
        'updatedAlt'
    ])
};
var $558a1874964eed3d$var$CalendarJSX = $558a1874964eed3d$var$DatePicker$1;
var $558a1874964eed3d$export$5109c6dd95d8fb00 = function(_a) {
    var id = _a.id, _b = _a.name, name = _b === void 0 ? undefined : _b, _c = _a.value, value = _c === void 0 ? undefined : _c, _d = _a.onInputChange, onInputChange = _d === void 0 ? function() {} : _d, _e = _a.onFocus, onFocus = _e === void 0 ? function() {} : _e, _f = _a.onBlur, onBlur = _f === void 0 ? function() {} : _f, _g = _a.onComponentFocus, onComponentFocus = _g === void 0 ? function() {} : _g, _h = _a.onComponentBlur, onComponentBlur = _h === void 0 ? function() {} : _h, _j = _a.disabled, disabled = _j === void 0 ? false : _j, _k = _a.readOnly, readOnly = _k === void 0 ? false : _k, _l = _a.condensed, condensed = _l === void 0 ? false : _l, _m = _a.hideLabel, hideLabel = _m === void 0 ? false : _m, _o = _a.errorCode, errorCode = _o === void 0 ? undefined : _o, _p = _a.errorMessage, errorMessage = _p === void 0 ? undefined : _p, _q = _a.labelModifier, labelModifier = _q === void 0 ? undefined : _q, _r = _a.label, label = _r === void 0 ? undefined : _r, _s = _a.classes, classes = _s === void 0 ? [] : _s, _t = _a.customDateDisabler, customDateDisabler = _t === void 0 ? function() {} : _t, _u = _a.weekendsDisabled, weekendsDisabled = _u === void 0 ? false : _u, _v = _a.bankHolidaysDisabled, bankHolidaysDisabled = _v === void 0 ? false : _v, _w = _a.jonesMarketHolidaysDisabled, jonesMarketHolidaysDisabled = _w === void 0 ? false : _w, _x = _a.futureDatesDisabled, futureDatesDisabled = _x === void 0 ? false : _x, _y = _a.pastDatesDisabled, pastDatesDisabled = _y === void 0 ? false : _y, _z = _a.showBankHolidays, showBankHolidays = _z === void 0 ? false : _z, _0 = _a.showJonesMarketHolidays, showJonesMarketHolidays = _0 === void 0 ? false : _0, _1 = _a.showLastSellingDays, showLastSellingDays = _1 === void 0 ? false : _1, _2 = _a.locale, locale = _2 === void 0 ? 'en-us' : _2, _3 = _a.holidayLocale, holidayLocale = _3 === void 0 ? locale : _3, _4 = _a.positioning, positioning = _4 === void 0 ? 'below' : _4, _5 = _a.onDateSelect, onDateSelect = _5 === void 0 ? function() {} : _5;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$CalendarJSX, {
        id: id,
        name: name,
        value: value,
        onInputChange: onInputChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onComponentFocus: onComponentFocus,
        onComponentBlur: onComponentBlur,
        disabled: disabled,
        readOnly: readOnly,
        condensed: condensed,
        hideLabel: hideLabel,
        errorCode: errorCode,
        errorMessage: errorMessage,
        labelModifier: labelModifier,
        label: label,
        classes: classes,
        customDateDisabler: customDateDisabler,
        weekendsDisabled: weekendsDisabled,
        bankHolidaysDisabled: bankHolidaysDisabled,
        jonesMarketHolidaysDisabled: jonesMarketHolidaysDisabled,
        futureDatesDisabled: futureDatesDisabled,
        pastDatesDisabled: pastDatesDisabled,
        showBankHolidays: showBankHolidays,
        showJonesMarketHolidays: showJonesMarketHolidays,
        showLastSellingDays: showLastSellingDays,
        locale: locale,
        holidayLocale: holidayLocale,
        positioning: positioning,
        onDateSelect: onDateSelect
    });
};
$558a1874964eed3d$export$5109c6dd95d8fb00.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onComponentFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onComponentBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    errorCode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    errorMessage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    customDateDisabler: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    weekendsDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    bankHolidaysDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    jonesMarketHolidaysDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    futureDatesDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    pastDatesDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showBankHolidays: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showJonesMarketHolidays: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showLastSellingDays: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'en-us',
        'en-ca'
    ]),
    holidayLocale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'en-us',
        'en-ca',
        'all'
    ]),
    positioning: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'above',
        'below',
        'interactive'
    ]),
    onDateSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $558a1874964eed3d$export$3ddf2d174ce01153 = function(_a) {
    var title = _a.title, children = _a.children, open = _a.open, onRequestClose = _a.onRequestClose, onAfterClose = _a.onAfterClose, _b = _a.role, role = _b === void 0 ? 'dialog' : _b, _c = _a.icon, icon = _c === void 0 ? undefined : _c, _d = _a.ariaDescribedBy, ariaDescribedBy = _d === void 0 ? undefined : _d, _e = _a.parentSelector, parentSelector = _e === void 0 ? undefined : _e, _f = _a.className, className = _f === void 0 ? undefined : _f, _g = _a.classes, classes = _g === void 0 ? [] : _g, _h = _a.buttons, buttons = _h === void 0 ? [] : _h;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$Dialog$2, {
        icon: icon,
        title: title,
        ariaDescribedBy: ariaDescribedBy,
        open: open,
        className: className,
        buttons: buttons,
        onRequestClose: onRequestClose,
        onAfterClose: onAfterClose,
        parentSelector: parentSelector,
        role: role,
        classes: classes,
        children: children
    });
};
$558a1874964eed3d$export$3ddf2d174ce01153.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    onRequestClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    ariaDescribedBy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    parentSelector: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onAfterClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    buttons: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        text: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        styleVariant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'primary',
            'secondary',
            'tertiary',
            'reversed-primary',
            'reversed-secondary',
            'destructive-primary',
            'destructive-secondary',
            'destructive-tertiary'
        ]),
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
            })
        ]),
        iconPosition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'left',
            'right'
        ]),
        iconOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    }))
};
const $558a1874964eed3d$var$DonutChart$1 = ({ data: data, figureAlt: figureAlt, chartRadius: chartRadius, title: title, description: description, valueFormat: valueFormat = 'number', abbreviateLabels: abbreviateLabels = true, orientation: orientation = 'horizontal', classes: classes = [] })=>{
    // refs
    const figureRef = (0, $acw62.useRef)();
    const informationRefs = (0, $acw62.useRef)([]);
    const [dimensions, setDimensions] = (0, $acw62.useState)({
        figureWidth: 0
    });
    const [navItem, setNavItem] = (0, $acw62.useState)();
    const navItemRef = (0, $acw62.useRef)();
    navItemRef.current = navItem;
    // constants
    const MAXIMUM_FIGURE_WIDTH = 700;
    const MINIMUM_ANGLE = 0.01;
    const NUMBER_LEGEND_ELEMENTS = 2;
    // component data
    const maxDataPoints = data.length >= 9 ? 8 : data.length;
    const sortedData = data.sort((a, b)=>b.value - a.value).slice(0, maxDataPoints);
    const dataTotal = sortedData.reduce((total, val)=>total + val.value, 0);
    const dataPercentArray = sortedData.map((valueSet)=>valueSet.value / dataTotal);
    let percentDifference = 0;
    let noOfAdjustedSlices = 0;
    // component rendering
    const responsiveRadius = dimensions.figureWidth < MAXIMUM_FIGURE_WIDTH ? dimensions.figureWidth / 3 : chartRadius;
    const renderedRadius = chartRadius <= responsiveRadius ? chartRadius : responsiveRadius;
    const cx = renderedRadius * 1.25;
    const cy = renderedRadius * 1.25;
    const strokeWidth = renderedRadius * 0.5;
    const baseCircumference = 2 * Math.PI * renderedRadius;
    const adjustedCircumference = baseCircumference - 2; // for spacers between slices
    const sliceAngleOffset = (0, $acw62.useRef)(-90);
    const getDimensions = ()=>({
            figureWidth: figureRef.current.getBoundingClientRect().width
        });
    const moveFocus = (item)=>{
        if (typeof item === 'undefined') return;
        informationRefs.current.forEach((el)=>{
            el.setAttribute('tabIndex', '-1');
        });
        informationRefs.current[item].setAttribute('tabIndex', '0');
        informationRefs.current[item].focus();
    };
    const handleFigureFocus = (event)=>{
        if (figureRef.current !== event.target) return;
        informationRefs.current.forEach((el)=>{
            el.setAttribute('tabIndex', '-1');
        });
    };
    const handleKeyEvent = (event)=>{
        if (event.code === 'ArrowRight' || event.code === 'ArrowLeft') {
            event.preventDefault();
            event.stopPropagation();
            const currentItem = navItemRef.current;
            const lastNavItem = informationRefs.current.length - 1;
            const isFirst = navItemRef.current === 0;
            const isLast = navItemRef.current === lastNavItem;
            let destination;
            if (typeof navItemRef.current === 'undefined') {
                setNavItem(0);
                return;
            }
            if (event.code === 'ArrowRight' && event.target === figureRef.current || event.code === 'ArrowLeft' && event.target === figureRef.current) moveFocus(currentItem);
            else if (event.code === 'ArrowRight') {
                destination = isLast ? 0 : navItemRef.current + 1;
                setNavItem(destination);
            } else if (event.code === 'ArrowLeft') {
                destination = isFirst ? lastNavItem : navItemRef.current - 1;
                setNavItem(destination);
            }
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (!figureRef.current) return;
        figureRef.current.addEventListener('keydown', handleKeyEvent);
        // eslint-disable-next-line consistent-return
        return ()=>{
            if (!figureRef.current) return;
            figureRef.current.removeEventListener('keydown', handleKeyEvent);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const handleResize = ()=>{
            setDimensions(getDimensions());
        };
        if (figureRef.current) setDimensions(getDimensions());
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, [
        figureRef
    ]);
    (0, $acw62.useEffect)(()=>{
        if (typeof navItem === 'undefined') return;
        moveFocus(navItem);
    }, [
        navItem
    ]);
    const compareDataPercent = (percent)=>{
        if (percent < MINIMUM_ANGLE) {
            percentDifference += MINIMUM_ANGLE - percent;
            noOfAdjustedSlices += 1;
        }
    };
    dataPercentArray.forEach(compareDataPercent);
    if (percentDifference > 0) {
        const adjustValue = percentDifference / (dataPercentArray.length - noOfAdjustedSlices);
        dataPercentArray.map((percent)=>{
            let dataPercentValue;
            if (percent > MINIMUM_ANGLE) dataPercentValue = percent - adjustValue;
            else dataPercentValue = MINIMUM_ANGLE;
            return dataPercentValue;
        });
    }
    const calculateStrokeDashOffset = (index)=>{
        const strokeDiff = dataPercentArray[index] * baseCircumference;
        return baseCircumference - strokeDiff;
    };
    const calculateDegrees = (index)=>{
        const origAngle = sliceAngleOffset.current;
        sliceAngleOffset.current = dataPercentArray[index] * 360 + sliceAngleOffset.current;
        return origAngle;
    };
    const abbreviateNumber = (number, places)=>{
        // ** used as exponentiation operator
        const decimalPlaces = 10 ** places;
        const abbreviations = [
            'K',
            'M',
            'B',
            'T'
        ];
        let roundedNum;
        abbreviations.forEach((abbreviation, i)=>{
            const size = 10 ** ((i + 1) * 3);
            if (size <= number) {
                roundedNum = Math.round(number * decimalPlaces / size) / decimalPlaces;
                roundedNum += abbreviation;
            }
        });
        return roundedNum || number;
    };
    const addCommas = (dataVal)=>{
        const x = dataVal.toString().split('.');
        let x1 = x[0];
        const x2 = x.length > 1 ? `.${x[1]}` : '';
        const rgx = /(\d+)(\d{3})/;
        while(rgx.test(x1))x1 = x1.replace(rgx, '$1,$2');
        return `${x1}${x2}`;
    };
    const formatValues = (dataVal)=>{
        let formattedValue = '';
        if (valueFormat === 'percent') formattedValue = `${dataVal}%`;
        else if (valueFormat === 'dollar' && abbreviateLabels) formattedValue = `$${abbreviateNumber(dataVal, 1)}`;
        else if (valueFormat === 'dollar') formattedValue = `$${addCommas(dataVal)}`;
        else if (valueFormat === 'number' && abbreviateLabels) formattedValue = abbreviateNumber(dataVal, 1);
        else formattedValue = addCommas(dataVal);
        return formattedValue;
    };
    const renderKey = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            className: "axiom-donut-chart--key-wrapper key-wrapper",
            children: sortedData.map((value, index)=>{
                // Note:
                // This formatting is to make this content
                // more screen reader friendly. Utizing formatValues()
                // directly in string template causes extra characters
                // to be read by screen reader
                const formattedValue = formatValues(value.value);
                const listItemContent = `${value.category} (${formattedValue})`;
                return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    id: `chartdata-${index + 1}`,
                    className: `axiom-donut-chart--key-item key-item key${index + 1}`,
                    tabIndex: "-1",
                    ref: (legend)=>{
                        informationRefs.current[index + NUMBER_LEGEND_ELEMENTS] = legend;
                    },
                    children: listItemContent
                }, `key-${value.category}`);
            })
        });
    const renderChart = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("g", {
            className: "axiom-donut-chart--chartWrapper chartWrapper",
            children: sortedData.map((value, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: cx,
                    cy: cy,
                    r: renderedRadius,
                    fill: "transparent",
                    id: `slice-${value.category}`,
                    className: `axiom-donut-chart--slice${index + 1} slice${index + 1}`,
                    strokeWidth: strokeWidth,
                    strokeDasharray: adjustedCircumference,
                    strokeDashoffset: calculateStrokeDashOffset(index),
                    transform: `rotate(${calculateDegrees(index)},${cx},${cy})`
                }, `slice-${value.category}`))
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        style: {
            height: `${dimensions.figureWidth < MAXIMUM_FIGURE_WIDTH ? 'auto' : `${adjustedCircumference / 2}px`}`
        },
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-donut-chart',
                'donut-chart'
            ],
            custom: classes,
            required: []
        }),
        ref: figureRef,
        "aria-hidden": "false",
        "data-orientation": dimensions.figureWidth < MAXIMUM_FIGURE_WIDTH ? 'vertical' : orientation,
        tabIndex: "0",
        onFocus: handleFigureFocus,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "axiom-donut-chart--legend data-viz-legend",
                "aria-hidden": "false",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$DataVizLegend$1, {
                    title: title,
                    description: description,
                    ref: {
                        titleRef: (reference)=>{
                            informationRefs.current[0] = reference;
                        },
                        descriptionRef: (reference)=>{
                            informationRefs.current[1] = reference;
                        }
                    }
                })
            }),
            renderKey(),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "img",
                className: "axiom-donut-chart--main-container-svg main-container-svg",
                "aria-label": figureAlt,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    alt: `Donut Chart of ${title}`,
                    "aria-hidden": "true",
                    style: {
                        height: `${renderedRadius * 2 + strokeWidth}px`,
                        width: `${renderedRadius * 2 + strokeWidth}px`
                    },
                    children: renderChart()
                })
            })
        ]
    });
};
$558a1874964eed3d$var$DonutChart$1.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        category: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired
    })).isRequired,
    figureAlt: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    chartRadius: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            headingSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                1,
                2,
                3,
                4,
                5,
                6
            ]),
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ]),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
        })
    ]),
    valueFormat: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'percent',
        'dollar',
        'number'
    ]),
    abbreviateLabels: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'vertical',
        'horizontal'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$DonutChartJSX = $558a1874964eed3d$var$DonutChart$1;
var $558a1874964eed3d$export$533707e2f61b59ec = function(_a) {
    var data = _a.data, figureAlt = _a.figureAlt, chartRadius = _a.chartRadius, _b = _a.title, title = _b === void 0 ? undefined : _b, _c = _a.description, description = _c === void 0 ? undefined : _c, _d = _a.valueFormat, valueFormat = _d === void 0 ? 'number' : _d, _e = _a.abbreviateLabels, abbreviateLabels = _e === void 0 ? true : _e, _f = _a.orientation, orientation = _f === void 0 ? 'horizontal' : _f, _g = _a.classes, classes = _g === void 0 ? [] : _g;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$DonutChartJSX, {
        data: data,
        title: title,
        description: description,
        valueFormat: valueFormat,
        figureAlt: figureAlt,
        abbreviateLabels: abbreviateLabels,
        chartRadius: chartRadius,
        orientation: orientation,
        classes: classes
    });
};
$558a1874964eed3d$export$533707e2f61b59ec.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        category: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired
    })).isRequired,
    figureAlt: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    chartRadius: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            headingSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                1,
                2,
                3,
                4,
                5,
                6
            ]),
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ]),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
        })
    ]),
    valueFormat: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'percent',
        'dollar',
        'number'
    ]),
    abbreviateLabels: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'vertical',
        'horizontal'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$Feedback$1 = ({ id: id, preUrl: preUrl, jorpNumber: jorpNumber, classes: classes, useGateway: useGateway })=>{
    (useGateway || classes.buttonClasses || classes.notificationClasses || classes.modalClasses) && console.warn(`DEPRECATION WARNING
---------------------
  As our feedback system changes, the following props are planned for deprecation:
  - useGateway
  - classes.buttonClasses
  - classes.notificationClasses
  - classes.modalClasses

Please remove these props if you have not yet done so.
  
Visit the AXIOM documentation for further clarification.`);
    // eslint-disable-next-line no-console
    id !== undefined && console.warn(`PROP CHANGE WARNING
---------------------
The id prop now optionally applies a DOM ID to the button component at the core of this component.
      
If your application previously assigned an Application ID to this property, we recommend removing the prop or updating to a more appropriate DOM ID value.

Visit the AXIOM documentation for further clarification.`);
    const environment = window.location.href.indexOf('edwardjones.com') !== -1 ? '.edwardjones.com' : '.devjones.com';
    const surveyUrlBase = environment === '.edwardjones.com' ? 'https://edwardjones.co1.qualtrics.com/jfe/form/SV_1ZXjVzHyj5dKs18' : 'https://edwardjones.co1.qualtrics.com/jfe/form/SV_7R4fAdPzavmqtO6';
    const getSurveyUrlParameters = [];
    preUrl && getSurveyUrlParameters.push(`preURL=${preUrl}`);
    jorpNumber && getSurveyUrlParameters.push(`jorpNum=${jorpNumber}`);
    const surveyUrlParameters = getSurveyUrlParameters.length === 2 ? `${getSurveyUrlParameters[0]}&${getSurveyUrlParameters[1]}` : getSurveyUrlParameters[0];
    const surveyUrlWithParameters = getSurveyUrlParameters.length > 0 && `${surveyUrlBase}?${surveyUrlParameters}`;
    const surveyUrl = preUrl || jorpNumber ? surveyUrlWithParameters : surveyUrlBase;
    const goToSurvey = ()=>{
        window.open(surveyUrl, '_blank');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
        onClick: ()=>goToSurvey(),
        styleVariant: "reversed-secondary",
        label: "Feedback",
        icon: "feedback-bubble",
        id: id,
        classes: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-feedback--button'
            ],
            custom: classes,
            required: []
        })
    });
};
$558a1874964eed3d$var$Feedback$1.propTypes = {
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            buttonClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
            ]),
            notificationClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
            ]),
            modalClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
            ])
        })
    ]),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    jorpNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    preUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    useGateway: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $558a1874964eed3d$var$Feedback$2 = $558a1874964eed3d$var$Feedback$1;
var $558a1874964eed3d$export$175e500a48a60fd2 = function(_a) {
    var id = _a.id, _b = _a.classes, classes = _b === void 0 ? [] : _b, preUrl = _a.preUrl, jorpNumber = _a.jorpNumber, useGateway = _a.useGateway;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$Feedback$2, {
        id: id,
        classes: classes,
        preUrl: preUrl,
        jorpNumber: jorpNumber,
        useGateway: useGateway
    });
};
$558a1874964eed3d$export$175e500a48a60fd2.propTypes = {
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            buttonClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
            ]),
            notificationClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
            ]),
            modalClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
            ])
        })
    ]),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    jorpNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    preUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    useGateway: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
const $558a1874964eed3d$var$statusIconMap = {
    completed: 'checkmark-fill',
    error: 'notice-error-fill'
};
const $558a1874964eed3d$var$statusLabelMap$1 = {
    'awaiting-upload': 'In Upload Queue',
    'uploading': 'Uploading...',
    'completed': 'Upload Complete',
    'error': 'Upload Failed'
};
const $558a1874964eed3d$var$setQueueFromFileList = (fileList)=>{
    const compliedQueue = [];
    Array.from(fileList).forEach((fileItem)=>{
        if (fileItem instanceof File) compliedQueue.push({
            uuid: (0, $5sKyw.default)(),
            name: fileItem.name,
            file: fileItem
        });
        else if (fileItem.file instanceof File) compliedQueue.push({
            uuid: fileItem.uuid || (0, $5sKyw.default)(),
            name: fileItem.file.name,
            file: fileItem.file
        });
    });
    return compliedQueue;
};
/**
 * 2025-10 (Jarosik, Michael):
 * This value is used to ensure that the array instance
 * set as the default props value for `files` is always
 * the same. This prevents the useEffect hook with `files`
 * as a dependency from triggering when the component
 * re-renders following a file upload event.
 */ const $558a1874964eed3d$var$defaultFilesPropArray = [];
const $558a1874964eed3d$var$FileUpload$1 = ({ id: id, label: label, files: files = $558a1874964eed3d$var$defaultFilesPropArray, accept: accept, name: name, classes: classes = [], tabIndex: tabIndex = 0, uploadPrecision: uploadPrecision = 0, hideLabel: hideLabel = false, ariaLabel: ariaLabel, labelModifier: labelModifier = null, status: status = 'awaiting-upload', onChange: onChange = ()=>{}, onFileRemoved: onFileRemoved = ()=>{} })=>{
    const [uploadQueue, setUploadQueue] = (0, $acw62.useState)($558a1874964eed3d$var$setQueueFromFileList(files));
    const [globalUploadStatus, setGlobalUploadStatus] = (0, $acw62.useState)('');
    const fileInputRef = (0, $acw62.useRef)();
    const fileListenerRef = (0, $acw62.useRef)();
    const removeFileFromQueue = (index)=>{
        onFileRemoved(uploadQueue[index]);
        setUploadQueue([
            ...uploadQueue.slice(0, index),
            ...uploadQueue.slice(index + 1)
        ]);
    };
    const handleClickFiles = (event)=>{
        event.preventDefault();
        fileListenerRef.current.click();
    };
    const handleDropFiles = (event)=>{
        event.preventDefault();
        const newFiles = event.dataTransfer.files;
        setUploadQueue(uploadQueue.concat($558a1874964eed3d$var$setQueueFromFileList(newFiles)));
    };
    const handleFileListenerUpdate = ()=>{
        const newFiles = fileListenerRef.current.files;
        setUploadQueue(uploadQueue.concat($558a1874964eed3d$var$setQueueFromFileList(newFiles)));
    };
    const handleDragOver = (event)=>{
        event.preventDefault();
    };
    const handleFileKeyListener = (event)=>{
        const keyPressed = event.key;
        if ([
            'Enter',
            ' '
        ].includes(keyPressed)) {
            event.preventDefault();
            fileListenerRef.current.click();
        }
    };
    const handleRemoveFileListener = (event, index)=>{
        const keyPressed = event.key;
        if (keyPressed === 'Enter') removeFileFromQueue(index);
    };
    const getStatus = (fileUUID)=>{
        let statusMetadata;
        const defaultStatus = 'awaiting-upload';
        if (typeof status === 'string') statusMetadata = {
            name: status
        };
        else if (typeof status === 'object' && !(status instanceof Array)) {
            statusMetadata = status[fileUUID];
            if (typeof statusMetadata === 'string') statusMetadata = {
                name: statusMetadata
            };
            else if (typeof status.name !== 'undefined') statusMetadata = status;
            else if (typeof statusMetadata === 'undefined') statusMetadata = {
                name: defaultStatus
            };
        } else {
            // eslint-disable-next-line no-console
            console.warn('Invalid status passed to File Upload component, make sure that you are passing either a string or a uuid-indexed object. Falling back to default...');
            statusMetadata = {
                name: defaultStatus
            };
        }
        switch(statusMetadata.name){
            case 'awaiting-upload':
                statusMetadata.progress = 0;
                break;
            case 'completed':
                statusMetadata.progress = 100;
                break;
        }
        return statusMetadata;
    };
    const renderNumberPrecision = (number, precision)=>{
        const roundingScalar = 10 ** precision;
        const wholeNum = Math.round(number);
        if (precision > 0) {
            const decimalFullPrecision = number - Math.floor(number);
            const decimalRoundedPrecision = Math.round(decimalFullPrecision * roundingScalar);
            const zeroFillPrefix = Array.from(new Array(precision)).map(()=>'0').join('');
            const outputDecimal = `${zeroFillPrefix}${decimalRoundedPrecision}`.substr(precision * -1);
            return `${wholeNum}.${outputDecimal}`;
        }
        return wholeNum;
    };
    const renderStatus = (fileUUID, fileStatus)=>{
        const progressIndeterminate = typeof fileStatus.progress === 'undefined';
        if (fileStatus.name === 'uploading') {
            if (progressIndeterminate) return [
                'Uploading',
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "file-upload--ellipsis"
                }, fileUUID)
            ];
            return `${renderNumberPrecision(fileStatus.progress, uploadPrecision)}% Uploaded`;
        }
        return $558a1874964eed3d$var$statusLabelMap$1[fileStatus.name];
    };
    (0, $acw62.useEffect)(()=>{
        const updatedQueue = $558a1874964eed3d$var$setQueueFromFileList(files);
        if (updatedQueue.length !== uploadQueue.length) setUploadQueue(updatedQueue);
        else {
            const isUniqueQueue = updatedQueue.some((updateFile, index)=>updateFile.file !== uploadQueue[index].file);
            if (isUniqueQueue) setUploadQueue(updatedQueue);
        }
    }, [
        files
    ]);
    (0, $acw62.useEffect)(()=>{
        const dataTransfer = new DataTransfer();
        uploadQueue.forEach((queuedFile)=>dataTransfer.items.add(queuedFile.file));
        fileListenerRef.current.value = '';
        // [NOTE] This check is required for the component's jest test to pass due to a bug in JSDOM
        // where the DataTransfer implementation is missing which throws a TypeError for the line below.
        /* istanbul ignore next */ if (Object.getPrototypeOf(dataTransfer.files) === FileList.prototype) fileInputRef.current.files = dataTransfer.files;
        onChange({
            fileList: dataTransfer.files,
            uploadQueue: uploadQueue
        });
    }, [
        uploadQueue
    ]);
    (0, $acw62.useEffect)(()=>{
        const statusEntries = Object.entries(status);
        const filesCompleted = statusEntries.reduce((completionCount, statusEntry)=>{
            const fileStatus = statusEntry[1];
            const isCompleted = fileStatus.name === 'completed';
            return completionCount + isCompleted;
        }, 0);
        if (filesCompleted > 0) setGlobalUploadStatus(`File ${filesCompleted} of ${uploadQueue.length} completed`);
    }, [
        status
    ]);
    const fileInputProps = {
        accept: accept,
        'type': 'file',
        'multiple': true,
        'aria-hidden': 'true'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-file-upload',
                'file-upload'
            ],
            custom: classes,
            required: []
        }),
        children: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                ...fileInputProps,
                className: "axiom-file-upload--file-watcher file-upload-listener",
                "data-testid": "file-upload--file-watcher",
                ref: fileListenerRef,
                onChange: handleFileListenerUpdate
            }), document.body),
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$InputControl$1, {
                id: id,
                label: label,
                hideLabel: hideLabel,
                labelModifier: labelModifier,
                ariaLabel: ariaLabel,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    ...fileInputProps,
                    id: id,
                    className: "axiom-file-upload--file-input",
                    name: name,
                    "data-testid": "file-upload--filelist",
                    ref: fileInputRef,
                    onClick: handleClickFiles
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                role: "button",
                "data-testid": "file-upload--dropzone",
                className: "axiom-file-upload--dropzone file-upload--dropzone",
                onDrop: handleDropFiles,
                onDragOver: handleDragOver,
                tabIndex: tabIndex,
                onClick: handleClickFiles,
                onKeyDown: handleFileKeyListener,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                        name: "data-upload"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "Drag files here or click to upload"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                "data-testid": "file-upload--file-list",
                className: "axiom-file-upload--upload-queue file-upload--file-list",
                children: uploadQueue.map((file, index)=>{
                    const fileStatus = getStatus(file.uuid);
                    const uploadProgress = fileStatus.progress || 0;
                    const progressIndeterminate = typeof fileStatus.progress === 'undefined';
                    const fileListClasses = [
                        'axiom-file-upload--queued-file',
                        `file-upload--${fileStatus.name}`
                    ];
                    if (progressIndeterminate) fileListClasses.push('file-upload--progress-indeterminate');
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        className: fileListClasses.join(' '),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "data-testid": "file-upload--file-list-name",
                                id: file.uuid,
                                children: file.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                "aria-label": `Remove ${file.name}`,
                                className: "axiom-file-upload--delete-queued-file file-upload--delete-icon",
                                onClick: ()=>removeFileFromQueue(index),
                                onKeyDown: (event)=>handleRemoveFileListener(event, index),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                                    name: "trash-sm"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "axiom-file-upload--progress-bar file-upload--progress-bar",
                                role: "progressbar",
                                "aria-valuemin": 0,
                                "aria-valuemax": 100,
                                "aria-valuenow": uploadProgress,
                                "aria-labelledby": file.uuid,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "file-upload--progress-slider",
                                    style: {
                                        width: `${uploadProgress}%`
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "axiom-file-upload--download-status file-upload--download-status",
                                children: [
                                    typeof $558a1874964eed3d$var$statusIconMap[fileStatus.name] !== 'undefined' && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                                        name: $558a1874964eed3d$var$statusIconMap[fileStatus.name]
                                    }),
                                    renderStatus(file.uuid, fileStatus)
                                ]
                            })
                        ]
                    }, file.uuid);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "axiom-file-upload--global-status screen-reader-only",
                "aria-live": "polite",
                "aria-atomic": true,
                children: globalUploadStatus
            })
        ]
    });
};
$558a1874964eed3d$var$FileUpload$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    files: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                uuid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                file: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(File)
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(File)
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(FileList)
    ]),
    accept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    uploadPrecision: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    status: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf(Object.keys($558a1874964eed3d$var$statusLabelMap$1)),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf(Object.keys($558a1874964eed3d$var$statusLabelMap$1)),
            progress: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf(Object.keys($558a1874964eed3d$var$statusLabelMap$1)),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf(Object.keys($558a1874964eed3d$var$statusLabelMap$1)),
                progress: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
            })
        ]))
    ]),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFileRemoved: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$FileUploadJSX = $558a1874964eed3d$var$FileUpload$1;
var $558a1874964eed3d$var$statusLabelMap = {
    'awaiting-upload': 'AWAITING UPLOAD',
    'uploading': 'UPLOADING',
    'completed': 'COMPLETED',
    'error': 'FAILED TO UPLOAD'
};
var $558a1874964eed3d$export$d92f83d2e295fa99 = function(_a) {
    var id = _a.id, label = _a.label, _b = _a.files, files = _b === void 0 ? [] : _b, _c = _a.accept, accept = _c === void 0 ? undefined : _c, _d = _a.name, name = _d === void 0 ? undefined : _d, _e = _a.classes, classes = _e === void 0 ? [] : _e, _f = _a.tabIndex, tabIndex = _f === void 0 ? 0 : _f, _g = _a.uploadPrecision, uploadPrecision = _g === void 0 ? 0 : _g, _h = _a.hideLabel, hideLabel = _h === void 0 ? false : _h, _j = _a.ariaLabel, ariaLabel = _j === void 0 ? undefined : _j, _k = _a.labelModifier, labelModifier = _k === void 0 ? null : _k, _l = _a.status, status = _l === void 0 ? 'awaiting-upload' : _l, _m = _a.onChange, onChange = _m === void 0 ? function() {} : _m, _o = _a.onFileRemoved, onFileRemoved = _o === void 0 ? function() {} : _o;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$FileUploadJSX, {
        id: id,
        label: label,
        name: name,
        files: files,
        accept: accept,
        classes: classes,
        tabIndex: tabIndex,
        uploadPrecision: uploadPrecision,
        hideLabel: hideLabel,
        ariaLabel: ariaLabel,
        labelModifier: labelModifier,
        status: status,
        onChange: onChange,
        onFileRemoved: onFileRemoved
    });
};
$558a1874964eed3d$export$d92f83d2e295fa99.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    files: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                uuid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                file: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(File)
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(File)
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(FileList)
    ]),
    accept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    uploadPrecision: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    status: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf(Object.keys($558a1874964eed3d$var$statusLabelMap)),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf(Object.keys($558a1874964eed3d$var$statusLabelMap)),
            progress: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf(Object.keys($558a1874964eed3d$var$statusLabelMap)),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf(Object.keys($558a1874964eed3d$var$statusLabelMap)),
                progress: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
            })
        ]))
    ]),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFileRemoved: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
const $558a1874964eed3d$var$Tag$1 = ({ text: text, color: color = 'default', size: size = 'full', classes: classes = [] })=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: $558a1874964eed3d$var$createClassList({
            default: [
                `axiom-tag`,
                `axiom-tag--color--${color}`,
                `axiom-tag--size--${size}`
            ],
            custom: classes,
            required: []
        }),
        children: text
    });
$558a1874964eed3d$var$Tag$1.propTypes = {
    text: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'orange',
        'red',
        'green',
        'default',
        'luna',
        'sunflower',
        'sienna',
        'jade',
        'vividCerulean',
        'rose',
        'brick',
        'mardiGras'
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'full',
        'small'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$TagJSX = $558a1874964eed3d$var$Tag$1;
const $558a1874964eed3d$var$FilterMenu$1 = /*#__PURE__*/ (0, $acw62.forwardRef)(function ForwardedFilterMenu({ children: children, onApplyClick: onApplyClick, onClearClick: onClearClick, selectionCount: selectionCount, isShown: isShown = false, isApplyFilterDisabled: isApplyFilterDisabled = false, classes: classes = [] }, ref) {
    const [shown, setShown] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>setShown(isShown), [
        isShown
    ]);
    (0, $acw62.useImperativeHandle)(ref, // eslint-disable-next-line
    ()=>{
        return {
            shown: shown,
            toggleFilterPanel () {
                setShown(!shown);
            },
            showFilterPanel () {
                setShown(true);
            },
            hideFilterPanel () {
                setShown(false);
            }
        };
    }, [
        shown
    ]);
    const filterPanelId = `axiom-filter-menu-${(0, $5sKyw.default)()}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "filter",
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-filter-menu'
            ],
            custom: classes,
            required: []
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "axiom-filter-menu--header filter-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                        label: shown ? 'Hide Filter' : 'Show Filter',
                        icon: "filter",
                        styleVariant: "tertiary",
                        onClick: ()=>{
                            setShown(!shown);
                        },
                        classes: "axiom-filter-menu--header--button",
                        attributes: {
                            'data-testid': 'filter-toggle',
                            'aria-expanded': shown,
                            'aria-controls': filterPanelId
                        }
                    }),
                    selectionCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "axiom-filter-menu--header--button-wrapper clear",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                                label: "Clear",
                                styleVariant: "tertiary",
                                onClick: onClearClick,
                                attributes: {
                                    'data-testid': 'clear'
                                },
                                classes: "axiom-filter-menu--header--button--clear"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$TagJSX, {
                                color: "vividCerulean",
                                size: "small",
                                text: selectionCount,
                                classes: "filter-count-tag"
                            })
                        ]
                    })
                ]
            }),
            shown && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                id: filterPanelId,
                className: "axiom-filter-menu--body filter-body",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "screen-reader-only",
                        children: "Filter Menu Options"
                    }),
                    children,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-filter-menu--button-wrapper applyFilter",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                            label: "Apply Filter",
                            disabled: isApplyFilterDisabled,
                            classes: "axiom-filter-menu--button--applyFilter",
                            styleVariant: "secondary",
                            onClick: onApplyClick,
                            attributes: {
                                'data-testid': 'apply-FilterMenu'
                            }
                        })
                    })
                ]
            })
        ]
    });
});
$558a1874964eed3d$var$FilterMenu$1.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    onApplyClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    onClearClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    selectionCount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    isShown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isApplyFilterDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$FilterMenuJSX = $558a1874964eed3d$var$FilterMenu$1;
var $558a1874964eed3d$export$9a4e1638c9039348 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_a, ref) {
    var children = _a.children, onApplyClick = _a.onApplyClick, onClearClick = _a.onClearClick, selectionCount = _a.selectionCount, _b = _a.isShown, isShown = _b === void 0 ? false : _b, _c = _a.isApplyFilterDisabled, isApplyFilterDisabled = _c === void 0 ? false : _c, _d = _a.classes, classes = _d === void 0 ? [] : _d;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$FilterMenuJSX, {
        onApplyClick: onApplyClick,
        onClearClick: onClearClick,
        isShown: isShown,
        isApplyFilterDisabled: isApplyFilterDisabled,
        selectionCount: selectionCount,
        classes: classes,
        ref: ref,
        children: children
    });
});
$558a1874964eed3d$export$9a4e1638c9039348.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    onApplyClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    onClearClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    selectionCount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    isShown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isApplyFilterDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
$558a1874964eed3d$export$9a4e1638c9039348.displayName = 'FilterMenu';
const $558a1874964eed3d$var$HeaderBar$1 = ({ title: title, attributes: attributes = {}, customActions: customActions, disableFeedbackButton: disableFeedbackButton = false, feedbackId: feedbackId, feedbackUseGateway: feedbackUseGateway = false, feedbackPreUrl: feedbackPreUrl, feedbackJorpNumber: feedbackJorpNumber, headingLevel: headingLevel = '1', preHeadingContent: preHeadingContent, classes: classes = [], feedbackClasses: feedbackClasses = [] })=>{
    const HeadingLevel = `h${headingLevel}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-header header-bar'
            ],
            custom: classes,
            required: []
        }),
        "data-testid": "axiom-headerbar",
        ...attributes,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "header-bar--group",
                children: [
                    preHeadingContent && /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        className: "axiom-header--preheader-content header-bar--preHeadingContent-wrapper",
                        "data-testid": "axiom-headerbar-preHeadingContent",
                        children: preHeadingContent
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(HeadingLevel, {
                        className: "axiom-header--title header-bar--main-title",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "header-bar--group",
                children: [
                    customActions && /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        className: "axiom-header--postheader-content header-bar--content-wrapper",
                        "data-testid": "axiom-headerbar-customActions",
                        children: customActions
                    }),
                    disableFeedbackButton !== true && /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        className: "axiom-header--feedback-button header-bar--feedback-button-wrapper",
                        "data-testid": "axiom-headerbar-feedback-button",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Feedback$2, {
                            id: feedbackId,
                            useGateway: feedbackUseGateway,
                            classes: feedbackClasses,
                            jorpNumber: feedbackJorpNumber,
                            preUrl: feedbackPreUrl
                        })
                    })
                ]
            })
        ]
    });
};
$558a1874964eed3d$var$HeaderBar$1.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    customActions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    feedbackClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            buttonClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
            ]),
            notificationClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
            ]),
            modalClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
            ])
        })
    ]),
    disableFeedbackButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    feedbackId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    feedbackUseGateway: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    feedbackPreUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    feedbackJorpNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    headingLevel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    preHeadingContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};
var $558a1874964eed3d$var$HeaderBarJSX = $558a1874964eed3d$var$HeaderBar$1;
var $558a1874964eed3d$export$c7c21e5b2657e253 = function(_a) {
    var title = _a.title, _b = _a.attributes, attributes = _b === void 0 ? {} : _b, _c = _a.customActions, customActions = _c === void 0 ? undefined : _c, _d = _a.disableFeedbackButton, disableFeedbackButton = _d === void 0 ? false : _d, _e = _a.feedbackId, feedbackId = _e === void 0 ? undefined : _e, _f = _a.feedbackJorpNumber, feedbackJorpNumber = _f === void 0 ? undefined : _f, _g = _a.feedbackPreUrl, feedbackPreUrl = _g === void 0 ? undefined : _g, _h = _a.feedbackUseGateway, feedbackUseGateway = _h === void 0 ? false : _h, _j = _a.headingLevel, headingLevel = _j === void 0 ? '1' : _j, _k = _a.preHeadingContent, preHeadingContent = _k === void 0 ? undefined : _k, _l = _a.classes, classes = _l === void 0 ? [] : _l, _m = _a.feedbackClasses, feedbackClasses = _m === void 0 ? [] : _m;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$HeaderBarJSX, {
        attributes: attributes,
        customActions: customActions,
        disableFeedbackButton: disableFeedbackButton,
        feedbackClasses: feedbackClasses,
        feedbackId: feedbackId,
        feedbackJorpNumber: feedbackJorpNumber,
        feedbackUseGateway: feedbackUseGateway,
        feedbackPreUrl: feedbackPreUrl,
        headingLevel: headingLevel,
        preHeadingContent: preHeadingContent,
        title: title,
        classes: classes
    });
};
$558a1874964eed3d$export$c7c21e5b2657e253.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    customActions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    disableFeedbackButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    feedbackId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    feedbackJorpNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    feedbackUseGateway: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    feedbackPreUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    headingLevel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    preHeadingContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    feedbackClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            buttonClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
            ]),
            notificationClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
            ]),
            modalClasses: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
            ])
        })
    ])
};
const $558a1874964eed3d$var$HelpLink$1 = ({ children: children, href: href, onClick: onClick, classes: classes = [] })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
        href: href,
        onClick: onClick,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-link--help',
                'link--help'
            ],
            custom: classes,
            required: []
        }),
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                name: "help-question-mark"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "axiom-link--help--text link--help--text",
                children: children
            })
        ]
    });
$558a1874964eed3d$var$HelpLink$1.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$HelpLinkJSX = $558a1874964eed3d$var$HelpLink$1;
var $558a1874964eed3d$export$5b5b7a56b116efb5 = function(_a) {
    var children = _a.children, href = _a.href, _b = _a.onClick, onClick = _b === void 0 ? undefined : _b, _c = _a.classes, classes = _c === void 0 ? [] : _c;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$HelpLinkJSX, {
        href: href,
        onClick: onClick,
        classes: classes,
        children: children
    });
};
$558a1874964eed3d$export$5b5b7a56b116efb5.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$export$f04a61298a47a40f = function(_a) {
    var name = _a.name, _b = _a.id, id = _b === void 0 ? undefined : _b, _c = _a.seenByAssistiveTechnology, seenByAssistiveTechnology = _c === void 0 ? false : _c, _d = _a.altText, altText = _d === void 0 ? null : _d, _e = _a.classes, classes = _e === void 0 ? [] : _e;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
        id: id,
        name: name,
        seenByAssistiveTechnology: seenByAssistiveTechnology,
        altText: altText,
        classes: classes
    });
};
$558a1874964eed3d$export$f04a61298a47a40f.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    seenByAssistiveTechnology: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    altText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$AccountsOverTimeError = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104 52C104 23.2812 80.7186 0.00012207 51.9999 0.00012207C23.2811 0.00012207 0 23.2812 0 52C0 80.7187 23.2811 104 51.9999 104C80.7186 104 104 80.7187 104 52Z",
                fill: "#E8F2F7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.0865 63.4896C18.2619 63.4896 15.9639 65.7917 15.9639 68.6215C15.9639 71.4512 18.2619 73.7531 21.0865 73.7531C23.911 73.7531 26.2087 71.4512 26.2087 68.6215C26.2087 65.7917 23.911 63.4896 21.0865 63.4896ZM21.0865 76.7228C16.6276 76.7228 13 73.0885 13 68.6215C13 64.1544 16.6276 60.5199 21.0865 60.5199C25.5453 60.5199 29.1729 64.1544 29.1729 68.6215C29.1729 73.0885 25.5453 76.7228 21.0865 76.7228Z",
                fill: "#127DA7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M42.093 36.4861C39.2321 36.4861 36.9048 38.8177 36.9048 41.6838C36.9048 44.5496 39.2321 46.8812 42.093 46.8812C44.9539 46.8812 47.2812 44.5496 47.2812 41.6838C47.2812 38.8177 44.9539 36.4861 42.093 36.4861ZM42.093 49.8508C37.5979 49.8508 33.9409 46.1871 33.9409 41.6838C33.9409 37.1801 37.5979 33.5164 42.093 33.5164C46.5881 33.5164 50.2451 37.1801 50.2451 41.6838C50.2451 46.1871 46.5881 49.8508 42.093 49.8508Z",
                fill: "#127DA7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M62.2595 57.8032C59.5484 57.8032 57.3428 60.0128 57.3428 62.7286C57.3428 65.4447 59.5484 67.6543 62.2595 67.6543C64.9703 67.6543 67.1759 65.4447 67.1759 62.7286C67.1759 60.0128 64.9703 57.8032 62.2595 57.8032ZM62.2595 70.624C57.9138 70.624 54.3786 67.0823 54.3786 62.7286C54.3786 58.3753 57.9138 54.8336 62.2595 54.8336C66.6049 54.8336 70.1401 58.3753 70.1401 62.7286C70.1401 67.0823 66.6049 70.624 62.2595 70.624Z",
                fill: "#127DA7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M83.2659 30.9697C80.6124 30.9697 78.4535 33.1325 78.4535 35.7909C78.4535 38.4496 80.6124 40.6124 83.2659 40.6124C85.9197 40.6124 88.0786 38.4496 88.0786 35.7909C88.0786 33.1325 85.9197 30.9697 83.2659 30.9697ZM83.2659 43.5821C78.9778 43.5821 75.4893 40.0869 75.4893 35.7909C75.4893 31.4949 78.9778 28 83.2659 28C87.5543 28 91.0429 31.4949 91.0429 35.7909C91.0429 40.0869 87.5543 43.5821 83.2659 43.5821Z",
                fill: "#127DA7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.5849 64.4856L24.196 62.7272L36.5545 45.8741L38.9434 47.6323L26.5849 64.4856Z",
                fill: "#127DA7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M67.6365 58.7588L65.2476 57.0003L77.9504 39.6774L80.3393 41.4355L67.6365 58.7588Z",
                fill: "#127DA7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M56.4973 59.316L45.8186 47.2715L48.0348 45.2993L58.7135 57.3435L56.4973 59.316Z",
                fill: "#127DA7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104 88.0001C104 79.1636 96.8366 72.0001 88.0001 72.0001C79.1634 72.0001 72 79.1636 72 88.0001C72 96.837 79.1634 104 88.0001 104C96.8366 104 104 96.837 104 88.0001Z",
                fill: "#1B7EA8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M86.3107 96.9034H90.5323V92.4404H86.3107V96.9034ZM89.699 90.339L87.2185 90.3313L86 79.0001H90.8689L89.699 90.339Z",
                fill: "white"
            })
        ]
    });
var $558a1874964eed3d$var$AccountsOverTimeError$1 = $558a1874964eed3d$var$AccountsOverTimeError;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$DisabilityInsurance = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.24799 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.47438 86.639 1.24799 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.9829 20.7614L20.696 28.0037V47.6063C20.696 75.4168 51.9829 88.5497 51.9829 88.5497V20.7614Z",
                fill: "#90C6B4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.9829 20.7614L83.2698 28.0037V47.6063C83.2698 75.4168 51.9829 88.5497 51.9829 88.5497V20.7614Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M46.865 37.752H51.8864V65.1763H46.865V56.582H38.1742V46.4428H46.865V37.752Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.8691 37.752H56.8904V46.4475H65.5985V56.5868H56.8904V65.1763H51.8691V37.752Z",
                fill: "#E8E7E8"
            })
        ]
    });
var $558a1874964eed3d$var$DisabilityInsurance$1 = $558a1874964eed3d$var$DisabilityInsurance;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$EducationGoal = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.24799 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.47438 86.639 1.24799 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("mask", {
                id: "mask0_1_70",
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: 0,
                y: 0,
                width: 104,
                height: 104,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: 52,
                    cy: 52,
                    r: 52,
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                mask: "url(#mask0_1_70)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M95.454 35.2598V35.6572L52.0346 47.1828L10.3043 35.9553L9.50946 35.6572V35.2598L51.8359 19.76L95.454 35.2598Z",
                        fill: "#3C3E40"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M51.9352 49.5673L72.9991 43.904C73.0597 44.0152 73.1739 44.1973 73.33 44.4464C74.7081 46.646 79.358 54.0675 79.358 63.9743C79.9542 64.6698 66.6402 72.2209 52.1339 72.2209C37.6277 72.2209 24.8105 64.4711 24.6118 63.5769C24.6118 56.4175 29.3552 46.9348 30.8156 44.0153C30.8347 43.977 30.8534 43.9399 30.8714 43.904L51.9352 49.5673Z",
                        fill: "#3C3E40"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.50946 35.2598L51.8359 19.76C51.8359 19.76 51.9353 33.7694 51.9353 47.0834L9.50946 35.6572V35.2598ZM51.9352 72.7177C37.9258 72.7177 24.9099 64.2723 24.6118 63.9742C24.3137 56.8205 29.6572 45.8844 30.8495 43.8973L52.0346 49.6668C52.0346 61.0929 51.9352 74.705 51.9352 72.7177Z",
                        fill: "#898989"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M90.2874 33.372L87.8033 32.5772V47.8843C86.5395 48.3719 85.6176 49.6723 85.6176 51.1571C85.6176 52.3403 86.203 53.4064 87.0803 54.0374C85.0205 68.9298 84.922 89.9203 84.922 92.9868C87.8033 90.6022 90.5853 87.9195 92.97 85.1375C92.7716 76.9071 92.2764 63.9261 90.8916 53.899C91.6686 53.257 92.1752 52.2577 92.1752 51.1571C92.1752 49.7122 91.3022 48.4421 90.0907 47.9255L90.2874 33.372Z",
                        fill: "#F4826E"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M30.3883 71.7311C31.1831 69.2472 32.3755 67.26 33.6671 66.4652L-0.313263 56.43C0.282885 61.1992 1.07775 65.4716 2.86619 69.744L29.9909 77.8913C29.4941 76.5003 29.5935 74.1157 30.3883 71.7311Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M54.2205 85.5349L39.3168 80.7658C38.7207 79.2754 38.9194 77.0895 39.7143 74.7049C40.509 72.2209 41.8007 70.3331 42.9931 69.4389L57.4192 73.9896C57.4462 73.9952 57.4728 74.0018 57.4993 74.0094C57.546 74.0227 57.5915 74.039 57.6358 74.0578L57.7974 74.1087C57.7898 74.1152 57.7821 74.1217 57.7745 74.1282C58.9256 74.8105 59.119 77.5102 58.1948 80.4677C57.2676 83.4348 55.5616 85.5366 54.2073 85.4811C54.2117 85.4991 54.216 85.517 54.2205 85.5349Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M56.605 75.1023C57.5985 75.4004 57.7973 77.5863 57.0024 79.9709C56.3069 82.3555 54.8165 84.0446 53.9223 83.7465C52.9287 83.4484 52.7301 81.2626 53.5248 78.878C54.3197 76.4933 55.7107 74.8043 56.605 75.1023Z",
                        fill: "#BCBEC0"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M30.3883 71.7311C31.1831 69.2471 32.3755 67.26 33.6671 66.4651L33.4795 66.4097L33.5539 66.3589L42.993 69.4389C41.8007 70.3332 40.509 72.221 39.7143 74.7049C38.9438 77.016 38.7334 79.1405 39.2639 80.626L39.2174 80.7658L32.9578 92.3906L31.6662 86.0317L27.5925 89.5093L26.3009 86.2304L22.1279 85.2368L29.9717 77.8856L29.9909 77.8913C29.9888 77.8854 29.9866 77.8795 29.9845 77.8734L29.9894 77.8688L29.9353 77.7231C29.5029 76.3133 29.6246 74.0222 30.3883 71.7311Z",
                        fill: "#F4826E"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M39.3168 80.6663L29.9772 77.8843L32.8585 92.2913L36.4353 89.0124L41.602 91.1983L39.3168 80.6663Z",
                        fill: "#EF674A"
                    })
                ]
            })
        ]
    });
var $558a1874964eed3d$var$EducationGoal$1 = $558a1874964eed3d$var$EducationGoal;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$EmergencyFund = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.248 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.4744 86.639 1.248 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M50.4984 0.021838C51.0032 0.00731254 51.5097 0 52.018 0C52.5803 0.00191252 53.1405 0.0127005 53.6985 0.0322313C53.7048 0.0899599 53.708 0.148605 53.708 0.208V6.36128C53.708 7.25053 52.9872 7.97139 52.0979 7.97139C51.2087 7.97139 50.4877 7.25053 50.4877 6.36128V0.208C50.4877 0.145036 50.4914 0.0829171 50.4984 0.021838Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M62.7915 1.14851C61.7295 0.922317 60.6558 0.728327 59.5712 0.567612V11.5379C59.5712 12.4271 60.2921 13.148 61.1813 13.148C62.0705 13.148 62.7915 12.4271 62.7915 11.5379V1.14851Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M68.7523 2.79413C69.8422 3.16614 70.9161 3.57308 71.9725 4.01363V4.31019C71.9725 5.19943 71.2516 5.92031 70.3623 5.92031C69.4731 5.92031 68.7523 5.19943 68.7523 4.31019V2.79413Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M79.614 7.96988C79.1106 7.65415 78.6014 7.34674 78.0867 7.04785C78.3444 7.59371 78.8998 7.97139 79.5435 7.97139C79.5672 7.97139 79.5907 7.97089 79.614 7.96988Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14.2083 16.3016C14.2755 16.2305 14.3428 16.1597 14.4104 16.0891C14.6937 15.8409 15.0649 15.6904 15.4711 15.6904C16.3604 15.6904 17.0813 16.4112 17.0813 17.3005V24.4304C17.0813 25.3197 16.3604 26.0406 15.4711 26.0406C14.5819 26.0406 13.8611 25.3197 13.8611 24.4304V17.3005C13.8611 16.9231 13.9909 16.576 14.2083 16.3016Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7.04288 25.8541C7.32135 25.3779 7.60717 24.9063 7.90019 24.4398C7.8967 25.0532 7.55025 25.5852 7.04288 25.8541Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M5.35625 28.979C5.12396 29.4469 4.89849 29.9188 4.67999 30.3946V35.3697C4.67999 36.2589 5.40086 36.9797 6.2901 36.9797C7.17934 36.9797 7.90021 36.2589 7.90021 35.3697V30.2907C7.90021 29.4015 7.17934 28.6806 6.2901 28.6806C5.94196 28.6806 5.61962 28.7912 5.35625 28.979Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7.90021 79.6777C6.70324 77.7719 5.62628 75.7834 4.67999 73.7229V73.5583C5.62584 75.6215 6.70282 77.6126 7.90021 79.5207V79.6777Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M96.1979 79.2964V79.5785C97.3963 77.6611 98.4732 75.6603 99.4182 73.587V73.2502C98.4755 75.3425 97.3984 77.3616 96.1979 79.2964Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M99.4014 62.2671C99.4125 62.191 99.4182 62.1131 99.4182 62.0339V53.0481C99.4182 52.1589 98.6973 51.438 97.8081 51.438C96.9189 51.438 96.1979 52.1589 96.1979 53.0481V61.305C97.2934 61.6145 98.3617 61.9354 99.4014 62.2671Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M90.3347 59.8151V53.1458C90.3347 52.2566 89.6139 51.5356 88.7246 51.5356C87.8354 51.5356 87.1144 52.2566 87.1144 53.1458V59.1246C88.2068 59.3449 89.2804 59.5752 90.3347 59.8151Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M17.0813 59.0804V53.1458C17.0813 52.2566 16.3604 51.5356 15.4711 51.5356C14.5819 51.5356 13.8611 52.2566 13.8611 53.1458V59.7653C14.9155 59.5272 15.9892 59.2988 17.0813 59.0804Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7.90021 61.2705V53.0481C7.90021 52.1589 7.17934 51.438 6.2901 51.438C5.40086 51.438 4.67999 52.1589 4.67999 53.0481V62.1316C4.67999 62.1655 4.68104 62.1991 4.6831 62.2325C5.72736 61.9008 6.80021 61.58 7.90021 61.2705Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M98.6367 28.9099C98.9064 29.45 99.1669 29.9954 99.4182 30.5458V35.3697C99.4182 36.2589 98.6973 36.9797 97.8081 36.9797C96.9189 36.9797 96.1979 36.2589 96.1979 35.3697V30.2907C96.1979 29.4015 96.9189 28.6806 97.8081 28.6806C98.1111 28.6806 98.3946 28.7643 98.6367 28.9099Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M96.204 24.5724C96.4552 24.9738 96.7011 25.379 96.9414 25.7877C96.5318 25.5255 96.2487 25.0831 96.204 24.5724Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M89.313 15.8012C89.6303 16.1269 89.9434 16.4564 90.2521 16.7902C90.3057 16.9505 90.3347 17.1221 90.3347 17.3005V24.4304C90.3347 25.3197 89.6139 26.0406 88.7246 26.0406C87.8354 26.0406 87.1144 25.3197 87.1144 24.4304V17.3005C87.1144 16.4112 87.8354 15.6904 88.7246 15.6904C88.9323 15.6904 89.1308 15.7297 89.313 15.8012Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M44.527 0.53688C43.4425 0.693693 42.3687 0.884034 41.3067 1.10682V11.5379C41.3067 12.4271 42.0275 13.148 42.9168 13.148C43.806 13.148 44.527 12.4271 44.527 11.5379V0.53688Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M35.3459 2.73518V6.36128C35.3459 7.25052 34.6249 7.97139 33.7357 7.97139C32.8465 7.97139 32.1256 7.25052 32.1256 6.36128V3.94684C33.182 3.50868 34.2558 3.10435 35.3459 2.73518Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M99.4182 41.1322C99.4182 40.243 98.6973 39.5221 97.8081 39.5221C96.9189 39.5221 96.1979 40.243 96.1979 41.1322V47.2855C96.1979 48.1748 96.9189 48.8956 97.8081 48.8956C98.6973 48.8956 99.4182 48.1748 99.4182 47.2855V41.1322Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M79.5435 39.5221C80.4328 39.5221 81.1536 40.243 81.1536 41.1322V47.2855C81.1536 48.1748 80.4328 48.8956 79.5435 48.8956C78.6543 48.8956 77.9334 48.1748 77.9334 47.2855V41.1322C77.9334 40.243 78.6543 39.5221 79.5435 39.5221Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M81.1536 30.2907C81.1536 29.4015 80.4328 28.6806 79.5435 28.6806C78.6543 28.6806 77.9334 29.4015 77.9334 30.2907V35.3697C77.9334 36.2589 78.6543 36.9797 79.5435 36.9797C80.4328 36.9797 81.1536 36.2589 81.1536 35.3697V30.2907Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M79.5435 10.6114C80.4328 10.6114 81.1536 11.3324 81.1536 12.2216V24.4304C81.1536 25.3197 80.4328 26.0406 79.5435 26.0406C78.6543 26.0406 77.9334 25.3197 77.9334 24.4304V12.2216C77.9334 11.3324 78.6543 10.6114 79.5435 10.6114Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M90.3347 44.2577C90.3347 43.3685 89.6139 42.6476 88.7246 42.6476C87.8354 42.6476 87.1144 43.3685 87.1144 44.2577V47.2855C87.1144 48.1748 87.8354 48.8956 88.7246 48.8956C89.6139 48.8956 90.3347 48.1748 90.3347 47.2855V44.2577Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M90.3347 30.2907C90.3347 29.4015 89.6139 28.6806 88.7246 28.6806C87.8354 28.6806 87.1144 29.4015 87.1144 30.2907V38.3974C87.1144 39.2867 87.8354 40.0076 88.7246 40.0076C89.6139 40.0076 90.3347 39.2867 90.3347 38.3974V30.2907Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M70.3623 41.5732C71.2516 41.5732 71.9725 42.2941 71.9725 43.1833V47.2855C71.9725 48.1748 71.2516 48.8956 70.3623 48.8956C69.4731 48.8956 68.7523 48.1748 68.7523 47.2855V43.1833C68.7523 42.2941 69.4731 41.5732 70.3623 41.5732Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M71.9725 22.0864C71.9725 21.1971 71.2516 20.4762 70.3623 20.4762C69.4731 20.4762 68.7523 21.1971 68.7523 22.0864V37.4208C68.7523 38.31 69.4731 39.0309 70.3623 39.0309C71.2516 39.0309 71.9725 38.31 71.9725 37.4208V22.0864Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M70.3623 8.56035C71.2516 8.56035 71.9725 9.28121 71.9725 10.1705V16.3237C71.9725 17.213 71.2516 17.9339 70.3623 17.9339C69.4731 17.9339 68.7523 17.213 68.7523 16.3237V10.1705C68.7523 9.28121 69.4731 8.56035 70.3623 8.56035Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52.0979 39.5221C52.9872 39.5221 53.708 40.243 53.708 41.1322V47.2855C53.708 48.1748 52.9872 48.8956 52.0979 48.8956C51.2087 48.8956 50.4877 48.1748 50.4877 47.2855V41.1322C50.4877 40.243 51.2087 39.5221 52.0979 39.5221Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M53.708 30.2907C53.708 29.4015 52.9872 28.6806 52.0979 28.6806C51.2087 28.6806 50.4877 29.4015 50.4877 30.2907V35.3697C50.4877 36.2589 51.2087 36.9797 52.0979 36.9797C52.9872 36.9797 53.708 36.2589 53.708 35.3697V30.2907Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52.0979 10.6114C52.9872 10.6114 53.708 11.3324 53.708 12.2216V24.4304C53.708 25.3197 52.9872 26.0406 52.0979 26.0406C51.2087 26.0406 50.4877 25.3197 50.4877 24.4304V12.2216C50.4877 11.3324 51.2087 10.6114 52.0979 10.6114Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M62.7915 44.2577C62.7915 43.3685 62.0705 42.6476 61.1813 42.6476C60.2921 42.6476 59.5712 43.3685 59.5712 44.2577V47.2855C59.5712 48.1748 60.2921 48.8956 61.1813 48.8956C62.0705 48.8956 62.7915 48.1748 62.7915 47.2855V44.2577Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M61.1813 28.6806C62.0705 28.6806 62.7915 29.4015 62.7915 30.2907V38.3974C62.7915 39.2867 62.0705 40.0076 61.1813 40.0076C60.2921 40.0076 59.5712 39.2867 59.5712 38.3974V30.2907C59.5712 29.4015 60.2921 28.6806 61.1813 28.6806Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M62.7915 17.3005C62.7915 16.4112 62.0705 15.6904 61.1813 15.6904C60.2921 15.6904 59.5712 16.4112 59.5712 17.3005V24.4304C59.5712 25.3197 60.2921 26.0406 61.1813 26.0406C62.0705 26.0406 62.7915 25.3197 62.7915 24.4304V17.3005Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M35.3459 41.1322C35.3459 40.243 34.6249 39.5221 33.7357 39.5221C32.8465 39.5221 32.1256 40.243 32.1256 41.1322V47.2855C32.1256 48.1748 32.8465 48.8956 33.7357 48.8956C34.6249 48.8956 35.3459 48.1748 35.3459 47.2855V41.1322Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M33.7357 28.6806C34.6249 28.6806 35.3459 29.4015 35.3459 30.2907V35.3697C35.3459 36.2589 34.6249 36.9797 33.7357 36.9797C32.8465 36.9797 32.1256 36.2589 32.1256 35.3697V30.2907C32.1256 29.4015 32.8465 28.6806 33.7357 28.6806Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M35.3459 12.2216C35.3459 11.3324 34.6249 10.6114 33.7357 10.6114C32.8465 10.6114 32.1256 11.3324 32.1256 12.2216V24.4304C32.1256 25.3197 32.8465 26.0406 33.7357 26.0406C34.6249 26.0406 35.3459 25.3197 35.3459 24.4304V12.2216Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M42.9168 42.6476C43.806 42.6476 44.527 43.3685 44.527 44.2577V47.2855C44.527 48.1748 43.806 48.8956 42.9168 48.8956C42.0275 48.8956 41.3067 48.1748 41.3067 47.2855V44.2577C41.3067 43.3685 42.0275 42.6476 42.9168 42.6476Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M44.527 30.2907C44.527 29.4015 43.806 28.6806 42.9168 28.6806C42.0275 28.6806 41.3067 29.4015 41.3067 30.2907V38.3974C41.3067 39.2867 42.0275 40.0076 42.9168 40.0076C43.806 40.0076 44.527 39.2867 44.527 38.3974V30.2907Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M42.9168 15.6904C43.806 15.6904 44.527 16.4112 44.527 17.3005V24.4304C44.527 25.3197 43.806 26.0406 42.9168 26.0406C42.0275 26.0406 41.3067 25.3197 41.3067 24.4304V17.3005C41.3067 16.4112 42.0275 15.6904 42.9168 15.6904Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M26.1647 43.1833C26.1647 42.2941 25.4439 41.5732 24.5546 41.5732C23.6654 41.5732 22.9445 42.2941 22.9445 43.1833V47.2855C22.9445 48.1748 23.6654 48.8956 24.5546 48.8956C25.4439 48.8956 26.1647 48.1748 26.1647 47.2855V43.1833Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M24.5546 20.4762C25.4439 20.4762 26.1647 21.1971 26.1647 22.0864V37.4208C26.1647 38.31 25.4439 39.0309 24.5546 39.0309C23.6654 39.0309 22.9445 38.31 22.9445 37.4208V22.0864C22.9445 21.1971 23.6654 20.4762 24.5546 20.4762Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M26.1647 10.1705C26.1647 9.28121 25.4439 8.56035 24.5546 8.56035C23.6654 8.56035 22.9445 9.28121 22.9445 10.1705V16.3237C22.9445 17.213 23.6654 17.9339 24.5546 17.9339C25.4439 17.9339 26.1647 17.213 26.1647 16.3237V10.1705Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M6.2901 39.5221C7.17934 39.5221 7.90021 40.243 7.90021 41.1322V47.2855C7.90021 48.1748 7.17934 48.8956 6.2901 48.8956C5.40086 48.8956 4.67999 48.1748 4.67999 47.2855V41.1322C4.67999 40.243 5.40086 39.5221 6.2901 39.5221Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.4711 42.6476C16.3604 42.6476 17.0813 43.3685 17.0813 44.2577V47.2855C17.0813 48.1748 16.3604 48.8956 15.4711 48.8956C14.5819 48.8956 13.8611 48.1748 13.8611 47.2855V44.2577C13.8611 43.3685 14.5819 42.6476 15.4711 42.6476Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.4711 28.6806C16.3604 28.6806 17.0813 29.4015 17.0813 30.2907V38.3974C17.0813 39.2867 16.3604 40.0076 15.4711 40.0076C14.5819 40.0076 13.8611 39.2867 13.8611 38.3974V30.2907C13.8611 29.4015 14.5819 28.6806 15.4711 28.6806Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M49.7738 87.233V48.7506H52.8592V87.233C52.8592 87.8737 53.1144 88.2912 53.5047 88.5895C53.9377 88.9204 54.5915 89.1332 55.321 89.1332C56.0507 89.1332 56.7044 88.9204 57.1374 88.5895C57.5277 88.2912 57.7829 87.8737 57.7829 87.233V83.1308H60.8683V87.233C60.8683 88.8876 60.1223 90.1916 59.0109 91.041C57.9422 91.8577 56.5937 92.2187 55.321 92.2187C54.0485 92.2187 52.6999 91.8577 51.6312 91.041C50.5198 90.1916 49.7738 88.8876 49.7738 87.233Z",
                fill: "#4B4B4D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.3165 17.5935C32.2707 17.5935 16.741 33.0255 16.741 52.1691C21.8198 51.3878 27.7778 50.8994 34.4194 50.8994C40.7681 50.8994 46.433 51.4854 51.3165 52.1691V17.5935Z",
                fill: "#979BCD"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.3352 17.576C70.3812 17.576 85.9109 33.008 85.9109 52.1516C80.8319 51.3703 74.874 50.8819 68.2323 50.8819C61.8837 50.8819 56.2188 51.4679 51.3352 52.1516V17.576Z",
                fill: "#3C3E40"
            })
        ]
    });
var $558a1874964eed3d$var$EmergencyFund$1 = $558a1874964eed3d$var$EmergencyFund;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$GeneralFinancialGoal = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.248 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.4744 86.639 1.248 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M31.7196 75.3203L26.312 86.2321H36.5479L40.3138 77.831L31.7196 75.3203Z",
                fill: "#898989"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M72.3734 75.3203L77.781 86.2321H67.5451L63.7791 77.831L72.3734 75.3203Z",
                fill: "#898989"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 52,
                cy: 48.464,
                r: 34.216,
                fill: "#EF674A"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 52,
                cy: 48.464,
                r: 26.6125,
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 52,
                cy: 48.464,
                r: 19.0089,
                fill: "#EF674A"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 52,
                cy: 48.464,
                r: 11.4054,
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 52,
                cy: 48.464,
                r: 3.80178,
                fill: "#EF674A"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("mask", {
                id: "mask0_1_4",
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: 52,
                y: 14,
                width: 35,
                height: 69,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M52 82.68C70.897 82.68 86.216 67.361 86.216 48.464C86.216 29.567 70.897 14.248 52 14.248V82.68Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                mask: "url(#mask0_1_4)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: 52,
                        cy: 48.464,
                        r: 34.216,
                        fill: "#3C3E40"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: 52,
                        cy: 48.464,
                        r: 26.6125,
                        fill: "#E8E7E8"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: 52,
                        cy: 48.464,
                        r: 19.0089,
                        fill: "#3C3E40"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: 52,
                        cy: 48.464,
                        r: 11.4054,
                        fill: "#E8E7E8"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: 52,
                        cy: 48.464,
                        r: 3.80178,
                        fill: "#3C3E40"
                    })
                ]
            })
        ]
    });
var $558a1874964eed3d$var$GeneralFinancialGoal$1 = $558a1874964eed3d$var$GeneralFinancialGoal;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$GiDebtfree = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.8412 56.0047C71.8718 56.0047 89.9281 58.946 102.717 63.6562C107.417 42.9335 98.9803 21.4427 81.4381 9.45144C63.896 -2.53987 40.8087 -2.59774 23.2066 9.30548C5.60458 21.2087 -2.93943 42.6569 1.65668 63.4029C14.4008 58.8403 32.171 56.0047 51.8412 56.0047Z",
                fill: "#FBE37E"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.8386 56.0003C32.1679 56.0003 14.3978 58.836 1.65366 63.399C6.88732 87.0682 27.8416 103.938 52.0824 103.999C76.3232 104.06 97.3616 87.2946 102.714 63.6519C89.9251 58.9417 71.8688 56.0003 51.8386 56.0003Z",
                fill: "#F7CA3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M54.1482 66.157C54.1396 65.0533 53.2381 64.1655 52.1344 64.1737C51.0307 64.182 50.1426 65.0832 50.1506 66.1869C50.1585 67.2906 51.0595 68.179 52.1631 68.1714C52.6935 68.1675 53.2006 67.9531 53.5729 67.5753C53.9452 67.1975 54.1521 66.6873 54.1482 66.157Z",
                fill: "#8BBCD8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M33.0384 52.6382L33.0422 41.458C30.2688 38.6397 28.4283 36.778 28.2759 36.6572C28.1525 36.5592 24.7684 44.3713 28.2759 47.8939C28.8999 48.5205 30.661 50.2739 33.0384 52.6382Z",
                fill: "#0076A0"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M52.1869 68.1826L52.2158 71.6918L46.2006 77.7238C48.4133 82.4603 46.9159 88.1016 42.6456 91.1173C38.3753 94.133 32.5581 93.6574 28.8344 89.988C25.1107 86.3186 24.5497 80.509 27.5024 76.1949C30.4551 71.8807 36.0738 70.3007 40.8422 72.4435L46.8112 66.3222L42.5149 62.0548C45.7664 62.4456 49.0642 62.0447 52.1273 60.8862L52.1545 64.1922C52.1483 64.1922 52.1423 64.1913 52.1363 64.1905C52.1301 64.1896 52.1239 64.1887 52.1174 64.1887C51.0233 64.2108 50.1502 65.1084 50.1584 66.2027C50.1667 67.297 51.0533 68.1814 52.1476 68.1869C52.1543 68.1869 52.1608 68.1858 52.1672 68.1847C52.1737 68.1836 52.1802 68.1826 52.1869 68.1826ZM31.3952 84.4034C32.2582 86.443 34.2649 87.7618 36.4794 87.7449V87.7467C37.9318 87.7358 39.3204 87.1483 40.3394 86.1134C41.3585 85.0784 41.9245 83.681 41.9129 82.2286C41.8962 80.0141 40.5472 78.0276 38.4948 77.1956C36.4425 76.3635 34.091 76.8498 32.5369 78.4275C30.9828 80.0053 30.5322 82.3639 31.3952 84.4034Z",
                fill: "#0076A0"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M63.7995 72.3922C65.0964 71.8453 66.4881 71.5587 67.8956 71.5486C72.7012 71.5087 76.9517 74.6574 78.3137 79.2661C79.6756 83.8748 77.8195 88.8282 73.7642 91.4069C69.7089 93.9856 64.4358 93.5655 60.8399 90.3774C57.244 87.1892 56.1954 82.0044 58.2698 77.6695L52.2326 71.6845L52.2041 68.1688C53.2964 68.1465 54.1677 67.2499 54.1587 66.1574C54.1498 65.0649 53.2639 64.1827 52.1713 64.1784L52.1446 60.8724L75.8333 36.5731C75.8333 36.5731 79.5471 42.0436 75.9109 47.9328C73.5306 51.7877 64.0843 60.8059 57.8443 66.5751C60.5293 69.2493 62.6637 71.3419 63.7995 72.3922ZM62.9345 84.4584C63.7973 86.498 65.8037 87.8171 68.0182 87.8006V87.7998C71.0414 87.7767 73.474 85.308 73.4525 82.2847C73.436 80.0702 72.0872 78.0837 70.0349 77.2515C67.9827 76.4192 65.6312 76.9052 64.077 78.4828C62.5227 80.0603 62.0718 82.4188 62.9345 84.4584Z",
                fill: "#3B3D3F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M71.0976 53.6796C67.1668 57.8352 61.849 62.8713 57.8439 66.5743L57.868 66.5984H71.0929L71.0976 53.6796Z",
                fill: "#EFEFEF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M64.5189 40.5246H52.1618L52.1381 60.875L71.1019 41.4239L71.111 15.2828H52.1726L52.1696 23.482H64.5189C64.903 23.4983 65.206 23.8145 65.206 24.199C65.206 24.5835 64.903 24.8997 64.5189 24.916H52.1675L52.1649 31.276H64.5189C64.905 31.2894 65.2112 31.6063 65.2112 31.9927C65.2112 32.3792 64.905 32.6961 64.5189 32.7095H52.1644V39.0924H64.5189C64.903 39.1087 65.206 39.4249 65.206 39.8094C65.206 40.1939 64.903 40.51 64.5189 40.5264V40.5246Z",
                fill: "#EFEFEF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M39.6788 40.5246C39.2947 40.5083 38.9916 40.1921 38.9916 39.8076C38.9916 39.4231 39.2947 39.107 39.6788 39.0906H52.1623V32.7078H39.6788C39.2926 32.6944 38.9865 32.3774 38.9865 31.991C38.9865 31.6046 39.2926 31.2876 39.6788 31.2742H52.1649L52.1674 24.9143H39.6788C39.2947 24.8979 38.9916 24.5818 38.9916 24.1973C38.9916 23.8128 39.2947 23.4966 39.6788 23.4803H52.1679L52.1709 15.2811H33.069L33.053 56.8L38.3484 48.1404C38.3484 48.1404 38.4287 51.297 42.6819 55.3103C47.3597 59.7232 51.9754 60.8365 52.1381 60.8737L52.1618 40.5233L39.6788 40.5246Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M33.0379 56.8259C33.0379 56.8259 33.6649 59.6585 39.873 61.4912C46.3029 63.39 52.1441 60.8707 52.1441 60.8707C52.1441 60.8707 47.4439 59.8035 42.6823 55.3116C38.4287 51.2983 38.3484 48.1417 38.3484 48.1417L33.0379 56.8259Z",
                fill: "#BFBDBD"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M64.5189 40.5246H39.6788C39.2947 40.5083 38.9917 40.1921 38.9917 39.8076C38.9917 39.4231 39.2947 39.1069 39.6788 39.0906H64.5189C64.903 39.1069 65.206 39.4231 65.206 39.8076C65.206 40.1921 64.903 40.5083 64.5189 40.5246Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M64.5189 32.7078H39.6788C39.2926 32.6944 38.9865 32.3774 38.9865 31.991C38.9865 31.6046 39.2926 31.2876 39.6788 31.2742H64.5189C64.905 31.2876 65.2112 31.6046 65.2112 31.991C65.2112 32.3774 64.905 32.6944 64.5189 32.7078Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M64.5189 24.9142H39.6788C39.2947 24.8979 38.9917 24.5817 38.9917 24.1973C38.9917 23.8128 39.2947 23.4966 39.6788 23.4803H64.5189C64.903 23.4966 65.206 23.8128 65.206 24.1973C65.206 24.5817 64.903 24.8979 64.5189 24.9142Z",
                fill: "#888888"
            })
        ]
    });
var $558a1874964eed3d$var$GiDebtfree$1 = $558a1874964eed3d$var$GiDebtfree;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$GiHealthy = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.3475 56.0033C71.1873 56.0033 89.0716 58.9443 101.738 63.6545C106.394 42.9318 98.0376 21.441 80.6625 9.4497C63.2874 -2.54161 40.42 -2.59948 22.9856 9.30374C5.55119 21.207 -2.91144 42.6552 1.64089 63.4011C14.2636 58.8385 31.8646 56.0033 51.3475 56.0033Z",
                fill: "#FBE37E"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.3475 56.0034C31.8646 56.0034 14.2636 58.8385 1.6409 63.4012C6.82538 87.0696 27.5797 103.939 51.5892 104C75.5986 104.061 96.4364 87.2964 101.738 63.6545C89.0716 58.9443 71.1873 56.0034 51.3475 56.0034Z",
                fill: "#F7CA3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.7467 88.3163C51.7467 88.3163 6.21477 52.2343 23.2378 30.7512C35.9084 14.7611 51.7471 33.9489 51.7471 33.9489L51.7467 88.3163Z",
                fill: "#F4826E"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.7467 88.3163C51.7467 88.3163 97.2786 52.2339 80.256 30.7495C67.5854 14.7602 51.7467 33.9471 51.7467 33.9471L51.7467 88.3163Z",
                fill: "#3C3E3F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M81.0211 53.9756H60.4657L54.307 64.9366L41.1824 43.1475L36.9394 53.9756H22.4723C22.8091 54.7086 23.1675 55.4402 23.5473 56.1704H38.4166L41.5962 48.0575L54.3728 69.27L61.7313 56.1721H79.9461C80.3271 55.4414 80.6854 54.7092 81.0211 53.9756Z",
                fill: "white"
            })
        ]
    });
var $558a1874964eed3d$var$GiHealthy$1 = $558a1874964eed3d$var$GiHealthy;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$HomeImprovement = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.24799 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.4441C97.4873 86.636 76.7311 104 51.9791 104C27.2292 104 6.47438 86.639 1.24799 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M32.24 84.656C32.24 84.656 26.936 83.889 26.936 78.4241C26.936 74.0139 32.24 66.248 32.24 66.248",
                fill: "#979BCD"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M32.24 84.656C32.24 84.656 37.544 83.889 37.544 78.4241C37.544 74.0139 32.24 66.248 32.24 66.248",
                fill: "#6B458D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M41.6 63.544C41.6 63.544 37.856 62.9704 37.856 59.147C37.856 56.0881 41.6 50.544 41.6 50.544",
                fill: "#979BCD"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M41.6 63.544C41.6 63.544 45.344 62.9704 45.344 59.147C45.344 56.0881 41.6 50.544 41.6 50.544",
                fill: "#6B458D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("mask", {
                id: "mask0_1_237",
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: 0,
                y: 0,
                width: 104,
                height: 104,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: 52,
                    cy: 52,
                    r: 52,
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                mask: "url(#mask0_1_237)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M96.4685 67.6L81.8315 49.6889L66.1352 47.1852L61.7055 51.4222L73.261 63.074L72.7796 70.3926L70.8536 73.2815C75.2833 75.5926 74.9944 79.2519 77.0167 80.3111C82.3129 83.0074 86.7426 79.5408 86.7426 79.5408L92.2315 84.9334C95.6981 80.7926 98.587 76.1703 100.609 71.1629L96.4685 67.6Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M58.1425 54.5037L58.6241 72.9926C58.6241 72.9926 61.2241 73.9555 63.7278 67.6L66.4241 57.2963L58.1425 54.5037Z",
                fill: "#898989"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M62.3796 55.7555L62.9574 76.2666C62.9574 76.2666 65.5574 77.2297 68.0611 70.874L70.7574 60.5703L62.3796 55.7555Z",
                fill: "#898989"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M66.713 58.0666L67.2908 78.5778C67.2908 78.5778 69.8908 79.5408 72.3945 73.1852L75.0908 62.8815L66.713 58.0666Z",
                fill: "#898989"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M70.3722 18.9703C71.6241 16.7555 71.5278 14.926 69.987 13.5778L63.4389 8.08889L62.5722 7.31852L61.2241 6.16297C59.587 4.81482 57.1796 5.00741 55.8315 6.54815L53.4241 9.34074L55.9278 11.4592L58.3352 8.66666C58.5278 8.47408 58.9129 8.37778 59.1055 8.66666L62.4759 11.4592L67.8685 16.0815C68.061 16.274 68.1573 16.6592 67.9647 16.8518L53.3278 43.9111C52.461 45.5482 52.1722 47.9555 53.7129 49.3037L57.4685 52.5778L59.587 50.074L55.8315 46.8C55.6389 46.6074 55.5426 46.2222 55.7352 46.0297L70.3722 18.9703Z",
                fill: "#4B4B4D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M88.0908 71.2592C89.2463 72.2222 89.3427 73.9555 88.3796 75.0148L86.55 77.1334C85.587 78.2889 83.8537 78.3852 82.7945 77.4222L57.6611 56.0445C56.5056 55.0815 56.4093 53.4445 57.3722 52.2889L59.2019 50.1703C60.1648 49.0148 61.8982 48.9185 62.9574 49.8815L88.0908 71.2592Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M60.0685 17.3078C60.1648 17.0189 60.0685 16.73 59.9722 16.3447C59.5871 14.6115 57.6611 12.0115 54.9648 9.70033C52.2685 7.38922 49.5722 5.84848 47.7427 5.65588C47.7427 5.65588 47.7427 5.65588 47.6464 5.65588C47.0685 5.55959 46.6834 5.65588 46.3945 5.75219C46.1056 5.84848 45.7204 6.23367 45.5279 6.42625L7.1056 50.7226C7.00931 50.8189 6.91301 51.0115 6.81671 51.1078C6.81671 51.1078 6.72042 51.1078 6.72042 51.204C5.66116 52.4559 7.77968 56.1152 11.5353 59.3892C15.0982 62.567 18.8537 64.204 20.1056 63.241C20.3945 63.1447 20.6834 62.8559 20.9722 62.567L59.5871 18.2707C59.876 17.9818 59.9722 17.6929 60.0685 17.3078Z",
                fill: "#979BCD"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M60.0685 17.3334C60.0685 17.2371 60.0685 17.2371 60.0685 17.3334C60.1648 16.9482 60.0685 16.6592 59.9722 16.3703C59.587 14.6371 57.6611 12.0371 54.9648 9.72592C52.2685 7.41482 49.5722 5.87408 47.7426 5.68148C47.7426 5.68148 47.7426 5.68148 47.6464 5.68148C47.0685 5.58518 46.587 5.58518 46.2982 5.87408L46.1056 5.97037V33.7037L59.4907 18.2963C59.8759 17.9111 59.9722 17.6222 60.0685 17.3334Z",
                fill: "#6B458D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M73.2611 67.5037C73.2611 67.5037 66.4241 61.9185 64.787 60.7629C59.2019 56.6222 55.2537 60.7629 55.2537 60.7629C55.2537 60.7629 62.187 66.3482 69.4093 74.7259C69.4093 74.7259 77.6907 86.1852 90.2093 82.8148L98.1056 72.4148L76.0537 53.9259L77.2093 67.5037H73.2611Z",
                fill: "white"
            })
        ]
    });
var $558a1874964eed3d$var$HomeImprovement$1 = $558a1874964eed3d$var$HomeImprovement;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$LeavingAnInheritance = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.248 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.4441C97.4873 86.636 76.7311 104 51.9791 104C27.2292 104 6.4744 86.639 1.248 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M50.8179 70.3734C50.7199 70.0793 49.1516 62.2383 42.3887 62.2383V59.5919C49.5437 59.5919 52.7781 66.2567 53.4642 69.7852L50.8179 70.3734Z",
                fill: "#8FC6B4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M26.0204 60.8661C19.1595 55.4754 20.2377 42.5377 20.2377 42.5377C20.2377 42.5377 32.4893 38.421 39.3502 43.8118C46.211 49.2025 45.133 62.1402 45.133 62.1402C45.133 62.1402 32.8814 66.2567 26.0204 60.8661Z",
                fill: "#90C6B4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.3138 47.2423C51.2158 46.8502 49.5497 38.8131 42.3947 38.8131V37.049C51.0198 37.049 52.9801 46.8502 52.9801 46.9482L51.3138 47.2423Z",
                fill: "#8FC6B4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M36.612 37.735C33.2795 34.6966 34.4556 28.0317 34.4556 28.0317C34.4556 28.0317 41.0225 26.3655 44.257 29.5019C47.5894 32.6383 46.4132 39.2052 46.4132 39.2052C46.4132 39.2052 39.9444 40.8714 36.612 37.735Z",
                fill: "#90C6B4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52.196 15.094C52.196 15.094 58.2729 19.1126 58.1748 24.0132C58.0768 28.9139 52 32.8344 52 32.8344",
                fill: "#00A07E"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.9999 32.8344C51.9999 32.8344 45.9231 28.8158 46.021 23.9152C46.1191 19.0145 52.1959 15.094 52.1959 15.094",
                fill: "#90C6B4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52.0979 87.2316V34.8926",
                stroke: "#3C3E40",
                strokeWidth: 2.65419,
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M53.0782 47.2423L51.3139 46.9482C51.3139 46.8502 53.3722 37.049 61.8993 37.049V38.8131C54.8424 38.8131 53.0782 46.9482 53.0782 47.2423Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M67.3878 37.735C70.7203 34.6966 69.5442 28.0317 69.5442 28.0317C69.5442 28.0317 62.9773 26.3655 59.7429 29.5019C56.4104 32.6383 57.5866 39.2052 57.5866 39.2052C57.5866 39.2052 64.0555 40.8714 67.3878 37.735Z",
                fill: "#00A07E"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M53.3765 70.408L50.8464 69.9166C51.5294 66.3787 54.7488 59.696 61.8704 59.696V62.3495C55.139 62.2512 53.3765 70.3097 53.3765 70.408Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M77.9734 60.8661C84.8343 55.4754 83.7561 42.5377 83.7561 42.5377C83.7561 42.5377 71.5045 38.421 64.6436 43.8118C57.7826 49.2025 58.8608 62.1402 58.8608 62.1402C58.8608 62.1402 71.1124 66.2567 77.9734 60.8661Z",
                fill: "#00A07E"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M24.5563 37.1469C22.106 35.2847 22.498 30.678 22.498 30.678C22.498 30.678 26.8106 29.2079 29.2609 31.0701C31.7113 32.9323 31.3192 37.539 31.3192 37.539C31.3192 37.539 27.0066 39.1072 24.5563 37.1469Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M36.4159 23.4251C34.3576 21.1708 35.4357 16.7602 35.4357 16.7602C35.4357 16.7602 39.9443 15.9761 42.0026 18.2304C44.0608 20.4847 42.9828 24.8953 42.9828 24.8953C42.9828 24.8953 38.4742 25.6794 36.4159 23.4251Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M79.5417 37.1469C81.9919 35.2847 81.6 30.678 81.6 30.678C81.6 30.678 77.2874 29.2079 74.837 31.0701C72.3867 32.9323 72.7788 37.539 72.7788 37.539C72.7788 37.539 77.0913 39.1072 79.5417 37.1469Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M67.682 23.4251C69.7402 21.1708 68.6622 16.7602 68.6622 16.7602C68.6622 16.7602 64.1535 15.9761 62.0953 18.2304C60.037 20.4847 61.1151 24.8953 61.1151 24.8953C61.1151 24.8953 65.5257 25.6794 67.682 23.4251Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M65.4278 88.8978C65.4278 90.662 59.449 93.0144 52.098 93.0144C44.747 93.0144 38.7682 90.662 38.7682 88.8978C38.7682 87.1336 44.747 82.723 52.098 82.723C59.449 82.723 65.4278 87.2316 65.4278 88.8978Z",
                fill: "#3C3E40"
            })
        ]
    });
var $558a1874964eed3d$var$LeavingAnInheritance$1 = $558a1874964eed3d$var$LeavingAnInheritance;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$LifeInsurance = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.24799 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.47438 86.639 1.24799 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.9905 20.8L20.488 28.1003V47.8597C20.488 75.8928 51.9905 89.1306 51.9905 89.1306V20.8Z",
                fill: "#979BCD"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.9904 20.9275L83.493 28.2278V47.9872C83.493 76.0203 51.9904 89.2581 51.9904 89.2581V20.9275Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.9904 44.9697C51.9904 44.9697 44.7955 36.4041 39.1561 43.5096C31.475 53.1461 51.9904 69.3039 51.9904 69.3039",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.9904 69.3039C51.9904 69.3039 72.6032 53.1461 64.8248 43.5097C59.0882 36.3067 51.9904 44.9697 51.9904 44.9697",
                fill: "#E8E7E8"
            })
        ]
    });
var $558a1874964eed3d$var$LifeInsurance$1 = $558a1874964eed3d$var$LifeInsurance;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$LivingInMyIdealHome = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.248 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.4744 86.639 1.248 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("mask", {
                id: "mask0_1_317",
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: 0,
                y: 0,
                width: 104,
                height: 104,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: 52,
                    cy: 52,
                    r: 52,
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                mask: "url(#mask0_1_317)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M52.0724 60.4662L43.898 -13.104H60.2469L52.0724 60.4662Z",
                        fill: "#FFD10A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M52.0724 60.6563L87.812 -4.16913L101.214 5.24102L52.0724 60.6563Z",
                        fill: "#FFD10A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M124.049 43.7904L52 60.7097L118.632 28.392",
                        fill: "#FFD10A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M53.7179 60.4574L17.9783 -4.36801L4.576 5.04213L53.7179 60.4574Z",
                        fill: "#FFD10A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M51.9774 60.7514L-14.559 28.4337L-20.072 43.8322L51.9774 60.7514Z",
                        fill: "#FFD10A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M39.624 48.88H20.384V81.744H39.624V48.88Z",
                fill: "#027DAB"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M39.624 48.702L60.146 30.472L80.288 48.702V81.744H39.624V48.702Z",
                fill: "#8CBDD9"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M66.456 64.896H53.976V81.744H66.456V64.896Z",
                fill: "#027DAB"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M66.456 57.304H53.976V46.8H59.0491H66.456V57.304Z",
                fill: "#E8E7E8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M34.3928 29.1942H27.2639V42.3113H34.3928V29.1942Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M62.92 29.744L84.9965 49.7996H80.288V48.7016L61.1268 31.3593L37.8958 51.5105H16.224L41.3177 29.744H62.92Z",
                fill: "#3C3E40"
            })
        ]
    });
var $558a1874964eed3d$var$LivingInMyIdealHome$1 = $558a1874964eed3d$var$LivingInMyIdealHome;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$LongTermCare = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.24799 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.47438 86.639 1.24799 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M70.6468 65.9629C72.1875 69.0445 72.8616 72.5111 72.8616 76.4592H72.8602C72.8611 76.5552 72.8616 76.6515 72.8616 76.7482V83.9703H30.8763C30.8763 81.4609 31.1653 76.5555 31.1653 76.5555C31.1653 76.5555 31.8394 69.1408 33.3801 66.0592C34.8245 63.074 37.0394 60.474 39.9282 58.4519C40.1168 58.3212 40.3033 58.1929 40.4866 58.0666C41.5196 57.3552 42.4518 56.7133 43.106 56.1408C43.2869 56.0001 43.4594 55.8678 43.6244 55.7412C44.2499 55.2614 44.7673 54.8646 45.2245 54.4074L45.4171 54.2148C46.38 53.2519 46.7653 52.2889 46.7653 51.2297C46.7653 50.2666 46.2838 49.2074 45.3208 48.2445L45.1282 48.0519C45.0169 47.9591 44.9021 47.8628 44.783 47.7629C44.2837 47.3442 43.7094 46.8627 43.0097 46.3185C42.1431 45.7408 41.0838 44.9703 39.832 44.0074C36.9431 41.9852 34.8245 39.0963 33.3801 35.726C32.032 32.1629 31.2616 27.926 31.2616 23.8815V18.5852H72.8616C72.8616 20.3506 72.8616 22.116 72.8616 23.8815C72.8616 27.926 72.0912 32.1629 70.5505 35.9185C69.106 39.2889 66.9875 42.274 64.0986 44.2C63.91 44.3306 63.7236 44.459 63.5404 44.5852C62.5073 45.2966 61.5752 45.9386 60.9208 46.5111C60.7399 46.6518 60.5674 46.7841 60.4025 46.9107C59.777 47.3904 59.2595 47.7873 58.8023 48.2445L58.6097 48.4371C57.6908 49.356 57.298 50.2751 57.264 51.2777C57.298 52.2805 57.6907 53.1995 58.6097 54.1185L58.8023 54.3111C59.2595 54.7683 59.777 55.1651 60.4025 55.6449C60.5674 55.7715 60.7399 55.9037 60.9208 56.0445C61.5752 56.617 62.5072 57.2589 63.5402 57.9703C63.7235 58.0966 63.91 58.2249 64.0986 58.3555C66.9875 60.3778 69.2023 62.9778 70.6468 65.9629Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M27.9876 83.928C27.4099 83.928 26.832 84.5058 26.832 85.1799V87.6836C26.832 88.3577 27.3136 88.9354 27.9876 88.9354H52.5431V83.928H27.9876Z",
                fill: "#848484"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M77.1949 87.6836V85.1799C77.1949 84.5058 76.7134 83.928 76.0394 83.928H52.5431V88.9354H76.0394C76.6171 88.9354 77.1949 88.3577 77.1949 87.6836Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M27.9876 13.624C27.4099 13.624 26.832 14.2018 26.832 14.8758V17.3795C26.832 18.0537 27.3136 18.6314 27.9876 18.6314H52.5431V13.624H27.9876Z",
                fill: "#848484"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M77.1949 17.3795V14.8758C77.1949 14.2018 76.7134 13.624 76.0394 13.624H52.5431V18.6314H76.0394C76.6171 18.6314 77.1949 18.0537 77.1949 17.3795Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52.0378 27.5016C51.9324 27.3341 51.8117 27.142 51.688 26.936V72.9035L37.5209 80.3111H67.3728L53.2288 73.104V47.6983C53.5806 46.7987 54.0398 45.9894 54.8504 45.2525C55.9611 44.1419 57.6944 42.9422 60.0505 41.3116C60.1457 41.2458 60.242 41.1791 60.3393 41.1117C61.8679 40.0723 64.5974 37.9572 65.443 34.9488C66.6996 30.478 66.5985 24.8377 61.1097 23.8748C55.2356 22.8154 52.7319 27.2451 52.3467 28.0154C52.2916 27.9053 52.1785 27.7255 52.0378 27.5016Z",
                fill: "#8A65AB"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M49.7505 45.1629C48.595 44.0074 46.8617 42.7555 44.2617 41.0222C41.9505 39.4815 40.6987 37.5555 39.3505 35.4371C39.3505 35.3408 39.2542 35.3408 39.2542 35.2445C39.2542 35.1481 39.158 35.0518 39.158 35.0518C37.1357 31.2 37.9062 24.8445 43.4913 23.8815C48.0172 23.0148 50.5325 25.3952 51.688 26.936V48.1481C51.4954 47.0889 50.8099 46.126 49.7505 45.1629Z",
                fill: "#979BCD"
            })
        ]
    });
var $558a1874964eed3d$var$LongTermCare$1 = $558a1874964eed3d$var$LongTermCare;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$MajorPurchase = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.24799 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.47438 86.639 1.24799 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M94.8415 46.9303L81.2259 22.6927C80.067 20.5683 77.3632 19.7958 75.2388 21.0511L37.0959 42.4884C34.9715 43.6471 34.199 46.3509 35.4542 48.4754L49.0698 72.7131C50.2286 74.8376 52.9325 75.6101 55.0569 74.3547L93.2964 52.9174C95.3242 51.662 96.0967 49.0548 94.8415 46.9303Z",
                fill: "#8CBDD9"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M59.28 29.952L75.4394 20.9471C77.564 19.7883 80.2677 20.4643 81.4265 22.5887L95.0421 46.8263C96.2009 48.9508 95.5249 51.6546 93.4005 52.8134L59.28 71.968",
                fill: "#007DAA"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M71.77 39.5914L81.2334 34.2804L76.9845 25.7827L67.5212 31.0938L71.77 39.5914Z",
                fill: "#66A4BF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M94.2696 45.4819L91.3726 40.364L54.485 61.1254V67.8848L94.2696 45.4819Z",
                fill: "#515251"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M48.308 71.344L59.2166 65.1811L59.384 58.344L45.5044 66.2433L48.308 71.344Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("mask", {
                id: "mask0_1_54",
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: 0,
                y: 0,
                width: 104,
                height: 104,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: 52,
                    cy: 52,
                    r: 52,
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                mask: "url(#mask0_1_54)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M6.58887 66.7261C6.97512 65.9536 29.0884 20.182 29.0884 20.182C29.0884 20.182 34.3995 24.7205 32.9509 30.5144L12.2861 69.623L6.58887 66.7261Z",
                        fill: "#3C3E40"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M7.26483 69.9128C7.45796 69.1402 19.3354 23.5617 19.3354 23.5617C19.3354 23.5617 24.9361 26.7484 24.6464 32.2526L12.9621 71.4578L7.26483 69.9128Z",
                        fill: "#3C3E40"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M24.6464 35.5358L53.9055 54.2693C53.9055 54.2693 48.3048 58.8078 43.1868 56.2006C38.069 53.5933 28.5091 48.4754 28.5091 48.4754L24.6464 35.5358Z",
                        fill: "#898989"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M30.054 80.7279C34.1098 76.3826 38.8414 70.5887 44.4422 64.4086L41.9315 59.9666C39.9036 59.9666 37.393 60.6425 34.7857 63.1532C32.951 64.8913 25.8052 70.9749 25.8052 70.9749L22.0393 62.4773L29.0884 48.3788L24.6464 35.6323L21.8461 40.0743L3.01599 70.2024C5.91293 77.5414 8.90643 82.949 14.6038 88.1634L17.3076 87.2944C17.3076 87.2944 24.9362 86.3287 30.054 80.7279Z",
                        fill: "#898989"
                    })
                ]
            })
        ]
    });
var $558a1874964eed3d$var$MajorPurchase$1 = $558a1874964eed3d$var$MajorPurchase;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$MedicalExpenses = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.24799 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.47438 86.639 1.24799 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M28.9779 15.74L38.5378 75.7066H53.8916V15.74H28.9779Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M73.2045 15.74H53.8915V75.7066H82.7644L73.2045 15.74Z",
                fill: "#F0EFEF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M48.6771 31.287H67.8935",
                stroke: "white",
                strokeWidth: 1.93129,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M49.6427 35.922H68.7625",
                stroke: "white",
                strokeWidth: 1.93129,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M50.5119 40.6537H69.6316",
                stroke: "white",
                strokeWidth: 1.93129,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.381 45.2888H70.5008",
                stroke: "white",
                strokeWidth: 1.93129,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M43.5877 32.3491C43.5877 29.9499 44.1841 28.207 45.0233 26.9249C45.8675 25.6351 47.0015 24.7451 48.1691 24.1289C49.3408 23.5104 50.5257 23.1792 51.4264 23.0041C51.8743 22.917 52.2447 22.8699 52.4985 22.8447C52.6251 22.8322 52.7223 22.8251 52.7847 22.8213C52.8159 22.8194 52.8383 22.8183 52.8516 22.8177C52.8581 22.8174 52.8624 22.8173 52.8642 22.8172H52.8651H52.8642H52.8634C52.8629 22.8173 52.8624 22.8173 52.8294 21.6304C52.7964 20.4437 52.7958 20.4437 52.7952 20.4437H52.7936L52.7899 20.4438L52.7795 20.4442C52.7713 20.4445 52.7606 20.4449 52.7473 20.4455C52.7211 20.4466 52.6851 20.4485 52.6398 20.4512C52.5495 20.4567 52.4226 20.4661 52.2641 20.4818C51.9475 20.5132 51.5032 20.5702 50.9732 20.6732C49.9185 20.8783 48.4962 21.2713 47.0607 22.029C45.6211 22.7887 44.1478 23.9267 43.0366 25.6244C41.9203 27.3297 41.2131 29.5338 41.2131 32.3491C41.2131 35.3147 42.7542 38.6448 44.8334 41.9763C46.9374 45.3477 49.7308 48.929 52.4754 52.42C52.6045 52.5841 52.7333 52.748 52.8621 52.9117C55.492 56.2555 58.0474 59.5045 59.9805 62.489C62.0414 65.6707 63.2298 68.3133 63.2298 70.299C63.2298 78.259 60.1054 83.4021 55.6583 86.2189C51.16 89.0683 45.1195 89.6562 39.1301 88.0776C31.3039 86.0082 27.7223 79.8649 26.09 74.0116C25.2752 71.0901 24.9643 68.291 24.8586 66.2161C24.806 65.1809 24.8046 64.3317 24.8162 63.7451C24.822 63.452 24.831 63.2247 24.8384 63.0732C24.8421 62.9974 24.8454 62.9405 24.8477 62.9038C24.8488 62.8854 24.8497 62.8721 24.8503 62.8639L24.8508 62.8556L24.8509 62.8546C24.8509 62.8549 24.8509 62.8552 23.6669 62.7669C22.4829 62.6786 22.4828 62.6792 22.4828 62.6799L22.4827 62.6814L22.4824 62.6863L22.4813 62.7019C22.4803 62.7149 22.4792 62.7333 22.4777 62.7567C22.4748 62.8035 22.471 62.8709 22.4667 62.9574C22.4583 63.1305 22.4484 63.3806 22.4422 63.6982C22.4296 64.3329 22.4312 65.2386 22.4872 66.3368C22.5988 68.5289 22.9276 71.5115 23.8028 74.6495C25.5501 80.9148 29.5486 88.0006 38.5241 90.3735L38.5249 90.3737C44.9924 92.0783 51.7467 91.5074 56.929 88.2249C62.1624 84.91 65.6043 78.9481 65.6043 70.299H65.6045C65.6045 68.3133 66.7929 65.6707 68.8538 62.489C70.7869 59.5045 73.3423 56.2555 75.9722 52.9117C76.101 52.748 76.2298 52.5841 76.3589 52.42C79.1035 48.929 81.897 45.3477 84.001 41.9763C86.0801 38.6448 87.6211 35.3147 87.6211 32.3491C87.6211 29.5338 86.9139 27.3297 85.7977 25.6244C84.6866 23.9267 83.2132 22.7887 81.7735 22.029C80.3381 21.2713 78.9157 20.8783 77.8611 20.6732C77.3311 20.5702 76.8868 20.5132 76.5702 20.4818C76.4118 20.4661 76.2848 20.4567 76.1945 20.4512C76.1493 20.4485 76.1132 20.4466 76.0869 20.4455C76.0738 20.4449 76.063 20.4445 76.0549 20.4442L76.0445 20.4438L76.0407 20.4437H76.0392C76.0386 20.4437 76.0379 20.4437 76.005 21.6304C75.972 22.8173 75.9714 22.8173 75.971 22.8172L75.9766 22.8175L75.9827 22.8177C75.9959 22.8183 76.0184 22.8194 76.0496 22.8213C76.1121 22.8251 76.2091 22.8322 76.3358 22.8447C76.5897 22.8699 76.9601 22.917 77.4078 23.0041C78.3086 23.1792 79.4934 23.5104 80.6652 24.1289C81.8328 24.7451 82.9667 25.6351 83.811 26.9249C84.6502 28.207 85.2466 29.9499 85.2466 32.3491C85.2466 34.5981 84.0356 37.4359 81.9865 40.7191C79.9625 43.9625 77.2517 47.4424 74.4922 50.9524C74.3542 51.128 74.216 51.3036 74.0777 51.4793L74.0776 51.4795C71.4733 54.7905 68.8553 58.1188 66.8608 61.1981C65.903 62.6768 65.0534 64.1495 64.4172 65.5774C63.781 64.1495 62.9313 62.6768 61.9735 61.1981C59.979 58.1188 57.361 54.7904 54.7565 51.4794L54.556 51.2244C54.4847 51.1337 54.4134 51.043 54.3421 50.9524C51.5825 47.4424 48.8718 43.9625 46.8477 40.7191C44.7987 37.4359 43.5877 34.5981 43.5877 32.3491Z",
                fill: "#4B4B4D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M31.199 60.0631C31.199 64.2154 27.8192 67.4986 23.7635 67.4986C19.6112 67.4986 16.328 64.1188 16.328 60.0631C16.328 55.9109 19.7078 52.6276 23.7635 52.6276C27.8192 52.5311 31.199 55.9109 31.199 60.0631Z",
                fill: "#027DAB"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M26.1775 60.0631C26.1775 61.415 25.0187 62.5738 23.6669 62.5738C22.315 62.5738 21.1562 61.415 21.1562 60.0631C21.1562 58.7112 22.315 57.5525 23.6669 57.5525C25.1154 57.456 26.1775 58.6147 26.1775 60.0631Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M58.6233 24.5274H54.1814C52.5397 24.5274 51.2844 23.1755 51.2844 21.6304C51.2844 19.9889 52.6363 18.7335 54.1814 18.7335H58.6233V24.5274Z",
                fill: "#027DAB"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M70.211 18.5404H74.653C76.2946 18.5404 77.55 19.8923 77.55 21.4373C77.55 23.079 76.1981 24.3342 74.653 24.3342H70.211V18.5404Z",
                fill: "#027DAB"
            })
        ]
    });
var $558a1874964eed3d$var$MedicalExpenses$1 = $558a1874964eed3d$var$MedicalExpenses;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$PurchasingAVehicle = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.248 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.4744 86.639 1.248 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M44.3372 49.2074V71.9334C44.3372 72.4148 44.8186 72.8963 45.4927 72.8963H45.2038V74.6297L47.5149 76.7482V78.2889L45.9741 80.1185V81.1778L47.8038 84.2592V85.3185L47.4186 85.9926V90.2297L46.263 91.1926C45.9741 91.4815 45.8778 91.7703 45.9741 92.0592C46.3594 93.5037 47.9001 97.6445 52.1372 97.6445C54.6409 97.6445 56.5667 92.6371 57.0483 91.0963C57.1446 90.8074 57.0483 90.5185 56.8557 90.326L55.3149 88.7852L55.5075 85.9926L54.6409 84.5482V82.1408L56.7594 79.8297V78.4815L55.5075 77.2297V74.3408L57.2409 72.8V71.4519H58.0112C58.589 71.4519 59.0704 71.0666 59.0704 70.6815L58.6853 49.2074H44.3372Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M50.5001 55.2741C49.6334 55.2741 49.7297 58.5482 49.7297 69.6222C49.7297 73.2815 49.7297 93.9852 49.826 97.2593C50.3075 97.3556 50.5964 97.6445 51.0778 97.6445C51.0778 94.2741 51.0778 73.5703 51.0778 69.8148C51.0778 58.3556 50.8852 55.2741 50.5001 55.2741Z",
                fill: "#898989"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M53.6779 48.9185V96.9703C55.315 95.5259 56.5668 92.3482 56.952 91.1926C57.0483 90.9037 56.952 90.6148 56.7595 90.4222L55.6039 88.8815L55.7964 86.0889L54.8335 84.6445V82.2371L56.5668 79.926V78.5778L56.2779 77.326V74.4371L58.0113 72.8963V71.6445H57.8187C58.3964 71.6445 58.8779 71.2592 58.8779 70.874L59.4558 49.1111L53.6779 48.9185Z",
                fill: "#898989"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M63.2148 10.608H51.168V16.1029H60.5177C63.9855 16.1029 66.7789 18.4165 66.7789 21.3086C66.7789 22.4655 65.6231 23.4294 64.1781 23.4294L51.168 23.4V52.832C62.0362 52.832 72.0016 48.3501 72.7511 36.3473L73.7144 19.8625C74.0997 14.8496 69.2834 10.608 63.2148 10.608Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.168 23.4L39.7149 23.5117C38.2704 23.5117 37.1149 22.5488 37.1149 21.3932C37.1149 18.5043 39.9075 16.0969 43.3742 16.0969H51.168V10.608H40.6779C34.6112 10.608 29.7964 14.8451 30.1816 19.9488L31.1446 36.4154C31.7224 45.4672 37.2051 52.5431 51.168 52.832C51.1418 43.0416 51.2621 33.19 51.168 23.4Z",
                fill: "#8CBDD9"
            })
        ]
    });
var $558a1874964eed3d$var$PurchasingAVehicle$1 = $558a1874964eed3d$var$PurchasingAVehicle;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$PursuingAPassion = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.248 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.4744 86.639 1.248 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M28.7348 18.512L31.5274 23.9046L37.4977 23.2305L33.2607 27.5638L35.7644 33.0528L30.3719 30.3564L25.8459 34.4972L26.8088 28.4305L21.5125 25.4454L27.4829 24.4823L28.7348 18.512Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M85.8386 66.6602L87.283 71.1861L92.0015 71.4749L88.1497 74.1712L89.4015 78.7935L85.5497 76.0009L81.6015 78.5046L83.046 74.0749L79.3867 70.9935L84.1052 71.0898L85.8386 66.6602Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16.5396 90.034L21.5858 84.0628C23.2228 80.7888 30.9265 65.1888 33.8154 58.9295C36.9932 51.9962 46.7191 42.9443 46.7191 42.9443L67.0377 44.3888C64.2839 48.5514 64.7243 48.0292 65.4134 47.2123C65.7605 46.8008 66.1705 46.3146 66.2672 46.3146C72.1405 45.5419 71.7038 46.176 69.6976 49.0898C68.4596 50.8876 66.6239 53.5536 65.3043 57.2925C65.3043 57.9642 65.6948 59.7505 66.1874 62.0036C67.3893 67.5017 69.1988 75.779 67.4228 77.4183C61.5488 82.7146 52.6895 91.574 52.6895 91.574C49.8006 94.7517 46.2377 96.4851 42.482 97.0628L38.8944 102.334C30.4062 100.131 22.7604 95.8363 16.5396 90.034Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M47.0311 73.4972L40.868 77.638C40.868 77.638 43.3718 83.2231 39.6162 92.2749C39.52 92.2749 48.3792 88.5194 47.0311 73.4972Z",
                fill: "#898989"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M43.1793 41.9351L15.8312 42.6092L37.4978 59.2685L29.7941 85.4611L52.2312 69.9574V16.224L43.1793 41.9351Z",
                fill: "#90C6B4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M88.7274 42.6092L61.3792 41.9351L52.2311 16.224V69.9574L74.7644 85.4611L66.9644 59.2685L88.7274 42.6092Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M72.3571 59.2454C73.32 60.6898 72.8386 62.712 71.3941 63.6749L65.1349 67.6231C63.6904 68.586 61.6681 68.2009 60.7052 66.7565C59.7423 65.312 60.2237 63.2898 61.6681 62.3268L67.8311 58.2823C69.4681 57.4157 71.3941 57.8009 72.3571 59.2454Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M74.9571 67.0454C75.92 68.4898 75.4386 70.512 73.9941 71.4749L68.9867 74.7491C67.5423 75.712 65.52 75.3268 64.5571 73.8823C63.5941 72.4379 64.0755 70.4157 65.52 69.4528L70.5274 66.1786C71.9718 65.2157 73.9941 65.6009 74.9571 67.0454Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20.8385 84.7638L25.1719 70.1268L40.194 44.512C43.3719 47.112 44.72 52.2157 36.7274 68.7786C39.8089 74.7491 45.8755 84.3786 39.6163 96.6083C39.6163 96.6083 30.0829 92.8528 20.8385 84.7638Z",
                fill: "white"
            })
        ]
    });
var $558a1874964eed3d$var$PursuingAPassion$1 = $558a1874964eed3d$var$PursuingAPassion;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Retirement = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.248 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.4744 86.639 1.248 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M37.1088 36.2074L36.9162 36.3037C36.9162 36.3037 36.9162 36.3037 36.9162 36.4L37.1088 36.2074Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M50.6866 50.648C50.6866 50.648 47.0466 52.3666 47.0466 56.2811C47.0466 60.1955 50.6866 62.296 50.6866 62.296V50.648Z",
                fill: "#8DC4B2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M50.6866 50.648C50.6866 50.648 54.3266 52.3666 54.3266 56.2811C54.3266 60.1955 50.6866 62.296 50.6866 62.296V50.648Z",
                fill: "#03896B"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M72.7384 85.2222C72.7384 89.8445 63.0125 94.5629 50.9754 94.5629C38.9384 94.5629 29.2125 89.8445 29.2125 85.2222C29.2125 80.6 38.9384 75.8815 50.9754 75.8815C63.0125 75.8815 72.7384 80.6 72.7384 85.2222Z",
                fill: "#B7B7B7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M43.0946 63.752C43.0946 63.752 38.3106 66.0608 38.3106 71.1594C38.3106 76.258 43.0946 79.144 43.0946 79.144V63.752Z",
                fill: "#8DC4B2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M43.0946 63.752C43.0946 63.752 47.7746 66.1388 47.7746 71.207C47.7746 76.2752 43.0946 79.144 43.0946 79.144V63.752Z",
                fill: "#03896B"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M66.9606 91.2889C63.0125 89.3629 57.3309 88.1111 50.9754 88.1111C44.6198 88.1111 39.0346 89.3629 34.9903 91.2889C38.9384 93.2148 44.6198 94.4666 50.9754 94.4666C57.3309 94.4666 63.0125 93.2148 66.9606 91.2889Z",
                fill: "#7F7F7F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("mask", {
                id: "mask0_1_23",
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: 0,
                y: 0,
                width: 104,
                height: 104,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: 52,
                    cy: 52,
                    r: 52,
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                mask: "url(#mask0_1_23)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M31.4273 21.9556C31.5236 22.0519 39.131 29.5629 40.5755 31.2963C42.0199 33.0297 46.0644 36.9778 47.3162 37.5556C48.5681 38.1334 50.3014 37.6519 50.8792 37.3629C51.5532 37.074 51.9384 36.4963 51.9384 36.4963L48.4718 31.5852C48.4718 31.5852 56.4644 36.6889 57.9088 37.1703C59.2569 37.7482 61.1829 37.5556 62.0495 36.8815C62.9162 36.2074 63.494 35.4371 63.494 35.4371L53.4792 27.926C53.4792 27.926 63.494 30.8148 64.6495 30.8148C65.8051 30.8148 67.1532 30.1408 67.9236 29.274C68.5977 28.4074 68.9829 27.6371 68.9829 27.6371C68.9829 27.6371 52.6126 20.9926 52.5162 20.9926L31.4273 21.9556Z",
                        fill: "#3C3E40"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M30.1754 41.6963C30.1754 41.6963 32.5828 40.0592 32.3902 37.074C32.294 34.0889 31.5235 32.7408 30.1754 31.2963C28.8272 29.8519 27.1902 28.6 27.768 25.9037C28.3458 23.2074 30.6569 22.726 33.1606 22.726C35.6643 22.726 64.9383 22.6297 66.094 22.726C67.2495 22.8222 69.9458 22.4371 70.9088 21.1852C71.968 19.9334 71.968 18.4889 71.968 18.4889C71.968 18.4889 33.3532 13.5778 30.1754 13.1926C26.9977 12.7111 24.0124 11.9408 22.0865 11.074C21.7977 10.8815 21.3161 10.5926 20.8346 10.3037C16.5014 13.3852 12.7458 17.1408 9.56799 21.3778C10.4346 22.2445 11.1088 23.0148 11.494 23.4C14.4791 26.5778 30.1754 41.6963 30.1754 41.6963Z",
                        fill: "#898989"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M63.8792 57.9703C62.9162 57.9703 62.1458 58.6445 61.7606 59.5111C55.7903 74.9185 61.0866 86.474 61.6643 92.1556H61.7606C67.731 88.9778 78.3235 79.5408 80.2495 64.2297C80.3458 63.2666 80.1532 62.3037 79.3829 61.8222L72.2569 57.9703H63.8792Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M66.1903 82.2371L71.294 64.1334C71.4866 63.6518 71.1977 63.1703 70.8126 63.074C70.331 62.8815 69.8495 63.1703 69.7532 63.5555L64.6495 81.7555",
                fill: "#C0BEBE"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M70.2386 58.4342L73.6376 59.592L75.7506 52.7418L72.2596 51.584L70.2386 58.4342Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M81.9829 31.6815L79.4792 30.9111C78.5162 30.6222 77.457 31.1037 77.1681 32.0666C76.6866 33.5111 75.9162 35.5334 75.1459 37.9408C75.0496 38.1334 75.0496 38.326 74.9533 38.5185C74.7607 39.0963 74.5681 39.7703 74.3755 40.3482C74.2792 40.5408 74.2792 40.7334 74.1829 40.926C73.9903 41.6 73.7977 42.1778 73.6052 42.8518C73.5089 43.0445 73.5089 43.2371 73.4125 43.4297C72.4496 46.9926 71.7755 50.3629 72.257 51.7111L75.7236 52.8666C76.8792 52 78.4199 48.9185 79.6718 45.4518C79.7681 45.2592 79.7681 45.0666 79.8644 44.874C80.057 44.2 80.3458 43.6222 80.5384 42.9482C80.6347 42.7555 80.6347 42.5629 80.731 42.3703C80.9236 41.6963 81.1162 41.1185 81.3089 40.4445C81.4052 40.2519 81.4052 40.0592 81.5015 39.8666C82.1755 37.5555 82.8496 35.3408 83.2347 33.8963C83.5236 32.9334 82.9458 31.9703 81.9829 31.6815Z",
                fill: "#03896B"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M41.9506 37.4592C41.9506 37.4592 38.3106 39.1778 38.3106 43.0923C38.3106 46.9113 41.9506 49.1072 41.9506 49.1072V37.4592Z",
                fill: "#8DC4B2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M41.9506 37.4592C41.9506 37.4592 45.6098 39.1926 45.6098 43.1408C45.6098 46.9926 41.9506 49.2074 41.9506 49.2074V37.4592Z",
                fill: "#03896B"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M67.3458 78.9629C74.8569 79.5408 72.931 85.9926 72.931 85.9926C68.9829 93.7926 53.8644 94.9482 46.8347 94.3703C49.099 88.9638 52.4942 87.5931 55.4136 87.6298C55.3826 87.44 55.3666 87.2457 55.3666 87.048C55.3666 84.8654 57.3222 83.096 59.7346 83.096C60.5931 83.096 61.3938 83.3201 62.0692 83.7072C63.1304 80.4162 65.0343 78.8969 67.3458 78.9629Z",
                fill: "#3B3E40"
            })
        ]
    });
var $558a1874964eed3d$var$Retirement$1 = $558a1874964eed3d$var$Retirement;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$SpendingTimeWithFriendsAndFamily = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.24799 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.4441C97.4873 86.636 76.7311 104 51.9791 104C27.2292 104 6.47438 86.639 1.24799 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M58.7046 81.7902C58.608 81.6936 50.9793 74.1616 49.5309 72.4234C48.0824 70.6853 44.0267 66.7261 42.7715 66.1467C41.5161 65.5673 39.7779 66.0501 39.1985 66.3398C38.6192 66.6295 38.1363 67.2089 38.1363 67.2089L41.6126 72.1337C41.6126 72.1337 33.5012 67.0158 32.1493 66.533C30.7974 65.9536 28.8661 66.1467 27.997 66.8226C27.128 67.4986 26.5486 68.2711 26.5486 68.2711L36.4947 75.7066C36.4947 75.7066 26.452 72.8097 25.2932 72.8097C24.1344 72.8097 22.7826 73.4856 22.01 74.3547C21.334 75.2237 20.9478 75.9962 20.9478 75.9962C20.9478 75.9962 37.3638 82.6592 37.4604 82.6592C37.5569 82.6592 58.7046 81.7902 58.7046 81.7902Z",
                fill: "#898989"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M67.5885 47.7029H72.8994C75.5067 47.7029 77.6311 49.7307 77.5346 52.2414V64.2154C77.5346 66.7261 75.4102 68.754 72.8029 68.754H67.4919V70.7818C67.4919 74.2581 64.4984 82.1764 60.8289 82.1764H39.0053C35.3359 82.1764 32.3423 79.2795 32.3423 75.7066V42.585C32.3423 41.5227 33.308 40.6537 34.3702 40.6537H65.5606C66.7193 40.6537 67.5885 41.5227 67.5885 42.585V47.7029ZM72.8994 64.7948C73.3823 64.7948 73.6721 64.5051 73.6721 64.1188V52.2414C73.6721 51.8551 73.2858 51.5655 72.8994 51.5655H67.5885V64.7948H72.8994Z",
                fill: "#8CBDD8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M67.5885 47.7029H72.8995C75.5067 47.7029 77.6311 49.7307 77.6311 52.2414V64.1188C77.6311 66.6296 75.5067 68.6574 72.8995 68.6574H67.5885V75.6101C67.5885 79.1829 64.5949 82.0798 60.9255 82.0798H55.4213V40.6537H65.5606C66.7193 40.6537 67.5885 41.5227 67.5885 42.585V47.7029ZM72.8995 64.7948C73.3823 64.7948 73.672 64.5051 73.672 64.1188V52.2414C73.672 51.8551 73.2858 51.5655 72.8995 51.5655H67.5885V64.7948H72.8995Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M32.9218 20.0854C33.0184 20.182 40.647 27.714 42.0954 29.4522C43.544 31.1903 47.5996 35.1495 48.855 35.7289C50.1103 36.3083 51.8485 35.8254 52.4278 35.5358C53.1038 35.246 53.4901 34.6666 53.4901 34.6666L50.1103 29.7419C50.1103 29.7419 58.1252 34.8598 59.5737 35.3426C60.9256 35.922 62.8569 35.7289 63.7259 35.0529C64.595 34.377 65.1744 33.6045 65.1744 33.6045L55.1316 26.0724C55.1316 26.0724 65.1744 28.9694 66.3332 28.9694C67.4919 28.9694 68.8438 28.2934 69.6163 27.4243C70.2923 26.5553 70.6786 25.7827 70.6786 25.7827C70.6786 25.7827 54.2626 19.1198 54.166 19.1198C53.9729 19.1198 32.9218 20.0854 32.9218 20.0854Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.135 19.8398C14.4602 15.6204 18.4249 11.9285 22.8827 8.91024C23.053 9.01211 23.2145 9.09991 23.3619 9.17363C25.1967 10.0427 28.1901 10.8153 31.3768 11.298C34.5635 11.6843 73.2858 16.6091 73.2858 16.6091C73.2858 16.6091 73.2858 18.0575 72.2236 19.3129C71.258 20.5683 68.5542 20.9545 67.3954 20.8579C66.4673 20.7806 47.454 20.8271 38.6289 20.8488C36.4346 20.8541 34.8703 20.8579 34.3703 20.8579C31.8597 20.8579 29.5421 21.3408 28.9627 24.0446C28.4507 26.434 29.6732 27.6922 30.8975 28.9522C31.0586 29.118 31.2197 29.2838 31.3768 29.4522C32.7287 30.9007 33.4047 32.2526 33.5978 35.246C33.791 38.2396 31.3768 39.8812 31.3768 39.8812C31.3768 39.8812 15.6368 24.624 12.6433 21.4373C12.4887 21.2829 12.2879 21.0666 12.047 20.807C11.7871 20.5271 11.4805 20.197 11.135 19.8398Z",
                fill: "#898989"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M77.4224 97.3725C75.5452 95.6021 72.5256 92.9405 70.9022 92.1716C69.0674 91.3024 66.074 90.5299 62.8873 90.047C59.7008 89.6608 21.944 84.7361 21.944 84.7361C21.944 84.7361 21.944 83.2876 23.0063 82.0323C23.9719 80.7769 25.71 80.3906 26.8688 80.4873C27.7968 80.5645 46.8102 80.518 55.6353 80.4964C57.8295 80.491 59.3939 80.4873 59.8938 80.4873C62.4046 80.4873 64.7221 80.0044 65.3015 77.3006C65.8135 74.9111 64.591 73.6529 63.3667 72.3929C63.2056 72.2272 63.0446 72.0614 62.8873 71.893C61.5354 70.4445 60.8596 69.0926 60.6664 66.0991C60.4733 63.1056 62.8873 61.464 62.8873 61.464C62.8873 61.464 78.5308 76.6246 81.6209 80.0044C82.8333 81.3733 85.9943 84.7138 89.3264 88.2042C85.8346 91.8035 81.8269 94.8994 77.4224 97.3725Z",
                fill: "white"
            })
        ]
    });
var $558a1874964eed3d$var$SpendingTimeWithFriendsAndFamily$1 = $558a1874964eed3d$var$SpendingTimeWithFriendsAndFamily;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$SupportingACause = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.24799 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.4441C97.4873 86.636 76.7311 104 51.9791 104C27.2292 104 6.47438 86.639 1.24799 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52.0168 63.85C52.0168 63.85 87.7063 35.7872 74.4084 19.1648C64.4349 6.74678 52.0168 21.6092 52.0168 21.6092",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52.0168 21.6092C52.0168 21.6092 39.5988 6.74678 29.6253 19.1648C16.2295 35.7872 52.0168 63.85 52.0168 63.85",
                fill: "#F4826E"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.6798 90.6415C52.1687 90.3482 82.8714 74.899 82.8714 74.899C82.8714 74.899 79.6447 71.5746 75.9291 72.7479L49.5286 86.9259L51.6798 90.6415Z",
                fill: "#898989"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.3865 91.2282C51.8754 90.8371 72.0179 73.3346 72.0179 73.3346C72.0179 73.3346 71.9202 73.2368 71.8224 73.2368C68.9867 71.5746 65.4668 71.9657 63.12 74.3124L53.9288 83.3081L37.5995 78.7124L51.3865 91.2282Z",
                fill: "#898989"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9.61597 82.1335C13.1065 77.5989 19.5019 73.8661 24.4972 71.1834L25.0838 70.89C32.8696 66.441 35.4167 66.6872 40.7362 67.2012C42.8988 67.4101 45.5198 67.6633 49.1376 67.6633L64.9778 67.7612C64.9778 67.7612 62.9245 72.8457 58.4266 74.019C56.8621 74.5079 40.9241 76.0724 40.9241 76.0724L44.3463 77.7347L61.36 85.0681L82.7737 74.899C82.7737 74.899 87.8582 74.4101 89.9116 77.2458L60.7733 94.5527L52.6576 92.5971C43.173 90.3482 36.9151 89.6637 27.5283 91.7171L26.2572 92.0105L24.0955 95.8864C18.4281 92.2753 13.5071 87.5966 9.61597 82.1335Z",
                fill: "white"
            })
        ]
    });
var $558a1874964eed3d$var$SupportingACause$1 = $558a1874964eed3d$var$SupportingACause;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Traveling = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.248 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.4441C97.4873 86.636 76.7311 104 51.9791 104C27.2292 104 6.4744 86.639 1.248 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.9764 16.5931C36.1765 16.5931 23.4 29.3695 23.4 45.2669C23.4 61.0668 48.7578 89.058 51.9764 89.253C55.3899 89.4481 80.5527 61.0668 80.5527 45.2669C80.5527 29.3695 67.7763 16.5931 51.9764 16.5931Z",
                fill: "#8CBDD9"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52 89.2539V16.5931C67.789 16.6058 80.5527 29.3775 80.5527 45.2669C80.5527 61.0308 55.5044 89.3189 52 89.2539Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M73.7962 99.2253C75.5122 96.3201 76.7201 92.8165 77.4844 89.165C80.435 74.1311 73.0878 63.6827 63.44 53.664C76.1366 60.3717 87.0192 69.4558 94.5396 81.9137C89.2942 89.3594 82.1434 95.3663 73.7962 99.2253Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M71.1939 51.2163L64.6594 54.6298C64.6594 54.6298 64.0742 62.0421 63.8792 62.0421C63.6841 62.0421 60.8557 60.2866 60.8557 60.2866L60.173 54.3373L51.2002 49.9484L46.7139 67.3088C46.5188 67.2112 42.8126 64.578 42.8126 64.578L43.1053 54.4347L39.204 50.2409L41.1547 47.0225L43.0077 48.3879L42.8126 43.5114C42.8126 43.5114 37.4485 40.2929 35.1078 37.8546C32.7671 35.3188 32.8646 34.051 32.8646 34.051C32.8646 34.051 32.8646 33.2707 33.6448 33.1732C34.425 33.0756 36.5708 33.3683 39.6917 34.8313C42.8126 36.2941 46.0311 38.83 46.0311 38.83L50.7126 37.0744L48.9571 35.6115L50.9077 32.7831L55.2965 35.6115L66.3175 31.3201L70.1211 33.9534L54.4187 44.4867L62.8063 50.5336L68.3655 49.1682L71.1939 51.2163Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52 50.3395V33.4871L55.2965 35.6115L66.3175 31.3201L70.1211 33.9534L54.4187 44.4867L62.8063 50.5336L68.3655 49.1682L71.1939 51.2163L64.6594 54.6298C64.6594 54.6298 64.0742 62.0421 63.8792 62.0421C63.6841 62.0421 60.8557 60.2866 60.8557 60.2866L60.173 54.3373L52 50.3395Z",
                fill: "#E8E7E8"
            })
        ]
    });
var $558a1874964eed3d$var$Traveling$1 = $558a1874964eed3d$var$Traveling;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Vacation = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.24799 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.47438 86.639 1.24799 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M42.9828 60.7629L51.2643 19.5481C52.5162 18.5852 53.9606 17.9111 55.5014 17.3334C55.6939 17.2371 55.8865 17.2371 55.9828 17.1408H56.0791C57.9088 16.5629 59.9309 16.274 62.0495 16.274C62.1457 16.274 62.1457 16.274 62.242 16.274C62.4346 16.274 62.6272 16.274 62.7235 16.274C63.4939 16.274 64.2643 16.3703 65.0346 16.4666C66.6717 16.6592 68.3088 17.0444 69.8494 17.526C70.2346 17.6222 70.6199 17.8148 71.0051 17.9111C71.0051 17.9111 71.1014 17.9111 71.1014 18.0074C73.0272 18.7778 74.8569 19.7408 76.3013 20.8963C77.9383 22.1481 79.3828 23.5926 80.3457 25.1334L65.7088 67.5037L42.9828 60.7629Z",
                fill: "#DD5239"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M43.0791 60.6666L51.168 19.5482C52.4199 18.5852 53.8643 17.9111 55.405 17.3334C55.5976 17.2371 55.7902 17.2371 55.9828 17.1408H56.0791C57.6199 16.6592 59.2569 16.4666 60.9902 16.3703L60.5088 65.7703L43.0791 60.6666Z",
                fill: "#F4826E"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.3976 42.1778L20.4494 77.6148L21.5086 78L29.6939 77.2297L28.9235 41.2148L24.3976 42.1778Z",
                fill: "#DD5239"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M46.9309 41.5037L47.4125 38.8074L17.368 40.926V42.8519L21.9902 44.7778",
                fill: "#EF674A"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M17.368 40.926V42.8518L18.4273 43.3334L21.9902 44.7778H22.0865L22.1828 42.6592L17.5606 40.926H17.368Z",
                fill: "#EF674A"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.1828 42.7555L47.0273 40.0592L47.5088 38.1334L17.368 40.926L22.1828 42.7555Z",
                fill: "#F6BAA8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M73.2198 48.2444L71.7754 70.3926L77.4569 72.126L78.1309 47.3778L73.2198 48.2444Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M51.9384 63.4592L71.294 69.2371C71.294 69.2371 79.5755 71.9334 82.0792 72.9926C86.3163 74.8222 86.7014 81.0815 86.7014 81.0815L83.5236 81.1778L51.9384 72.126L48.9532 66.926L51.9384 63.4592Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M50.3014 67.3111L49.4347 66.9259L51.9384 63.4592L52.2273 64.5185",
                fill: "#F9B096"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.9605 55.5629L24.3013 57.7778L55.0199 68.2741L55.5013 64.4222L27.9605 55.5629Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.3014 57.7778L23.9163 62.4L57.5237 75.2074L58.0051 69.1408L24.3014 57.7778Z",
                fill: "#DD5239"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M55.5977 51.7111L51.5532 87.0518L52.7088 87.5334L60.894 86.1852L60.9903 50.8445L55.5977 51.7111Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M84.4866 48.1482V46.7037L80.0569 46.4148L48.568 50.4593V52.4815L53.2866 54.4074",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M53.3829 52.2889L84.4866 46.7037L80.0569 45.7408L48.568 50.4592L53.3829 52.2889Z",
                fill: "white"
            })
        ]
    });
var $558a1874964eed3d$var$Vacation$1 = $558a1874964eed3d$var$Vacation;
/* eslint-disable react/jsx-props-no-spreading */ const $558a1874964eed3d$var$Wedding = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 104,
        height: 104,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.24799 63.45C14.0547 58.7913 32.0482 55.8977 51.9879 55.8977C71.9191 55.8977 89.9059 58.7888 102.712 63.444C97.4873 86.6359 76.7311 104 51.9791 104C27.2292 104 6.47438 86.639 1.24799 63.45Z",
                fill: "#F7CB3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M102.732 63.4441C103.562 59.761 104 55.9309 104 52C104 23.3171 80.6829 0 52 0C23.3171 0 0 23.3171 0 52C0 55.933 0.438397 59.7651 1.26891 63.45C14.0756 58.7913 32.0691 55.8977 52.0088 55.8977C71.94 55.8977 89.9268 58.7888 102.732 63.4441Z",
                fill: "#FCE47F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M85.0758 74.9185C85.0758 81.9482 70.2462 87.5334 51.95 87.5334C33.6536 87.5334 18.824 81.8518 18.824 74.9185C18.824 67.8889 33.6536 62.3037 51.95 62.3037C70.2462 62.2074 85.0758 67.8889 85.0758 74.9185Z",
                fill: "#3C3E40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52 27.56V38.064C48.9671 38.0364 31.616 37.872 31.616 32.3783C31.616 29.2946 40.8989 27.56 52 27.56Z",
                fill: "#979BCD"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M51.9961 38.1603C41.3072 38.1603 32.448 35.6566 31.5814 32.864V47.8593C31.5814 49.4963 34.0851 50.9408 38.1294 52C41.7888 52.9629 46.6035 53.5408 51.9961 53.5408V38.1603Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52 38.1603C62.6889 38.1603 71.5482 35.6566 72.4149 32.864V47.8593C72.4149 49.4963 69.9112 50.9408 65.8667 52C62.2075 52.9629 57.3926 53.5408 52 53.5408V38.1603Z",
                fill: "#DCDBDB"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52 27.56V38.064C48.9671 38.0364 31.616 37.872 31.616 32.3783C31.616 29.2946 40.8989 27.56 52 27.56Z",
                fill: "#979BCD"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M52 27.56V38.064C55.033 38.0364 72.384 37.872 72.384 32.3783C72.384 29.2946 63.1012 27.56 52 27.56Z",
                fill: "#8A65AB"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M31.5814 47.7629C31.5814 49.4 34.0851 50.8444 38.1296 51.9037C41.7888 52.8666 46.6036 53.4444 51.9962 53.4444V60.3778C47.1611 60.3478 22.6259 59.9666 22.6259 51.4222C22.6259 49.2074 26.0925 47.1852 31.5814 45.7408V47.7629Z",
                fill: "#979BCD"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M72.4148 47.7629C72.4148 49.4 69.9111 50.8444 65.8666 51.9037C62.2074 52.8666 57.3926 53.4444 52 53.4444V60.3778C56.8351 60.3478 81.3703 59.9666 81.3703 51.4222C81.3703 49.2074 77.9037 47.1852 72.4148 45.7408V47.7629Z",
                fill: "#8A65AB"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M22.7221 52.0963V73.2815C22.7221 73.474 22.7221 73.5703 22.7221 73.7629C22.7221 78.0963 35.8184 83.3926 51.9961 83.4889V60.3778C36.4924 60.2815 23.8777 56.3334 22.7221 52.0963Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M81.274 52.0963V73.2815C81.274 73.474 81.274 73.5703 81.274 73.7629C81.274 78.0963 68.1777 83.3926 52 83.4889V60.3778C67.5037 60.2815 80.1185 56.3334 81.274 52.0963Z",
                fill: "#DCDBDB"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M47.3162 18.5852C48.2791 16.3703 43.5606 13.674 46.4495 12.8074C50.3977 11.6519 55.9828 15.2148 53.768 20.0297C51.6495 24.7482 46.3532 20.8 47.3162 18.5852Z",
                fill: "#979BCD"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M58.005 12.7111C55.405 11.8445 45.7754 16.1778 47.5087 25.6148L58.4864 17.3334C58.4864 17.3334 60.7013 13.5778 58.005 12.7111Z",
                fill: "#9978B5"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M43.68 15.7188C43.68 13.6003 53.0208 15.2374 55.7171 23.1337C57.2578 27.6595 54.3689 31.2226 51.2874 31.2226C48.206 31.2226 45.0281 28.8151 45.2208 23.7114C45.4134 18.6077 44.4503 17.0669 43.68 15.7188Z",
                fill: "#6B458D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M60.4125 16.6592C60.4125 14.6371 50.0125 16.0815 47.3162 23.4963C45.7754 27.7334 49.3383 31.2 52.6125 31.2C55.7902 31.2 59.0643 28.8889 58.8717 24.1703C58.6791 19.4518 59.7383 18.0074 60.4125 16.6592Z",
                fill: "#979BCD"
            })
        ]
    });
var $558a1874964eed3d$var$Wedding$1 = $558a1874964eed3d$var$Wedding;
var $558a1874964eed3d$var$illustrations = {
    'accounts-over-time-error': $558a1874964eed3d$var$AccountsOverTimeError$1(),
    'disability-insurance': $558a1874964eed3d$var$DisabilityInsurance$1(),
    'education-goal': $558a1874964eed3d$var$EducationGoal$1(),
    'emergency-fund': $558a1874964eed3d$var$EmergencyFund$1(),
    'general-financial-goal': $558a1874964eed3d$var$GeneralFinancialGoal$1(),
    'gi-debtfree': $558a1874964eed3d$var$GiDebtfree$1(),
    'gi-healthy': $558a1874964eed3d$var$GiHealthy$1(),
    'home-improvement': $558a1874964eed3d$var$HomeImprovement$1(),
    'leaving-an-inheritance': $558a1874964eed3d$var$LeavingAnInheritance$1(),
    'life-insurance': $558a1874964eed3d$var$LifeInsurance$1(),
    'living-in-my-ideal-home': $558a1874964eed3d$var$LivingInMyIdealHome$1(),
    'long-term-care': $558a1874964eed3d$var$LongTermCare$1(),
    'major-purchase': $558a1874964eed3d$var$MajorPurchase$1(),
    'medical-expenses': $558a1874964eed3d$var$MedicalExpenses$1(),
    'purchasing-a-vehicle': $558a1874964eed3d$var$PurchasingAVehicle$1(),
    'pursuing-a-passion': $558a1874964eed3d$var$PursuingAPassion$1(),
    'retirement': $558a1874964eed3d$var$Retirement$1(),
    'spending-time-with-friends-and-family': $558a1874964eed3d$var$SpendingTimeWithFriendsAndFamily$1(),
    'supporting-a-cause': $558a1874964eed3d$var$SupportingACause$1(),
    'traveling': $558a1874964eed3d$var$Traveling$1(),
    'vacation': $558a1874964eed3d$var$Vacation$1(),
    'wedding': $558a1874964eed3d$var$Wedding$1()
};
const $558a1874964eed3d$var$Illustration$1 = ({ name: name, id: id, seenByAssistiveTechnology: seenByAssistiveTechnology = false, altText: altText = null, classes: classes = [] })=>{
    const classNames = [
        'axiom-illustration',
        `axiom-illustration--${name}`
    ];
    const a11yText = altText || `${name} illustration`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        id: id,
        "data-testid": "uxd-illustration",
        role: !seenByAssistiveTechnology ? 'presentation' : 'img',
        className: $558a1874964eed3d$var$createClassList({
            default: classNames,
            custom: classes,
            required: []
        }),
        ...!seenByAssistiveTechnology ? {
            'aria-hidden': 'true'
        } : {
            'aria-label': a11yText
        },
        children: $558a1874964eed3d$var$illustrations[name] || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: "Illustration Not Found"
        })
    });
};
$558a1874964eed3d$var$Illustration$1.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    seenByAssistiveTechnology: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    altText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$IllustrationJSX = $558a1874964eed3d$var$Illustration$1;
var $558a1874964eed3d$export$d43c2e2ca9b2c105 = function(_a) {
    var name = _a.name, _b = _a.id, id = _b === void 0 ? undefined : _b, _c = _a.seenByAssistiveTechnology, seenByAssistiveTechnology = _c === void 0 ? false : _c, _d = _a.altText, altText = _d === void 0 ? null : _d, _e = _a.classes, classes = _e === void 0 ? [] : _e;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$IllustrationJSX, {
        id: id,
        name: name,
        seenByAssistiveTechnology: seenByAssistiveTechnology,
        altText: altText,
        classes: classes
    });
};
$558a1874964eed3d$export$d43c2e2ca9b2c105.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    seenByAssistiveTechnology: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    altText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$InfoTooltip$1 = ({ title: title, children: children, linkDecoration: linkDecoration = 'underline', linkText: linkText, linkUrl: linkUrl, placement: placement = 'auto', align: align = 'auto', customAriaLabel: customAriaLabel = 'Info Tooltip', classes: classes = [] })=>{
    const [toggle, setToggle] = (0, $acw62.useState)(false);
    const handleClick = ()=>{
        setToggle(!toggle);
    };
    const handleClose = ()=>{
        setToggle(false);
    };
    const infoButtonId = (0, $5sKyw.default)();
    const tooltipId = (0, $5sKyw.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "axiom-infotooltip--wrapper",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: $558a1874964eed3d$var$createClassList({
                default: [
                    'axiom-infoTooltip',
                    'infotooltip'
                ],
                custom: classes,
                required: []
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "axiom-infoTooltip--btn-wrapper info--btn-wrapper",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        "data-testid": "info-tooltip",
                        className: " axiom-infoTooltip--info-btn info--btn axiom-button button button--tertiary button--icon-only ",
                        onClick: handleClick,
                        title: "information",
                        "aria-label": customAriaLabel,
                        id: infoButtonId,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                            id: `${infoButtonId}-icon-notice-info`,
                            name: "notice-info"
                        })
                    })
                }),
                toggle && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$TooltipJSX, {
                    title: title,
                    linkDecoration: linkDecoration,
                    linkText: linkText,
                    linkUrl: linkUrl,
                    shown: toggle,
                    onClose: handleClose,
                    targetId: infoButtonId,
                    id: tooltipId,
                    placement: placement,
                    customAnchorId: `${infoButtonId}-icon-notice-info`,
                    align: align,
                    classes: "axiom-infoTooltip--tooltip",
                    children: children
                })
            ]
        })
    });
};
$558a1874964eed3d$var$InfoTooltip$1.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    linkDecoration: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'underline',
        'none'
    ]),
    linkText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    linkUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    placement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'auto',
        'above',
        'center',
        'below'
    ]),
    align: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'auto',
        'left',
        'center',
        'right'
    ]),
    customAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$InfoTooltipJSX = $558a1874964eed3d$var$InfoTooltip$1;
var $558a1874964eed3d$export$dbdcde5ca046596e = function(_a) {
    var title = _a.title, children = _a.children, _b = _a.linkDecoration, linkDecoration = _b === void 0 ? 'underline' : _b, _c = _a.linkText, linkText = _c === void 0 ? undefined : _c, _d = _a.linkUrl, linkUrl = _d === void 0 ? undefined : _d, _e = _a.placement, placement = _e === void 0 ? 'auto' : _e, _f = _a.align, align = _f === void 0 ? 'auto' : _f, _g = _a.customAriaLabel, customAriaLabel = _g === void 0 ? 'Activate Info Tooltip' : _g, _h = _a.classes, classes = _h === void 0 ? [] : _h;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$InfoTooltipJSX, {
        title: title,
        linkDecoration: linkDecoration,
        linkText: linkText,
        linkUrl: linkUrl,
        placement: placement,
        align: align,
        customAriaLabel: customAriaLabel,
        classes: classes,
        children: children
    });
};
$558a1874964eed3d$export$dbdcde5ca046596e.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]).isRequired,
    linkDecoration: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'underline',
        'none'
    ]),
    linkText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    linkUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    placement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'auto',
        'above',
        'center',
        'below'
    ]),
    align: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'auto',
        'left',
        'center',
        'right'
    ]),
    customAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$InlineNotification$1 = ({ text: text, type: type = 'informational', onClose: onClose = null, link: link, altText: altText, classes: classes = [] })=>{
    let iconName;
    switch(type){
        case 'alert':
            iconName = 'notice-warning';
            break;
        case 'confirmation':
            iconName = 'checkmark-circle';
            break;
        case 'error':
            iconName = 'notice-error';
            break;
        default:
            iconName = 'notice-info';
            break;
    }
    const a11yText = altText || `${type} notification`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        role: "alert",
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-inline-notification',
                'inline-notification',
                `inline-notification--type--${type}`
            ],
            custom: classes,
            required: []
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                name: iconName,
                seenByAssistiveTechnology: true,
                altText: a11yText
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "axiom-inline-notification--text inline-notification-text",
                children: [
                    text,
                    link && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "axiom-inline-notification--link inline-notification--link",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$LinkJSX, {
                            href: link.linkUrl,
                            newWindow: true,
                            children: link.linkText
                        })
                    })
                ]
            }),
            onClose && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                "data-testid": "inline-notification-close-button",
                "aria-label": "dismiss notification",
                className: "axiom-inline-notification--button--close close-button",
                onClick: onClose,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                    name: "close"
                })
            })
        ]
    });
};
$558a1874964eed3d$var$InlineNotification$1.propTypes = {
    text: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]).isRequired,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'informational',
        'alert',
        'confirmation',
        'error'
    ]),
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    link: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        linkText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        linkUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    }),
    altText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$InlineNotificationJSX = $558a1874964eed3d$var$InlineNotification$1;
var $558a1874964eed3d$export$cae1c58733dbe1ed = function(_a) {
    var text = _a.text, _b = _a.type, type = _b === void 0 ? 'informational' : _b, _c = _a.onClose, onClose = _c === void 0 ? null : _c, _d = _a.link, link = _d === void 0 ? undefined : _d, _e = _a.altText, altText = _e === void 0 ? undefined : _e, _f = _a.classes, classes = _f === void 0 ? [] : _f;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$InlineNotificationJSX, {
        text: text,
        type: type,
        onClose: onClose,
        link: link,
        altText: altText,
        classes: classes
    });
};
$558a1874964eed3d$export$cae1c58733dbe1ed.propTypes = {
    text: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]).isRequired,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'informational',
        'alert',
        'confirmation',
        'error'
    ]),
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    link: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        linkText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        linkUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    }),
    altText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$export$b04be29aa201d4f5 = function(_a) {
    var label = _a.label, labelForId = _a.labelForId, _b = _a.error, error = _b === void 0 ? undefined : _b, _c = _a.hideLabel, hideLabel = _c === void 0 ? false : _c, _d = _a.labelModifier, labelModifier = _d === void 0 ? null : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? undefined : _e, _f = _a.className, className = _f === void 0 ? undefined : _f, _g = _a.classes, classes = _g === void 0 ? [] : _g, _h = _a.labelClickHandler, labelClickHandler = _h === void 0 ? undefined : _h;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$LabelJSX, {
        error: error,
        hideLabel: hideLabel,
        label: label,
        labelForId: labelForId,
        labelModifier: labelModifier,
        ariaLabel: ariaLabel,
        className: className,
        labelClickHandler: labelClickHandler,
        classes: classes
    });
};
$558a1874964eed3d$export$b04be29aa201d4f5.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    labelForId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    labelClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
/**
 * Returns the rendering order of the chart's series (data groups)
 * 
 * @param {Object} data: The raw used to calculate the data range of the DataViz component
 * @param {Array<{
 *    id: String,
 *    label: String
 * }>} valueFieldList: A normalized list of value fields (usually passed in from the initializeValueFields() function)
 * 
 * @returns {Array<{
 *    id: String,
 *    label: String,
 *    maxValue: number 
 * }>}
 */ const $558a1874964eed3d$var$getSeriesRenderOrder = (data, valueFieldList)=>valueFieldList.map((valueField)=>{
        const { id: id } = valueField;
        const fieldValues = data.map((dataRow)=>dataRow[id]);
        return {
            ...valueField,
            maxValue: Math.max(...fieldValues)
        };
    }).sort((a, b)=>b.maxValue - a.maxValue);
const $558a1874964eed3d$var$CHART_WIDTH_PADDING = 20;
const $558a1874964eed3d$var$LineChart$1 = ({ data: data, labelField: labelField, valueFields: valueFields, title: title, description: description, valueType: valueType = 'number', figureAlt: figureAlt, range: range = {
    min: undefined,
    max: undefined
}, xAxisLabel: xAxisLabel, yAxisLabel: yAxisLabel, height: height = 400, classes: classes = [] })=>{
    const [horizontalOffset, setHorizontalOffset] = (0, $acw62.useState)(0);
    const [horizontalLabels, setHorizontalLabels] = (0, $acw62.useState)([]);
    const [verticalOffset, setVerticalOffset] = (0, $acw62.useState)(0);
    const [verticalLabels, setVerticalLabels] = (0, $acw62.useState)([]);
    const figureRef = (0, $acw62.useRef)();
    const plotRef = (0, $acw62.useRef)();
    const horizontalLabelRef = (0, $acw62.useRef)();
    const verticalLabelRef = (0, $acw62.useRef)();
    const valueFieldList = $558a1874964eed3d$var$initializeValueFields(valueFields);
    const seriesRenderOrder = $558a1874964eed3d$var$getSeriesRenderOrder(data, valueFieldList);
    const plotRange = $558a1874964eed3d$var$getAdjustedRange({
        data: data,
        range: range,
        valueFields: valueFields,
        valueType: valueType
    });
    const chartMetadata = $558a1874964eed3d$var$getChartMetadata({
        data: data,
        labelField: labelField,
        valueFields: valueFields,
        height: height,
        horizontalLabels: horizontalLabels,
        horizontalOffset: horizontalOffset,
        verticalOffset: verticalOffset,
        verticalLabels: verticalLabels,
        adjustedRange: plotRange,
        chartPadding: $558a1874964eed3d$var$CHART_WIDTH_PADDING
    });
    const setPlotDimensions = ()=>{
        setHorizontalOffset(horizontalLabelRef.current.getBoundingClientRect().x);
        setVerticalOffset(verticalLabelRef.current.getBoundingClientRect().y);
        setHorizontalLabels(Array.from(figureRef.current.querySelectorAll('.data-viz--horizontal-label')).map((domColumn)=>domColumn.getBoundingClientRect()));
        setVerticalLabels(Array.from(figureRef.current.querySelectorAll('.data-viz--vertical-label')).map((domColumn)=>domColumn.getBoundingClientRect()));
    };
    (0, $acw62.useEffect)(setPlotDimensions, [
        plotRef.current,
        xAxisLabel,
        yAxisLabel,
        data
    ]);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener('resize', setPlotDimensions);
        return ()=>{
            window.removeEventListener('resize', setPlotDimensions);
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        ref: figureRef,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-line-chart',
                'line-chart',
                'data-viz'
            ],
            custom: classes,
            required: []
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "axiom-line-chart--legend data-viz--legend",
                "aria-hidden": "false",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$DataVizLegend$1, {
                        title: title,
                        description: description
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-line-chart--legend-keys data-viz--legend-keys",
                        children: $558a1874964eed3d$var$renderLegend(valueFields, 'line')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                ref: verticalLabelRef,
                className: "axiom-line-chart--y-labels data-viz--y-labels",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-line-chart--y-title data-viz--y-title",
                        children: yAxisLabel
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-line-chart--vertical-labels data-viz--vertical-labels",
                        children: chartMetadata.yLabels.map((yLabel)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "axiom-line-chart--vertical-label data-viz--vertical-label",
                                children: yLabel.value
                            }, `data-viz--vertical-label-${yLabel.value}`))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "img",
                className: "axiom-line-chart--plot data-viz--plot",
                "aria-label": figureAlt,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    ref: plotRef,
                    height: height,
                    style: {
                        height: `${height}px`
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        transform: `scale(1 -1) translate(0 -${height})`,
                        children: [
                            chartMetadata.yLabels.map((yLabel)=>/*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                    className: "axiom-line-chart--horizontal-line data-viz--horizontal-line",
                                    x1: "0%",
                                    x2: "100%",
                                    y1: yLabel.position,
                                    y2: yLabel.position
                                }, `data-viz--horizontal-line-${yLabel.value}`)),
                            seriesRenderOrder.map((seriesField)=>{
                                const index = valueFieldList.findIndex((field)=>field.id === seriesField.id);
                                return $558a1874964eed3d$var$renderPlotLine({
                                    field: seriesField,
                                    index: index,
                                    plotPoints: chartMetadata.plotPoints
                                });
                            })
                        ]
                    }, 'data-viz--origin-transform')
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                ref: horizontalLabelRef,
                className: "axiom-line-chart--x-labels data-viz--x-labels",
                style: {
                    padding: `0 ${$558a1874964eed3d$var$CHART_WIDTH_PADDING}px`
                },
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-line-chart--horizontal-labels data-viz--horizontal-labels",
                        children: chartMetadata.xLabels.map((xLabel)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "axiom-line-chart--horizontal-label data-viz--horizontal-label",
                                children: xLabel
                            }, `data-viz--horizontal-label-${xLabel}`))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-line-chart--x-title data-viz--x-title",
                        children: xAxisLabel || labelField
                    })
                ]
            })
        ]
    });
};
$558a1874964eed3d$var$LineChart$1.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any).isRequired,
    labelField: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    valueFields: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ])).isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            headingSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                1,
                2,
                3,
                4,
                5,
                6
            ]),
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ]),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
        })
    ]),
    valueType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'percent',
        'dollar',
        'number'
    ]),
    figureAlt: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    range: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        min: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                expansionRule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                    'strict',
                    'loose'
                ])
            })
        ]),
        max: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                expansionRule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                    'strict',
                    'loose'
                ])
            })
        ])
    }),
    xAxisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    yAxisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$LineChartJSX = $558a1874964eed3d$var$LineChart$1;
var $558a1874964eed3d$export$54d0e8420ac838ac = function(_a) {
    var data = _a.data, labelField = _a.labelField, valueFields = _a.valueFields, _b = _a.title, title = _b === void 0 ? undefined : _b, _c = _a.description, description = _c === void 0 ? undefined : _c, _d = _a.valueType, valueType = _d === void 0 ? 'number' : _d, figureAlt = _a.figureAlt, _e = _a.range, range = _e === void 0 ? {
        min: undefined,
        max: undefined
    } : _e, _f = _a.xAxisLabel, xAxisLabel = _f === void 0 ? undefined : _f, _g = _a.yAxisLabel, yAxisLabel = _g === void 0 ? undefined : _g, _h = _a.height, height = _h === void 0 ? 400 : _h, _j = _a.classes, classes = _j === void 0 ? [] : _j;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$LineChartJSX, {
        title: title,
        description: description,
        data: data,
        labelField: labelField,
        valueFields: valueFields,
        valueType: valueType,
        figureAlt: figureAlt,
        range: range,
        xAxisLabel: xAxisLabel,
        yAxisLabel: yAxisLabel,
        height: height,
        classes: classes
    });
};
$558a1874964eed3d$export$54d0e8420ac838ac.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any).isRequired,
    labelField: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    valueFields: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ])).isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            headingSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                1,
                2,
                3,
                4,
                5,
                6
            ]),
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ]),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
        })
    ]),
    valueType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'percent',
        'dollar',
        'number'
    ]),
    figureAlt: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    range: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        min: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                expansionRule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                    'strict',
                    'loose'
                ])
            })
        ]),
        max: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                expansionRule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                    'strict',
                    'loose'
                ])
            })
        ])
    }),
    xAxisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    yAxisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$export$a6c7ac8248d6e38a = function(_a) {
    var children = _a.children, _b = _a.href, href = _b === void 0 ? undefined : _b, _c = _a.newWindow, newWindow = _c === void 0 ? false : _c, _d = _a.utilityFunction, utilityFunction = _d === void 0 ? undefined : _d, _e = _a.hideUnderline, hideUnderline = _e === void 0 ? false : _e, _f = _a.attributes, attributes = _f === void 0 ? {} : _f, _g = _a.onClick, onClick = _g === void 0 ? undefined : _g, _h = _a.configObj, configObj = _h === void 0 ? {} : _h, _j = _a.classes, classes = _j === void 0 ? [] : _j;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$LinkJSX, {
        href: href,
        newWindow: newWindow,
        hideUnderline: hideUnderline,
        onClick: onClick,
        utilityFunction: utilityFunction,
        configObj: configObj,
        classes: classes,
        attributes: attributes,
        children: children
    });
};
$558a1874964eed3d$export$a6c7ac8248d6e38a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    newWindow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    hideUnderline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    utilityFunction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'window',
        'ums',
        'pdf',
        'relWkspc'
    ]),
    configObj: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$CYCLE_DURATION = 1500;
const $558a1874964eed3d$var$ASSIST_TEXT_DURATION = 10000;
const $558a1874964eed3d$var$CENTER_POSITION = 50;
const $558a1874964eed3d$var$DEGREE_SHIFT = -90;
const $558a1874964eed3d$var$INNER_STROKE_WIDTH = 4;
const $558a1874964eed3d$var$OUTER_STROKE_WIDTH = 12;
const $558a1874964eed3d$var$RADIUS = $558a1874964eed3d$var$CENTER_POSITION - $558a1874964eed3d$var$OUTER_STROKE_WIDTH / 2;
const $558a1874964eed3d$var$easeInOut = (progress)=>{
    // Harmonic Angle is limited between sin of [±90deg] or [±0.5PI rad]
    const harmonicAngle = (progress - 0.5) * Math.PI;
    // Shift output of sin(x) up by 1 so the resulting value range is [0,2]
    const sineShift = Math.sin(harmonicAngle) + 1;
    // Compress sineShift by half to get final progress range of [0,1]
    return sineShift / 2;
};
const $558a1874964eed3d$var$getCartisianCoordinates = (angleInDegrees, isGrowing)=>{
    const angleInRadians = angleInDegrees * Math.PI / 180;
    const posX = $558a1874964eed3d$var$CENTER_POSITION + $558a1874964eed3d$var$RADIUS * Math.cos(angleInRadians);
    const posY = $558a1874964eed3d$var$CENTER_POSITION + $558a1874964eed3d$var$RADIUS * Math.sin(angleInRadians);
    if (isGrowing) return {
        x: posX,
        y: posY
    };
    return {
        // reflect X across the center
        x: $558a1874964eed3d$var$CENTER_POSITION * 2 - posX,
        y: posY
    };
};
const $558a1874964eed3d$var$getTrackData = (angle, isGrowing)=>{
    const startPoint = $558a1874964eed3d$var$getCartisianCoordinates($558a1874964eed3d$var$DEGREE_SHIFT, isGrowing);
    const endPoint = $558a1874964eed3d$var$getCartisianCoordinates(angle + $558a1874964eed3d$var$DEGREE_SHIFT, isGrowing);
    const trackData = new $558a1874964eed3d$var$PathBuilder$1();
    trackData.moveTo(startPoint);
    if (angle <= 180) trackData.createArc(endPoint, $558a1874964eed3d$var$RADIUS, {
        rotateClockwise: isGrowing
    });
    else {
        const midPoint = $558a1874964eed3d$var$getCartisianCoordinates(180 + $558a1874964eed3d$var$DEGREE_SHIFT, $558a1874964eed3d$var$RADIUS);
        trackData.createArc(midPoint, $558a1874964eed3d$var$RADIUS, {
            rotateClockwise: isGrowing
        }).createArc(endPoint, $558a1874964eed3d$var$RADIUS, {
            rotateClockwise: isGrowing
        });
    }
    return trackData.getPath();
};
const $558a1874964eed3d$var$LoadingSpinner = ({ id: id = null, percent: percent, classes: classes = [], attributes: attributes = {}, assistiveText: assistiveText = 'loading' })=>{
    const animatorRef = (0, $acw62.useRef)();
    const startTimeRef = (0, $acw62.useRef)();
    const [innerTrackData, setInnerTrackData] = (0, $acw62.useState)('');
    const [outerTrackData, setOuterTrackData] = (0, $acw62.useState)('');
    const [currentAssistiveText, setCurrentAssistiveText] = (0, $acw62.useState)(Array.isArray(assistiveText) ? assistiveText[0] : assistiveText);
    const animate = (time)=>{
        if (startTimeRef.current === undefined) startTimeRef.current = time;
        const timePassed = time - startTimeRef.current;
        const innerProgress = timePassed < $558a1874964eed3d$var$CYCLE_DURATION ? $558a1874964eed3d$var$easeInOut(timePassed / $558a1874964eed3d$var$CYCLE_DURATION) : 1;
        const outerProgressionStep = timePassed % (2 * $558a1874964eed3d$var$CYCLE_DURATION) - $558a1874964eed3d$var$CYCLE_DURATION;
        const outerProgress = timePassed < $558a1874964eed3d$var$CYCLE_DURATION ? 0 : $558a1874964eed3d$var$easeInOut(Math.abs(outerProgressionStep) / $558a1874964eed3d$var$CYCLE_DURATION);
        const isGrowing = Math.sign(outerProgressionStep) !== -1;
        const innerTrackAngle = innerProgress * 360;
        const outerTrackAngle = outerProgress * 360;
        setInnerTrackData($558a1874964eed3d$var$getTrackData(innerTrackAngle, true));
        setOuterTrackData($558a1874964eed3d$var$getTrackData(outerTrackAngle, isGrowing));
        animatorRef.current = requestAnimationFrame(animate);
    };
    (0, $acw62.useEffect)(()=>{
        animatorRef.current = requestAnimationFrame(animate);
        return ()=>cancelAnimationFrame(animatorRef.current);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (Array.isArray(assistiveText) && assistiveText.length > 1) setTimeout(()=>{
            const newIndex = assistiveText.indexOf(currentAssistiveText) + 1;
            const newAssistiveText = newIndex < assistiveText.length ? assistiveText[newIndex] : assistiveText[0];
            setCurrentAssistiveText(newAssistiveText);
            return newAssistiveText;
        }, $558a1874964eed3d$var$ASSIST_TEXT_DURATION);
    }, [
        currentAssistiveText
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        id: id,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-loading-spinner',
                'loading-spinner'
            ],
            custom: classes,
            required: []
        }),
        ...attributes,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                id: "loading-spinner-assistive-text",
                className: "loading-spinner--assistive-text screen-reader-only",
                "aria-live": "polite",
                children: currentAssistiveText
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 100 100",
                "aria-hidden": "true",
                children: [
                    typeof percent === 'number' && /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        className: "axiom-loading-spinner--percentage loading-spinner--percentage",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                className: "axiom-loading-spinner--percentage-background loading-spinner--percentage-background",
                                cx: "50",
                                cy: "50",
                                r: $558a1874964eed3d$var$RADIUS
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("text", {
                                className: "axiom-loading-spinner--percentage-value loading-spinner--percentage-value",
                                alignmentBaseline: "central",
                                textAnchor: "middle",
                                x: "50",
                                y: "50",
                                children: [
                                    percent,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "axiom-loading-spinner--inner-track loading-spinner--inner-track",
                        fill: "none",
                        strokeWidth: `${$558a1874964eed3d$var$INNER_STROKE_WIDTH}px`,
                        d: innerTrackData
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "axiom-loading-spinner--outer-track loading-spinner--outer-track",
                        fill: "none",
                        strokeWidth: `${$558a1874964eed3d$var$OUTER_STROKE_WIDTH}px`,
                        d: outerTrackData
                    })
                ]
            })
        ]
    });
};
$558a1874964eed3d$var$LoadingSpinner.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    percent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    assistiveText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$AppSpinnerJSX = $558a1874964eed3d$var$LoadingSpinner;
var $558a1874964eed3d$export$b08b517936747730 = function(_a) {
    var _b = _a.id, id = _b === void 0 ? null : _b, _c = _a.percent, percent = _c === void 0 ? undefined : _c, _d = _a.classes, classes = _d === void 0 ? [] : _d, _e = _a.attributes, attributes = _e === void 0 ? {} : _e, _f = _a.assistiveText, assistiveText = _f === void 0 ? 'loading' : _f;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$AppSpinnerJSX, {
        id: id,
        percent: percent,
        classes: classes,
        attributes: attributes,
        assistiveText: assistiveText
    });
};
$558a1874964eed3d$export$b08b517936747730.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    percent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    assistiveText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
/* eslint-disable no-nested-ternary */ const $558a1874964eed3d$var$MaskedInput$1 = ({ id: id, label: label, name: name, value: value, onChange: onChange, labelModifier: labelModifier, disabled: disabled = false, readOnly: readOnly = false, error: error, customMaskHelperText: customMaskHelperText, onKeyDown: onKeyDown, customMask: customMask, maskType: maskType, inputRef: inputRef, locale: locale, onBlur: onBlur, hideLabel: hideLabel = false, onFocus: onFocus, ariaLabel: ariaLabel, condensed: condensed = false, classes: modifierClasses = [] })=>{
    const [isFocusOut, setIsFocusOut] = (0, $acw62.useState)(true);
    const [inputValue, setInputValue] = (0, $acw62.useState)(value);
    const formatUserInput = (userInput)=>{
        let formattedValue = userInput;
        if (formattedValue !== undefined && maskType === 'phone') formattedValue = userInput.split('-').join('');
        return formattedValue;
    };
    const handleOnChange = (e)=>{
        setInputValue(e.target.value);
        if (onChange) onChange(formatUserInput(e.target.value));
    };
    const handleOnBlur = (e)=>{
        setIsFocusOut(true);
        setInputValue(e.target.value);
        if (onBlur) {
            onBlur(formatUserInput(e.target.value));
            return;
        }
        if (onChange) onChange(formatUserInput(e.target.value));
    };
    const handleFocus = ()=>{
        if (onFocus) onFocus();
        setIsFocusOut(false);
    };
    let maskFormat;
    let helperText;
    let screenReaderDateFormat;
    let tempValue = value;
    let formatChars = {
        '9': '[0-9]',
        'a': '[A-Za-z]',
        '*': '[A-Za-z0-9]'
    };
    if (customMask) {
        maskFormat = customMask;
        helperText = customMaskHelperText;
    }
    if (maskType === 'phone') {
        maskFormat = '999-999-9999';
        helperText = 'Format as 123-456-7890';
    }
    if (maskType === 'ssn') {
        maskFormat = '999-99-9999'; // TS says this is useless
        helperText = 'Format entry as 123-45-6789';
        /*
    below logic is to,
    (if) hide first 5 numbers while focus-out from input.
    (else) show all numbers while focus-in to input.
    */ if (inputValue && inputValue.split('-').length === 3 && isFocusOut) {
            maskFormat = 'XXX-XX-9999';
            tempValue = `XXX-XX-${inputValue.split('-')[2]}`;
        } else {
            maskFormat = '999-99-9999';
            tempValue = inputValue;
        }
    }
    if (maskType === 'sin') {
        maskFormat = '999-999-999'; // TS says this is useless
        helperText = 'Format entry as 123-456-789';
        /*
    below logic is to,
    (if) hide first 6 numbers while focus-out from input.
    (else) show all numbers while focus-in to input.
    */ if (inputValue && inputValue.split('-').length === 3 && isFocusOut) {
            maskFormat = 'XXX-XXX-999';
            tempValue = `XXX-XX-${inputValue.split('-')[2]}`;
        } else {
            maskFormat = '999-999-999';
            tempValue = inputValue;
        }
    }
    if (maskType === 'date') {
        formatChars = {
            1: '[0-1]',
            2: '[0-2]',
            3: '[0-3]',
            9: '[0-9]'
        };
        if (locale === 'US' || locale === 'en-us') {
            maskFormat = '19/39/2999';
            helperText = `Format entry as mm/dd/yyyy`;
            screenReaderDateFormat = 'Format entry as a 2 digit month slash 2 digit day slash 4 digit year';
        }
        if (locale === 'CA' || locale === 'en-ca') {
            maskFormat = '39/19/2999';
            helperText = `Format entry as dd/mm/yyyy`;
            screenReaderDateFormat = 'Format entry as a 2 digit day slash 2 digit month slash 4 digit year';
        }
    }
    const setInputRef = (el)=>{
        if (!inputRef) return;
        inputRef.current = el;
    };
    const normalizedPropClasses = modifierClasses instanceof Array ? modifierClasses : [
        modifierClasses
    ];
    const controllerClasses = [
        'axiom-masked-input',
        ...normalizedPropClasses
    ];
    const wrapperClasses = condensed ? `axiom-masked-input--input-wrap--condensed input-control--input--wrap--condensed` : 'axiom-masked-input--input-wrap input-control--input--wrap';
    const inputClasses = readOnly ? 'axiom-masked-input--input read-only' : 'axiom-masked-input--input';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$InputControl$1, {
        id: id,
        classes: controllerClasses,
        label: label,
        labelModifier: labelModifier,
        error: error,
        microcopy: helperText,
        hideLabel: hideLabel,
        ariaLabel: ariaLabel,
        condensed: condensed,
        microcopyScreenReader: screenReaderDateFormat,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            "data-testid": "wrap",
            className: wrapperClasses,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dHBXt))), {
                id: id,
                "data-testid": "maskedInput",
                name: name,
                value: tempValue,
                formatChars: formatChars,
                mask: maskFormat,
                maskChar: "",
                onChange: handleOnChange,
                onBlur: handleOnBlur,
                onFocus: handleFocus,
                onKeyDown: onKeyDown,
                disabled: disabled,
                "aria-required": labelModifier === 'required',
                "aria-invalid": error ? true : null,
                "aria-describedby": error || customMaskHelperText || maskType !== 'date' ? `${id}_messages` : maskType === 'date' && screenReaderDateFormat !== undefined ? `${id}-microcopy-sr-only` : null,
                className: inputClasses,
                readOnly: readOnly,
                alwaysShowMask: false,
                inputRef: setInputRef
            })
        })
    });
};
$558a1874964eed3d$var$MaskedInput$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    customMask: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    customMaskHelperText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    maskType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'date',
        'phone',
        'ssn',
        'sin'
    ]),
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'CA',
        'US',
        'en-ca',
        'en-us'
    ]),
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$MaskedInputJSX = $558a1874964eed3d$var$MaskedInput$1;
var $558a1874964eed3d$export$dec03dc0f3ef8025 = function(_a) {
    var id = _a.id, label = _a.label, name = _a.name, value = _a.value, onChange = _a.onChange, _b = _a.labelModifier, labelModifier = _b === void 0 ? undefined : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.readOnly, readOnly = _d === void 0 ? false : _d, _e = _a.error, error = _e === void 0 ? undefined : _e, _f = _a.customMaskHelperText, customMaskHelperText = _f === void 0 ? undefined : _f, _g = _a.onKeyDown, onKeyDown = _g === void 0 ? undefined : _g, _h = _a.customMask, customMask = _h === void 0 ? undefined : _h, _j = _a.maskType, maskType = _j === void 0 ? undefined : _j, _k = _a.inputRef, inputRef = _k === void 0 ? undefined : _k, _l = _a.locale, locale = _l === void 0 ? undefined : _l, _m = _a.onBlur, onBlur = _m === void 0 ? undefined : _m, _o = _a.hideLabel, hideLabel = _o === void 0 ? false : _o, _p = _a.onFocus, onFocus = _p === void 0 ? undefined : _p, _q = _a.ariaLabel, ariaLabel = _q === void 0 ? undefined : _q, _r = _a.condensed, condensed = _r === void 0 ? false : _r, _s = _a.classes, classes = _s === void 0 ? [] : _s;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$MaskedInputJSX, {
        id: id,
        classes: classes,
        label: label,
        name: name,
        value: value,
        labelModifier: labelModifier,
        disabled: disabled,
        readOnly: readOnly,
        error: error,
        customMaskHelperText: customMaskHelperText,
        onChange: onChange,
        onKeyDown: onKeyDown,
        customMask: customMask,
        maskType: maskType,
        inputRef: inputRef,
        locale: locale,
        onBlur: onBlur,
        hideLabel: hideLabel,
        onFocus: onFocus,
        ariaLabel: ariaLabel,
        condensed: condensed
    });
};
$558a1874964eed3d$export$dec03dc0f3ef8025.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    customMask: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    customMaskHelperText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    maskType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'date',
        'phone',
        'ssn',
        'sin'
    ]),
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'CA',
        'US',
        'en-ca',
        'en-us'
    ]),
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$NextLink$1 = ({ children: children, href: href, classes: classes = [] })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
        href: href,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-link--next',
                'link--next'
            ],
            custom: classes,
            required: []
        }),
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                name: "chevron-right"
            })
        ]
    });
$558a1874964eed3d$var$NextLink$1.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$NextLinkJSX = $558a1874964eed3d$var$NextLink$1;
var $558a1874964eed3d$export$982d939ae07866bf = function(_a) {
    var children = _a.children, href = _a.href, _b = _a.classes, classes = _b === void 0 ? [] : _b;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$NextLinkJSX, {
        href: href,
        classes: classes,
        children: children
    });
};
$558a1874964eed3d$export$982d939ae07866bf.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$VALID_KEYS_REGEX = /[-\d.]/;
const $558a1874964eed3d$var$TRAILING_ZEROS_REGEX = /(\.\d*0|\.)$/;
const $558a1874964eed3d$var$UNIT_VALUE_MAX_LENGTH = 15;
const $558a1874964eed3d$var$nthMatch = (string, pattern, n)=>{
    let nthIndex = 0;
    return Array.from(string).findIndex((char)=>{
        nthIndex += pattern.test(char);
        return nthIndex === n;
    });
};
/**
 For further guidance on the NumberInput component, please visit the
   <a target="_blank" href="http://hqcontent.edwardjones.com/GUI/guisite/axiom-ds/components/form/text-input" class="axiom-link"> AXIOM</a>
    documentation site.
   <br/>
   <br/>
 Sentence style, no colon at the end.

####Required fields

- If all fields are required, state at the top of the form “All required.”
- If only some fields are required, add an asterisk before the label and a note at the top of the
form “* Required.”
- If most of the fields are required but a few are optional, include “(optional)” after the field
label.
* */ const $558a1874964eed3d$var$NumberInput$1 = ({ id: id, name: name, label: label, precision: precision, onChange: onChange, rounded: rounded, classes: modifierClasses = [], type: type = 'numeric', value: value = '', labelModifier: labelModifier, disabled: disabled = false, readOnly: readOnly = false, error: error, microcopy: microcopy, onBlur: onBlur, inputRef: inputRefProp, hideLabel: hideLabel = false, formatted: formattedProp, attributes: attributes = {}, condensed: condensed = false })=>{
    const internalInputRef = (0, $acw62.useRef)();
    const isMounted = $558a1874964eed3d$var$useIsMounted$1();
    const inputRef = inputRefProp || internalInputRef;
    const formatted = typeof formattedProp === 'undefined' ? type !== 'numeric' : formattedProp;
    const getDefaultValueSegments = ()=>{
        const stringValue = typeof value !== 'undefined' && value !== null ? value.toString() : '';
        const rawValue = value === null ? '' : $558a1874964eed3d$var$getNumericStringValue(stringValue);
        let roundedValue = $558a1874964eed3d$var$preciseRound(rawValue, precision);
        if ([
            null,
            Number.NaN
        ].includes(roundedValue)) roundedValue = '';
        let displayedValue = rounded && typeof roundedValue === 'number' ? roundedValue.toFixed(precision) : roundedValue.toString();
        const wholeNumberValue = displayedValue.split('.')[0];
        const decimalValue = rawValue.match($558a1874964eed3d$var$TRAILING_ZEROS_REGEX);
        // If the string contains trailing zeroes, maintain it for the input so that the number parser doesn't truncate the number prematurely
        if (decimalValue) displayedValue = wholeNumberValue + decimalValue[0];
        return displayedValue.split('.', 2);
    };
    const [valueSegments, setValueSegments] = (0, $acw62.useState)(getDefaultValueSegments());
    const [caretPosition, setCaretPosition] = (0, $acw62.useState)(null);
    let inputMode = type;
    if ([
        'currency',
        'percent'
    ].includes(type)) inputMode = 'decimal';
    const getValue = ()=>$558a1874964eed3d$var$getRawValue(valueSegments.join('.'));
    const getFormattedValue = (segments, formatType, showPrecision = false)=>{
        let formattedValueSegments = [
            ...segments
        ];
        if (formatted) {
            const textValue = formattedValueSegments.join('.');
            if (![
                '.',
                '-',
                '-.'
            ].includes(textValue)) {
                const decimalValue = $558a1874964eed3d$var$getRawValue(segments[1]);
                const decimalText = Number.isNaN(decimalValue) ? '' : String(segments[1].replace(/[^\d]/g, ''));
                const displayPrecision = showPrecision ? precision : decimalText.length;
                const rawValue = $558a1874964eed3d$var$getRawValue(textValue);
                formattedValueSegments = $558a1874964eed3d$var$formatValue(rawValue, formatType, displayPrecision).split('.', 2);
            }
        }
        const formattedValue = formattedValueSegments.join('.');
        if (!$558a1874964eed3d$var$VALID_KEYS_REGEX.test(formattedValue)) return '';
        if (segments[0] === '') {
            if (type === 'currency') formattedValueSegments[0] = '$';
            else formattedValueSegments[0] = '';
        }
        if (segments[1] === '') {
            if (type === 'percent') {
                formattedValueSegments[0] = formattedValueSegments[0].replace('%', '');
                formattedValueSegments[1] = '%';
            } else formattedValueSegments[1] = '';
        }
        return formattedValueSegments.join('.');
    };
    (0, $acw62.useEffect)(()=>{
        if (isMounted) setValueSegments(getDefaultValueSegments());
    }, [
        value
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMounted) onChange(getFormattedValue(valueSegments, type));
    }, [
        valueSegments
    ]);
    (0, $acw62.useEffect)(()=>{
        if (caretPosition !== null) /* istanbul ignore next */ window.requestAnimationFrame(()=>{
            if (inputRef.current) inputRef.current.setSelectionRange(caretPosition.start, caretPosition.end);
        });
    }, [
        caretPosition
    ]);
    const handleDataRemoval = (editorCaret, pressedKey)=>{
        const updatedValueSegments = [
            ...valueSegments
        ];
        const currentValue = getFormattedValue(updatedValueSegments, type);
        const currentCommaMatch = currentValue.match(/,/g);
        const currentCommaCount = currentCommaMatch === null ? 0 : currentCommaMatch.length;
        /**
     * 2023-04: Replaced the line below with a regular expression literal to satisfy ESLint rule 'prefer-regex-literals'
     *
     * .replace(new RegExp('[^/]', 'g'), ''),
     */ const newValue = {
            start: currentValue.substring(0, editorCaret.start),
            end: currentValue.substring(editorCaret.end),
            highlighted: currentValue.substring(editorCaret.start, editorCaret.end).replace(/[^/]/g, '')
        };
        const isDeletingBlock = editorCaret.length > 0;
        if (!isDeletingBlock) {
            if (pressedKey === 'Backspace') {
                const isDeletingDecorator = $558a1874964eed3d$var$UNIT_DECORATORS.includes(newValue.start.substr(-1));
                const deleteBy = 1 + isDeletingDecorator;
                newValue.start = newValue.start.slice(0, -1 * deleteBy);
                editorCaret.moveBy(-1 * deleteBy);
            }
            if (pressedKey === 'Delete') {
                const isDeletingDecorator = $558a1874964eed3d$var$UNIT_DECORATORS.includes(newValue.end.substr(0, 1));
                const deleteBy = 1 + isDeletingDecorator;
                newValue.end = newValue.end.slice(deleteBy);
            }
        }
        const updatedValue = `${newValue.start}${newValue.highlighted}${newValue.end}`;
        let updatedFormattedValue = getFormattedValue(String($558a1874964eed3d$var$getRawValue(updatedValue)).split('.', 2), type);
        if (updatedValue.substr(-1) === '.') updatedFormattedValue += '.';
        const updatedCommaMatch = updatedFormattedValue.match(/,/g);
        const updatedCommaCount = updatedCommaMatch === null ? 0 : updatedCommaMatch.length;
        editorCaret.moveBy(updatedCommaCount - currentCommaCount);
        editorCaret.collapse();
        const updatedSegmentValue = updatedValue.split('.', 2).map((segment)=>{
            const segmentValue = $558a1874964eed3d$var$getRawValue(segment);
            return Number.isNaN(segmentValue) && segment !== '-' ? '' : segment;
        });
        setValueSegments(updatedSegmentValue);
        setCaretPosition(editorCaret);
    };
    const handleChange = (event)=>{
        const domInput = event.target;
        const editorCaret = new $558a1874964eed3d$var$CaretManager$1(domInput);
        // Allow user to enter '-' only one time and as a first character
        const hasNegativeSign = domInput.value.replace('$', '')[0] === '-';
        const isNegativeNumber = domInput.value.length > 0 && hasNegativeSign;
        const updatedValue = (isNegativeNumber ? '-' : '') + domInput.value.replace(/[^\d.]/g, '');
        const updatedValueSegments = updatedValue.split('.', 2);
        // A number is considered an "empty" negative if the integer value has no numeric value (this can also include numbers with a decimal value)
        const isEmptyNegative = updatedValueSegments[0] === '-';
        if (formatted && typeof updatedValueSegments[0] !== 'undefined' && ![
            '',
            '-'
        ].includes(updatedValueSegments[0]) && !updatedValueSegments[0].match(/-0*$/)) {
            updatedValueSegments[0] = $558a1874964eed3d$var$getRawValue(updatedValueSegments[0]);
            if (Number.isNaN(updatedValueSegments[0])) updatedValueSegments[0] = '';
        }
        setValueSegments(updatedValueSegments);
        const prevCharacterCount = Array.from(domInput.value.substring(0, editorCaret.start)).filter((char)=>$558a1874964eed3d$var$VALID_KEYS_REGEX.test(char)).length;
        const formattedValue = getFormattedValue(updatedValueSegments, type);
        const updatedPosition = // Get the current position of the caret
        $558a1874964eed3d$var$nthMatch(formattedValue, $558a1874964eed3d$var$VALID_KEYS_REGEX, prevCharacterCount) + // Add an additional character if the number is negative with no recorded integer value and has a proper decimal value
        (isEmptyNegative && updatedValueSegments[1] !== '') + // Add the new character
        1;
        editorCaret.jumpTo(updatedPosition);
        setCaretPosition(editorCaret);
    };
    const handleBlur = ()=>{
        let rawValue = getValue();
        let updatedSegmentValue = [
            ...valueSegments
        ];
        if (rounded) {
            rawValue = $558a1874964eed3d$var$preciseRound(rawValue, precision);
            updatedSegmentValue = rawValue.toFixed(precision).split('.', 2);
            setValueSegments(updatedSegmentValue);
        }
        if (onBlur) onBlur(getFormattedValue(updatedSegmentValue, type, true));
    };
    const handleKeyPress = (event)=>{
        const domInput = event.target;
        const pressedKey = event.key;
        const isNumeric = /^[\d]$/.test(pressedKey);
        const isDecimalKey = pressedKey === '.';
        const isMinusKey = pressedKey === '-';
        const isDeleteKey = [
            'Backspace',
            'Delete'
        ].includes(pressedKey);
        const editorCaret = new $558a1874964eed3d$var$CaretManager$1(domInput);
        let suppressDefaultEvent = false;
        const val = domInput.value;
        const nonHighlightedValue = val.substring(0, editorCaret.start) + val.substring(editorCaret.end);
        if (isNumeric) {
            const numericVal = nonHighlightedValue.replace('%', '') || '';
            const valSegments = numericVal.split('.') || [];
            const unitValue = valSegments[0].replace(/[^\d.]/g, '');
            const precisionValue = valSegments[1] || '';
            const decimalPosition = numericVal.indexOf('.');
            if (precision && precisionValue.length >= precision && decimalPosition < editorCaret.start) suppressDefaultEvent = true;
            if (formatted && unitValue.length >= $558a1874964eed3d$var$UNIT_VALUE_MAX_LENGTH) suppressDefaultEvent = true;
        }
        if (isMinusKey) {
            const isNegativeNumber = nonHighlightedValue.length > 0 && nonHighlightedValue[0] === '-';
            const isCaretAtStart = editorCaret.start === 0 || type === 'currency' && editorCaret.start === 1;
            if (isNegativeNumber || !isCaretAtStart) suppressDefaultEvent = true;
        }
        if (isDecimalKey) {
            if (!precision || nonHighlightedValue.includes('.')) suppressDefaultEvent = true;
        }
        if (isDeleteKey) {
            handleDataRemoval(editorCaret, pressedKey);
            suppressDefaultEvent = true;
        }
        if (suppressDefaultEvent) {
            event.stopPropagation();
            event.preventDefault();
        }
    };
    const classes = [
        'axiom-number-input--input-wrap',
        'input-control--input--wrap'
    ];
    if (valueSegments.length) classes.push('axiom-number-input--input-wrap--has-value input-control--input--wrap--has-value');
    if (condensed) classes.push('axiom-number-input--input-wrap--condensed input-control--input--wrap--condensed');
    const formattedValue = getFormattedValue(valueSegments, type);
    const normalizedPropClasses = modifierClasses instanceof Array ? modifierClasses : [
        modifierClasses
    ];
    const controllerClasses = [
        'axiom-number-input',
        ...normalizedPropClasses
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$InputControl$1, {
        id: id,
        classes: controllerClasses,
        label: label,
        labelModifier: labelModifier,
        error: error,
        microcopy: microcopy,
        hideLabel: hideLabel,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            "data-testid": "wrap",
            className: classes.join(' '),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                id: id,
                "data-testid": "input",
                "aria-required": labelModifier === 'required',
                "aria-invalid": !!error,
                "aria-describedby": error || microcopy ? `${id}_messages` : null,
                name: name,
                value: value === null ? '' : formattedValue,
                onChange: handleChange,
                onKeyDown: handleKeyPress,
                onBlur: handleBlur,
                disabled: disabled,
                readOnly: readOnly,
                inputMode: inputMode,
                className: "axiom-number-input--input",
                ref: inputRef,
                ...attributes
            })
        })
    });
};
$558a1874964eed3d$var$NumberInput$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    precision: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    rounded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'numeric',
        'currency',
        'percent'
    ]),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    formatted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$NumberInputJSX = $558a1874964eed3d$var$NumberInput$1;
var $558a1874964eed3d$export$6bf0cd3a219bbade = function(_a) {
    var id = _a.id, name = _a.name, label = _a.label, precision = _a.precision, onChange = _a.onChange, rounded = _a.rounded, _b = _a.classes, classes = _b === void 0 ? [] : _b, _c = _a.type, type = _c === void 0 ? 'numeric' : _c, _d = _a.value, value = _d === void 0 ? '' : _d, _e = _a.labelModifier, labelModifier = _e === void 0 ? undefined : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.readOnly, readOnly = _g === void 0 ? false : _g, _h = _a.error, error = _h === void 0 ? undefined : _h, _j = _a.microcopy, microcopy = _j === void 0 ? undefined : _j, _k = _a.onBlur, onBlur = _k === void 0 ? undefined : _k, _l = _a.inputRef, inputRef = _l === void 0 ? undefined : _l, _m = _a.hideLabel, hideLabel = _m === void 0 ? false : _m, _o = _a.formatted, formatted = _o === void 0 ? undefined : _o, _p = _a.attributes, attributes = _p === void 0 ? {} : _p, _q = _a.condensed, condensed = _q === void 0 ? false : _q;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$NumberInputJSX, {
        id: id,
        classes: classes,
        label: label,
        type: type,
        name: name,
        value: value,
        precision: precision,
        labelModifier: labelModifier,
        disabled: disabled,
        readOnly: readOnly,
        error: error,
        microcopy: microcopy,
        onBlur: onBlur,
        onChange: onChange,
        inputRef: inputRef,
        hideLabel: hideLabel,
        rounded: rounded,
        formatted: formatted,
        attributes: attributes,
        condensed: condensed
    });
};
$558a1874964eed3d$export$6bf0cd3a219bbade.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    precision: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    rounded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'numeric',
        'currency',
        'percent'
    ]),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    formatted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$PreviousLink$1 = ({ href: href, children: children, classes: classes = [] })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
        href: href,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-link--previous',
                ' link--previous'
            ],
            custom: classes,
            required: []
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                name: "chevron-left"
            }),
            children
        ]
    });
$558a1874964eed3d$var$PreviousLink$1.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$PreviousLinkJSX = $558a1874964eed3d$var$PreviousLink$1;
var $558a1874964eed3d$export$8ae346ca63cca3ae = function(_a) {
    var href = _a.href, children = _a.children, _b = _a.classes, classes = _b === void 0 ? [] : _b;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$PreviousLinkJSX, {
        href: href,
        classes: classes,
        children: children
    });
};
$558a1874964eed3d$export$8ae346ca63cca3ae.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$renderCircle = (strokeWidth, includeFill = false)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 50 50",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fff",
                d: "M0 0h50v50H0z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "25",
                cy: "25",
                r: 25 - strokeWidth / 2,
                stroke: "currentColor",
                fill: includeFill ? 'currentColor' : 'none',
                strokeWidth: strokeWidth
            })
        ]
    });
const $558a1874964eed3d$var$renderCheck = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 20 20",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fff",
                d: "M0 0h20v20H0z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "3",
                d: "M2.962 11.436l2.873 4.083c.235.334.597.534.987.545.39.011.764-.167 1.016-.484l9.2-11.644"
            })
        ]
    });
const $558a1874964eed3d$var$renderIcon = (obj)=>{
    switch(true){
        case obj.prev:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                name: "chevron-left"
            });
        case obj.next:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                name: "chevron-right"
            });
        case obj.isActive:
            return $558a1874964eed3d$var$renderCircle(7, true);
        case obj.hasLine:
            return $558a1874964eed3d$var$renderCheck();
        default:
            return $558a1874964eed3d$var$renderCircle(7);
    }
};
const $558a1874964eed3d$var$setNavClass = (id, tag, isDisabled)=>{
    const baseClass = `axiom-stepper-nav-${tag}`;
    if (!isDisabled) return `${baseClass} ${baseClass}-${id}`;
    return `${baseClass} ${baseClass}-${id} ${baseClass}-disabled`;
};
const $558a1874964eed3d$var$NavStep = (props)=>{
    const { id: id, step: step } = props;
    const { onClick: onClick, isDisabled: isDisabled } = props;
    const itemClass = $558a1874964eed3d$var$setNavClass(id, 'item', isDisabled);
    const linkClass = $558a1874964eed3d$var$setNavClass(id, 'link', isDisabled);
    const textClass = $558a1874964eed3d$var$setNavClass(id, 'text', isDisabled);
    const iconClass = $558a1874964eed3d$var$setNavClass(id, 'icon', isDisabled);
    const handleClick = (event)=>{
        event.preventDefault();
        if (isDisabled) return;
        onClick(step, event);
    };
    const handleKeyUp = (event)=>{
        event.preventDefault();
        if (isDisabled || event.keyCode !== 13) return;
        onClick(step, event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: `axiom-stepper--nav ${itemClass}`,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
            className: linkClass,
            href: step.slug || '#',
            onClick: handleClick,
            onKeyUp: handleKeyUp,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: textClass,
                    children: id
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: iconClass,
                    children: $558a1874964eed3d$var$renderIcon({
                        [id]: true
                    })
                })
            ]
        })
    });
};
$558a1874964eed3d$var$NavStep.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'prev',
        'next'
    ]).isRequired,
    step: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ]),
        slug: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }).isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};
var $558a1874964eed3d$var$NavStep$1 = $558a1874964eed3d$var$NavStep;
const $558a1874964eed3d$var$setStepClass = (tag, obj)=>{
    const baseClass = `axiom-stepper-${tag}`;
    const classArray = [
        baseClass,
        obj.isActive ? `${baseClass}-active` : '',
        obj.hasLine ? `${baseClass}-complete` : '',
        obj.isLink ? '' : `${baseClass}-disabled`,
        obj.isLast ? `${baseClass}-omega` : ''
    ];
    return classArray.filter(Boolean).join(' ');
};
const $558a1874964eed3d$var$ProgressStep = (props)=>{
    const { step: step, onClick: onClick, isActive: isActive, isLink: isLink, hasLine: hasLine } = props;
    const handleClick = (event)=>{
        event.preventDefault();
        if (!isLink) return;
        onClick(step, event);
    };
    const handleKeyUp = (event)=>{
        event.preventDefault();
        if (!isLink || event.keyCode !== 13) return;
        onClick(step, event);
    };
    const stepClass = $558a1874964eed3d$var$setStepClass('step', props);
    const linkClass = $558a1874964eed3d$var$setStepClass('link', props);
    const textClass = $558a1874964eed3d$var$setStepClass('text', props);
    const iconClass = $558a1874964eed3d$var$setStepClass('icon', props);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: `axiom-stepper--step ${stepClass}`,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
            href: step.slug || '#',
            className: linkClass,
            onClick: handleClick,
            onKeyUp: handleKeyUp,
            "aria-current": isActive ? 'step' : undefined,
            "aria-disabled": isLink ? undefined : 'true',
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: textClass,
                    children: step.label
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: iconClass,
                    "aria-hidden": "true",
                    children: $558a1874964eed3d$var$renderIcon(props)
                }),
                hasLine && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "screen-reader-only",
                    children: "\xA0completed step"
                })
            ]
        })
    });
};
$558a1874964eed3d$var$ProgressStep.propTypes = {
    step: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ]).isRequired,
        slug: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    }).isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    isLink: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    hasLine: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};
var $558a1874964eed3d$var$ProgressStep$1 = $558a1874964eed3d$var$ProgressStep;
const $558a1874964eed3d$var$initMaxIndex = (completedStepIndexes)=>{
    if (!completedStepIndexes.length) return 0;
    return Math.max(...completedStepIndexes);
};
const $558a1874964eed3d$var$ProgressStepper$1 = ({ steps: steps, onClick: onClick, ariaLabel: ariaLabel, activeStepIndex: activeStepIndex, completedStepIndexes: completedStepIndexes, classes: classes = [] })=>{
    const [maxIndex, setMaxIndex] = (0, $acw62.useState)($558a1874964eed3d$var$initMaxIndex(completedStepIndexes));
    (0, $acw62.useEffect)(()=>{
        if (maxIndex >= activeStepIndex) return;
        setMaxIndex(activeStepIndex);
    }, [
        maxIndex,
        activeStepIndex
    ]);
    const renderPrev = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$NavStep$1, {
            id: "prev",
            step: steps[activeStepIndex - 1] || {},
            isDisabled: !activeStepIndex,
            onClick: onClick
        });
    const renderNext = ()=>{
        const nextStep = steps[activeStepIndex + 1];
        const isDisabled = !nextStep || activeStepIndex >= maxIndex;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$NavStep$1, {
            id: "next",
            step: nextStep || {},
            isDisabled: isDisabled,
            onClick: onClick
        });
    };
    const renderStep = (step, index)=>{
        const isDone = completedStepIndexes.includes(index);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$ProgressStep$1, {
            hasLine: maxIndex > index,
            isActive: activeStepIndex === index,
            isLast: !steps[index + 1],
            isLink: isDone || activeStepIndex > index || maxIndex === index,
            isDone: isDone,
            onClick: onClick,
            step: step
        }, step.id);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
        "aria-label": ariaLabel,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-stepper'
            ],
            custom: classes,
            required: []
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
            className: "axiom-stepper-list",
            children: [
                renderPrev(),
                renderNext(),
                steps.map(renderStep)
            ]
        })
    });
};
$558a1874964eed3d$var$ProgressStepper$1.propTypes = {
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ]).isRequired,
        slug: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    })).isRequired,
    activeStepIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    completedStepIndexes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$ProgressStepper$2 = $558a1874964eed3d$var$ProgressStepper$1;
var $558a1874964eed3d$export$cbd315633ca307d1 = function(_a) {
    var steps = _a.steps, onClick = _a.onClick, ariaLabel = _a.ariaLabel, activeStepIndex = _a.activeStepIndex, completedStepIndexes = _a.completedStepIndexes, _b = _a.classes, classes = _b === void 0 ? [] : _b;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$ProgressStepper$2, {
        steps: steps,
        onClick: onClick,
        ariaLabel: ariaLabel,
        activeStepIndex: activeStepIndex,
        completedStepIndexes: completedStepIndexes,
        classes: classes
    });
};
$558a1874964eed3d$export$cbd315633ca307d1.propTypes = {
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ]).isRequired,
        slug: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    })).isRequired,
    activeStepIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    completedStepIndexes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$Radio$1 = ({ id: id, name: name, label: label, onChange: onChange, value: value, disabled: disabled = false, inputRef: inputRef, hideLabel: hideLabel = false, checked: checked = false, condensed: condensed = false, attributes: attributes = {}, classes: classes = [] })=>{
    const [selected, setSelected] = (0, $acw62.useState)(checked);
    const handleChange = (e)=>{
        // [EVENT REWORK] The component should expose the full event object for the change handlers so that developers have greater control over the component. Change should be
        // targeted for a major release to avoid invoking breaking changes
        const stopPropagation = onChange(e.target.value);
        if (!stopPropagation) setSelected(e.target.value === value);
    };
    (0, $acw62.useEffect)(()=>setSelected(checked), [
        checked
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-radio-button-set radio-button-set',
                `${condensed ? 'condensed' : ''}`
            ],
            custom: classes,
            required: []
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                id: id,
                type: "radio",
                "data-testid": "radio",
                name: name,
                value: value,
                disabled: disabled,
                onChange: handleChange,
                checked: selected,
                ref: inputRef,
                ...attributes
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                htmlFor: id,
                className: hideLabel ? 'label_hidden' : null,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "radio-button-set--indicator"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "radio-button-set--label-text",
                        children: label
                    })
                ]
            })
        ]
    }, label);
};
$558a1874964eed3d$var$Radio$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    // changed to optional + default [MJ]
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$Radio$2 = $558a1874964eed3d$var$Radio$1;
var $558a1874964eed3d$export$d7b12c4107be0d61 = function(_a) {
    var id = _a.id, name = _a.name, label = _a.label, onChange = _a.onChange, _b = _a.value, value = _b === void 0 ? undefined : _b, _c = _a.checked, checked = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.inputRef, inputRef = _e === void 0 ? undefined : _e, _f = _a.hideLabel, hideLabel = _f === void 0 ? false : _f, _g = _a.condensed, condensed = _g === void 0 ? false : _g, _h = _a.attributes, attributes = _h === void 0 ? {} : _h, _j = _a.classes, classes = _j === void 0 ? [] : _j;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$Radio$2, {
        id: id,
        name: name,
        label: label,
        onChange: onChange,
        value: value,
        checked: checked,
        disabled: disabled,
        inputRef: inputRef,
        hideLabel: hideLabel,
        condensed: condensed,
        attributes: attributes,
        classes: classes
    });
};
$558a1874964eed3d$export$d7b12c4107be0d61.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // @sic; can be on or off
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    // changed to optional + default [MJ]
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$RadioGroup$1 = ({ name: name, legend: legend, onChange: onChange, options: options, id: id, legendModifier: legendModifier, error: error = {
    code: undefined,
    message: undefined
}, microcopy: microcopy, horizontal: horizontal = false, condensed: condensed = false, classes: classes = [] })=>{
    const [selectedOption, setSelectedOption] = (0, $acw62.useState)(options.find((option)=>option.checked));
    const handleChange = (value)=>{
        setSelectedOption(options.find((option)=>option.value === value));
        onChange(value);
        // To prevent the Radio Button from over-riding it's own state, we tell the base component to skip it's default behavior by passing a truth flag to the component
        return true;
    };
    (0, $acw62.useEffect)(()=>{
        setSelectedOption(options.find((option)=>option.checked));
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Fieldset$1, {
        id: id,
        legend: legend,
        legendModifier: legendModifier,
        error: error,
        microcopy: microcopy,
        horizontal: horizontal,
        condensed: condensed,
        role: "radiogroup",
        classes: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-radiogroup--set'
            ],
            custom: classes
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "axiom-radiogroup--radio-buttons field-set--radio-button-group",
            children: options.map((option)=>{
                const checked = selectedOption ? selectedOption.value === option.value : false;
                return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Radio$2, {
                    id: option.id,
                    name: name,
                    label: option.label,
                    value: option.value,
                    inputRef: option.inputRef,
                    disabled: option.disabled,
                    checked: checked,
                    onChange: handleChange,
                    condensed: condensed
                }, option.id);
            })
        })
    });
};
$558a1874964eed3d$var$RadioGroup$1.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
            })
        ]),
        condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    })).isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    legendModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        code: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        message: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$RadioGroupJSX = $558a1874964eed3d$var$RadioGroup$1;
var $558a1874964eed3d$export$a98f0dcb43a68a25 = function(_a) {
    var name = _a.name, legend = _a.legend, onChange = _a.onChange, options = _a.options, _b = _a.id, id = _b === void 0 ? undefined : _b, _c = _a.legendModifier, legendModifier = _c === void 0 ? undefined : _c, _d = _a.error, error = _d === void 0 ? {
        code: undefined,
        message: undefined
    } : _d, _e = _a.microcopy, microcopy = _e === void 0 ? undefined : _e, _f = _a.horizontal, horizontal = _f === void 0 ? false : _f, _g = _a.condensed, condensed = _g === void 0 ? false : _g, _h = _a.classes, classes = _h === void 0 ? [] : _h;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$RadioGroupJSX, {
        id: id,
        name: name,
        legend: legend,
        onChange: onChange,
        options: options,
        legendModifier: legendModifier,
        error: error,
        microcopy: microcopy,
        horizontal: horizontal,
        condensed: condensed,
        classes: classes
    });
};
$558a1874964eed3d$export$a98f0dcb43a68a25.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
            })
        ]),
        condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    })).isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    legendModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        code: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        message: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$TextInput$1 = ({ id: id, label: label, name: name, value: value, onChange: onChange, type: type = 'text', labelModifier: labelModifier, condensed: condensed = false, disabled: disabled = false, readOnly: readOnly = false, error: error, microcopy: microcopy, onFocus: onFocus = ()=>{}, onBlur: onBlur, onKeyDown: onKeyDown, maxLength: maxLength, inputRef: inputRef, hideLabel: hideLabel = false, attributes: attributes = {}, classes: modifierClasses = [] })=>{
    const additionalProps = {
        'aria-invalid': error ? 'true' : 'false',
        'aria-required': labelModifier === 'required'
    };
    const inputType = type;
    let inputMode;
    if (type === 'password') inputMode = 'text';
    else inputMode = type;
    const handleOnChange = (e)=>{
        onChange(e.target.value);
    };
    const handleOnFocus = (e)=>{
        onFocus(e.target.value);
    };
    const handleOnBlur = (e)=>{
        if (onBlur) {
            onBlur(e.target.value);
            return;
        }
        onChange(e.target.value);
    };
    const classes = [
        'input-control--input--wrap'
    ];
    if (condensed) classes.push('input-control--condensed');
    const normalizedPropClasses = modifierClasses instanceof Array ? modifierClasses : [
        modifierClasses
    ];
    const controllerClasses = [
        'axiom-text-input',
        ...normalizedPropClasses
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$InputControl$1, {
        id: id,
        classes: controllerClasses,
        label: label,
        labelModifier: labelModifier,
        error: error,
        microcopy: microcopy,
        hideLabel: hideLabel,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            "data-testid": "wrap",
            className: classes.join(' '),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                id: id,
                "data-testid": "input",
                name: name,
                value: value,
                "aria-describedby": error || microcopy ? `${id}_messages` : null,
                onChange: handleOnChange,
                onFocus: handleOnFocus,
                onBlur: handleOnBlur,
                onKeyDown: onKeyDown,
                disabled: disabled,
                readOnly: readOnly,
                className: `axiom-text-input--input${readOnly ? ' read-only' : ''}`,
                type: inputType,
                inputMode: inputMode,
                maxLength: maxLength,
                ref: inputRef,
                ...attributes,
                ...additionalProps
            })
        })
    });
};
$558a1874964eed3d$var$TextInput$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'text',
        'email',
        'password',
        'url'
    ]),
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$TextInputJSX = $558a1874964eed3d$var$TextInput$1;
const $558a1874964eed3d$var$OptionsList = /*#__PURE__*/ (0, $acw62.forwardRef)(({ id: id, handleSelect: handleSelect, setIsExpanded: setIsExpanded, isExpanded: isExpanded, options: options, returnFocus: returnFocus = ()=>{} }, ref)=>{
    const listRef = (0, $acw62.useRef)();
    const [prevOptions, setPrevOptions] = (0, $acw62.useState)(options);
    const [currentItem, setCurrentItem] = (0, $acw62.useState)();
    if (options !== prevOptions) {
        setPrevOptions(options);
        setCurrentItem(options[0]);
    }
    (0, $acw62.useEffect)(()=>{
        if (listRef.current) {
            const inputDom = listRef.current.parentElement;
            const listDom = listRef.current;
            const inputRect = inputDom.getBoundingClientRect();
            listDom.style.setProperty('--suggestions-block-start', `${inputRect.bottom}px`);
        }
    }, [
        isExpanded
    ]);
    const itemSelect = (value)=>{
        handleSelect(value);
        if (isExpanded) setIsExpanded(false);
    };
    const getCurrentElement = (collection)=>{
        const array = Array.isArray(collection) ? collection : Array.from(collection);
        return array.find((item)=>item.dataset.value === currentItem);
    };
    const handleKeyDown = (event)=>{
        const { key: key } = event;
        const suggestions = Array.from(listRef.current.children);
        const currentElement = getCurrentElement(suggestions);
        const next = currentElement.nextElementSibling;
        const prev = currentElement.previousElementSibling;
        const first = suggestions.at(0);
        const last = suggestions.at(-1);
        switch(key){
            case 'ArrowUp':
            case 'ArrowDown':
            case 'Home':
            case 'End':
                event.preventDefault();
                if (key === 'ArrowUp') {
                    if (suggestions.indexOf(currentElement) > 0) {
                        prev.focus();
                        setCurrentItem(prev.dataset.value);
                    } else {
                        last.focus();
                        setCurrentItem(last.dataset.value);
                    }
                } else if (key === 'ArrowDown') {
                    if (suggestions.indexOf(currentElement) < suggestions.length - 1) {
                        next.focus();
                        setCurrentItem(next.dataset.value);
                    } else {
                        first.focus();
                        setCurrentItem(first.dataset.value);
                    }
                } else if (key === 'End') {
                    suggestions.at(-1).focus();
                    setCurrentItem(last.dataset.value);
                } else {
                    suggestions.at(0).focus();
                    setCurrentItem(first.dataset.value);
                }
                break;
            case 'Enter':
                break;
            case 'Tab':
                break;
            case 'Escape':
                setIsExpanded(false);
                returnFocus();
                break;
        }
        return true;
    };
    /**
   *  Following condition uses for the parent triggers the child functions.
   *  We have a parent key down function, it triggers when parent key press happened.
   *  We have condition based on dropdown opened/closed and also first time dropdown
   */ const setCurrentItemFromParent = (option)=>{
        setCurrentItem(option);
    };
    const openSuggestions = ()=>{
        setIsExpanded(true);
    };
    const closeSuggestions = ()=>{
        setIsExpanded(false);
    };
    const handleParentKeyDown = (event)=>{
        const { key: key } = event;
        if (key === 'ArrowDown') {
            if (!isExpanded) setIsExpanded(true);
            else /* eslint-disable no-lonely-if */ if (listRef.current && listRef.current.children.length > 0) Array.from(listRef.current.children).at(0).focus();
        }
        if (key === 'ArrowUp') {
            if (listRef.current && listRef.current.children.length > 0) {
                Array.from(listRef.current.children).at(-1).focus();
                setCurrentItem(options.at(-1));
            }
        }
        if (key === 'Escape') setIsExpanded(false);
    };
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            handleParentKeyDown: handleParentKeyDown,
            setCurrentItemFromParent: setCurrentItemFromParent,
            openSuggestions: openSuggestions,
            closeSuggestions: closeSuggestions
        }));
    return isExpanded && options.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: id,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-search-input--suggestion-list'
            ],
            custom: [],
            required: []
        }),
        role: "listbox",
        tabIndex: -1,
        ref: listRef,
        "aria-label": "Search Suggestions",
        "data-testid": "option-list",
        onKeyDown: (e)=>handleKeyDown(e),
        children: options.map((opt, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                id: `${`${id}_${index}`}`,
                className: $558a1874964eed3d$var$createClassList({
                    default: [
                        'axiom-search-input--suggestion-list-item'
                    ],
                    custom: [],
                    required: []
                }),
                onClick: ()=>itemSelect(opt),
                onKeyDown: (e)=>handleKeyDown(e),
                role: "option",
                tabIndex: "-1",
                "aria-selected": "",
                "data-value": opt,
                children: opt
            }, `${`${id}_${index}`}`))
    });
});
$558a1874964eed3d$var$OptionsList.displayName = 'OptionsList';
$558a1874964eed3d$var$OptionsList.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    isExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    setIsExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    handleSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    returnFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $558a1874964eed3d$var$OptionsList$1 = $558a1874964eed3d$var$OptionsList;
const $558a1874964eed3d$var$SUGGESTION_LIST_QUERY_CUTOFF = 2;
const $558a1874964eed3d$var$SearchInput$1 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ onChange: onChange, id: id, name: name = 'q', value: value = '', microcopy: microcopy, onFocus: onFocus = ()=>{}, onBlur: onBlur = ()=>{}, onSearch: onSearch = ()=>{}, hideSuggestionList: hideSuggestionList = false, suggestionList: suggestionList = [], onSelect: onSelect = ()=>{} }, ref)=>{
    const generatedId = (0, $acw62.useId)();
    const componentId = id || generatedId;
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(false);
    const inputRef = (0, $acw62.useRef)();
    const searchInputRef = (0, $acw62.useRef)();
    const searchButtonRef = (0, $acw62.useRef)();
    const suggestionsListRef = (0, $acw62.useRef)();
    const maxSuggestions = suggestionList.slice(0, 10);
    // Allow apps to control state of suggestions box
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            openSuggestionsList () {
                setIsExpanded(true);
            },
            closeSuggestionsList () {
                setIsExpanded(false);
            }
        }));
    const handleClickOutside = (e)=>{
        /* istanbul ignore next */ if (suggestionsListRef.current) {
            // 👇 works around effects cleanup "bug" introduced in React 17 - https://legacy.reactjs.org/blog/2020/08/10/react-v17-rc.html#potential-issues
            const component = searchInputRef.current;
            if (!component.contains(e.target)) suggestionsListRef.current.closeSuggestions();
        }
    };
    (0, $acw62.useEffect)(()=>{
        document.addEventListener('click', handleClickOutside);
        return ()=>{
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    const handleSearch = (searchTerm, event)=>{
        onSearch(searchTerm, event);
        if (isExpanded) setIsExpanded(false);
    };
    const handleKeyDown = (e)=>{
        if (suggestionsListRef.current) {
            const listRef = suggestionsListRef.current;
            listRef.handleParentKeyDown(e);
        }
        if (e.key === 'Tab') setIsExpanded(false);
        if (e.key === 'Enter') handleSearch(value, e);
    };
    const handleOnChange = (inputValue)=>{
        onChange(inputValue);
        // Only show the suggestion list if the input value meets the character cutoff
        setIsExpanded(inputValue.length >= $558a1874964eed3d$var$SUGGESTION_LIST_QUERY_CUTOFF);
    };
    const handleOnFocus = ()=>{
        onFocus();
    };
    const handleSelectOption = (optionValue)=>{
        onSelect(optionValue);
        /* istanbul ignore next */ if (inputRef.current) inputRef.current.focus();
        onSearch(optionValue, null);
    };
    const handleOnBlur = ()=>{
        onBlur();
        /* istanbul ignore next */ if (!!suggestionList.length && hideSuggestionList !== false && searchButtonRef.current && suggestionsListRef.current) {
            if (searchButtonRef.current.hasFocus() === false || suggestionsListRef.current.hasFocus() === false) setIsExpanded(false);
        }
    };
    const returnFocus = ()=>{
        /* istanbul ignore next */ if (inputRef.current) {
            const input = inputRef.current;
            input.focus();
        }
    };
    const inputAttributes = {
        'autoComplete': 'off',
        'role': 'combobox',
        'aria-autocomplete': 'list',
        'aria-expanded': isExpanded
    };
    if (isExpanded) inputAttributes['aria-controls'] = `${componentId}-options`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: componentId,
        ref: searchInputRef,
        className: "axiom-search-input",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                classes: $558a1874964eed3d$var$createClassList({
                    default: [
                        'axiom-search-input--search-icon'
                    ],
                    custom: [],
                    required: []
                }),
                name: "search",
                seenByAssistiveTechnology: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$TextInputJSX, {
                id: `${componentId}-input`,
                label: "Search",
                name: name,
                value: value,
                classes: $558a1874964eed3d$var$createClassList({
                    default: [
                        'axiom-search-input--search-input'
                    ],
                    custom: [],
                    required: []
                }),
                microcopy: microcopy,
                onChange: handleOnChange,
                onFocus: handleOnFocus,
                hideLabel: true,
                onBlur: handleOnBlur,
                onKeyDown: handleKeyDown,
                inputRef: inputRef,
                attributes: inputAttributes
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                id: `${componentId}-search-button`,
                label: "Search",
                styleVariant: "primary",
                classes: $558a1874964eed3d$var$createClassList({
                    default: [
                        'axiom-search-input--search-button'
                    ],
                    custom: [],
                    required: []
                }),
                onClick: (e)=>handleSearch(value, e),
                inputRef: searchButtonRef
            }),
            !hideSuggestionList && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-search-input--search-result-count screen-reader-only",
                        "aria-live": "polite",
                        "aria-atomic": true,
                        children: isExpanded && `${maxSuggestions.length} search suggestions found. To navigate, use the up and down arrow keys`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$OptionsList$1, {
                        id: `${componentId}-options`,
                        options: maxSuggestions,
                        handleSelect: handleSelectOption,
                        isExpanded: isExpanded,
                        ref: suggestionsListRef,
                        setIsExpanded: setIsExpanded,
                        inputId: `${componentId}-input`,
                        returnFocus: returnFocus
                    })
                ]
            })
        ]
    });
});
$558a1874964eed3d$var$SearchInput$1.displayName = 'SearchInput';
$558a1874964eed3d$var$SearchInput$1.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    hideSuggestionList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    suggestionList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ]))
};
var $558a1874964eed3d$var$SearchInputJSX = $558a1874964eed3d$var$SearchInput$1;
var $558a1874964eed3d$export$55d7609a8f1eccd2 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_a, ref) {
    var onChange = _a.onChange, _b = _a.id, id = _b === void 0 ? undefined : _b, _c = _a.name, name = _c === void 0 ? 'q' : _c, _d = _a.value, value = _d === void 0 ? '' : _d, _e = _a.microcopy, microcopy = _e === void 0 ? undefined : _e, _f = _a.onFocus, onFocus = _f === void 0 ? function() {} : _f, _g = _a.onBlur, onBlur = _g === void 0 ? function() {} : _g, _h = _a.onSearch, onSearch = _h === void 0 ? function() {} : _h, _j = _a.hideSuggestionList, hideSuggestionList = _j === void 0 ? false : _j, _k = _a.suggestionList, suggestionList = _k === void 0 ? [] : _k, _l = _a.onSelect, onSelect = _l === void 0 ? function() {} : _l;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$SearchInputJSX, {
        id: id,
        name: name,
        value: value,
        microcopy: microcopy,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onSearch: onSearch,
        onSelect: onSelect,
        hideSuggestionList: hideSuggestionList,
        suggestionList: suggestionList,
        ref: ref
    });
});
$558a1874964eed3d$export$55d7609a8f1eccd2.displayName = 'SearchInput';
$558a1874964eed3d$export$55d7609a8f1eccd2.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    hideSuggestionList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    suggestionList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
};
const $558a1874964eed3d$var$Segment = ({ segment: segment, onSegmentClick: onSegmentClick, setFocus: setFocus, formattedId: formattedId, focus: focus = false, index: index = 0, selectedSegment: selectedSegment, inputRefs: inputRefs, displayIconOnly: displayIconOnly = false })=>{
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (focus) ref.current.focus();
    }, [
        focus
    ]);
    const handleSelect = (0, $acw62.useCallback)(()=>{
        // setting focus to that element when it is selected
        setFocus(index);
    }, [
        segment,
        index,
        setFocus
    ]);
    const matchedSegments = inputRefs ? inputRefs.filter((inputref)=>inputref.segment === segment) : undefined;
    const refOfSegment = matchedSegments && matchedSegments.length > 0 ? matchedSegments[0].inputRef : undefined;
    const keyValue = segment.name || segment.icon;
    const selected = selectedSegment && segment && JSON.stringify(segment) === JSON.stringify(selectedSegment);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "tab-item",
        ref: refOfSegment,
        role: "presentation",
        className: `${selected ? 'axiom-segmented-control--segment segmented-control--segment--active ' : 'axiom-segmented-control--segment '}`,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
            role: "tab",
            tabIndex: index === 0 && !selectedSegment || selectedSegment === segment ? 0 : -1,
            type: "button",
            id: formattedId,
            ref: ref,
            title: segment.name,
            "data-title": keyValue,
            onClick: ()=>onSegmentClick({
                    ...segment,
                    index: index
                }),
            onKeyDown: handleSelect,
            "aria-selected": selected,
            "aria-controls": segment.ariaControls,
            "aria-label": segment.name,
            className: "axiom-segmented-control--segment--button",
            children: [
                segment.icon && !displayIconOnly && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                            name: segment.icon
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "axiom-segmented-control--segment--icon-text segmented-control-icon-text",
                            children: segment.name
                        })
                    ]
                }),
                !segment.icon && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: segment.name
                }),
                segment.icon && displayIconOnly && /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                    name: segment.icon
                })
            ]
        })
    }, `${keyValue + index}`);
};
$558a1874964eed3d$var$Segment.propTypes = {
    segment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        ariaControls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }).isRequired,
    onSegmentClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    setFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    formattedId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    selectedSegment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    inputRefs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        segment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        }),
        inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
            })
        ])
    })),
    focus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    displayIconOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $558a1874964eed3d$var$Segment$1 = $558a1874964eed3d$var$Segment;
const $558a1874964eed3d$var$SegmentedControl$1 = ({ segments: segments, onSegmentClick: onSegmentClick, inputRefs: inputRefs, activeIndex: activeIndex = 0, iconsOnly: iconsOnly = false, classes: classes = [] })=>{
    const [selectedIndex, setSelectedIndex] = (0, $acw62.useState)(activeIndex);
    const [focus, setFocus] = (0, $acw62.useState)(null);
    const segmentedEleRef = (0, $acw62.useRef)(null);
    const currentSegment = segments[selectedIndex];
    const handleSegmentClick = (tab)=>{
        setSelectedIndex(tab.index);
        onSegmentClick(tab);
    };
    const handleKeyDown = (event)=>{
        if (event.key === 'ArrowRight') {
            // when Right arrow key is pressed
            event.preventDefault();
            setFocus(focus === segments.length - 1 ? 0 : focus + 1);
        } else if (event.key === 'ArrowLeft') {
            // when Left arrow key is pressed
            event.preventDefault();
            setFocus(focus === 0 || !focus ? segments.length - 1 : focus - 1);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (selectedIndex === activeIndex) return;
        setSelectedIndex(activeIndex);
    }, [
        activeIndex
    ]);
    function updateStyles() {
        if (segmentedEleRef && segmentedEleRef.current && segmentedEleRef.current.querySelector('.segmented-control--segment--active')) {
            const selectedDiv = segmentedEleRef.current.querySelector('.axiom-segmented-control--segment.selected');
            selectedDiv.style.left = `${100 * selectedIndex / segments.length}%`;
        }
    }
    /** Updating the styles for selected segment changes */ (0, $acw62.useEffect)(()=>{
        updateStyles();
    }, [
        selectedIndex
    ]);
    const getFormattedIds = ()=>segments.map((segment, index)=>segment.id ? segment.id : `${segment.name.replace(/\s+/g, '')}-${index}`);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: $558a1874964eed3d$var$createClassList({
            default: 'axiom-segmented-control--wrapper',
            custom: classes,
            required: []
        }),
        children: /*#__PURE__*/ // eslint-disable-next-line jsx-a11y/interactive-supports-focus
        (0, $ayMG0.jsxs)("div", {
            role: "tablist",
            className: "axiom-segmented-control segmented-control",
            onKeyDown: handleKeyDown,
            ref: segmentedEleRef,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "axiom-segmented-control--selector-rail",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "axiom-segmented-control--segment selected",
                        style: {
                            width: `${100 / segments.length}%`
                        },
                        role: "presentation"
                    })
                }),
                segments.map((segment, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Segment$1, {
                        setFocus: setFocus,
                        index: index,
                        inputRefs: inputRefs,
                        focus: focus === index,
                        segment: segment,
                        selectedSegment: currentSegment,
                        onSegmentClick: handleSegmentClick,
                        displayIconOnly: iconsOnly,
                        formattedId: getFormattedIds()[index]
                    }, `${segment}${index}`))
            ]
        })
    });
};
$558a1874964eed3d$var$SegmentedControl$1.propTypes = {
    segments: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        ariaControls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    })).isRequired,
    onSegmentClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    iconsOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputRefs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        segment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        }),
        inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
            })
        ])
    })),
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$SegmentedControlJSX = $558a1874964eed3d$var$SegmentedControl$1;
var $558a1874964eed3d$export$668709c620d0b8e2 = function(_a) {
    var segments = _a.segments, onSegmentClick = _a.onSegmentClick, _b = _a.inputRefs, inputRefs = _b === void 0 ? undefined : _b, _c = _a.activeIndex, activeIndex = _c === void 0 ? 0 : _c, _d = _a.iconsOnly, iconsOnly = _d === void 0 ? false : _d, _e = _a.classes, classes = _e === void 0 ? [] : _e;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$SegmentedControlJSX, {
        segments: segments,
        onSegmentClick: onSegmentClick,
        iconsOnly: iconsOnly,
        inputRefs: inputRefs,
        activeIndex: activeIndex,
        classes: classes
    });
};
$558a1874964eed3d$export$668709c620d0b8e2.propTypes = {
    segments: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        ariaControls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    })).isRequired,
    onSegmentClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    iconsOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputRefs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        segment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        }),
        inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
            })
        ])
    })),
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
/* eslint-disable react/button-has-type */ const $558a1874964eed3d$var$Pagination$1 = ({ pageCount: pageCountProp, page: pageProp = 1, align: align = 'center', classes: classes = [], ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, onPageChange: onPageChange = ()=>{} })=>{
    // To prevent the component from rendering negative pages, we'll set the minimum pageCount to 1.
    const pageCount = Math.max(pageCountProp, 1);
    const initialPage = Math.max(Math.min(pageProp, pageCount), 1);
    // minimum interaction width (44) + margin + padding + border
    const NAV_ITEM_MINIMUM_WIDTH = 54;
    const isInternalUpdate = (0, $acw62.useRef)();
    const paginationRef = (0, $acw62.useRef)(null);
    const navigatorRef = (0, $acw62.useRef)(null);
    const navigatePrevRef = (0, $acw62.useRef)(null);
    const navigateNextRef = (0, $acw62.useRef)(null);
    const lastPageRef = (0, $acw62.useRef)(null);
    const firstGapRef = (0, $acw62.useRef)(null);
    const lastGapRef = (0, $acw62.useRef)(null);
    const pagesRef = (0, $acw62.useRef)(null);
    const [pageNumber, setPageNumber] = (0, $acw62.useState)(initialPage);
    const [visiblePages, setVisiblePages] = (0, $acw62.useState)([
        1,
        2
    ]);
    const [visibleCount, setVisibleCount] = (0, $acw62.useState)(pageCount);
    const [reflow, setReflow] = (0, $acw62.useState)(null);
    const [itemWidth, setItemWidth] = (0, $acw62.useState)(NAV_ITEM_MINIMUM_WIDTH);
    const isFirstPage = pageNumber === 1;
    const isLastPage = pageNumber === pageCount;
    let pageControlOffsets = 0;
    const goToFirst = ()=>{
        setVisiblePages([
            1,
            visibleCount
        ]);
        setPageNumber(1);
    };
    const goToLast = ()=>{
        setVisiblePages([
            Math.max(pageCount - visibleCount, 1),
            pageCount
        ]);
        setPageNumber(pageCount);
    };
    const firstVisibleOrLastActive = visiblePages[0] || pageNumber;
    const goToPrevious = ()=>{
        if (pageNumber > 1 && firstVisibleOrLastActive < pageNumber) setPageNumber(pageNumber - 1);
        else if (pageNumber > 1 && visiblePages[0] === pageNumber && visiblePages[1] !== pageCount) {
            const newPageLimits = [
                visiblePages[0] - visibleCount <= 1 ? 1 : visiblePages[0] - visibleCount,
                visiblePages[1] - visibleCount > visibleCount ? visiblePages[1] - visibleCount : visibleCount
            ];
            setVisiblePages(newPageLimits);
            setPageNumber(pageNumber - 1);
        } else if (pageNumber > 1 && visiblePages[0] === pageNumber && visiblePages[1] === pageCount) {
            const newPageLimits = [
                visiblePages[0] - visibleCount <= 1 ? 1 : visiblePages[0] - visibleCount,
                visiblePages[1] - visibleCount > visibleCount ? pageNumber - 1 : visibleCount
            ];
            setVisiblePages(newPageLimits);
            setPageNumber(pageNumber - 1);
        }
    };
    const goToNext = ()=>{
        if (pageNumber < pageCount && visiblePages[1] > pageNumber) setPageNumber(pageNumber + 1);
        else if (pageNumber < pageCount && visiblePages[1] === pageNumber) {
            const newPageLimits = [
                visiblePages[0] + visibleCount > pageCount - visibleCount ? pageCount - visibleCount : pageNumber + 1,
                visiblePages[1] + visibleCount >= pageCount ? pageCount : visiblePages[1] + visibleCount
            ];
            setVisiblePages(newPageLimits);
            setPageNumber(pageNumber + 1);
        }
    };
    const jumpToPage = (event)=>{
        if (event.currentTarget.value === '1') goToFirst();
        else if (event.currentTarget.value === `${pageCount}`) goToLast();
        else setPageNumber(parseInt(event.currentTarget.value, 10));
    };
    const reflowPagination = ()=>{
        requestAnimationFrame(()=>setReflow(Date.now()));
    };
    const pageCountGapIndicator = (position, hide)=>{
        if (hide) return;
        // eslint-disable-next-line consistent-return
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            ref: position === 'first' ? firstGapRef : lastGapRef,
            className: `axiom-pagination--item-container axiom-pagination--item-container--gap axiom-pagination--item-container--gap-${position}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: "..."
            })
        }, `${position}-hidden`);
    };
    const pageNode = (currentPage)=>{
        const pageClasses = [
            'axiom-pagination--page',
            'pagination-page',
            `pagination-page--${currentPage}`
        ];
        if (currentPage === pageNumber) pageClasses.push('pagination--selected');
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "axiom-pagination--item-container",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                styleVariant: "tertiary",
                label: `${currentPage}`,
                classes: pageClasses.join(' '),
                onClick: jumpToPage,
                ariaCurrent: currentPage === pageNumber,
                inputRef: currentPage === pageCount ? lastPageRef : null,
                attributes: {
                    value: currentPage
                }
            })
        }, currentPage);
    };
    const renderPageControls = ()=>{
        const pageNodes = [];
        // eslint-disable-next-line max-len
        for(let currentPage = visiblePages[0]; currentPage <= visiblePages[1]; currentPage++)pageNodes.push(pageNode(currentPage));
        const countNodes = pageNodes.filter((page)=>page.key !== '1' && page.key !== `${pageCount}`);
        const shouldHideFirst = countNodes.length > 0 ? countNodes[0].key === '2' : countNodes.length !== 0 || pageCount <= 2;
        const shouldHideLast = countNodes.length > 0 ? countNodes[countNodes.length - 1].key === `${pageCount - 1}` || pageCount <= 2 : true;
        pageControlOffsets = 2 + !shouldHideFirst + !shouldHideLast;
        const renderedNodes = [
            pageNode(1),
            pageCountGapIndicator('first', shouldHideFirst),
            ...countNodes,
            pageCountGapIndicator('last', shouldHideLast),
            pageCount === 1 ? null : pageNode(pageCount)
        ];
        return renderedNodes;
    };
    const adjustItemWidths = (page)=>{
        const currentSelectedWidth = String(page).length;
        if (currentSelectedWidth <= 3) setItemWidth(NAV_ITEM_MINIMUM_WIDTH * 1);
        else if (currentSelectedWidth === 4) setItemWidth(NAV_ITEM_MINIMUM_WIDTH * 1.25);
        else if (currentSelectedWidth === 5 || currentSelectedWidth === 6) setItemWidth(NAV_ITEM_MINIMUM_WIDTH * 1.5);
        if (currentSelectedWidth > 6) // Note: Tests timeout if this
        // condition >= 7. May hint at
        // a performance liability with
        // this approach.
        setItemWidth(NAV_ITEM_MINIMUM_WIDTH * 1.65);
    };
    (0, $acw62.useEffect)(()=>{
        // If the page count becomes lower than the currently selected page, then we automatically adjust the selected page to new page count
        const selectedPage = Math.max(Math.min(pageNumber, pageCount), 1);
        setPageNumber(selectedPage);
        adjustItemWidths(selectedPage);
        isInternalUpdate.current = selectedPage === pageNumber;
        if (selectedPage < visiblePages[0] || selectedPage > visiblePages[1]) reflowPagination();
    }, [
        pageCount
    ]);
    (0, $acw62.useEffect)(()=>{
        const selectedPage = Math.max(Math.min(pageProp, pageCount), 1);
        setPageNumber(selectedPage);
        adjustItemWidths(selectedPage);
        isInternalUpdate.current = selectedPage === pageNumber;
        if (selectedPage < visiblePages[0] || selectedPage > visiblePages[1]) reflowPagination();
    }, [
        pageProp
    ]);
    (0, $acw62.useEffect)(()=>{
        // eslint-disable-next-line react/destructuring-assignment
        onPageChange(pageNumber, isInternalUpdate.current);
        isInternalUpdate.current = true;
    }, [
        pageNumber
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        const paginationWidth = paginationRef.current.offsetWidth;
        const navigationButtons = [
            ...navigatorRef.current.getElementsByTagName('button')
        ].filter((a)=>!a.className.includes('pagination-page'));
        const navigationButtonsWidth = navigationButtons.reduce((totalWidth, button)=>totalWidth + button.offsetWidth, 0);
        if (!itemWidth) adjustItemWidths(pageNumber);
        const lastItemWidth = lastPageRef.current.offsetWidth;
        const visibleControlAdustment = pageControlOffsets * itemWidth;
        const maxVisiblePages = Math.floor((paginationWidth - navigationButtonsWidth - visibleControlAdustment - lastItemWidth) / itemWidth);
        const pageGutterSize = Math.floor(maxVisiblePages / 2);
        const appliedGutterSize = !lastGapRef.current || visiblePages[1] === 2 ? maxVisiblePages : pageGutterSize;
        const initialLeftMostPage = Math.max(pageNumber - appliedGutterSize, 1);
        const initialRightMostPage = Math.min(initialLeftMostPage + maxVisiblePages, pageCount);
        setVisiblePages([
            initialLeftMostPage,
            initialRightMostPage
        ]);
        setVisibleCount(Math.min(maxVisiblePages, pageCount));
        return ()=>{
            setVisiblePages([]);
            setVisibleCount(1);
        };
    }, [
        navigatorRef.current,
        reflow,
        itemWidth
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        reflowPagination();
    }, [
        pageCount
    ]);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener('resize', reflowPagination);
        return ()=>{
            setReflow(null);
            window.removeEventListener('resize', reflowPagination);
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
        ref: paginationRef,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                `axiom-pagination`,
                `pagination`,
                `align-${align}`
            ],
            custom: classes,
            required: []
        }),
        "aria-label": ariaLabel && !ariaLabelledBy ? ariaLabel : null,
        "aria-labelledby": ariaLabelledBy || null,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            ref: navigatorRef,
            className: "axiom-pagination--page-navigator page-navigator",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                    styleVariant: "tertiary",
                    label: "Prev",
                    customAriaLabel: "Previous Page",
                    classes: "axiom-pagination--page-navigator--controls axiom-pagination--previous-page page-navigator--controls",
                    icon: "chevron-left",
                    onClick: goToPrevious,
                    inputRef: navigatePrevRef,
                    attributes: {
                        'data-testid': 'prev-page',
                        'aria-disabled': isFirstPage ? true : null
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "pages",
                    className: "axiom-pagination--pages pages",
                    ref: pagesRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
                        children: renderPageControls()
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                    styleVariant: "tertiary",
                    label: "Next",
                    customAriaLabel: "Next Page",
                    classes: "axiom-pagination--page-navigator axiom-pagination--next-page page-navigator--controls",
                    icon: "chevron-right",
                    iconPosition: "right",
                    onClick: goToNext,
                    inputRef: navigateNextRef,
                    attributes: {
                        'data-testid': 'next-page',
                        'aria-disabled': isLastPage ? true : null
                    }
                })
            ]
        })
    });
};
$558a1874964eed3d$var$Pagination$1.propTypes = {
    pageCount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    page: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    align: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'left',
        'center',
        'right'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    ariaLabelledBy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $558a1874964eed3d$var$PaginationJSX = $558a1874964eed3d$var$Pagination$1;
var $558a1874964eed3d$export$68f5e1453c188a82 = function(_a) {
    var pageCount = _a.pageCount, _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.align, align = _c === void 0 ? 'center' : _c, _d = _a.classes, classes = _d === void 0 ? [] : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? undefined : _e, _f = _a.ariaLabelledBy, ariaLabelledBy = _f === void 0 ? undefined : _f, _g = _a.onPageChange, onPageChange = _g === void 0 ? function() {} : _g;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$PaginationJSX, {
        pageCount: pageCount,
        page: page,
        align: align,
        onPageChange: onPageChange,
        classes: classes,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy
    });
};
$558a1874964eed3d$export$68f5e1453c188a82.propTypes = {
    pageCount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    page: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    align: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'left',
        'center',
        'right'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    ariaLabelledBy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
const $558a1874964eed3d$var$Dropdown = /*#__PURE__*/ (0, $acw62.forwardRef)(({ options: options, handleSelect: handleSelect, labelId: labelId, selected: selected = {
    name: '',
    value: undefined
}, isVisible: isVisible = null, isResizing: isResizing = false }, ref)=>{
    const classes = [
        'axiom-select-input--dropdown dropdown',
        'option'
    ];
    if (isVisible) classes.push('slideDown');
    if (isResizing) classes.push('axiom-select-input--dropdown--resizing');
    const ulRef = (0, $acw62.useRef)();
    /**
   *  @param index: options index when selected (via arrow up/down, enter,
   * on base select when we open from parent/when we click onc select.)
   * @param triggerChange: param refers to the flag based on the selected
   * event only should reflect the changed element.
   */ const itemSelect = (index, triggerToggle, key)=>{
        let nextItem = ulRef.current.querySelector('li[aria-selected=true]');
        if (nextItem) nextItem.removeAttribute('aria-selected');
        nextItem = ulRef.current.children[index];
        nextItem.setAttribute('aria-selected', true);
        nextItem.focus();
        handleSelect(options[index], triggerToggle, key);
    };
    const handleKeyDown = (event)=>{
        const key = event.which || event.keyCode;
        let nextItem = ulRef.current.querySelector('li[aria-selected=true]');
        let index = -1;
        if (!nextItem) {
            ulRef.current.focus();
            itemSelect(0, false, key);
            return null;
        }
        switch(key){
            case 38:
            case 40:
            case 36:
            case 35:
                nextItem.removeAttribute('aria-selected');
                event.preventDefault();
                // Focus on UL for screen reader
                if (document.activeElement.tagName !== 'UL') ulRef.current.focus();
                if (key === 38) do {
                    nextItem = nextItem.previousElementSibling;
                    if (!nextItem) nextItem = ulRef.current.children[ulRef.current.children.length - 1];
                }while (nextItem.classList.contains('disabled'));
                else if (key === 40) do {
                    nextItem = nextItem.nextElementSibling;
                    if (!nextItem) nextItem = ulRef.current.children[ulRef.current.children.length - ulRef.current.children.length];
                }while (nextItem.classList.contains('disabled'));
                else if (key === 35) for(let i = 0; i < ulRef.current.children.length; i++){
                    nextItem = ulRef.current.children[ulRef.current.children.length - 1 - i];
                    if (!nextItem.classList.contains('disabled')) break;
                }
                else for(let i = 0; i < ulRef.current.children.length; i++){
                    nextItem = ulRef.current.children[i];
                    if (!nextItem.classList.contains('disabled')) break;
                }
                /** update scroll focus in the options list with Arrow keys */ if (ulRef.current.scrollHeight > ulRef.current.clientHeight) {
                    const scrollBottom = ulRef.current.clientHeight + ulRef.current.scrollTop;
                    const eleBottom = nextItem.offsetTop + nextItem.offsetHeight;
                    if (eleBottom > scrollBottom) ulRef.current.scrollTop = eleBottom - ulRef.current.clientHeight;
                    else if (nextItem.offsetTop < ulRef.current.scrollTop) ulRef.current.scrollTop = nextItem.offsetTop;
                }
                if (nextItem) {
                    nextItem.setAttribute('aria-selected', true);
                    nextItem.focus();
                }
                index = Array.from(ulRef.current.children).indexOf(nextItem);
                itemSelect(index, false, key);
                nextItem.focus();
                break;
            case 13:
                nextItem.removeAttribute('aria-selected');
                // For Enter Key
                index = Array.from(ulRef.current.children).indexOf(nextItem);
                if (event.target.tagName === 'UL' && isVisible) // collapse menu
                itemSelect(index, true, key);
                break;
            case 9:
            case 27:
                nextItem.removeAttribute('aria-selected');
                // For Tab key
                index = Array.from(ulRef.current.children).indexOf(nextItem);
                if (event.target.tagName === 'UL' && isVisible) // collapse menu
                itemSelect(index, true, key);
                break;
            case 32:
                // For Spacebar
                index = Array.from(ulRef.current.children).indexOf(nextItem);
                itemSelect(index, false, key);
                break;
        }
        return true;
    };
    const setSelectedAria = ()=>{
        let nextItem = ulRef.current.querySelector('li[aria-selected=true]');
        // Focus on UL for screen reader
        ulRef.current.focus();
        if (!nextItem) {
            nextItem = ulRef.current.querySelector('li');
            ulRef.current.setAttribute('aria-activedescendant', nextItem.getAttribute('id'));
            nextItem.setAttribute('aria-selected', true);
            nextItem.focus();
            return;
        }
        nextItem.setAttribute('aria-selected', true);
        ulRef.current.setAttribute('aria-activedescendant', nextItem.getAttribute('id'));
        nextItem.focus();
    };
    const getSelectedAria = ()=>{
        const selectedOptionIndex = options.findIndex((option)=>option.value === selected.value);
        return selectedOptionIndex > -1 ? `${`${labelId}_${selectedOptionIndex}`}` : null;
    };
    /**
   *  Following condition uses for the parent triggers the child functions.
   *  We have a parent key down function, it triggers when parent key press happened.
   *  We have condition based on dropdown opened/closed and also first time dropdown
   * opened to select first one as default.
   */ (0, $acw62.useImperativeHandle)(ref, ()=>({
            listDom: ulRef.current,
            handleParentKeyDown (event, isDropdownVisible) {
                const key = event.which || event.keyCode;
                if (isDropdownVisible) handleKeyDown(event);
                else if (key === 13 || key === 38 || key === 40 || key === 32) setSelectedAria();
            }
        }));
    (0, $acw62.useEffect)(()=>{
        const domOptionlist = Array.from(ulRef.current.children);
        const selectedOption = options.find((option)=>option.selected);
        domOptionlist.forEach((domOption)=>{
            const isSelected = typeof selectedOption !== 'undefined' ? domOption.dataset.value === selectedOption.value : false;
            if (isSelected) ulRef.current.setAttribute('aria-activedescendant', domOption.id);
            domOption.setAttribute('aria-selected', isSelected);
        });
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: classes.join(' '),
        role: "listbox",
        ref: ulRef,
        tabIndex: "-1",
        "aria-label": "list",
        "aria-labelledby": labelId,
        "aria-activedescendant": getSelectedAria(),
        onKeyDown: (e)=>handleKeyDown(e),
        id: `${labelId}_option-list`,
        "data-testid": "option-list",
        children: options.map((opt, index)=>{
            const defaultClasses = [
                'items'
            ];
            opt.disabled && defaultClasses.push('disabled');
            const optionClasses = opt.classes instanceof Array ? [
                ...defaultClasses,
                ...opt.classes
            ] : [
                ...defaultClasses,
                opt.classes
            ];
            return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                role: "option",
                "data-value": opt.value,
                "aria-selected": opt.selected ? 'true' : 'false',
                "aria-disabled": opt.disabled ? true : undefined,
                className: optionClasses.join(' '),
                id: `${`${labelId}_${index}`}`,
                onClick: (e)=>itemSelect(index, true, e.keyCode),
                onKeyDown: (e)=>itemSelect(index, true, e.keyCode),
                children: opt.name
            }, `${opt.name + index}`);
        })
    });
});
$558a1874964eed3d$var$Dropdown.displayName = 'Dropdown';
$558a1874964eed3d$var$Dropdown.propTypes = {
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
        ])
    })).isRequired,
    handleSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    labelId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    }),
    isVisible: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isResizing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $558a1874964eed3d$var$Dropdown$1 = $558a1874964eed3d$var$Dropdown;
const $558a1874964eed3d$var$getAriaLabel = (label, labelModifier)=>{
    if (labelModifier === 'required') return `* ${label}`;
    if (labelModifier === 'optional') return `${label} (Optional)`;
    return label;
};
const $558a1874964eed3d$var$SelectInput$1 = ({ id: id, name: name, label: label, onSelect: onSelect, options: options, labelModifier: labelModifier, disabled: disabled = false, error: error, microcopy: microcopy, hideLabel: hideLabel = false, condensed: condensed = false, attributes: attributes = {}, classes: modifierClasses = [] })=>{
    const inputRef = (0, $acw62.useRef)();
    const selectRef = (0, $acw62.useRef)();
    const dropdownRef = (0, $acw62.useRef)();
    const buttonRef = (0, $acw62.useRef)();
    const [optionWidth, setOptionWidth] = (0, $acw62.useState)(null);
    const [prevSelected, setPrevSelected] = (0, $acw62.useState)();
    const [selected, setSelected] = (0, $acw62.useState)(options.find((option)=>option.selected));
    const [showDropdown, setShowDropDown] = (0, $acw62.useState)(false);
    const isMounted = $558a1874964eed3d$var$useIsMounted$1();
    const handleToggle = (e)=>{
        e.preventDefault();
        setShowDropDown(!showDropdown);
    };
    const handleSelect = (option, triggerToggle, key)=>{
        setSelected(option);
        if (triggerToggle) {
            // Collapse menu by setting dropdown to false for tab and focusing on button for enter key. If key
            // is undefined, then we assume we're dealing with a click handler and collapse the menu
            if (key === 9 || key === 27 || key === undefined) setShowDropDown(false);
            buttonRef.current.focus();
        }
    };
    const handleKeyDown = (event)=>{
        const isDropdownVisible = showDropdown;
        if (!disabled) {
            if (showDropdown && event.keyCode !== 13) dropdownRef.current.handleParentKeyDown(event, isDropdownVisible);
            else if (!showDropdown && (event.keyCode === 38 || event.keyCode === 40 || event.keyCode === 13 || event.keyCode === 32)) {
                // Using keys and menu isn't showing
                selectRef.current.querySelector('.dropdown.option').style.display = 'flex';
                setShowDropDown(!showDropdown);
                dropdownRef.current.handleParentKeyDown(event, isDropdownVisible);
            } else if (showDropdown && event.keyCode === 13) {
                // Using enter key when dropdown shows, collapse dropdown and focus on button
                setShowDropDown(!showDropdown);
                buttonRef.current.focus();
            }
        }
    };
    const handleDomClick = (0, $acw62.useCallback)((e)=>{
        if (e.target === selectRef.current || selectRef.current.contains(e.target)) return false;
        if (showDropdown) setShowDropDown(false);
        return true;
    }, [
        showDropdown,
        selected
    ]);
    const setValue = ()=>{
        let defaultOption;
        if (options.length) defaultOption = options.find((eachValue)=>eachValue.selected === true);
        if (!defaultOption) defaultOption = {
            name: '',
            value: undefined
        };
        setSelected(defaultOption);
        setPrevSelected(defaultOption);
    };
    (0, $acw62.useEffect)(()=>{
        if (showDropdown) document.addEventListener('click', handleDomClick, false);
        else document.removeEventListener('click', handleDomClick, false);
        return ()=>{
            document.removeEventListener('click', handleDomClick, false);
        };
    }, [
        showDropdown
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMounted) {
            const isValueUpdated = !prevSelected || selected.value !== prevSelected.value;
            const isValuePopulated = selected.value !== undefined;
            if (!showDropdown && isValueUpdated && isValuePopulated) {
                onSelect(selected && selected.value || '');
                setPrevSelected(selected);
            }
        }
    }, [
        selected,
        showDropdown
    ]);
    (0, $acw62.useEffect)(()=>{
        setValue();
        setOptionWidth(null);
    }, [
        options
    ]);
    // Refresh the component's width if the component is fully initialized or if the options have been updated
    (0, $acw62.useEffect)(()=>{
        if (dropdownRef.current && optionWidth === null) {
            const { listDom: listDom } = dropdownRef.current;
            setOptionWidth(listDom.getBoundingClientRect().width);
        }
    }, [
        dropdownRef,
        optionWidth
    ]);
    const optionStateClasses = [
        'axiom-selected-option selected-option'
    ];
    if (disabled) optionStateClasses.push('disabled');
    if (condensed) optionStateClasses.push('condensed');
    if (showDropdown) optionStateClasses.push('up');
    else optionStateClasses.push('down');
    const normalizedPropClasses = modifierClasses instanceof Array ? modifierClasses : [
        modifierClasses
    ];
    const controllerClasses = [
        'axiom-select-input',
        ...normalizedPropClasses
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($558a1874964eed3d$var$InputControl$1, {
        id: id,
        classes: controllerClasses,
        label: label,
        labelModifier: labelModifier,
        error: error,
        microcopy: microcopy,
        hideLabel: hideLabel,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "input-control--select--wrap",
                "data-testid": "select-wrapper",
                ref: selectRef,
                style: {
                    width: optionWidth ? `${optionWidth}px` : null
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        "data-testid": "selected-label",
                        onKeyUp: handleKeyDown,
                        className: optionStateClasses.join(' '),
                        onClick: handleToggle,
                        "aria-describedby": error || microcopy ? `${id}_messages` : null,
                        "aria-haspopup": "listbox",
                        "aria-owns": `${id}_textbox`,
                        "aria-label": $558a1874964eed3d$var$getAriaLabel(label, labelModifier),
                        "aria-controls": `${id}_option-list`,
                        "aria-disabled": disabled ? true : undefined,
                        "aria-invalid": error ? true : undefined,
                        "aria-required": labelModifier === 'required' ? true : undefined,
                        ref: buttonRef,
                        id: id,
                        role: "combobox",
                        "aria-expanded": showDropdown ? 'true' : 'false',
                        tabIndex: 0,
                        ...attributes,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "axiom-select--selected-option-label",
                                children: selected && selected.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                                name: showDropdown ? 'caret-up' : 'caret-down'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        ref: inputRef,
                        id: `${id}_textbox`,
                        name: name,
                        type: "hidden",
                        className: "axiom-select-input--input",
                        defaultValue: selected ? selected.value : undefined
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Dropdown$1, {
                        ref: dropdownRef,
                        options: options,
                        selected: selected,
                        condensed: condensed,
                        handleSelect: handleSelect,
                        isVisible: showDropdown,
                        isResizing: optionWidth === null,
                        labelId: id
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {})
        ]
    });
};
$558a1874964eed3d$var$SelectInput$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
        ])
    })).isRequired,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$SelectInputJSX = $558a1874964eed3d$var$SelectInput$1;
var $558a1874964eed3d$export$d6701e98ab1a6725 = function(_a) {
    var id = _a.id, name = _a.name, label = _a.label, onSelect = _a.onSelect, options = _a.options, _b = _a.labelModifier, labelModifier = _b === void 0 ? undefined : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.error, error = _d === void 0 ? undefined : _d, _e = _a.microcopy, microcopy = _e === void 0 ? undefined : _e, _f = _a.hideLabel, hideLabel = _f === void 0 ? false : _f, _g = _a.condensed, condensed = _g === void 0 ? false : _g, _h = _a.attributes, attributes = _h === void 0 ? {} : _h, _j = _a.classes, classes = _j === void 0 ? [] : _j;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$SelectInputJSX, {
        id: id,
        classes: classes,
        name: name,
        label: label,
        options: options,
        labelModifier: labelModifier,
        disabled: disabled,
        error: error,
        microcopy: microcopy,
        onSelect: onSelect,
        hideLabel: hideLabel,
        condensed: condensed,
        attributes: attributes
    });
};
$558a1874964eed3d$export$d6701e98ab1a6725.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
        ])
    })).isRequired,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$Skeleton$1 = ({ width: width, height: height, id: id = null, variant: variant = 'rectangle', classes: classes = [], attributes: attributes = {}, assistiveText: assistiveText = 'loading' })=>{
    const [currentAssistiveText, setCurrentAssistiveText] = (0, $acw62.useState)(assistiveText.isArray ? assistiveText[0] : assistiveText);
    let className = 'animateGlimmer';
    if (variant === 'circle') className += ' circle';
    (0, $acw62.useEffect)(()=>{
        if (assistiveText.isArray && assistiveText.length > 1) setTimeout(()=>{
            const newIndex = assistiveText.indexOf(currentAssistiveText) + 1;
            const newAssistiveText = newIndex < assistiveText.length ? assistiveText[newIndex] : assistiveText[0];
            setCurrentAssistiveText(newAssistiveText);
            return newAssistiveText;
        }, 10000);
    }, [
        currentAssistiveText
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: id,
        "data-testid": "skeleton-wrap",
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-skeleton',
                'skeleton-wrap'
            ],
            custom: classes,
            required: []
        }),
        ...attributes,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "skeleton--assistive-text screen-reader-only",
                "aria-live": "polite",
                children: currentAssistiveText
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: className,
                style: {
                    width: width,
                    height: height
                },
                "aria-hidden": "true"
            })
        ]
    });
};
$558a1874964eed3d$var$Skeleton$1.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'rectangle',
        'circle'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    assistiveText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$SkeletonJSX = $558a1874964eed3d$var$Skeleton$1;
var $558a1874964eed3d$export$8f31e4c4a37b8e9c = function(_a) {
    var width = _a.width, height = _a.height, _b = _a.id, id = _b === void 0 ? null : _b, _c = _a.variant, variant = _c === void 0 ? 'rectangle' : _c, _d = _a.classes, classes = _d === void 0 ? [] : _d, _e = _a.attributes, attributes = _e === void 0 ? {} : _e, _f = _a.assistiveText, assistiveText = _f === void 0 ? 'loading' : _f;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$SkeletonJSX, {
        id: id,
        width: width,
        height: height,
        variant: variant,
        classes: classes,
        attributes: attributes,
        assistiveText: assistiveText
    });
};
$558a1874964eed3d$export$8f31e4c4a37b8e9c.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'rectangle',
        'circle'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    assistiveText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$export$7f7cbe89f1eacd2 = function(_a) {
    var _b = _a.id, id = _b === void 0 ? null : _b, _c = _a.mode, mode = _c === void 0 ? 'dark' : _c, _d = _a.classes, classes = _d === void 0 ? [] : _d, _e = _a.attributes, attributes = _e === void 0 ? {} : _e, _f = _a.assistiveText, assistiveText = _f === void 0 ? 'loading' : _f;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$SpinnerJSX, {
        id: id,
        mode: mode,
        classes: classes,
        attributes: attributes,
        assistiveText: assistiveText
    });
};
$558a1874964eed3d$export$7f7cbe89f1eacd2.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'light',
        'dark'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    assistiveText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$ARROW_UP_KEYS = [
    'ArrowUp',
    'Up'
];
const $558a1874964eed3d$var$ARROW_DOWN_KEYS = [
    'ArrowDown',
    'Down'
];
const $558a1874964eed3d$var$ESCAPE_KEYS = [
    'Escape',
    'Esc'
];
const $558a1874964eed3d$var$traverseDOM = (startNode, callback)=>{
    let node = startNode;
    while(node !== document.body){
        if (callback(node)) return true;
        node = node.parentNode || document.body;
    }
    return false;
};
const $558a1874964eed3d$var$SplitButton$1 = ({ actions: actions, secondary: secondary = false, classes: classes = [] })=>{
    const componentRef = (0, $acw62.useRef)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [closing, setClosing] = (0, $acw62.useState)(false);
    // @todo: needs review [MJ]
    const optionRefs = actions.slice(1).map((obj)=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const ref = obj.inputRef ? obj.inputRef : (0, $acw62.useRef)();
        return ref;
    });
    const optionsClasses = [
        'axiom-split-button--options split-button--options'
    ];
    if (open) optionsClasses.push('split-button--options--open');
    else if (closing) optionsClasses.push('split-button--options--closing');
    else optionsClasses.push('split-button--options--hidden');
    const handleOpenChange = (newOpen)=>{
        setOpen(newOpen);
        if (newOpen) optionRefs[0].current.focus();
        if (newOpen === false) {
            setClosing(true);
            setTimeout(()=>{
                setClosing(false);
            }, 200);
        }
    };
    const currentIndexOfNode = (node)=>optionRefs.map((x)=>x.current).indexOf(node);
    const handleKeyUpWhenOpen = (0, $acw62.useCallback)(({ key: key, target: target })=>{
        if ($558a1874964eed3d$var$ESCAPE_KEYS.includes(key)) handleOpenChange(false);
        if ($558a1874964eed3d$var$ARROW_DOWN_KEYS.includes(key)) $558a1874964eed3d$var$traverseDOM(target, (node)=>{
            const currentIndex = currentIndexOfNode(node);
            const lastIndex = optionRefs.length - 1;
            if (currentIndex !== -1) {
                if (currentIndex === lastIndex) return true;
                /* istanbul ignore else */ if (currentIndex < lastIndex) {
                    optionRefs[currentIndex + 1].current.focus();
                    return true;
                }
            }
            if (node === componentRef.current) {
                optionRefs[0].current.focus();
                return true;
            }
            return false;
        });
        if ($558a1874964eed3d$var$ARROW_UP_KEYS.includes(key)) $558a1874964eed3d$var$traverseDOM(target, (node)=>{
            const currentIndex = currentIndexOfNode(node);
            if (currentIndex > 0) {
                optionRefs[currentIndex - 1].current.focus();
                return true;
            }
            return false;
        });
    }, []);
    const handleKeyUpWhenClosed = (0, $acw62.useCallback)(({ key: key, target: target })=>{
        /* istanbul ignore else */ if ($558a1874964eed3d$var$ARROW_DOWN_KEYS.includes(key)) $558a1874964eed3d$var$traverseDOM(target, (node)=>{
            const componentNode = componentRef.current;
            if (node === componentNode) {
                handleOpenChange(true);
                return true;
            }
            return false;
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        const cleanupOpenListeners = ()=>{
            document.removeEventListener('keyup', handleKeyUpWhenOpen, false);
        };
        const cleanupClosedListeners = ()=>{
            document.removeEventListener('keyup', handleKeyUpWhenClosed, false);
        };
        if (open) {
            cleanupClosedListeners();
            document.addEventListener('keyup', handleKeyUpWhenOpen, false);
        } else {
            cleanupOpenListeners();
            document.addEventListener('keyup', handleKeyUpWhenClosed, false);
        }
        return ()=>{
            cleanupOpenListeners();
            cleanupClosedListeners();
        };
    }, [
        open
    ]);
    const handleNonPrimaryButtonClick = (onClick)=>{
        handleOpenChange(false);
        onClick();
    };
    const handleBlur = (e)=>{
        /* istanbul ignore next */ const target = e.relatedTarget || document.activeElement;
        if (target === null || target.nodeType !== 1) {
            handleOpenChange(false);
            return;
        }
        const parentFound = $558a1874964eed3d$var$traverseDOM(target, (node)=>node === componentRef.current);
        if (!parentFound) handleOpenChange(false);
    };
    const [optionsId] = (0, $acw62.useState)((0, $5sKyw.default)());
    if (actions.length < 2) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: 'Minimum of 2 actions are required, have you considered using <Button/>?'
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-split-button split-button'
            ],
            custom: classes,
            required: []
        }),
        ref: componentRef,
        "data-testid": "split-button",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "split-button--button",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                        label: actions[0].label,
                        onClick: actions[0].onClick,
                        styleVariant: secondary ? 'secondary' : 'primary',
                        attributes: {
                            'onBlur': handleBlur,
                            'data-testid': 'split-button-primary'
                        },
                        inputRef: actions[0].inputRef
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Button$2, {
                        icon: "caret-down",
                        label: `${actions[0].label} actions`,
                        iconOnly: true,
                        onClick: ()=>handleOpenChange(!open),
                        styleVariant: "secondary",
                        attributes: {
                            'aria-controls': optionsId,
                            'aria-haspopup': 'true',
                            'aria-expanded': open,
                            'onBlur': handleBlur,
                            'data-testid': 'split-button-open-options'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                id: optionsId,
                "data-testid": "split-button-options",
                className: optionsClasses.join(' '),
                role: "menu",
                children: actions.slice(1).map(({ label: label, onClick: onClick }, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        role: "menuitem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            ref: optionRefs[i],
                            onClick: ()=>handleNonPrimaryButtonClick(onClick),
                            onBlur: handleBlur,
                            children: label
                        })
                    }, `${label + i}`))
            })
        ]
    });
};
$558a1874964eed3d$var$SplitButton$1.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                    current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
                })
            ])
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        })
    ])).isRequired,
    secondary: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$SplitButtonJSX = $558a1874964eed3d$var$SplitButton$1;
var $558a1874964eed3d$export$651ad66661acd392 = function(_a) {
    var actions = _a.actions, _b = _a.secondary, secondary = _b === void 0 ? false : _b, _c = _a.classes, classes = _c === void 0 ? [] : _c;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$SplitButtonJSX, {
        actions: actions,
        secondary: secondary,
        classes: classes
    });
};
$558a1874964eed3d$export$651ad66661acd392.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                    current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
                })
            ])
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        })
    ])).isRequired,
    secondary: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$Caption = ({ children: children, hideCaption: hideCaption = false, attributes: attributes = {} })=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-props-no-spreading
    (0, $ayMG0.jsx)("caption", {
        ...attributes,
        className: $558a1874964eed3d$var$createClassList({
            default: 'axiom-table--caption',
            custom: [
                hideCaption ? 'screen-reader-only' : null
            ]
        }),
        children: children
    });
$558a1874964eed3d$var$Caption.displayName = 'Table.Caption';
$558a1874964eed3d$var$Caption.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    hideCaption: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
};
var $558a1874964eed3d$var$Caption$1 = $558a1874964eed3d$var$Caption;
const $558a1874964eed3d$var$Header = ({ children: children = null, classes: classes = [], attributes: attributes = {}, ...props })=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-props-no-spreading
    (0, $ayMG0.jsx)("thead", {
        ...attributes,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-table--header'
            ],
            custom: classes
        }),
        children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child)=>child && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
                ...props,
                header: true
            }))
    });
$558a1874964eed3d$var$Header.displayName = 'Table.Header';
$558a1874964eed3d$var$Header.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
};
var $558a1874964eed3d$var$Header$1 = $558a1874964eed3d$var$Header;
const $558a1874964eed3d$var$Body = ({ children: children = null, classes: classes = [], attributes: attributes = {}, ...props })=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-props-no-spreading
    (0, $ayMG0.jsx)("tbody", {
        ...attributes,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-table--body'
            ],
            custom: classes
        }),
        children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child, rowIndex)=>child && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
                ...props,
                rowIndex: rowIndex
            }))
    });
$558a1874964eed3d$var$Body.displayName = 'Table.Body';
$558a1874964eed3d$var$Body.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
};
var $558a1874964eed3d$var$Body$1 = $558a1874964eed3d$var$Body;
const $558a1874964eed3d$var$Cell = ({ children: children = null, id: id = null, cellIndex: cellIndex = false, header: header = false, headerType: headerType = null, align: align = 'left', classes: classes = '', sortable: sortable = null, tableSortable: tableSortable = null, sortOrder: sortOrder = null, updateSortOrder: updateSortOrder = ()=>{}, monospacedNumbers: monospacedNumbers = false, attributes: attributes = {} })=>{
    const cellRef = (0, $acw62.useRef)();
    const elementType = header ? 'th' : 'td';
    const cellClasses = [
        'axiom-table--cell',
        `cell--alignment--${align}`,
        monospacedNumbers && 'cell--monospacedNumbers',
        classes
    ];
    const cellId = id || cellIndex;
    const cellChildren = children instanceof Array ? [
        ...children
    ] : [
        children
    ];
    const isSortable = sortable !== null ? sortable : tableSortable;
    let clickHandler = null;
    const cellProps = {
        ...attributes
    };
    if (header) cellProps.role = `${headerType}header`;
    if (header && cellIndex !== null && isSortable) {
        const cellText = cellChildren.toString();
        clickHandler = ()=>updateSortOrder(cellId, cellRef);
        cellClasses.push('cell--sortable');
        cellProps.scope = 'col';
        if (sortOrder.id === cellId) {
            cellChildren.splice(cellChildren.indexOf(cellText), 1, /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                className: "axiom-table--heading-sorter th-button",
                "aria-label": cellText,
                title: `sorted by ${sortOrder.direction === 'asc' ? 'ascending' : 'descending'}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                        name: `sort-${sortOrder.direction}`
                    }),
                    cellText
                ]
            }, 'table-icon'));
            cellClasses.push('cell-sorted');
            if (sortOrder.direction === 'asc') cellProps['aria-sort'] = 'ascending';
            else cellProps['aria-sort'] = 'descending';
        } else cellChildren.splice(cellChildren.indexOf(cellText), 1, /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
            type: "button",
            className: "axiom-table--heading-sorter th-button",
            "aria-label": cellText,
            title: "unsorted",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Icon$2, {
                    name: "sortable"
                }),
                cellText
            ]
        }, 'table-icon'));
    }
    cellProps.className = cellClasses.filter((s)=>s).join(' ');
    cellProps.onClick = clickHandler;
    cellProps.ref = cellRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(elementType, cellProps, cellChildren);
};
$558a1874964eed3d$var$Cell.displayName = 'Table.Cell';
$558a1874964eed3d$var$Cell.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    headerType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'row',
        'column'
    ]),
    tableSortable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    sortable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    align: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'left',
        'right'
    ]),
    cellIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    updateSortOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    sortOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        direction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'asc',
            'desc'
        ])
    }),
    monospacedNumbers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    // eslint-disable-next-line react/forbid-prop-types
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
};
var $558a1874964eed3d$var$Cell$1 = $558a1874964eed3d$var$Cell;
const $558a1874964eed3d$var$Row = ({ children: children = null, header: header = null, tableSelectable: tableSelectable = null, tableSortable: tableSortable = null, tableId: tableId = null, id: id = null, ariaLabel: ariaLabel = null, rowIndex: rowIndex = null, bodyRows: bodyRows = [], selected: selected = false, selectable: selectable = null, toggleRow: toggleRow = ()=>{}, sortOrder: sortOrder = null, updateSortOrder: updateSortOrder = ()=>{}, attributes: attributes = {} })=>{
    const cellProps = {
        header: header,
        tableSortable: tableSortable,
        tableId: tableId,
        sortOrder: sortOrder,
        updateSortOrder: updateSortOrder
    };
    const modifiedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child, cellIndex)=>{
        if (child) {
            const isHeader = header || child.props.header;
            const isColumnHeader = rowIndex === null;
            const childProps = {
                ...cellProps,
                header: isHeader,
                cellIndex: cellIndex
            };
            if (isHeader) childProps.headerType = isColumnHeader ? 'column' : 'row';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, childProps);
        }
        return null;
    });
    if (tableSelectable) {
        const rowId = id === null ? tableId : id;
        const selectorId = `${rowId}-selector--${header ? 'header' : rowIndex}`;
        let checked = selected;
        let indeterminate = false;
        let checkboxLabel = `Select Row ${rowIndex}`;
        if (header) {
            checked = null;
            checkboxLabel = 'Select All Rows';
            bodyRows.some((row)=>{
                const rowSelected = row.props.selected;
                if (row.props.selectable !== false) {
                    if (checked !== null) indeterminate = rowSelected !== checked;
                    checked = checked || rowSelected;
                }
                return indeterminate;
            });
        } else if (typeof modifiedChildren[0].props.children === 'string') checkboxLabel = `Select ${modifiedChildren[0].props.children}`;
        if (selectable === false) // eslint-disable-next-line react/jsx-props-no-spreading
        modifiedChildren.unshift(/*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Cell$1, {
            ...cellProps,
            classes: "cell--selector"
        }, 'cell--selector'));
        else // [HACK] In order to address an A11Y bug in JAWS, we are opting to render this selector cell as a standard table cell (td) to
        // prevent JAWS from announcing the header cell's label when the user focuses on the checkbox. We should remove this behaviour
        // in the future if JAWS correctly uses the `aria-labelledby` prop's intended functionality
        // ---------------
        modifiedChildren.unshift(/*#__PURE__*/ // eslint-disable-next-line react/jsx-props-no-spreading
        (0, $ayMG0.jsx)($558a1874964eed3d$var$Cell$1, {
            ...cellProps,
            header: false,
            classes: "cell--selector axiom-table--header-row",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Checkbox$2, {
                id: selectorId,
                name: `${rowId}-selector`,
                label: ariaLabel || checkboxLabel,
                hideLabel: true,
                onChange: ()=>toggleRow(rowIndex, !checked),
                checked: checked,
                indeterminate: indeterminate,
                classes: "axiom-table--row-selector"
            })
        }, 'cell--selector'));
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
        ...attributes,
        className: "axiom-table--row",
        id: id,
        role: "row",
        children: modifiedChildren
    });
};
$558a1874964eed3d$var$Row.displayName = 'Table.Row';
$558a1874964eed3d$var$Row.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    tableSelectable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tableSortable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tableId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    selectable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    rowIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    bodyRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node),
    toggleRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    updateSortOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    sortOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        direction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'asc',
            'desc'
        ])
    }),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
};
var $558a1874964eed3d$var$Row$1 = $558a1874964eed3d$var$Row;
const $558a1874964eed3d$var$getComponentType = (component)=>{
    if (component) {
        const componentType = component.type;
        return typeof componentType === 'string' ? componentType : componentType.displayName;
    }
    return 'null';
};
const $558a1874964eed3d$var$useSubComponentsByType = (children)=>{
    const results = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
        const childType = $558a1874964eed3d$var$getComponentType(child);
        if (results[childType]) results[childType].push(child);
        else results[childType] = [
            child
        ];
    });
    return results;
};
const $558a1874964eed3d$var$defaultOnSort = ({ id: id, rows: rows, direction: direction })=>{
    const row1Data = rows[0].props.data || {};
    const row2Data = rows[1].props.data || {};
    const row1CellText = rows[0].cellDom ? rows[0].cellDom.innerText : '';
    const row2CellText = rows[1].cellDom ? rows[1].cellDom.innerText : '';
    const row1Value = typeof row1Data[id] !== 'undefined' ? row1Data[id] : row1CellText;
    const row2Value = typeof row2Data[id] !== 'undefined' ? row2Data[id] : row2CellText;
    const sortModifier = direction === 'asc' ? 1 : -1;
    return row1Value > row2Value ? sortModifier : sortModifier * -1;
};
const $558a1874964eed3d$var$getSortableRows = ({ rows: rows, cellIndex: cellIndex, tableRef: tableRef })=>{
    if (!(rows instanceof Array)) return [];
    return rows.map((row, rowIndex)=>({
            ...row,
            rowIndex: rowIndex,
            cellIndex: cellIndex,
            cellDom: tableRef.current.querySelector('tbody').children[rowIndex].children[cellIndex]
        }));
};
const $558a1874964eed3d$var$getSortedRows = ({ id: id, rows: rows, direction: direction, onSort: onSort, cellIndex: cellIndex, tableRef: tableRef })=>{
    const sortableRows = $558a1874964eed3d$var$getSortableRows({
        rows: rows,
        cellIndex: cellIndex,
        tableRef: tableRef
    });
    const updatedRows = onSort({
        id: id,
        rows: sortableRows,
        direction: direction
    });
    if (typeof updatedRows !== 'undefined') return updatedRows;
    return sortableRows.sort((row1, row2)=>$558a1874964eed3d$var$defaultOnSort({
            id: id,
            direction: direction,
            rows: [
                row1,
                row2
            ]
        }));
};
const $558a1874964eed3d$var$getInitialSort = (reactRows, sort, disableAutoSort)=>{
    if (reactRows && sort.id && !disableAutoSort) return reactRows.sort((row1, row2)=>$558a1874964eed3d$var$defaultOnSort({
            id: sort.id,
            direction: sort.direction,
            rows: [
                row1,
                row2
            ]
        }));
    return reactRows;
};
const $558a1874964eed3d$var$normalizeSort = (sort)=>{
    if (typeof sort === 'string') return {
        id: sort,
        direction: 'asc'
    };
    return sort;
};
// [TABLE]
const $558a1874964eed3d$var$Table$1 = ({ children: children = null, selectable: selectable = false, sortable: sortable = false, id: id = null, initialSort: initialSort = {
    id: null,
    direction: 'asc'
}, disableAutoSort: disableAutoSort = false, classes: classes = [], attributes: attributes = {}, onSort: onSort = ()=>{}, onSelection: onSelection = ()=>{} })=>{
    const tableRef = (0, $acw62.useRef)();
    const tableRowsRef = (0, $acw62.useRef)();
    const childrenByType = $558a1874964eed3d$var$useSubComponentsByType(children);
    const tableId = id === null ? (0, $5sKyw.default)() : id;
    const hasCaption = typeof childrenByType['Table.Caption'] !== 'undefined';
    const hasHeader = typeof childrenByType['Table.Header'] !== 'undefined';
    const hasBody = typeof childrenByType['Table.Body'] !== 'undefined';
    const caption = hasCaption ? childrenByType['Table.Caption'][0] : null;
    const header = hasHeader ? childrenByType['Table.Header'][0] : null;
    const body = hasBody ? childrenByType['Table.Body'][0] : /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Body$1, {
        children: childrenByType['Table.Row']
    });
    const bodyChildrenByType = $558a1874964eed3d$var$useSubComponentsByType(body.props.children);
    const [sortOrder, setSortOrder] = (0, $acw62.useState)($558a1874964eed3d$var$normalizeSort(initialSort));
    const [bodyRows, setBodyRows] = (0, $acw62.useState)($558a1874964eed3d$var$getInitialSort(bodyChildrenByType['Table.Row'], sortOrder, disableAutoSort));
    const [selectedRows, setSelectedRows] = (0, $acw62.useState)(bodyRows && bodyRows.map((row, rowIndex)=>({
            rowIndex: rowIndex,
            data: row.props.data || {},
            selected: row.props.selected
        })).filter((row)=>row.selected));
    const toggleRow = (rowIndex, checked)=>{
        const modifiedBodyRows = [
            ...bodyRows
        ];
        let modifiedRow;
        let rowProps;
        if (rowIndex !== null) {
            modifiedRow = {
                ...modifiedBodyRows[rowIndex]
            };
            rowProps = {
                ...modifiedRow.props
            };
            rowProps.selected = checked;
            modifiedRow.props = rowProps;
            modifiedBodyRows[rowIndex] = modifiedRow;
        } else for(let index = 0; index < modifiedBodyRows.length; index++){
            modifiedRow = {
                ...modifiedBodyRows[index]
            };
            rowProps = {
                ...modifiedRow.props
            };
            rowProps.selected = checked;
            modifiedRow.props = rowProps;
            modifiedBodyRows[index] = modifiedRow;
        }
        setBodyRows(modifiedBodyRows);
        setSelectedRows(modifiedBodyRows.map((row, modifiedRowIndex)=>({
                rowIndex: modifiedRowIndex,
                data: row.props.data || {},
                selected: row.props.selected
            })).filter((row)=>row.selected));
    };
    const updateSortOrder = (cellId, cellRef)=>{
        let direction = 'asc';
        const { cellIndex: cellIndex } = cellRef.current;
        if (sortOrder.id === cellId && sortOrder.direction === 'asc') direction = 'desc';
        if (disableAutoSort) {
            const sortableRows = $558a1874964eed3d$var$getSortableRows({
                rows: bodyRows,
                cellIndex: cellIndex,
                tableRef: tableRef
            });
            onSort({
                id: cellId,
                rows: sortableRows,
                direction: direction
            });
        } else setBodyRows($558a1874964eed3d$var$getSortedRows({
            id: cellId,
            direction: direction,
            rows: bodyRows,
            onSort: onSort,
            cellIndex: cellIndex,
            tableRef: tableRef
        }));
        setSortOrder({
            id: cellId,
            direction: direction
        });
    };
    (0, $acw62.useEffect)(()=>onSelection(selectedRows), [
        selectedRows
    ]);
    (0, $acw62.useEffect)(()=>setBodyRows(bodyChildrenByType['Table.Row']), [
        children
    ]);
    const subComponentProps = {
        tableSelectable: selectable,
        tableSortable: sortable,
        tableId: tableId,
        bodyRows: bodyRows,
        sortOrder: sortOrder,
        toggleRow: toggleRow,
        updateSortOrder: updateSortOrder
    };
    const tableProps = {
        ...attributes,
        id: id,
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'axiom-table'
            ],
            custom: classes,
            required: []
        })
    };
    return(/*#__PURE__*/ // eslint-disable-next-line react/jsx-props-no-spreading
    (0, $ayMG0.jsxs)("table", {
        ref: tableRef,
        ...tableProps,
        children: [
            caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(caption, subComponentProps),
            header && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(header, subComponentProps),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(body, {
                ...subComponentProps,
                children: bodyRows,
                forwardRef: tableRowsRef
            })
        ]
    }));
};
$558a1874964eed3d$var$Table$1.Caption = $558a1874964eed3d$var$Caption$1;
$558a1874964eed3d$var$Table$1.Header = $558a1874964eed3d$var$Header$1;
$558a1874964eed3d$var$Table$1.Body = $558a1874964eed3d$var$Body$1;
$558a1874964eed3d$var$Table$1.Row = $558a1874964eed3d$var$Row$1;
$558a1874964eed3d$var$Table$1.Cell = $558a1874964eed3d$var$Cell$1;
$558a1874964eed3d$var$Table$1.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    selectable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    sortable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    initialSort: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            direction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                'asc',
                'desc'
            ])
        })
    ]),
    disableAutoSort: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    // eslint-disable-next-line react/forbid-prop-types
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    onSort: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSelection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$TableJSX = $558a1874964eed3d$var$Table$1;
var $558a1874964eed3d$export$54ec01a60f47d33d = function(_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b, _c = _a.selectable, selectable = _c === void 0 ? false : _c, _d = _a.sortable, sortable = _d === void 0 ? false : _d, _e = _a.id, id = _e === void 0 ? null : _e, _f = _a.initialSort, initialSort = _f === void 0 ? {
        id: null,
        direction: 'asc'
    } : _f, _g = _a.disableAutoSort, disableAutoSort = _g === void 0 ? false : _g, _h = _a.classes, classes = _h === void 0 ? [] : _h, _j = _a.attributes, attributes = _j === void 0 ? {} : _j, _k = _a.onSort, onSort = _k === void 0 ? function() {} : _k, _l = _a.onSelection, onSelection = _l === void 0 ? function() {} : _l;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$TableJSX, {
        selectable: selectable,
        sortable: sortable,
        initialSort: initialSort,
        disableAutoSort: disableAutoSort,
        id: id,
        classes: classes,
        attributes: attributes,
        onSort: onSort,
        onSelection: onSelection,
        children: children
    });
};
$558a1874964eed3d$export$54ec01a60f47d33d.Body = $558a1874964eed3d$var$Body$1;
$558a1874964eed3d$export$54ec01a60f47d33d.Cell = $558a1874964eed3d$var$Cell$1;
$558a1874964eed3d$export$54ec01a60f47d33d.Header = $558a1874964eed3d$var$Header$1;
$558a1874964eed3d$export$54ec01a60f47d33d.Row = $558a1874964eed3d$var$Row$1;
$558a1874964eed3d$export$54ec01a60f47d33d.Caption = $558a1874964eed3d$var$Caption$1;
$558a1874964eed3d$export$54ec01a60f47d33d.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    selectable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    sortable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    initialSort: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            direction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
                'asc',
                'desc'
            ])
        })
    ]),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    disableAutoSort: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    onSort: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSelection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
/**
 *
 * A collection of common helpers for typography
 *
 * */ const $558a1874964eed3d$var$removeWhiteSpace = (str)=>str.replace(/\s/g, '');
const $558a1874964eed3d$var$Tab = ({ tab: tab, setFocus: setFocus, onTabClick: onTabClick, currentPosition: currentPosition, focus: focus = false, index: index = 0, selectedTab: selectedTab, ariaControl: ariaControl })=>{
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (focus) ref.current.focus();
    }, [
        focus
    ]);
    const setAnimatePosition = (event)=>{
        const currentBtn = event.currentTarget.getBoundingClientRect();
        const size = currentBtn.width > currentBtn.height ? currentBtn.width : currentBtn.height;
        const x = event.pageX > 0 ? event.pageX - currentBtn.left - size / 2 : (event.pageX + event.pageY) / 2;
        const y = event.pageY > 0 ? event.pageY - currentBtn.top - size / 2 : (event.pageX + event.pageY) / 2;
        return {
            x: x,
            y: y,
            size: size
        };
    };
    // White space controlled to match ID and ARIA elements
    // for improved assistive technology use.
    const trimmedTab = tab.trim();
    const noWhiteSpaceTab = $558a1874964eed3d$var$removeWhiteSpace(tab);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        role: "tab",
        "data-testid": "tab-item",
        className: `${tab === selectedTab ? 'axiom-tab--active tab--active' : 'axiom-tab'}`,
        id: `${noWhiteSpaceTab + index}`,
        tabIndex: index === 0 && !selectedTab || selectedTab === tab ? 0 : -1,
        type: "button",
        ref: ref,
        "data-title": trimmedTab,
        "aria-controls": ariaControl,
        "aria-selected": tab === selectedTab,
        onClick: (e)=>{
            const tabPosition = setAnimatePosition(e);
            onTabClick(tab, tabPosition);
            setFocus(index);
        },
        onFocus: ()=>{
            if (selectedTab === tab) setFocus(index);
        } // NOTE: This seems redundant but is needed for the following scenario:
        ,
        children: [
            trimmedTab,
            selectedTab && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    left: `${currentPosition.x}px`,
                    top: `${currentPosition.y}px`,
                    width: currentPosition.size,
                    height: currentPosition.size
                }
            })
        ]
    }, `${noWhiteSpaceTab + index}`);
};
$558a1874964eed3d$var$Tab.propTypes = {
    tab: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onTabClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    setFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    currentPosition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired
    }).isRequired,
    selectedTab: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    focus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    ariaControl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $558a1874964eed3d$var$Tab$1 = $558a1874964eed3d$var$Tab;
const $558a1874964eed3d$var$Tabs$1 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ tabs: tabs, onTabClick: onTabClick, selectedTab: selectedTab, classes: classes = [], disableAutoTabSwap: disableAutoTabSwap = false, attributes: attributes = {} }, refs)=>{
    const [currentTab, setCurrentTab] = (0, $acw62.useState)(selectedTab);
    const [currentPosition, setCurrentPosition] = (0, $acw62.useState)({
        x: 0,
        y: 0,
        size: 0
    });
    const [currentFocus, setCurrentFocus] = (0, $acw62.useState)(null);
    const handleKeyDown = (event)=>{
        if (event.keyCode === 39) {
            // when Right arrow key is pressed
            event.preventDefault();
            setCurrentFocus(currentFocus === tabs.length - 1 ? 0 : currentFocus + 1);
        } else if (event.keyCode === 37) {
            // when Left arrow key is pressed
            event.preventDefault();
            setCurrentFocus(currentFocus === 0 || !currentFocus ? tabs.length - 1 : currentFocus - 1);
        }
    };
    const handleTabClick = (tab, tabPosition)=>{
        onTabClick(tab);
        if (!disableAutoTabSwap) {
            setCurrentTab(tab);
            setCurrentPosition(tabPosition);
        }
    };
    (0, $acw62.useEffect)(()=>{
        setCurrentTab(selectedTab);
    }, [
        selectedTab
    ]);
    (0, $acw62.useImperativeHandle)(refs, ()=>({
            setTab: setCurrentTab
        }), []);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    (0, $ayMG0.jsx)("div", {
        ...attributes,
        role: "tablist",
        "data-testid": "tablist",
        onKeyDown: handleKeyDown,
        className: $558a1874964eed3d$var$createClassList({
            default: 'axiom-tabs tabs',
            custom: classes,
            required: []
        }),
        children: tabs.map((tab, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$Tab$1, {
                setFocus: setCurrentFocus,
                index: index,
                focus: currentFocus === index,
                tab: tab.name,
                ariaControl: tab.ariaControls,
                selectedTab: currentTab,
                currentPosition: currentPosition,
                onTabClick: handleTabClick
            }, tab.name))
    }));
});
$558a1874964eed3d$var$Tabs$1.displayName = 'Tabs';
$558a1874964eed3d$var$Tabs$1.propTypes = {
    tabs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        ariaControls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    })).isRequired,
    onTabClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    selectedTab: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    disableAutoTabSwap: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
};
var $558a1874964eed3d$var$TabsJSX = $558a1874964eed3d$var$Tabs$1;
var $558a1874964eed3d$export$b2539bed5023c21c = function(_a) {
    var tabs = _a.tabs, onTabClick = _a.onTabClick, _b = _a.selectedTab, selectedTab = _b === void 0 ? undefined : _b, _c = _a.classes, classes = _c === void 0 ? [] : _c, _d = _a.disableAutoTabSwap, disableAutoTabSwap = _d === void 0 ? false : _d, _e = _a.attributes, attributes = _e === void 0 ? {} : _e;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$TabsJSX, {
        tabs: tabs,
        onTabClick: onTabClick,
        selectedTab: selectedTab,
        classes: classes,
        disableAutoTabSwap: disableAutoTabSwap,
        attributes: attributes
    });
};
$558a1874964eed3d$export$b2539bed5023c21c.propTypes = {
    tabs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        ariaControls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    })).isRequired,
    onTabClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    selectedTab: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    disableAutoTabSwap: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
};
var $558a1874964eed3d$export$3288d34c523a1192 = function(_a) {
    var text = _a.text, _b = _a.color, color = _b === void 0 ? 'default' : _b, _c = _a.size, size = _c === void 0 ? 'full' : _c, _d = _a.classes, classes = _d === void 0 ? [] : _d;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$TagJSX, {
        text: text,
        color: color,
        size: size,
        classes: classes
    });
};
$558a1874964eed3d$export$3288d34c523a1192.propTypes = {
    text: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'orange',
        'red',
        'green',
        'default',
        'luna',
        'sunflower',
        'sienna',
        'jade',
        'vividCerulean',
        'rose',
        'brick',
        'mardiGras'
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'full',
        'small'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$TextArea$1 = ({ id: id, label: label, name: name, value: value, onChange: onChange, labelModifier: labelModifier, condensed: condensed = false, disabled: disabled = false, readOnly: readOnly = false, error: error, microcopy: microcopy, onBlur: onBlur, maxLength: maxLength, inputRef: inputRef, hideLabel: hideLabel = false, attributes: attributes = {}, classes: modifierClasses = [] })=>{
    const additionalProps = {};
    if (error) additionalProps['aria-invalid'] = 'true';
    if (labelModifier === 'required') additionalProps['aria-required'] = 'true';
    const handleOnChange = (e)=>{
        onChange(e.target.value);
    };
    const handleOnBlur = (e)=>{
        if (onBlur) {
            onBlur(e.target.value);
            return;
        }
        onChange(e.target.value);
    };
    const normalizedPropClasses = modifierClasses instanceof Array ? modifierClasses : [
        modifierClasses
    ];
    const controllerClasses = [
        'axiom-text-area',
        ...normalizedPropClasses
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$InputControl$1, {
        id: id,
        classes: controllerClasses,
        label: label,
        error: error,
        labelModifier: labelModifier,
        microcopy: microcopy,
        hideLabel: hideLabel,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: condensed ? 'axiom-text-area--input--wrap--condensed input-control--input--wrap--condensed' : 'axiom-text-area--input--wrap input-control--input--wrap',
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                id: id,
                "aria-describedby": error || microcopy ? `${id}_messages` : null,
                "data-testid": "textarea",
                name: name,
                value: value,
                onBlur: handleOnBlur,
                onChange: handleOnChange,
                disabled: disabled,
                readOnly: readOnly,
                maxLength: maxLength,
                className: "axiom-text-area--input",
                ref: inputRef,
                ...attributes,
                ...additionalProps
            })
        })
    });
};
$558a1874964eed3d$var$TextArea$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$TextAreaJSX = $558a1874964eed3d$var$TextArea$1;
var $558a1874964eed3d$export$f5c9f3c2c4054eec = function(_a) {
    var id = _a.id, label = _a.label, name = _a.name, value = _a.value, onChange = _a.onChange, _b = _a.labelModifier, labelModifier = _b === void 0 ? undefined : _b, _c = _a.condensed, condensed = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.readOnly, readOnly = _e === void 0 ? false : _e, _f = _a.error, error = _f === void 0 ? undefined : _f, _g = _a.microcopy, microcopy = _g === void 0 ? undefined : _g, _h = _a.onBlur, onBlur = _h === void 0 ? undefined : _h, _j = _a.maxLength, maxLength = _j === void 0 ? undefined : _j, _k = _a.inputRef, inputRef = _k === void 0 ? undefined : _k, _l = _a.hideLabel, hideLabel = _l === void 0 ? false : _l, _m = _a.attributes, attributes = _m === void 0 ? {} : _m, _o = _a.classes, classes = _o === void 0 ? [] : _o;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$TextAreaJSX, {
        id: id,
        classes: classes,
        label: label,
        name: name,
        value: value,
        labelModifier: labelModifier,
        disabled: disabled,
        condensed: condensed,
        readOnly: readOnly,
        error: error,
        microcopy: microcopy,
        onChange: onChange,
        onBlur: onBlur,
        maxLength: maxLength,
        inputRef: inputRef,
        hideLabel: hideLabel,
        attributes: attributes
    });
};
$558a1874964eed3d$export$f5c9f3c2c4054eec.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$export$c86715117507e8e5 = function(_a) {
    var id = _a.id, label = _a.label, name = _a.name, value = _a.value, onChange = _a.onChange, _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.labelModifier, labelModifier = _c === void 0 ? undefined : _c, _d = _a.condensed, condensed = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.readOnly, readOnly = _f === void 0 ? false : _f, _g = _a.error, error = _g === void 0 ? undefined : _g, _h = _a.microcopy, microcopy = _h === void 0 ? undefined : _h, _j = _a.onFocus, onFocus = _j === void 0 ? function() {} : _j, _k = _a.onBlur, onBlur = _k === void 0 ? undefined : _k, _l = _a.onKeyDown, onKeyDown = _l === void 0 ? undefined : _l, _m = _a.maxLength, maxLength = _m === void 0 ? undefined : _m, _o = _a.inputRef, inputRef = _o === void 0 ? undefined : _o, _p = _a.hideLabel, hideLabel = _p === void 0 ? false : _p, _q = _a.attributes, attributes = _q === void 0 ? {} : _q, _r = _a.classes, classes = _r === void 0 ? [] : _r;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$TextInputJSX, {
        id: id,
        classes: classes,
        label: label,
        type: type,
        name: name,
        value: value,
        labelModifier: labelModifier,
        condensed: condensed,
        disabled: disabled,
        readOnly: readOnly,
        error: error,
        microcopy: microcopy,
        onChange: onChange,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onBlur: onBlur,
        maxLength: maxLength,
        inputRef: inputRef,
        hideLabel: hideLabel,
        attributes: attributes
    });
};
$558a1874964eed3d$export$c86715117507e8e5.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'text',
        'email',
        'password',
        'url'
    ]),
    labelModifier: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'required',
        'optional'
    ]),
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    microcopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
const $558a1874964eed3d$var$Toggle$1 = ({ id: id, label: label, onChange: onChange, attributes: attributes = {}, condensed: condensed = false, hideLabel: hideLabel = false, inputRef: inputRef, labelPlacement: labelPlacement = 'right', on: on = false, classes: classes = [] })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: $558a1874964eed3d$var$createClassList({
            default: [
                `axiom-toggle toggle label-${hideLabel ? 'none' : labelPlacement}${condensed ? ' condensed' : ''}`
            ],
            custom: classes,
            required: []
        }),
        "data-testid": "toggle",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                id: id,
                type: "checkbox",
                "aria-label": label,
                checked: on,
                onChange: ()=>onChange(!on),
                "data-testid": "toggle-input",
                ref: inputRef,
                className: "axiom-toggle--input",
                role: "switch",
                "aria-checked": on,
                ...attributes
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                htmlFor: id,
                className: "axiom-toggle--label",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: hideLabel ? 'screen-reader-only' : '',
                    children: label
                })
            })
        ]
    });
$558a1874964eed3d$var$Toggle$1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    labelPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'left',
        'right'
    ]),
    on: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$ToggleJSX = $558a1874964eed3d$var$Toggle$1;
var $558a1874964eed3d$export$bea8ebba691c5813 = function(_a) {
    var id = _a.id, label = _a.label, onChange = _a.onChange, _b = _a.attributes, attributes = _b === void 0 ? {} : _b, _c = _a.condensed, condensed = _c === void 0 ? false : _c, _d = _a.hideLabel, hideLabel = _d === void 0 ? false : _d, _e = _a.inputRef, inputRef = _e === void 0 ? undefined : _e, _f = _a.labelPlacement, labelPlacement = _f === void 0 ? 'right' : _f, _g = _a.on, on = _g === void 0 ? false : _g, _h = _a.classes, classes = _h === void 0 ? [] : _h;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$ToggleJSX, {
        id: id,
        label: label,
        labelPlacement: labelPlacement,
        on: on,
        onChange: onChange,
        inputRef: inputRef,
        hideLabel: hideLabel,
        attributes: attributes,
        condensed: condensed,
        classes: classes
    });
};
$558a1874964eed3d$export$bea8ebba691c5813.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    condensed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any),
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    labelPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'left',
        'right'
    ]),
    on: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$export$28c660c63b792dea = function(_a) {
    var id = _a.id, title = _a.title, children = _a.children, onClose = _a.onClose, targetId = _a.targetId, _b = _a.linkDecoration, linkDecoration = _b === void 0 ? 'underline' : _b, _c = _a.linkText, linkText = _c === void 0 ? undefined : _c, _d = _a.linkUrl, linkUrl = _d === void 0 ? undefined : _d, _e = _a.shown, shown = _e === void 0 ? false : _e, _f = _a.modal, modal = _f === void 0 ? false : _f, _g = _a.closeLabel, closeLabel = _g === void 0 ? 'Close tooltip' : _g, _h = _a.onKeyDown, onKeyDown = _h === void 0 ? function() {} : _h, _j = _a.placement, placement = _j === void 0 ? 'auto' : _j, _k = _a.customAnchorId, customAnchorId = _k === void 0 ? undefined : _k, _l = _a.align, align = _l === void 0 ? 'auto' : _l, _m = _a.classes, classes = _m === void 0 ? [] : _m, _o = _a.ariaLabel, ariaLabel = _o === void 0 ? undefined : _o;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$TooltipJSX, {
        title: title,
        linkDecoration: linkDecoration,
        linkText: linkText,
        linkUrl: linkUrl,
        shown: shown,
        modal: modal,
        closeLabel: closeLabel,
        onClose: onClose,
        onKeyDown: onKeyDown,
        targetId: targetId,
        id: id,
        placement: placement,
        customAnchorId: customAnchorId,
        align: align,
        classes: classes,
        ariaLabel: ariaLabel,
        children: children
    });
};
$558a1874964eed3d$export$28c660c63b792dea.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    targetId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    linkDecoration: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'underline',
        'none'
    ]),
    linkText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    linkUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    shown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    modal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    closeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    placement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'auto',
        'above',
        'center',
        'below'
    ]),
    customAnchorId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    align: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'auto',
        'left',
        'center',
        'right'
    ]),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
const $558a1874964eed3d$var$Wizard$1 = ({ steps: steps, onProgressStepClick: onProgressStepClick, onRequestClose: onRequestClose, ariaLabel: ariaLabel, activeStepIndex: activeStepIndex, completedStepIndexes: completedStepIndexes, children: children, title: title, open: open, buttons: buttons = [], classes: classes = [] })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: $558a1874964eed3d$var$createClassList({
            default: [
                'wizard-container'
            ],
            custom: classes,
            required: []
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($558a1874964eed3d$var$Dialog$2, {
            buttons: buttons,
            title: title,
            className: "axiom-wizard wizard-dialog",
            open: open,
            onRequestClose: onRequestClose,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($558a1874964eed3d$var$ProgressStepper$2, {
                    classes: "axiom-wizard--progress-stepper",
                    steps: steps,
                    onClick: onProgressStepClick,
                    ariaLabel: ariaLabel,
                    activeStepIndex: activeStepIndex,
                    completedStepIndexes: completedStepIndexes
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "axiom-wizard--content wizard-content",
                    children: children
                })
            ]
        })
    });
$558a1874964eed3d$var$Wizard$1.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ]).isRequired,
        slug: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    })).isRequired,
    activeStepIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    completedStepIndexes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
    onProgressStepClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onRequestClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    buttons: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        styleVariant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'primary',
            'secondary',
            'tertiary'
        ]),
        text: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
    })),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};
var $558a1874964eed3d$var$WizardJSX = $558a1874964eed3d$var$Wizard$1;
var $558a1874964eed3d$export$c6a37f46d6629cf2 = function(_a) {
    var steps = _a.steps, onProgressStepClick = _a.onProgressStepClick, onRequestClose = _a.onRequestClose, ariaLabel = _a.ariaLabel, activeStepIndex = _a.activeStepIndex, completedStepIndexes = _a.completedStepIndexes, children = _a.children, title = _a.title, open = _a.open, _b = _a.buttons, buttons = _b === void 0 ? [] : _b, _c = _a.classes, classes = _c === void 0 ? [] : _c;
    return (0, $ayMG0.jsx)($558a1874964eed3d$var$WizardJSX, {
        steps: steps,
        onProgressStepClick: onProgressStepClick,
        onRequestClose: onRequestClose,
        ariaLabel: ariaLabel,
        activeStepIndex: activeStepIndex,
        completedStepIndexes: completedStepIndexes,
        title: title,
        open: open,
        buttons: buttons,
        classes: classes,
        children: children
    });
};
$558a1874964eed3d$export$c6a37f46d6629cf2.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ]).isRequired,
        slug: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    })).isRequired,
    activeStepIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    completedStepIndexes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
    onProgressStepClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onRequestClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    buttons: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        styleVariant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'primary',
            'secondary',
            'tertiary'
        ]),
        text: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
    })),
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ])
};

});
parcelRegister("a3QyA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7532f3e29d96fa2a$export$2e2bcd8739ae039);

var $dwyob = parcelRequire("dwyob");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9Hi20 = parcelRequire("9Hi20");

var $eP9YU = parcelRequire("eP9YU");

var $a9M6v = parcelRequire("a9M6v");

parcelRequire("cbdLd");
parcelRequire("02Ztr");
parcelRequire("gZU1N");
parcelRequire("fu0YK");
parcelRequire("lR7jo");
parcelRequire("f8wIT");
parcelRequire("9jKhT");
parcelRequire("fUHKi");

parcelRequire("41YNz");
parcelRequire("gS6QF");
parcelRequire("g5Zhu");
parcelRequire("1u0KT");

parcelRequire("jLbqB");
var $7532f3e29d96fa2a$var$StateManagedSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $dwyob.u)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $9Hi20.S), (0, $8nd05.default)({
        ref: ref
    }, baseSelectProps));
});
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$StateManagedSelect;
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $acw62.useMemo)(function() {
        return (0, $a9M6v.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $eP9YU.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("dwyob", function(module, exports) {

$parcel$export(module.exports, "u", () => $9d88f0746ba78f85$export$3b14a55fb2447963);

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");
var $9d88f0746ba78f85$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $9d88f0746ba78f85$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $9X7IJ.default)(_ref, $9d88f0746ba78f85$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $eUqlC.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $eUqlC.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $eUqlC.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $d49SP.default)((0, $d49SP.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("d49SP", function(module, exports) {

$parcel$export(module.exports, "default", () => $983350b7b3960a26$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");
function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kSlfw.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("eUqlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adaabbc18727b3e6$export$2e2bcd8739ae039);

var $1uEeT = parcelRequire("1uEeT");

var $guSBA = parcelRequire("guSBA");

var $abLc2 = parcelRequire("abLc2");

var $782Uh = parcelRequire("782Uh");
function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1uEeT.default)(r) || (0, $guSBA.default)(r, e) || (0, $abLc2.default)(r, e) || (0, $782Uh.default)();
}

});
parcelRegister("1uEeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1167ce760980f343$export$2e2bcd8739ae039);
function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("guSBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c029ce1ef065e371$export$2e2bcd8739ae039);
function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("abLc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $76af8a05551d5f25$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7K8zV.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7K8zV.default)(r, a) : void 0;
    }
}

});
parcelRegister("7K8zV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a337bca9556bfe7$export$2e2bcd8739ae039);
function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("782Uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $530b88ff20858fe6$export$2e2bcd8739ae039);
function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9X7IJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ef9ce1c41fc0c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $1En50.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});



parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("9Hi20", function(module, exports) {

$parcel$export(module.exports, "S", () => $70f61dd951fba0f0$export$25ce5a424b770e84);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");

var $jJwlt = parcelRequire("jJwlt");

var $jjlaj = parcelRequire("jjlaj");

var $jk22o = parcelRequire("jk22o");

var $9X7IJ = parcelRequire("9X7IJ");
function $70f61dd951fba0f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $70f61dd951fba0f0$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $70f61dd951fba0f0$var$A11yText = function A11yText(props) {
    return (0, $jjlaj.jsx)("span", (0, $8nd05.default)({
        css: $70f61dd951fba0f0$var$_ref
    }, props));
};
var $70f61dd951fba0f0$var$A11yText$1 = $70f61dd951fba0f0$var$A11yText;
var $70f61dd951fba0f0$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $70f61dd951fba0f0$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $d49SP.default)((0, $d49SP.default)({}, $70f61dd951fba0f0$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $d49SP.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $jjlaj.jsx)((0, $acw62.Fragment), null, (0, $jjlaj.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $jjlaj.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $jjlaj.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $jjlaj.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $jjlaj.jsx)((0, $acw62.Fragment), null, (0, $jjlaj.jsx)($70f61dd951fba0f0$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $jjlaj.jsx)($70f61dd951fba0f0$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $70f61dd951fba0f0$var$LiveRegion$1 = $70f61dd951fba0f0$var$LiveRegion;
var $70f61dd951fba0f0$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $70f61dd951fba0f0$var$anyDiacritic = new RegExp('[' + $70f61dd951fba0f0$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $70f61dd951fba0f0$var$diacriticToBase = {};
for(var $70f61dd951fba0f0$var$i = 0; $70f61dd951fba0f0$var$i < $70f61dd951fba0f0$var$diacritics.length; $70f61dd951fba0f0$var$i++){
    var $70f61dd951fba0f0$var$diacritic = $70f61dd951fba0f0$var$diacritics[$70f61dd951fba0f0$var$i];
    for(var $70f61dd951fba0f0$var$j = 0; $70f61dd951fba0f0$var$j < $70f61dd951fba0f0$var$diacritic.letters.length; $70f61dd951fba0f0$var$j++)$70f61dd951fba0f0$var$diacriticToBase[$70f61dd951fba0f0$var$diacritic.letters[$70f61dd951fba0f0$var$j]] = $70f61dd951fba0f0$var$diacritic.base;
}
var $70f61dd951fba0f0$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($70f61dd951fba0f0$var$anyDiacritic, function(match) {
        return $70f61dd951fba0f0$var$diacriticToBase[match];
    });
};
var $70f61dd951fba0f0$var$memoizedStripDiacriticsForInput = (0, $jk22o.default)($70f61dd951fba0f0$var$stripDiacritics);
var $70f61dd951fba0f0$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $70f61dd951fba0f0$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $70f61dd951fba0f0$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $d49SP.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $70f61dd951fba0f0$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $70f61dd951fba0f0$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $70f61dd951fba0f0$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $70f61dd951fba0f0$var$memoizedStripDiacriticsForInput(input);
            candidate = $70f61dd951fba0f0$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $70f61dd951fba0f0$var$_excluded = [
    "innerRef"
];
function $70f61dd951fba0f0$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $9X7IJ.default)(_ref, $70f61dd951fba0f0$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jJwlt.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $jjlaj.jsx)("input", (0, $8nd05.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $jjlaj.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $70f61dd951fba0f0$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $70f61dd951fba0f0$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $70f61dd951fba0f0$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jJwlt.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $70f61dd951fba0f0$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $70f61dd951fba0f0$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $70f61dd951fba0f0$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $70f61dd951fba0f0$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $70f61dd951fba0f0$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $70f61dd951fba0f0$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $70f61dd951fba0f0$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $70f61dd951fba0f0$var$activeScrollLocks = 0;
var $70f61dd951fba0f0$var$listenerOptions = {
    capture: false,
    passive: false
};
function $70f61dd951fba0f0$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$70f61dd951fba0f0$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $70f61dd951fba0f0$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $70f61dd951fba0f0$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($70f61dd951fba0f0$var$LOCK_STYLES).forEach(function(key) {
                var val = $70f61dd951fba0f0$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $70f61dd951fba0f0$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $70f61dd951fba0f0$var$preventTouchMove, $70f61dd951fba0f0$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $70f61dd951fba0f0$var$preventInertiaScroll, $70f61dd951fba0f0$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $70f61dd951fba0f0$var$allowTouchMove, $70f61dd951fba0f0$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $70f61dd951fba0f0$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$70f61dd951fba0f0$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $70f61dd951fba0f0$var$activeScrollLocks = Math.max($70f61dd951fba0f0$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $70f61dd951fba0f0$var$activeScrollLocks < 1) $70f61dd951fba0f0$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $70f61dd951fba0f0$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $70f61dd951fba0f0$var$preventTouchMove, $70f61dd951fba0f0$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $70f61dd951fba0f0$var$preventInertiaScroll, $70f61dd951fba0f0$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $70f61dd951fba0f0$var$allowTouchMove, $70f61dd951fba0f0$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $70f61dd951fba0f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $70f61dd951fba0f0$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $70f61dd951fba0f0$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $70f61dd951fba0f0$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $70f61dd951fba0f0$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $70f61dd951fba0f0$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $jjlaj.jsx)((0, $acw62.Fragment), null, lockEnabled && (0, $jjlaj.jsx)("div", {
        onClick: $70f61dd951fba0f0$var$blurSelectInput,
        css: $70f61dd951fba0f0$var$_ref2$1
    }), children(targetRef));
}
function $70f61dd951fba0f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $70f61dd951fba0f0$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $70f61dd951fba0f0$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $jjlaj.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $70f61dd951fba0f0$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $70f61dd951fba0f0$var$RequiredInput$1 = $70f61dd951fba0f0$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $70f61dd951fba0f0$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $70f61dd951fba0f0$var$isIPhone() {
    return $70f61dd951fba0f0$var$testPlatform(/^iPhone/i);
}
function $70f61dd951fba0f0$var$isMac() {
    return $70f61dd951fba0f0$var$testPlatform(/^Mac/i);
}
function $70f61dd951fba0f0$var$isIPad() {
    return $70f61dd951fba0f0$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $70f61dd951fba0f0$var$isMac() && navigator.maxTouchPoints > 1;
}
function $70f61dd951fba0f0$var$isIOS() {
    return $70f61dd951fba0f0$var$isIPhone() || $70f61dd951fba0f0$var$isIPad();
}
function $70f61dd951fba0f0$var$isAppleDevice() {
    return $70f61dd951fba0f0$var$isMac() || $70f61dd951fba0f0$var$isIOS();
}
var $70f61dd951fba0f0$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $70f61dd951fba0f0$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $70f61dd951fba0f0$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $70f61dd951fba0f0$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $70f61dd951fba0f0$var$defaultStyles = {
    clearIndicator: (0, $jJwlt.a),
    container: (0, $jJwlt.b),
    control: (0, $jJwlt.d),
    dropdownIndicator: (0, $jJwlt.e),
    group: (0, $jJwlt.g),
    groupHeading: (0, $jJwlt.f),
    indicatorsContainer: (0, $jJwlt.i),
    indicatorSeparator: (0, $jJwlt.h),
    input: (0, $jJwlt.j),
    loadingIndicator: (0, $jJwlt.l),
    loadingMessage: (0, $jJwlt.k),
    menu: (0, $jJwlt.m),
    menuList: (0, $jJwlt.n),
    menuPortal: (0, $jJwlt.o),
    multiValue: (0, $jJwlt.p),
    multiValueLabel: (0, $jJwlt.q),
    multiValueRemove: (0, $jJwlt.t),
    noOptionsMessage: (0, $jJwlt.u),
    option: (0, $jJwlt.v),
    placeholder: (0, $jJwlt.w),
    singleValue: (0, $jJwlt.x),
    valueContainer: (0, $jJwlt.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $70f61dd951fba0f0$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $d49SP.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $70f61dd951fba0f0$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $70f61dd951fba0f0$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $70f61dd951fba0f0$var$baseUnit = 4;
// The minimum height of the control
var $70f61dd951fba0f0$var$controlHeight = 38;
// The amount of space between the control and menu */
var $70f61dd951fba0f0$var$menuGutter = $70f61dd951fba0f0$var$baseUnit * 2;
var $70f61dd951fba0f0$var$spacing = {
    baseUnit: $70f61dd951fba0f0$var$baseUnit,
    controlHeight: $70f61dd951fba0f0$var$controlHeight,
    menuGutter: $70f61dd951fba0f0$var$menuGutter
};
var $70f61dd951fba0f0$export$4368d992c4eafac0 = {
    borderRadius: $70f61dd951fba0f0$var$borderRadius,
    colors: $70f61dd951fba0f0$var$colors,
    spacing: $70f61dd951fba0f0$var$spacing
};
var $70f61dd951fba0f0$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jJwlt.z)(),
    captureMenuScroll: !(0, $jJwlt.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $70f61dd951fba0f0$export$db3b6bfb95261072(),
    formatGroupLabel: $70f61dd951fba0f0$var$formatGroupLabel,
    getOptionLabel: $70f61dd951fba0f0$export$8b22cf2602fb60ce,
    getOptionValue: $70f61dd951fba0f0$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $70f61dd951fba0f0$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jJwlt.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $70f61dd951fba0f0$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $70f61dd951fba0f0$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $70f61dd951fba0f0$var$_isOptionSelected(props, option, selectValue);
    var label = $70f61dd951fba0f0$var$getOptionLabel(props, option);
    var value = $70f61dd951fba0f0$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $70f61dd951fba0f0$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $70f61dd951fba0f0$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $70f61dd951fba0f0$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $70f61dd951fba0f0$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $70f61dd951fba0f0$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jJwlt.K));
}
function $70f61dd951fba0f0$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $kbxxf.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $70f61dd951fba0f0$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $kbxxf.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $70f61dd951fba0f0$var$buildFocusableOptions(props, selectValue) {
    return $70f61dd951fba0f0$var$buildFocusableOptionsFromCategorizedOptions($70f61dd951fba0f0$var$buildCategorizedOptions(props, selectValue));
}
function $70f61dd951fba0f0$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$70f61dd951fba0f0$var$shouldHideSelectedOptions(props) || !isSelected) && $70f61dd951fba0f0$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $70f61dd951fba0f0$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $70f61dd951fba0f0$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $70f61dd951fba0f0$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $70f61dd951fba0f0$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $70f61dd951fba0f0$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $70f61dd951fba0f0$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $70f61dd951fba0f0$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $70f61dd951fba0f0$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $70f61dd951fba0f0$var$getOptionValue(props, i) === candidate;
    });
}
function $70f61dd951fba0f0$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $70f61dd951fba0f0$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $70f61dd951fba0f0$var$instanceId = 1;
var $70f61dd951fba0f0$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(Select, _Component);
    var _super = (0, $enfmq.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $6CZeq.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            isAppleDevice: false
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jJwlt.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jJwlt.B)([].concat((0, $kbxxf.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jJwlt.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jJwlt.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jJwlt.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jJwlt.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jJwlt.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $70f61dd951fba0f0$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $70f61dd951fba0f0$var$buildFocusableOptionsWithIds($70f61dd951fba0f0$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jJwlt.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $70f61dd951fba0f0$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $70f61dd951fba0f0$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $70f61dd951fba0f0$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jJwlt.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $70f61dd951fba0f0$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $70f61dd951fba0f0$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $d49SP.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jJwlt.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $70f61dd951fba0f0$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$70f61dd951fba0f0$var$instanceId);
        _this.state.selectValue = (0, $jJwlt.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $70f61dd951fba0f0$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $cHPF9.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jJwlt.I)(this.menuListRef, this.focusedOptionRef);
                if ($70f61dd951fba0f0$var$isAppleDevice()) // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    isAppleDevice: true
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jJwlt.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $70f61dd951fba0f0$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($70f61dd951fba0f0$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $d49SP.default)((0, $d49SP.default)({}, $70f61dd951fba0f0$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $70f61dd951fba0f0$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $70f61dd951fba0f0$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $70f61dd951fba0f0$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.state.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $acw62.createElement($70f61dd951fba0f0$var$DummyInput, (0, $8nd05.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jJwlt.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $acw62.createElement(Input, (0, $8nd05.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $acw62.createElement(Placeholder, (0, $8nd05.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $acw62.createElement(MultiValue, (0, $8nd05.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $acw62.createElement(SingleValue, (0, $8nd05.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(ClearIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(LoadingIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $acw62.createElement(IndicatorSeparator, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(DropdownIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.state.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $acw62.createElement(Option, (0, $8nd05.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $acw62.createElement(Group, (0, $8nd05.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $acw62.createElement((0, $jJwlt.M), (0, $8nd05.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $acw62.createElement(Menu, (0, $8nd05.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $acw62.createElement($70f61dd951fba0f0$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $acw62.createElement(MenuList, (0, $8nd05.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $acw62.createElement(MenuPortal, (0, $8nd05.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $acw62.createElement($70f61dd951fba0f0$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $acw62.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $acw62.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $acw62.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $acw62.createElement($70f61dd951fba0f0$var$LiveRegion$1, (0, $8nd05.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.state.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $acw62.createElement(SelectContainer, (0, $8nd05.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $acw62.createElement(Control, (0, $8nd05.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $acw62.createElement(ValueContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $acw62.createElement(IndicatorsContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jJwlt.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $70f61dd951fba0f0$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $70f61dd951fba0f0$var$buildFocusableOptionsWithIds($70f61dd951fba0f0$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $70f61dd951fba0f0$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $70f61dd951fba0f0$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $70f61dd951fba0f0$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jJwlt.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$70f61dd951fba0f0$export$25ce5a424b770e84.defaultProps = $70f61dd951fba0f0$export$407448d2b89b1813;

});
parcelRegister("6CZeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d35ca0862055760$export$2e2bcd8739ae039);
function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cHPF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $94019358ecbcf36b$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $4ZreY.default)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("1gYAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed648f7bbaf3aff$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $VFVve.default)(t, e);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("enfmq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a76f20fb39fa9d46$export$2e2bcd8739ae039);

var $jDKKo = parcelRequire("jDKKo");

var $fhGLX = parcelRequire("fhGLX");

var $9715X = parcelRequire("9715X");
function $a76f20fb39fa9d46$export$2e2bcd8739ae039(t) {
    var r = (0, $fhGLX.default)();
    return function() {
        var e, o = (0, $jDKKo.default)(t);
        if (r) {
            var s = (0, $jDKKo.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $9715X.default)(this, e);
    };
}

});
parcelRegister("jDKKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c5ebe502337db0$export$2e2bcd8739ae039);
function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}

});

parcelRegister("fhGLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2099f49db83e2df$export$2e2bcd8739ae039);
function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("9715X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a259df8fa92dc4a$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $hDpcU = parcelRequire("hDpcU");
function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $fSwVM.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hDpcU.default)(t);
}

});
parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});



parcelRegister("kbxxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1ed927433e7e98$export$2e2bcd8739ae039);

var $cN7Ua = parcelRequire("cN7Ua");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $fB5Ly = parcelRequire("fB5Ly");
function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $cN7Ua.default)(r) || (0, $dOjF6.default)(r) || (0, $abLc2.default)(r) || (0, $fB5Ly.default)();
}

});
parcelRegister("cN7Ua", function(module, exports) {

$parcel$export(module.exports, "default", () => $95003165623aa54c$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7K8zV.default)(r);
}

});

parcelRegister("dOjF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0df324e6f81ee90$export$2e2bcd8739ae039);
function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("fB5Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5aec8b8da7ac2f2$export$2e2bcd8739ae039);
function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jJwlt", function(module, exports) {

$parcel$export(module.exports, "J", () => $e5db4f66b3bbccc3$export$b4171a6734a65d42);
$parcel$export(module.exports, "E", () => $e5db4f66b3bbccc3$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "H", () => $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "G", () => $e5db4f66b3bbccc3$export$2329c99376c9d0a4);
$parcel$export(module.exports, "I", () => $e5db4f66b3bbccc3$export$9bb611d729802a56);
$parcel$export(module.exports, "z", () => $e5db4f66b3bbccc3$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e5db4f66b3bbccc3$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e5db4f66b3bbccc3$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "K", () => $e5db4f66b3bbccc3$export$3466f893ebf79586);
$parcel$export(module.exports, "D", () => $e5db4f66b3bbccc3$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e5db4f66b3bbccc3$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e5db4f66b3bbccc3$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e5db4f66b3bbccc3$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e5db4f66b3bbccc3$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e5db4f66b3bbccc3$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e5db4f66b3bbccc3$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e5db4f66b3bbccc3$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e5db4f66b3bbccc3$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e5db4f66b3bbccc3$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e5db4f66b3bbccc3$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e5db4f66b3bbccc3$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e5db4f66b3bbccc3$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e5db4f66b3bbccc3$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e5db4f66b3bbccc3$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e5db4f66b3bbccc3$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e5db4f66b3bbccc3$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e5db4f66b3bbccc3$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e5db4f66b3bbccc3$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e5db4f66b3bbccc3$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e5db4f66b3bbccc3$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e5db4f66b3bbccc3$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e5db4f66b3bbccc3$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e5db4f66b3bbccc3$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e5db4f66b3bbccc3$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e5db4f66b3bbccc3$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e5db4f66b3bbccc3$export$d141bba7fdc215a3);
$parcel$export(module.exports, "F", () => $e5db4f66b3bbccc3$export$d66501df72047452);

var $d49SP = parcelRequire("d49SP");

var $8nd05 = parcelRequire("8nd05");

var $jjlaj = parcelRequire("jjlaj");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $fSwVM = parcelRequire("fSwVM");

var $hvnYt = parcelRequire("hvnYt");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $618j3 = parcelRequire("618j3");

var $jLbqB = parcelRequire("jLbqB");
var $e5db4f66b3bbccc3$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e5db4f66b3bbccc3$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e5db4f66b3bbccc3$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e5db4f66b3bbccc3$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e5db4f66b3bbccc3$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($e5db4f66b3bbccc3$var$isArray(value)) return value.filter(Boolean);
    if ((0, $fSwVM.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e5db4f66b3bbccc3$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $9X7IJ.default)(props, $e5db4f66b3bbccc3$var$_excluded$4);
    return (0, $d49SP.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e5db4f66b3bbccc3$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e5db4f66b3bbccc3$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e5db4f66b3bbccc3$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e5db4f66b3bbccc3$var$normalizedHeight(el) {
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e5db4f66b3bbccc3$var$getScrollTop(el) {
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e5db4f66b3bbccc3$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e5db4f66b3bbccc3$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e5db4f66b3bbccc3$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e5db4f66b3bbccc3$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e5db4f66b3bbccc3$export$b4171a6734a65d42;
    var start = $e5db4f66b3bbccc3$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e5db4f66b3bbccc3$var$easeOutCubic(currentTime, start, change, duration);
        $e5db4f66b3bbccc3$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e5db4f66b3bbccc3$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e5db4f66b3bbccc3$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e5db4f66b3bbccc3$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e5db4f66b3bbccc3$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e5db4f66b3bbccc3$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e5db4f66b3bbccc3$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e5db4f66b3bbccc3$var$passiveOptionAccessed = false;
var $e5db4f66b3bbccc3$var$options = {
    get passive () {
        return $e5db4f66b3bbccc3$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e5db4f66b3bbccc3$var$w = typeof window !== 'undefined' ? window : {};
if ($e5db4f66b3bbccc3$var$w.addEventListener && $e5db4f66b3bbccc3$var$w.removeEventListener) {
    $e5db4f66b3bbccc3$var$w.addEventListener('p', $e5db4f66b3bbccc3$export$b4171a6734a65d42, $e5db4f66b3bbccc3$var$options);
    $e5db4f66b3bbccc3$var$w.removeEventListener('p', $e5db4f66b3bbccc3$export$b4171a6734a65d42, false);
}
var $e5db4f66b3bbccc3$export$2408f22a0fab9ae5 = $e5db4f66b3bbccc3$var$passiveOptionAccessed;
function $e5db4f66b3bbccc3$export$3466f893ebf79586(item) {
    return item != null;
}
function $e5db4f66b3bbccc3$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e5db4f66b3bbccc3$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e5db4f66b3bbccc3$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e5db4f66b3bbccc3$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e5db4f66b3bbccc3$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $eUqlC.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $eUqlC.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $e5db4f66b3bbccc3$var$_excluded$3 = [
    "children",
    "innerProps"
], $e5db4f66b3bbccc3$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $e5db4f66b3bbccc3$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e5db4f66b3bbccc3$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e5db4f66b3bbccc3$var$normalizedHeight(scrollParent);
    var scrollTop = $e5db4f66b3bbccc3$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e5db4f66b3bbccc3$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e5db4f66b3bbccc3$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e5db4f66b3bbccc3$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e5db4f66b3bbccc3$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $d49SP.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $kSlfw.default)(_objectSpread2, $e5db4f66b3bbccc3$var$alignToControl(placement), '100%'), (0, $kSlfw.default)(_objectSpread2, "position", 'absolute'), (0, $kSlfw.default)(_objectSpread2, "width", '100%'), (0, $kSlfw.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e5db4f66b3bbccc3$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// NOTE: internal only
var $e5db4f66b3bbccc3$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $acw62.useContext)($e5db4f66b3bbccc3$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, $eUqlC.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $eUqlC.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $jLbqB.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e5db4f66b3bbccc3$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
            placement: placement || $e5db4f66b3bbccc3$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e5db4f66b3bbccc3$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $e5db4f66b3bbccc3$var$Menu$1 = $e5db4f66b3bbccc3$var$Menu;
// ==============================
// Menu List
// ==============================
var $e5db4f66b3bbccc3$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $d49SP.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e5db4f66b3bbccc3$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e5db4f66b3bbccc3$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $d49SP.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e5db4f66b3bbccc3$export$3b14a55fb2447963 = $e5db4f66b3bbccc3$var$noticeCSS;
var $e5db4f66b3bbccc3$export$342063e11d6c3cad = $e5db4f66b3bbccc3$var$noticeCSS;
var $e5db4f66b3bbccc3$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $9X7IJ.default)(_ref6, $e5db4f66b3bbccc3$var$_excluded$3);
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $d49SP.default)((0, $d49SP.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $9X7IJ.default)(_ref7, $e5db4f66b3bbccc3$var$_excluded2$1);
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $d49SP.default)((0, $d49SP.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $e5db4f66b3bbccc3$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e5db4f66b3bbccc3$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState5 = (0, $acw62.useState)($e5db4f66b3bbccc3$var$coercePlacement(menuPlacement)), _useState6 = (0, $eUqlC.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $acw62.useState)(null), _useState8 = (0, $eUqlC.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e5db4f66b3bbccc3$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $jLbqB.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $618j3.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $jLbqB.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $jjlaj.jsx)("div", (0, $8nd05.default)({
        ref: setMenuPortalElement
    }, $e5db4f66b3bbccc3$var$getStyleProps((0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $1u0KT.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e5db4f66b3bbccc3$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e5db4f66b3bbccc3$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e5db4f66b3bbccc3$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $d49SP.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e5db4f66b3bbccc3$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e5db4f66b3bbccc3$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e5db4f66b3bbccc3$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$_templateObject;
var $e5db4f66b3bbccc3$var$_excluded$2 = [
    "size"
], $e5db4f66b3bbccc3$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $e5db4f66b3bbccc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e5db4f66b3bbccc3$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e5db4f66b3bbccc3$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $9X7IJ.default)(_ref, $e5db4f66b3bbccc3$var$_excluded$2);
    return (0, $jjlaj.jsx)("svg", (0, $8nd05.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e5db4f66b3bbccc3$var$_ref2
    }, props));
};
var $e5db4f66b3bbccc3$var$CrossIcon = function CrossIcon(props) {
    return (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $jjlaj.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e5db4f66b3bbccc3$var$DownChevron = function DownChevron(props) {
    return (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $jjlaj.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e5db4f66b3bbccc3$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $d49SP.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e5db4f66b3bbccc3$export$f1e1789686576879 = $e5db4f66b3bbccc3$var$baseCSS;
var $e5db4f66b3bbccc3$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$DownChevron, null));
};
var $e5db4f66b3bbccc3$export$407448d2b89b1813 = $e5db4f66b3bbccc3$var$baseCSS;
var $e5db4f66b3bbccc3$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e5db4f66b3bbccc3$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $d49SP.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e5db4f66b3bbccc3$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("span", (0, $8nd05.default)({}, innerProps, $e5db4f66b3bbccc3$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e5db4f66b3bbccc3$var$loadingDotAnimations = (0, $jjlaj.keyframes)($e5db4f66b3bbccc3$var$_templateObject || ($e5db4f66b3bbccc3$var$_templateObject = (0, $hvnYt.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e5db4f66b3bbccc3$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $d49SP.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e5db4f66b3bbccc3$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $jjlaj.jsx)("span", {
        css: /*#__PURE__*/ (0, $jjlaj.css)({
            animation: "".concat($e5db4f66b3bbccc3$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e5db4f66b3bbccc3$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $9X7IJ.default)(_ref7, $e5db4f66b3bbccc3$var$_excluded2);
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $d49SP.default)((0, $d49SP.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $e5db4f66b3bbccc3$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $d49SP.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e5db4f66b3bbccc3$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({
        ref: innerRef
    }, $e5db4f66b3bbccc3$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $e5db4f66b3bbccc3$var$Control$1 = $e5db4f66b3bbccc3$var$Control;
var $e5db4f66b3bbccc3$var$_excluded$1 = [
    "data"
];
var $e5db4f66b3bbccc3$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e5db4f66b3bbccc3$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $jjlaj.jsx)(Heading, (0, $8nd05.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $jjlaj.jsx)("div", null, children));
};
var $e5db4f66b3bbccc3$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $d49SP.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e5db4f66b3bbccc3$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e5db4f66b3bbccc3$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $9X7IJ.default)(_cleanCommonProps, $e5db4f66b3bbccc3$var$_excluded$1);
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e5db4f66b3bbccc3$var$Group$1 = $e5db4f66b3bbccc3$var$Group;
var $e5db4f66b3bbccc3$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e5db4f66b3bbccc3$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $d49SP.default)((0, $d49SP.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e5db4f66b3bbccc3$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e5db4f66b3bbccc3$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e5db4f66b3bbccc3$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $d49SP.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e5db4f66b3bbccc3$var$spacingStyle)
};
var $e5db4f66b3bbccc3$var$inputStyle = function inputStyle(isHidden) {
    return (0, $d49SP.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e5db4f66b3bbccc3$var$spacingStyle);
};
var $e5db4f66b3bbccc3$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e5db4f66b3bbccc3$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $9X7IJ.default)(_cleanCommonProps, $e5db4f66b3bbccc3$var$_excluded);
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $jjlaj.jsx)("input", (0, $8nd05.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e5db4f66b3bbccc3$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e5db4f66b3bbccc3$var$Input$1 = $e5db4f66b3bbccc3$var$Input;
var $e5db4f66b3bbccc3$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $d49SP.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $d49SP.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e5db4f66b3bbccc3$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $d49SP.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e5db4f66b3bbccc3$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $jjlaj.jsx)("div", innerProps, children);
};
var $e5db4f66b3bbccc3$var$MultiValueContainer = $e5db4f66b3bbccc3$var$MultiValueGeneric;
var $e5db4f66b3bbccc3$var$MultiValueLabel = $e5db4f66b3bbccc3$var$MultiValueGeneric;
function $e5db4f66b3bbccc3$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({
        role: "button"
    }, innerProps), children || (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$CrossIcon, {
        size: 14
    }));
}
var $e5db4f66b3bbccc3$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $jjlaj.jsx)(Container, {
        data: data,
        innerProps: (0, $d49SP.default)((0, $d49SP.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $jjlaj.jsx)(Label, {
        data: data,
        innerProps: (0, $d49SP.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $jjlaj.jsx)(Remove, {
        data: data,
        innerProps: (0, $d49SP.default)((0, $d49SP.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e5db4f66b3bbccc3$var$MultiValue$1 = $e5db4f66b3bbccc3$var$MultiValue;
var $e5db4f66b3bbccc3$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $d49SP.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e5db4f66b3bbccc3$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e5db4f66b3bbccc3$var$Option$1 = $e5db4f66b3bbccc3$var$Option;
var $e5db4f66b3bbccc3$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $d49SP.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$Placeholder$1 = $e5db4f66b3bbccc3$var$Placeholder;
var $e5db4f66b3bbccc3$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $d49SP.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$SingleValue$1 = $e5db4f66b3bbccc3$var$SingleValue;
var $e5db4f66b3bbccc3$export$db3b6bfb95261072 = {
    ClearIndicator: $e5db4f66b3bbccc3$var$ClearIndicator,
    Control: $e5db4f66b3bbccc3$var$Control$1,
    DropdownIndicator: $e5db4f66b3bbccc3$var$DropdownIndicator,
    DownChevron: $e5db4f66b3bbccc3$var$DownChevron,
    CrossIcon: $e5db4f66b3bbccc3$var$CrossIcon,
    Group: $e5db4f66b3bbccc3$var$Group$1,
    GroupHeading: $e5db4f66b3bbccc3$var$GroupHeading,
    IndicatorsContainer: $e5db4f66b3bbccc3$var$IndicatorsContainer,
    IndicatorSeparator: $e5db4f66b3bbccc3$var$IndicatorSeparator,
    Input: $e5db4f66b3bbccc3$var$Input$1,
    LoadingIndicator: $e5db4f66b3bbccc3$var$LoadingIndicator,
    Menu: $e5db4f66b3bbccc3$var$Menu$1,
    MenuList: $e5db4f66b3bbccc3$var$MenuList,
    MenuPortal: $e5db4f66b3bbccc3$var$MenuPortal,
    LoadingMessage: $e5db4f66b3bbccc3$var$LoadingMessage,
    NoOptionsMessage: $e5db4f66b3bbccc3$var$NoOptionsMessage,
    MultiValue: $e5db4f66b3bbccc3$var$MultiValue$1,
    MultiValueContainer: $e5db4f66b3bbccc3$var$MultiValueContainer,
    MultiValueLabel: $e5db4f66b3bbccc3$var$MultiValueLabel,
    MultiValueRemove: $e5db4f66b3bbccc3$var$MultiValueRemove,
    Option: $e5db4f66b3bbccc3$var$Option$1,
    Placeholder: $e5db4f66b3bbccc3$var$Placeholder$1,
    SelectContainer: $e5db4f66b3bbccc3$var$SelectContainer,
    SingleValue: $e5db4f66b3bbccc3$var$SingleValue$1,
    ValueContainer: $e5db4f66b3bbccc3$var$ValueContainer
};
var $e5db4f66b3bbccc3$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $d49SP.default)((0, $d49SP.default)({}, $e5db4f66b3bbccc3$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "jsx", () => $e0f035ab0866fe47$export$c8a8987d4410bf2d);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $acad92301ef10c3f$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});
parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});




parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});


parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hvnYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe7edbf3ccb8828$export$2e2bcd8739ae039);
function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("618j3", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $461947879dcdbcd4$export$deee3a793edee05f);

var $cZ41y = parcelRequire("cZ41y");
var $1obCQ = parcelRequire("1obCQ");

var $1obCQ = parcelRequire("1obCQ");

var $33bLr = parcelRequire("33bLr");
function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $33bLr.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $33bLr.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $1obCQ.round)(width) !== offsetWidth || (0, $1obCQ.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $33bLr.isElement)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $33bLr.isHTMLElement)(domElement)) return (0, $1obCQ.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $1obCQ.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $1obCQ.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $1obCQ.createCoords)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $33bLr.getWindow)(element);
    if (!(0, $33bLr.isWebKit)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $33bLr.getWindow)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $1obCQ.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $33bLr.isElement)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $1obCQ.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $33bLr.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $33bLr.isElement)(offsetParent) ? (0, $33bLr.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $33bLr.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $33bLr.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $33bLr.getWindow)(currentIFrame);
            currentIFrame = (0, $33bLr.getFrameElement)(currentWin);
        }
    }
    return (0, $1obCQ.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $33bLr.getNodeScroll)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $33bLr.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $33bLr.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $1obCQ.createCoords)(1);
    const offsets = (0, $1obCQ.createCoords)(0);
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== 'body' || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $1obCQ.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $33bLr.getDocumentElement)(element);
    const scroll = (0, $33bLr.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $1obCQ.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $1obCQ.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $33bLr.getComputedStyle)(body).direction === 'rtl') x += (0, $1obCQ.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $461947879dcdbcd4$var$SCROLLBAR_MAX = 25;
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $33bLr.getWindow)(element);
    const html = (0, $33bLr.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $33bLr.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $461947879dcdbcd4$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $461947879dcdbcd4$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $461947879dcdbcd4$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $33bLr.isHTMLElement)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $1obCQ.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $461947879dcdbcd4$var$getDocumentRect((0, $33bLr.getDocumentElement)(element));
    else if ((0, $33bLr.isElement)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $1obCQ.rectToClientRect)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $33bLr.getParentNode)(element);
    if (parentNode === stopNode || !(0, $33bLr.isElement)(parentNode) || (0, $33bLr.isLastTraversableNode)(parentNode)) return false;
    return (0, $33bLr.getComputedStyle)(parentNode).position === 'fixed' || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $33bLr.getOverflowAncestors)(element, [], false).filter((el)=>(0, $33bLr.isElement)(el) && (0, $33bLr.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $33bLr.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $33bLr.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $33bLr.isElement)(currentNode) && !(0, $33bLr.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $33bLr.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $33bLr.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $33bLr.isOverflowElement)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $33bLr.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $33bLr.isTopLayer)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $1obCQ.max)(rect.top, top);
        right = (0, $1obCQ.min)(rect.right, right);
        bottom = (0, $1obCQ.min)(rect.bottom, bottom);
        left = (0, $1obCQ.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $1obCQ.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== 'body' || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $1obCQ.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $33bLr.getComputedStyle)(element).position === 'static';
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $33bLr.isHTMLElement)(element) || (0, $33bLr.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $33bLr.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $33bLr.getWindow)(element);
    if ((0, $33bLr.isTopLayer)(element)) return win;
    if (!(0, $33bLr.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $33bLr.getParentNode)(element);
        while(svgOffsetParent && !(0, $33bLr.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $33bLr.isElement)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $33bLr.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $33bLr.isTableElement)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $33bLr.isLastTraversableNode)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $33bLr.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $33bLr.getContainingBlock)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $33bLr.getComputedStyle)(element).direction === 'rtl';
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $33bLr.getDocumentElement,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $33bLr.isElement,
    isRTL: $461947879dcdbcd4$var$isRTL
};
function $461947879dcdbcd4$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $33bLr.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $1obCQ.floor)(top);
        const insetRight = (0, $1obCQ.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $1obCQ.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $1obCQ.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $1obCQ.max)(0, (0, $1obCQ.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$461947879dcdbcd4$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $33bLr.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, $33bLr.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && !$461947879dcdbcd4$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $cZ41y.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $cZ41y.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $cZ41y.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $cZ41y.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $cZ41y.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $cZ41y.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $cZ41y.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $cZ41y.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $cZ41y.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $cZ41y.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $cZ41y.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("cZ41y", function(module, exports) {

$parcel$export(module.exports, "detectOverflow", () => $973e4da43f2a375d$export$37b6bde19b108ecc);
$parcel$export(module.exports, "computePosition", () => $973e4da43f2a375d$export$48a53dcb22e581d0);
$parcel$export(module.exports, "arrow", () => $973e4da43f2a375d$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $973e4da43f2a375d$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $973e4da43f2a375d$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $973e4da43f2a375d$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $973e4da43f2a375d$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $973e4da43f2a375d$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $973e4da43f2a375d$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $973e4da43f2a375d$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $973e4da43f2a375d$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("1obCQ")).rectToClientRect);

var $1obCQ = parcelRequire("1obCQ");
function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $1obCQ.getSideAxis)(placement);
    const alignmentAxis = (0, $1obCQ.getAlignmentAxis)(placement);
    const alignLength = (0, $1obCQ.getAxisLength)(alignmentAxis);
    const side = (0, $1obCQ.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $1obCQ.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state);
    const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $1obCQ.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $1obCQ.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $973e4da43f2a375d$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $973e4da43f2a375d$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $973e4da43f2a375d$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $1obCQ.getAlignmentAxis)(placement);
            const length = (0, $1obCQ.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $1obCQ.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $1obCQ.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $1obCQ.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $1obCQ.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $1obCQ.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $1obCQ.getAlignment)(placement) === alignment || (autoAlignment ? (0, $1obCQ.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $1obCQ.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $1obCQ.placements) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $1obCQ.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $1obCQ.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $1obCQ.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $1obCQ.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $1obCQ.getSide)(placement);
            const initialSideAxis = (0, $1obCQ.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $1obCQ.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $1obCQ.getOppositePlacement)(initialPlacement)
            ] : (0, $1obCQ.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $1obCQ.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $1obCQ.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $1obCQ.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $1obCQ.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $1obCQ.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $1obCQ.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $1obCQ.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $1obCQ.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $1obCQ.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $1obCQ.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $1obCQ.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $1obCQ.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $1obCQ.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $1obCQ.getSide)(placement) === 'left';
                    const maxRight = (0, $1obCQ.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $1obCQ.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $973e4da43f2a375d$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $1obCQ.getSide)(placement);
    const alignment = (0, $1obCQ.getAlignment)(placement);
    const isVertical = (0, $1obCQ.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $973e4da43f2a375d$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $1obCQ.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $1obCQ.getSideAxis)((0, $1obCQ.getSide)(placement));
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $1obCQ.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $1obCQ.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $1obCQ.getSideAxis)(placement);
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $1obCQ.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $973e4da43f2a375d$var$originSides.has((0, $1obCQ.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $1obCQ.getSide)(placement);
            const alignment = (0, $1obCQ.getAlignment)(placement);
            const isYAxis = (0, $1obCQ.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $1obCQ.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $1obCQ.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $1obCQ.max)(overflow.left, 0);
                const xMax = (0, $1obCQ.max)(overflow.right, 0);
                const yMin = (0, $1obCQ.max)(overflow.top, 0);
                const yMax = (0, $1obCQ.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $1obCQ.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $1obCQ.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("1obCQ", function(module, exports) {

$parcel$export(module.exports, "sides", () => $10310cf078d13212$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $10310cf078d13212$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $10310cf078d13212$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $10310cf078d13212$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $10310cf078d13212$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $10310cf078d13212$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $10310cf078d13212$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $10310cf078d13212$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $10310cf078d13212$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $10310cf078d13212$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $10310cf078d13212$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $10310cf078d13212$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $10310cf078d13212$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $10310cf078d13212$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $10310cf078d13212$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $10310cf078d13212$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $10310cf078d13212$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $10310cf078d13212$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $10310cf078d13212$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $10310cf078d13212$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $10310cf078d13212$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $10310cf078d13212$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $10310cf078d13212$var$lrPlacement = [
    'left',
    'right'
];
const $10310cf078d13212$var$rlPlacement = [
    'right',
    'left'
];
const $10310cf078d13212$var$tbPlacement = [
    'top',
    'bottom'
];
const $10310cf078d13212$var$btPlacement = [
    'bottom',
    'top'
];
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $10310cf078d13212$var$rlPlacement : $10310cf078d13212$var$lrPlacement;
            return isStart ? $10310cf078d13212$var$lrPlacement : $10310cf078d13212$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $10310cf078d13212$var$tbPlacement : $10310cf078d13212$var$btPlacement;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    const side = $10310cf078d13212$export$3c915306cb7fc97a(placement);
    return $10310cf078d13212$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("33bLr", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $238ac70369f38756$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $238ac70369f38756$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $238ac70369f38756$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $238ac70369f38756$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $238ac70369f38756$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $238ac70369f38756$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $238ac70369f38756$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $238ac70369f38756$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $238ac70369f38756$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $238ac70369f38756$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $238ac70369f38756$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $238ac70369f38756$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $238ac70369f38756$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $238ac70369f38756$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $238ac70369f38756$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $238ac70369f38756$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $238ac70369f38756$export$7bf1f8740e3e34af);
function $238ac70369f38756$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $238ac70369f38756$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $238ac70369f38756$var$containRe = /paint|layout|strict|content/;
const $238ac70369f38756$var$isNotNone = (value)=>!!value && value !== 'none';
let $238ac70369f38756$var$isWebKitValue;
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $238ac70369f38756$var$isNotNone(css.transform) || $238ac70369f38756$var$isNotNone(css.translate) || $238ac70369f38756$var$isNotNone(css.scale) || $238ac70369f38756$var$isNotNone(css.rotate) || $238ac70369f38756$var$isNotNone(css.perspective) || !$238ac70369f38756$export$78551043582a6a98() && ($238ac70369f38756$var$isNotNone(css.backdropFilter) || $238ac70369f38756$var$isNotNone(css.filter)) || $238ac70369f38756$var$willChangeRe.test(css.willChange || '') || $238ac70369f38756$var$containRe.test(css.contain || '');
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if ($238ac70369f38756$var$isWebKitValue == null) $238ac70369f38756$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $238ac70369f38756$var$isWebKitValue;
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("jLbqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62b4578a0a2b358$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = (0, $acw62.useLayoutEffect);

});


parcelRegister("jk22o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e111773323c0bcc0$export$2e2bcd8739ae039);
var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("cbdLd", function(module, exports) {

var $g5Zhu = parcelRequire("g5Zhu");
function $8de12fa6a893dcd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de12fa6a893dcd1$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de12fa6a893dcd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $g5Zhu(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de12fa6a893dcd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $8de12fa6a893dcd1$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $5DKOa(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("02Ztr", function(module, exports) {

var $gpDEB = parcelRequire("gpDEB");

var $kzBhd = parcelRequire("kzBhd");

var $72a6v = parcelRequire("72a6v");

var $dIU5s = parcelRequire("dIU5s");
function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $gpDEB(r) || $kzBhd(r, e) || $72a6v(r, e) || $dIU5s();
}
module.exports = $008fdf6f13d86ab1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gpDEB", function(module, exports) {
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kzBhd", function(module, exports) {
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $efa3fde0b6100532$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("72a6v", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2zZPz(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2zZPz(r, a) : void 0;
    }
}
module.exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2zZPz", function(module, exports) {
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dIU5s", function(module, exports) {
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9fdae42208ebda05$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gZU1N", function(module, exports) {

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c05no(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5DKOa(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("f8wIT", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $b050fc8434f4a0e1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $aAhot(t, e);
}
module.exports = $b050fc8434f4a0e1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e) {
    return module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9jKhT", function(module, exports) {

var $cGTaw = parcelRequire("cGTaw");

var $5HCVq = parcelRequire("5HCVq");

var $eN9hz = parcelRequire("eN9hz");
function $6c89cb228f797fa5$var$_createSuper(t) {
    var r = $5HCVq();
    return function() {
        var e, o = $cGTaw(t);
        if (r) {
            var s = $cGTaw(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $eN9hz(this, e);
    };
}
module.exports = $6c89cb228f797fa5$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cGTaw", function(module, exports) {
function $93d4339c80153a6a$var$_getPrototypeOf(t) {
    return module.exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $93d4339c80153a6a$var$_getPrototypeOf(t);
}
module.exports = $93d4339c80153a6a$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5HCVq", function(module, exports) {
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eN9hz", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;

var $6zC7B = parcelRequire("6zC7B");
function $ac4cd79166dac6e4$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ac4cd79166dac6e4$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $6zC7B(t);
}
module.exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6zC7B", function(module, exports) {
function $4c93951af9bb8a88$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $4c93951af9bb8a88$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fUHKi", function(module, exports) {

var $5F6pO = parcelRequire("5F6pO");

var $hAHB6 = parcelRequire("hAHB6");

var $72a6v = parcelRequire("72a6v");

var $8UrHA = parcelRequire("8UrHA");
function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $5F6pO(r) || $hAHB6(r) || $72a6v(r) || $8UrHA();
}
module.exports = $b95e04f2d4c66124$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5F6pO", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2zZPz(r);
}
module.exports = $41f5c206613f56c9$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hAHB6", function(module, exports) {
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $cce79e023a3a67e7$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8UrHA", function(module, exports) {
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $67c90abe6042aecd$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gS6QF", function(module, exports) {
function $c4870074adc2be76$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $c4870074adc2be76$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gmF1g", function(module, exports) {
module.exports = JSON.parse("{\"lightmodeActionBorderRadiusDefault\":\"4px\",\"lightmodeActionColorDefault\":\"#006DA3\",\"lightmodeActionColorDisabledPrimary\":\"#CBCCCD\",\"lightmodeActionColorDisabledSecondary\":\"#7D8082\",\"lightmodeActionColorDisabledTertiary\":\"#4B4D4E\",\"lightmodeActionColorHoverDefault\":\"#004B70\",\"lightmodeActionColorHoverSecondary\":\"#F0FAFF\",\"lightmodeContentFontSize\":\"16px\",\"lightmodeContentFontWeight\":\"400\",\"lightmodeContentCommonFontSize\":\"16px\",\"lightmodeContentCommonFontWeight\":\"400\",\"lightmodeContentCommonLineHeight\":\"1.5\",\"lightmodeContentCommonTextColorDefault\":\"#191A1A\",\"lightmodeContentCommonTextColorReverse\":\"#FFFFFF\",\"lightmodeContentDisclaimerColor\":\"#191A1A\",\"lightmodeContentDisclaimerFontSize\":\"10px\",\"lightmodeContentDisclaimerFontWeight\":\"400\",\"lightmodeContentDisclaimerLineHeight\":\"1.5\",\"lightmodeContentHeadingColor\":\"#191A1A\",\"lightmodeContentHeadingFontSize\":\"30px\",\"lightmodeContentHeadingFontWeight\":\"500\",\"lightmodeContentHeadingLineHeight\":\"1.5\",\"lightmodeContentHeadingMarginBottom\":\"32px\",\"lightmodeContentHeadingLargeColor\":\"#191A1A\",\"lightmodeContentHeadingLargeFontSize\":\"36px\",\"lightmodeContentHeadingLargeFontWeight\":\"600\",\"lightmodeContentHeadingLargeLineHeight\":\"1.5\",\"lightmodeContentHeavyColor\":\"#191A1A\",\"lightmodeContentHeavyFontSize\":\"16px\",\"lightmodeContentHeavyFontWeight\":\"600\",\"lightmodeContentHeavyLineHeight\":\"1.5\",\"lightmodeContentHeroColor\":\"#191A1A\",\"lightmodeContentHeroFontSize\":\"64px\",\"lightmodeContentHeroFontWeight\":\"300\",\"lightmodeContentHeroLineHeight\":\"1.5\",\"lightmodeContentMicrocopyColor\":\"#646768\",\"lightmodeContentMicrocopyFontSize\":\"14px\",\"lightmodeContentMicrocopyFontWeight\":\"400\",\"lightmodeContentMicrocopyLineHeight\":\"1.75\",\"lightmodeContentNanocopyColor\":\"#646768\",\"lightmodeContentNanocopyFontSize\":\"12px\",\"lightmodeContentNanocopyFontWeight\":\"450\",\"lightmodeContentNanocopyLineHeight\":\"1.5\",\"lightmodeContentNanoheadingColor\":\"#646768\",\"lightmodeContentNanoheadingFontSize\":\"12px\",\"lightmodeContentNanoheadingFontWeight\":\"575\",\"lightmodeContentNanoheadingLetterCase\":\"uppercase\",\"lightmodeContentNanoheadingLineHeight\":\"1.55\",\"lightmodeContentPageTitleColor\":\"#191A1A\",\"lightmodeContentPageTitleFontSize\":\"50px\",\"lightmodeContentPageTitleFontWeight\":\"600\",\"lightmodeContentPageTitleLineHeight\":\"1.5\",\"lightmodeContentParagraphColor\":\"#191A1A\",\"lightmodeContentParagraphFontSize\":\"16px\",\"lightmodeContentParagraphFontWeight\":\"400\",\"lightmodeContentParagraphLineHeight\":\"1.5\",\"lightmodeContentParagraphMarginBottom\":\"24px\",\"lightmodeContentSubheadingColor\":\"#191A1A\",\"lightmodeContentSubheadingFontSize\":\"20px\",\"lightmodeContentSubheadingFontWeight\":\"525\",\"lightmodeContentSubheadingLineHeight\":\"1.5\",\"lightmodeContentSubheadingMarginBottom\":\"32px\",\"lightmodeContentTextColorDefault\":\"#191A1A\",\"lightmodeContentTextColorReverse\":\"#FFFFFF\",\"lightmodeControlBackgroundColor\":\"#FFFFFF\",\"lightmodeControlBorderColor\":\"#7D8082\",\"lightmodeControlBorderRadius\":\"4px\",\"lightmodeControlFontSize\":\"16px\",\"lightmodeControlTextColor\":\"#191A1A\",\"lightmodeControlAccentColorActive\":\"#006DA3\",\"lightmodeControlAccentColorInactive\":\"#7D8082\",\"lightmodeControlBorderWidthActive\":\"4px\",\"lightmodeControlBorderWidthDefault\":\"1px\",\"lightmodeControlColorDisabledPrimary\":\"#CBCCCD\",\"lightmodeControlColorDisabledSecondary\":\"#7D8082\",\"lightmodeControlColorDisabledTertiary\":\"#4B4D4E\",\"lightmodeLayoutBackgroundColorPrimary\":\"#F0FAFF\",\"lightmodeLayoutBackgroundColorSecondary\":\"#F7F7F7\",\"lightmodeLayoutBackgroundColorTertiary\":\"#FFFAE5\",\"lightmodeLayoutSectionMarginBottom\":\"48px\",\"lightmodeResponseColorCriticalPrimary\":\"#CB0B31\",\"lightmodeResponseColorCriticalSecondary\":\"#FFF0F3\",\"lightmodeResponseColorCriticalTertiary\":\"#9F0423\",\"lightmodeResponseColorNeutralPrimary\":\"#4B4D4E\",\"lightmodeResponseColorNeutralSecondary\":\"#F7F7F7\",\"lightmodeResponseColorSuccessPrimary\":\"#247E58\",\"lightmodeResponseColorSuccessSecondary\":\"#F2FCF9\",\"lightmodeResponseColorWarningPrimary\":\"#D13805\",\"lightmodeResponseColorWarningSecondary\":\"#FFF4F0\",\"lightmodeSurfaceBorderColor\":\"#7D8082\",\"lightmodeSurfaceBorderRadius\":\"4px\",\"lightmodeSurfaceBorderWidth\":\"1px\",\"lightmodeSurfaceBackgroundColorPrimary\":\"#FFFFFF\",\"lightmodeSurfaceBackgroundColorReverse\":\"#323334\",\"lightmodeAutocompleteInputBackgroundColorDefault\":\"#FFFFFF\",\"lightmodeAutocompleteInputBackgroundColorError\":\"#FFF0F3\",\"lightmodeAutocompleteInputValueFontSize\":\"16px\",\"lightmodeAutocompleteInputValueFontWeight\":\"400\",\"lightmodeAvatarAspectRatio\":1,\"lightmodeAvatarBackgroundColor\":\"#FAD141\",\"lightmodeAvatarBorderRadiusEntity\":\"4px\",\"lightmodeAvatarBorderRadiusPerson\":\"50%\",\"lightmodeAvatarWidthLarge\":\"80px\",\"lightmodeAvatarWidthMedium\":\"48px\",\"lightmodeAvatarWidthSmall\":\"40px\",\"lightmodeAvatarWidthXlarge\":\"112px\",\"lightmodeAvatarWidthXsmall\":\"32px\",\"lightmodeAvatarWidthXxlarge\":\"144px\",\"lightmodeBarchartBarBorderRadius\":\"4px\",\"lightmodeBarchartBarBackgroundColorPrimary\":\"#00293D\",\"lightmodeBarchartBarBackgroundColorSecondary\":\"#C08D16\",\"lightmodeBarchartBarBackgroundColorTertiary\":\"#514396\",\"lightmodeBreadcrumbsCurrentPageFontSize\":\"16px\",\"lightmodeBreadcrumbsCurrentPageFontWeight\":\"600\",\"lightmodeBreadcrumbsParentPageFontSize\":\"16px\",\"lightmodeBreadcrumbsParentPageFontWeight\":\"400\",\"lightmodeBreadcrumbsParentPageColorDefault\":\"#006DA3\",\"lightmodeBreadcrumbsParentPageColorHover\":\"#004B70\",\"lightmodeBreadcrumbsParentPageColorVisited\":\"#8A4691\",\"lightmodeButtonBorderRadius\":\"4px\",\"lightmodeButtonFontSize\":\"16px\",\"lightmodeButtonFontWeight\":\"400\",\"lightmodeButtonMinHeight\":\"48px\",\"lightmodeButtonPadding\":\"12px\",\"lightmodeButtonBackgroundColorPrimaryDefault\":\"#006DA3\",\"lightmodeButtonBackgroundColorPrimaryHover\":\"#004B70\",\"lightmodeButtonBackgroundColorPrimaryDestructiveDefault\":\"#CB0B31\",\"lightmodeButtonBackgroundColorPrimaryDestructiveHover\":\"#9F0423\",\"lightmodeButtonBackgroundColorSecondaryDefault\":\"#FFFFFF\",\"lightmodeButtonBackgroundColorSecondaryHover\":\"#F0FAFF\",\"lightmodeButtonBackgroundColorTertiaryDefault\":\"#FFFFFF\",\"lightmodeButtonBackgroundColorTertiaryHover\":\"#F0FAFF\",\"lightmodeButtonBorderColorPrimary\":\"#006DA3\",\"lightmodeButtonBorderColorSecondary\":\"#006DA3\",\"lightmodeButtonBorderColorTertiary\":\"#FFFFFF\",\"lightmodeButtonTextColorPrimary\":\"#FFFFFF\",\"lightmodeButtonTextColorSecondaryDefault\":\"#006DA3\",\"lightmodeButtonTextColorSecondaryHover\":\"#004B70\",\"lightmodeButtonTextColorTertiaryDefault\":\"#006DA3\",\"lightmodeButtonTextColorTertiaryHover\":\"#004B70\",\"lightmodeCardBackgroundColor\":\"#FFFFFF\",\"lightmodeCardBorderColor\":\"#7D8082\",\"lightmodeCardBorderRadius\":\"4px\",\"lightmodeCardBorderWidth\":\"1px\",\"lightmodeCardMarginBottom\":\"24px\",\"lightmodeCardHeaderBorderBottomColor\":\"#7D8082\",\"lightmodeCardHeaderBorderBottomWidth\":\"1px\",\"lightmodeCardRadioBackgroundColor\":\"#FFFFFF\",\"lightmodeCardRadioBorderColorDefault\":\"#7D8082\",\"lightmodeCardRadioBorderColorHover\":\"#006DA3\",\"lightmodeCardRadioBorderColorSelected\":\"#006DA3\",\"lightmodeCardRadioFooterFooterTextColor\":\"#191A1A\",\"lightmodeCardRadioFooterFooterTextFontSize\":\"16px\",\"lightmodeCardRadioFooterFooterTextFontWeight\":\"400\",\"lightmodeCardRadioFooterFormattedListColor\":\"#191A1A\",\"lightmodeCardRadioFooterFormattedListFontSize\":\"16px\",\"lightmodeCardRadioFooterFormattedListFontWeight\":\"400\",\"lightmodeCardRadioSubtextColor\":\"#191A1A\",\"lightmodeCardRadioSubtextFontSize\":\"16px\",\"lightmodeCardRadioSubtextFontWeight\":\"400\",\"lightmodeCardRadioSubtitleColor\":\"#191A1A\",\"lightmodeCardRadioSubtitleFontSize\":\"16px\",\"lightmodeCardRadioSubtitleFontWeight\":\"400\",\"lightmodeCardRadioTitleColor\":\"#191A1A\",\"lightmodeCardRadioTitleFontSize\":\"20px\",\"lightmodeCardRadioTitleFontWeight\":\"525\",\"lightmodeCheckboxBorderColor\":\"#7D8082\",\"lightmodeCheckboxBorderRadius\":\"4px\",\"lightmodeCheckboxHeight\":\"24px\",\"lightmodeCheckboxSelectedColor\":\"#006DA3\",\"lightmodeCheckboxTextColor\":\"#191A1A\",\"lightmodeCheckboxWidth\":\"24px\",\"lightmodeCheckboxBackgroundColorDefault\":\"#FFFFFF\",\"lightmodeCheckboxBackgroundColorDisabled\":\"#CBCCCD\",\"lightmodeCheckboxBackgroundColorSelected\":\"#006DA3\",\"lightmodeCheckboxCheckmarkDisabled\":\"#4B4D4E\",\"lightmodeCheckboxCheckmarkSelected\":\"#FFFFFF\",\"lightmodeCheckboxValueColor\":\"#191A1A\",\"lightmodeCheckboxValueFontSize\":\"16px\",\"lightmodeCheckboxValueFontWeight\":\"400\",\"lightmodeDatepickerCalendarColumnHeaderColor\":\"#646768\",\"lightmodeDatepickerCalendarColumnHeaderFontSize\":\"12px\",\"lightmodeDatepickerCalendarColumnHeaderFontWeight\":\"450\",\"lightmodeDatepickerCalendarDayFontSize\":\"12px\",\"lightmodeDatepickerCalendarDayFontWeight\":\"700\",\"lightmodeDatepickerCalendarDayBackgroundColorDefault\":\"#FFFFFF\",\"lightmodeDatepickerCalendarDayBackgroundColorDisabled\":\"#FFFFFF\",\"lightmodeDatepickerCalendarDayBackgroundColorHoliday\":\"#E5F6FF\",\"lightmodeDatepickerCalendarDayBackgroundColorHover\":\"#F0FAFF\",\"lightmodeDatepickerCalendarDayBackgroundColorLastSellingDay\":\"#FEECE6\",\"lightmodeDatepickerCalendarDayBackgroundColorSelected\":\"#006DA3\",\"lightmodeDatepickerCalendarDayBorderColorDefault\":\"#7D8082\",\"lightmodeDatepickerCalendarDayBorderColorDisabled\":\"#FFFFFF\",\"lightmodeDatepickerCalendarDayBorderColorHoliday\":\"#004B70\",\"lightmodeDatepickerCalendarDayBorderColorHover\":\"#7D8082\",\"lightmodeDatepickerCalendarDayBorderColorLastSellingDay\":\"#6D1D03\",\"lightmodeDatepickerCalendarDayBorderColorSelected\":\"#006DA3\",\"lightmodeDatepickerCalendarDayTextColorDefault\":\"#191A1A\",\"lightmodeDatepickerCalendarDayTextColorDisabled\":\"#4B4D4E\",\"lightmodeDatepickerCalendarDayTextColorHoliday\":\"#191A1A\",\"lightmodeDatepickerCalendarDayTextColorHover\":\"#191A1A\",\"lightmodeDatepickerCalendarDayTextColorLastSellingDay\":\"#191A1A\",\"lightmodeDatepickerCalendarDayTextColorSelected\":\"#FFFFFF\",\"lightmodeDatepickerCalendarKeyFontSize\":\"14px\",\"lightmodeDatepickerCalendarKeyFontWeight\":\"400\",\"lightmodeDatepickerCalendarTitleColor\":\"#191A1A\",\"lightmodeDatepickerCalendarTitleFontSize\":\"20px\",\"lightmodeDatepickerCalendarTitleFontWeight\":\"525\",\"lightmodeDialogBackgroundColor\":\"#FFFFFF\",\"lightmodeDialogBorderColor\":\"#7D8082\",\"lightmodeDialogBorderRadius\":\"4px\",\"lightmodeDialogBorderWidth\":\"1px\",\"lightmodeDialogColor\":\"#191A1A\",\"lightmodeDialogFontSize\":\"14px\",\"lightmodeDialogFontWeight\":\"400\",\"lightmodeDialogAnimateIn\":\"300ms cubic-bezier(0.42,0,1,1) 0ms\",\"lightmodeDialogAnimateOut\":\"200ms cubic-bezier(0,0,0.58,1) 0ms\",\"lightmodeDialogDescriptionFontSize\":\"14px\",\"lightmodeDialogDescriptionFontWeight\":\"400\",\"lightmodeDialogTitleFontSize\":\"16px\",\"lightmodeDialogTitleFontWeight\":\"600\",\"lightmodeDonutchartBackgroundColor1stCategory\":\"#00293D\",\"lightmodeDonutchartBackgroundColor2ndCategory\":\"#C08D16\",\"lightmodeDonutchartBackgroundColor3rdCategory\":\"#9F2B04\",\"lightmodeDonutchartBackgroundColor4thCategory\":\"#2BAB81\",\"lightmodeDonutchartBackgroundColor5thCategory\":\"#1588C1\",\"lightmodeDonutchartBackgroundColor6thCategory\":\"#550213\",\"lightmodeDonutchartBackgroundColor7thCategory\":\"#514396\",\"lightmodeDonutchartBackgroundColor8thCategory\":\"#891420\",\"lightmodeFileUploadDropzoneLabelFontSize\":\"14px\",\"lightmodeFileUploadDropzoneLabelFontWeight\":\"400\",\"lightmodeFileUploadFileFileNameFontSize\":\"14px\",\"lightmodeFileUploadFileFileNameFontWeight\":\"400\",\"lightmodeFileUploadFileUploadStatusFontSize\":\"12px\",\"lightmodeFileUploadFileUploadStatusFontWeight\":\"575\",\"lightmodeFileUploadTitleFontSize\":\"16px\",\"lightmodeFileUploadTitleFontWeight\":\"600\",\"lightmodeInlineNotificationBorderRadius\":\"4px\",\"lightmodeInlineNotificationFontSize\":\"16px\",\"lightmodeInlineNotificationFontWeight\":\"400\",\"lightmodeInlineNotificationHeight\":\"48px\",\"lightmodeInlineNotificationBackgroundColorCritical\":\"#FFF0F3\",\"lightmodeInlineNotificationBackgroundColorNeutral\":\"#F7F7F7\",\"lightmodeInlineNotificationBackgroundColorSuccess\":\"#F2FCF9\",\"lightmodeInlineNotificationBackgroundColorWarning\":\"#FFF4F0\",\"lightmodeInlineNotificationBorderColorCritical\":\"#CB0B31\",\"lightmodeInlineNotificationBorderColorNeutral\":\"#4B4D4E\",\"lightmodeInlineNotificationBorderColorSuccess\":\"#247E58\",\"lightmodeInlineNotificationBorderColorWarning\":\"#D13805\",\"lightmodeInlineNotificationBorderWidthDefault\":\"1px\",\"lightmodeInlineNotificationBorderWidthRight\":\"8px\",\"lightmodeLabelColorDefault\":\"#191A1A\",\"lightmodeLabelColorError\":\"#CB0B31\",\"lightmodeLabelColorMicrocopy\":\"#646768\",\"lightmodeLabelFontSizeDefault\":\"14px\",\"lightmodeLabelFontSizeError\":\"14px\",\"lightmodeLabelFontSizeMicrocopy\":\"12px\",\"lightmodeLabelFontWeightDefault\":\"400\",\"lightmodeLabelFontWeightError\":\"700\",\"lightmodeLabelFontWeightMicrocopy\":\"450\",\"lightmodeLinkDecoration\":\"underline\",\"lightmodeLinkColorDefault\":\"#0076A0\",\"lightmodeLinkColorHover\":\"#044D66\",\"lightmodeLinkColorVisited\":\"#8C4B9D\",\"lightmodeLinkFontSizeDefault\":\"16px\",\"lightmodeLinkFontSizeHelp\":\"14px\",\"lightmodeLinkFontWeightDefault\":\"400\",\"lightmodeLinkFontWeightHelp\":\"400\",\"lightmodePaginationPageNodeBorderRadius\":\"4px\",\"lightmodePaginationPageNodeFontSize\":\"16px\",\"lightmodePaginationPageNodeBackgroundColorDefault\":\"#FFFFFF\",\"lightmodePaginationPageNodeBackgroundColorHover\":\"#F0FAFF\",\"lightmodePaginationPageNodeBorderColorActive\":\"#006DA3\",\"lightmodePaginationPageNodeBorderWidthActive\":\"4px\",\"lightmodePaginationPageNodeFontWeightActive\":\"600\",\"lightmodePaginationPageNodeFontWeightDefault\":\"400\",\"lightmodePaginationPageNodeTextColorActive\":\"#191A1A\",\"lightmodePaginationPageNodeTextColorDefault\":\"#006DA3\",\"lightmodePaginationPageNodeTextColorHover\":\"#004B70\",\"lightmodeProgressStepperCheckmarkColor\":\"#247E58\",\"lightmodeProgressStepperPathCurrentLocationColor\":\"#646768\",\"lightmodeProgressStepperPathTraveledColor\":\"#646768\",\"lightmodeRadioHeight\":\"48px\",\"lightmodeRadioBackgroundColorDefault\":\"#FFFFFF\",\"lightmodeRadioBackgroundColorDisabled\":\"#CBCCCD\",\"lightmodeRadioBorderColorDefault\":\"#7D8082\",\"lightmodeRadioBorderColorDisabled\":\"#CBCCCD\",\"lightmodeRadioIndicatorDisabled\":\"#4B4D4E\",\"lightmodeRadioIndicatorHeight\":\"24px\",\"lightmodeRadioIndicatorSelectedColor\":\"#006DA3\",\"lightmodeRadioIndicatorUnselectedColor\":\"#7D8082\",\"lightmodeRadioIndicatorWidth\":\"24px\",\"lightmodeRadioValueColor\":\"#191A1A\",\"lightmodeRadioValueFontSize\":\"16px\",\"lightmodeRadioValueMarginLeft\":\"8px\",\"lightmodeScrimBackgroundColor\":\"rgba(55, 56, 67, 0.75)\",\"lightmodeScrimEntrance\":\"300ms cubic-bezier(0,0,0.58,1) 0ms\",\"lightmodeScrimExit\":\"200ms cubic-bezier(0.42,0,1,1) 0ms\",\"lightmodeSearchInputButtonFontSize\":\"16px\",\"lightmodeSearchInputButtonFontWeight\":\"400\",\"lightmodeSearchInputValueFontSize\":\"16px\",\"lightmodeSearchInputValueFontWeight\":\"400\",\"lightmodeSegmentedControlBackgroundColor\":\"#F7F7F7\",\"lightmodeSegmentedControlBorderRadius\":\"50%\",\"lightmodeSegmentedControlFontSize\":\"16px\",\"lightmodeSegmentedControlPadding\":\"4px\",\"lightmodeSegmentedControlButtonBackgroundColorActive\":\"#FFFFFF\",\"lightmodeSegmentedControlButtonBackgroundColorInactive\":\"#F7F7F7\",\"lightmodeSegmentedControlButtonBorderColorActive\":\"#006DA3\",\"lightmodeSegmentedControlButtonBorderColorInactive\":\"#F7F7F7\",\"lightmodeSegmentedControlButtonColorActive\":\"#006DA3\",\"lightmodeSegmentedControlButtonColorInactive\":\"#494949\",\"lightmodeSegmentedControlButtonFontWeightActive\":\"600\",\"lightmodeSegmentedControlButtonFontWeightInactive\":\"400\",\"lightmodeSelectInputBorderColor\":\"#7D8082\",\"lightmodeSelectInputBackgroundColorDefault\":\"#FFFFFF\",\"lightmodeSelectInputBackgroundColorError\":\"#FFF0F3\",\"lightmodeSelectInputValueColor\":\"#191A1A\",\"lightmodeSelectInputValueFontSize\":\"16px\",\"lightmodeSelectInputValueFontWeight\":\"400\",\"lightmodeTabAccentColor\":\"#006DA3\",\"lightmodeTabAnimation\":\"400ms cubic-bezier(0.42,0,1,1) 0ms\",\"lightmodeTabColor\":\"#191A1A\",\"lightmodeTabFontSize\":\"16px\",\"lightmodeTabPadding\":\"8px 24px\",\"lightmodeTabBackgroundColorDefault\":\"#FFFFFF\",\"lightmodeTabBackgroundColorHover\":\"#F0FAFF\",\"lightmodeTabBorderBottomColorActive\":\"#006DA3\",\"lightmodeTabBorderBottomColorInactive\":\"#7D8082\",\"lightmodeTabBorderBottomWidthActive\":\"4px\",\"lightmodeTabBorderBottomWidthInactive\":\"1px\",\"lightmodeTabFontWeightActive\":\"600\",\"lightmodeTabFontWeightDefault\":\"400\",\"lightmodeTableMarginBottom\":\"48px\",\"lightmodeTableCaptionFontSizeDescription\":\"16px\",\"lightmodeTableCaptionFontSizeTitle\":\"20px\",\"lightmodeTableCaptionFontWeightDescription\":\"400\",\"lightmodeTableCaptionFontWeightTitle\":\"525\",\"lightmodeTableCellFontSize\":\"16px\",\"lightmodeTableCellFontWeight\":\"400\",\"lightmodeTableCellBackgroundColorDefault\":\"#FFFFFF\",\"lightmodeTableCellBackgroundColorSorted\":\"#F0FAFF\",\"lightmodeTableCellBorderBottomColor\":\"#CBCCCD\",\"lightmodeTableCellBorderBottomWidth\":\"1px\",\"lightmodeTableCellHeaderFontSize\":\"12px\",\"lightmodeTableCellHeaderLetterCase\":\"uppercase\",\"lightmodeTableCellHeaderBorderBottomColorDefault\":\"#CBCCCD\",\"lightmodeTableCellHeaderBorderBottomColorSorted\":\"#7D8082\",\"lightmodeTableCellHeaderBorderBottomWidthDefault\":\"1px\",\"lightmodeTableCellHeaderBorderBottomWidthSorted\":\"2px\",\"lightmodeTableCellHeaderPaddingDefault\":\"1px 24px\",\"lightmodeTableCellHeaderTextColorDefault\":\"#646768\",\"lightmodeTableCellHeaderTextColorSorted\":\"#191A1A\",\"lightmodeTableCellPaddingDefault\":\"8px\",\"lightmodeTagBorderRadius\":\"20px\",\"lightmodeTagFontSize\":\"12px\",\"lightmodeTagFontWeight\":\"450\",\"lightmodeTagBackgroundColorGeneric\":\"#F7F7F7\",\"lightmodeTagBackgroundColorGreen\":\"#F7FCF2\",\"lightmodeTagBackgroundColorRed\":\"#FFF0F3\",\"lightmodeTagBackgroundColorSunflower\":\"#FFFFFF\",\"lightmodeTagBorderColorGeneric\":\"#7D8082\",\"lightmodeTagBorderColorGreen\":\"#247E58\",\"lightmodeTagBorderColorRed\":\"#CB0B31\",\"lightmodeTagBorderColorSunflower\":\"#C08D16\",\"lightmodeTagHeightCondensed\":\"24px\",\"lightmodeTagHeightRoomy\":\"32px\",\"lightmodeTextAreaBorderColor\":\"#7D8082\",\"lightmodeTextAreaBorderRadius\":\"4px\",\"lightmodeTextAreaBorderWidth\":\"1px\",\"lightmodeTextAreaValueFontSize\":\"16px\",\"lightmodeTextAreaValueFontWeight\":\"400\",\"lightmodeTextInputBorderColor\":\"#7D8082\",\"lightmodeTextInputBorderRadius\":\"4px\",\"lightmodeTextInputBorderWidth\":\"1px\",\"lightmodeTextInputColor\":\"#191A1A\",\"lightmodeTextInputFontSize\":\"16px\",\"lightmodeTextInputBackgroundColorDefault\":\"#FFFFFF\",\"lightmodeTextInputBackgroundColorError\":\"#FFF0F3\",\"lightmodeTextInputPaddingCondensed\":\"8px\",\"lightmodeTextInputPaddingDefault\":\"12px\",\"lightmodeToggleHeight\":\"24px\",\"lightmodeTogglePadding\":\"2px\",\"lightmodeToggleWidth\":\"48px\",\"lightmodeToggleBackgroundColorOff\":\"#7D8082\",\"lightmodeToggleBackgroundColorOn\":\"#006DA3\",\"lightmodeToggleControlBackgroundColor\":\"#FFFFFF\",\"lightmodeToggleControlBorderRadius\":\"12px\",\"lightmodeToggleControlHeight\":\"20px\",\"lightmodeToggleControlWidth\":\"20px\",\"lightmodeTooltipFontSizeDescription\":\"14px\",\"lightmodeTooltipFontSizeTitle\":\"16px\",\"lightmodeTooltipFontWeightDescription\":\"400\",\"lightmodeTooltipFontWeightTitle\":\"600\",\"refAnimateCurveEase\":\"cubic-bezier(0.25,1,0.25,1)\",\"refAnimateCurveEaseIn\":\"cubic-bezier(0.42,0,1,1)\",\"refAnimateCurveEaseInOut\":\"cubic-bezier(0.42,0,0.58,1)\",\"refAnimateCurveEaseOut\":\"cubic-bezier(0,0,0.58,1)\",\"refAnimateCurveLinear\":\"cubic-bezier(0,0,1,1)\",\"refAnimateInEase\":\"300ms cubic-bezier(0,0,0.58,1) 0ms\",\"refAnimateInEmphasis\":\"400ms cubic-bezier(0.42,0,1,1) 0ms\",\"refAnimateInFade\":\"300ms cubic-bezier(0.42,0,1,1) 0ms\",\"refAnimateInGrow\":\"300ms cubic-bezier(0,0,0.58,1) 0ms\",\"refAnimateInSlide\":\"400ms cubic-bezier(0.42,0,0.58,1) 0ms\",\"refAnimateOutEase\":\"200ms cubic-bezier(0.42,0,1,1) 0ms\",\"refAnimateOutEmphasis\":\"300ms cubic-bezier(0,0,0.58,1) 0ms\",\"refAnimateOutFade\":\"200ms cubic-bezier(0,0,0.58,1) 0ms\",\"refAnimateOutShrink\":\"200ms cubic-bezier(0.42,0,1,1) 0ms\",\"refAnimateOutSlide\":\"400ms cubic-bezier(0.42,0,0.58,1) 0ms\",\"refAnimateSpeedCrawl\":\"800ms\",\"refAnimateSpeedDefault\":\"100ms\",\"refAnimateSpeedJog\":\"300ms\",\"refAnimateSpeedRun\":\"200ms\",\"refAnimateSpeedSprint\":\"100ms\",\"refAnimateSpeedWalk\":\"400ms\",\"refBorderWidth\":\"1px\",\"refBorderRadiusDefault\":\"4px\",\"refBorderRadiusModerate\":\"4px\",\"refBorderRadiusSubtle\":\"2px\",\"refBreakpointLarge\":\"1040px\",\"refBreakpointMedium\":\"720px\",\"refBreakpointSmall\":\"320px\",\"refBreakpointXlarge\":\"1320px\",\"refColorAlice\":\"#F8FBFC\",\"refColorAzure\":\"#E7F6FD\",\"refColorBlue50\":\"#001824\",\"refColorBlue100\":\"#00293D\",\"refColorBlue150\":\"#003A57\",\"refColorBlue200\":\"#004B70\",\"refColorBlue250\":\"#005C8A\",\"refColorBlue300\":\"#006DA3\",\"refColorBlue400\":\"#1588C1\",\"refColorBlue500\":\"#28A4E2\",\"refColorBlue600\":\"#5AB8E7\",\"refColorBlue700\":\"#7BCCF4\",\"refColorBlue800\":\"#B5DAED\",\"refColorBlue850\":\"#CAE5F2\",\"refColorBlue900\":\"#D6F1FF\",\"refColorBlue950\":\"#E5F6FF\",\"refColorBlue970\":\"#F0FAFF\",\"refColorBrandDarkGold\":\"#FAD141\",\"refColorBrandDarkGray\":\"#3B3D3F\",\"refColorBrandLightBlue\":\"#8BBDD9\",\"refColorBrick\":\"#651D24\",\"refColorCardinal\":\"#D61F34\",\"refColorCerulean\":\"#0076A0\",\"refColorCharcoal\":\"#494949\",\"refColorClearDay\":\"#F1FAFE\",\"refColorDarkCardinal\":\"#B51629\",\"refColorDarkCerulean\":\"#044D66\",\"refColorDarkFuchsia\":\"#8C4B9D\",\"refColorDew\":\"#F2F9F6\",\"refColorEden\":\"#008549\",\"refColorEmpress\":\"#767576\",\"refColorGhost\":\"#CDCCCB\",\"refColorGlacier\":\"#7FB2C5\",\"refColorGold50\":\"#241700\",\"refColorGold100\":\"#3D2800\",\"refColorGold150\":\"#573800\",\"refColorGold200\":\"#704900\",\"refColorGold250\":\"#8A5A00\",\"refColorGold300\":\"#94650F\",\"refColorGold400\":\"#C08D16\",\"refColorGold500\":\"#DFB22C\",\"refColorGold600\":\"#FAD141\",\"refColorGold700\":\"#FDE272\",\"refColorGold800\":\"#FFEEA3\",\"refColorGold850\":\"#FFF2BD\",\"refColorGold900\":\"#FFF7D6\",\"refColorGold950\":\"#FFFAE5\",\"refColorGold970\":\"#FFFCF0\",\"refColorGreen50\":\"#121C08\",\"refColorGreen100\":\"#1F2F0E\",\"refColorGreen150\":\"#2B4314\",\"refColorGreen200\":\"#385719\",\"refColorGreen250\":\"#456B1F\",\"refColorGreen300\":\"#517E24\",\"refColorGreen400\":\"#6BAB2B\",\"refColorGreen500\":\"#85C841\",\"refColorGreen600\":\"#9ED369\",\"refColorGreen700\":\"#B8E689\",\"refColorGreen800\":\"#D1F1B1\",\"refColorGreen850\":\"#DEF5C7\",\"refColorGreen900\":\"#EBF8DD\",\"refColorGreen950\":\"#F2FBEA\",\"refColorGreen970\":\"#F7FCF2\",\"refColorJade\":\"#00A286\",\"refColorLightGold\":\"#FDE57F\",\"refColorLightGreen\":\"#79D3BE\",\"refColorLightOrange\":\"#F9AF95\",\"refColorLightPurple\":\"#B0ADDA\",\"refColorLuna\":\"#02255E\",\"refColorMardiGras\":\"#514396\",\"refColorMirage\":\"#404040\",\"refColorMist\":\"#929492\",\"refColorNeutral0\":\"#000000\",\"refColorNeutral50\":\"#0D0D0D\",\"refColorNeutral100\":\"#191A1A\",\"refColorNeutral150\":\"#262727\",\"refColorNeutral200\":\"#323334\",\"refColorNeutral250\":\"#3F4041\",\"refColorNeutral300\":\"#4B4D4E\",\"refColorNeutral400\":\"#646768\",\"refColorNeutral500\":\"#7D8082\",\"refColorNeutral600\":\"#979A9B\",\"refColorNeutral700\":\"#B1B3B4\",\"refColorNeutral800\":\"#CBCCCD\",\"refColorNeutral850\":\"#D8D9D9\",\"refColorNeutral900\":\"#E5E6E6\",\"refColorNeutral950\":\"#F2F2F2\",\"refColorNeutral970\":\"#F7F7F7\",\"refColorNeutral1000\":\"#FFFFFF\",\"refColorNight\":\"#343333\",\"refColorNiro\":\"#19191A\",\"refColorOrange\":\"#FF824E\",\"refColorOrange50\":\"#230901\",\"refColorOrange100\":\"#3C1002\",\"refColorOrange150\":\"#551702\",\"refColorOrange200\":\"#6D1D03\",\"refColorOrange250\":\"#862403\",\"refColorOrange300\":\"#9F2B04\",\"refColorOrange400\":\"#D13805\",\"refColorOrange500\":\"#F94A10\",\"refColorOrange600\":\"#FA784C\",\"refColorOrange700\":\"#FB8E6A\",\"refColorOrange800\":\"#FFBAA3\",\"refColorOrange850\":\"#FFCDBD\",\"refColorOrange900\":\"#FEE1D7\",\"refColorOrange950\":\"#FEECE6\",\"refColorOrange970\":\"#FFF4F0\",\"refColorPumpkin\":\"#C74C0B\",\"refColorPurple\":\"#665E99\",\"refColorPurple50\":\"#0E0A1A\",\"refColorPurple100\":\"#18112D\",\"refColorPurple150\":\"#1F1344\",\"refColorPurple200\":\"#2B1F51\",\"refColorPurple250\":\"#301E67\",\"refColorPurple300\":\"#514396\",\"refColorPurple400\":\"#6F5AAF\",\"refColorPurple500\":\"#8872CA\",\"refColorPurple600\":\"#A490DF\",\"refColorPurple700\":\"#B4A4E5\",\"refColorPurple800\":\"#C6BAE8\",\"refColorPurple850\":\"#D6CDEE\",\"refColorPurple900\":\"#E0D6FF\",\"refColorPurple950\":\"#ECE5FF\",\"refColorPurple970\":\"#F4F0FF\",\"refColorRaven\":\"#616061\",\"refColorRed50\":\"#230108\",\"refColorRed100\":\"#3C020D\",\"refColorRed150\":\"#550213\",\"refColorRed200\":\"#650B1D\",\"refColorRed250\":\"#891420\",\"refColorRed300\":\"#9F0423\",\"refColorRed400\":\"#CB0B31\",\"refColorRed500\":\"#EA1F48\",\"refColorRed600\":\"#FA4267\",\"refColorRed700\":\"#FB748F\",\"refColorRed800\":\"#FFA3B6\",\"refColorRed850\":\"#FFBDCA\",\"refColorRed900\":\"#FFD6DE\",\"refColorRed950\":\"#FFE5EB\",\"refColorRed970\":\"#FFF0F3\",\"refColorRose\":\"#A03150\",\"refColorSeashell\":\"#FFF8F3\",\"refColorSienna\":\"#C8450E\",\"refColorSmoke\":\"#F1F3F4\",\"refColorSunflower\":\"#C48817\",\"refColorTeal50\":\"#081C13\",\"refColorTeal100\":\"#0E2F21\",\"refColorTeal150\":\"#14432F\",\"refColorTeal200\":\"#19573D\",\"refColorTeal250\":\"#1F6B4B\",\"refColorTeal300\":\"#247E58\",\"refColorTeal400\":\"#2BAB81\",\"refColorTeal500\":\"#41C89B\",\"refColorTeal600\":\"#69D3B0\",\"refColorTeal700\":\"#82EDCA\",\"refColorTeal800\":\"#B1F1DC\",\"refColorTeal850\":\"#C7F5E6\",\"refColorTeal900\":\"#DDF8EF\",\"refColorTeal950\":\"#EAFBF5\",\"refColorTeal970\":\"#F2FCF9\",\"refColorTutu\":\"#FDF4F5\",\"refColorViolet50\":\"#190A1A\",\"refColorViolet100\":\"#2A112D\",\"refColorViolet150\":\"#401344\",\"refColorViolet200\":\"#4D1F51\",\"refColorViolet250\":\"#5F2664\",\"refColorViolet300\":\"#6C3271\",\"refColorViolet400\":\"#8A4691\",\"refColorViolet500\":\"#B24EBC\",\"refColorViolet600\":\"#CB69D3\",\"refColorViolet700\":\"#DE89E6\",\"refColorViolet800\":\"#ECB1F1\",\"refColorViolet850\":\"#F1C7F5\",\"refColorViolet900\":\"#F7DCF9\",\"refColorViolet950\":\"#F8ECF9\",\"refColorViolet970\":\"#FBF3FC\",\"refColorVividCerulean\":\"#0090C2\",\"refColorWhite\":\"#FFFFFF\",\"refFontFamilyDisplay\":\"EJ Sans Text Var\",\"refFontFamilyText\":\"EJ Sans Text Var\",\"refFontLineHeightCondensed\":\"1.3\",\"refFontLineHeightDefault\":\"1.5\",\"refFontLineHeightRoomy\":\"1.618\",\"refFontLineHeightSpacious\":\"1.75\",\"refFontResourceWoff\":\"'https://edwardjoneslive.pc.cdn.bitgravity.com/content/axiom/fonts/EJSansTextVar/woff2/EJ_Sans_Text_v2_000_Romans_Variable.woff'\",\"refFontResourceWoff2\":\"'https://edwardjoneslive.pc.cdn.bitgravity.com/content/axiom/fonts/EJSansTextVar/woff2/EJ_Sans_Text_v2_000_Romans_Variable.woff2'\",\"refFontSizeDefault\":\"16px\",\"refFontSizeGinormous\":\"64px\",\"refFontSizeHuge\":\"50px\",\"refFontSizeLarge\":\"20px\",\"refFontSizeMedium\":\"16px\",\"refFontSizeSmall\":\"14px\",\"refFontSizeXlarge\":\"30px\",\"refFontSizeXsmall\":\"12px\",\"refFontSizeXxlarge\":\"36px\",\"refFontSizeXxsmall\":\"10px\",\"refFontWeightBold\":\"700\",\"refFontWeightDefault\":\"400\",\"refFontWeightLight\":\"300\",\"refFontWeightMedium\":\"500\",\"refFontWeightMediumPlus\":\"525\",\"refFontWeightMediumSemibold\":\"575\",\"refFontWeightRegular\":\"400\",\"refFontWeightRegularMedium\":\"450\",\"refFontWeightSemibold\":\"600\",\"refSize01\":\"2px\",\"refSize02\":\"4px\",\"refSize03\":\"8px\",\"refSize04\":\"12px\",\"refSize05\":\"16px\",\"refSize06\":\"20px\",\"refSize07\":\"24px\",\"refSize08\":\"32px\",\"refSize09\":\"40px\",\"refSize10\":\"44px\",\"refSize11\":\"48px\",\"refSize12\":\"64px\",\"refSize13\":\"80px\",\"refSize14\":\"96px\",\"refSize15\":\"112px\",\"refSize16\":\"128px\",\"refSize17\":\"144px\",\"refSizeBase\":\"8px\",\"refSizeHairline\":\"1px\",\"refSpace01\":\"2px\",\"refSpace02\":\"4px\",\"refSpace03\":\"8px\",\"refSpace04\":\"12px\",\"refSpace05\":\"16px\",\"refSpace06\":\"20px\",\"refSpace07\":\"24px\",\"refSpace08\":\"32px\",\"refSpace09\":\"40px\",\"refSpace10\":\"44px\",\"refSpace11\":\"48px\",\"refSpace12\":\"64px\"}");

});

parcelRegister("6IdRn", function(module, exports) {

$parcel$export(module.exports, "EventSubscriber", () => $4e319a71384c3012$export$b68dd350ea69c913);
$parcel$export(module.exports, "openWindow", () => $4e319a71384c3012$export$e5968930f07b8990);
$parcel$export(module.exports, "displayRelWkspc", () => $4e319a71384c3012$export$cecff1659cc6244f);
$parcel$export(module.exports, "openPdfWin", () => $4e319a71384c3012$export$3aaa5db63a8795c1);
$parcel$export(module.exports, "openUMSWin", () => $4e319a71384c3012$export$acbfdcc283a84bb0);

var $cE2z5 = parcelRequire("cE2z5");

var $45fvw = parcelRequire("45fvw");
var $4e319a71384c3012$export$6192cc88c8758041 = function(n) {
    var t = n.toLowerCase(), e = t.includes("apps2"), a = e ? "apps2.devjones.com" : "apps.devjones.com", o = e ? "apps2.uat.edwardjones.com" : "apps.uat.edwardjones.com", r = e ? "apps2.edwardjones.com" : "apps.edwardjones.com", d = t.includes("devjones.com"), i = t.includes("uat"), c = t.includes("edwardjones.com") && !i;
    return t = d ? a : i ? o : c ? r : "";
}, $4e319a71384c3012$var$a = function() {
    return $4e319a71384c3012$var$a = Object.assign || function(n) {
        for(var t, e = 1, a = arguments.length; e < a; e++)for(var o in t = arguments[e])Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
        return n;
    }, $4e319a71384c3012$var$a.apply(this, arguments);
};
function $4e319a71384c3012$var$o(n, t) {
    var e = "function" == typeof Symbol && n[Symbol.iterator];
    if (!e) return n;
    var a, o, r = e.call(n), d = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(a = r.next()).done;)d.push(a.value);
    } catch (n) {
        o = {
            error: n
        };
    } finally{
        try {
            a && !a.done && (e = r.return) && e.call(r);
        } finally{
            if (o) throw o.error;
        }
    }
    return d;
}
function $4e319a71384c3012$var$r(n, t, e) {
    if (e || 2 === arguments.length) for(var a, o = 0, r = t.length; o < r; o++)!a && o in t || (a || (a = Array.prototype.slice.call(t, 0, o)), a[o] = t[o]);
    return n.concat(a || Array.prototype.slice.call(t));
}
"function" == typeof SuppressedError && SuppressedError;
var $4e319a71384c3012$export$b68dd350ea69c913 = function() {
    var n = {};
    return {
        getEvent: function(t) {
            return n[t];
        },
        subscribe: function(t, e) {
            return n[t] = e, t;
        },
        unsubscribe: function(t) {
            delete n[t];
        },
        checkSubscription: function(t) {
            return void 0 !== n[t];
        },
        evoke: function(t) {
            for(var e = [], a = 1; a < arguments.length; a++)e[a - 1] = arguments[a];
            if (void 0 === n[t]) throw new Error("Could not evoke event. Event of name [".concat(t, "] is not being tracked."));
            return n[t].apply(n, $4e319a71384c3012$var$r([], $4e319a71384c3012$var$o(e), !1));
        }
    };
}, $4e319a71384c3012$export$b47b1e333f1bf2a6 = function() {
    var t = $4e319a71384c3012$export$b68dd350ea69c913();
    return {
        beforeUnload: function(e, a) {
            var d = a || {}, i = d.eventName, c = void 0 === i ? (0, $cE2z5.default)() : i, u = d.preventPageUnload, s = void 0 !== u && u, l = d.eventProps, f = void 0 === l ? [] : l, h = function(n) {
                s && n.preventDefault(), e.apply(void 0, $4e319a71384c3012$var$r([], $4e319a71384c3012$var$o(f), !1));
            };
            return t.subscribe(c, h), window.addEventListener("beforeunload", h), c;
        },
        unsubscribeBeforeOnload: function(n) {
            var e = t.getEvent(n);
            t.unsubscribe(n), window.removeEventListener("beforeunload", e);
        }
    };
}, $4e319a71384c3012$export$4293978a3aa4b038 = function(n, t, e, a, o) {
    return !(o < 2021 && 5 === t) && (5 === a ? n.some(function(n) {
        return "en-us" === n.locale ? n.month === t && (n.date === e || n.date + n.saturdayAdjustment === e) : n.month === t && n.date === e;
    }) : 1 === a ? n.some(function(n) {
        return "en-us" === n.locale && n.month === t && (n.date === e || n.date + n.sundayAdjustment === e) || "en-ca" === n.locale && n.month === t && (n.date === e || n.date + n.saturdayAdjustment === e || n.date + n.sundayAdjustment === e);
    }) : 2 === a ? n.some(function(n) {
        return "en-ca" === n.locale && ("boxingDaySundayAdjustment" in n || "boxingDayMondayAdjustment" in n) && n.month === t && (n.date + n.boxingDaySundayAdjustment === e || n.date + n.boxingDayMondayAdjustment === e) || n.month === t && n.date === e;
    }) : 6 === a ? n.some(function(n) {
        return n.month === t && n.date === e && 0 === n.saturdayAdjustment;
    }) : 0 === a ? n.some(function(n) {
        return n.month === t && n.date === e && 0 === n.sundayAdjustment;
    }) : n.some(function(n) {
        return n.month === t && n.date === e;
    }));
}, $4e319a71384c3012$export$cb75dfaab8b3c58d = function(n, t, e, a) {
    return n.some(function(n) {
        return n.month === t && n.dayOfWeek === e && n.weekOfMonth === a;
    });
}, $4e319a71384c3012$export$80f357ba9cfd6e15 = function(n, e, a, o) {
    return 4 === n && 1 === a && e === function(n) {
        var e = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))("5-31-".concat(n), "MM-DD-YYYY").day();
        return 0 === e ? 25 : 31 - (e - 1);
    }(o);
}, $4e319a71384c3012$var$l = [
    {
        month: 0,
        date: 1,
        saturdayAdjustment: 0,
        sundayAdjustment: 1,
        locale: "en-us"
    },
    {
        month: 5,
        date: 19,
        saturdayAdjustment: 0,
        sundayAdjustment: 1,
        locale: "en-us"
    },
    {
        month: 6,
        date: 4,
        saturdayAdjustment: 0,
        sundayAdjustment: 1,
        locale: "en-us"
    },
    {
        month: 10,
        date: 11,
        saturdayAdjustment: 0,
        sundayAdjustment: 1,
        locale: "en-us"
    },
    {
        month: 11,
        date: 25,
        saturdayAdjustment: 0,
        sundayAdjustment: 1,
        locale: "en-us"
    }
], $4e319a71384c3012$var$f = [
    {
        month: 0,
        dayOfWeek: 1,
        weekOfMonth: 3
    },
    {
        month: 1,
        dayOfWeek: 1,
        weekOfMonth: 3
    },
    {
        month: 8,
        dayOfWeek: 1,
        weekOfMonth: 1
    },
    {
        month: 9,
        dayOfWeek: 1,
        weekOfMonth: 2
    },
    {
        month: 10,
        dayOfWeek: 4,
        weekOfMonth: 4
    }
], $4e319a71384c3012$export$e687f858d51654ba = function(n) {
    if (!n) return !1;
    var t = n.month(), e = n.date(), a = n.day(), o = function(n) {
        return Math.ceil(n.date() / 7);
    }(n), r = n.year();
    return $4e319a71384c3012$export$4293978a3aa4b038($4e319a71384c3012$var$l, t, e, a, r) || $4e319a71384c3012$export$cb75dfaab8b3c58d($4e319a71384c3012$var$f, t, a, o) || $4e319a71384c3012$export$80f357ba9cfd6e15(t, e, a, r);
}, $4e319a71384c3012$export$124e3adae1cff7a8 = function(n, t, e, a) {
    var o = function(n) {
        var t, e, a, o, r, d = Math.floor(n / 100), i = n % 19;
        return t = Math.floor((d - 15) / 2) + 202 - 11 * i, [
            21,
            24,
            25,
            27,
            28,
            29,
            30,
            31,
            32,
            34,
            35,
            38
        ].indexOf(d) > -1 ? t -= 1 : [
            33,
            36,
            37,
            39,
            40
        ].indexOf(d) > -1 && (t -= 2), o = 21 + (t %= 30), 29 === t && (o -= 1), 28 === t && i > 10 && (o -= 1), 3 == (r = (40 - d) % 4) && (r += 1), r > 1 && (r += 1), a = o + ((20 - (o - 19) % 7 - r - ((t = n % 100) + Math.floor(t / 4)) % 7) % 7 + 1), (a -= 2) > 31 ? (a -= 31, e = 3) : e = 2, {
            month: e,
            date: a
        };
    }(a);
    return n === o.month && t === o.date && 5 === e;
}, $4e319a71384c3012$export$55de0282ab5c6601 = function(n) {
    if (4 === n.month() && 1 === n.isoWeekday()) {
        var t = n.date();
        if (t < 25 && t >= 18) return !0;
    }
    return !1;
}, $4e319a71384c3012$var$y = [
    {
        month: 0,
        date: 1,
        saturdayAdjustment: 2,
        sundayAdjustment: 1,
        locale: "en-ca"
    },
    {
        month: 6,
        date: 1,
        saturdayAdjustment: 2,
        sundayAdjustment: 1,
        locale: "en-ca"
    },
    {
        month: 11,
        date: 25,
        saturdayAdjustment: 2,
        sundayAdjustment: 1,
        locale: "en-ca"
    },
    {
        month: 11,
        date: 26,
        saturdayAdjustment: 2,
        sundayAdjustment: 2,
        locale: "en-ca",
        boxingDaySundayAdjustment: 2,
        boxingDayMondayAdjustment: 1
    }
], $4e319a71384c3012$var$p = [
    {
        month: 0,
        date: 1,
        saturdayAdjustment: 0,
        sundayAdjustment: 1,
        locale: "en-us"
    },
    {
        month: 5,
        date: 19,
        saturdayAdjustment: -1,
        sundayAdjustment: 1,
        locale: "en-us"
    },
    {
        month: 6,
        date: 4,
        saturdayAdjustment: -1,
        sundayAdjustment: 1,
        locale: "en-us"
    },
    {
        month: 11,
        date: 25,
        saturdayAdjustment: -1,
        sundayAdjustment: 1,
        locale: "en-us"
    }
], $4e319a71384c3012$var$v = [
    {
        month: 0,
        dayOfWeek: 1,
        weekOfMonth: 3
    },
    {
        month: 1,
        dayOfWeek: 1,
        weekOfMonth: 3
    },
    {
        month: 8,
        dayOfWeek: 1,
        weekOfMonth: 1
    },
    {
        month: 10,
        dayOfWeek: 4,
        weekOfMonth: 4
    }
], $4e319a71384c3012$var$b = [
    {
        month: 7,
        dayOfWeek: 1,
        weekOfMonth: 1
    },
    {
        month: 1,
        dayOfWeek: 1,
        weekOfMonth: 3
    },
    {
        month: 8,
        dayOfWeek: 1,
        weekOfMonth: 1
    },
    {
        month: 9,
        dayOfWeek: 1,
        weekOfMonth: 2
    }
], $4e319a71384c3012$export$839b9b90a3e514c1 = function(n, t) {
    if (!n) return !1;
    var e = n.month(), a = n.date(), o = n.day(), r = function(n) {
        return Math.ceil(n.date() / 7);
    }(n), d = n.year();
    return $4e319a71384c3012$export$4293978a3aa4b038(function(n) {
        var t = [];
        return "en-ca" !== n && "all" !== n || (t = [].concat($4e319a71384c3012$var$y)), "en-us" !== n && "all" !== n || (t = [].concat(t, $4e319a71384c3012$var$p)), t;
    }(t), e, a, o, d) || $4e319a71384c3012$export$cb75dfaab8b3c58d(function(n) {
        var t = [];
        return "en-ca" !== n && "all" !== n || (t = [].concat($4e319a71384c3012$var$b)), "en-us" !== n && "all" !== n || (t = [].concat(t, $4e319a71384c3012$var$v)), t;
    }(t), e, o, r) || $4e319a71384c3012$export$124e3adae1cff7a8(e, a, o, d) || ("en-us" === t || "all" === t) && $4e319a71384c3012$export$80f357ba9cfd6e15(e, a, o, d) || ("en-ca" === t || "all" === t) && $4e319a71384c3012$export$55de0282ab5c6601(n);
}, $4e319a71384c3012$export$903c25cc52a57879 = function(n, e) {
    if (!n) return !1;
    var a = n.month(), o = n.date(), r = n.year(), d = function(n, e, a) {
        var o = function(n, t) {
            var e = [
                31,
                28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ];
            return t % 4 == 0 ? t % 100 == 0 && t % 400 != 0 ? e[n] : [
                31,
                29,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ][n] : e[n];
        }(n, e), r = n + 1, d = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))("".concat(o, "-").concat(r, "-").concat(e), "DD-MM-YYYY");
        if ("en-us" === a) {
            var i = 2;
            if (11 === n) {
                for(; i > 0;)0 === d.day() || 6 === d.day() || $4e319a71384c3012$export$e687f858d51654ba(d) || $4e319a71384c3012$export$839b9b90a3e514c1(d, a) ? d = d.subtract(1, "day") : (d = d.subtract(1, "day"), i -= 1);
                return 0 === d.day() && (d = d.subtract(2, "days")), 6 === d.day() && (d = d.subtract(1, "day")), {
                    month: d.month(),
                    date: d.date(),
                    year: d.year()
                };
            }
            for(; 5 !== d.day();)d = d.subtract(1, "day");
            for(; i > 0;)$4e319a71384c3012$export$e687f858d51654ba(d) || $4e319a71384c3012$export$839b9b90a3e514c1(d, a) ? d = d.subtract(1, "day") : (d = d.subtract(1, "day"), i -= 1);
            return {
                month: d.month(),
                date: d.date(),
                year: d.year()
            };
        }
        for(; 0 === d.day() || 6 === d.day() || $4e319a71384c3012$export$e687f858d51654ba(d) || $4e319a71384c3012$export$839b9b90a3e514c1(d, a);)d = d.subtract(1, "day");
        return {
            month: d.month(),
            date: d.date(),
            year: d.year()
        };
    }(a, r, e);
    return a === d.month && o === d.date && r === d.year;
}, $4e319a71384c3012$export$e5968930f07b8990 = function(n) {
    if (n.winURL) {
        var t = n.winURL;
        -1 === t.indexOf("?") ? t += "?" : t += "&";
        var e = function(n) {
            return "number" == typeof n.winWidth && 0 !== n.winWidth ? n.winWidth < 1 ? Math.floor(window.screen.availWidth * n.winWidth) : n.winWidth : Math.min(Math.floor(.75 * window.screen.availWidth), Math.floor(990));
        }(n), a = function(n) {
            var t = 0;
            return "number" == typeof n.winHeight && 0 !== n.winHeight ? n.winHeight < 1 ? Math.floor(window.screen.availHeight * t) : n.winHeight : Math.floor(.8 * window.screen.availHeight);
        }(n), o = "number" == typeof n.winLeft ? n.winLeft : Math.floor((window.screen.availWidth - e) * ((Math.random() + 1) / 3)), r = "number" == typeof n.winTop ? n.winTop : Math.floor((window.screen.availHeight - (a + 30)) * ((Math.random() + 1) / 4)), d = n.winNa || n.winName || "_blank", i = function(n) {
            return n.winParms ? n.winParms : n.winParams ? n.winParams : "hotkeys=1,location=0,menubar=1,personalbar=1,resizable=1,scrollbars=1,status=1,titlebar=1,toolbar=0";
        }(n);
        setTimeout(function() {
            var n = window.open(t, d, "".concat(i, ",width=").concat(e, ",height=").concat(a, ",top=").concat(r, ",left=").concat(o));
            n.focus(), n = null;
        }, 0);
    } else console.warn("openWindow(): No URL provided, no action taken");
}, $4e319a71384c3012$var$W = function(n, t) {
    var e = $4e319a71384c3012$var$a({}, n), r = $4e319a71384c3012$var$o(t, 2), d = r[0], i = r[1];
    return e[d] = i, e;
};
var $4e319a71384c3012$var$k = function(n) {
    return n.toLowerCase().includes("edwardjones.com") ? "edwardjones.com" : "devjones.com";
};
$4e319a71384c3012$var$k(window.location.href);
var $4e319a71384c3012$var$O = function(n) {
    var t = $4e319a71384c3012$var$r([], $4e319a71384c3012$var$o(new URLSearchParams(n)), !1).reduce($4e319a71384c3012$var$W, {});
    switch(!0){
        case "P" === t.type:
            return t.conId = t.number, t;
        case !t.ctryCd:
            return t.acctId || t.vndrAcctId || (t.vndrAcctId = t.number), t;
        case "US" === t.ctryCd && !t.vndrAcctId:
            return t.vndrAcctId = t.number, t;
        case !t.acctId:
            return t.acctId = t.number, t;
        default:
            return t;
    }
}, $4e319a71384c3012$var$g = function(n, t, e, a) {
    var o, r = (o = window.location.href, "https:" === window.location.protocol ? "https://relworkspaceweb.".concat($4e319a71384c3012$var$k(o), ":9548/RLWRelationshipWorkspace-web/display-workspace.action") : "http://relworkspaceweb.".concat($4e319a71384c3012$var$k(o), ":9048/RLWRelationshipWorkspace-web/display-workspace.action")), d = function(n, t) {
        var e = !1 === t ? "F" : "T", a = [
            "acctId",
            "conId",
            "rlshpId",
            "vndrAcctId"
        ].filter(function(t) {
            return n[t];
        }).map(function(t) {
            return "".concat(t, "=").concat(n[t]);
        }).join("&");
        return (a += "&authorizeUser=".concat(e)).replace("vndrAcctId", "vndrAcctNo");
    }(t, e), i = encodeURIComponent(a);
    return "".concat(r, "?appId=").concat(n, "&").concat(d, "&parmSet=").concat(i);
}, $4e319a71384c3012$export$cecff1659cc6244f = function(n, t, e) {
    var a = $4e319a71384c3012$var$O(t);
    if (function(n) {
        return !(!n.acctId && !n.conId && !n.rlshpId && !n.vndrAcctId && (console.error("ERROR : UXD-COMMON-UTILS : displayRelWkspc()", "\n", "One of the following values must be set in the second argument passed to displayRelWkspc:", "\n", "  - acctId", "\n", "  - conId", "\n", "  - rlshpId", "\n", "  - vndrAcctId"), 1));
    }(a)) {
        var o, r, d, i, c, u, s = $4e319a71384c3012$var$g(n, a, e, t);
        $4e319a71384c3012$export$e5968930f07b8990((o = s, r = Math.floor, d = Math.random, i = window.screen, c = i.availWidth, u = i.availHeight, {
            winURL: o,
            winName: "_blank",
            winParams: "resizable=1,status=1,scrollbars=0",
            winWidth: Math.min(Math.floor(.87 * c), Math.floor(990)),
            winHeight: r(.85 * u),
            winLeft: r(u * ((d() + 1) / 45)),
            winTop: r(c * ((d() + 1) / 45))
        }));
    }
}, $4e319a71384c3012$export$3aaa5db63a8795c1 = function(n, t, e, a) {
    var o = 0;
    o = "number" == typeof e ? e < 1 ? Math.floor(window.screen.availWidth * e) : e : Math.floor(.65 * window.screen.availWidth);
    var r = 0;
    r = "number" == typeof e ? a < 1 ? Math.floor(window.screen.availHeight * a) : a : Math.floor(.85 * window.screen.availHeight);
    var d = "string" != typeof t || "" === t ? "GenericWin" + (new Date).getTime() : t, i = Math.floor(window.screen.availWidth * ((Math.random() + 1) / 45)), c = Math.floor(window.screen.availHeight * ((Math.random() + 1) / 45));
    window.PDFWINDOW = window.open(n, d, "".concat("resizable=yes,scrollbars=yes", ",width=").concat(o, ",height=").concat(r, ",top=").concat(c, ",left=").concat(i)), window.PDFWINDOW.focus();
}, $4e319a71384c3012$export$acbfdcc283a84bb0 = function(n, t, e, a, o, r, d, i) {
    var c, u = "".concat((c = window.location.href, "https:" === window.location.protocol ? "https://userutilityweb.".concat($4e319a71384c3012$var$k(c), ":9507/FWKurl-mapping-web/forward-url-map-entry.action") : "http://userutilityweb.".concat($4e319a71384c3012$var$k(c), ":9007/FWKurl-mapping-web/forward-url-map-entry.action")), "?keyId=").concat(n);
    if (!0 === i) $4e319a71384c3012$export$3aaa5db63a8795c1(u, null, a, o);
    else {
        var s = 0;
        s = "number" == typeof a ? a < 1 ? Math.floor(window.screen.availWidth * a) : a : window.screen.width > 1900 ? Math.floor(.55 * window.screen.availWidth) : window.screen.width > 1280 ? Math.floor(.7 * window.screen.availWidth) : Math.floor(.8 * window.screen.availWidth);
        var l = 0;
        if ("number" == typeof o) l = o < 1 ? Math.floor(window.screen.availWidth * o) : o;
        else {
            var f = window.screen.availHeight;
            l = f < 800 ? Math.floor(.7 * f) : Math.floor(.77 * f);
        }
        $4e319a71384c3012$export$e5968930f07b8990({
            winURL: u,
            winNa: t,
            winParms: "string" == typeof e ? e : "directories=yes,location=yes,resizable=yes,status=yes,scrollbars=yes,hotkeys=yes,menubar=yes,toolbar=yes,personalbar=yes,titlebar=yes",
            winWidth: s,
            winHeight: l,
            winLeft: r,
            winTop: d
        });
    }
};

});
parcelRegister("cE2z5", function(module, exports) {

$parcel$export(module.exports, "default", () => $934b35c73ea25036$export$2e2bcd8739ae039);

var $9eJIW = parcelRequire("9eJIW");

var $6mxhW = parcelRequire("6mxhW");

var $7bwB0 = parcelRequire("7bwB0");
function $934b35c73ea25036$var$v4(options, buf, offset) {
    if ((0, $9eJIW.default).randomUUID && !buf && !options) return (0, $9eJIW.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $6mxhW.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $7bwB0.unsafeStringify)(rnds);
}
var $934b35c73ea25036$export$2e2bcd8739ae039 = $934b35c73ea25036$var$v4;

});
parcelRegister("9eJIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b98e3a6364ff655$export$2e2bcd8739ae039);
const $6b98e3a6364ff655$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $6b98e3a6364ff655$export$2e2bcd8739ae039 = {
    randomUUID: $6b98e3a6364ff655$var$randomUUID
};

});

parcelRegister("6mxhW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a1e9e89460c6fc7$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $4a1e9e89460c6fc7$var$getRandomValues;
const $4a1e9e89460c6fc7$var$rnds8 = new Uint8Array(16);
function $4a1e9e89460c6fc7$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$4a1e9e89460c6fc7$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $4a1e9e89460c6fc7$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$4a1e9e89460c6fc7$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $4a1e9e89460c6fc7$var$getRandomValues($4a1e9e89460c6fc7$var$rnds8);
}

});

parcelRegister("7bwB0", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $53b2d85c75686444$export$8fb373d660548968);

var $23hYW = parcelRequire("23hYW");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $53b2d85c75686444$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$53b2d85c75686444$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $53b2d85c75686444$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $53b2d85c75686444$var$byteToHex[arr[offset + 0]] + $53b2d85c75686444$var$byteToHex[arr[offset + 1]] + $53b2d85c75686444$var$byteToHex[arr[offset + 2]] + $53b2d85c75686444$var$byteToHex[arr[offset + 3]] + '-' + $53b2d85c75686444$var$byteToHex[arr[offset + 4]] + $53b2d85c75686444$var$byteToHex[arr[offset + 5]] + '-' + $53b2d85c75686444$var$byteToHex[arr[offset + 6]] + $53b2d85c75686444$var$byteToHex[arr[offset + 7]] + '-' + $53b2d85c75686444$var$byteToHex[arr[offset + 8]] + $53b2d85c75686444$var$byteToHex[arr[offset + 9]] + '-' + $53b2d85c75686444$var$byteToHex[arr[offset + 10]] + $53b2d85c75686444$var$byteToHex[arr[offset + 11]] + $53b2d85c75686444$var$byteToHex[arr[offset + 12]] + $53b2d85c75686444$var$byteToHex[arr[offset + 13]] + $53b2d85c75686444$var$byteToHex[arr[offset + 14]] + $53b2d85c75686444$var$byteToHex[arr[offset + 15]];
}
function $53b2d85c75686444$var$stringify(arr, offset = 0) {
    const uuid = $53b2d85c75686444$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $23hYW.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $53b2d85c75686444$export$2e2bcd8739ae039 = $53b2d85c75686444$var$stringify;

});
parcelRegister("23hYW", function(module, exports) {

$parcel$export(module.exports, "default", () => $17e9cf6add73054f$export$2e2bcd8739ae039);

var $jk0CE = parcelRequire("jk0CE");
function $17e9cf6add73054f$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $jk0CE.default).test(uuid);
}
var $17e9cf6add73054f$export$2e2bcd8739ae039 = $17e9cf6add73054f$var$validate;

});
parcelRegister("jk0CE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1105e30d904a9c8$export$2e2bcd8739ae039);
var $e1105e30d904a9c8$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});


parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $7qKRb.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.default)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $568f4ee4022ba00e$var$getRandomValues;
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("2uohp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0137947e8554ce$export$2e2bcd8739ae039);

var $64ZUg = parcelRequire("64ZUg");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1d0137947e8554ce$var$byteToHex = [];
for(var $1d0137947e8554ce$var$i = 0; $1d0137947e8554ce$var$i < 256; ++$1d0137947e8554ce$var$i)$1d0137947e8554ce$var$byteToHex.push(($1d0137947e8554ce$var$i + 0x100).toString(16).substr(1));
function $1d0137947e8554ce$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $64ZUg.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRegister("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRegister("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("b5weT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2UcEv = parcelRequire("2UcEv");
var $81292b5b491156fc$var$_Modal2 = $81292b5b491156fc$var$_interopRequireDefault($2UcEv);
function $81292b5b491156fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = $81292b5b491156fc$var$_Modal2.default;
module.exports = module.exports["default"];

});
parcelRegister("2UcEv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bodyOpenClassName = module.exports.portalClassName = undefined;
var $21daa036d62cc547$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $21daa036d62cc547$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $21daa036d62cc547$var$_react2 = $21daa036d62cc547$var$_interopRequireDefault($acw62);

var $1u0KT = parcelRequire("1u0KT");
var $21daa036d62cc547$var$_reactDom2 = $21daa036d62cc547$var$_interopRequireDefault($1u0KT);

var $c9Z8w = parcelRequire("c9Z8w");
var $21daa036d62cc547$var$_propTypes2 = $21daa036d62cc547$var$_interopRequireDefault($c9Z8w);

var $brdkq = parcelRequire("brdkq");
var $21daa036d62cc547$var$_ModalPortal2 = $21daa036d62cc547$var$_interopRequireDefault($brdkq);

var $gKo3c = parcelRequire("gKo3c");
var $21daa036d62cc547$var$ariaAppHider = $21daa036d62cc547$var$_interopRequireWildcard($gKo3c);

var $gHLoi = parcelRequire("gHLoi");
var $21daa036d62cc547$var$_safeHTMLElement2 = $21daa036d62cc547$var$_interopRequireDefault($gHLoi);

var $hdX8Q = parcelRequire("hdX8Q");
function $21daa036d62cc547$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $21daa036d62cc547$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $21daa036d62cc547$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $21daa036d62cc547$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $21daa036d62cc547$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $21daa036d62cc547$var$portalClassName = module.exports.portalClassName = "ReactModalPortal";
var $21daa036d62cc547$var$bodyOpenClassName = module.exports.bodyOpenClassName = "ReactModal__Body--open";
var $21daa036d62cc547$var$isReact16 = $gHLoi.canUseDOM && $21daa036d62cc547$var$_reactDom2.default.createPortal !== undefined;
var $21daa036d62cc547$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $21daa036d62cc547$var$getCreatePortal = function getCreatePortal() {
    return $21daa036d62cc547$var$isReact16 ? $21daa036d62cc547$var$_reactDom2.default.createPortal : $21daa036d62cc547$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $21daa036d62cc547$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $21daa036d62cc547$var$Modal = function(_Component) {
    $21daa036d62cc547$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $21daa036d62cc547$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $21daa036d62cc547$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$21daa036d62cc547$var$isReact16 && $21daa036d62cc547$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $21daa036d62cc547$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $21daa036d62cc547$var$getCreatePortal();
            var portal = createPortal(_this, $21daa036d62cc547$var$_react2.default.createElement($21daa036d62cc547$var$_ModalPortal2.default, $21daa036d62cc547$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $21daa036d62cc547$var$_possibleConstructorReturn(_this, _ret);
    }
    $21daa036d62cc547$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$gHLoi.canUseDOM) return;
                if (!$21daa036d62cc547$var$isReact16) this.node = $21daa036d62cc547$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $21daa036d62cc547$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$21daa036d62cc547$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $21daa036d62cc547$var$getParentElement(prevProps.parentSelector);
                var nextParent = $21daa036d62cc547$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$gHLoi.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$21daa036d62cc547$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$gHLoi.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$gHLoi.canUseDOM || !$21daa036d62cc547$var$isReact16) return null;
                if (!this.node && $21daa036d62cc547$var$isReact16) this.node = $21daa036d62cc547$var$createHTMLElement("div");
                var createPortal = $21daa036d62cc547$var$getCreatePortal();
                return createPortal($21daa036d62cc547$var$_react2.default.createElement($21daa036d62cc547$var$_ModalPortal2.default, $21daa036d62cc547$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $21daa036d62cc547$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($acw62.Component);
$21daa036d62cc547$var$Modal.propTypes = {
    isOpen: $21daa036d62cc547$var$_propTypes2.default.bool.isRequired,
    style: $21daa036d62cc547$var$_propTypes2.default.shape({
        content: $21daa036d62cc547$var$_propTypes2.default.object,
        overlay: $21daa036d62cc547$var$_propTypes2.default.object
    }),
    portalClassName: $21daa036d62cc547$var$_propTypes2.default.string,
    bodyOpenClassName: $21daa036d62cc547$var$_propTypes2.default.string,
    htmlOpenClassName: $21daa036d62cc547$var$_propTypes2.default.string,
    className: $21daa036d62cc547$var$_propTypes2.default.oneOfType([
        $21daa036d62cc547$var$_propTypes2.default.string,
        $21daa036d62cc547$var$_propTypes2.default.shape({
            base: $21daa036d62cc547$var$_propTypes2.default.string.isRequired,
            afterOpen: $21daa036d62cc547$var$_propTypes2.default.string.isRequired,
            beforeClose: $21daa036d62cc547$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $21daa036d62cc547$var$_propTypes2.default.oneOfType([
        $21daa036d62cc547$var$_propTypes2.default.string,
        $21daa036d62cc547$var$_propTypes2.default.shape({
            base: $21daa036d62cc547$var$_propTypes2.default.string.isRequired,
            afterOpen: $21daa036d62cc547$var$_propTypes2.default.string.isRequired,
            beforeClose: $21daa036d62cc547$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $21daa036d62cc547$var$_propTypes2.default.oneOfType([
        $21daa036d62cc547$var$_propTypes2.default.instanceOf($21daa036d62cc547$var$_safeHTMLElement2.default),
        $21daa036d62cc547$var$_propTypes2.default.instanceOf($gHLoi.SafeHTMLCollection),
        $21daa036d62cc547$var$_propTypes2.default.instanceOf($gHLoi.SafeNodeList),
        $21daa036d62cc547$var$_propTypes2.default.arrayOf($21daa036d62cc547$var$_propTypes2.default.instanceOf($21daa036d62cc547$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $21daa036d62cc547$var$_propTypes2.default.func,
    onRequestClose: $21daa036d62cc547$var$_propTypes2.default.func,
    closeTimeoutMS: $21daa036d62cc547$var$_propTypes2.default.number,
    ariaHideApp: $21daa036d62cc547$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $21daa036d62cc547$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $21daa036d62cc547$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $21daa036d62cc547$var$_propTypes2.default.bool,
    preventScroll: $21daa036d62cc547$var$_propTypes2.default.bool,
    parentSelector: $21daa036d62cc547$var$_propTypes2.default.func,
    aria: $21daa036d62cc547$var$_propTypes2.default.object,
    data: $21daa036d62cc547$var$_propTypes2.default.object,
    role: $21daa036d62cc547$var$_propTypes2.default.string,
    contentLabel: $21daa036d62cc547$var$_propTypes2.default.string,
    shouldCloseOnEsc: $21daa036d62cc547$var$_propTypes2.default.bool,
    overlayRef: $21daa036d62cc547$var$_propTypes2.default.func,
    contentRef: $21daa036d62cc547$var$_propTypes2.default.func,
    id: $21daa036d62cc547$var$_propTypes2.default.string,
    overlayElement: $21daa036d62cc547$var$_propTypes2.default.func,
    contentElement: $21daa036d62cc547$var$_propTypes2.default.func
};
$21daa036d62cc547$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $21daa036d62cc547$var$portalClassName,
    bodyOpenClassName: $21daa036d62cc547$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $21daa036d62cc547$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $21daa036d62cc547$var$_react2.default.createElement("div", props, children);
    }
};
$21daa036d62cc547$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $hdX8Q.polyfill)($21daa036d62cc547$var$Modal);
module.exports.default = $21daa036d62cc547$var$Modal;

});
parcelRegister("brdkq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $853c8e196b6200d7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $853c8e196b6200d7$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $853c8e196b6200d7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $853c8e196b6200d7$var$_propTypes2 = $853c8e196b6200d7$var$_interopRequireDefault($c9Z8w);

var $6nu5B = parcelRequire("6nu5B");
var $853c8e196b6200d7$var$focusManager = $853c8e196b6200d7$var$_interopRequireWildcard($6nu5B);

var $bUn0I = parcelRequire("bUn0I");
var $853c8e196b6200d7$var$_scopeTab2 = $853c8e196b6200d7$var$_interopRequireDefault($bUn0I);

var $gKo3c = parcelRequire("gKo3c");
var $853c8e196b6200d7$var$ariaAppHider = $853c8e196b6200d7$var$_interopRequireWildcard($gKo3c);

var $kYIf9 = parcelRequire("kYIf9");
var $853c8e196b6200d7$var$classList = $853c8e196b6200d7$var$_interopRequireWildcard($kYIf9);

var $gHLoi = parcelRequire("gHLoi");
var $853c8e196b6200d7$var$_safeHTMLElement2 = $853c8e196b6200d7$var$_interopRequireDefault($gHLoi);

var $kczmP = parcelRequire("kczmP");
var $853c8e196b6200d7$var$_portalOpenInstances2 = $853c8e196b6200d7$var$_interopRequireDefault($kczmP);
parcelRequire("fmy2t");
function $853c8e196b6200d7$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $853c8e196b6200d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $853c8e196b6200d7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $853c8e196b6200d7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $853c8e196b6200d7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $853c8e196b6200d7$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */ var $853c8e196b6200d7$var$isTabKey = function isTabKey(event) {
    return event.code === "Tab" || event.keyCode === 9;
};
var $853c8e196b6200d7$var$isEscKey = function isEscKey(event) {
    return event.code === "Escape" || event.keyCode === 27;
};
var $853c8e196b6200d7$var$ariaHiddenInstances = 0;
var $853c8e196b6200d7$var$ModalPortal = function(_Component) {
    $853c8e196b6200d7$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $853c8e196b6200d7$var$_classCallCheck(this, ModalPortal);
        var _this = $853c8e196b6200d7$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
            var parentDocument = parentSelector && parentSelector().ownerDocument || document;
            // Remove classes.
            bodyOpenClassName && $853c8e196b6200d7$var$classList.remove(parentDocument.body, bodyOpenClassName);
            htmlOpenClassName && $853c8e196b6200d7$var$classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $853c8e196b6200d7$var$ariaHiddenInstances > 0) {
                $853c8e196b6200d7$var$ariaHiddenInstances -= 1;
                if ($853c8e196b6200d7$var$ariaHiddenInstances === 0) $853c8e196b6200d7$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $853c8e196b6200d7$var$focusManager.returnFocus(_this.props.preventScroll);
                    $853c8e196b6200d7$var$focusManager.teardownScopedFocus();
                } else $853c8e196b6200d7$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $853c8e196b6200d7$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $853c8e196b6200d7$var$focusManager.setupScopedFocus(_this.node);
                    $853c8e196b6200d7$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if ($853c8e196b6200d7$var$isTabKey(event)) (0, $853c8e196b6200d7$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && $853c8e196b6200d7$var$isEscKey(event)) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $853c8e196b6200d7$var$_typeof(additional)) === "object" ? additional : {
                base: $853c8e196b6200d7$var$CLASS_NAMES[which],
                afterOpen: $853c8e196b6200d7$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $853c8e196b6200d7$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $853c8e196b6200d7$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
                var parentDocument = parentSelector && parentSelector().ownerDocument || document;
                // Add classes.
                bodyOpenClassName && $853c8e196b6200d7$var$classList.add(parentDocument.body, bodyOpenClassName);
                htmlOpenClassName && $853c8e196b6200d7$var$classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $853c8e196b6200d7$var$ariaHiddenInstances += 1;
                    $853c8e196b6200d7$var$ariaAppHider.hide(appElement);
                }
                $853c8e196b6200d7$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $853c8e196b6200d7$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $853c8e196b6200d7$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $853c8e196b6200d7$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $853c8e196b6200d7$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($acw62.Component);
$853c8e196b6200d7$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$853c8e196b6200d7$var$ModalPortal.propTypes = {
    isOpen: $853c8e196b6200d7$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $853c8e196b6200d7$var$_propTypes2.default.shape({
        content: $853c8e196b6200d7$var$_propTypes2.default.object,
        overlay: $853c8e196b6200d7$var$_propTypes2.default.object
    }),
    style: $853c8e196b6200d7$var$_propTypes2.default.shape({
        content: $853c8e196b6200d7$var$_propTypes2.default.object,
        overlay: $853c8e196b6200d7$var$_propTypes2.default.object
    }),
    className: $853c8e196b6200d7$var$_propTypes2.default.oneOfType([
        $853c8e196b6200d7$var$_propTypes2.default.string,
        $853c8e196b6200d7$var$_propTypes2.default.object
    ]),
    overlayClassName: $853c8e196b6200d7$var$_propTypes2.default.oneOfType([
        $853c8e196b6200d7$var$_propTypes2.default.string,
        $853c8e196b6200d7$var$_propTypes2.default.object
    ]),
    parentSelector: $853c8e196b6200d7$var$_propTypes2.default.func,
    bodyOpenClassName: $853c8e196b6200d7$var$_propTypes2.default.string,
    htmlOpenClassName: $853c8e196b6200d7$var$_propTypes2.default.string,
    ariaHideApp: $853c8e196b6200d7$var$_propTypes2.default.bool,
    appElement: $853c8e196b6200d7$var$_propTypes2.default.oneOfType([
        $853c8e196b6200d7$var$_propTypes2.default.instanceOf($853c8e196b6200d7$var$_safeHTMLElement2.default),
        $853c8e196b6200d7$var$_propTypes2.default.instanceOf($gHLoi.SafeHTMLCollection),
        $853c8e196b6200d7$var$_propTypes2.default.instanceOf($gHLoi.SafeNodeList),
        $853c8e196b6200d7$var$_propTypes2.default.arrayOf($853c8e196b6200d7$var$_propTypes2.default.instanceOf($853c8e196b6200d7$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $853c8e196b6200d7$var$_propTypes2.default.func,
    onAfterClose: $853c8e196b6200d7$var$_propTypes2.default.func,
    onRequestClose: $853c8e196b6200d7$var$_propTypes2.default.func,
    closeTimeoutMS: $853c8e196b6200d7$var$_propTypes2.default.number,
    shouldFocusAfterRender: $853c8e196b6200d7$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $853c8e196b6200d7$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $853c8e196b6200d7$var$_propTypes2.default.bool,
    preventScroll: $853c8e196b6200d7$var$_propTypes2.default.bool,
    role: $853c8e196b6200d7$var$_propTypes2.default.string,
    contentLabel: $853c8e196b6200d7$var$_propTypes2.default.string,
    aria: $853c8e196b6200d7$var$_propTypes2.default.object,
    data: $853c8e196b6200d7$var$_propTypes2.default.object,
    children: $853c8e196b6200d7$var$_propTypes2.default.node,
    shouldCloseOnEsc: $853c8e196b6200d7$var$_propTypes2.default.bool,
    overlayRef: $853c8e196b6200d7$var$_propTypes2.default.func,
    contentRef: $853c8e196b6200d7$var$_propTypes2.default.func,
    id: $853c8e196b6200d7$var$_propTypes2.default.string,
    overlayElement: $853c8e196b6200d7$var$_propTypes2.default.func,
    contentElement: $853c8e196b6200d7$var$_propTypes2.default.func,
    testId: $853c8e196b6200d7$var$_propTypes2.default.string
};
module.exports.default = $853c8e196b6200d7$var$ModalPortal;
module.exports = module.exports["default"];

});
parcelRegister("6nu5B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $4a4c3b2f05aea188$var$resetState;
module.exports.log = $4a4c3b2f05aea188$var$log;
module.exports.handleBlur = $4a4c3b2f05aea188$var$handleBlur;
module.exports.handleFocus = $4a4c3b2f05aea188$var$handleFocus;
module.exports.markForFocusLater = $4a4c3b2f05aea188$var$markForFocusLater;
module.exports.returnFocus = $4a4c3b2f05aea188$var$returnFocus;
module.exports.popWithoutFocus = $4a4c3b2f05aea188$var$popWithoutFocus;
module.exports.setupScopedFocus = $4a4c3b2f05aea188$var$setupScopedFocus;
module.exports.teardownScopedFocus = $4a4c3b2f05aea188$var$teardownScopedFocus;

var $iRreP = parcelRequire("iRreP");
var $4a4c3b2f05aea188$var$_tabbable2 = $4a4c3b2f05aea188$var$_interopRequireDefault($iRreP);
function $4a4c3b2f05aea188$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4a4c3b2f05aea188$var$focusLaterElements = [];
var $4a4c3b2f05aea188$var$modalElement = null;
var $4a4c3b2f05aea188$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $4a4c3b2f05aea188$var$resetState() {
    $4a4c3b2f05aea188$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $4a4c3b2f05aea188$var$log() {}
/* eslint-enable no-console */ function $4a4c3b2f05aea188$var$handleBlur() {
    $4a4c3b2f05aea188$var$needToFocus = true;
}
function $4a4c3b2f05aea188$var$handleFocus() {
    if ($4a4c3b2f05aea188$var$needToFocus) {
        $4a4c3b2f05aea188$var$needToFocus = false;
        if (!$4a4c3b2f05aea188$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($4a4c3b2f05aea188$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $4a4c3b2f05aea188$var$_tabbable2.default)($4a4c3b2f05aea188$var$modalElement)[0] || $4a4c3b2f05aea188$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $4a4c3b2f05aea188$var$markForFocusLater() {
    $4a4c3b2f05aea188$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $4a4c3b2f05aea188$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($4a4c3b2f05aea188$var$focusLaterElements.length !== 0) {
            toFocus = $4a4c3b2f05aea188$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $4a4c3b2f05aea188$var$popWithoutFocus() {
    $4a4c3b2f05aea188$var$focusLaterElements.length > 0 && $4a4c3b2f05aea188$var$focusLaterElements.pop();
}
function $4a4c3b2f05aea188$var$setupScopedFocus(element) {
    $4a4c3b2f05aea188$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $4a4c3b2f05aea188$var$handleBlur, false);
        document.addEventListener("focus", $4a4c3b2f05aea188$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $4a4c3b2f05aea188$var$handleBlur);
        document.attachEvent("onFocus", $4a4c3b2f05aea188$var$handleFocus);
    }
}
function $4a4c3b2f05aea188$var$teardownScopedFocus() {
    $4a4c3b2f05aea188$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $4a4c3b2f05aea188$var$handleBlur);
        document.removeEventListener("focus", $4a4c3b2f05aea188$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $4a4c3b2f05aea188$var$handleBlur);
        document.detachEvent("onFocus", $4a4c3b2f05aea188$var$handleFocus);
    }
}

});
parcelRegister("iRreP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dbb24e2c8fdaedca$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $dbb24e2c8fdaedca$var$DISPLAY_NONE = "none";
var $dbb24e2c8fdaedca$var$DISPLAY_CONTENTS = "contents";
// match the whole word to prevent fuzzy searching
var $dbb24e2c8fdaedca$var$tabbableNode = /^(input|select|textarea|button|object|iframe)$/;
function $dbb24e2c8fdaedca$var$isNotOverflowing(element, style) {
    return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0;
}
function $dbb24e2c8fdaedca$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        var displayValue = style.getPropertyValue("display");
        return zeroSize ? displayValue !== $dbb24e2c8fdaedca$var$DISPLAY_CONTENTS && $dbb24e2c8fdaedca$var$isNotOverflowing(element, style) : displayValue === $dbb24e2c8fdaedca$var$DISPLAY_NONE;
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $dbb24e2c8fdaedca$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($dbb24e2c8fdaedca$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $dbb24e2c8fdaedca$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $dbb24e2c8fdaedca$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $dbb24e2c8fdaedca$var$visible(element);
}
function $dbb24e2c8fdaedca$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $dbb24e2c8fdaedca$var$focusable(element, !isTabIndexNaN);
}
function $dbb24e2c8fdaedca$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $dbb24e2c8fdaedca$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($dbb24e2c8fdaedca$var$tabbable);
}
module.exports = module.exports["default"];

});


parcelRegister("bUn0I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8ab6c60fe3353573$var$scopeTab;

var $iRreP = parcelRequire("iRreP");
var $8ab6c60fe3353573$var$_tabbable2 = $8ab6c60fe3353573$var$_interopRequireDefault($iRreP);
function $8ab6c60fe3353573$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8ab6c60fe3353573$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $8ab6c60fe3353573$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $8ab6c60fe3353573$var$scopeTab(node, event) {
    var tabbable = (0, $8ab6c60fe3353573$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $8ab6c60fe3353573$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
module.exports = module.exports["default"];

});

parcelRegister("gKo3c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $c3139925b7b56b46$var$resetState;
module.exports.log = $c3139925b7b56b46$var$log;
module.exports.assertNodeList = $c3139925b7b56b46$var$assertNodeList;
module.exports.setElement = $c3139925b7b56b46$var$setElement;
module.exports.validateElement = $c3139925b7b56b46$var$validateElement;
module.exports.hide = $c3139925b7b56b46$var$hide;
module.exports.show = $c3139925b7b56b46$var$show;
module.exports.documentNotReadyOrSSRTesting = $c3139925b7b56b46$var$documentNotReadyOrSSRTesting;

var $kg9aN = parcelRequire("kg9aN");
var $c3139925b7b56b46$var$_warning2 = $c3139925b7b56b46$var$_interopRequireDefault($kg9aN);

var $gHLoi = parcelRequire("gHLoi");
function $c3139925b7b56b46$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c3139925b7b56b46$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $c3139925b7b56b46$var$resetState() {
    if ($c3139925b7b56b46$var$globalElement) {
        if ($c3139925b7b56b46$var$globalElement.removeAttribute) $c3139925b7b56b46$var$globalElement.removeAttribute("aria-hidden");
        else if ($c3139925b7b56b46$var$globalElement.length != null) $c3139925b7b56b46$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($c3139925b7b56b46$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $c3139925b7b56b46$var$globalElement = null;
}
/* istanbul ignore next */ function $c3139925b7b56b46$var$log() {
    var check;
}
/* eslint-enable no-console */ function $c3139925b7b56b46$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $c3139925b7b56b46$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $gHLoi.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $c3139925b7b56b46$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $c3139925b7b56b46$var$globalElement = useElement || $c3139925b7b56b46$var$globalElement;
    return $c3139925b7b56b46$var$globalElement;
}
function $c3139925b7b56b46$var$validateElement(appElement) {
    var el = appElement || $c3139925b7b56b46$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $c3139925b7b56b46$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $c3139925b7b56b46$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $c3139925b7b56b46$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $c3139925b7b56b46$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $c3139925b7b56b46$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $c3139925b7b56b46$var$documentNotReadyOrSSRTesting() {
    $c3139925b7b56b46$var$globalElement = null;
}

});
parcelRegister("kg9aN", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $ebfc6adce9fdacf8$var$warning;

});

parcelRegister("gHLoi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canUseDOM = module.exports.SafeNodeList = module.exports.SafeHTMLCollection = undefined;

var $djCxr = parcelRequire("djCxr");
var $c2956c5113267bbb$var$_exenv2 = $c2956c5113267bbb$var$_interopRequireDefault($djCxr);
function $c2956c5113267bbb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c2956c5113267bbb$var$EE = $c2956c5113267bbb$var$_exenv2.default;
var $c2956c5113267bbb$var$SafeHTMLElement = $c2956c5113267bbb$var$EE.canUseDOM ? window.HTMLElement : {};
var $c2956c5113267bbb$var$SafeHTMLCollection = module.exports.SafeHTMLCollection = $c2956c5113267bbb$var$EE.canUseDOM ? window.HTMLCollection : {};
var $c2956c5113267bbb$var$SafeNodeList = module.exports.SafeNodeList = $c2956c5113267bbb$var$EE.canUseDOM ? window.NodeList : {};
var $c2956c5113267bbb$var$canUseDOM = module.exports.canUseDOM = $c2956c5113267bbb$var$EE.canUseDOM;
module.exports.default = $c2956c5113267bbb$var$SafeHTMLElement;

});
parcelRegister("djCxr", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});



parcelRegister("kYIf9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $f45bbb0d96c30d54$var$resetState;
module.exports.log = $f45bbb0d96c30d54$var$log;
var $f45bbb0d96c30d54$var$htmlClassList = {};
var $f45bbb0d96c30d54$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $f45bbb0d96c30d54$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $f45bbb0d96c30d54$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $f45bbb0d96c30d54$var$htmlClassList)$f45bbb0d96c30d54$var$removeClass(htmlElement, $f45bbb0d96c30d54$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $f45bbb0d96c30d54$var$docBodyClassList)$f45bbb0d96c30d54$var$removeClass(body, $f45bbb0d96c30d54$var$docBodyClassList[_cls]);
    $f45bbb0d96c30d54$var$htmlClassList = {};
    $f45bbb0d96c30d54$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $f45bbb0d96c30d54$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $f45bbb0d96c30d54$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $f45bbb0d96c30d54$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $f45bbb0d96c30d54$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $f45bbb0d96c30d54$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $f45bbb0d96c30d54$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $f45bbb0d96c30d54$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $f45bbb0d96c30d54$var$add = module.exports.add = function add(element, classString) {
    return $f45bbb0d96c30d54$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $f45bbb0d96c30d54$var$htmlClassList : $f45bbb0d96c30d54$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $f45bbb0d96c30d54$var$remove = module.exports.remove = function remove(element, classString) {
    return $f45bbb0d96c30d54$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $f45bbb0d96c30d54$var$htmlClassList : $f45bbb0d96c30d54$var$docBodyClassList, classString.split(" "));
};

});

parcelRegister("kczmP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.log = $eb505cd0fca5b004$var$log;
module.exports.resetState = $eb505cd0fca5b004$var$resetState;
function $eb505cd0fca5b004$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $eb505cd0fca5b004$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $eb505cd0fca5b004$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $eb505cd0fca5b004$var$portalOpenInstances = new $eb505cd0fca5b004$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $eb505cd0fca5b004$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($eb505cd0fca5b004$var$portalOpenInstances.openInstances.length);
    $eb505cd0fca5b004$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $eb505cd0fca5b004$var$resetState() {
    $eb505cd0fca5b004$var$portalOpenInstances = new $eb505cd0fca5b004$var$PortalOpenInstances();
}
/* eslint-enable no-console */ module.exports.default = $eb505cd0fca5b004$var$portalOpenInstances;

});

parcelRegister("fmy2t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $b2f35082d0ec1256$var$resetState;
module.exports.log = $b2f35082d0ec1256$var$log;

var $kczmP = parcelRequire("kczmP");
var $b2f35082d0ec1256$var$_portalOpenInstances2 = $b2f35082d0ec1256$var$_interopRequireDefault($kczmP);
function $b2f35082d0ec1256$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $b2f35082d0ec1256$var$before = void 0, $b2f35082d0ec1256$var$after = void 0, $b2f35082d0ec1256$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $b2f35082d0ec1256$var$resetState() {
    var _arr = [
        $b2f35082d0ec1256$var$before,
        $b2f35082d0ec1256$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $b2f35082d0ec1256$var$before = $b2f35082d0ec1256$var$after = null;
    $b2f35082d0ec1256$var$instances = [];
}
/* istanbul ignore next */ function $b2f35082d0ec1256$var$log() {
    console.log("bodyTrap ----------");
    console.log($b2f35082d0ec1256$var$instances.length);
    var _arr2 = [
        $b2f35082d0ec1256$var$before,
        $b2f35082d0ec1256$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $b2f35082d0ec1256$var$focusContent() {
    if ($b2f35082d0ec1256$var$instances.length === 0) return;
    $b2f35082d0ec1256$var$instances[$b2f35082d0ec1256$var$instances.length - 1].focusContent();
}
function $b2f35082d0ec1256$var$bodyTrap(eventType, openInstances) {
    if (!$b2f35082d0ec1256$var$before && !$b2f35082d0ec1256$var$after) {
        $b2f35082d0ec1256$var$before = document.createElement("div");
        $b2f35082d0ec1256$var$before.setAttribute("data-react-modal-body-trap", "");
        $b2f35082d0ec1256$var$before.style.position = "absolute";
        $b2f35082d0ec1256$var$before.style.opacity = "0";
        $b2f35082d0ec1256$var$before.setAttribute("tabindex", "0");
        $b2f35082d0ec1256$var$before.addEventListener("focus", $b2f35082d0ec1256$var$focusContent);
        $b2f35082d0ec1256$var$after = $b2f35082d0ec1256$var$before.cloneNode();
        $b2f35082d0ec1256$var$after.addEventListener("focus", $b2f35082d0ec1256$var$focusContent);
    }
    $b2f35082d0ec1256$var$instances = openInstances;
    if ($b2f35082d0ec1256$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $b2f35082d0ec1256$var$before) document.body.insertBefore($b2f35082d0ec1256$var$before, document.body.firstChild);
        if (document.body.lastChild !== $b2f35082d0ec1256$var$after) document.body.appendChild($b2f35082d0ec1256$var$after);
    } else {
        // Remove focus trap
        if ($b2f35082d0ec1256$var$before.parentElement) $b2f35082d0ec1256$var$before.parentElement.removeChild($b2f35082d0ec1256$var$before);
        if ($b2f35082d0ec1256$var$after.parentElement) $b2f35082d0ec1256$var$after.parentElement.removeChild($b2f35082d0ec1256$var$after);
    }
}
$b2f35082d0ec1256$var$_portalOpenInstances2.default.subscribe($b2f35082d0ec1256$var$bodyTrap);

});


parcelRegister("hdX8Q", function(module, exports) {

$parcel$export(module.exports, "polyfill", () => $c8a186e1757974bb$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRegister("dHBXt", function(module, exports) {

module.exports = (parcelRequire("c2cFF"));

});
parcelRegister("c2cFF", function(module, exports) {
"use strict";
function $8c2f801fb933983e$var$_interopDefault(e) {
    return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

var $8c2f801fb933983e$var$React = $8c2f801fb933983e$var$_interopDefault((parcelRequire("acw62")));

var $1u0KT = parcelRequire("1u0KT");
function $8c2f801fb933983e$var$_defaults2(e, t) {
    for(var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++){
        var i = n[a], r = Object.getOwnPropertyDescriptor(t, i);
        r && r.configurable && e[i] === undefined && Object.defineProperty(e, i, r);
    }
    return e;
}
function $8c2f801fb933983e$var$_extends() {
    return ($8c2f801fb933983e$var$_extends = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var a in n)Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
        }
        return e;
    }).apply(this, arguments);
}
function $8c2f801fb933983e$var$_inheritsLoose(e, t) {
    e.prototype = Object.create(t.prototype), $8c2f801fb933983e$var$_defaults2(e.prototype.constructor = e, t);
}
function $8c2f801fb933983e$var$_objectWithoutPropertiesLoose(e, t) {
    if (null == e) return {};
    var n, a, i = {}, r = Object.keys(e);
    for(a = 0; a < r.length; a++)n = r[a], 0 <= t.indexOf(n) || (i[n] = e[n]);
    return i;
}
function $8c2f801fb933983e$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
var $8c2f801fb933983e$var$invariant = function(e, t, n, a, i, r, o, s) {
    if (!e) {
        var l;
        if (t === undefined) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var u = [
                n,
                a,
                i,
                r,
                o,
                s
            ], c = 0;
            (l = new Error(t.replace(/%s/g, function() {
                return u[c++];
            }))).name = "Invariant Violation";
        }
        throw l.framesToPop = 1, l;
    }
}, $8c2f801fb933983e$var$invariant_1 = $8c2f801fb933983e$var$invariant;
function $8c2f801fb933983e$var$setInputSelection(e, t, n) {
    if ("selectionStart" in e && "selectionEnd" in e) e.selectionStart = t, e.selectionEnd = n;
    else {
        var a = e.createTextRange();
        a.collapse(!0), a.moveStart("character", t), a.moveEnd("character", n - t), a.select();
    }
}
function $8c2f801fb933983e$var$getInputSelection(e) {
    var t = 0, n = 0;
    if ("selectionStart" in e && "selectionEnd" in e) t = e.selectionStart, n = e.selectionEnd;
    else {
        var a = document.selection.createRange();
        a.parentElement() === e && (t = -a.moveStart("character", -e.value.length), n = -a.moveEnd("character", -e.value.length));
    }
    return {
        start: t,
        end: n,
        length: n - t
    };
}
var $8c2f801fb933983e$var$defaultFormatChars = {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]"
}, $8c2f801fb933983e$var$defaultMaskChar = "_";
function $8c2f801fb933983e$var$parseMask(e, t, n) {
    var a = "", i = "", r = null, o = [];
    if (t === undefined && (t = $8c2f801fb933983e$var$defaultMaskChar), null == n && (n = $8c2f801fb933983e$var$defaultFormatChars), !e || "string" != typeof e) return {
        maskChar: t,
        formatChars: n,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
    };
    var s = !1;
    return e.split("").forEach(function(e) {
        s = !s && "\\" === e || (s || !n[e] ? (o.push(a.length), a.length === o.length - 1 && (i += e)) : r = a.length + 1, a += e, !1);
    }), {
        maskChar: t,
        formatChars: n,
        prefix: i,
        mask: a,
        lastEditablePosition: r,
        permanents: o
    };
}
function $8c2f801fb933983e$var$isPermanentCharacter(e, t) {
    return -1 !== e.permanents.indexOf(t);
}
function $8c2f801fb933983e$var$isAllowedCharacter(e, t, n) {
    var a = e.mask, i = e.formatChars;
    if (!n) return !1;
    if ($8c2f801fb933983e$var$isPermanentCharacter(e, t)) return a[t] === n;
    var r = i[a[t]];
    return new RegExp(r).test(n);
}
function $8c2f801fb933983e$var$isEmpty(n, e) {
    return e.split("").every(function(e, t) {
        return $8c2f801fb933983e$var$isPermanentCharacter(n, t) || !$8c2f801fb933983e$var$isAllowedCharacter(n, t, e);
    });
}
function $8c2f801fb933983e$var$getFilledLength(e, t) {
    var n = e.maskChar, a = e.prefix;
    if (!n) {
        for(; t.length > a.length && $8c2f801fb933983e$var$isPermanentCharacter(e, t.length - 1);)t = t.slice(0, t.length - 1);
        return t.length;
    }
    for(var i = a.length, r = t.length; r >= a.length; r--){
        var o = t[r];
        if (!$8c2f801fb933983e$var$isPermanentCharacter(e, r) && $8c2f801fb933983e$var$isAllowedCharacter(e, r, o)) {
            i = r + 1;
            break;
        }
    }
    return i;
}
function $8c2f801fb933983e$var$isFilled(e, t) {
    return $8c2f801fb933983e$var$getFilledLength(e, t) === e.mask.length;
}
function $8c2f801fb933983e$var$formatValue(e, t) {
    var n = e.maskChar, a = e.mask, i = e.prefix;
    if (!n) {
        for((t = $8c2f801fb933983e$var$insertString(e, "", t, 0)).length < i.length && (t = i); t.length < a.length && $8c2f801fb933983e$var$isPermanentCharacter(e, t.length);)t += a[t.length];
        return t;
    }
    if (t) return $8c2f801fb933983e$var$insertString(e, $8c2f801fb933983e$var$formatValue(e, ""), t, 0);
    for(var r = 0; r < a.length; r++)$8c2f801fb933983e$var$isPermanentCharacter(e, r) ? t += a[r] : t += n;
    return t;
}
function $8c2f801fb933983e$var$clearRange(n, e, a, t) {
    var i = a + t, r = n.maskChar, o = n.mask, s = n.prefix, l = e.split("");
    if (r) return l.map(function(e, t) {
        return t < a || i <= t ? e : $8c2f801fb933983e$var$isPermanentCharacter(n, t) ? o[t] : r;
    }).join("");
    for(var u = i; u < l.length; u++)$8c2f801fb933983e$var$isPermanentCharacter(n, u) && (l[u] = "");
    return a = Math.max(s.length, a), l.splice(a, i - a), e = l.join(""), $8c2f801fb933983e$var$formatValue(n, e);
}
function $8c2f801fb933983e$var$insertString(r, o, e, s) {
    var l = r.mask, u = r.maskChar, c = r.prefix, t = e.split(""), h = $8c2f801fb933983e$var$isFilled(r, o);
    return !u && s > o.length && (o += l.slice(o.length, s)), t.every(function(e) {
        for(; i = e, $8c2f801fb933983e$var$isPermanentCharacter(r, a = s) && i !== l[a];){
            if (s >= o.length && (o += l[s]), t = e, n = s, u && $8c2f801fb933983e$var$isPermanentCharacter(r, n) && t === u) return !0;
            if (++s >= l.length) return !1;
        }
        var t, n, a, i;
        return !$8c2f801fb933983e$var$isAllowedCharacter(r, s, e) && e !== u || (s < o.length ? o = u || h || s < c.length ? o.slice(0, s) + e + o.slice(s + 1) : (o = o.slice(0, s) + e + o.slice(s), $8c2f801fb933983e$var$formatValue(r, o)) : u || (o += e), ++s < l.length);
    }), o;
}
function $8c2f801fb933983e$var$getInsertStringLength(a, e, t, i) {
    var r = a.mask, o = a.maskChar, n = t.split(""), s = i;
    return n.every(function(e) {
        for(; n = e, $8c2f801fb933983e$var$isPermanentCharacter(a, t = i) && n !== r[t];)if (++i >= r.length) return !1;
        var t, n;
        return ($8c2f801fb933983e$var$isAllowedCharacter(a, i, e) || e === o) && i++, i < r.length;
    }), i - s;
}
function $8c2f801fb933983e$var$getLeftEditablePosition(e, t) {
    for(var n = t; 0 <= n; --n)if (!$8c2f801fb933983e$var$isPermanentCharacter(e, n)) return n;
    return null;
}
function $8c2f801fb933983e$var$getRightEditablePosition(e, t) {
    for(var n = e.mask, a = t; a < n.length; ++a)if (!$8c2f801fb933983e$var$isPermanentCharacter(e, a)) return a;
    return null;
}
function $8c2f801fb933983e$var$getStringValue(e) {
    return e || 0 === e ? e + "" : "";
}
function $8c2f801fb933983e$var$processChange(e, t, n, a, i) {
    var r = e.mask, o = e.prefix, s = e.lastEditablePosition, l = t, u = "", c = 0, h = 0, f = Math.min(i.start, n.start);
    if (n.end > i.start ? h = (c = $8c2f801fb933983e$var$getInsertStringLength(e, a, u = l.slice(i.start, n.end), f)) ? i.length : 0 : l.length < a.length && (h = a.length - l.length), l = a, h) {
        if (1 === h && !i.length) f = i.start === n.start ? $8c2f801fb933983e$var$getRightEditablePosition(e, n.start) : $8c2f801fb933983e$var$getLeftEditablePosition(e, n.start);
        l = $8c2f801fb933983e$var$clearRange(e, l, f, h);
    }
    return l = $8c2f801fb933983e$var$insertString(e, l, u, f), (f += c) >= r.length ? f = r.length : f < o.length && !c ? f = o.length : f >= o.length && f < s && c && (f = $8c2f801fb933983e$var$getRightEditablePosition(e, f)), u || (u = null), {
        value: l = $8c2f801fb933983e$var$formatValue(e, l),
        enteredString: u,
        selection: {
            start: f,
            end: f
        }
    };
}
function $8c2f801fb933983e$var$isWindowsPhoneBrowser() {
    var e = new RegExp("windows", "i"), t = new RegExp("phone", "i"), n = navigator.userAgent;
    return e.test(n) && t.test(n);
}
function $8c2f801fb933983e$var$isFunction(e) {
    return "function" == typeof e;
}
function $8c2f801fb933983e$var$getRequestAnimationFrame() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
}
function $8c2f801fb933983e$var$getCancelAnimationFrame() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
}
function $8c2f801fb933983e$var$defer(e) {
    return (!!$8c2f801fb933983e$var$getCancelAnimationFrame() ? $8c2f801fb933983e$var$getRequestAnimationFrame() : function() {
        return setTimeout(e, 1e3 / 60);
    })(e);
}
function $8c2f801fb933983e$var$cancelDefer(e) {
    ($8c2f801fb933983e$var$getCancelAnimationFrame() || clearTimeout)(e);
}
var $8c2f801fb933983e$var$InputElement = function(c) {
    function e(e) {
        var f = c.call(this, e) || this;
        f.focused = !1, f.mounted = !1, f.previousSelection = null, f.selectionDeferId = null, f.saveSelectionLoopDeferId = null, f.saveSelectionLoop = function() {
            f.previousSelection = f.getSelection(), f.saveSelectionLoopDeferId = $8c2f801fb933983e$var$defer(f.saveSelectionLoop);
        }, f.runSaveSelectionLoop = function() {
            null === f.saveSelectionLoopDeferId && f.saveSelectionLoop();
        }, f.stopSaveSelectionLoop = function() {
            null !== f.saveSelectionLoopDeferId && ($8c2f801fb933983e$var$cancelDefer(f.saveSelectionLoopDeferId), f.saveSelectionLoopDeferId = null, f.previousSelection = null);
        }, f.getInputDOMNode = function() {
            if (!f.mounted) return null;
            var e = $1u0KT.findDOMNode($8c2f801fb933983e$var$_assertThisInitialized($8c2f801fb933983e$var$_assertThisInitialized(f))), t = "undefined" != typeof window && e instanceof window.Element;
            if (e && !t) return null;
            if ("INPUT" !== e.nodeName && (e = e.querySelector("input")), !e) throw new Error("react-input-mask: inputComponent doesn't contain input node");
            return e;
        }, f.getInputValue = function() {
            var e = f.getInputDOMNode();
            return e ? e.value : null;
        }, f.setInputValue = function(e) {
            var t = f.getInputDOMNode();
            t && (f.value = e, t.value = e);
        }, f.setCursorToEnd = function() {
            var e = $8c2f801fb933983e$var$getFilledLength(f.maskOptions, f.value), t = $8c2f801fb933983e$var$getRightEditablePosition(f.maskOptions, e);
            null !== t && f.setCursorPosition(t);
        }, f.setSelection = function(e, t, n) {
            void 0 === n && (n = {});
            var a = f.getInputDOMNode(), i = f.isFocused();
            a && i && (n.deferred || $8c2f801fb933983e$var$setInputSelection(a, e, t), null !== f.selectionDeferId && $8c2f801fb933983e$var$cancelDefer(f.selectionDeferId), f.selectionDeferId = $8c2f801fb933983e$var$defer(function() {
                f.selectionDeferId = null, $8c2f801fb933983e$var$setInputSelection(a, e, t);
            }), f.previousSelection = {
                start: e,
                end: t,
                length: Math.abs(t - e)
            });
        }, f.getSelection = function() {
            return $8c2f801fb933983e$var$getInputSelection(f.getInputDOMNode());
        }, f.getCursorPosition = function() {
            return f.getSelection().start;
        }, f.setCursorPosition = function(e) {
            f.setSelection(e, e);
        }, f.isFocused = function() {
            return f.focused;
        }, f.getBeforeMaskedValueChangeConfig = function() {
            var e = f.maskOptions, t = e.mask, n = e.maskChar, a = e.permanents, i = e.formatChars;
            return {
                mask: t,
                maskChar: n,
                permanents: a,
                alwaysShowMask: !!f.props.alwaysShowMask,
                formatChars: i
            };
        }, f.isInputAutofilled = function(e, t, n, a) {
            var i = f.getInputDOMNode();
            try {
                if (i.matches(":-webkit-autofill")) return !0;
            } catch (r) {}
            return !f.focused || a.end < n.length && t.end === e.length;
        }, f.onChange = function(e) {
            var t = $8c2f801fb933983e$var$_assertThisInitialized($8c2f801fb933983e$var$_assertThisInitialized(f)).beforePasteState, n = $8c2f801fb933983e$var$_assertThisInitialized($8c2f801fb933983e$var$_assertThisInitialized(f)).previousSelection, a = f.props.beforeMaskedValueChange, i = f.getInputValue(), r = f.value, o = f.getSelection();
            f.isInputAutofilled(i, o, r, n) && (r = $8c2f801fb933983e$var$formatValue(f.maskOptions, ""), n = {
                start: 0,
                end: 0,
                length: 0
            }), t && (n = t.selection, r = t.value, o = {
                start: n.start + i.length,
                end: n.start + i.length,
                length: 0
            }, i = r.slice(0, n.start) + i + r.slice(n.end), f.beforePasteState = null);
            var s = $8c2f801fb933983e$var$processChange(f.maskOptions, i, o, r, n), l = s.enteredString, u = s.selection, c = s.value;
            if ($8c2f801fb933983e$var$isFunction(a)) {
                var h = a({
                    value: c,
                    selection: u
                }, {
                    value: r,
                    selection: n
                }, l, f.getBeforeMaskedValueChangeConfig());
                c = h.value, u = h.selection;
            }
            f.setInputValue(c), $8c2f801fb933983e$var$isFunction(f.props.onChange) && f.props.onChange(e), f.isWindowsPhoneBrowser ? f.setSelection(u.start, u.end, {
                deferred: !0
            }) : f.setSelection(u.start, u.end);
        }, f.onFocus = function(e) {
            var t = f.props.beforeMaskedValueChange, n = f.maskOptions, a = n.mask, i = n.prefix;
            if (f.focused = !0, f.mounted = !0, a) {
                if (f.value) $8c2f801fb933983e$var$getFilledLength(f.maskOptions, f.value) < f.maskOptions.mask.length && f.setCursorToEnd();
                else {
                    var r = $8c2f801fb933983e$var$formatValue(f.maskOptions, i), o = $8c2f801fb933983e$var$formatValue(f.maskOptions, r), s = $8c2f801fb933983e$var$getFilledLength(f.maskOptions, o), l = $8c2f801fb933983e$var$getRightEditablePosition(f.maskOptions, s), u = {
                        start: l,
                        end: l
                    };
                    if ($8c2f801fb933983e$var$isFunction(t)) {
                        var c = t({
                            value: o,
                            selection: u
                        }, {
                            value: f.value,
                            selection: null
                        }, null, f.getBeforeMaskedValueChangeConfig());
                        o = c.value, u = c.selection;
                    }
                    var h = o !== f.getInputValue();
                    h && f.setInputValue(o), h && $8c2f801fb933983e$var$isFunction(f.props.onChange) && f.props.onChange(e), f.setSelection(u.start, u.end);
                }
                f.runSaveSelectionLoop();
            }
            $8c2f801fb933983e$var$isFunction(f.props.onFocus) && f.props.onFocus(e);
        }, f.onBlur = function(e) {
            var t = f.props.beforeMaskedValueChange, n = f.maskOptions.mask;
            if (f.stopSaveSelectionLoop(), f.focused = !1, n && !f.props.alwaysShowMask && $8c2f801fb933983e$var$isEmpty(f.maskOptions, f.value)) {
                var a = "";
                if ($8c2f801fb933983e$var$isFunction(t)) a = t({
                    value: a,
                    selection: null
                }, {
                    value: f.value,
                    selection: f.previousSelection
                }, null, f.getBeforeMaskedValueChangeConfig()).value;
                var i = a !== f.getInputValue();
                i && f.setInputValue(a), i && $8c2f801fb933983e$var$isFunction(f.props.onChange) && f.props.onChange(e);
            }
            $8c2f801fb933983e$var$isFunction(f.props.onBlur) && f.props.onBlur(e);
        }, f.onMouseDown = function(e) {
            if (!f.focused && document.addEventListener) {
                f.mouseDownX = e.clientX, f.mouseDownY = e.clientY, f.mouseDownTime = (new Date).getTime();
                var r = function r(e) {
                    if (document.removeEventListener("mouseup", r), f.focused) {
                        var t = Math.abs(e.clientX - f.mouseDownX), n = Math.abs(e.clientY - f.mouseDownY), a = Math.max(t, n), i = (new Date).getTime() - f.mouseDownTime;
                        (a <= 10 && i <= 200 || a <= 5 && i <= 300) && f.setCursorToEnd();
                    }
                };
                document.addEventListener("mouseup", r);
            }
            $8c2f801fb933983e$var$isFunction(f.props.onMouseDown) && f.props.onMouseDown(e);
        }, f.onPaste = function(e) {
            $8c2f801fb933983e$var$isFunction(f.props.onPaste) && f.props.onPaste(e), e.defaultPrevented || (f.beforePasteState = {
                value: f.getInputValue(),
                selection: f.getSelection()
            }, f.setInputValue(""));
        }, f.handleRef = function(e) {
            null == f.props.children && $8c2f801fb933983e$var$isFunction(f.props.inputRef) && f.props.inputRef(e);
        };
        var t = e.mask, n = e.maskChar, a = e.formatChars, i = e.alwaysShowMask, r = e.beforeMaskedValueChange, o = e.defaultValue, s = e.value;
        f.maskOptions = $8c2f801fb933983e$var$parseMask(t, n, a), null == o && (o = ""), null == s && (s = o);
        var l = $8c2f801fb933983e$var$getStringValue(s);
        if (f.maskOptions.mask && (i || l) && (l = $8c2f801fb933983e$var$formatValue(f.maskOptions, l), $8c2f801fb933983e$var$isFunction(r))) {
            var u = e.value;
            null == e.value && (u = o), l = r({
                value: l,
                selection: null
            }, {
                value: u = $8c2f801fb933983e$var$getStringValue(u),
                selection: null
            }, null, f.getBeforeMaskedValueChangeConfig()).value;
        }
        return f.value = l, f;
    }
    $8c2f801fb933983e$var$_inheritsLoose(e, c);
    var t = e.prototype;
    return t.componentDidMount = function() {
        this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = $8c2f801fb933983e$var$isWindowsPhoneBrowser(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, t.componentDidUpdate = function() {
        var e = this.previousSelection, t = this.props, n = t.beforeMaskedValueChange, a = t.alwaysShowMask, i = t.mask, r = t.maskChar, o = t.formatChars, s = this.maskOptions, l = a || this.isFocused(), u = null != this.props.value, c = u ? $8c2f801fb933983e$var$getStringValue(this.props.value) : this.value, h = e ? e.start : null;
        if (this.maskOptions = $8c2f801fb933983e$var$parseMask(i, r, o), this.maskOptions.mask) {
            !s.mask && this.isFocused() && this.runSaveSelectionLoop();
            var f = this.maskOptions.mask && this.maskOptions.mask !== s.mask;
            if (s.mask || u || (c = this.getInputValue()), (f || this.maskOptions.mask && (c || l)) && (c = $8c2f801fb933983e$var$formatValue(this.maskOptions, c)), f) {
                var p = $8c2f801fb933983e$var$getFilledLength(this.maskOptions, c);
                (null === h || p < h) && (h = $8c2f801fb933983e$var$isFilled(this.maskOptions, c) ? p : $8c2f801fb933983e$var$getRightEditablePosition(this.maskOptions, p));
            }
            !this.maskOptions.mask || !$8c2f801fb933983e$var$isEmpty(this.maskOptions, c) || l || u && this.props.value || (c = "");
            var d = {
                start: h,
                end: h
            };
            if ($8c2f801fb933983e$var$isFunction(n)) {
                var m = n({
                    value: c,
                    selection: d
                }, {
                    value: this.value,
                    selection: this.previousSelection
                }, null, this.getBeforeMaskedValueChangeConfig());
                c = m.value, d = m.selection;
            }
            this.value = c;
            var g = this.getInputValue() !== this.value;
            g ? (this.setInputValue(this.value), this.forceUpdate()) : f && this.forceUpdate();
            var v = !1;
            null != d.start && null != d.end && (v = !e || e.start !== d.start || e.end !== d.end), (v || g) && this.setSelection(d.start, d.end);
        } else s.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
    }, t.componentWillUnmount = function() {
        this.mounted = !1, null !== this.selectionDeferId && $8c2f801fb933983e$var$cancelDefer(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, t.render = function() {
        var t, e = this.props, n = (e.mask, e.alwaysShowMask, e.maskChar, e.formatChars, e.inputRef, e.beforeMaskedValueChange, e.children), a = $8c2f801fb933983e$var$_objectWithoutPropertiesLoose(e, [
            "mask",
            "alwaysShowMask",
            "maskChar",
            "formatChars",
            "inputRef",
            "beforeMaskedValueChange",
            "children"
        ]);
        if (n) {
            $8c2f801fb933983e$var$isFunction(n) || $8c2f801fb933983e$var$invariant_1(!1);
            var i = [
                "onChange",
                "onPaste",
                "onMouseDown",
                "onFocus",
                "onBlur",
                "value",
                "disabled",
                "readOnly"
            ], r = $8c2f801fb933983e$var$_extends({}, a);
            i.forEach(function(e) {
                return delete r[e];
            }), t = n(r), i.filter(function(e) {
                return null != t.props[e] && t.props[e] !== a[e];
            }).length && $8c2f801fb933983e$var$invariant_1(!1);
        } else t = $8c2f801fb933983e$var$React.createElement("input", $8c2f801fb933983e$var$_extends({
            ref: this.handleRef
        }, a));
        var o = {
            onFocus: this.onFocus,
            onBlur: this.onBlur
        };
        return this.maskOptions.mask && (a.disabled || a.readOnly || (o.onChange = this.onChange, o.onPaste = this.onPaste, o.onMouseDown = this.onMouseDown), null != a.value && (o.value = this.value)), t = $8c2f801fb933983e$var$React.cloneElement(t, o);
    }, e;
}($8c2f801fb933983e$var$React.Component);
module.exports = $8c2f801fb933983e$var$InputElement;

});



parcelRegister("4dB0L", function(module, exports) {

$parcel$export(module.exports, "default", () => $312515fc7a4c2917$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $312515fc7a4c2917$var$Spinner = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$312515fc7a4c2917$var$Spinner.displayName = 'Spinner';
var $312515fc7a4c2917$export$2e2bcd8739ae039 = $312515fc7a4c2917$var$Spinner;

});
parcelRegister("8g1PZ", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("8rTrh", function(module, exports) {

$parcel$export(module.exports, "useBootstrapPrefix", () => $626bd95fa485b758$export$7f387860ebffb32c);
$parcel$export(module.exports, "useIsRTL", () => $626bd95fa485b758$export$35e511eefa30ac5a);

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $626bd95fa485b758$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $626bd95fa485b758$export$ff817e17bad2e091 = 'xs';
const $626bd95fa485b758$var$ThemeContext = /*#__PURE__*/ $acw62.createContext({
    prefixes: {},
    breakpoints: $626bd95fa485b758$export$666ad80b5007f835,
    minBreakpoint: $626bd95fa485b758$export$ff817e17bad2e091
});
const { Consumer: $626bd95fa485b758$export$b631efc24e9d5e2f, Provider: $626bd95fa485b758$var$Provider } = $626bd95fa485b758$var$ThemeContext;
function $626bd95fa485b758$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $626bd95fa485b758$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $626bd95fa485b758$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $acw62.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($626bd95fa485b758$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $626bd95fa485b758$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $626bd95fa485b758$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return breakpoints;
}
function $626bd95fa485b758$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return minBreakpoint;
}
function $626bd95fa485b758$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return dir === 'rtl';
}
function $626bd95fa485b758$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $acw62.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $626bd95fa485b758$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $626bd95fa485b758$export$2e2bcd8739ae039 = $626bd95fa485b758$var$ThemeProvider;

});


parcelRegister("3qYM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cef4f2d2ab25605$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");


var $9Ryut = parcelRequire("9Ryut");

var $iJxY6 = parcelRequire("iJxY6");
const $2cef4f2d2ab25605$var$StyledModal = ({ displayModal: displayModal, closeModalHandler: closeModalHandler, headerText: headerText, paragraphText1: paragraphText1, paragraphText2: paragraphText2 })=>{
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const button = {
        text: (0, $iJxY6.default)(locId, 'styleModalButton', null),
        onClick: closeModalHandler
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Dialog), {
        title: headerText,
        open: displayModal,
        buttons: [
            button
        ],
        onRequestClose: closeModalHandler,
        children: paragraphText1 && paragraphText2 && paragraphText1 !== '' && paragraphText2 !== '' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "modal-paragraph",
                    children: paragraphText1
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "modal-paragraph",
                    children: paragraphText2
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {})
    });
};
$2cef4f2d2ab25605$var$StyledModal.defaultProps = {
    paragraphText1: '',
    paragraphText2: ''
};
$2cef4f2d2ab25605$var$StyledModal.propTypes = {
    displayModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    closeModalHandler: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    headerText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    paragraphText1: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    paragraphText2: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $2cef4f2d2ab25605$export$2e2bcd8739ae039 = $2cef4f2d2ab25605$var$StyledModal;

});

parcelRegister("2DcdH", function(module, exports) {

$parcel$export(module.exports, "PreviousPathProvider", () => $b58212fb45b7bbcc$export$c6c4b9be16ad9af);
$parcel$export(module.exports, "usePreviousPath", () => $b58212fb45b7bbcc$export$36fec3d0c6eb636);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $b58212fb45b7bbcc$var$PreviousPathContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $b58212fb45b7bbcc$export$c6c4b9be16ad9af = ({ children: children })=>{
    const [previousPath, setPreviousPath] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b58212fb45b7bbcc$var$PreviousPathContext.Provider, {
        value: {
            previousPath: previousPath,
            setPreviousPath: setPreviousPath
        },
        children: children
    });
};
const $b58212fb45b7bbcc$export$36fec3d0c6eb636 = ()=>{
    const context = (0, $acw62.useContext)($b58212fb45b7bbcc$var$PreviousPathContext);
    if (!context) throw new Error('use previous path undefined');
    return context;
};

});

parcelRegister("RXYi2", function(module, exports) {

$parcel$export(module.exports, "DataLayerInfoProvider", () => $604c8c784370f66e$export$6228544df41d9a59);
$parcel$export(module.exports, "useDataLayerInfo", () => $604c8c784370f66e$export$e15dd02a0ebc14ff);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2DcdH = parcelRequire("2DcdH");
const $604c8c784370f66e$var$DataLayerContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $604c8c784370f66e$export$6228544df41d9a59 = ({ children: children })=>{
    const [dataLayerInfo, setDataLayerInfo] = (0, $acw62.useState)({
        'page_type': 'welcome-page',
        'locale': undefined,
        'environment': window.ENVIRONMENT,
        'sessionId': undefined,
        'fa_no': undefined,
        'fa_entity_id': undefined
    });
    const previousPath = (0, $2DcdH.usePreviousPath)().previousPath;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($604c8c784370f66e$var$DataLayerContext.Provider, {
        value: {
            dataLayerInfo: dataLayerInfo,
            setDataLayerInfo: setDataLayerInfo
        },
        children: children
    });
};
const $604c8c784370f66e$export$e15dd02a0ebc14ff = ()=>{
    const context = (0, $acw62.useContext)($604c8c784370f66e$var$DataLayerContext);
    if (!context) throw new Error('unsafe use of provider');
    return context;
};

});


parcelRegister("4KZVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8803f490f5dde294$export$2e2bcd8739ae039);
/* eslint-disable no-use-before-define */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");

var $4dB0L = parcelRequire("4dB0L");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $iJxY6 = parcelRequire("iJxY6");

var $9Ryut = parcelRequire("9Ryut");


var $fUEMe = parcelRequire("fUEMe");

var $7mmdw = parcelRequire("7mmdw");

var $kMrYv = parcelRequire("kMrYv");

var $2DcdH = parcelRequire("2DcdH");

var $RXYi2 = parcelRequire("RXYi2");
/**
 * FPWelcomePage is the introductory screen for the quiz
 */ const $8803f490f5dde294$var$FPWelcomePage = (props)=>{
    const { customizeBtnCallback: customizeBtnCallback, isLoading: isLoading } = props;
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const userPersona = (0, $acw62.useContext)((0, $7mmdw.default));
    const [isMobile, setIsMobile] = (0, $acw62.useState)(false);
    const [viewOrientation, setViewOrientation] = (0, $acw62.useState)(null);
    const maximumPhoneWidth = 767;
    const handleMobileView = ()=>{
        if (window.screen && window.screen.orientation) setViewOrientation(window.screen.orientation.type);
        setIsMobile(window.innerWidth < maximumPhoneWidth);
    };
    const { setPreviousPath: setPreviousPath, previousPath: previousPath } = (0, $2DcdH.usePreviousPath)();
    const currentLocation = (0, $aphAM.useLocation)();
    const pageTitle = (0, $iJxY6.default)(locId, 'pageTitle', 'fpWelcomePage');
    const pageReferrer = previousPath ? `${window.location.origin}${previousPath}${currentLocation.search}` : undefined;
    const pageURL = `${window.location.origin}${currentLocation.pathname}${currentLocation.search}`;
    const virtualPageInfo = {
        pagePath: currentLocation.pathname,
        pageTitle: pageTitle,
        page_referrer: pageReferrer,
        external_referrer: window.document.referrer && window.document.referrer.trim() !== '' ? window.document.referrer : undefined,
        page_url: pageURL
    };
    const { dataLayerInfo: dataLayerInfo } = (0, $RXYi2.useDataLayerInfo)();
    const updatesFPPlanningTopics = {
        ...dataLayerInfo,
        page_type: 'welcome-page'
    };
    (0, $acw62.useEffect)(()=>{
        document.title = pageTitle;
        handleMobileView();
        window.removeEventListener('resize', handleMobileView);
        window.addEventListener('resize', handleMobileView);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!isLoading) {
            setPreviousPath(currentLocation.pathname);
            (0, $fUEMe.default)('dataLayer-initialized', updatesFPPlanningTopics);
            (0, $fUEMe.default)('VirtualPageview', virtualPageInfo);
            dataLayerScroll();
        }
    }, [
        isLoading
    ]);
    function dataLayerScroll() {
        let timeout;
        window.addEventListener('scroll', ()=>{
            if (timeout) window.clearTimeout(timeout);
            timeout = window.setTimeout(scrollEvent, 100);
        }, true);
    }
    function scrollEvent() {
        const footerLocation = document.querySelector('footer').getBoundingClientRect();
        if (footerLocation.top >= 0 && footerLocation.left >= 0 && footerLocation.bottom <= (window.innerHeight || document.documentElement.clientHeight) && footerLocation.right <= (window.innerWidth || document.documentElement.clientWidth)) (0, $fUEMe.default)('footer-visible', {});
    }
    return isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: "spinner",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dB0L.default), {
            animation: "border"
        })
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "FPWelcomePage",
        "data-testid": "welcome-page-fp",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "FPWelcomePage_content",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    id: "main-header",
                    "data-testid": "main-header-fp",
                    children: (0, $iJxY6.default)(locId, 'mainHeader', 'fpWelcomePage')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "FPWelcomePage_p",
                    "data-testid": "main-header-paragraph-fp",
                    children: (0, $iJxY6.default)(locId, 'mainHeaderParagraph', 'fpWelcomePage')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "FPWelcomePage_cta_container",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            id: "cta-container-header",
                            "data-testid": "cta-container-header-fp",
                            children: (0, $iJxY6.default)(locId, 'ctaSectionHeader', 'fpWelcomePage')
                        }),
                        userPersona === (0, $kMrYv.default).DIRECT_URL ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "FPWelcomePage_p FPWelcomePage_p--secondary-one",
                            "data-testid": "cta-container-header-paragraph-one-fp",
                            children: (0, $iJxY6.default)(locId, 'ctaSectionHeaderParagraphOneDefault', 'fpWelcomePage')
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "FPWelcomePage_p FPWelcomePage_p--secondary-one",
                            "data-testid": "cta-container-header-paragraph-one-fp",
                            children: (0, $iJxY6.default)(locId, 'ctaSectionHeaderParagraphOneAlternate', 'fpWelcomePage')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "FPWelcomePage_cta_container_cta",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "FPWelcomePage_cta_container_cta_button",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "FPWelcomePage_p FPWelcomePage_p--secondary-two",
                                            "data-testid": "cta-container-header-paragraph-two-fp",
                                            children: (0, $iJxY6.default)(locId, 'ctaSectionHeaderParagraphTwo', 'fpWelcomePage')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                                            label: (0, $iJxY6.default)(locId, 'startBtnLabel', 'fpWelcomePage'),
                                            styleVariant: "primary",
                                            onClick: ()=>{
                                                (0, $fUEMe.default)('to-customize-page', {});
                                                customizeBtnCallback();
                                            },
                                            attributes: {
                                                value: '',
                                                id: 'customize-quiz-button-fp'
                                            }
                                        })
                                    ]
                                }),
                                !isMobile || isMobile && viewOrientation === 'landscape-primary' || viewOrientation === 'landscape-secondary' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "image-frame",
                                    "data-testid": "welcome-image-frame-fp",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: "/public/images/welcome_image.png",
                                        alt: "",
                                        role: "presentation"
                                    })
                                }) : null
                            ]
                        })
                    ]
                }),
                isMobile && (viewOrientation === 'portrait-primary' || viewOrientation === 'portrait-secondary') ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "image-frame",
                    "data-testid": "welcome-image-frame-fp",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: "/public/images/welcome_image.png",
                        alt: "",
                        role: "presentation"
                    })
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "disclosureFP",
                    "data-testid": "fp-disclosure",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "microcopy--2",
                        children: (0, $iJxY6.default)(locId, 'welcomePageDisclosure', 'fpWelcomePage')
                    })
                })
            ]
        })
    });
};
$8803f490f5dde294$var$FPWelcomePage.propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    customizeBtnCallback: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};
var $8803f490f5dde294$export$2e2bcd8739ae039 = $8803f490f5dde294$var$FPWelcomePage;

});
parcelRegister("7mmdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f078b543969ac27$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $5f078b543969ac27$var$UserContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $5f078b543969ac27$export$2e2bcd8739ae039 = $5f078b543969ac27$var$UserContext;

});

parcelRegister("kMrYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $33a0a93915de0b83$export$2e2bcd8739ae039);
var $33a0a93915de0b83$var$UserPersonaTypes = /*#__PURE__*/ function(UserPersonaTypes) {
    UserPersonaTypes["WORD_POWER"] = "wordpower";
    UserPersonaTypes["WORD_POWER_CA"] = "wordpower_ca";
    UserPersonaTypes["NEWS_LETTER"] = "newsletter";
    UserPersonaTypes["NEWS_LETTER_CA"] = "newsletter_ca";
    UserPersonaTypes["FINANCIAL_FOUNDATION"] = "financial_foundation";
    UserPersonaTypes["FINANCIAL_FOUNDATION_CA"] = "financial_foundation_ca";
    UserPersonaTypes["PERSONAL_LINK"] = "personal_link";
    UserPersonaTypes["PERSONAL_LINK_CA"] = "personal_link_ca";
    UserPersonaTypes["PERSONAL_LINK_FA_PROFILE"] = "personal_link_fa_profile";
    UserPersonaTypes["PERSONAL_LINK_FA_PROFILE_CA"] = "personal_link_fa_profile_ca";
    UserPersonaTypes["DIRECT_URL_CA"] = "direct_url_ca";
    UserPersonaTypes["DIRECT_URL"] = "direct_url";
    return UserPersonaTypes;
}($33a0a93915de0b83$var$UserPersonaTypes || {});
var $33a0a93915de0b83$export$2e2bcd8739ae039 = $33a0a93915de0b83$var$UserPersonaTypes;

});


parcelRegister("iGWsk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d32cea67a54d6614$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $gfQkH = parcelRequire("gfQkH");

var $7lk71 = parcelRequire("7lk71");

var $9ze7e = parcelRequire("9ze7e");

var $fKxvO = parcelRequire("fKxvO");

var $iJxY6 = parcelRequire("iJxY6");

var $tL0U5 = parcelRequire("tL0U5");

var $l19uC = parcelRequire("l19uC");

var $9Ryut = parcelRequire("9Ryut");

var $fUEMe = parcelRequire("fUEMe");


var $2DcdH = parcelRequire("2DcdH");

var $RXYi2 = parcelRequire("RXYi2");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
const $d32cea67a54d6614$var$Quiz = (props)=>{
    const { initialValuePair: initialValuePair, valueList: valueList, finalResultsCallBack: finalResultsCallBack, errorPageCallback: errorPageCallback } = props;
    const { dataLayerInfo: dataLayerInfo } = (0, $RXYi2.useDataLayerInfo)();
    const [questionNumber, setQuestionNumber] = (0, $acw62.useState)(0);
    const [firstValue, setFirstValue] = (0, $acw62.useState)(initialValuePair[0]);
    const [secondValue, setSecondValue] = (0, $acw62.useState)(initialValuePair[1]);
    const [allPairsIndex, setAllPairsIndex] = (0, $acw62.useState)([]);
    const [allChoicesIndex, setallChoicesIndex] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const progress = Math.round(questionNumber * 100 / $l19uC.MAX_QUESTIONS);
    const firstValueCard = (0, $acw62.useRef)();
    const topOfQuiz = (0, $acw62.useRef)();
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    function removeFocus() {
        const heading = document.getElementById('heading-no-focus');
        heading.removeAttribute('tabIndex');
    }
    (0, $acw62.useEffect)(()=>{
        if (firstValueCard.current && valueList.filter((value)=>value.statementId === firstValue.statementId).length > 0) firstValueCard.current.focus();
    }, [
        firstValue,
        secondValue
    ]);
    (0, $acw62.useEffect)(()=>{
        setFirstValue(initialValuePair[0]);
        setSecondValue(initialValuePair[1]);
        setAllPairsIndex([
            [
                initialValuePair[0].indexId,
                initialValuePair[1].indexId
            ]
        ]);
    }, [
        initialValuePair
    ]);
    const updatedDataLayerInfo = {
        ...dataLayerInfo,
        page_type: "quiz-page"
    };
    const { setPreviousPath: setPreviousPath, previousPath: previousPath } = (0, $2DcdH.usePreviousPath)();
    const currentLocation = (0, $aphAM.useLocation)();
    const pageTitle = (0, $iJxY6.default)(locId, 'pageTitle', 'quizPage');
    const pageReferrer = previousPath ? `${window.location.origin}${previousPath}${currentLocation.search}` : undefined;
    const pageURL = `${window.location.origin}${currentLocation.pathname}${currentLocation.search}`;
    const virtualPageInfo = {
        'pagePath': currentLocation.pathname,
        'pageTitle': pageTitle,
        'page_referrer': pageReferrer,
        'external_referrer': window.document.referrer && window.document.referrer.trim() !== '' ? window.document.referrer : undefined,
        'page_url': pageURL
    };
    (0, $acw62.useEffect)(()=>{
        setPreviousPath(currentLocation.pathname);
        (0, $fUEMe.default)("dataLayer-initialized", updatedDataLayerInfo);
        (0, $fUEMe.default)('VirtualPageview', virtualPageInfo);
        setAllPairsIndex([
            [
                initialValuePair[0].indexId,
                initialValuePair[1].indexId
            ]
        ]);
        if (typeof topOfQuiz.current !== 'undefined') topOfQuiz.current.focus();
        setTimeout(removeFocus, 1000);
        document.title = pageTitle;
    }, []);
    function getValueFromIndex(index) {
        return valueList.filter((value)=>value.indexId === index)[0];
    }
    function userSelection(winner, loser) {
        setIsLoading(true);
        setallChoicesIndex(()=>allChoicesIndex.concat([
                [
                    winner.indexId,
                    loser.indexId
                ]
            ]));
        (0, $fUEMe.default)('next-selection', {});
        const data = JSON.stringify(allChoicesIndex.concat([
            [
                winner.indexId,
                loser.indexId
            ]
        ]));
        (0, $tL0U5.getNextPair)(data).then((res)=>{
            if (res.valuePair) {
                setFirstValue(getValueFromIndex(res.valuePair[0]));
                setSecondValue(getValueFromIndex(res.valuePair[1]));
                setAllPairsIndex(()=>allPairsIndex.concat([
                        res.valuePair
                    ]));
                setQuestionNumber(questionNumber + 1);
                setIsLoading(false);
            }
            if (questionNumber === $l19uC.MAX_QUESTIONS - 1) {
                setIsLoading(false);
                finalResultsCallBack(res.rankedList);
            }
        }).catch((error)=>{
            if (error.response && error.response.status === 403) (0, $tL0U5.handleAVIError)(error, locId);
            errorPageCallback();
        });
    }
    function handleBackClick() {
        const tempValuePairs = allPairsIndex;
        const tempChoices = allChoicesIndex;
        tempValuePairs.pop();
        tempChoices.pop();
        setAllPairsIndex(tempValuePairs);
        setallChoicesIndex(tempChoices);
        setQuestionNumber(questionNumber - 1);
        setFirstValue(getValueFromIndex(tempValuePairs[tempValuePairs.length - 1][0]));
        setSecondValue(getValueFromIndex(tempValuePairs[tempValuePairs.length - 1][1]));
        if (typeof firstValueCard.current !== 'undefined') firstValueCard.current.focus();
        (0, $fUEMe.default)('previous-selection', {});
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "quizPage",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "title-tooltip-container",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        id: "heading-no-focus",
                                        className: "heading--semi-bold",
                                        ref: topOfQuiz,
                                        tabIndex: -1,
                                        children: (0, $iJxY6.default)(locId, 'header', 'quizPage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "quiz-tooltip",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.InfoTooltip), {
                                            title: "",
                                            placement: "below",
                                            align: "right",
                                            children: (0, $iJxY6.default)(locId, 'tooltipDescription', 'quizPage')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "quiz-instructions",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: (0, $iJxY6.default)(locId, 'chooseOneBoldText', 'quizPage')
                                    }),
                                    (0, $iJxY6.default)(locId, 'goWithText', 'quizPage')
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                "aria-live": "polite",
                                className: "progress-bar-container",
                                "data-testid": "progress-bar",
                                "aria-label": (0, $iJxY6.default)(locId, 'progressBarAriaLabel', 'quizPage').replace('%QUESTION_NUMBER%', `${questionNumber + 1}`).replace('%MAX_QUESTIONS%', `${$l19uC.MAX_QUESTIONS}`),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gfQkH.default), {
                                    animated: true,
                                    now: progress,
                                    "aria-hidden": true
                                })
                            })
                        ]
                    }),
                    valueList.filter((value)=>value.statementId === firstValue.statementId).length > 0 && valueList.filter((value)=>value.statementId === secondValue.statementId).length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "cards-container",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                "aria-label": (0, $iJxY6.default)(locId, 'ariaLabelChoiceNumberOne', 'quizPage') + (0, $fKxvO.default)(firstValue.statementId, valueList),
                                className: !isLoading ? 'value-card-1' : 'value-card-1 vc-loading',
                                ref: firstValueCard,
                                onClick: ()=>!isLoading && userSelection(firstValue, secondValue),
                                "data-testid": "vc1-test",
                                id: "value-card-one",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ze7e.default), {
                                    valueStatement: (0, $fKxvO.default)(firstValue.statementId, valueList),
                                    valueStatementId: firstValue.statementId,
                                    isLoading: isLoading
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                "aria-label": (0, $iJxY6.default)(locId, 'ariaLabelChoiceNumberTwo', 'quizPage') + (0, $fKxvO.default)(secondValue.statementId, valueList),
                                className: !isLoading ? 'value-card-2' : 'value-card-2 vc-loading',
                                onClick: ()=>!isLoading && userSelection(secondValue, firstValue),
                                "data-testid": "vc2-test",
                                id: "value-card-two",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ze7e.default), {
                                    valueStatement: (0, $fKxvO.default)(secondValue.statementId, valueList),
                                    valueStatementId: secondValue.statementId,
                                    isLoading: isLoading
                                })
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "backBtn",
                        children: questionNumber > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                            onClick: ()=>handleBackClick(),
                            icon: "chevron-left",
                            label: (0, $iJxY6.default)(locId, 'changePreviousAnswerButtonLabel', 'quizPage'),
                            styleVariant: "tertiary",
                            attributes: {
                                value: '',
                                'data-testid': 'backBtn',
                                id: 'change-previous-button'
                            },
                            "aria-label": (0, $iJxY6.default)(locId, 'changePreviousAnswerAriaLabel', 'quizPage')
                        }) : null
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "footer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "disclaimer",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "microcopy--2",
                        children: (0, $iJxY6.default)(locId, 'quizPageDisclosure', 'quizPage')
                    })
                })
            })
        ]
    });
};
$d32cea67a54d6614$var$Quiz.propTypes = {
    initialValuePair: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    valueList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    finalResultsCallBack: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    errorPageCallback: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $d32cea67a54d6614$export$2e2bcd8739ae039 = $d32cea67a54d6614$var$Quiz;

});
parcelRegister("gfQkH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd56a4485ab443d2$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $iaLOT = parcelRequire("iaLOT");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $bd56a4485ab443d2$var$ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */ function $bd56a4485ab443d2$var$onlyProgressBar(props, propName, componentName) {
    const children = props[propName];
    if (!children) return null;
    let error = null;
    $acw62.Children.forEach(children, (child)=>{
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ const element = /*#__PURE__*/ (0, $ayMG0.jsx)($bd56a4485ab443d2$var$ProgressBar, {});
        if (child.type === element.type) return;
        const childType = child.type;
        const childIdentifier = /*#__PURE__*/ $acw62.isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error(`Children of ${componentName} can contain only ProgressBar ` + `components. Found ${childIdentifier}.`);
    });
    return error;
}
function $bd56a4485ab443d2$var$getPercentage(now, min, max) {
    const percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * $bd56a4485ab443d2$var$ROUND_PRECISION) / $bd56a4485ab443d2$var$ROUND_PRECISION;
}
function $bd56a4485ab443d2$var$renderProgressBar({ min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, className: className, style: style, variant: variant, bsPrefix: bsPrefix, ...props }, ref) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: ref,
        ...props,
        role: "progressbar",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, `${bsPrefix}-bar`, {
            [`bg-${variant}`]: variant,
            [`${bsPrefix}-bar-animated`]: animated,
            [`${bsPrefix}-bar-striped`]: animated || striped
        }),
        style: {
            width: `${$bd56a4485ab443d2$var$getPercentage(now, min, max)}%`,
            ...style
        },
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max,
        children: visuallyHidden ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "visually-hidden",
            children: label
        }) : label
    });
}
const $bd56a4485ab443d2$var$ProgressBar = /*#__PURE__*/ $acw62.forwardRef(({ isChild: isChild = false, ...rest }, ref)=>{
    const props = {
        min: 0,
        max: 100,
        animated: false,
        visuallyHidden: false,
        striped: false,
        ...rest
    };
    props.bsPrefix = (0, $8rTrh.useBootstrapPrefix)(props.bsPrefix, 'progress');
    if (isChild) return $bd56a4485ab443d2$var$renderProgressBar(props, ref);
    const { min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, bsPrefix: bsPrefix, variant: variant, className: className, children: children, ...wrapperProps } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: ref,
        ...wrapperProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        children: children ? (0, $iaLOT.map)(children, (child)=>/*#__PURE__*/ (0, $acw62.cloneElement)(child, {
                isChild: true
            })) : $bd56a4485ab443d2$var$renderProgressBar({
            min: min,
            now: now,
            max: max,
            label: label,
            visuallyHidden: visuallyHidden,
            striped: striped,
            animated: animated,
            bsPrefix: bsPrefix,
            variant: variant
        }, ref)
    });
});
$bd56a4485ab443d2$var$ProgressBar.displayName = 'ProgressBar';
var $bd56a4485ab443d2$export$2e2bcd8739ae039 = $bd56a4485ab443d2$var$ProgressBar;

});
parcelRegister("iaLOT", function(module, exports) {

$parcel$export(module.exports, "map", () => $d3ae4136892dd278$export$871de8747c9eaa88);
$parcel$export(module.exports, "forEach", () => $d3ae4136892dd278$export$4b80e395e36b5a56);

var $acw62 = parcelRequire("acw62");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $d3ae4136892dd278$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $acw62.Children.map(children, (child)=>/*#__PURE__*/ $acw62.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $d3ae4136892dd278$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $acw62.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $d3ae4136892dd278$export$500fd6099226ffae(children, type) {
    return $acw62.Children.toArray(children).some((child)=>/*#__PURE__*/ $acw62.isValidElement(child) && child.type === type);
}

});


parcelRegister("9ze7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a92300a88b40147$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");


var $fUEMe = parcelRequire("fUEMe");

var $9TzF7 = parcelRequire("9TzF7");

var $9Ryut = parcelRequire("9Ryut");

var $iJxY6 = parcelRequire("iJxY6");

var $jdW6Z = parcelRequire("jdW6Z");

var $7mmdw = parcelRequire("7mmdw");

var $kMrYv = parcelRequire("kMrYv");
const $4a92300a88b40147$var$ValueCard = (props)=>{
    const { valueStatement: valueStatement, valueStatementId: valueStatementId, learnMoreContent: learnMoreContent, learnMoreLinks: learnMoreLinks, isLoading: isLoading, displayLearnMoreButton: displayLearnMoreButton, rank: rank, disabled: disabled, cardClassName: cardClassName, setCardClassName: setCardClassName, setShowAdditionalInfoModal: setShowAdditionalInfoModal, setShowCustomPriorityEditModal: setShowCustomPriorityEditModal, isEditable: isEditable, setEditModalCurrentCardValue: setEditModalCurrentCardValue, infoModalContent: infoModalContent, setInfoModalContent: setInfoModalContent } = props;
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const userPersona = (0, $acw62.useContext)((0, $7mmdw.default));
    const [displayLearnMoreContent, setDisplayLearnMoreContent] = (0, $acw62.useState)(false);
    const SPACE = ' ';
    const ENTER = 'Enter';
    const ESCAPE = 'Escape';
    const personaTypeArrayUS = Array.of((0, $kMrYv.default).WORD_POWER, (0, $kMrYv.default).NEWS_LETTER, (0, $kMrYv.default).PERSONAL_LINK, (0, $kMrYv.default).PERSONAL_LINK_FA_PROFILE, (0, $kMrYv.default).FINANCIAL_FOUNDATION, (0, $kMrYv.default).DIRECT_URL);
    (0, $acw62.useEffect)(()=>{
        if (displayLearnMoreContent) setCardClassName('value-card value-card-disabled');
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!displayLearnMoreContent) document.body.classList.remove('verification-multi-modal');
    }, [
        displayLearnMoreContent
    ]);
    const learnMoreClickHandler = ()=>{
        (0, $fUEMe.default)('learn-more-content', {});
        setDisplayLearnMoreContent(true);
        document.body.classList.add('verification-multi-modal');
    };
    const learnMoreKeyDownHandler = (e)=>{
        if (e.key === ENTER || e.key === SPACE) {
            (0, $fUEMe.default)('learn-more-content', {});
            setDisplayLearnMoreContent(true);
            document.body.classList.add('verification-multi-modal');
        }
        if (e.key === ESCAPE) setDisplayLearnMoreContent(false);
    };
    const valueCardInfoOnClickHandler = ()=>{
        if (isEditable) setInfoModalContent((0, $iJxY6.default)(locId, 'customPriorityInfoModalTitle', 'customizePage'));
        else setInfoModalContent(infoModalContent);
        setShowAdditionalInfoModal(true);
    };
    const valueCardInfoKeyDownHandler = (e)=>{
        if (e.key === ENTER || e.key === SPACE) {
            if (isEditable) setInfoModalContent((0, $iJxY6.default)(locId, 'customPriorityInfoModalTitle', 'customizePage'));
            else setInfoModalContent(infoModalContent);
            setShowAdditionalInfoModal(true);
        }
        if (e.key === ESCAPE) setShowAdditionalInfoModal(false);
    };
    const valueEditOnClickHandler = ()=>{
        setEditModalCurrentCardValue({
            statementId: valueStatementId,
            statementText: valueStatement
        });
        setShowCustomPriorityEditModal(true);
    };
    const valueEditKeyDownHandler = (e)=>{
        if (e.key === ENTER || e.key === SPACE) {
            setEditModalCurrentCardValue({
                statementId: valueStatementId,
                statementText: valueStatement
            });
            setShowCustomPriorityEditModal(true);
        }
        if (e.key === ESCAPE) setShowCustomPriorityEditModal(false);
    };
    if (!isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: cardClassName,
        "data-testid": `valueCard-${valueStatementId}`,
        children: [
            rank ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "value-rank",
                "aria-hidden": "true",
                children: rank
            }) : null,
            !personaTypeArrayUS.includes(userPersona) && (isEditable || infoModalContent) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "button",
                className: "value-additional-info-button",
                tabIndex: 0,
                onClick: (e)=>{
                    e.stopPropagation();
                    valueCardInfoOnClickHandler();
                },
                onKeyDown: (e)=>{
                    e.stopPropagation();
                    valueCardInfoKeyDownHandler(e);
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "value-edit-info--icon--custom-size",
                    "data-testid": `value-additional-info-button-${valueStatementId}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Icon), {
                        name: "help-question-mark"
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: isEditable ? 'value-edit-img' : 'value-image',
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: $jdW6Z[`${valueStatementId}`],
                    alt: "",
                    role: "presentation"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-container",
                children: [
                    isEditable ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        role: "button",
                        className: "value-edit-statement",
                        "aria-hidden": "true",
                        tabIndex: 0,
                        onClick: (e)=>{
                            e.stopPropagation();
                            valueEditOnClickHandler();
                        },
                        onKeyDown: (e)=>{
                            e.stopPropagation();
                            valueEditKeyDownHandler(e);
                        },
                        children: valueStatement
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "value-statement",
                        children: valueStatement
                    }),
                    displayLearnMoreButton ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        role: "button",
                        className: "learn-more-button",
                        tabIndex: -1,
                        onClick: ()=>{
                            learnMoreClickHandler();
                        },
                        onKeyDown: (e)=>{
                            learnMoreKeyDownHandler(e);
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: (0, $iJxY6.default)(locId, 'learnMoreButton', 'resultsPage')
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TzF7.default), {
                displayLearnMoreContent: displayLearnMoreContent,
                setDisplayLearnMoreContent: setDisplayLearnMoreContent,
                learnMoreContent: learnMoreContent,
                learnMoreLinks: learnMoreLinks,
                valueStatement: valueStatement,
                valueStatementId: valueStatementId,
                rank: rank
            }),
            disabled || displayLearnMoreContent ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "value-card-disabledBox"
            }) : null
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "value-card"
    });
};
$4a92300a88b40147$var$ValueCard.defaultProps = {
    rank: null,
    isLoading: false,
    displayLearnMoreButton: false,
    disabled: false,
    learnMoreContent: null,
    cardClassName: 'value-card',
    setCardClassName: null,
    learnMoreLinks: null,
    setShowAdditionalInfoModal: null,
    setShowCustomPriorityEditModal: null,
    isEditable: false,
    setEditModalCurrentCardValue: null,
    infoModalContent: null,
    setInfoModalContent: null
};
$4a92300a88b40147$var$ValueCard.propTypes = {
    valueStatement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    valueStatementId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    setCardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    learnMoreLinks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    learnMoreContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    displayLearnMoreButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    rank: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setShowAdditionalInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    setShowCustomPriorityEditModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isEditable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    setEditModalCurrentCardValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    infoModalContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setInfoModalContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $4a92300a88b40147$export$2e2bcd8739ae039 = $4a92300a88b40147$var$ValueCard;

});
parcelRegister("9TzF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $65ecc3a981c81cc6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");


var $gbnJ1 = parcelRequire("gbnJ1");
const $65ecc3a981c81cc6$var$LearnMoreCards = (props)=>{
    const { valueStatement: valueStatement, valueStatementId: valueStatementId, learnMoreContent: learnMoreContent, learnMoreLinks: learnMoreLinks, displayLearnMoreContent: displayLearnMoreContent, setDisplayLearnMoreContent: setDisplayLearnMoreContent, rank: rank } = props;
    (0, $acw62.useEffect)(()=>{}, [
        document.getElementsByClassName('learnMoreCard')
    ]);
    (0, $acw62.useEffect)(()=>{
        document.body.classList.add('verification-multi-modal');
        return ()=>{
            document.body.classList.remove('verification-multi-modal');
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7lk71.Dialog), {
        title: "",
        open: displayLearnMoreContent,
        buttons: [],
        className: "learnMoreCard",
        onRequestClose: ()=>{
            setDisplayLearnMoreContent(false);
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "value-rank",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    children: rank
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "value-image",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: $gbnJ1[`${valueStatementId}`],
                    alt: "",
                    role: "presentation"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "value-statement",
                children: valueStatement
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "learn-more-content",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: learnMoreContent
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "learn-more-links-button",
                children: learnMoreLinks ? /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                    children: learnMoreLinks.map((link)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: link.learnMoreLinkUrl,
                                target: "_blank",
                                rel: "noreferrer noopener",
                                children: link.learnMoreLinkText
                            })
                        }, link.learnMoreLinkUrl))
                }) : null
            })
        ]
    });
};
$65ecc3a981c81cc6$var$LearnMoreCards.defaultProps = {
    learnMoreContent: null,
    learnMoreLinks: null,
    displayLearnMoreContent: false,
    setDisplayLearnMoreContent: null,
    rank: null
};
$65ecc3a981c81cc6$var$LearnMoreCards.propTypes = {
    valueStatement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    valueStatementId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    learnMoreContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    learnMoreLinks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    displayLearnMoreContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    setDisplayLearnMoreContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    rank: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
};
var $65ecc3a981c81cc6$export$2e2bcd8739ae039 = $65ecc3a981c81cc6$var$LearnMoreCards;

});
parcelRegister("gbnJ1", function(module, exports) {

var $j0E3x = parcelRequire("j0E3x");

var $dAgX1 = parcelRequire("dAgX1");

var $gvzSq = parcelRequire("gvzSq");

var $96XcN = parcelRequire("96XcN");

var $b31so = parcelRequire("b31so");

var $6mupl = parcelRequire("6mupl");

var $65cSr = parcelRequire("65cSr");

var $907wP = parcelRequire("907wP");

var $3PJH8 = parcelRequire("3PJH8");

var $68htO = parcelRequire("68htO");

var $gZoD5 = parcelRequire("gZoD5");

var $iWIB7 = parcelRequire("iWIB7");

var $7CXEs = parcelRequire("7CXEs");

var $7u4TD = parcelRequire("7u4TD");

var $NQSic = parcelRequire("NQSic");

var $1iHQW = parcelRequire("1iHQW");

var $gTWkC = parcelRequire("gTWkC");
module.exports = {
    "0": $j0E3x,
    "1": $dAgX1,
    "2": $gvzSq,
    "3": $96XcN,
    "4": $b31so,
    "5": $6mupl,
    "6": $65cSr,
    "7": $907wP,
    "8": $3PJH8,
    "9": $68htO,
    "10": $gZoD5,
    "11": $iWIB7,
    "12": $7CXEs,
    "13": $7u4TD,
    "14": $NQSic,
    "15": $1iHQW,
    "dnd-icon": $gTWkC
};

});
parcelRegister("j0E3x", function(module, exports) {
module.exports = $parcel$resolve("cZyW1");

});

parcelRegister("dAgX1", function(module, exports) {
module.exports = $parcel$resolve("9ukTJ");

});

parcelRegister("gvzSq", function(module, exports) {
module.exports = $parcel$resolve("7XYOj");

});

parcelRegister("96XcN", function(module, exports) {
module.exports = $parcel$resolve("1HMa7");

});

parcelRegister("b31so", function(module, exports) {
module.exports = $parcel$resolve("eXSkc");

});

parcelRegister("6mupl", function(module, exports) {
module.exports = $parcel$resolve("k3pgF");

});

parcelRegister("65cSr", function(module, exports) {
module.exports = $parcel$resolve("ggarB");

});

parcelRegister("907wP", function(module, exports) {
module.exports = $parcel$resolve("kGZum");

});

parcelRegister("3PJH8", function(module, exports) {
module.exports = $parcel$resolve("f5fsq");

});

parcelRegister("68htO", function(module, exports) {
module.exports = $parcel$resolve("gEHFQ");

});

parcelRegister("gZoD5", function(module, exports) {
module.exports = $parcel$resolve("jmD52");

});

parcelRegister("iWIB7", function(module, exports) {
module.exports = $parcel$resolve("7QXfa");

});

parcelRegister("7CXEs", function(module, exports) {
module.exports = $parcel$resolve("fB4Nx");

});

parcelRegister("7u4TD", function(module, exports) {
module.exports = $parcel$resolve("cXffW");

});

parcelRegister("NQSic", function(module, exports) {
module.exports = $parcel$resolve("7WeNu");

});

parcelRegister("1iHQW", function(module, exports) {
module.exports = $parcel$resolve("3MeVc");

});

parcelRegister("gTWkC", function(module, exports) {
module.exports = $parcel$resolve("di0eo");

});



parcelRegister("jdW6Z", function(module, exports) {

var $j0E3x = parcelRequire("j0E3x");

var $dAgX1 = parcelRequire("dAgX1");

var $gvzSq = parcelRequire("gvzSq");

var $96XcN = parcelRequire("96XcN");

var $b31so = parcelRequire("b31so");

var $6mupl = parcelRequire("6mupl");

var $65cSr = parcelRequire("65cSr");

var $907wP = parcelRequire("907wP");

var $3PJH8 = parcelRequire("3PJH8");

var $68htO = parcelRequire("68htO");

var $gZoD5 = parcelRequire("gZoD5");

var $iWIB7 = parcelRequire("iWIB7");

var $7CXEs = parcelRequire("7CXEs");

var $7u4TD = parcelRequire("7u4TD");

var $NQSic = parcelRequire("NQSic");

var $1iHQW = parcelRequire("1iHQW");

var $gTWkC = parcelRequire("gTWkC");
module.exports = {
    "0": $j0E3x,
    "1": $dAgX1,
    "2": $gvzSq,
    "3": $96XcN,
    "4": $b31so,
    "5": $6mupl,
    "6": $65cSr,
    "7": $907wP,
    "8": $3PJH8,
    "9": $68htO,
    "10": $gZoD5,
    "11": $iWIB7,
    "12": $7CXEs,
    "13": $7u4TD,
    "14": $NQSic,
    "15": $1iHQW,
    "dnd-icon": $gTWkC
};

});


parcelRegister("fKxvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $20e9d412b3bbacc6$export$2e2bcd8739ae039);
function $20e9d412b3bbacc6$var$getStatementText(id, valueList) {
    const statementObj = valueList.filter((valueStatement)=>valueStatement.statementId === id);
    return statementObj[0].statementText;
}
var $20e9d412b3bbacc6$export$2e2bcd8739ae039 = $20e9d412b3bbacc6$var$getStatementText;

});

parcelRegister("tL0U5", function(module, exports) {

$parcel$export(module.exports, "getSchema", () => $bbd230e5ce70aa2a$export$19a621270f26273c);
$parcel$export(module.exports, "getNextPair", () => $bbd230e5ce70aa2a$export$e951da72b8fedff3);
$parcel$export(module.exports, "sendToDelegator", () => $bbd230e5ce70aa2a$export$58a8deda9f01cc92);
$parcel$export(module.exports, "isMpUsFinancialPlanningContentActive", () => $bbd230e5ce70aa2a$export$c64ce1d138703d5d);
$parcel$export(module.exports, "handleAVIError", () => $bbd230e5ce70aa2a$export$50de3d74606b79a0);
parcelRequire("9NZOq");
parcelRequire("fmRoT");
var $7we3r = parcelRequire("7we3r");

var $l19uC = parcelRequire("l19uC");
const $bbd230e5ce70aa2a$var$assessment = (method, headers, params)=>{
    let baseUrl;
    if (window.location.host.includes('localhost')) // baseUrl = constants.LOCAL_ASSESSMENT_API_BASE;
    baseUrl = `https://prp-mypriorities-gtwy.apps2.devjones.com${$l19uC.ASSESSMENT_API_BASE}`;
    else baseUrl = $l19uC.ASSESSMENT_API_BASE;
    return (0, $7we3r.default).create({
        baseURL: baseUrl,
        method: method,
        headers: {
            withCredentials: 'true',
            'Cache-Control': 'no-store',
            ...headers
        },
        params: params
    });
};
const $bbd230e5ce70aa2a$var$delegator = (responseType, method, params)=>{
    let baseURL;
    if (window.location.host.includes('localhost')) // baseURL = constants.LOCAL_DELEGATOR_API_BASE;
    baseURL = `https://prp-mypriorities-gtwy.apps2.devjones.com${$l19uC.DELEGATOR_API_BASE}`;
    else baseURL = $l19uC.DELEGATOR_API_BASE;
    return (0, $7we3r.default).create({
        baseURL: baseURL,
        method: method,
        headers: {
            'Content-Type': 'application/json',
            credentials: 'include',
            'Cache-Control': 'no-store'
        },
        responseType: responseType,
        params: params
    });
};
const $bbd230e5ce70aa2a$var$featureGateway = (method)=>{
    let baseURL;
    if (window.location.host.includes('localhost')) // baseURL = constants.LOCAL_FEATURE_API_BASE;
    baseURL = `https://prp-mypriorities-gtwy.apps2.devjones.com${$l19uC.FEATURE_API_BASE}`;
    else baseURL = $l19uC.FEATURE_API_BASE;
    return (0, $7we3r.default).create({
        baseURL: baseURL,
        method: method,
        headers: {
            credentials: 'include',
            'Cache-Control': 'no-store'
        }
    });
};
const $bbd230e5ce70aa2a$export$19a621270f26273c = (locId, conId, utmSource, conType, faNo, entityIdBase64)=>{
    return $bbd230e5ce70aa2a$var$assessment('get').get('values/', {
        params: {
            sysId: 'PRP',
            appName: 'MyPriorities',
            conId: conId,
            faNo: faNo,
            locId: locId,
            utmSource: utmSource,
            conType: conType,
            entityIdBase64: entityIdBase64
        }
    }).then((res)=>res.data);
};
const $bbd230e5ce70aa2a$export$e951da72b8fedff3 = (data)=>{
    const headers = {
        'Content-Type': 'application/json'
    };
    const params = {
        sysId: 'PRP',
        appName: 'MyPriorities'
    };
    const url = 'ranking/';
    return $bbd230e5ce70aa2a$var$assessment('post', headers, params).post(url, data).then((res)=>res.data);
};
const $bbd230e5ce70aa2a$export$58a8deda9f01cc92 = (params, data, responseType)=>{
    let url;
    if (responseType === 'blob') url = 'results-pdf/';
    else url = 'process-request/';
    return $bbd230e5ce70aa2a$var$delegator(responseType, 'post', params).post(url, data).then((res)=>res.data);
};
const $bbd230e5ce70aa2a$export$c64ce1d138703d5d = ()=>{
    const url = '/mp/us-fp-active';
    return $bbd230e5ce70aa2a$var$featureGateway('get').get(url).then((res)=>res.data);
};
function $bbd230e5ce70aa2a$export$cd3757937af5a96f(data, locId) {
    let url;
    if (window.location.host.includes('localhost')) url = $l19uC.ERROR_API_LOCAL;
    else url = $l19uC.ERROR_API;
    return (0, $7we3r.default)({
        method: 'post',
        url: url,
        params: {
            sysId: 'PRP',
            appName: 'MyPriorities',
            locale: locId
        },
        data: data
    }).then((res)=>res.data);
}
async function $bbd230e5ce70aa2a$export$225cfad360f35a0(supportId, locId) {
    try {
        const data = {
            appName: 'MyPriorities',
            locale: locId,
            aviSupportId: supportId,
            errorDateTime: new Date().toISOString()
        };
        await $bbd230e5ce70aa2a$export$cd3757937af5a96f(data, locId);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    }
}
function $bbd230e5ce70aa2a$export$50de3d74606b79a0(error, locId) {
    try {
        const htmlString = error.response.data;
        const startTextLocation = htmlString.indexOf('ID:');
        const endTextLocation = htmlString.indexOf('and');
        const supportId = htmlString.slice(startTextLocation + 4, endTextLocation).trim(); // Removing all text except the supportId.
        $bbd230e5ce70aa2a$export$225cfad360f35a0(supportId, locId);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
    }
}

});
parcelRegister("9NZOq", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7238a34a955809b2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = $7238a34a955809b2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7238a34a955809b2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7238a34a955809b2$var$runtime);
}

});

parcelRegister("fmRoT", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7we3r")).default);

var $7we3r = parcelRequire("7we3r");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $7we3r.default);

});
parcelRegister("7we3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $57966c7e0affc4cb$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $blSvA = parcelRequire("blSvA");

var $8cmY2 = parcelRequire("8cmY2");

var $dIGMp = parcelRequire("dIGMp");

var $lAKPy = parcelRequire("lAKPy");

var $7L4QX = parcelRequire("7L4QX");

var $35BUy = parcelRequire("35BUy");

var $jOwpo = parcelRequire("jOwpo");

var $6HVMZ = parcelRequire("6HVMZ");

var $JEeti = parcelRequire("JEeti");

var $dxy9O = parcelRequire("dxy9O");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");

var $lnWCo = parcelRequire("lnWCo");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $ewFRw.default)(defaultConfig);
    const instance = (0, $jJbMR.default)((0, $ewFRw.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $gKvUL.default).extend(instance, (0, $ewFRw.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $gKvUL.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $lk5EI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $blSvA.default));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $ewFRw.default);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $dIGMp.default);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $lAKPy.default);
$57966c7e0affc4cb$var$axios.isCancel = (0, $7L4QX.default);
$57966c7e0affc4cb$var$axios.VERSION = (0, $35BUy.VERSION);
$57966c7e0affc4cb$var$axios.toFormData = (0, $jOwpo.default);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $6HVMZ.default);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $JEeti.default);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $dxy9O.default);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $lk5EI.default);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $bxxyx.default);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $8cmY2.default)((0, $gKvUL.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $jZ6wW.default).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $lnWCo.default);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c319b2c832c2914a$export$2e2bcd8739ae039);

var $jJbMR = parcelRequire("jJbMR");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c319b2c832c2914a$var$toStringTag in val) && !($c319b2c832c2914a$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 * 
 * @param {*} value The value to test
 * 
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 * 
 * @param {*} formData The formData to test
 * 
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $jJbMR.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable
};

});
parcelRegister("jJbMR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5cb5cefd6507f7e$export$2e2bcd8739ae039);
'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("ewFRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93486d2307f31c3$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $7GD7a = parcelRequire("7GD7a");

var $bv3QM = parcelRequire("bv3QM");

var $bxxyx = parcelRequire("bxxyx");

var $6YCMk = parcelRequire("6YCMk");
'use strict';
const $a93486d2307f31c3$var$validators = (0, $bv3QM.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $83RYu.default)(),
            response: new (0, $83RYu.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $lk5EI.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $bv3QM.default).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $gKvUL.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $bv3QM.default).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $bv3QM.default).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $gKvUL.default).merge(headers.common, headers[config.method]);
        headers && (0, $gKvUL.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $bxxyx.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $6YCMk.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dlZEJ.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $dlZEJ.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $lk5EI.default)(this.defaults, config);
        const fullPath = (0, $7GD7a.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $cbIsf.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $gKvUL.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $lk5EI.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $gKvUL.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $lk5EI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df8fedf1c1e4428$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $l9LQd = parcelRequire("l9LQd");
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const _options = (0, $gKvUL.default).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $gKvUL.default).isURLSearchParams(params) ? params.toString() : new (0, $l9LQd.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("l9LQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66f8c7b4f247caf$export$2e2bcd8739ae039);

var $jOwpo = parcelRequire("jOwpo");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $jOwpo.default)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;

});
parcelRegister("jOwpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6cbd383b18c9625$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $5vpyF = parcelRequire("5vpyF");

var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $gKvUL.default).isPlainObject(thing) || (0, $gKvUL.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $gKvUL.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $gKvUL.default).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $gKvUL.default).toFlatObject((0, $gKvUL.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $5vpyF.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $gKvUL.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $gKvUL.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $gKvUL.default).isSpecCompliantForm(formData);
    if (!(0, $gKvUL.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $gKvUL.default).isDate(value)) return value.toISOString();
        if ((0, $gKvUL.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $gKvUL.default).isBlob(value)) throw new (0, $6HVMZ.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $gKvUL.default).isArrayBuffer(value) || (0, $gKvUL.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $gKvUL.default).isReactNative(formData) && (0, $gKvUL.default).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $gKvUL.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $gKvUL.default).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $gKvUL.default).isFileList(value) || (0, $gKvUL.default).endsWith(key, '[]')) && (arr = (0, $gKvUL.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $gKvUL.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $gKvUL.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $gKvUL.default).forEach(value, function each(el, key) {
            const result = !((0, $gKvUL.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $gKvUL.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;

});
parcelRegister("6HVMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2395edb77acf3a$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $gKvUL.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;

});

parcelRegister("5vpyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4023ac50ad132196$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("83RYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de878cd737ef277$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $gKvUL.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8d10189805ccc0$export$2e2bcd8739ae039);

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $blSvA = parcelRequire("blSvA");

var $dIGMp = parcelRequire("dIGMp");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $dIGMp.default)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $bxxyx.default).from(config.headers);
    // Transform request data
    config.data = (0, $7YJ0v.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $jZ6wW.default).getAdapter(config.adapter || (0, $blSvA.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $7YJ0v.default).call(config, config.transformResponse, response);
        response.headers = (0, $bxxyx.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7L4QX.default)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $7YJ0v.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $bxxyx.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("7YJ0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf10c777cce5f4f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $blSvA = parcelRequire("blSvA");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $blSvA.default);
    const context = response || config;
    const headers = (0, $bxxyx.default).from(context.headers);
    let data = context.data;
    (0, $gKvUL.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("blSvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $843bf0209bc94df8$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $6YCMk = parcelRequire("6YCMk");

var $jOwpo = parcelRequire("jOwpo");

var $lcuqa = parcelRequire("lcuqa");

var $g65xr = parcelRequire("g65xr");

var $8cmY2 = parcelRequire("8cmY2");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $gKvUL.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $gKvUL.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $6YCMk.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $gKvUL.default).isObject(data);
            if (isObjectPayload && (0, $gKvUL.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $gKvUL.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $8cmY2.default)(data)) : data;
            if ((0, $gKvUL.default).isArrayBuffer(data) || (0, $gKvUL.default).isBuffer(data) || (0, $gKvUL.default).isStream(data) || (0, $gKvUL.default).isFile(data) || (0, $gKvUL.default).isBlob(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if ((0, $gKvUL.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $gKvUL.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $lcuqa.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $gKvUL.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $jOwpo.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $gKvUL.default).isResponse(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if (data && (0, $gKvUL.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $6HVMZ.default).from(e, (0, $6HVMZ.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $g65xr.default).classes.FormData,
        Blob: (0, $g65xr.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $gKvUL.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;

});
parcelRegister("6YCMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $51466d41a76e5b4b$export$2e2bcd8739ae039);
'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};

});

parcelRegister("lcuqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f250f62cadb740$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jOwpo = parcelRequire("jOwpo");

var $g65xr = parcelRequire("g65xr");
'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $jOwpo.default)(data, new (0, $g65xr.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $g65xr.default).isNode && (0, $gKvUL.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("g65xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8180acb278e187$export$2e2bcd8739ae039);

var $44xkq = parcelRequire("44xkq");

var $7pJXT = parcelRequire("7pJXT");
var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$7pJXT,
    ...(0, $44xkq.default)
};

});
parcelRegister("44xkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f71637df772b183$export$2e2bcd8739ae039);

var $9ww2p = parcelRequire("9ww2p");

var $bzEBu = parcelRequire("bzEBu");

var $7HTwA = parcelRequire("7HTwA");
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9ww2p.default,
        FormData: $bzEBu.default,
        Blob: $7HTwA.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("9ww2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eeff4490c995137$export$2e2bcd8739ae039);

var $l9LQd = parcelRequire("l9LQd");
'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $l9LQd.default);

});

parcelRegister("bzEBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d275a264afb13f$export$2e2bcd8739ae039);
'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("7HTwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c79e94740631e4$export$2e2bcd8739ae039);
'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("7pJXT", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("8cmY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8142930b3b943f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $gKvUL.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $gKvUL.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $gKvUL.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $gKvUL.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $gKvUL.default).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $gKvUL.default).isFormData(formData) && (0, $gKvUL.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $gKvUL.default).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;

});


parcelRegister("bxxyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $866cce54f6bdfb0c$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $lDriZ = parcelRequire("lDriZ");
'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $gKvUL.default).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $gKvUL.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $gKvUL.default).isString(value)) return;
    if ((0, $gKvUL.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $gKvUL.default).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $gKvUL.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $gKvUL.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $gKvUL.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $gKvUL.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $gKvUL.default).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $lDriZ.default)(header), valueOrRewrite);
        else if ((0, $gKvUL.default).isObject(header) && (0, $gKvUL.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $gKvUL.default).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $gKvUL.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $gKvUL.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $gKvUL.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $gKvUL.default).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $gKvUL.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            const key = (0, $gKvUL.default).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $gKvUL.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $gKvUL.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $gKvUL.default).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $gKvUL.default).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;

});
parcelRegister("lDriZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc026bbf9ee156f1$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $gKvUL.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("7L4QX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a60afef8b0dd173$export$2e2bcd8739ae039);
'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("dIGMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd0919e266b4fda$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $6HVMZ.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $6HVMZ.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;

});

parcelRegister("jZ6wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c8c7960873e9ee$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $5vpyF = parcelRequire("5vpyF");

var $at5cb = parcelRequire("at5cb");

var $jFSbX = parcelRequire("jFSbX");

var $6HVMZ = parcelRequire("6HVMZ");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $5vpyF.default),
    xhr: (0, $at5cb.default),
    fetch: {
        get: $jFSbX.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $gKvUL.default).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $gKvUL.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $gKvUL.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $6HVMZ.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $gKvUL.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $6HVMZ.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};

});
parcelRegister("at5cb", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f0a48d5eb7919b$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $6YCMk = parcelRequire("6YCMk");

var $6HVMZ = parcelRequire("6HVMZ");

var $dIGMp = parcelRequire("dIGMp");

var $32jg5 = parcelRequire("32jg5");

var $g65xr = parcelRequire("g65xr");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $eHGD2.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $bxxyx.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $bxxyx.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $kk0E9.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6HVMZ.default)('Request aborted', (0, $6HVMZ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $6HVMZ.default)(msg, (0, $6HVMZ.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $6YCMk.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $6HVMZ.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6HVMZ.default).ETIMEDOUT : (0, $6HVMZ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $gKvUL.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $gKvUL.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $2gEvX.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $2gEvX.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $dIGMp.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $32jg5.default)(_config.url);
        if (protocol && (0, $g65xr.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $6HVMZ.default)('Unsupported protocol ' + protocol + ':', (0, $6HVMZ.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb62d5372993dcf$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6HVMZ.default)('Request failed with status code ' + response.status, [
        (0, $6HVMZ.default).ERR_BAD_REQUEST,
        (0, $6HVMZ.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("32jg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $23607f53e4fda918$export$2e2bcd8739ae039);
'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("2gEvX", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $1a6c80b567b74091$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $1a6c80b567b74091$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $1a6c80b567b74091$export$5d35863c355a22a9);

var $6paAk = parcelRequire("6paAk");

var $dkklI = parcelRequire("dkklI");

var $gKvUL = parcelRequire("gKvUL");
const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $6paAk.default)(50, 250);
    return (0, $dkklI.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $gKvUL.default).asap(()=>fn(...args));

});
parcelRegister("6paAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9d49cd0e6b8acc$export$2e2bcd8739ae039);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;

});

parcelRegister("dkklI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3ced92bc7bdc99$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;

});


parcelRegister("eHGD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab4625fac3104691$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $889er = parcelRequire("889er");

var $8JRzs = parcelRequire("8JRzs");

var $7GD7a = parcelRequire("7GD7a");

var $lk5EI = parcelRequire("lk5EI");

var $bxxyx = parcelRequire("bxxyx");

var $cbIsf = parcelRequire("cbIsf");
var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $lk5EI.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $bxxyx.default).from(headers);
    newConfig.url = (0, $cbIsf.default)((0, $7GD7a.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $gKvUL.default).isFormData(data)) {
        if ((0, $g65xr.default).hasStandardBrowserEnv || (0, $g65xr.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $gKvUL.default).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $g65xr.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $gKvUL.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $889er.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8JRzs.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("889er", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63b558e1fb85a$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $g65xr.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $g65xr.default).origin), (0, $g65xr.default).navigator && /(msie|trident)/i.test((0, $g65xr.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("8JRzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cc14c0704b5541$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $g65xr = parcelRequire("g65xr");
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $gKvUL.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $gKvUL.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $gKvUL.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $gKvUL.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("7GD7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $598acbfafd2c63c5$export$2e2bcd8739ae039);

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $ckHwb.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $fE4ul.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("ckHwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa91c1a59edb5d9$export$2e2bcd8739ae039);
'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("fE4ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63e12c1e0b9e0be$export$2e2bcd8739ae039);
'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("lk5EI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85fda54cd977b19$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $bxxyx.default) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $gKvUL.default).isPlainObject(target) && (0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge({}, source);
        else if ((0, $gKvUL.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $gKvUL.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $gKvUL.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $gKvUL.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("jFSbX", function(module, exports) {

$parcel$export(module.exports, "getFetch", () => $e52be20a9fc15e96$export$3105c6651375d4fa);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $dLozx = parcelRequire("dLozx");

var $hhnAb = parcelRequire("hhnAb");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");

var $kk0E9 = parcelRequire("kk0E9");
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $gKvUL.default);
const $e52be20a9fc15e96$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $gKvUL.default).global);
const { ReadableStream: $e52be20a9fc15e96$var$ReadableStream, TextEncoder: $e52be20a9fc15e96$var$TextEncoder } = (0, $gKvUL.default).global;
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    env = (0, $gKvUL.default).merge.call({
        skipUndefined: true
    }, $e52be20a9fc15e96$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction($e52be20a9fc15e96$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $e52be20a9fc15e96$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $e52be20a9fc15e96$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $g65xr.default).origin, {
            body: new $e52be20a9fc15e96$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $gKvUL.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $6HVMZ.default)(`Response type '${type}' is not supported`, (0, $6HVMZ.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $gKvUL.default).isBlob(body)) return body.size;
        if ((0, $gKvUL.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $g65xr.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $gKvUL.default).isArrayBufferView(body) || (0, $gKvUL.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $gKvUL.default).isURLSearchParams(body)) body = body + '';
        if ((0, $gKvUL.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $gKvUL.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $eHGD2.default)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $dLozx.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $gKvUL.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $2gEvX.progressEventDecorator)(requestContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onUploadProgress)));
                    data = (0, $hhnAb.trackStream)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $gKvUL.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $gKvUL.default).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $2gEvX.progressEventDecorator)(responseContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onDownloadProgress), true)) || [];
                response = new Response((0, $hhnAb.trackStream)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $gKvUL.default).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $kk0E9.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $bxxyx.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $6HVMZ.default)('Network Error', (0, $6HVMZ.default).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $6HVMZ.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;

});
parcelRegister("dLozx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a052b9a6636aacdc$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $6HVMZ.default) ? err : new (0, $dIGMp.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $6HVMZ.default)(`timeout of ${timeout}ms exceeded`, (0, $6HVMZ.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $gKvUL.default).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;

});

parcelRegister("hhnAb", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $c9465135abb26626$export$b0119225647bd83);
const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("bv3QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f59389941e7907$export$2e2bcd8739ae039);

var $35BUy = parcelRequire("35BUy");

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $35BUy.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6HVMZ.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $6HVMZ.default).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $6HVMZ.default)('options must be an object', (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6HVMZ.default)('option ' + opt + ' must be ' + result, (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6HVMZ.default)('Unknown option ' + opt, (0, $6HVMZ.default).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRegister("35BUy", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $23ff3f1a5c7912d5$export$a4ad2735b021c132);
const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.13.6";

});



parcelRegister("lAKPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb81495929d8a282$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $dIGMp.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {

$parcel$export(module.exports, "default", () => $089369673aa7c1c3$export$2e2bcd8739ae039);
'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("dxy9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db8da59db12cd94$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $gKvUL.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("lnWCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f919374d785e9fb8$export$2e2bcd8739ae039);
const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;

});



parcelRegister("l19uC", function(module, exports) {

$parcel$export(module.exports, "MAX_QUESTIONS", () => $5dc958303e06c3a5$export$330d21ec90b7e2ef);
$parcel$export(module.exports, "ASSESSMENT_API_BASE", () => $5dc958303e06c3a5$export$af2a89701b90a765);
$parcel$export(module.exports, "DELEGATOR_API_BASE", () => $5dc958303e06c3a5$export$b0243658c0836e11);
$parcel$export(module.exports, "FEATURE_API_BASE", () => $5dc958303e06c3a5$export$8786beefec63af05);
$parcel$export(module.exports, "ERROR_API", () => $5dc958303e06c3a5$export$fa6bf836bb2659b);
$parcel$export(module.exports, "ERROR_API_LOCAL", () => $5dc958303e06c3a5$export$ee58649df75d2854);
$parcel$export(module.exports, "MY_PRIORITIES_APP_NAME_FRENCH", () => $5dc958303e06c3a5$export$42eb50125bc5a98);
$parcel$export(module.exports, "LOCALE_EN_US", () => $5dc958303e06c3a5$export$615418016b9d4a24);
$parcel$export(module.exports, "LOCALE_EN_CA", () => $5dc958303e06c3a5$export$4e5fea1559848799);
$parcel$export(module.exports, "LOCALE_FR_CA", () => $5dc958303e06c3a5$export$2c4b1b66f1c84842);
const $5dc958303e06c3a5$export$330d21ec90b7e2ef = 26;
const $5dc958303e06c3a5$export$af2a89701b90a765 = `/api/mp-assessment/`;
const $5dc958303e06c3a5$export$4e4fe6cfe3a48f5b = `http://localhost:8081/mp-assessment/`;
const $5dc958303e06c3a5$export$b0243658c0836e11 = `/api/prp-delegator/mp/`;
const $5dc958303e06c3a5$export$e131fede3339cfe = `http://localhost:8080/prp-delegator/mp/`;
const $5dc958303e06c3a5$export$8786beefec63af05 = '/api/prp-feature';
const $5dc958303e06c3a5$export$e6ca75cc42a0f843 = 'http://localhost:8082/prp-feature';
const $5dc958303e06c3a5$export$fa6bf836bb2659b = '/api/prp-delegator/notify/avi';
const $5dc958303e06c3a5$export$ee58649df75d2854 = 'http://localhost:8080/prp-delegator/notify/avi';
const $5dc958303e06c3a5$export$42eb50125bc5a98 = 'mespriorites';
const $5dc958303e06c3a5$export$615418016b9d4a24 = 'en_US';
const $5dc958303e06c3a5$export$4e5fea1559848799 = 'en_CA';
const $5dc958303e06c3a5$export$2c4b1b66f1c84842 = 'fr_CA';

});



parcelRegister("cDDaL", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e5876c3a6340fc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $gfQkH = parcelRequire("gfQkH");

var $7lk71 = parcelRequire("7lk71");

var $1ovHo = parcelRequire("1ovHo");

var $fKxvO = parcelRequire("fKxvO");

var $iJxY6 = parcelRequire("iJxY6");

var $tL0U5 = parcelRequire("tL0U5");

var $l19uC = parcelRequire("l19uC");

var $9Ryut = parcelRequire("9Ryut");

var $fUEMe = parcelRequire("fUEMe");


var $2DcdH = parcelRequire("2DcdH");

var $RXYi2 = parcelRequire("RXYi2");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
const $15e5876c3a6340fc$var$FPQuiz = (props)=>{
    const { initialValuePair: initialValuePair, valueList: valueList, finalResultsCallBack: finalResultsCallBack, errorPageCallback: errorPageCallback } = props;
    const { dataLayerInfo: dataLayerInfo } = (0, $RXYi2.useDataLayerInfo)();
    const [questionNumber, setQuestionNumber] = (0, $acw62.useState)(0);
    const [firstValue, setFirstValue] = (0, $acw62.useState)(initialValuePair[0]);
    const [secondValue, setSecondValue] = (0, $acw62.useState)(initialValuePair[1]);
    const [allPairsIndex, setAllPairsIndex] = (0, $acw62.useState)([]);
    const [allChoicesIndex, setallChoicesIndex] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const progress = Math.round(questionNumber * 100 / $l19uC.MAX_QUESTIONS);
    const firstValueCard = (0, $acw62.useRef)();
    const topOfQuiz = (0, $acw62.useRef)();
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    function removeFocus() {
        const heading = document.getElementById('heading-no-focus');
        heading.removeAttribute('tabIndex');
    }
    (0, $acw62.useEffect)(()=>{
        if (firstValueCard.current && valueList.filter((value)=>value.statementId === firstValue.statementId).length > 0) firstValueCard.current.focus();
    }, [
        firstValue,
        secondValue
    ]);
    (0, $acw62.useEffect)(()=>{
        setFirstValue(initialValuePair[0]);
        setSecondValue(initialValuePair[1]);
        setAllPairsIndex([
            [
                initialValuePair[0].indexId,
                initialValuePair[1].indexId
            ]
        ]);
    }, [
        initialValuePair
    ]);
    const updatedDataLayerInfo = {
        ...dataLayerInfo,
        page_type: "quiz-page"
    };
    const { setPreviousPath: setPreviousPath, previousPath: previousPath } = (0, $2DcdH.usePreviousPath)();
    const currentLocation = (0, $aphAM.useLocation)();
    const pageTitle = (0, $iJxY6.default)(locId, 'pageTitle', 'quizPage');
    const pageReferrer = previousPath ? `${window.location.origin}${previousPath}${currentLocation.search}` : undefined;
    const pageURL = `${window.location.origin}${currentLocation.pathname}${currentLocation.search}`;
    const virtualPageInfo = {
        'pagePath': currentLocation.pathname,
        'pageTitle': pageTitle,
        'page_referrer': pageReferrer,
        'external_referrer': window.document.referrer && window.document.referrer.trim() !== '' ? window.document.referrer : undefined,
        'page_url': pageURL
    };
    (0, $acw62.useEffect)(()=>{
        setPreviousPath(currentLocation.pathname);
        (0, $fUEMe.default)("dataLayer-initialized", updatedDataLayerInfo);
        (0, $fUEMe.default)('VirtualPageview', virtualPageInfo);
        setAllPairsIndex([
            [
                initialValuePair[0].indexId,
                initialValuePair[1].indexId
            ]
        ]);
        if (typeof topOfQuiz.current !== 'undefined') topOfQuiz.current.focus();
        setTimeout(removeFocus, 1000);
        document.title = pageTitle;
    }, []);
    function getValueFromIndex(index) {
        return valueList.filter((value)=>value.indexId === index)[0];
    }
    function userSelection(winner, loser) {
        setIsLoading(true);
        setallChoicesIndex(()=>allChoicesIndex.concat([
                [
                    winner.indexId,
                    loser.indexId
                ]
            ]));
        (0, $fUEMe.default)('next-selection', {});
        const data = JSON.stringify(allChoicesIndex.concat([
            [
                winner.indexId,
                loser.indexId
            ]
        ]));
        (0, $tL0U5.getNextPair)(data).then((res)=>{
            if (res.valuePair) {
                setFirstValue(getValueFromIndex(res.valuePair[0]));
                setSecondValue(getValueFromIndex(res.valuePair[1]));
                setAllPairsIndex(()=>allPairsIndex.concat([
                        res.valuePair
                    ]));
                setQuestionNumber(questionNumber + 1);
                setIsLoading(false);
            }
            if (questionNumber === $l19uC.MAX_QUESTIONS - 1) {
                setIsLoading(false);
                finalResultsCallBack(res.rankedList);
            }
        }).catch((error)=>{
            if (error.response && error.response.status === 403) (0, $tL0U5.handleAVIError)(error, locId);
            errorPageCallback();
        });
    }
    function handleBackClick() {
        const tempValuePairs = allPairsIndex;
        const tempChoices = allChoicesIndex;
        tempValuePairs.pop();
        tempChoices.pop();
        setAllPairsIndex(tempValuePairs);
        setallChoicesIndex(tempChoices);
        setQuestionNumber(questionNumber - 1);
        setFirstValue(getValueFromIndex(tempValuePairs[tempValuePairs.length - 1][0]));
        setSecondValue(getValueFromIndex(tempValuePairs[tempValuePairs.length - 1][1]));
        if (typeof firstValueCard.current !== 'undefined') firstValueCard.current.focus();
        (0, $fUEMe.default)('previous-selection', {});
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "fpQuizPage",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "title-tooltip-container",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        id: "heading-no-focus",
                                        className: "heading--semi-bold",
                                        ref: topOfQuiz,
                                        tabIndex: -1,
                                        "data-testid": "header-fp",
                                        children: (0, $iJxY6.default)(locId, 'header', 'quizPage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "quiz-tooltip",
                                        "data-testid": "quiz-tooltip-fp",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.InfoTooltip), {
                                            title: "",
                                            placement: "below",
                                            align: "right",
                                            children: (0, $iJxY6.default)(locId, 'tooltipDescription', 'quizPage')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "quiz-instructions",
                                "data-testid": "quiz-instructions-fp",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: (0, $iJxY6.default)(locId, 'chooseOneBoldText', 'quizPage')
                                    }),
                                    (0, $iJxY6.default)(locId, 'goWithText', 'quizPage')
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                "aria-live": "polite",
                                className: "progress-bar-container",
                                "data-testid": "progress-bar-fp",
                                "aria-label": (0, $iJxY6.default)(locId, 'progressBarAriaLabel', 'quizPage').replace('%QUESTION_NUMBER%', `${questionNumber + 1}`).replace('%MAX_QUESTIONS%', `${$l19uC.MAX_QUESTIONS}`),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gfQkH.default), {
                                    animated: true,
                                    now: progress,
                                    "aria-hidden": true
                                })
                            })
                        ]
                    }),
                    valueList.filter((value)=>value.statementId === firstValue.statementId).length > 0 && valueList.filter((value)=>value.statementId === secondValue.statementId).length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "cards-container",
                        "data-testid": "cards-container-fp",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                "aria-label": (0, $iJxY6.default)(locId, 'ariaLabelChoiceNumberOne', 'quizPage') + (0, $fKxvO.default)(firstValue.statementId, valueList),
                                className: !isLoading ? 'value-card-1-fp' : 'value-card-1-fp vc-loading',
                                ref: firstValueCard,
                                onClick: ()=>!isLoading && userSelection(firstValue, secondValue),
                                "data-testid": "vc1-test-fp",
                                id: "value-card-one-fp",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ovHo.default), {
                                    valueStatement: (0, $fKxvO.default)(firstValue.statementId, valueList),
                                    valueStatementId: firstValue.statementId,
                                    isLoading: isLoading
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                "aria-label": (0, $iJxY6.default)(locId, 'ariaLabelChoiceNumberTwo', 'quizPage') + (0, $fKxvO.default)(secondValue.statementId, valueList),
                                className: !isLoading ? 'value-card-2-fp' : 'value-card-2-fp vc-loading',
                                onClick: ()=>!isLoading && userSelection(secondValue, firstValue),
                                "data-testid": "vc2-test-fp",
                                id: "value-card-two-fp",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ovHo.default), {
                                    valueStatement: (0, $fKxvO.default)(secondValue.statementId, valueList),
                                    valueStatementId: secondValue.statementId,
                                    isLoading: isLoading
                                })
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "backBtn",
                        "data-testid": "back-btn-fp",
                        children: questionNumber > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                            onClick: ()=>handleBackClick(),
                            icon: "chevron-left",
                            label: (0, $iJxY6.default)(locId, 'changePreviousAnswerButtonLabel', 'quizPage'),
                            styleVariant: "tertiary",
                            attributes: {
                                value: '',
                                'data-testid': 'backBtn',
                                id: 'change-previous-button'
                            },
                            "aria-label": (0, $iJxY6.default)(locId, 'changePreviousAnswerAriaLabel', 'quizPage')
                        }) : null
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "footer",
                "data-testid": "footer-fp",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "disclaimer",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "microcopy--2",
                        children: (0, $iJxY6.default)(locId, 'quizPageDisclosure', 'quizPage')
                    })
                })
            })
        ]
    });
};
$15e5876c3a6340fc$var$FPQuiz.propTypes = {
    initialValuePair: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    valueList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    finalResultsCallBack: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    errorPageCallback: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $15e5876c3a6340fc$export$2e2bcd8739ae039 = $15e5876c3a6340fc$var$FPQuiz;

});
parcelRegister("1ovHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $55afc8c0f303cf99$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");


var $fUEMe = parcelRequire("fUEMe");

var $9TzF7 = parcelRequire("9TzF7");

var $9Ryut = parcelRequire("9Ryut");

var $iJxY6 = parcelRequire("iJxY6");

var $bxZTw = parcelRequire("bxZTw");

var $7mmdw = parcelRequire("7mmdw");

var $kMrYv = parcelRequire("kMrYv");
const $55afc8c0f303cf99$var$ValueCardFP = (props)=>{
    const { valueStatement: valueStatement, valueStatementId: valueStatementId, learnMoreContent: learnMoreContent, learnMoreLinks: learnMoreLinks, isLoading: isLoading, displayLearnMoreButton: displayLearnMoreButton, rank: rank, disabled: disabled, cardClassName: cardClassName, setCardClassName: setCardClassName, setShowAdditionalInfoModal: setShowAdditionalInfoModal, setShowCustomPriorityEditModal: setShowCustomPriorityEditModal, isEditable: isEditable, setEditModalCurrentCardValue: setEditModalCurrentCardValue, infoModalContent: infoModalContent, setInfoModalContent: setInfoModalContent } = props;
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const userPersona = (0, $acw62.useContext)((0, $7mmdw.default));
    const [displayLearnMoreContent, setDisplayLearnMoreContent] = (0, $acw62.useState)(false);
    const SPACE = ' ';
    const ENTER = 'Enter';
    const ESCAPE = 'Escape';
    const personaTypeArrayUS = Array.of((0, $kMrYv.default).WORD_POWER, (0, $kMrYv.default).NEWS_LETTER, (0, $kMrYv.default).PERSONAL_LINK, (0, $kMrYv.default).PERSONAL_LINK_FA_PROFILE, (0, $kMrYv.default).FINANCIAL_FOUNDATION, (0, $kMrYv.default).DIRECT_URL);
    (0, $acw62.useEffect)(()=>{
        if (displayLearnMoreContent) setCardClassName('value-card-fp value-card-disabled');
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!displayLearnMoreContent) document.body.classList.remove('verification-multi-modal');
    }, [
        displayLearnMoreContent
    ]);
    const learnMoreClickHandler = ()=>{
        (0, $fUEMe.default)('learn-more-content', {});
        setDisplayLearnMoreContent(true);
        document.body.classList.add('verification-multi-modal');
    };
    const learnMoreKeyDownHandler = (e)=>{
        if (e.key === ENTER || e.key === SPACE) {
            (0, $fUEMe.default)('learn-more-content', {});
            setDisplayLearnMoreContent(true);
            document.body.classList.add('verification-multi-modal');
        }
        if (e.key === ESCAPE) setDisplayLearnMoreContent(false);
    };
    const valueCardInfoOnClickHandler = ()=>{
        if (isEditable) setInfoModalContent((0, $iJxY6.default)(locId, 'customPriorityInfoModalTitle', 'customizePage'));
        else setInfoModalContent(infoModalContent);
        setShowAdditionalInfoModal(true);
    };
    const valueCardInfoKeyDownHandler = (e)=>{
        if (e.key === ENTER || e.key === SPACE) {
            if (isEditable) setInfoModalContent((0, $iJxY6.default)(locId, 'customPriorityInfoModalTitle', 'customizePage'));
            else setInfoModalContent(infoModalContent);
            setShowAdditionalInfoModal(true);
        }
        if (e.key === ESCAPE) setShowAdditionalInfoModal(false);
    };
    const valueEditOnClickHandler = ()=>{
        setEditModalCurrentCardValue({
            statementId: valueStatementId,
            statementText: valueStatement
        });
        setShowCustomPriorityEditModal(true);
    };
    const valueEditKeyDownHandler = (e)=>{
        if (e.key === ENTER || e.key === SPACE) {
            setEditModalCurrentCardValue({
                statementId: valueStatementId,
                statementText: valueStatement
            });
            setShowCustomPriorityEditModal(true);
        }
        if (e.key === ESCAPE) setShowCustomPriorityEditModal(false);
    };
    if (!isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: cardClassName,
        "data-testid": `valueCardFP-${valueStatementId}`,
        children: [
            rank ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "value-rank-fp",
                "aria-hidden": "true",
                children: rank
            }) : null,
            !personaTypeArrayUS.includes(userPersona) && (isEditable || infoModalContent) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "button",
                className: "value-additional-info-button",
                tabIndex: 0,
                onClick: (e)=>{
                    e.stopPropagation();
                    valueCardInfoOnClickHandler();
                },
                onKeyDown: (e)=>{
                    e.stopPropagation();
                    valueCardInfoKeyDownHandler(e);
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "value-edit-info--icon--custom-size",
                    "data-testid": `value-additional-info-button-${valueStatementId}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Icon), {
                        name: "help-question-mark"
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: isEditable ? 'value-edit-img-fp' : 'value-image-fp',
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: $bxZTw[`${valueStatementId}`],
                    alt: "",
                    role: "presentation"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-container-fp",
                children: [
                    isEditable ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        role: "button",
                        className: "value-edit-statement-fp",
                        "aria-hidden": "true",
                        tabIndex: 0,
                        onClick: (e)=>{
                            e.stopPropagation();
                            valueEditOnClickHandler();
                        },
                        onKeyDown: (e)=>{
                            e.stopPropagation();
                            valueEditKeyDownHandler(e);
                        },
                        children: valueStatement
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "value-statement-fp",
                        children: valueStatement
                    }),
                    displayLearnMoreButton ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        role: "button",
                        className: "learn-more-button-fp",
                        tabIndex: -1,
                        onClick: ()=>{
                            learnMoreClickHandler();
                        },
                        onKeyDown: (e)=>{
                            learnMoreKeyDownHandler(e);
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: (0, $iJxY6.default)(locId, 'learnMoreButton', 'resultsPage')
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TzF7.default), {
                displayLearnMoreContent: displayLearnMoreContent,
                setDisplayLearnMoreContent: setDisplayLearnMoreContent,
                learnMoreContent: learnMoreContent,
                learnMoreLinks: learnMoreLinks,
                valueStatement: valueStatement,
                valueStatementId: valueStatementId,
                rank: rank
            }),
            disabled || displayLearnMoreContent ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "value-card-disabledBox"
            }) : null
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "value-card-fp"
    });
};
$55afc8c0f303cf99$var$ValueCardFP.defaultProps = {
    rank: null,
    isLoading: false,
    displayLearnMoreButton: false,
    disabled: false,
    learnMoreContent: null,
    cardClassName: 'value-card-fp',
    setCardClassName: null,
    learnMoreLinks: null,
    setShowAdditionalInfoModal: null,
    setShowCustomPriorityEditModal: null,
    isEditable: false,
    setEditModalCurrentCardValue: null,
    infoModalContent: null,
    setInfoModalContent: null
};
$55afc8c0f303cf99$var$ValueCardFP.propTypes = {
    valueStatement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    valueStatementId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    setCardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    learnMoreLinks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    learnMoreContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    displayLearnMoreButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    rank: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setShowAdditionalInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    setShowCustomPriorityEditModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isEditable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    setEditModalCurrentCardValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    infoModalContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setInfoModalContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $55afc8c0f303cf99$export$2e2bcd8739ae039 = $55afc8c0f303cf99$var$ValueCardFP;

});
parcelRegister("bxZTw", function(module, exports) {

var $7X35N = parcelRequire("7X35N");

var $dlmpu = parcelRequire("dlmpu");

var $7ODq2 = parcelRequire("7ODq2");

var $428EK = parcelRequire("428EK");

var $2AuuH = parcelRequire("2AuuH");

var $d9Yau = parcelRequire("d9Yau");

var $fTRLW = parcelRequire("fTRLW");

var $cQnS8 = parcelRequire("cQnS8");

var $57Z8j = parcelRequire("57Z8j");

var $jBAlZ = parcelRequire("jBAlZ");

var $emiSf = parcelRequire("emiSf");

var $03Vb0 = parcelRequire("03Vb0");

var $kOcb8 = parcelRequire("kOcb8");

var $ar2KL = parcelRequire("ar2KL");

var $hSA0Q = parcelRequire("hSA0Q");

var $a96nb = parcelRequire("a96nb");

var $exbDH = parcelRequire("exbDH");
module.exports = {
    "0": $7X35N,
    "1": $dlmpu,
    "2": $7ODq2,
    "3": $428EK,
    "4": $2AuuH,
    "5": $d9Yau,
    "6": $fTRLW,
    "7": $cQnS8,
    "8": $57Z8j,
    "9": $jBAlZ,
    "10": $emiSf,
    "11": $03Vb0,
    "12": $kOcb8,
    "13": $ar2KL,
    "14": $hSA0Q,
    "15": $a96nb,
    "dnd-icon": $exbDH
};

});
parcelRegister("7X35N", function(module, exports) {
module.exports = $parcel$resolve("jTbp6");

});

parcelRegister("dlmpu", function(module, exports) {
module.exports = $parcel$resolve("4VsGu");

});

parcelRegister("7ODq2", function(module, exports) {
module.exports = $parcel$resolve("cMm2I");

});

parcelRegister("428EK", function(module, exports) {
module.exports = $parcel$resolve("2prqY");

});

parcelRegister("2AuuH", function(module, exports) {
module.exports = $parcel$resolve("jrm6c");

});

parcelRegister("d9Yau", function(module, exports) {
module.exports = $parcel$resolve("80mqb");

});

parcelRegister("fTRLW", function(module, exports) {
module.exports = $parcel$resolve("jOIzf");

});

parcelRegister("cQnS8", function(module, exports) {
module.exports = $parcel$resolve("5ZfJZ");

});

parcelRegister("57Z8j", function(module, exports) {
module.exports = $parcel$resolve("h6teb");

});

parcelRegister("jBAlZ", function(module, exports) {
module.exports = $parcel$resolve("kE3p8");

});

parcelRegister("emiSf", function(module, exports) {
module.exports = $parcel$resolve("5YJAF");

});

parcelRegister("03Vb0", function(module, exports) {
module.exports = $parcel$resolve("8kCQJ");

});

parcelRegister("kOcb8", function(module, exports) {
module.exports = $parcel$resolve("gW96p");

});

parcelRegister("ar2KL", function(module, exports) {
module.exports = $parcel$resolve("9eLnP");

});

parcelRegister("hSA0Q", function(module, exports) {
module.exports = $parcel$resolve("2w91T");

});

parcelRegister("a96nb", function(module, exports) {
module.exports = $parcel$resolve("EuxKH");

});

parcelRegister("exbDH", function(module, exports) {
module.exports = $parcel$resolve("5unre");

});




parcelRegister("atdSF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8574c3c5787d0658$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");

var $4dB0L = parcelRequire("4dB0L");

var $9ze7e = parcelRequire("9ze7e");

var $iJxY6 = parcelRequire("iJxY6");

var $9Ryut = parcelRequire("9Ryut");


var $3qYM8 = parcelRequire("3qYM8");

var $fUEMe = parcelRequire("fUEMe");

var $8Mm3X = parcelRequire("8Mm3X");

var $iw8KV = parcelRequire("iw8KV");

var $devjf = parcelRequire("devjf");

var $2DcdH = parcelRequire("2DcdH");

var $RXYi2 = parcelRequire("RXYi2");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
const $8574c3c5787d0658$var$CustomizePage = (props)=>{
    const { dataLayerInfo: dataLayerInfo } = (0, $RXYi2.useDataLayerInfo)();
    const { valueList: valueList, setInitialValuePair: setInitialValuePair, customizePageBtnCallback: customizePageBtnCallback, restart: restart, isLoading: isLoading } = props;
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const [isMobile, setIsMobile] = (0, $acw62.useState)(false);
    const [startQuizLabel, setStartQuizLabel] = (0, $acw62.useState)((0, $iJxY6.default)(locId, 'disabledBtnDefault', 'customizePage'));
    const [quizDisabled, setQuizDisabled] = (0, $acw62.useState)(true);
    const [localValuesList, setLocalValuesList] = (0, $acw62.useState)([]);
    const [numValuesToRemove, setNumValuesToRemove] = (0, $acw62.useState)(5);
    const [showWhyElevenPrioritiesInfoModal, setShowWhyElevenPrioritiesInfoModal] = (0, $acw62.useState)(false);
    const [showAdditionalInfoModal, setShowAdditionalInfoModal] = (0, $acw62.useState)(false);
    const [showCustomPriorityEditModal, setShowCustomPriorityEditModal] = (0, $acw62.useState)(false);
    const [editModalCurrentCardValue, setEditModalCurrentCardValue] = (0, $acw62.useState)({
        statementId: -1,
        statementText: ''
    });
    const writeInStatementId = 15;
    const maximumPhoneWidth = 768;
    const SPACE = ' ';
    const ENTER = 'Enter';
    const [infoModalContent, setInfoModalContent] = (0, $acw62.useState)('');
    const handleMobileView = ()=>setIsMobile(window.innerWidth < maximumPhoneWidth);
    const updatedFaInfo = {
        ...dataLayerInfo,
        page_type: 'customize-page'
    };
    const { setPreviousPath: setPreviousPath, previousPath: previousPath } = (0, $2DcdH.usePreviousPath)();
    const currentLocation = (0, $aphAM.useLocation)();
    const pageTitle = (0, $iJxY6.default)(locId, 'pageTitle', 'customizePage');
    const pageReferrer = previousPath ? `${window.location.origin}${previousPath}${currentLocation.search}` : undefined;
    const pageURL = `${window.location.origin}${currentLocation.pathname}${currentLocation.search}`;
    const virtualPageInfo = {
        'pagePath': currentLocation.pathname,
        'pageTitle': pageTitle,
        'page_referrer': pageReferrer,
        'external_referrer': window.document.referrer && window.document.referrer.trim() !== '' ? window.document.referrer : undefined,
        'page_url': pageURL
    };
    (0, $acw62.useEffect)(()=>{
        document.title = pageTitle;
        handleMobileView();
        window.removeEventListener('resize', handleMobileView);
        window.addEventListener('resize', handleMobileView);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (valueList.length > 0 && valueList[0]) {
            setPreviousPath(currentLocation.pathname);
            (0, $fUEMe.default)("dataLayer-initialized", updatedFaInfo);
            (0, $fUEMe.default)('VirtualPageview', virtualPageInfo);
            let tempValueList;
            if (!restart) tempValueList = (0, $iw8KV.sortValueList)(valueList.map((value)=>{
                return {
                    statementId: value.statementId,
                    statementRank: value.statementRank,
                    statementText: value.statementText,
                    learnMoreContent: value.learnMoreContent,
                    learnMoreLinks: value.learnMoreLinks,
                    isActive: true,
                    indexId: value.indexId,
                    additionalInfo: value.additionalInfo
                };
            }));
            else {
                tempValueList = (0, $iw8KV.sortValueList)(valueList);
                setNumValuesToRemove(0);
            }
            setLocalValuesList(tempValueList);
        }
    }, [
        valueList
    ]);
    (0, $acw62.useEffect)(()=>{
        if (numValuesToRemove > 0) {
            setStartQuizLabel(`${(0, $iJxY6.default)(locId, 'disabledBtnRemove', 'customizePage')} ${numValuesToRemove} ${(0, $iJxY6.default)(locId, 'disabledBtnMore', 'customizePage')}`);
            setQuizDisabled(true);
        } else if (numValuesToRemove < 0) {
            setStartQuizLabel(`${(0, $iJxY6.default)(locId, 'disabledBtnAdd', 'customizePage')} ${Math.abs(numValuesToRemove)} ${(0, $iJxY6.default)(locId, 'disabledBtnMore', 'customizePage')}`);
            setQuizDisabled(true);
        } else {
            setStartQuizLabel((0, $iJxY6.default)(locId, 'startQuiz', 'customizePage'));
            setQuizDisabled(false);
        }
    }, [
        numValuesToRemove
    ]);
    (0, $acw62.useEffect)(()=>{
        if (localValuesList.length > 0 && localValuesList[0]) {
            const newLocalValuesList = localValuesList.map((value)=>{
                if (value.statementId === editModalCurrentCardValue.statementId) return {
                    ...value,
                    statementText: editModalCurrentCardValue.statementText
                };
                return value;
            });
            setLocalValuesList(newLocalValuesList);
        }
    }, [
        editModalCurrentCardValue
    ]);
    function handleCardClick(valueId) {
        setLocalValuesList(localValuesList.map((value)=>{
            if (value.statementId === valueId) {
                // If currently active, reduce numsValueToRemove since it will be switched to disabled
                setNumValuesToRemove(value.isActive ? numValuesToRemove - 1 : numValuesToRemove + 1);
                return {
                    statementId: value.statementId,
                    statementRank: value.statementRank,
                    statementText: value.statementText,
                    learnMoreContent: value.learnMoreContent,
                    learnMoreLinks: value.learnMoreLinks,
                    isActive: !value.isActive,
                    indexId: value.indexId,
                    additionalInfo: value.additionalInfo
                };
            }
            return value;
        }));
    }
    function finalizeValueSelections() {
        let indexNum = 0;
        const finalValuesList = Array.from(localValuesList);
        finalValuesList.forEach((value, index)=>{
            if (value.isActive) {
                finalValuesList[index].indexId = indexNum;
                indexNum += 1;
            } else finalValuesList[index].indexId = -1;
        });
        setInitialValuePair(finalValuesList);
        return finalValuesList;
    }
    const mapValuesToCustomizeCards = ()=>{
        return localValuesList.map((value)=>{
            return value ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "CustomizePage_card",
                role: "button",
                onClick: ()=>handleCardClick(value.statementId),
                onKeyDown: (e)=>{
                    if (e.key === ENTER || e.key === SPACE) {
                        e.preventDefault();
                        handleCardClick(value.statementId);
                    }
                },
                tabIndex: 0,
                "aria-pressed": value.isActive,
                "data-testid": `valueCardContainer-${value.statementId}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ze7e.default), {
                    valueStatement: value.statementText,
                    valueStatementId: value.statementId,
                    disabled: !value.isActive,
                    setShowAdditionalInfoModal: setShowAdditionalInfoModal,
                    setShowCustomPriorityEditModal: setShowCustomPriorityEditModal,
                    isEditable: value.statementId === writeInStatementId,
                    setEditModalCurrentCardValue: setEditModalCurrentCardValue,
                    infoModalContent: value.additionalInfo,
                    setInfoModalContent: setInfoModalContent
                })
            }, value.statementId) : null;
        });
    };
    const mapValuesToCustomizeRows = ()=>{
        return localValuesList.map((value)=>{
            return value ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "CustomizePage_row",
                role: "button",
                onClick: (e)=>{
                    e.preventDefault();
                    handleCardClick(value.statementId);
                },
                onKeyDown: (e)=>{
                    e.stopPropagation();
                    if (e.key === ENTER || e.key === SPACE) {
                        e.preventDefault();
                        handleCardClick(value.statementId);
                    }
                },
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $devjf.default), {
                    valueStatement: value.statementText,
                    valueStatementId: value.statementId,
                    disabled: !value.isActive,
                    setShowAdditionalInfoModal: setShowAdditionalInfoModal,
                    setShowCustomPriorityEditModal: setShowCustomPriorityEditModal,
                    isEditable: value.statementId === writeInStatementId,
                    setEditModalCurrentCardValue: setEditModalCurrentCardValue,
                    infoModalContent: value.additionalInfo,
                    setInfoModalContent: setInfoModalContent
                })
            }, value.statementId) : null;
        });
    };
    const doesValuesListContainInvalidWriteInValue = ()=>{
        const writeInPriority = localValuesList.find((value)=>value.statementId === writeInStatementId);
        return writeInPriority && writeInPriority.isActive && (!writeInPriority.statementText || writeInPriority.statementText.toLowerCase() === (0, $iJxY6.default)(locId, 'writeInPlaceHolderText', 'customizePage'));
    };
    const handleStartBtnClick = ()=>{
        if (!doesValuesListContainInvalidWriteInValue()) {
            (0, $fUEMe.default)('get-started-customize-page', {});
            window.removeEventListener('resize', handleMobileView);
            customizePageBtnCallback(finalizeValueSelections());
        } else {
            const writeInPriority = localValuesList.find((value)=>value.statementId === writeInStatementId);
            setEditModalCurrentCardValue({
                statementId: writeInPriority.statementId,
                statementText: writeInPriority.statementText
            });
            setShowCustomPriorityEditModal(true);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "CustomizePage",
        "data-testid": "customize-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "CustomizePage_content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "CustomizePage_intro",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                id: "heading-no-focus",
                                className: "heading--semi-bold",
                                children: (0, $iJxY6.default)(locId, 'header', 'customizePage')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "CustomizePage_headerDesc",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "CustomizePage_p",
                                        children: (0, $iJxY6.default)(locId, 'description', 'customizePage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                                        label: (0, $iJxY6.default)(locId, 'iconButton', 'customizePage'),
                                        icon: "help-question-mark",
                                        styleVariant: "tertiary",
                                        onClick: ()=>{
                                            setShowWhyElevenPrioritiesInfoModal(true);
                                        },
                                        attributes: {
                                            value: '',
                                            id: 'modal-icon-button'
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "CustomizePage_btnContainer",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-live": "polite",
                                "aria-relevant": "text",
                                "aria-atomic": "true",
                                className: "CustomizePage_visually-hidden",
                                children: startQuizLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                                label: startQuizLabel,
                                disabled: quizDisabled,
                                onClick: ()=>handleStartBtnClick(),
                                attributes: {
                                    value: '',
                                    id: 'get-started-button'
                                }
                            })
                        ]
                    }),
                    isMobile ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "CustomizePage_rowsListContainer",
                                children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    id: "spinner",
                                    "data-testid": "customize-spinner",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dB0L.default), {
                                        animation: "border"
                                    })
                                }) : mapValuesToCustomizeRows()
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "CustomizePage_btnContainer",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                                    label: startQuizLabel,
                                    disabled: quizDisabled,
                                    onClick: ()=>handleStartBtnClick(),
                                    attributes: {
                                        value: '',
                                        id: 'get-started-button'
                                    }
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "CustomizePage_cardsContainer",
                        children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            id: "spinner",
                            "data-testid": "customize-spinner",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dB0L.default), {
                                animation: "border"
                            })
                        }) : mapValuesToCustomizeCards()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3qYM8.default), {
                        displayModal: showWhyElevenPrioritiesInfoModal,
                        closeModalHandler: ()=>setShowWhyElevenPrioritiesInfoModal(false),
                        headerText: (0, $iJxY6.default)(locId, 'modalTitle', 'customizePage'),
                        paragraphText1: (0, $iJxY6.default)(locId, 'modalParagraph1', 'customizePage'),
                        paragraphText2: (0, $iJxY6.default)(locId, 'modalParagraph2', 'customizePage')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3qYM8.default), {
                        displayModal: showAdditionalInfoModal,
                        closeModalHandler: ()=>setShowAdditionalInfoModal(false),
                        headerText: infoModalContent
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8Mm3X.default), {
                        currentCardValue: editModalCurrentCardValue,
                        setCurrentCardValue: setEditModalCurrentCardValue,
                        showModal: showCustomPriorityEditModal,
                        closeModalHandler: ()=>setShowCustomPriorityEditModal(false)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "footer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "disclaimer",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "microcopy--2",
                        children: (0, $iJxY6.default)(locId, 'welcomePageDisclosure', 'welcomePage')
                    })
                })
            })
        ]
    });
};
$8574c3c5787d0658$var$CustomizePage.propTypes = {
    valueList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        statementId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        statementText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        statementRank: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        isActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        indexId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    })).isRequired,
    setInitialValuePair: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    customizePageBtnCallback: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    restart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};
var $8574c3c5787d0658$export$2e2bcd8739ae039 = $8574c3c5787d0658$var$CustomizePage;

});
parcelRegister("8Mm3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd06aa503614bfa1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");


var $9Ryut = parcelRequire("9Ryut");

var $iJxY6 = parcelRequire("iJxY6");
const $cd06aa503614bfa1$var$WriteInModal = ({ currentCardValue: currentCardValue, setCurrentCardValue: setCurrentCardValue, showModal: showModal, closeModalHandler: closeModalHandler })=>{
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const MAX_LENGTH = 40;
    const [writeInValueError, setWriteInValueError] = (0, $acw62.useState)(null);
    const [localWriteInValueText, setLocalWriteInValueText] = (0, $acw62.useState)('');
    const [subText, setSubText] = (0, $acw62.useState)((0, $iJxY6.default)(locId, 'modalSubTextOne', 'writeInModal').replace('%MAX_LENGTH%', MAX_LENGTH.toString()));
    const [charsLeft, setCharsLeft] = (0, $acw62.useState)(MAX_LENGTH);
    const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = (0, $acw62.useState)(false);
    const writeInValueRegex = /^[a-zA-ZÀ-ÿ'’«»\s-]*$/;
    // this regex will match strings that contain all white spaces (space, tab, etc.)
    const whiteSpaceRegex = /^\s*$/;
    const invalidWriteInValue = (0, $iJxY6.default)(locId, 'modalTextValueError', 'writeInModal');
    const missingWriteInValue = (0, $iJxY6.default)(locId, 'modalMissingTextValueError', 'writeInModal');
    const validateForm = ()=>{
        let isValid = true;
        if (localWriteInValueText.length === 0 || whiteSpaceRegex.test(localWriteInValueText)) {
            setWriteInValueError(missingWriteInValue);
            setIsSubmitButtonDisabled(true);
            isValid = false;
        }
        setLocalWriteInValueText(localWriteInValueText.trim());
        return isValid;
    };
    const submitButtonHandler = ()=>{
        if (!writeInValueError && validateForm()) {
            closeModalHandler();
            setCurrentCardValue({
                ...currentCardValue,
                statementText: localWriteInValueText
            });
        }
    };
    const validateWriteInValue = (text)=>{
        if (text.length === 0 || whiteSpaceRegex.test(text)) {
            setIsSubmitButtonDisabled(true);
            setWriteInValueError(missingWriteInValue);
        } else if (!writeInValueRegex.test(text)) {
            setIsSubmitButtonDisabled(true);
            setWriteInValueError(invalidWriteInValue);
        } else {
            setIsSubmitButtonDisabled(false);
            setLocalWriteInValueText(text.trim());
            setWriteInValueError(null);
        }
    };
    const writeInValueHandler = (text)=>{
        validateWriteInValue(text);
        setLocalWriteInValueText(text);
        setCharsLeft(MAX_LENGTH - text.length);
    };
    const buttons = [
        {
            text: (0, $iJxY6.default)(locId, 'cancelButton', 'writeInModal'),
            onClick: ()=>closeModalHandler(),
            styleVariant: 'secondary'
        },
        {
            text: (0, $iJxY6.default)(locId, 'submitButton', 'writeInModal'),
            onClick: ()=>submitButtonHandler(),
            styleVariant: 'primary',
            disabled: isSubmitButtonDisabled
        }
    ];
    (0, $acw62.useEffect)(()=>{
        if (charsLeft === MAX_LENGTH) setSubText((0, $iJxY6.default)(locId, 'modalSubTextOne', 'writeInModal').replace('%MAX_LENGTH%', MAX_LENGTH.toString()));
        else setSubText((0, $iJxY6.default)(locId, 'modalSubTextTwo', 'writeInModal').replace('%CHARS_LEFT%', charsLeft.toString()));
    }, [
        charsLeft
    ]);
    (0, $acw62.useEffect)(()=>{
        const statementText = currentCardValue.statementText.toLowerCase() !== (0, $iJxY6.default)(locId, 'writeInPlaceHolderText', 'writeInModal') ? currentCardValue.statementText : '';
        setLocalWriteInValueText(statementText);
        setCharsLeft(MAX_LENGTH - statementText.length);
        setIsSubmitButtonDisabled(false);
        setWriteInValueError(null);
    }, [
        currentCardValue
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7lk71.Dialog), {
        title: (0, $iJxY6.default)(locId, 'modalTitle', 'writeInModal'),
        open: showModal,
        buttons: buttons,
        className: "writeInModal",
        onRequestClose: closeModalHandler,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "writeInModal--paragraph",
                    children: (0, $iJxY6.default)(locId, 'modalTextValuelabel', 'writeInModal')
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.TextInput), {
                hideLabel: true,
                id: "write-in-input",
                label: (0, $iJxY6.default)(locId, 'modalTextValuelabel', 'writeInModal'),
                attributes: {
                    className: 'writeInModal--input'
                },
                name: "write-in-input",
                value: localWriteInValueText,
                maxLength: MAX_LENGTH,
                microcopy: subText,
                onChange: (text)=>writeInValueHandler(text),
                onBlur: validateWriteInValue,
                error: writeInValueError
            })
        ]
    });
};
$cd06aa503614bfa1$var$WriteInModal.propTypes = {
    currentCardValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        statementId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        statementText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }).isRequired,
    setCurrentCardValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    showModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    closeModalHandler: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $cd06aa503614bfa1$export$2e2bcd8739ae039 = $cd06aa503614bfa1$var$WriteInModal;

});

parcelRegister("iw8KV", function(module, exports) {

$parcel$export(module.exports, "sortValueList", () => $9b84e8cc2c77403c$export$108073e222883acb);

var $l3ekl = parcelRequire("l3ekl");
const $9b84e8cc2c77403c$export$4964c84431c09027 = (value)=>{
    if (!value || !Number.isInteger(value.statementId) || value.statementId < 0) return 0;
    const statmentId = (0, $l3ekl.valueStatementMap).get(value.statementId)?.displayOrdinal;
    return !statmentId ? 0 : statmentId;
};
const $9b84e8cc2c77403c$export$108073e222883acb = (valueList)=>{
    if (!valueList) return [];
    return valueList.sort((value1, value2)=>{
        return $9b84e8cc2c77403c$export$4964c84431c09027(value1) - $9b84e8cc2c77403c$export$4964c84431c09027(value2);
    });
};

});
parcelRegister("l3ekl", function(module, exports) {

$parcel$export(module.exports, "valueStatementMap", () => $c5a9e3a3f3bc2baf$export$16ed5a9a87111d0);
const $c5a9e3a3f3bc2baf$export$10645d89de387cd3 = Object.freeze({
    TRAVELING: {
        statementId: 0,
        statementText: 'Traveling',
        displayOrdinal: 8
    },
    MAKING_A_MEANINGFUL_IMPACT: {
        statementId: 1,
        statementText: 'Making a meaningful impact',
        displayOrdinal: 7
    },
    MAINTAINING_AN_EMERGENCY_FUND: {
        statementId: 2,
        statementText: 'Maintaining an emergency fund',
        displayOrdinal: 4
    },
    MANAGING_DEBT: {
        statementId: 3,
        statementText: 'Managing debt',
        displayOrdinal: 13
    },
    PURSUING_A_PASSION: {
        statementId: 4,
        statementText: 'Pursuing a passion',
        displayOrdinal: 12
    },
    LEAVING_AN_INHERITANCE: {
        statementId: 5,
        statementText: 'Leaving an inheritance',
        displayOrdinal: 9
    },
    LIVING_IN_MY_IDEAL_HOME: {
        statementId: 6,
        statementText: 'Living in my ideal home',
        displayOrdinal: 11
    },
    MAINTAINING_A_HEALTHY_LIFESTYLE: {
        statementId: 7,
        statementText: 'Maintaining a healthy lifestyle',
        displayOrdinal: 5
    },
    MAKING_MAJOR_PURCHASES: {
        statementId: 8,
        statementText: 'Making major purchases',
        displayOrdinal: 2
    },
    PAYING_FOR_EDUCATION: {
        statementId: 9,
        statementText: 'Paying for education',
        displayOrdinal: 3
    },
    SPENDING_TIME_WITH_FRIENDS_AND_FAMILY: {
        statementId: 10,
        statementText: 'Spending time with friends and family',
        displayOrdinal: 10
    },
    SAVING_FOR_RETIREMENT: {
        statementId: 11,
        statementText: 'Saving for retirement',
        displayOrdinal: 1
    },
    PLANNING_FOR_HEALTH_CARE_COSTS: {
        statementId: 12,
        statementText: 'Planning for health care costs',
        displayOrdinal: 6
    },
    RUNNING_A_BUSINESS: {
        statementId: 13,
        statementText: 'Running a business',
        displayOrdinal: 15
    },
    PROTECTING_YOUR_GOALS: {
        statementId: 14,
        statementText: 'Protecting your goals',
        displayOrdinal: 14
    },
    ADD_YOUR_OWN_PRIORITY: {
        statementId: 15,
        statementText: 'Add your own priority',
        displayOrdinal: 16
    }
});
const $c5a9e3a3f3bc2baf$export$16ed5a9a87111d0 = new Map([
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.TRAVELING.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.TRAVELING
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.MAKING_A_MEANINGFUL_IMPACT.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.MAKING_A_MEANINGFUL_IMPACT
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.MAINTAINING_AN_EMERGENCY_FUND.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.MAINTAINING_AN_EMERGENCY_FUND
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.MANAGING_DEBT.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.MANAGING_DEBT
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.PURSUING_A_PASSION.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.PURSUING_A_PASSION
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.LEAVING_AN_INHERITANCE.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.LEAVING_AN_INHERITANCE
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.LIVING_IN_MY_IDEAL_HOME.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.LIVING_IN_MY_IDEAL_HOME
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.MAINTAINING_A_HEALTHY_LIFESTYLE.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.MAINTAINING_A_HEALTHY_LIFESTYLE
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.MAKING_MAJOR_PURCHASES.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.MAKING_MAJOR_PURCHASES
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.PAYING_FOR_EDUCATION.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.PAYING_FOR_EDUCATION
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.SPENDING_TIME_WITH_FRIENDS_AND_FAMILY.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.SPENDING_TIME_WITH_FRIENDS_AND_FAMILY
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.SAVING_FOR_RETIREMENT.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.SAVING_FOR_RETIREMENT
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.PLANNING_FOR_HEALTH_CARE_COSTS.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.PLANNING_FOR_HEALTH_CARE_COSTS
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.RUNNING_A_BUSINESS.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.RUNNING_A_BUSINESS
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.PROTECTING_YOUR_GOALS.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.PROTECTING_YOUR_GOALS
    ],
    [
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.ADD_YOUR_OWN_PRIORITY.statementId,
        $c5a9e3a3f3bc2baf$export$10645d89de387cd3.ADD_YOUR_OWN_PRIORITY
    ]
]);

});


parcelRegister("devjf", function(module, exports) {

$parcel$export(module.exports, "default", () => $739b87ee72c6cbb1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7lk71 = parcelRequire("7lk71");

var $c9Z8w = parcelRequire("c9Z8w");


var $iJxY6 = parcelRequire("iJxY6");

var $9Ryut = parcelRequire("9Ryut");

var $kMrYv = parcelRequire("kMrYv");

var $7mmdw = parcelRequire("7mmdw");
const $739b87ee72c6cbb1$var$ValueRow = (props)=>{
    const { valueStatement: valueStatement, valueStatementId: valueStatementId, disabled: disabled, setShowAdditionalInfoModal: setShowAdditionalInfoModal, setShowCustomPriorityEditModal: setShowCustomPriorityEditModal, isEditable: isEditable, setEditModalCurrentCardValue: setEditModalCurrentCardValue, infoModalContent: infoModalContent, setInfoModalContent: setInfoModalContent } = props;
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const enterKey = 13;
    const escapeKey = 27;
    const personaTypeArrayUS = Array.of((0, $kMrYv.default).WORD_POWER, (0, $kMrYv.default).NEWS_LETTER, (0, $kMrYv.default).PERSONAL_LINK, (0, $kMrYv.default).PERSONAL_LINK_FA_PROFILE, (0, $kMrYv.default).FINANCIAL_FOUNDATION, (0, $kMrYv.default).DIRECT_URL);
    const userPersona = (0, $acw62.useContext)((0, $7mmdw.default));
    const valueAdditionalInfoOnClickHandler = ()=>{
        if (isEditable) setInfoModalContent((0, $iJxY6.default)(locId, 'customPriorityInfoModalTitle', 'customizePage'));
        else setInfoModalContent(infoModalContent);
        setShowAdditionalInfoModal(true);
    };
    const valueAdditionalInfoKeyDownHandler = (e)=>{
        if (e.keyCode === enterKey) {
            if (isEditable) setInfoModalContent((0, $iJxY6.default)(locId, 'customPriorityInfoModalTitle', 'customizePage'));
            else setInfoModalContent(infoModalContent);
            setShowAdditionalInfoModal(true);
        }
        if (e.keyCode === escapeKey) setShowAdditionalInfoModal(false);
    };
    const valueEditOnClickHandler = ()=>{
        setEditModalCurrentCardValue({
            statementId: valueStatementId,
            statementText: valueStatement
        });
        setShowCustomPriorityEditModal(true);
    };
    const valueEditKeyDownHandler = (e)=>{
        if (e.keyCode === enterKey) {
            setEditModalCurrentCardValue({
                statementId: valueStatementId,
                statementText: valueStatement
            });
            setShowCustomPriorityEditModal(true);
        }
        if (e.keyCode === escapeKey) setShowCustomPriorityEditModal(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "value-row",
        "data-testid": `valueRow-${valueStatementId}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Checkbox), {
                checked: !disabled,
                id: `checkbox-${valueStatementId}`,
                name: `checkbox-${valueStatementId}`,
                label: valueStatement,
                hideLabel: true,
                onChange: ()=>{}
            }),
            !personaTypeArrayUS.includes(userPersona) && (isEditable || infoModalContent) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "button",
                className: "value-additional-info-button",
                tabIndex: 0,
                onClick: (e)=>{
                    e.stopPropagation();
                    valueAdditionalInfoOnClickHandler();
                },
                onKeyDown: (e)=>{
                    e.stopPropagation();
                    valueAdditionalInfoKeyDownHandler(e);
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "value-edit-info--icon--custom-size",
                    "data-testid": `value-additional-info-button-${valueStatementId}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Icon), {
                        name: "help-question-mark"
                    })
                })
            }) : null,
            isEditable ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "button",
                className: "value-edit-row-text",
                tabIndex: 0,
                onClick: (e)=>{
                    e.stopPropagation();
                    valueEditOnClickHandler();
                },
                onKeyDown: (e)=>{
                    e.stopPropagation();
                    valueEditKeyDownHandler(e);
                },
                children: valueStatement
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "value-row-text",
                children: valueStatement
            })
        ]
    });
};
$739b87ee72c6cbb1$var$ValueRow.defaultProps = {
    disabled: false,
    setShowAdditionalInfoModal: null,
    setShowCustomPriorityEditModal: null,
    isEditable: false,
    setEditModalCurrentCardValue: null,
    infoModalContent: null,
    setInfoModalContent: null
};
$739b87ee72c6cbb1$var$ValueRow.propTypes = {
    valueStatement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    valueStatementId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    setShowAdditionalInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    setShowCustomPriorityEditModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isEditable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    setEditModalCurrentCardValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    infoModalContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setInfoModalContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $739b87ee72c6cbb1$export$2e2bcd8739ae039 = $739b87ee72c6cbb1$var$ValueRow;

});


parcelRegister("a77Be", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5cdd61f63d8d66d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");

var $4dB0L = parcelRequire("4dB0L");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $1ovHo = parcelRequire("1ovHo");

var $iJxY6 = parcelRequire("iJxY6");

var $9Ryut = parcelRequire("9Ryut");


var $3qYM8 = parcelRequire("3qYM8");

var $fUEMe = parcelRequire("fUEMe");

var $8Mm3X = parcelRequire("8Mm3X");

var $iIWMQ = parcelRequire("iIWMQ");

var $devjf = parcelRequire("devjf");

var $2DcdH = parcelRequire("2DcdH");

var $RXYi2 = parcelRequire("RXYi2");
const $b5cdd61f63d8d66d$var$FPCustomizePage = (props)=>{
    const { dataLayerInfo: dataLayerInfo } = (0, $RXYi2.useDataLayerInfo)();
    const { valueList: valueList, setInitialValuePair: setInitialValuePair, customizePageBtnCallback: customizePageBtnCallback, restart: restart, isLoading: isLoading } = props;
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const [before, after] = (0, $iJxY6.default)(locId, 'description', 'fpCustomizePage').split('least');
    const [isMobile, setIsMobile] = (0, $acw62.useState)(false);
    const [startQuizLabel, setStartQuizLabel] = (0, $acw62.useState)((0, $iJxY6.default)(locId, 'disabledBtnDefault', 'fpCustomizePage'));
    const [quizDisabled, setQuizDisabled] = (0, $acw62.useState)(true);
    const [localValuesList, setLocalValuesList] = (0, $acw62.useState)([]);
    const [numValuesToRemove, setNumValuesToRemove] = (0, $acw62.useState)(5);
    const [showAdditionalInfoModal, setShowAdditionalInfoModal] = (0, $acw62.useState)(false);
    const [showCustomPriorityEditModal, setShowCustomPriorityEditModal] = (0, $acw62.useState)(false);
    const [editModalCurrentCardValue, setEditModalCurrentCardValue] = (0, $acw62.useState)({
        statementId: -1,
        statementText: ''
    });
    const writeInStatementId = 15;
    const maximumPhoneWidth = 768;
    const SPACE = ' ';
    const ENTER = 'Enter';
    const [infoModalContent, setInfoModalContent] = (0, $acw62.useState)('');
    const handleMobileView = ()=>setIsMobile(window.innerWidth < maximumPhoneWidth);
    const updatedFaInfo = {
        ...dataLayerInfo,
        page_type: 'customize-page'
    };
    const { setPreviousPath: setPreviousPath, previousPath: previousPath } = (0, $2DcdH.usePreviousPath)();
    const currentLocation = (0, $aphAM.useLocation)();
    const pageTitle = (0, $iJxY6.default)(locId, 'pageTitle', 'fpCustomizePage');
    const pageReferrer = previousPath ? `${window.location.origin}${previousPath}${currentLocation.search}` : undefined;
    const pageURL = `${window.location.origin}${currentLocation.pathname}${currentLocation.search}`;
    const virtualPageInfo = {
        pagePath: currentLocation.pathname,
        pageTitle: pageTitle,
        page_referrer: pageReferrer,
        external_referrer: window.document.referrer && window.document.referrer.trim() !== '' ? window.document.referrer : undefined,
        page_url: pageURL
    };
    (0, $acw62.useEffect)(()=>{
        document.title = pageTitle;
        handleMobileView();
        window.removeEventListener('resize', handleMobileView);
        window.addEventListener('resize', handleMobileView);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (valueList.length > 0 && valueList[0]) {
            setPreviousPath(currentLocation.pathname);
            (0, $fUEMe.default)('dataLayer-initialized', updatedFaInfo);
            (0, $fUEMe.default)('VirtualPageview', virtualPageInfo);
            let tempValueList;
            if (!restart) tempValueList = (0, $iIWMQ.sortValueList)(valueList.map((value)=>{
                return {
                    statementId: value.statementId,
                    statementRank: value.statementRank,
                    statementText: value.statementText,
                    learnMoreContent: value.learnMoreContent,
                    learnMoreLinks: value.learnMoreLinks,
                    isActive: true,
                    indexId: value.indexId,
                    additionalInfo: value.additionalInfo
                };
            }));
            else {
                tempValueList = (0, $iIWMQ.sortValueList)(valueList);
                setNumValuesToRemove(0);
            }
            setLocalValuesList(tempValueList);
        }
    }, [
        valueList
    ]);
    (0, $acw62.useEffect)(()=>{
        if (numValuesToRemove > 0) {
            setStartQuizLabel(`${(0, $iJxY6.default)(locId, 'disabledBtnRemove', 'fpCustomizePage')} ${numValuesToRemove} ${(0, $iJxY6.default)(locId, 'disabledBtnMore', 'fpCustomizePage')}`);
            setQuizDisabled(true);
        } else if (numValuesToRemove < 0) {
            setStartQuizLabel(`${(0, $iJxY6.default)(locId, 'disabledBtnAdd', 'fpCustomizePage')} ${Math.abs(numValuesToRemove)} ${(0, $iJxY6.default)(locId, 'disabledBtnMore', 'fpCustomizePage')}`);
            setQuizDisabled(true);
        } else {
            setStartQuizLabel((0, $iJxY6.default)(locId, 'startQuiz', 'fpCustomizePage'));
            setQuizDisabled(false);
        }
    }, [
        numValuesToRemove
    ]);
    (0, $acw62.useEffect)(()=>{
        if (localValuesList.length > 0 && localValuesList[0]) {
            const newLocalValuesList = localValuesList.map((value)=>{
                if (value.statementId === editModalCurrentCardValue.statementId) return {
                    ...value,
                    statementText: editModalCurrentCardValue.statementText
                };
                return value;
            });
            setLocalValuesList(newLocalValuesList);
        }
    }, [
        editModalCurrentCardValue
    ]);
    function handleCardClick(valueId) {
        setLocalValuesList(localValuesList.map((value)=>{
            if (value.statementId === valueId) {
                // If currently active, reduce numsValueToRemove since it will be switched to disabled
                setNumValuesToRemove(value.isActive ? numValuesToRemove - 1 : numValuesToRemove + 1);
                return {
                    statementId: value.statementId,
                    statementRank: value.statementRank,
                    statementText: value.statementText,
                    learnMoreContent: value.learnMoreContent,
                    learnMoreLinks: value.learnMoreLinks,
                    isActive: !value.isActive,
                    indexId: value.indexId,
                    additionalInfo: value.additionalInfo
                };
            }
            return value;
        }));
    }
    function finalizeValueSelections() {
        let indexNum = 0;
        const finalValuesList = Array.from(localValuesList);
        finalValuesList.forEach((value, index)=>{
            if (value.isActive) {
                finalValuesList[index].indexId = indexNum;
                indexNum += 1;
            } else finalValuesList[index].indexId = -1;
        });
        setInitialValuePair(finalValuesList);
        return finalValuesList;
    }
    const mapValuesToCustomizeCards = ()=>{
        return localValuesList.map((value)=>{
            return value ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "CustomizePageFP_card",
                role: "button",
                onClick: ()=>handleCardClick(value.statementId),
                onKeyDown: (e)=>{
                    if (e.key === ENTER || e.key === SPACE) {
                        e.preventDefault();
                        handleCardClick(value.statementId);
                    }
                },
                tabIndex: 0,
                "aria-pressed": value.isActive,
                "data-testid": `valueCardContainerFP-${value.statementId}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ovHo.default), {
                    valueStatement: value.statementText,
                    valueStatementId: value.statementId,
                    disabled: !value.isActive,
                    setShowAdditionalInfoModal: setShowAdditionalInfoModal,
                    setShowCustomPriorityEditModal: setShowCustomPriorityEditModal,
                    isEditable: value.statementId === writeInStatementId,
                    setEditModalCurrentCardValue: setEditModalCurrentCardValue,
                    infoModalContent: value.additionalInfo,
                    setInfoModalContent: setInfoModalContent
                })
            }, value.statementId) : null;
        });
    };
    const mapValuesToCustomizeRows = ()=>{
        return localValuesList.map((value)=>{
            return value ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "CustomizePageFP_row",
                role: "button",
                onClick: (e)=>{
                    e.preventDefault();
                    handleCardClick(value.statementId);
                },
                onKeyDown: (e)=>{
                    e.stopPropagation();
                    if (e.key === ENTER || e.key === SPACE) {
                        e.preventDefault();
                        handleCardClick(value.statementId);
                    }
                },
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $devjf.default), {
                    valueStatement: value.statementText,
                    valueStatementId: value.statementId,
                    disabled: !value.isActive,
                    setShowAdditionalInfoModal: setShowAdditionalInfoModal,
                    setShowCustomPriorityEditModal: setShowCustomPriorityEditModal,
                    isEditable: value.statementId === writeInStatementId,
                    setEditModalCurrentCardValue: setEditModalCurrentCardValue,
                    infoModalContent: value.additionalInfo,
                    setInfoModalContent: setInfoModalContent
                })
            }, value.statementId) : null;
        });
    };
    const doesValuesListContainInvalidWriteInValue = ()=>{
        const writeInPriority = localValuesList.find((value)=>value.statementId === writeInStatementId);
        return writeInPriority && writeInPriority.isActive && (!writeInPriority.statementText || writeInPriority.statementText.toLowerCase() === (0, $iJxY6.default)(locId, 'writeInPlaceHolderText', 'fpCustomizePage'));
    };
    const handleStartBtnClick = ()=>{
        if (!doesValuesListContainInvalidWriteInValue()) {
            (0, $fUEMe.default)('get-started-customize-page', {});
            window.removeEventListener('resize', handleMobileView);
            customizePageBtnCallback(finalizeValueSelections());
        } else {
            const writeInPriority = localValuesList.find((value)=>value.statementId === writeInStatementId);
            setEditModalCurrentCardValue({
                statementId: writeInPriority.statementId,
                statementText: writeInPriority.statementText
            });
            setShowCustomPriorityEditModal(true);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "CustomizePageFP",
        "data-testid": "customize-pageFP",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "CustomizePageFP_content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "CustomizePageFP_intro",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                id: "heading-no-focus",
                                className: "heading--semi-bold",
                                children: (0, $iJxY6.default)(locId, 'header', 'fpCustomizePage')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "CustomizePageFP_headerDesc",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    "data-testid": "customize-headerDesc-fp",
                                    children: [
                                        before,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "least"
                                        }),
                                        after
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "CustomizePageFP_btnContainer",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-live": "polite",
                                "aria-relevant": "text",
                                "aria-atomic": "true",
                                className: "CustomizePageFP_visually-hidden",
                                children: startQuizLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                                label: startQuizLabel,
                                disabled: quizDisabled,
                                onClick: ()=>handleStartBtnClick(),
                                attributes: {
                                    value: '',
                                    id: 'get-started-buttonFP'
                                }
                            })
                        ]
                    }),
                    isMobile ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "CustomizePageFP_rowsListContainer",
                                children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    id: "spinner",
                                    "data-testid": "customize-spinnerFP",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dB0L.default), {
                                        animation: "border"
                                    })
                                }) : mapValuesToCustomizeRows()
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "CustomizePageFP_btnContainer",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                                    label: startQuizLabel,
                                    disabled: quizDisabled,
                                    onClick: ()=>handleStartBtnClick(),
                                    attributes: {
                                        value: '',
                                        id: 'get-started-buttonFP'
                                    }
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "CustomizePageFP_cardsContainer",
                        children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            id: "spinner",
                            "data-testid": "customize-spinnerFP",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dB0L.default), {
                                animation: "border"
                            })
                        }) : mapValuesToCustomizeCards()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3qYM8.default), {
                        displayModal: showAdditionalInfoModal,
                        closeModalHandler: ()=>setShowAdditionalInfoModal(false),
                        headerText: infoModalContent
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8Mm3X.default), {
                        currentCardValue: editModalCurrentCardValue,
                        setCurrentCardValue: setEditModalCurrentCardValue,
                        showModal: showCustomPriorityEditModal,
                        closeModalHandler: ()=>setShowCustomPriorityEditModal(false)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "footerFP",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "disclaimerFP",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "microcopy--2",
                        children: (0, $iJxY6.default)(locId, 'customizePageDisclosure', 'fpCustomizePage')
                    })
                })
            })
        ]
    });
};
$b5cdd61f63d8d66d$var$FPCustomizePage.propTypes = {
    valueList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        statementId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        statementText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        statementRank: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        isActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        indexId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    })).isRequired,
    setInitialValuePair: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    customizePageBtnCallback: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    restart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};
var $b5cdd61f63d8d66d$export$2e2bcd8739ae039 = $b5cdd61f63d8d66d$var$FPCustomizePage;

});
parcelRegister("iIWMQ", function(module, exports) {

$parcel$export(module.exports, "sortValueList", () => $4c4e2fcf69e619c0$export$108073e222883acb);

var $hqet7 = parcelRequire("hqet7");
const $4c4e2fcf69e619c0$export$4964c84431c09027 = (value)=>{
    if (!value || !Number.isInteger(value.statementId) || value.statementId < 0) return 0;
    const statmentId = (0, $hqet7.valueStatementMapFP).get(value.statementId)?.displayOrdinal;
    return !statmentId ? 0 : statmentId;
};
const $4c4e2fcf69e619c0$export$108073e222883acb = (valueList)=>{
    if (!valueList) return [];
    return valueList.sort((value1, value2)=>{
        return $4c4e2fcf69e619c0$export$4964c84431c09027(value1) - $4c4e2fcf69e619c0$export$4964c84431c09027(value2);
    });
};

});
parcelRegister("hqet7", function(module, exports) {

$parcel$export(module.exports, "valueStatementMapFP", () => $25a7937541e323e1$export$f9f08872f573006c);
const $25a7937541e323e1$export$10645d89de387cd3 = Object.freeze({
    TRAVELING: {
        statementId: 0,
        statementText: 'Traveling often',
        displayOrdinal: 16
    },
    MAKING_A_MEANINGFUL_IMPACT: {
        statementId: 1,
        statementText: 'Making an impact',
        displayOrdinal: 14
    },
    MAINTAINING_AN_EMERGENCY_FUND: {
        statementId: 2,
        statementText: 'A low-stress lifestyle',
        displayOrdinal: 7
    },
    MANAGING_DEBT: {
        statementId: 3,
        statementText: 'Living debt free',
        displayOrdinal: 4
    },
    PURSUING_A_PASSION: {
        statementId: 4,
        statementText: 'Community building',
        displayOrdinal: 13
    },
    LEAVING_AN_INHERITANCE: {
        statementId: 5,
        statementText: 'Starting/growing a family',
        displayOrdinal: 12
    },
    LIVING_IN_MY_IDEAL_HOME: {
        statementId: 6,
        statementText: 'Living in my ideal home',
        displayOrdinal: 9
    },
    MAINTAINING_A_HEALTHY_LIFESTYLE: {
        statementId: 7,
        statementText: 'A healthy lifestyle',
        displayOrdinal: 6
    },
    MAKING_MAJOR_PURCHASES: {
        statementId: 8,
        statementText: 'Being financially wealthy',
        displayOrdinal: 3
    },
    PAYING_FOR_EDUCATION: {
        statementId: 9,
        statementText: 'Supporting loved ones',
        displayOrdinal: 10
    },
    SPENDING_TIME_WITH_FRIENDS_AND_FAMILY: {
        statementId: 10,
        statementText: 'Time with friends and family',
        displayOrdinal: 11
    },
    SAVING_FOR_RETIREMENT: {
        statementId: 11,
        statementText: 'Retiring early',
        displayOrdinal: 2
    },
    PLANNING_FOR_HEALTH_CARE_COSTS: {
        statementId: 12,
        statementText: 'A focus on spirituality',
        displayOrdinal: 15
    },
    RUNNING_A_BUSINESS: {
        statementId: 13,
        statementText: 'Being my own boss',
        displayOrdinal: 5
    },
    PROTECTING_YOUR_GOALS: {
        statementId: 14,
        statementText: 'Frequent fun/adventure',
        displayOrdinal: 8
    },
    ADD_YOUR_OWN_PRIORITY: {
        statementId: 15,
        statementText: 'Add your own priority',
        displayOrdinal: 1
    }
});
const $25a7937541e323e1$export$f9f08872f573006c = new Map([
    [
        $25a7937541e323e1$export$10645d89de387cd3.TRAVELING.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.TRAVELING
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.MAKING_A_MEANINGFUL_IMPACT.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.MAKING_A_MEANINGFUL_IMPACT
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.MAINTAINING_AN_EMERGENCY_FUND.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.MAINTAINING_AN_EMERGENCY_FUND
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.MANAGING_DEBT.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.MANAGING_DEBT
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.PURSUING_A_PASSION.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.PURSUING_A_PASSION
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.LEAVING_AN_INHERITANCE.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.LEAVING_AN_INHERITANCE
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.LIVING_IN_MY_IDEAL_HOME.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.LIVING_IN_MY_IDEAL_HOME
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.MAINTAINING_A_HEALTHY_LIFESTYLE.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.MAINTAINING_A_HEALTHY_LIFESTYLE
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.MAKING_MAJOR_PURCHASES.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.MAKING_MAJOR_PURCHASES
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.PAYING_FOR_EDUCATION.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.PAYING_FOR_EDUCATION
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.SPENDING_TIME_WITH_FRIENDS_AND_FAMILY.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.SPENDING_TIME_WITH_FRIENDS_AND_FAMILY
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.SAVING_FOR_RETIREMENT.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.SAVING_FOR_RETIREMENT
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.PLANNING_FOR_HEALTH_CARE_COSTS.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.PLANNING_FOR_HEALTH_CARE_COSTS
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.RUNNING_A_BUSINESS.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.RUNNING_A_BUSINESS
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.PROTECTING_YOUR_GOALS.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.PROTECTING_YOUR_GOALS
    ],
    [
        $25a7937541e323e1$export$10645d89de387cd3.ADD_YOUR_OWN_PRIORITY.statementId,
        $25a7937541e323e1$export$10645d89de387cd3.ADD_YOUR_OWN_PRIORITY
    ]
]);

});



parcelRegister("cLiYZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $425be8ab73da4c8c$export$2e2bcd8739ae039);
/* eslint-disable no-use-before-define */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $4dB0L = parcelRequire("4dB0L");

var $iJxY6 = parcelRequire("iJxY6");

var $9Ryut = parcelRequire("9Ryut");

var $Usxxm = parcelRequire("Usxxm");

var $7a1Nm = parcelRequire("7a1Nm");

var $2APmv = parcelRequire("2APmv");

var $fUEMe = parcelRequire("fUEMe");


var $4mrbC = parcelRequire("4mrbC");

var $2DcdH = parcelRequire("2DcdH");

var $RXYi2 = parcelRequire("RXYi2");
const $425be8ab73da4c8c$var$PlanningTopicsPage = (props)=>{
    const { isLoading: isLoading, planningTopicsBtnCallback: planningTopicsBtnCallback, updateFinancialPlanningContent: updateFinancialPlanningContent, financialPlanningContent: financialPlanningContent } = props;
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const SPACE = ' ';
    const ENTER = 'Enter';
    const [isContinueButtonDisabled, setIsContinueButtonDisabled] = (0, $acw62.useState)(true);
    const [planningTopics, setPlanningTopics] = (0, $acw62.useState)([]);
    const [isMobile, setIsMobile] = (0, $acw62.useState)(false);
    const maximumPhoneWidth = 768;
    const initRadioOptions = (0, $acw62.useMemo)(()=>[
            {
                checked: false,
                disabled: false,
                id: 'id-only-advisor',
                label: (0, $iJxY6.default)(locId, 'advisorOnlyOption', 'planningTopicsPage'),
                value: (0, $4mrbC.default).ADVISOR_ONLY.code
            },
            {
                checked: false,
                disabled: false,
                id: 'id-with-advisor',
                label: (0, $iJxY6.default)(locId, 'togetherWithAdvisorOption', 'planningTopicsPage'),
                value: (0, $4mrbC.default).TOGETHER_WITH_ADVISOR.code
            },
            {
                checked: false,
                disabled: false,
                id: 'id-myself-only',
                label: (0, $iJxY6.default)(locId, 'myselfOnlyOption', 'planningTopicsPage'),
                value: (0, $4mrbC.default).MYSELF_ONLY.code
            },
            {
                checked: false,
                disabled: false,
                id: 'id-it-depends',
                label: (0, $iJxY6.default)(locId, 'itDependsOption', 'planningTopicsPage'),
                value: (0, $4mrbC.default).IT_DEPENDS.code
            },
            {
                checked: false,
                disabled: false,
                id: 'id-unsure',
                label: (0, $iJxY6.default)(locId, 'unsureOption', 'planningTopicsPage'),
                value: (0, $4mrbC.default).UNSURE.code
            }
        ], [
        locId
    ]);
    const [radioOptions, setRadioOptions] = (0, $acw62.useState)(()=>{
        if (financialPlanningContent?.investorInvolvementCode) return initRadioOptions.map((option)=>({
                ...option,
                checked: option.value === financialPlanningContent.investorInvolvementCode
            }));
        return initRadioOptions;
    });
    const [liveRegionMessage, setLiveRegionMessage] = (0, $acw62.useState)('');
    const [selectedInvestmentDecision, setSelectedInvestmentDecision] = (0, $acw62.useState)('');
    const checkboxRefs = (0, $acw62.useRef)({});
    const [focusTopicId, setFocusTopicId] = (0, $acw62.useState)(null);
    const updateInvestmentDecision = (optionValue)=>{
        const updatedOptions = initRadioOptions.map((option)=>({
                ...option,
                checked: option.value === optionValue
            }));
        setSelectedInvestmentDecision(optionValue);
        setRadioOptions(updatedOptions);
        const investmentDecisionOptionLabel = updatedOptions.find((investmentDecisionOption)=>investmentDecisionOption.value === optionValue)?.label;
        (0, $fUEMe.default)('radial_button_selection', {
            button_name: investmentDecisionOptionLabel
        });
    };
    const handleMobileView = ()=>setIsMobile(window.innerWidth < maximumPhoneWidth);
    const { setPreviousPath: setPreviousPath, previousPath: previousPath } = (0, $2DcdH.usePreviousPath)();
    const currentLocation = (0, $aphAM.useLocation)();
    const pageTitle = (0, $iJxY6.default)(locId, 'pageTitle', 'planningTopicsPage');
    const pageReferrer = previousPath ? `${window.location.origin}${previousPath}${currentLocation.search}` : undefined;
    const pageURL = `${window.location.origin}${currentLocation.pathname}${currentLocation.search}`;
    const virtualPageInfo = {
        pagePath: currentLocation.pathname,
        pageTitle: pageTitle,
        page_referrer: pageReferrer,
        external_referrer: window.document.referrer && window.document.referrer.trim() !== '' ? window.document.referrer : undefined,
        page_url: pageURL
    };
    const { dataLayerInfo: dataLayerInfo } = (0, $RXYi2.useDataLayerInfo)();
    const updatesFPPlanningTopics = {
        ...dataLayerInfo,
        page_type: 'planning-topics-page'
    };
    (0, $acw62.useEffect)(()=>{
        document.title = pageTitle;
        setPreviousPath(currentLocation.pathname);
        (0, $fUEMe.default)('dataLayer-initialized', updatesFPPlanningTopics);
        (0, $fUEMe.default)('VirtualPageview', virtualPageInfo);
        handleMobileView();
        window.addEventListener('resize', handleMobileView);
        const topics = [];
        const investorInvolvementCode = financialPlanningContent?.investorInvolvementCode || '';
        (0, $2APmv.planningTopicsMap).forEach((topic)=>{
            const isChecked = financialPlanningContent?.planningTopics?.some((t)=>t.topicTitleId === topic.topicTitleId && t.checked);
            topics.push({
                ...topic,
                checked: !!isChecked
            });
        });
        setPlanningTopics(topics);
        setSelectedInvestmentDecision(investorInvolvementCode);
        return ()=>{
            window.removeEventListener('resize', handleMobileView);
        };
    }, []);
    const handleCardClick = (topicId)=>{
        const planningTopicCardTitle = (0, $2APmv.planningTopicsMap).get(topicId)?.topicTitle;
        (0, $fUEMe.default)('card_click', {
            button_name: planningTopicCardTitle
        });
        setPlanningTopics(planningTopics.map((topic)=>topic.topicTitleId === topicId ? {
                ...topic,
                checked: !topic.checked
            } : topic));
        setFocusTopicId(topicId);
        // Update live region message for screen readers
        const toggledTopic = planningTopics.find((t)=>t.topicTitleId === topicId);
        const isNowChecked = toggledTopic ? !toggledTopic.checked : false;
        setLiveRegionMessage(`${planningTopicCardTitle} ${isNowChecked ? 'checked' : 'unchecked'}`);
        // Focus the checkbox after state update
        setTimeout(()=>{
            checkboxRefs.current[topicId]?.focus();
        }, 0);
    };
    // Focus on checkbox after DOM update
    // This is necessary to ensure the checkbox is focused after the state update for screen readers
    (0, $acw62.useEffect)(()=>{
        if (focusTopicId && checkboxRefs.current[focusTopicId]) {
            checkboxRefs.current[focusTopicId]?.focus();
            setFocusTopicId(null); // reset the flag
        }
    }, [
        planningTopics,
        focusTopicId
    ]);
    const mapPlanningTopicsToCards = ()=>{
        return planningTopics.map((topic)=>{
            return topic ? /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                htmlFor: `checkbox-${topic.topicTitleId}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "FPPlanningTopicsPage_card",
                    "data-testid": `planningTopicsCardContainer-${topic.topicTitleId}`,
                    onKeyDown: (e)=>{
                        e.stopPropagation();
                        if (e.key === ENTER || e.key === SPACE) {
                            e.preventDefault();
                            handleCardClick(topic.topicTitleId);
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Usxxm.default), {
                        topicTitle: topic.topicTitle,
                        topicStatement: topic.topicStatement,
                        topicTitleId: topic.topicTitleId,
                        checked: topic.checked,
                        color: topic.color,
                        handleCardClick: handleCardClick,
                        ref: (el)=>{
                            checkboxRefs.current[topic.topicTitleId] = el;
                        }
                    })
                })
            }, `planningTopicsCard-${topic.topicTitleId}`) : null;
        });
    };
    const mapPlanningTopicsToRows = ()=>{
        return planningTopics.map((topic)=>{
            return topic ? /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                htmlFor: `checkbox-${topic.topicTitleId}`,
                className: "FPPlanningTopicsPage_rowLabels",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "FPPlanningTopicsPage_row",
                    "data-testid": `planningTopicsRowContainer-${topic.topicTitleId}`,
                    onKeyDown: (e)=>{
                        e.stopPropagation();
                        if (e.key === ENTER || e.key === SPACE) {
                            e.preventDefault();
                            handleCardClick(topic.topicTitleId);
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7a1Nm.default), {
                        topicTitle: topic.topicTitle,
                        topicStatement: topic.topicStatement,
                        topicTitleId: topic.topicTitleId,
                        checked: topic.checked,
                        color: topic.color,
                        handleCardClick: handleCardClick,
                        ref: (el)=>{
                            checkboxRefs.current[topic.topicTitleId] = el;
                        }
                    })
                })
            }, `planningTopicsRow-${topic.topicTitleId}`) : null;
        });
    };
    (0, $acw62.useEffect)(()=>{
        const hasSelectedTopic = planningTopics.some((topic)=>topic.checked);
        const hasSelectedRadio = selectedInvestmentDecision !== '';
        setIsContinueButtonDisabled(!(hasSelectedTopic && hasSelectedRadio));
    }, [
        planningTopics,
        selectedInvestmentDecision
    ]);
    const saveFinancialPlanningContent = ()=>{
        const selectedTopics = planningTopics.filter((topic)=>topic.checked);
        const planningTopicsData = {
            planningTopics: selectedTopics,
            investorInvolvementCode: selectedInvestmentDecision
        };
        (0, $fUEMe.default)('save_and_continue', {});
        planningTopicsBtnCallback();
        updateFinancialPlanningContent(planningTopicsData);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "FPPlanningTopicsPage",
        "data-testid": "planning-topics-page",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "FPPlanningTopicsPage_content",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    "aria-live": "polite",
                    "aria-relevant": "text",
                    "aria-atomic": "true",
                    className: "FPPlanningTopicsPage_visually-hidden",
                    children: liveRegionMessage
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "heading--semi-bold",
                    children: (0, $iJxY6.default)(locId, 'header', 'planningTopicsPage')
                }),
                isMobile ? /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    className: "FPPlanningTopicsPage_rowsFieldset",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "FPPlanningTopicsPage_description",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                                children: (0, $iJxY6.default)(locId, 'description', 'planningTopicsPage')
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "FPPlanningTopicsPage_rowsContainer",
                            children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                id: "spinner",
                                "data-testid": "planning-topics-spinner",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dB0L.default), {
                                    animation: "border"
                                })
                            }) : mapPlanningTopicsToRows()
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    className: "FPPlanningTopicsPage_cardsContainer",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "FPPlanningTopicsPage_description",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                                    children: (0, $iJxY6.default)(locId, 'description', 'planningTopicsPage')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "image-frame",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: "/public/images/welcome_image.png",
                                        alt: "",
                                        role: "presentation"
                                    })
                                })
                            ]
                        }),
                        isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            id: "spinner",
                            "data-testid": "planning-topics-spinner",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dB0L.default), {
                                animation: "border"
                            })
                        }) : mapPlanningTopicsToCards()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("fieldset", {
                    "data-testid": "planning-topics-investment-decision",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.RadioGroup), {
                        classes: [
                            'decision-group'
                        ],
                        legend: (0, $iJxY6.default)(locId, 'selectInvestmentDecision', 'planningTopicsPage'),
                        name: "decision-group",
                        onChange: updateInvestmentDecision,
                        options: radioOptions
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "FPPlanningTopicsPage_btnContainer",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                        label: (0, $iJxY6.default)(locId, 'saveBtnLabel', 'planningTopicsPage'),
                        styleVariant: "primary",
                        onClick: saveFinancialPlanningContent,
                        "data-testid": "FPPlanningTopicsPage_btn",
                        attributes: {
                            value: '',
                            id: 'results-page-button_fp'
                        },
                        disabled: isContinueButtonDisabled
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "footerFP",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "disclaimerFP",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "microcopy--2",
                            children: (0, $iJxY6.default)(locId, 'planningTopicsPageDisclosure', 'planningTopicsPage')
                        })
                    })
                })
            ]
        })
    });
};
$425be8ab73da4c8c$var$PlanningTopicsPage.propTypes = {
    planningTopicsBtnCallback: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    updateFinancialPlanningContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    financialPlanningContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        // eslint-disable-next-line react/forbid-prop-types
        planningTopics: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
        investorInvolvementCode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    })
};
var $425be8ab73da4c8c$export$2e2bcd8739ae039 = $425be8ab73da4c8c$var$PlanningTopicsPage;

});
parcelRegister("Usxxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $03420b86ab902ff6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");

const $03420b86ab902ff6$var$PlanningTopicsCard = /*#__PURE__*/ (0, $acw62.forwardRef)(({ topicTitle: topicTitle, topicStatement: topicStatement, topicTitleId: topicTitleId, checked: checked, color: color, handleCardClick: handleCardClick }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "planning-topics-card",
        "data-testid": `planningTopicsCard-${topicTitleId}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "planning-topics-header",
                style: {
                    backgroundColor: color
                },
                "data-testid": "planningTopicsHeader"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "planning-topics-title",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Checkbox), {
                        checked: checked,
                        id: `checkbox-${topicTitleId}`,
                        name: `checkbox-${topicTitleId}`,
                        label: "",
                        hideLabel: true,
                        onChange: ()=>handleCardClick(topicTitleId),
                        "aria-describedby": `${topicTitle}-statement`,
                        inputRef: ref && typeof ref !== 'function' ? ref : undefined
                    }),
                    topicTitle
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "planning-topics-statement",
                id: `${topicTitle}-statement`,
                children: topicStatement
            })
        ]
    }));
$03420b86ab902ff6$var$PlanningTopicsCard.displayName = 'PlanningTopicsCard';
$03420b86ab902ff6$var$PlanningTopicsCard.propTypes = {
    topicTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    topicStatement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    topicTitleId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    handleCardClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $03420b86ab902ff6$export$2e2bcd8739ae039 = $03420b86ab902ff6$var$PlanningTopicsCard;

});

parcelRegister("7a1Nm", function(module, exports) {

$parcel$export(module.exports, "default", () => $30caff95352e542d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");

const $30caff95352e542d$var$PlanningTopicsRow = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { topicTitle: topicTitle, topicStatement: topicStatement, topicTitleId: topicTitleId, checked: checked, color: color, handleCardClick: handleCardClick } = props;
    const [height, setHeight] = (0, $acw62.useState)(checked ? undefined : 0);
    const heightRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (checked) setHeight(122);
        else setHeight(0);
    }, [
        checked
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "planning-topics-row",
        "data-testid": `planningTopicsRow-${topicTitleId}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "planning-topics-header",
                style: {
                    backgroundColor: color
                },
                "data-testid": "planningTopicsHeader"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "planning-topics-title",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Checkbox), {
                        checked: checked,
                        id: `checkbox-${topicTitleId}`,
                        name: `checkbox-${topicTitleId}`,
                        label: "",
                        hideLabel: true,
                        onChange: ()=>handleCardClick(topicTitleId),
                        "aria-describedby": `${topicTitle}-statement`,
                        ref: ref
                    }),
                    topicTitle,
                    checked ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "planning-topics-button",
                        "data-testid": "planningTopicsRowCheckedIcon",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Icon), {
                            name: "caret-up"
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "planning-topics-button",
                        "data-testid": "planningTopicsRowUncheckedIcon",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Icon), {
                            name: "caret-down"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "planning-topics-statement-container",
                "data-testid": "planningTopicsRowStatement",
                style: {
                    height: height
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    ref: heightRef,
                    id: `${topicTitle}-statement`,
                    children: topicStatement
                })
            })
        ]
    });
});
$30caff95352e542d$var$PlanningTopicsRow.propTypes = {
    topicTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    topicStatement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    topicTitleId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    handleCardClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $30caff95352e542d$export$2e2bcd8739ae039 = $30caff95352e542d$var$PlanningTopicsRow;

});

parcelRegister("2APmv", function(module, exports) {

$parcel$export(module.exports, "planningTopicsMap", () => $a69591315430d9d0$export$cd44912be04c8930);
const $a69591315430d9d0$export$c4d320998d6d74bf = Object.freeze({
    CASH_AND_INCOME: {
        topicTitle: 'Cash & Income',
        topicStatement: 'Knowing your cash flow and net worth provides a snapshot of your current financial position.',
        topicTitleId: '1',
        color: '#06AE93',
        code: 'CASH_AND_INCOME'
    },
    PORTFOLIO_AND_INVESTMENTS: {
        topicTitle: 'Portfolio & Investments',
        topicStatement: 'Through personalized recommendations, we can support you in aligning your investments with your goals.',
        topicTitleId: '2',
        color: '#3C3E40',
        code: 'PORTFOLIO_AND_INVESTMENTS'
    },
    GOAL_PLANNING: {
        topicTitle: 'Goal Planning',
        topicStatement: 'Goals are at the foundation of your plan, and we will provide recommendations to help you accomplish what is most important to you.',
        topicTitleId: '3',
        color: '#FED21D',
        code: 'GOAL_PLANNING'
    },
    RISK_AND_PROTECTION: {
        topicTitle: 'Risk & Protection',
        topicStatement: 'An unexpected event could leave you, or your family, unable to accomplish what matters most to you.',
        topicTitleId: '4',
        color: '#8CBDD9',
        code: 'RISK_AND_PROTECTION'
    },
    ESTATE_AND_WEALTH_TRANSFER: {
        topicTitle: 'Estate & Wealth Transfer',
        topicStatement: 'A comprehensive estate strategy includes appointing someone to make decisions on your behalf if you are unable to do so.',
        topicTitleId: '5',
        color: '#D2D1D3',
        code: 'ESTATE_AND_WEALTH_TRANSFER'
    }
});
const $a69591315430d9d0$export$cd44912be04c8930 = new Map([
    [
        $a69591315430d9d0$export$c4d320998d6d74bf.CASH_AND_INCOME.topicTitleId,
        $a69591315430d9d0$export$c4d320998d6d74bf.CASH_AND_INCOME
    ],
    [
        $a69591315430d9d0$export$c4d320998d6d74bf.PORTFOLIO_AND_INVESTMENTS.topicTitleId,
        $a69591315430d9d0$export$c4d320998d6d74bf.PORTFOLIO_AND_INVESTMENTS
    ],
    [
        $a69591315430d9d0$export$c4d320998d6d74bf.GOAL_PLANNING.topicTitleId,
        $a69591315430d9d0$export$c4d320998d6d74bf.GOAL_PLANNING
    ],
    [
        $a69591315430d9d0$export$c4d320998d6d74bf.RISK_AND_PROTECTION.topicTitleId,
        $a69591315430d9d0$export$c4d320998d6d74bf.RISK_AND_PROTECTION
    ],
    [
        $a69591315430d9d0$export$c4d320998d6d74bf.ESTATE_AND_WEALTH_TRANSFER.topicTitleId,
        $a69591315430d9d0$export$c4d320998d6d74bf.ESTATE_AND_WEALTH_TRANSFER
    ]
]);

});

parcelRegister("4mrbC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3522152c4ca8f321$export$2e2bcd8739ae039);
const $3522152c4ca8f321$var$INVESTMENT_DECISION_LIST = Object.freeze({
    ADVISOR_ONLY: {
        decisionStatement: 'I like to have investment professionals do it for me',
        code: 'ADVISOR_ONLY'
    },
    TOGETHER_WITH_ADVISOR: {
        decisionStatement: 'I like to work with my advisor and select investments together',
        code: 'TOGETHER_WITH_ADVISOR'
    },
    MYSELF_ONLY: {
        decisionStatement: 'I like to make investment decisions myself',
        code: 'MYSELF_ONLY'
    },
    IT_DEPENDS: {
        decisionStatement: 'It depends on the type or purpose of my account',
        code: 'IT_DEPENDS'
    },
    UNSURE: {
        decisionStatement: 'I am unsure about this',
        code: 'UNSURE'
    }
});
var $3522152c4ca8f321$export$2e2bcd8739ae039 = $3522152c4ca8f321$var$INVESTMENT_DECISION_LIST;

});


parcelRegister("cb4KN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9229fb45c836a0e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $iJxY6 = parcelRequire("iJxY6");

var $9Ryut = parcelRequire("9Ryut");

const $b9229fb45c836a0e$var$ErrorPage = (props)=>{
    const { quizIsStarted: quizIsStarted, resetWelcomePage: resetWelcomePage, notFound: notFound } = props;
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const location = (0, $aphAM.useLocation)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "ErrorPage",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "ErrorPage_message",
            children: [
                notFound ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            id: "heading-no-focus",
                            children: (0, $iJxY6.default)(locId, 'fourOhFour', 'errorPage')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ErrorPage_welcome-page-link",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    (0, $iJxY6.default)(locId, 'returnToWelcomePage', 'errorPage'),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                        "data-testid": "welcome-page-link",
                                        to: {
                                            pathname: '/',
                                            search: location.search
                                        },
                                        onClick: ()=>resetWelcomePage(),
                                        children: (0, $iJxY6.default)(locId, 'welcomePageLinkText', 'errorPage')
                                    }),
                                    "."
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            id: "heading-no-focus",
                            children: `${(0, $iJxY6.default)(locId, 'errorTextLine1', 'errorPage')}`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: `${(0, $iJxY6.default)(locId, 'errorTextLine2', 'errorPage')}`
                        })
                    ]
                }),
                quizIsStarted ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "ErrorPage_welcome-page-link",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            (0, $iJxY6.default)(locId, 'returnToWelcomePage', 'errorPage'),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                "data-testid": "welcome-page-link",
                                to: {
                                    pathname: '/',
                                    search: location.search
                                },
                                onClick: ()=>resetWelcomePage(),
                                children: (0, $iJxY6.default)(locId, 'welcomePageLinkText', 'errorPage')
                            }),
                            "."
                        ]
                    })
                }) : null
            ]
        })
    });
};
$b9229fb45c836a0e$var$ErrorPage.propTypes = {
    quizIsStarted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    resetWelcomePage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    notFound: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
$b9229fb45c836a0e$var$ErrorPage.defaultProps = {
    notFound: false
};
var $b9229fb45c836a0e$export$2e2bcd8739ae039 = $b9229fb45c836a0e$var$ErrorPage;

});

parcelRegister("g7KiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $25730f9bf4e79896$export$2e2bcd8739ae039);
/* eslint-disable no-use-before-define */ /* eslint-disable no-plusplus */ /* eslint-disable no-nested-ternary */ /* eslint-disable no-shadow */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");

var $89C3d = parcelRequire("89C3d");

var $6mQzc = parcelRequire("6mQzc");

var $145EN = parcelRequire("145EN");

var $a3fhk = parcelRequire("a3fhk");

var $fKxvO = parcelRequire("fKxvO");

var $iJxY6 = parcelRequire("iJxY6");

var $86M2b = parcelRequire("86M2b");

var $9Ryut = parcelRequire("9Ryut");

var $6UZN0 = parcelRequire("6UZN0");

var $2DcdH = parcelRequire("2DcdH");


var $fUEMe = parcelRequire("fUEMe");

var $8cWO4 = parcelRequire("8cWO4");

var $aO5Es = parcelRequire("aO5Es");

var $duf9k = parcelRequire("duf9k");

var $kiK3k = parcelRequire("kiK3k");

var $aU90w = parcelRequire("aU90w");

var $kgzQz = parcelRequire("kgzQz");

var $5W5zw = parcelRequire("5W5zw");

var $jNFbw = parcelRequire("jNFbw");

var $7d1HW = parcelRequire("7d1HW");

var $58ODK = parcelRequire("58ODK");

var $RXYi2 = parcelRequire("RXYi2");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
const $25730f9bf4e79896$var$ResultsPage = (props)=>{
    const { contactID: contactID, contactName: contactName, financialAdvisorID: financialAdvisorID, entityID: entityID, timestamp: timestamp, sessionId: sessionId, valueList: valueList, finalResultsIndex: finalResultsIndex, restartCallback: restartCallback, callerApp: callerApp, displaySendToFAButton: displaySendToFAButton, faInfo: faInfo } = props;
    const initialResultsStatementIds = finalResultsIndex.map((index)=>{
        const value = valueList.find((value)=>index === value.indexId);
        return value.statementId;
    });
    const { dataLayerInfo: dataLayerInfo } = (0, $RXYi2.useDataLayerInfo)();
    const [notificationOpen, setNotificationOpen] = (0, $acw62.useState)(false);
    const [notificationContent, setNotificationContent] = (0, $acw62.useState)({
        type: null,
        message: null
    });
    const [displaySendResults, setDisplaySendResults] = (0, $acw62.useState)(false);
    const [coldContactData, setColdContactData] = (0, $acw62.useState)(null);
    const [userComments, setUserComments] = (0, $acw62.useState)('');
    const [cardClassName, setCardClassName] = (0, $acw62.useState)('value-card');
    const [finalResultsStatementIds, setFinalResultsStatementIds] = (0, $acw62.useState)(initialResultsStatementIds);
    const [sendResultsButtonDisabled, setSendResultsButtonDisabled] = (0, $acw62.useState)(false);
    const topOfResults = (0, $acw62.useRef)();
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const resultsJSON = createResultsJSON();
    const displayFAName = !!faInfo.faFirstName && !!faInfo.faLastName;
    const faFullName = `${faInfo.faFirstName} ${faInfo.faLastName}`;
    const sendResultsToFaText = (0, $iJxY6.default)(locId, 'sendResultsToFA', 'resultsPage');
    const faNameDefaultText = (0, $iJxY6.default)(locId, 'faDefaultText', 'resultsPage');
    const whatsNextSendToFaHeadingText = (0, $iJxY6.default)(locId, 'whatNextSendToFaHeading', 'resultsPage');
    const whatsNextSendToFaText = (0, $iJxY6.default)(locId, 'whatNextSendToFA', 'resultsPage');
    const yourFaNameDefaultText = (0, $iJxY6.default)(locId, 'yourFaDefaultText', 'resultsPage');
    const urlQuery = (0, $58ODK.default)();
    const isTouchDevice = ()=>{
        return 'ontouchstart' in window;
    };
    const isFinancialFoundationsUser = ()=>{
        return (urlQuery.get('faNo') || faInfo.faNo) && urlQuery.get('conId') && urlQuery.get('utm_source') && urlQuery.get('utm_source').toUpperCase() === 'FF';
    };
    const isSendToFAButtonDisplayed = ()=>{
        return displaySendToFAButton && !isFinancialFoundationsUser() && (!contactID || contactID && (0, $6UZN0.default)(timestamp));
    };
    const isFindAnFAButtonDisplayed = ()=>{
        return callerApp === 'StartingPoint' && (!financialAdvisorID || financialAdvisorID === '0') && (!entityID || entityID === '0');
    };
    const getValueStatementHeadersString = ()=>{
        const valueStatementHeaderArray = finalResultsStatementIds.map((statementId)=>{
            const value = valueList.find((value)=>statementId === value.statementId);
            return statementId === 15 ? 'Custom Text' : value.statementText;
        });
        return valueStatementHeaderArray.join('|');
    };
    (0, $acw62.useEffect)(()=>{
        (0, $fUEMe.default)('value-statements-displayed', {
            'value-statements-as-string': getValueStatementHeadersString()
        });
    }, [
        finalResultsStatementIds
    ]);
    const updatedFaInfo = {
        ...dataLayerInfo,
        page_type: "results-page"
    };
    const { setPreviousPath: setPreviousPath, previousPath: previousPath } = (0, $2DcdH.usePreviousPath)();
    const currentLocation = (0, $aphAM.useLocation)();
    const pageTitle = (0, $iJxY6.default)(locId, 'pageTitle', 'resultsPage');
    const pageReferrer = previousPath ? `${window.location.origin}${previousPath}${currentLocation.search}` : undefined;
    const pageURL = `${window.location.origin}${currentLocation.pathname}${currentLocation.search}`;
    const virtualPageInfo = {
        'pagePath': currentLocation.pathname,
        'pageTitle': pageTitle,
        'page_referrer': pageReferrer,
        'external_referrer': window.document.referrer && window.document.referrer.trim() !== '' ? window.document.referrer : undefined,
        'page_url': pageURL
    };
    (0, $acw62.useEffect)(()=>{
        setPreviousPath(currentLocation.pathname);
        (0, $fUEMe.default)("dataLayer-initialized", updatedFaInfo);
        (0, $fUEMe.default)('VirtualPageview', virtualPageInfo);
        if (topOfResults.current !== undefined) topOfResults.current.focus();
        ariaHideCarouselIndicators();
        document.title = pageTitle;
        (0, $fUEMe.default)('view-results', {});
        if (isSendToFAButtonDisplayed()) setDisplaySendResults(true);
        setTimeout(removeFocus, 1000);
    }, []);
    function ariaHideCarouselIndicators() {
        const ol = document.querySelector('.carousel-indicators');
        ol.setAttribute('aria-hidden', 'true');
    }
    function removeFocus() {
        const heading = document.getElementById('heading-no-focus');
        heading.removeAttribute('tabIndex');
    }
    function createResultsJSON() {
        const resultsObj = {};
        finalResultsStatementIds.forEach((result, index)=>{
            const statementId = result;
            const statementText = (0, $fKxvO.default)(result, valueList);
            const learnMoreContent = (0, $aU90w.default)(result, valueList);
            const learnMoreLinks = (0, $kgzQz.default)(result, valueList);
            const keyName = (index + 1).toString();
            resultsObj[keyName] = {
                statementId: statementId,
                statementText: statementText,
                learnMoreContent: learnMoreContent,
                learnMoreLinks: learnMoreLinks
            };
        });
        return resultsObj;
    }
    const handleDefaultDisplayNameText = ()=>{
        return sendResultsToFaText.replace('%FA_NAME%', faNameDefaultText);
    };
    const handleDisplayFaNameText = ()=>{
        if (displayFAName) return sendResultsToFaText.replace('%FA_NAME%', faFullName);
        return handleDefaultDisplayNameText();
    };
    const handleWhatsNextSendToFaHeadingText = ()=>{
        if (displayFAName) return whatsNextSendToFaHeadingText.replace('%FA_NAME%', faFullName);
        return whatsNextSendToFaHeadingText.replace('%FA_NAME%', yourFaNameDefaultText);
    };
    const handleWhatsNextSendToFaText = ()=>{
        if (displayFAName) return whatsNextSendToFaText.replace('%FA_NAME%', faFullName);
        return whatsNextSendToFaText.replace('%FA_NAME%', yourFaNameDefaultText);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "ResultsPage",
        className: "ResultsPage",
        children: [
            finalResultsStatementIds.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "youDidIt",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "banner",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    id: "heading-no-focus",
                                    className: "heading--semi-bold",
                                    ref: topOfResults,
                                    tabIndex: -1,
                                    children: contactName.firstName ? (0, $iJxY6.default)(locId, 'howYouRankedHeading', 'resultsPage').replace('%CONTACT_FIRSTNAME%', contactName.firstName) : (0, $iJxY6.default)(locId, 'howYouRankedHeadingContactUnkown', 'resultsPage')
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: (0, $iJxY6.default)(locId, 'topThreePriorities', 'resultsPage')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                className: "visually-hidden",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: (0, $fKxvO.default)(finalResultsStatementIds[0], valueList)
                                    }, finalResultsStatementIds[0]),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: (0, $fKxvO.default)(finalResultsStatementIds[1], valueList)
                                    }, finalResultsStatementIds[1]),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: (0, $fKxvO.default)(finalResultsStatementIds[2], valueList)
                                    }, finalResultsStatementIds[2])
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "results_topThree",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "results_podium",
                                "data-testid": "results_podium",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86M2b.default), {
                                    valueList: valueList,
                                    finalResults: finalResultsStatementIds,
                                    cardClassName: cardClassName,
                                    setCardClassName: setCardClassName
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "results_carousel",
                                "data-testid": "results_carousel",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3fhk.default), {
                                    valueList: valueList,
                                    finalResults: finalResultsStatementIds,
                                    cardClassName: cardClassName,
                                    setCardClassName: setCardClassName
                                })
                            })
                        ]
                    }),
                    notificationOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "inlineNotification_container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.InlineNotification), {
                            type: notificationContent.type,
                            text: notificationContent.message,
                            onClose: ()=>{
                                setNotificationOpen(false);
                            }
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "nowWhat",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "action_btns",
                            children: [
                                displaySendResults ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $duf9k.default), {
                                    coldContactData: coldContactData,
                                    contactName: contactName,
                                    setColdContactData: setColdContactData,
                                    setNotificationContent: setNotificationContent,
                                    setNotificationOpen: setNotificationOpen,
                                    userComments: userComments,
                                    setUserComments: setUserComments,
                                    faInfo: faInfo,
                                    sessionId: sessionId,
                                    resultsJSON: resultsJSON,
                                    sendResultsButtonDisabled: sendResultsButtonDisabled,
                                    setSendResultsButtonDisabled: setSendResultsButtonDisabled,
                                    buttonText: handleDisplayFaNameText()
                                }) : null,
                                !isFinancialFoundationsUser() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8cWO4.default), {
                                    setNotificationContent: setNotificationContent,
                                    setNotificationOpen: setNotificationOpen,
                                    displaySendToFAButton: displaySendResults,
                                    resultsJSON: resultsJSON,
                                    coldContactData: coldContactData,
                                    userComments: userComments,
                                    label: (0, $iJxY6.default)(locId, 'downloadPdf', 'resultsPage')
                                }) : null,
                                isFinancialFoundationsUser() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kiK3k.default), {
                                    setNotificationContent: setNotificationContent,
                                    setNotificationOpen: setNotificationOpen,
                                    sessionId: sessionId,
                                    resultsJSON: resultsJSON,
                                    faInfo: faInfo
                                }) : null,
                                isFindAnFAButtonDisplayed() ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: (0, $iJxY6.default)(locId, 'findFALink', 'resultsPage'),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    tabIndex: -1,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                                        label: (0, $iJxY6.default)(locId, 'findFAButton', 'resultsPage'),
                                        onClick: ()=>{},
                                        attributes: {
                                            value: '',
                                            id: 'find-fa',
                                            'data-testid': 'find-fa'
                                        }
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                                    label: (0, $iJxY6.default)(locId, 'restartQuiz', 'resultsPage'),
                                    onClick: ()=>{
                                        (0, $fUEMe.default)('restart-quiz', {});
                                        restartCallback();
                                    },
                                    attributes: {
                                        value: '',
                                        id: 'restart-button'
                                    },
                                    styleVariant: "secondary"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dnd-header",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: (0, $iJxY6.default)(locId, 'dndHeading', 'resultsPage')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: (0, $iJxY6.default)(locId, 'dndMessage', 'resultsPage')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89C3d.DndProvider), {
                        backend: isTouchDevice() ? (0, $145EN.TouchBackend) : (0, $6mQzc.HTML5Backend),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5W5zw.default), {
                            finalResultsStatementIds: finalResultsStatementIds,
                            valueList: valueList,
                            setFinalResultsStatementIds: setFinalResultsStatementIds
                        })
                    })
                ]
            }) : null,
            !isFinancialFoundationsUser() ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "whatNext",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: (0, $iJxY6.default)(locId, 'whatNext', 'resultsPage')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "cta_container",
                        children: [
                            displaySendResults ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "whatNext_container",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: handleWhatsNextSendToFaHeadingText()
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: handleWhatsNextSendToFaText()
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "action_btns",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $duf9k.default), {
                                            coldContactData: coldContactData,
                                            contactName: contactName,
                                            setColdContactData: setColdContactData,
                                            setNotificationContent: setNotificationContent,
                                            setNotificationOpen: setNotificationOpen,
                                            userComments: userComments,
                                            setUserComments: setUserComments,
                                            faInfo: faInfo,
                                            sessionId: sessionId,
                                            resultsJSON: resultsJSON,
                                            sendResultsButtonDisabled: sendResultsButtonDisabled,
                                            setSendResultsButtonDisabled: setSendResultsButtonDisabled,
                                            buttonText: handleDefaultDisplayNameText()
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "whatNext_container",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: (0, $iJxY6.default)(locId, 'whatNextDownloadHeading', 'resultsPage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: (0, $iJxY6.default)(locId, 'whatNextDownload', 'resultsPage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "action_btns",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8cWO4.default), {
                                            setNotificationContent: setNotificationContent,
                                            setNotificationOpen: setNotificationOpen,
                                            displaySendToFAButton: displaySendResults,
                                            resultsJSON: resultsJSON,
                                            coldContactData: coldContactData,
                                            userComments: userComments,
                                            label: (0, $iJxY6.default)(locId, 'downloadResults', 'resultsPage')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "shareQuiz_container",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: (0, $iJxY6.default)(locId, 'shareQuizHeading', 'resultsPage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: (0, $iJxY6.default)(locId, 'shareQuizMessage', 'resultsPage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "action_btns_container",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "copyLink_action_btn",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aO5Es.default), {})
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "shareQuiz_action_btn",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: (0, $iJxY6.default)(locId, 'shareLink', 'resultsPage')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1HW.default), {
                                                        icon: "/public/images/linkedin-icon.png",
                                                        socialMediaLink: (0, $iJxY6.default)(locId, 'linkedInUrl', 'resultsPage'),
                                                        title: (0, $iJxY6.default)(locId, 'socialMediaTitle', 'resultsPage').replace('%APP_NAME%', 'LinkedIn')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1HW.default), {
                                                        icon: "/public/images/facebook-icon.png",
                                                        socialMediaLink: (0, $iJxY6.default)(locId, 'faceBookUrl', 'resultsPage'),
                                                        title: (0, $iJxY6.default)(locId, 'socialMediaTitle', 'resultsPage').replace('%APP_NAME%', 'Facebook')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNFbw.default), {})
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "footer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "disclaimer",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "microcopy--2",
                        children: (0, $iJxY6.default)(locId, 'resultsPageDisclosure', 'resultsPage')
                    })
                })
            })
        ]
    });
};
$25730f9bf4e79896$var$ResultsPage.defaultProps = {
    contactID: '',
    contactName: null,
    financialAdvisorID: '',
    entityID: '',
    timestamp: '',
    callerApp: '',
    faInfo: null
};
$25730f9bf4e79896$var$ResultsPage.propTypes = {
    contactID: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    contactName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    financialAdvisorID: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    entityID: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    timestamp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    sessionId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    valueList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    finalResultsIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
    restartCallback: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    callerApp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    displaySendToFAButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    faInfo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        environment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        sessionId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        faNo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        fa_entity_id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }).isRequired
};
var $25730f9bf4e79896$export$2e2bcd8739ae039 = $25730f9bf4e79896$var$ResultsPage;

});
parcelRegister("89C3d", function(module, exports) {

$parcel$export(module.exports, "DndProvider", () => $5efcae14d81f2a61$export$9861489d68213f9c);

var $ayMG0 = parcelRequire("ayMG0");

var $ciz3K = parcelRequire("ciz3K");

var $acw62 = parcelRequire("acw62");

var $jpYzs = parcelRequire("jpYzs");
function $5efcae14d81f2a61$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5efcae14d81f2a61$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5efcae14d81f2a61$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $5efcae14d81f2a61$var$refCount = 0;
const $5efcae14d81f2a61$var$INSTANCE_SYM = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');
var $5efcae14d81f2a61$export$9861489d68213f9c = /*#__PURE__*/ (0, $acw62.memo)(function DndProvider(_param) {
    var { children: children } = _param, props = $5efcae14d81f2a61$var$_objectWithoutProperties(_param, [
        "children"
    ]);
    const [manager, isGlobalInstance] = $5efcae14d81f2a61$var$getDndContextValue(props) // memoized from props
    ;
    /**
		 * If the global context was used to store the DND context
		 * then where theres no more references to it we should
		 * clean it up to avoid memory leaks
		 */ (0, $acw62.useEffect)(()=>{
        if (isGlobalInstance) {
            const context = $5efcae14d81f2a61$var$getGlobalContext();
            ++$5efcae14d81f2a61$var$refCount;
            return ()=>{
                if (--$5efcae14d81f2a61$var$refCount === 0) context[$5efcae14d81f2a61$var$INSTANCE_SYM] = null;
            };
        }
        return;
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jpYzs.DndContext).Provider, {
        value: manager,
        children: children
    });
});
function $5efcae14d81f2a61$var$getDndContextValue(props) {
    if ('manager' in props) {
        const manager = {
            dragDropManager: props.manager
        };
        return [
            manager,
            false
        ];
    }
    const manager = $5efcae14d81f2a61$var$createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    const isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function $5efcae14d81f2a61$var$createSingletonDndContext(backend, context = $5efcae14d81f2a61$var$getGlobalContext(), options, debugMode) {
    const ctx = context;
    if (!ctx[$5efcae14d81f2a61$var$INSTANCE_SYM]) ctx[$5efcae14d81f2a61$var$INSTANCE_SYM] = {
        dragDropManager: (0, $ciz3K.createDragDropManager)(backend, context, options, debugMode)
    };
    return ctx[$5efcae14d81f2a61$var$INSTANCE_SYM];
}
function $5efcae14d81f2a61$var$getGlobalContext() {
    return typeof $parcel$global !== 'undefined' ? $parcel$global : window;
}

});
parcelRegister("ciz3K", function(module, exports) {

$parcel$export(module.exports, "createDragDropManager", () => $8f425c8f8284afc9$export$ff47aa43d5fd3e5d);

var $eShmq = parcelRequire("eShmq");

var $3dSPe = parcelRequire("3dSPe");

var $8vskJ = parcelRequire("8vskJ");

var $aU1EO = parcelRequire("aU1EO");

var $7XOcc = parcelRequire("7XOcc");
function $8f425c8f8284afc9$export$ff47aa43d5fd3e5d(backendFactory, globalContext, backendOptions = {}, debugMode = false) {
    const store = $8f425c8f8284afc9$var$makeStoreInstance(debugMode);
    const monitor = new (0, $8vskJ.DragDropMonitorImpl)(store, new (0, $aU1EO.HandlerRegistryImpl)(store));
    const manager = new (0, $3dSPe.DragDropManagerImpl)(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function $8f425c8f8284afc9$var$makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
    return (0, $eShmq.createStore)((0, $7XOcc.reduce), debugMode && reduxDevTools && reduxDevTools({
        name: 'dnd-core',
        instanceId: 'dnd-core'
    }));
}

});
parcelRegister("eShmq", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $ad4393542232627c$export$f51a9068ac82ea43);

var $d49SP = parcelRequire("d49SP");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($ad4393542232627c$var$isDate(val)) return 'date';
    if ($ad4393542232627c$var$isError(val)) return 'error';
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $ad4393542232627c$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $d49SP.default)((0, $d49SP.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});

parcelRegister("3dSPe", function(module, exports) {

$parcel$export(module.exports, "DragDropManagerImpl", () => $258d1d2eff99c8e9$export$1141bbf61324c55f);

var $5hL3e = parcelRequire("5hL3e");
class $258d1d2eff99c8e9$export$1141bbf61324c55f {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch: dispatch } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== 'undefined') dispatch(action);
            };
        }
        const actions = (0, $5hL3e.createDragDropActions)(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}

});
parcelRegister("5hL3e", function(module, exports) {
$parcel$export(module.exports, "BEGIN_DRAG", () => (parcelRequire("6faF1")).BEGIN_DRAG);
$parcel$export(module.exports, "DROP", () => (parcelRequire("6faF1")).DROP);
$parcel$export(module.exports, "END_DRAG", () => (parcelRequire("6faF1")).END_DRAG);
$parcel$export(module.exports, "HOVER", () => (parcelRequire("6faF1")).HOVER);
$parcel$export(module.exports, "INIT_COORDS", () => (parcelRequire("6faF1")).INIT_COORDS);
$parcel$export(module.exports, "PUBLISH_DRAG_SOURCE", () => (parcelRequire("6faF1")).PUBLISH_DRAG_SOURCE);

$parcel$export(module.exports, "createDragDropActions", () => $3d9309a3e8f06640$export$ac1b80e79f04247f);

var $cTqCW = parcelRequire("cTqCW");

var $9nS6K = parcelRequire("9nS6K");

var $9BgCU = parcelRequire("9BgCU");

var $92iIL = parcelRequire("92iIL");

var $9gedY = parcelRequire("9gedY");
parcelRequire("6faF1");
function $3d9309a3e8f06640$export$ac1b80e79f04247f(manager) {
    return {
        beginDrag: (0, $cTqCW.createBeginDrag)(manager),
        publishDragSource: (0, $9gedY.createPublishDragSource)(manager),
        hover: (0, $92iIL.createHover)(manager),
        drop: (0, $9nS6K.createDrop)(manager),
        endDrag: (0, $9BgCU.createEndDrag)(manager)
    };
}

});
parcelRegister("cTqCW", function(module, exports) {

$parcel$export(module.exports, "createBeginDrag", () => $962f46acaee6ebd7$export$d6542eb0d76867d6);

var $JSEe2 = parcelRequire("JSEe2");

var $2xXn5 = parcelRequire("2xXn5");

var $ggJDN = parcelRequire("ggJDN");

var $6faF1 = parcelRequire("6faF1");
const $962f46acaee6ebd7$var$ResetCoordinatesAction = {
    type: (0, $6faF1.INIT_COORDS),
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function $962f46acaee6ebd7$export$d6542eb0d76867d6(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource: publishSource = true, clientOffset: clientOffset, getSourceClientOffset: getSourceClientOffset } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch((0, $ggJDN.setClientOffset)(clientOffset));
        $962f46acaee6ebd7$var$verifyInvariants(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = $962f46acaee6ebd7$var$getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch($962f46acaee6ebd7$var$ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) throw new Error('getSourceClientOffset must be defined');
            $962f46acaee6ebd7$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch((0, $ggJDN.setClientOffset)(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) return undefined;
        $962f46acaee6ebd7$var$verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: (0, $6faF1.BEGIN_DRAG),
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function $962f46acaee6ebd7$var$verifyInvariants(sourceIds, monitor, registry) {
    (0, $JSEe2.invariant)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
    sourceIds.forEach(function(sourceId) {
        (0, $JSEe2.invariant)(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
    });
}
function $962f46acaee6ebd7$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    (0, $JSEe2.invariant)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}
function $962f46acaee6ebd7$var$verifyItemIsObject(item) {
    (0, $JSEe2.invariant)((0, $2xXn5.isObject)(item), 'Item must be an object.');
}
function $962f46acaee6ebd7$var$getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}

});
parcelRegister("JSEe2", function(module, exports) {

$parcel$export(module.exports, "invariant", () => $089e97ff993c55da$export$f5708dca728d7177);
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ function $089e97ff993c55da$export$f5708dca728d7177(condition, format, ...args) {
    if ($089e97ff993c55da$var$isProduction()) {
        if (format === undefined) throw new Error('invariant requires an error message argument');
    }
    if (!condition) {
        let error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function $089e97ff993c55da$var$isProduction() {
    return false;
}

});

parcelRegister("2xXn5", function(module, exports) {

$parcel$export(module.exports, "get", () => $1dacb7c0f38ea510$export$3988ae62b71be9a3);
$parcel$export(module.exports, "without", () => $1dacb7c0f38ea510$export$5d14bf425b37f49e);
$parcel$export(module.exports, "isObject", () => $1dacb7c0f38ea510$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "xor", () => $1dacb7c0f38ea510$export$6444ef5cd411280c);
$parcel$export(module.exports, "intersection", () => $1dacb7c0f38ea510$export$bc86dfbf7795668c);
// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ function $1dacb7c0f38ea510$export$3988ae62b71be9a3(obj, path, defaultValue) {
    return path.split('.').reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null, obj);
}
function $1dacb7c0f38ea510$export$5d14bf425b37f49e(items, item) {
    return items.filter((i)=>i !== item);
}
function $1dacb7c0f38ea510$export$844ec244b1367d54(input) {
    return typeof input === 'string';
}
function $1dacb7c0f38ea510$export$a6cdc56e425d0d0a(input) {
    return typeof input === 'object';
}
function $1dacb7c0f38ea510$export$6444ef5cd411280c(itemsA, itemsB) {
    const map = new Map();
    const insertItem = (item)=>{
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map.forEach((count, key)=>{
        if (count === 1) result.push(key);
    });
    return result;
}
function $1dacb7c0f38ea510$export$bc86dfbf7795668c(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1);
}

});

parcelRegister("ggJDN", function(module, exports) {

$parcel$export(module.exports, "setClientOffset", () => $bd818b49dc64ed07$export$844048139dfc906d);

var $6faF1 = parcelRequire("6faF1");
function $bd818b49dc64ed07$export$844048139dfc906d(clientOffset, sourceClientOffset) {
    return {
        type: (0, $6faF1.INIT_COORDS),
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}

});
parcelRegister("6faF1", function(module, exports) {

$parcel$export(module.exports, "INIT_COORDS", () => $48bc69bfe7b791cf$export$3fc3a33e48b33945);
$parcel$export(module.exports, "BEGIN_DRAG", () => $48bc69bfe7b791cf$export$98f9b4193e6b55e6);
$parcel$export(module.exports, "PUBLISH_DRAG_SOURCE", () => $48bc69bfe7b791cf$export$22d1d88e2de0d0e0);
$parcel$export(module.exports, "HOVER", () => $48bc69bfe7b791cf$export$9d358706ccac3727);
$parcel$export(module.exports, "DROP", () => $48bc69bfe7b791cf$export$b4af72c40fd57063);
$parcel$export(module.exports, "END_DRAG", () => $48bc69bfe7b791cf$export$d300627d16aeb9cc);
const $48bc69bfe7b791cf$export$3fc3a33e48b33945 = 'dnd-core/INIT_COORDS';
const $48bc69bfe7b791cf$export$98f9b4193e6b55e6 = 'dnd-core/BEGIN_DRAG';
const $48bc69bfe7b791cf$export$22d1d88e2de0d0e0 = 'dnd-core/PUBLISH_DRAG_SOURCE';
const $48bc69bfe7b791cf$export$9d358706ccac3727 = 'dnd-core/HOVER';
const $48bc69bfe7b791cf$export$b4af72c40fd57063 = 'dnd-core/DROP';
const $48bc69bfe7b791cf$export$d300627d16aeb9cc = 'dnd-core/END_DRAG';

});



parcelRegister("9nS6K", function(module, exports) {

$parcel$export(module.exports, "createDrop", () => $6d503bbfe2267d95$export$9f5cbae8d079dda0);

var $JSEe2 = parcelRequire("JSEe2");

var $2xXn5 = parcelRequire("2xXn5");

var $6faF1 = parcelRequire("6faF1");
function $6d503bbfe2267d95$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6d503bbfe2267d95$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $6d503bbfe2267d95$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $6d503bbfe2267d95$export$9f5cbae8d079dda0(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $6d503bbfe2267d95$var$verifyInvariants(monitor);
        const targetIds = $6d503bbfe2267d95$var$getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = $6d503bbfe2267d95$var$determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: (0, $6faF1.DROP),
                payload: {
                    dropResult: $6d503bbfe2267d95$var$_objectSpread({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function $6d503bbfe2267d95$var$verifyInvariants(monitor) {
    (0, $JSEe2.invariant)(monitor.isDragging(), 'Cannot call drop while not dragging.');
    (0, $JSEe2.invariant)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}
function $6d503bbfe2267d95$var$determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    $6d503bbfe2267d95$var$verifyDropResultType(dropResult);
    if (typeof dropResult === 'undefined') dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function $6d503bbfe2267d95$var$verifyDropResultType(dropResult) {
    (0, $JSEe2.invariant)(typeof dropResult === 'undefined' || (0, $2xXn5.isObject)(dropResult), 'Drop result must either be an object or undefined.');
}
function $6d503bbfe2267d95$var$getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}

});

parcelRegister("9BgCU", function(module, exports) {

$parcel$export(module.exports, "createEndDrag", () => $6fd4776e187d0a07$export$2f5c7d4805260fdf);

var $JSEe2 = parcelRequire("JSEe2");

var $6faF1 = parcelRequire("6faF1");
function $6fd4776e187d0a07$export$2f5c7d4805260fdf(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $6fd4776e187d0a07$var$verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: (0, $6faF1.END_DRAG)
        };
    };
}
function $6fd4776e187d0a07$var$verifyIsDragging(monitor) {
    (0, $JSEe2.invariant)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}

});

parcelRegister("92iIL", function(module, exports) {

$parcel$export(module.exports, "createHover", () => $6942d28b7c712c0e$export$2f85b44a1d72ad03);

var $JSEe2 = parcelRequire("JSEe2");

var $cZ6pE = parcelRequire("cZ6pE");

var $6faF1 = parcelRequire("6faF1");
function $6942d28b7c712c0e$export$2f85b44a1d72ad03(manager) {
    return function hover(targetIdsArg, { clientOffset: clientOffset } = {}) {
        $6942d28b7c712c0e$var$verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        const draggedItemType = monitor.getItemType();
        $6942d28b7c712c0e$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        $6942d28b7c712c0e$var$checkInvariants(targetIds, monitor, registry);
        $6942d28b7c712c0e$var$hoverAllTargets(targetIds, monitor, registry);
        return {
            type: (0, $6faF1.HOVER),
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function $6942d28b7c712c0e$var$verifyTargetIdsIsArray(targetIdsArg) {
    (0, $JSEe2.invariant)(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}
function $6942d28b7c712c0e$var$checkInvariants(targetIds, monitor, registry) {
    (0, $JSEe2.invariant)(monitor.isDragging(), 'Cannot call hover while not dragging.');
    (0, $JSEe2.invariant)(!monitor.didDrop(), 'Cannot call hover after drop.');
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        (0, $JSEe2.invariant)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
        const target = registry.getTarget(targetId);
        (0, $JSEe2.invariant)(target, 'Expected targetIds to be registered.');
    }
}
function $6942d28b7c712c0e$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!(0, $cZ6pE.matchesType)(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function $6942d28b7c712c0e$var$hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}

});
parcelRegister("cZ6pE", function(module, exports) {

$parcel$export(module.exports, "matchesType", () => $974027fd97df8b86$export$2d6239ff106f142f);
function $974027fd97df8b86$export$2d6239ff106f142f(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType) : targetType === draggedItemType;
}

});


parcelRegister("9gedY", function(module, exports) {

$parcel$export(module.exports, "createPublishDragSource", () => $6be0a456b0880ec9$export$1675a481db21e714);

var $6faF1 = parcelRequire("6faF1");
function $6be0a456b0880ec9$export$1675a481db21e714(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: (0, $6faF1.PUBLISH_DRAG_SOURCE)
        };
        return;
    };
}

});



parcelRegister("8vskJ", function(module, exports) {

$parcel$export(module.exports, "DragDropMonitorImpl", () => $6317326c01c73ba4$export$e220263e518daaed);

var $JSEe2 = parcelRequire("JSEe2");

var $lRSFq = parcelRequire("lRSFq");

var $4eeHJ = parcelRequire("4eeHJ");

var $cZ6pE = parcelRequire("cZ6pE");
class $6317326c01c73ba4$export$e220263e518daaed {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds: handlerIds } = options;
        (0, $JSEe2.invariant)(typeof listener === 'function', 'listener must be a function.');
        (0, $JSEe2.invariant)(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, $4eeHJ.areDirty)(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) listener();
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        (0, $JSEe2.invariant)(typeof listener === 'function', 'listener must be a function.');
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) return;
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId);
        (0, $JSEe2.invariant)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) return false;
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) return false;
        const target = this.registry.getTarget(targetId);
        (0, $JSEe2.invariant)(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return (0, $cZ6pE.matchesType)(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId, true);
        (0, $JSEe2.invariant)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) return false;
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) return false;
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) return false;
        const { shallow: shallow } = options;
        if (!this.isDragging()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !(0, $cZ6pE.matchesType)(targetType, draggedItemType)) return false;
        const targetIds = this.getTargetIds();
        if (!targetIds.length) return false;
        const index = targetIds.indexOf(targetId);
        if (shallow) return index === targetIds.length - 1;
        else return index > -1;
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return (0, $lRSFq.getSourceClientOffset)(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return (0, $lRSFq.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}

});
parcelRegister("lRSFq", function(module, exports) {

$parcel$export(module.exports, "getSourceClientOffset", () => $feb8f3f899e606b8$export$b6a5970fca17c71e);
$parcel$export(module.exports, "getDifferenceFromInitialOffset", () => $feb8f3f899e606b8$export$b57ee1a41eb1620b);
/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $feb8f3f899e606b8$export$e16d8520af44a096(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function $feb8f3f899e606b8$export$4e2d2ead65e5f7e3(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $feb8f3f899e606b8$export$b6a5970fca17c71e(state) {
    const { clientOffset: clientOffset, initialClientOffset: initialClientOffset, initialSourceClientOffset: initialSourceClientOffset } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return $feb8f3f899e606b8$export$4e2d2ead65e5f7e3($feb8f3f899e606b8$export$e16d8520af44a096(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function $feb8f3f899e606b8$export$b57ee1a41eb1620b(state) {
    const { clientOffset: clientOffset, initialClientOffset: initialClientOffset } = state;
    if (!clientOffset || !initialClientOffset) return null;
    return $feb8f3f899e606b8$export$4e2d2ead65e5f7e3(clientOffset, initialClientOffset);
}

});

parcelRegister("4eeHJ", function(module, exports) {

$parcel$export(module.exports, "NONE", () => $3143e037c38403c2$export$c53d0f541b41b88e);
$parcel$export(module.exports, "ALL", () => $3143e037c38403c2$export$61b49a5ae59d663);
$parcel$export(module.exports, "areDirty", () => $3143e037c38403c2$export$3347776eeed47180);

var $2xXn5 = parcelRequire("2xXn5");
const $3143e037c38403c2$export$c53d0f541b41b88e = [];
const $3143e037c38403c2$export$61b49a5ae59d663 = [];
$3143e037c38403c2$export$c53d0f541b41b88e.__IS_NONE__ = true;
$3143e037c38403c2$export$61b49a5ae59d663.__IS_ALL__ = true;
function $3143e037c38403c2$export$3347776eeed47180(dirtyIds, handlerIds) {
    if (dirtyIds === $3143e037c38403c2$export$c53d0f541b41b88e) return false;
    if (dirtyIds === $3143e037c38403c2$export$61b49a5ae59d663 || typeof handlerIds === 'undefined') return true;
    const commonIds = (0, $2xXn5.intersection)(handlerIds, dirtyIds);
    return commonIds.length > 0;
}

});


parcelRegister("aU1EO", function(module, exports) {

$parcel$export(module.exports, "HandlerRegistryImpl", () => $7f006b74dfbeade6$export$60ceab237232d5db);
parcelRequire("bG5QV");
var $7grKL = parcelRequire("7grKL");

var $JSEe2 = parcelRequire("JSEe2");

var $4Yr5z = parcelRequire("4Yr5z");

var $gKe07 = parcelRequire("gKe07");

var $6w6bA = parcelRequire("6w6bA");

var $DDncl = parcelRequire("DDncl");
function $7f006b74dfbeade6$var$getNextHandlerId(role) {
    const id = (0, $DDncl.getNextUniqueId)().toString();
    switch(role){
        case (0, $6w6bA.HandlerRole).SOURCE:
            return `S${id}`;
        case (0, $6w6bA.HandlerRole).TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function $7f006b74dfbeade6$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case 'S':
            return (0, $6w6bA.HandlerRole).SOURCE;
        case 'T':
            return (0, $6w6bA.HandlerRole).TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function $7f006b74dfbeade6$var$mapContainsValue(map, searchValue) {
    const entries = map.entries();
    let isDone = false;
    do {
        const { done: done, value: [, value] } = entries.next();
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
class $7f006b74dfbeade6$export$60ceab237232d5db {
    addSource(type, source) {
        (0, $gKe07.validateType)(type);
        (0, $gKe07.validateSourceContract)(source);
        const sourceId = this.addHandler((0, $6w6bA.HandlerRole).SOURCE, type, source);
        this.store.dispatch((0, $4Yr5z.addSource)(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        (0, $gKe07.validateType)(type, true);
        (0, $gKe07.validateTargetContract)(target);
        const targetId = this.addHandler((0, $6w6bA.HandlerRole).TARGET, type, target);
        this.store.dispatch((0, $4Yr5z.addTarget)(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return $7f006b74dfbeade6$var$mapContainsValue(this.dragSources, handler) || $7f006b74dfbeade6$var$mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        (0, $JSEe2.invariant)(this.isSourceId(sourceId), 'Expected a valid source ID.');
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        (0, $JSEe2.invariant)(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        (0, $JSEe2.invariant)(this.isSourceId(sourceId), 'Expected a valid source ID.');
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        (0, $JSEe2.invariant)(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = $7f006b74dfbeade6$var$parseRoleFromHandlerId(handlerId);
        return role === (0, $6w6bA.HandlerRole).SOURCE;
    }
    isTargetId(handlerId) {
        const role = $7f006b74dfbeade6$var$parseRoleFromHandlerId(handlerId);
        return role === (0, $6w6bA.HandlerRole).TARGET;
    }
    removeSource(sourceId) {
        (0, $JSEe2.invariant)(this.getSource(sourceId), 'Expected an existing source.');
        this.store.dispatch((0, $4Yr5z.removeSource)(sourceId));
        (0, $7grKL.asap)(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        (0, $JSEe2.invariant)(this.getTarget(targetId), 'Expected an existing target.');
        this.store.dispatch((0, $4Yr5z.removeTarget)(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        (0, $JSEe2.invariant)(source, 'Expected an existing source.');
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        (0, $JSEe2.invariant)(this.pinnedSource, 'No source is pinned at the time.');
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = $7f006b74dfbeade6$var$getNextHandlerId(role);
        this.types.set(id, type);
        if (role === (0, $6w6bA.HandlerRole).SOURCE) this.dragSources.set(id, handler);
        else if (role === (0, $6w6bA.HandlerRole).TARGET) this.dropTargets.set(id, handler);
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}

});
parcelRegister("bG5QV", function(module, exports) {
$parcel$export(module.exports, "asap", () => (parcelRequire("7grKL")).asap);
parcelRequire("7grKL");
parcelRequire("1Y8dM");
parcelRequire("ecnpT");
parcelRequire("d3n2D");

});
parcelRegister("7grKL", function(module, exports) {

$parcel$export(module.exports, "asap", () => $549f8e3dc127b3fb$export$dc4d482300a341e1);

var $1Y8dM = parcelRequire("1Y8dM");

var $ecnpT = parcelRequire("ecnpT");
const $549f8e3dc127b3fb$var$asapQueue = new (0, $1Y8dM.AsapQueue)();
const $549f8e3dc127b3fb$var$taskFactory = new (0, $ecnpT.TaskFactory)($549f8e3dc127b3fb$var$asapQueue.registerPendingError);
function $549f8e3dc127b3fb$export$dc4d482300a341e1(task) {
    $549f8e3dc127b3fb$var$asapQueue.enqueueTask($549f8e3dc127b3fb$var$taskFactory.create(task));
}

});
parcelRegister("1Y8dM", function(module, exports) {

$parcel$export(module.exports, "AsapQueue", () => $16f1c59c99c75ee8$export$d3f0708de0e313ed);
/* eslint-disable no-restricted-globals, @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-non-null-assertion */ 
var $5q4nv = parcelRequire("5q4nv");
class $16f1c59c99c75ee8$export$d3f0708de0e313ed {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q, requestFlush: requestFlush } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = (0, $5q4nv.makeRequestCall)(this.flush);
        this.requestErrorThrow = (0, $5q4nv.makeRequestCallFromTimer)(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
 // original foundation for this library.
 // http://www.nonblocking.io/2011/06/windownexttick.html
 // Safari 6.0.5 (at least) intermittently fails to create message ports on a
 // page's first load. Thankfully, this version of Safari supports
 // MutationObservers, so we don't need to fall back in that case.
 // function makeRequestCallFromMessageChannel(callback) {
 //     var channel = new MessageChannel();
 //     channel.port1.onmessage = callback;
 //     return function requestCall() {
 //         channel.port2.postMessage(0);
 //     };
 // }
 // For reasons explained above, we are also unable to use `setImmediate`
 // under any circumstances.
 // Even if we were, there is another bug in Internet Explorer 10.
 // It is not sufficient to assign `setImmediate` to `requestFlush` because
 // `setImmediate` must be called *by name* and therefore must be wrapped in a
 // closure.
 // Never forget.
 // function makeRequestCallFromSetImmediate(callback) {
 //     return function requestCall() {
 //         setImmediate(callback);
 //     };
 // }
 // Safari 6.0 has a problem where timers will get lost while the user is
 // scrolling. This problem does not impact ASAP because Safari 6.0 supports
 // mutation observers, so that implementation is used instead.
 // However, if we ever elect to use timers in Safari, the prevalent work-around
 // is to add a scroll event listener that calls for a flush.
 // `setTimeout` does not call the passed callback if the delay is less than
 // approximately 7 in web workers in Firefox 8 through 18, and sometimes not
 // even then.
 // This is for `asap.js` only.
 // Its name will be periodically randomized to break any code that depends on
 // // its existence.
 // rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
 // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

});
parcelRegister("5q4nv", function(module, exports) {

$parcel$export(module.exports, "makeRequestCallFromTimer", () => $3f22c6dd9c872de9$export$27a7cafb047f3c77);
$parcel$export(module.exports, "makeRequestCall", () => $3f22c6dd9c872de9$export$29545a1340296ce3);
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const $3f22c6dd9c872de9$var$scope = typeof $parcel$global !== 'undefined' ? $parcel$global : self;
const $3f22c6dd9c872de9$var$BrowserMutationObserver = $3f22c6dd9c872de9$var$scope.MutationObserver || $3f22c6dd9c872de9$var$scope.WebKitMutationObserver;
function $3f22c6dd9c872de9$export$27a7cafb047f3c77(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
function $3f22c6dd9c872de9$export$2785f4493cc9ca62(callback) {
    let toggle = 1;
    const observer = new $3f22c6dd9c872de9$var$BrowserMutationObserver(callback);
    const node = document.createTextNode('');
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const $3f22c6dd9c872de9$export$29545a1340296ce3 = typeof $3f22c6dd9c872de9$var$BrowserMutationObserver === 'function' ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
$3f22c6dd9c872de9$export$2785f4493cc9ca62 : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
$3f22c6dd9c872de9$export$27a7cafb047f3c77;

});


parcelRegister("ecnpT", function(module, exports) {

$parcel$export(module.exports, "TaskFactory", () => $a56459bfe3bb65ad$export$4577931b6c22c63b);

var $leAWY = parcelRequire("leAWY");
class $a56459bfe3bb65ad$export$4577931b6c22c63b {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new (0, $leAWY.RawTask)(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}

});
parcelRegister("leAWY", function(module, exports) {

$parcel$export(module.exports, "RawTask", () => $f757915593fc87ce$export$c84b69da61b33d93);
// `call`, just like a function.
class $f757915593fc87ce$export$c84b69da61b33d93 {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}

});



parcelRegister("d3n2D", function(module, exports) {

});


parcelRegister("4Yr5z", function(module, exports) {

$parcel$export(module.exports, "ADD_SOURCE", () => $39f1c74b9dd3b4bd$export$b36933c81fb1c092);
$parcel$export(module.exports, "ADD_TARGET", () => $39f1c74b9dd3b4bd$export$2c313542981556ae);
$parcel$export(module.exports, "REMOVE_SOURCE", () => $39f1c74b9dd3b4bd$export$13332566b98b8783);
$parcel$export(module.exports, "REMOVE_TARGET", () => $39f1c74b9dd3b4bd$export$82ace346d17d8869);
$parcel$export(module.exports, "addSource", () => $39f1c74b9dd3b4bd$export$bc333c64f07a75c4);
$parcel$export(module.exports, "addTarget", () => $39f1c74b9dd3b4bd$export$9dd68fe78f37278b);
$parcel$export(module.exports, "removeSource", () => $39f1c74b9dd3b4bd$export$c724aacd61334138);
$parcel$export(module.exports, "removeTarget", () => $39f1c74b9dd3b4bd$export$20ae7ec87f7f8696);
const $39f1c74b9dd3b4bd$export$b36933c81fb1c092 = 'dnd-core/ADD_SOURCE';
const $39f1c74b9dd3b4bd$export$2c313542981556ae = 'dnd-core/ADD_TARGET';
const $39f1c74b9dd3b4bd$export$13332566b98b8783 = 'dnd-core/REMOVE_SOURCE';
const $39f1c74b9dd3b4bd$export$82ace346d17d8869 = 'dnd-core/REMOVE_TARGET';
function $39f1c74b9dd3b4bd$export$bc333c64f07a75c4(sourceId) {
    return {
        type: $39f1c74b9dd3b4bd$export$b36933c81fb1c092,
        payload: {
            sourceId: sourceId
        }
    };
}
function $39f1c74b9dd3b4bd$export$9dd68fe78f37278b(targetId) {
    return {
        type: $39f1c74b9dd3b4bd$export$2c313542981556ae,
        payload: {
            targetId: targetId
        }
    };
}
function $39f1c74b9dd3b4bd$export$c724aacd61334138(sourceId) {
    return {
        type: $39f1c74b9dd3b4bd$export$13332566b98b8783,
        payload: {
            sourceId: sourceId
        }
    };
}
function $39f1c74b9dd3b4bd$export$20ae7ec87f7f8696(targetId) {
    return {
        type: $39f1c74b9dd3b4bd$export$82ace346d17d8869,
        payload: {
            targetId: targetId
        }
    };
}

});

parcelRegister("gKe07", function(module, exports) {

$parcel$export(module.exports, "validateSourceContract", () => $c30bcd7fed669010$export$a7a13c013ce18993);
$parcel$export(module.exports, "validateTargetContract", () => $c30bcd7fed669010$export$77d3cd1340fdeb5a);
$parcel$export(module.exports, "validateType", () => $c30bcd7fed669010$export$831a593efd22380d);

var $JSEe2 = parcelRequire("JSEe2");
function $c30bcd7fed669010$export$a7a13c013ce18993(source) {
    (0, $JSEe2.invariant)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
    (0, $JSEe2.invariant)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
    (0, $JSEe2.invariant)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function $c30bcd7fed669010$export$77d3cd1340fdeb5a(target) {
    (0, $JSEe2.invariant)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
    (0, $JSEe2.invariant)(typeof target.hover === 'function', 'Expected hover to be a function.');
    (0, $JSEe2.invariant)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function $c30bcd7fed669010$export$831a593efd22380d(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>$c30bcd7fed669010$export$831a593efd22380d(t, false));
        return;
    }
    (0, $JSEe2.invariant)(typeof type === 'string' || typeof type === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

});

parcelRegister("6w6bA", function(module, exports) {

$parcel$export(module.exports, "HandlerRole", () => $4bea87a2a6751515$export$bb8f0843d7d66cb0);
var $4bea87a2a6751515$export$bb8f0843d7d66cb0;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})($4bea87a2a6751515$export$bb8f0843d7d66cb0 || ($4bea87a2a6751515$export$bb8f0843d7d66cb0 = {}));

});

parcelRegister("DDncl", function(module, exports) {

$parcel$export(module.exports, "getNextUniqueId", () => $07722f52b994806b$export$dbfb29c8f2c7bb44);
let $07722f52b994806b$var$nextUniqueId = 0;
function $07722f52b994806b$export$dbfb29c8f2c7bb44() {
    return $07722f52b994806b$var$nextUniqueId++;
}

});


parcelRegister("7XOcc", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $5cc4faf0c74cfdd1$export$533b26079ad0b4b);

var $2xXn5 = parcelRequire("2xXn5");

var $aQPTn = parcelRequire("aQPTn");

var $6l3QM = parcelRequire("6l3QM");

var $cbDEV = parcelRequire("cbDEV");

var $dkYP3 = parcelRequire("dkYP3");

var $7rwjJ = parcelRequire("7rwjJ");
function $5cc4faf0c74cfdd1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5cc4faf0c74cfdd1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $5cc4faf0c74cfdd1$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $5cc4faf0c74cfdd1$export$533b26079ad0b4b(state = {}, action) {
    return {
        dirtyHandlerIds: (0, $aQPTn.reduce)(state.dirtyHandlerIds, {
            type: action.type,
            payload: $5cc4faf0c74cfdd1$var$_objectSpread({}, action.payload, {
                prevTargetIds: (0, $2xXn5.get)(state, 'dragOperation.targetIds', [])
            })
        }),
        dragOffset: (0, $6l3QM.reduce)(state.dragOffset, action),
        refCount: (0, $dkYP3.reduce)(state.refCount, action),
        dragOperation: (0, $cbDEV.reduce)(state.dragOperation, action),
        stateId: (0, $7rwjJ.reduce)(state.stateId)
    };
}

});
parcelRegister("aQPTn", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $7e67036b97240921$export$533b26079ad0b4b);

var $6faF1 = parcelRequire("6faF1");

var $4Yr5z = parcelRequire("4Yr5z");

var $4eeHJ = parcelRequire("4eeHJ");

var $gomSJ = parcelRequire("gomSJ");

var $2xXn5 = parcelRequire("2xXn5");
function $7e67036b97240921$export$533b26079ad0b4b(_state = (0, $4eeHJ.NONE), action) {
    switch(action.type){
        case 0, $6faF1.HOVER:
            break;
        case 0, $4Yr5z.ADD_SOURCE:
        case 0, $4Yr5z.ADD_TARGET:
        case 0, $4Yr5z.REMOVE_TARGET:
        case 0, $4Yr5z.REMOVE_SOURCE:
            return 0, $4eeHJ.NONE;
        case 0, $6faF1.BEGIN_DRAG:
        case 0, $6faF1.PUBLISH_DRAG_SOURCE:
        case 0, $6faF1.END_DRAG:
        case 0, $6faF1.DROP:
        default:
            return 0, $4eeHJ.ALL;
    }
    const { targetIds: targetIds = [], prevTargetIds: prevTargetIds = [] } = action.payload;
    const result = (0, $2xXn5.xor)(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !(0, $gomSJ.areArraysEqual)(targetIds, prevTargetIds);
    if (!didChange) return 0, $4eeHJ.NONE;
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}

});
parcelRegister("gomSJ", function(module, exports) {

$parcel$export(module.exports, "areCoordsEqual", () => $bef0a3103a6df97d$export$102b20725d4d2263);
$parcel$export(module.exports, "areArraysEqual", () => $bef0a3103a6df97d$export$94fd53d40f0652a);
const $bef0a3103a6df97d$export$2116cbe61f6a442a = (a, b)=>a === b;
function $bef0a3103a6df97d$export$102b20725d4d2263(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function $bef0a3103a6df97d$export$94fd53d40f0652a(a, b, isEqual = $bef0a3103a6df97d$export$2116cbe61f6a442a) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}

});


parcelRegister("6l3QM", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $49d7b0da0f4ada6f$export$533b26079ad0b4b);

var $6faF1 = parcelRequire("6faF1");

var $gomSJ = parcelRequire("gomSJ");
function $49d7b0da0f4ada6f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $49d7b0da0f4ada6f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $49d7b0da0f4ada6f$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const $49d7b0da0f4ada6f$var$initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $49d7b0da0f4ada6f$export$533b26079ad0b4b(state = $49d7b0da0f4ada6f$var$initialState, action) {
    const { payload: payload } = action;
    switch(action.type){
        case 0, $6faF1.INIT_COORDS:
        case 0, $6faF1.BEGIN_DRAG:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case 0, $6faF1.HOVER:
            if ((0, $gomSJ.areCoordsEqual)(state.clientOffset, payload.clientOffset)) return state;
            return $49d7b0da0f4ada6f$var$_objectSpread({}, state, {
                clientOffset: payload.clientOffset
            });
        case 0, $6faF1.END_DRAG:
        case 0, $6faF1.DROP:
            return $49d7b0da0f4ada6f$var$initialState;
        default:
            return state;
    }
}

});

parcelRegister("cbDEV", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $8df54694a0363721$export$533b26079ad0b4b);

var $6faF1 = parcelRequire("6faF1");

var $4Yr5z = parcelRequire("4Yr5z");

var $2xXn5 = parcelRequire("2xXn5");
function $8df54694a0363721$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8df54694a0363721$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $8df54694a0363721$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const $8df54694a0363721$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $8df54694a0363721$export$533b26079ad0b4b(state = $8df54694a0363721$var$initialState, action) {
    const { payload: payload } = action;
    switch(action.type){
        case 0, $6faF1.BEGIN_DRAG:
            return $8df54694a0363721$var$_objectSpread({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case 0, $6faF1.PUBLISH_DRAG_SOURCE:
            return $8df54694a0363721$var$_objectSpread({}, state, {
                isSourcePublic: true
            });
        case 0, $6faF1.HOVER:
            return $8df54694a0363721$var$_objectSpread({}, state, {
                targetIds: payload.targetIds
            });
        case 0, $4Yr5z.REMOVE_TARGET:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return $8df54694a0363721$var$_objectSpread({}, state, {
                targetIds: (0, $2xXn5.without)(state.targetIds, payload.targetId)
            });
        case 0, $6faF1.DROP:
            return $8df54694a0363721$var$_objectSpread({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case 0, $6faF1.END_DRAG:
            return $8df54694a0363721$var$_objectSpread({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}

});

parcelRegister("dkYP3", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $9b5c52b5e49a8e13$export$533b26079ad0b4b);

var $4Yr5z = parcelRequire("4Yr5z");
function $9b5c52b5e49a8e13$export$533b26079ad0b4b(state = 0, action) {
    switch(action.type){
        case 0, $4Yr5z.ADD_SOURCE:
        case 0, $4Yr5z.ADD_TARGET:
            return state + 1;
        case 0, $4Yr5z.REMOVE_SOURCE:
        case 0, $4Yr5z.REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}

});

parcelRegister("7rwjJ", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $56b41f89b66a4cf6$export$533b26079ad0b4b);
function $56b41f89b66a4cf6$export$533b26079ad0b4b(state = 0) {
    return state + 1;
}

});



parcelRegister("jpYzs", function(module, exports) {

$parcel$export(module.exports, "DndContext", () => $e22f563e49421000$export$2d5c5ceac203fc1e);

var $acw62 = parcelRequire("acw62");
const $e22f563e49421000$export$2d5c5ceac203fc1e = (0, $acw62.createContext)({
    dragDropManager: undefined
});

});


parcelRegister("6mQzc", function(module, exports) {

$parcel$export(module.exports, "HTML5Backend", () => $4a2d92d5bc16c08e$export$f4f61d779bb20744);

var $cHBMb = parcelRequire("cHBMb");


const $4a2d92d5bc16c08e$export$f4f61d779bb20744 = function createBackend(manager, context, options) {
    return new (0, $cHBMb.HTML5BackendImpl)(manager, context, options);
};

});
parcelRegister("cHBMb", function(module, exports) {

$parcel$export(module.exports, "HTML5BackendImpl", () => $93f6cdc20f312006$export$3a01990c235a9281);

var $94uBU = parcelRequire("94uBU");

var $5tBCf = parcelRequire("5tBCf");

var $eDvMN = parcelRequire("eDvMN");

var $9TN1r = parcelRequire("9TN1r");

var $alUVT = parcelRequire("alUVT");
function $93f6cdc20f312006$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $93f6cdc20f312006$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $93f6cdc20f312006$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
class $93f6cdc20f312006$export$3a01990c235a9281 {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref, ref1;
        return {
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            sourceNodeOptions: this.sourceNodeOptions.size,
            sourceNodes: this.sourceNodes.size,
            dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
            dropTargetIds: this.dropTargetIds.length,
            dragEnterTargetIds: this.dragEnterTargetIds.length,
            dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
        };
    }
    // public for test
    get window() {
        return this.options.window;
    }
    get document() {
        return this.options.document;
    }
    /**
	 * Get the root element to use for event subscriptions
	 */ get rootElement() {
        return this.options.rootElement;
    }
    setup() {
        const root = this.rootElement;
        if (root === undefined) return;
        if (root.__isReactDndBackendSetUp) throw new Error('Cannot have two HTML5 backends at the same time.');
        root.__isReactDndBackendSetUp = true;
        this.addEventListeners(root);
    }
    teardown() {
        const root = this.rootElement;
        if (root === undefined) return;
        root.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.rootElement);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            var ref;
            (ref = this.window) === null || ref === void 0 || ref.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDragSource(sourceId, node, options) {
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        const handleDragStart = (e)=>this.handleDragStart(e, sourceId);
        const handleSelectStart = (e)=>this.handleSelectStart(e);
        node.setAttribute('draggable', 'true');
        node.addEventListener('dragstart', handleDragStart);
        node.addEventListener('selectstart', handleSelectStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener('dragstart', handleDragStart);
            node.removeEventListener('selectstart', handleSelectStart);
            node.setAttribute('draggable', 'false');
        };
    }
    connectDropTarget(targetId, node) {
        const handleDragEnter = (e)=>this.handleDragEnter(e, targetId);
        const handleDragOver = (e)=>this.handleDragOver(e, targetId);
        const handleDrop = (e)=>this.handleDrop(e, targetId);
        node.addEventListener('dragenter', handleDragEnter);
        node.addEventListener('dragover', handleDragOver);
        node.addEventListener('drop', handleDrop);
        return ()=>{
            node.removeEventListener('dragenter', handleDragEnter);
            node.removeEventListener('dragover', handleDragOver);
            node.removeEventListener('drop', handleDrop);
        };
    }
    addEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) return;
        target.addEventListener('dragstart', this.handleTopDragStart);
        target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
        target.addEventListener('dragend', this.handleTopDragEndCapture, true);
        target.addEventListener('dragenter', this.handleTopDragEnter);
        target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
        target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
        target.addEventListener('dragover', this.handleTopDragOver);
        target.addEventListener('dragover', this.handleTopDragOverCapture, true);
        target.addEventListener('drop', this.handleTopDrop);
        target.addEventListener('drop', this.handleTopDropCapture, true);
    }
    removeEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) return;
        target.removeEventListener('dragstart', this.handleTopDragStart);
        target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
        target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
        target.removeEventListener('dragenter', this.handleTopDragEnter);
        target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
        target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
        target.removeEventListener('dragover', this.handleTopDragOver);
        target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
        target.removeEventListener('drop', this.handleTopDrop);
        target.removeEventListener('drop', this.handleTopDropCapture, true);
    }
    getCurrentSourceNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return $93f6cdc20f312006$var$_objectSpread({
            dropEffect: this.altKeyPressed ? 'copy' : 'move'
        }, sourceNodeOptions || {});
    }
    getCurrentDropEffect() {
        if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
        return 'copy';
        return this.getCurrentSourceNodeOptions().dropEffect;
    }
    getCurrentSourcePreviewNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return $93f6cdc20f312006$var$_objectSpread({
            anchorX: 0.5,
            anchorY: 0.5,
            captureDraggingState: false
        }, sourcePreviewNodeOptions || {});
    }
    isDraggingNativeItem() {
        const itemType = this.monitor.getItemType();
        return Object.keys($eDvMN).some((key)=>$eDvMN[key] === itemType);
    }
    beginDragNativeItem(type, dataTransfer) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = (0, $5tBCf.createNativeDragSource)(type, dataTransfer);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([
            this.currentNativeHandle
        ]);
    }
    setCurrentDragSourceNode(node) {
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        const MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(()=>{
            var ref;
            return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
        }, MOUSE_MOVE_TIMEOUT);
    }
    clearCurrentDragSourceNode() {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.rootElement) {
                var ref;
                (ref = this.window) === null || ref === void 0 || ref.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.rootElement.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    }
    handleDragStart(e, sourceId) {
        if (e.defaultPrevented) return;
        if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
        this.dragStartSourceIds.unshift(sourceId);
    }
    handleDragEnter(_e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    }
    handleDragOver(_e, targetId) {
        if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
        this.dragOverTargetIds.unshift(targetId);
    }
    handleDrop(_e, targetId) {
        this.dropTargetIds.unshift(targetId);
    }
    constructor(manager, globalContext, options){
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.lastClientOffset = null;
        this.hoverRafId = null;
        this.getSourceClientOffset = (sourceId)=>{
            const source = this.sourceNodes.get(sourceId);
            return source && (0, $9TN1r.getNodeClientOffset)(source) || null;
        };
        this.endDragNativeItem = ()=>{
            if (!this.isDraggingNativeItem()) return;
            this.actions.endDrag();
            if (this.currentNativeHandle) this.registry.removeSource(this.currentNativeHandle);
            this.currentNativeHandle = null;
            this.currentNativeSource = null;
        };
        this.isNodeInDocument = (node)=>{
            // Check the node either in the main document or in the current context
            return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
        };
        this.endDragIfSourceWasRemovedFromDOM = ()=>{
            const node = this.currentDragSourceNode;
            if (node == null || this.isNodeInDocument(node)) return;
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.scheduleHover = (dragOverTargetIds)=>{
            if (this.hoverRafId === null && typeof requestAnimationFrame !== 'undefined') this.hoverRafId = requestAnimationFrame(()=>{
                if (this.monitor.isDragging()) this.actions.hover(dragOverTargetIds || [], {
                    clientOffset: this.lastClientOffset
                });
                this.hoverRafId = null;
            });
        };
        this.cancelHover = ()=>{
            if (this.hoverRafId !== null && typeof cancelAnimationFrame !== 'undefined') {
                cancelAnimationFrame(this.hoverRafId);
                this.hoverRafId = null;
            }
        };
        this.handleTopDragStartCapture = ()=>{
            this.clearCurrentDragSourceNode();
            this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = (e)=>{
            if (e.defaultPrevented) return;
            const { dragStartSourceIds: dragStartSourceIds } = this;
            this.dragStartSourceIds = null;
            const clientOffset = (0, $9TN1r.getEventClientOffset)(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (this.monitor.isDragging()) {
                this.actions.endDrag();
                this.cancelHover();
            }
            // Don't publish the source just yet (see why below)
            this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset: clientOffset
            });
            const { dataTransfer: dataTransfer } = e;
            const nativeType = (0, $5tBCf.matchNativeItemType)(dataTransfer);
            if (this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    const sourceId = this.monitor.getSourceId();
                    const sourceNode = this.sourceNodes.get(sourceId);
                    const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        const { anchorX: anchorX, anchorY: anchorY, offsetX: offsetX, offsetY: offsetY } = this.getCurrentSourcePreviewNodeOptions();
                        const anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        const offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        const dragPreviewOffset = (0, $9TN1r.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 || dataTransfer.setData('application/json', {});
                } catch (err) {
                // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                const { captureDraggingState: captureDraggingState } = this.getCurrentSourcePreviewNodeOptions();
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(()=>this.actions.publishDragSource(), 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute('draggable'))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        };
        this.handleTopDragEndCapture = ()=>{
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            this.actions.endDrag();
            this.cancelHover();
        };
        this.handleTopDragEnterCapture = (e)=>{
            this.dragEnterTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
            const isFirstEnter = this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || this.monitor.isDragging()) return;
            const { dataTransfer: dataTransfer } = e;
            const nativeType = (0, $5tBCf.matchNativeItemType)(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            this.beginDragNativeItem(nativeType, dataTransfer);
        };
        this.handleTopDragEnter = (e)=>{
            const { dragEnterTargetIds: dragEnterTargetIds } = this;
            this.dragEnterTargetIds = [];
            if (!this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            this.altKeyPressed = e.altKey;
            // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) this.actions.hover(dragEnterTargetIds, {
                clientOffset: (0, $9TN1r.getEventClientOffset)(e)
            });
            const canDrop = dragEnterTargetIds.some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            }
        };
        this.handleTopDragOverCapture = (e)=>{
            this.dragOverTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
        };
        this.handleTopDragOver = (e)=>{
            const { dragOverTargetIds: dragOverTargetIds } = this;
            this.dragOverTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = 'none';
                return;
            }
            this.altKeyPressed = e.altKey;
            this.lastClientOffset = (0, $9TN1r.getEventClientOffset)(e);
            this.scheduleHover(dragOverTargetIds);
            const canDrop = (dragOverTargetIds || []).some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            } else if (this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = 'none';
            }
        };
        this.handleTopDragLeaveCapture = (e)=>{
            if (this.isDraggingNativeItem()) e.preventDefault();
            const isLastLeave = this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (this.isDraggingNativeItem()) setTimeout(()=>this.endDragNativeItem(), 0);
            this.cancelHover();
        };
        this.handleTopDropCapture = (e)=>{
            this.dropTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                e.preventDefault();
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            } else if ((0, $5tBCf.matchNativeItemType)(e.dataTransfer)) // Dragging some elements, like <a> and <img> may still behave like a native drag event,
            // even if the current drag event matches a user-defined type.
            // Stop the default behavior when we're not expecting a native item to be dropped.
            e.preventDefault();
            this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = (e)=>{
            const { dropTargetIds: dropTargetIds } = this;
            this.dropTargetIds = [];
            this.actions.hover(dropTargetIds, {
                clientOffset: (0, $9TN1r.getEventClientOffset)(e)
            });
            this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
            });
            if (this.isDraggingNativeItem()) this.endDragNativeItem();
            else if (this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.handleSelectStart = (e)=>{
            const target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== 'function') return;
            // Inputs and textareas should be selectable
            if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return;
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new (0, $alUVT.OptionsReader)(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new (0, $94uBU.EnterLeaveCounter)(this.isNodeInDocument);
    }
}

});
parcelRegister("94uBU", function(module, exports) {

$parcel$export(module.exports, "EnterLeaveCounter", () => $69ac3b5d5d6ccca0$export$9ff3e6eb5c734d0d);

var $ecq7N = parcelRequire("ecq7N");
class $69ac3b5d5d6ccca0$export$9ff3e6eb5c734d0d {
    enter(enteringNode) {
        const previousLength = this.entered.length;
        const isNodeEntered = (node)=>this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
        this.entered = (0, $ecq7N.union)(this.entered.filter(isNodeEntered), [
            enteringNode
        ]);
        return previousLength === 0 && this.entered.length > 0;
    }
    leave(leavingNode) {
        const previousLength = this.entered.length;
        this.entered = (0, $ecq7N.without)(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    }
    reset() {
        this.entered = [];
    }
    constructor(isNodeInDocument){
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
}

});
parcelRegister("ecq7N", function(module, exports) {

$parcel$export(module.exports, "memoize", () => $a5667381a9e5976e$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "without", () => $a5667381a9e5976e$export$5d14bf425b37f49e);
$parcel$export(module.exports, "union", () => $a5667381a9e5976e$export$971dd5b0dfd021b6);
// cheap lodash replacements
function $a5667381a9e5976e$export$fc10aeed3a532e2a(fn) {
    let result = null;
    const memoized = ()=>{
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
function $a5667381a9e5976e$export$5d14bf425b37f49e(items, item) {
    return items.filter((i)=>i !== item);
}
function $a5667381a9e5976e$export$971dd5b0dfd021b6(itemsA, itemsB) {
    const set = new Set();
    const insertItem = (item)=>set.add(item);
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    set.forEach((key)=>result.push(key));
    return result;
}

});


parcelRegister("5tBCf", function(module, exports) {

$parcel$export(module.exports, "createNativeDragSource", () => $3fccd6f051d01e09$export$ada362c01636774d);
$parcel$export(module.exports, "matchNativeItemType", () => $3fccd6f051d01e09$export$11b547ed8c182c11);

var $lP1xC = parcelRequire("lP1xC");

var $7t6h5 = parcelRequire("7t6h5");
function $3fccd6f051d01e09$export$ada362c01636774d(type, dataTransfer) {
    const config = (0, $7t6h5.nativeTypesConfig)[type];
    if (!config) throw new Error(`native type ${type} has no configuration`);
    const result = new (0, $lP1xC.NativeDragSource)(config);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function $3fccd6f051d01e09$export$11b547ed8c182c11(dataTransfer) {
    if (!dataTransfer) return null;
    const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys((0, $7t6h5.nativeTypesConfig)).filter((nativeItemType)=>{
        const typeConfig = (0, $7t6h5.nativeTypesConfig)[nativeItemType];
        if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) return false;
        return typeConfig.matchesTypes.some((t)=>dataTransferTypes.indexOf(t) > -1);
    })[0] || null;
}

});
parcelRegister("lP1xC", function(module, exports) {

$parcel$export(module.exports, "NativeDragSource", () => $fe2f8e72d980c933$export$f22384f077cf51c4);
class $fe2f8e72d980c933$export$f22384f077cf51c4 {
    initializeExposedProperties() {
        Object.keys(this.config.exposeProperties).forEach((property)=>{
            Object.defineProperty(this.item, property, {
                configurable: true,
                enumerable: true,
                get () {
                    // eslint-disable-next-line no-console
                    console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
                    return null;
                }
            });
        });
    }
    loadDataTransfer(dataTransfer) {
        if (dataTransfer) {
            const newProperties = {};
            Object.keys(this.config.exposeProperties).forEach((property)=>{
                const propertyFn = this.config.exposeProperties[property];
                if (propertyFn != null) newProperties[property] = {
                    value: propertyFn(dataTransfer, this.config.matchesTypes),
                    configurable: true,
                    enumerable: true
                };
            });
            Object.defineProperties(this.item, newProperties);
        }
    }
    canDrag() {
        return true;
    }
    beginDrag() {
        return this.item;
    }
    isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
    }
    endDrag() {
    // empty
    }
    constructor(config){
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
}

});

parcelRegister("7t6h5", function(module, exports) {

$parcel$export(module.exports, "nativeTypesConfig", () => $57001bd4a1edcf82$export$8cc89d9b8cb1bd88);

var $eDvMN = parcelRequire("eDvMN");

var $4p44p = parcelRequire("4p44p");
const $57001bd4a1edcf82$export$8cc89d9b8cb1bd88 = {
    [$eDvMN.FILE]: {
        exposeProperties: {
            files: (dataTransfer)=>Array.prototype.slice.call(dataTransfer.files),
            items: (dataTransfer)=>dataTransfer.items,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Files'
        ]
    },
    [$eDvMN.HTML]: {
        exposeProperties: {
            html: (dataTransfer, matchesTypes)=>(0, $4p44p.getDataFromDataTransfer)(dataTransfer, matchesTypes, ''),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Html',
            'text/html'
        ]
    },
    [$eDvMN.URL]: {
        exposeProperties: {
            urls: (dataTransfer, matchesTypes)=>(0, $4p44p.getDataFromDataTransfer)(dataTransfer, matchesTypes, '').split('\n'),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Url',
            'text/uri-list'
        ]
    },
    [$eDvMN.TEXT]: {
        exposeProperties: {
            text: (dataTransfer, matchesTypes)=>(0, $4p44p.getDataFromDataTransfer)(dataTransfer, matchesTypes, ''),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Text',
            'text/plain'
        ]
    }
};

});
parcelRegister("eDvMN", function(module, exports) {

$parcel$export(module.exports, "FILE", () => $aa7d5d3de84f6f0c$export$1802dbfd31b58482);
$parcel$export(module.exports, "URL", () => $aa7d5d3de84f6f0c$export$61abde59b50deb8e);
$parcel$export(module.exports, "TEXT", () => $aa7d5d3de84f6f0c$export$d597759d33be802e);
$parcel$export(module.exports, "HTML", () => $aa7d5d3de84f6f0c$export$9dcd2b1ca4768128);
const $aa7d5d3de84f6f0c$export$1802dbfd31b58482 = '__NATIVE_FILE__';
const $aa7d5d3de84f6f0c$export$61abde59b50deb8e = '__NATIVE_URL__';
const $aa7d5d3de84f6f0c$export$d597759d33be802e = '__NATIVE_TEXT__';
const $aa7d5d3de84f6f0c$export$9dcd2b1ca4768128 = '__NATIVE_HTML__';

});

parcelRegister("4p44p", function(module, exports) {

$parcel$export(module.exports, "getDataFromDataTransfer", () => $334ca777f3706e47$export$dc02f6a7b68f305f);
function $334ca777f3706e47$export$dc02f6a7b68f305f(dataTransfer, typesToTry, defaultValue) {
    const result = typesToTry.reduce((resultSoFar, typeToTry)=>resultSoFar || dataTransfer.getData(typeToTry), '');
    return result != null ? result : defaultValue;
}

});



parcelRegister("9TN1r", function(module, exports) {

$parcel$export(module.exports, "getNodeClientOffset", () => $734f46ea78f1e67d$export$8419e8612027b1d8);
$parcel$export(module.exports, "getEventClientOffset", () => $734f46ea78f1e67d$export$710c829989c68339);
$parcel$export(module.exports, "getDragPreviewOffset", () => $734f46ea78f1e67d$export$e99fdbb90efc75c5);

var $4kOql = parcelRequire("4kOql");

var $lqf9c = parcelRequire("lqf9c");
const $734f46ea78f1e67d$var$ELEMENT_NODE = 1;
function $734f46ea78f1e67d$export$8419e8612027b1d8(node) {
    const el = node.nodeType === $734f46ea78f1e67d$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return null;
    const { top: top, left: left } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $734f46ea78f1e67d$export$710c829989c68339(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function $734f46ea78f1e67d$var$isImageNode(node) {
    var ref;
    return node.nodeName === 'IMG' && ((0, $4kOql.isFirefox)() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function $734f46ea78f1e67d$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    let dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    let dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if ((0, $4kOql.isSafari)() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function $734f46ea78f1e67d$export$e99fdbb90efc75c5(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    const isImage = $734f46ea78f1e67d$var$isImageNode(dragPreview);
    const dragPreviewNode = isImage ? sourceNode : dragPreview;
    const dragPreviewNodeOffsetFromClient = $734f46ea78f1e67d$export$8419e8612027b1d8(dragPreviewNode);
    const offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    const { offsetWidth: sourceWidth, offsetHeight: sourceHeight } = sourceNode;
    const { anchorX: anchorX, anchorY: anchorY } = anchorPoint;
    const { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight } = $734f46ea78f1e67d$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight);
    const calculateYOffset = ()=>{
        const interpolantY = new (0, $lqf9c.MonotonicInterpolant)([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        let y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if ((0, $4kOql.isSafari)() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    const calculateXOffset = ()=>{
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        const interpolantX = new (0, $lqf9c.MonotonicInterpolant)([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    const { offsetX: offsetX, offsetY: offsetY } = offsetPoint;
    const isManualOffsetX = offsetX === 0 || offsetX;
    const isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}

});
parcelRegister("4kOql", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $328024cd95bf5908$export$b7d78993b74f766d);
$parcel$export(module.exports, "isSafari", () => $328024cd95bf5908$export$95df08bae54cb4df);

var $ecq7N = parcelRequire("ecq7N");
const $328024cd95bf5908$export$b7d78993b74f766d = (0, $ecq7N.memoize)(()=>/firefox/i.test(navigator.userAgent));
const $328024cd95bf5908$export$95df08bae54cb4df = (0, $ecq7N.memoize)(()=>Boolean(window.safari));

});

parcelRegister("lqf9c", function(module, exports) {

$parcel$export(module.exports, "MonotonicInterpolant", () => $f987c6a8b5f47deb$export$6d87c156c5199b02);
class $f987c6a8b5f47deb$export$6d87c156c5199b02 {
    interpolate(x) {
        const { xs: xs, ys: ys, c1s: c1s, c2s: c2s, c3s: c3s } = this;
        // The rightmost point in the dataset should give an exact result
        let i = xs.length - 1;
        if (x === xs[i]) return ys[i];
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        let low = 0;
        let high = c3s.length - 1;
        let mid;
        while(low <= high){
            mid = Math.floor(0.5 * (low + high));
            const xHere = xs[mid];
            if (xHere < x) low = mid + 1;
            else if (xHere > x) high = mid - 1;
            else return ys[mid];
        }
        i = Math.max(0, high);
        // Interpolate
        const diff = x - xs[i];
        const diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
    constructor(xs, ys){
        const { length: length } = xs;
        // Rearrange xs and ys so that xs is sorted
        const indexes = [];
        for(let i = 0; i < length; i++)indexes.push(i);
        indexes.sort((a, b)=>xs[a] < xs[b] ? -1 : 1);
        // Get consecutive differences and slopes
        const dys = [];
        const dxs = [];
        const ms = [];
        let dx;
        let dy;
        for(let i1 = 0; i1 < length - 1; i1++){
            dx = xs[i1 + 1] - xs[i1];
            dy = ys[i1 + 1] - ys[i1];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        const c1s = [
            ms[0]
        ];
        for(let i2 = 0; i2 < dxs.length - 1; i2++){
            const m2 = ms[i2];
            const mNext = ms[i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[i2];
                const dxNext = dxs[i2 + 1];
                const common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        const c2s = [];
        const c3s = [];
        let m;
        for(let i3 = 0; i3 < c1s.length - 1; i3++){
            m = ms[i3];
            const c1 = c1s[i3];
            const invDx = 1 / dxs[i3];
            const common = c1 + c1s[i3 + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
}

});


parcelRegister("alUVT", function(module, exports) {

$parcel$export(module.exports, "OptionsReader", () => $78980735a3a4c8fe$export$2b3a268803e49e64);
class $78980735a3a4c8fe$export$2b3a268803e49e64 {
    get window() {
        if (this.globalContext) return this.globalContext;
        else if (typeof window !== 'undefined') return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) return this.globalContext.document;
        else if (this.window) return this.window.document;
        else return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
    constructor(globalContext, options){
        this.ownerDocument = null;
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
}

});



parcelRegister("145EN", function(module, exports) {

$parcel$export(module.exports, "TouchBackend", () => $0c6a8d877a6e3cde$export$b4d0180dbe086f87);

var $cGWx1 = parcelRequire("cGWx1");

const $0c6a8d877a6e3cde$export$b4d0180dbe086f87 = function createBackend(manager, context = {}, options = {}) {
    return new (0, $cGWx1.TouchBackendImpl)(manager, context, options);
};

});
parcelRegister("cGWx1", function(module, exports) {

$parcel$export(module.exports, "TouchBackendImpl", () => $93d6cf72e508f30e$export$d96f7f27c2e7d149);

var $JSEe2 = parcelRequire("JSEe2");

var $frT2v = parcelRequire("frT2v");

var $lyAq4 = parcelRequire("lyAq4");

var $foZIt = parcelRequire("foZIt");

var $gA3MM = parcelRequire("gA3MM");

var $jlZnl = parcelRequire("jlZnl");

var $iyb5z = parcelRequire("iyb5z");
const $93d6cf72e508f30e$var$eventNames = {
    [(0, $frT2v.ListenerType).mouse]: {
        start: 'mousedown',
        move: 'mousemove',
        end: 'mouseup',
        contextmenu: 'contextmenu'
    },
    [(0, $frT2v.ListenerType).touch]: {
        start: 'touchstart',
        move: 'touchmove',
        end: 'touchend'
    },
    [(0, $frT2v.ListenerType).keyboard]: {
        keydown: 'keydown'
    }
};
class $93d6cf72e508f30e$export$d96f7f27c2e7d149 {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref;
        return {
            sourceNodes: this.sourceNodes.size,
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            targetNodes: this.targetNodes.size,
            dragOverTargetIds: ((ref = this.dragOverTargetIds) === null || ref === void 0 ? void 0 : ref.length) || 0
        };
    }
    // public for test
    get document() {
        return this.options.document;
    }
    setup() {
        const root = this.options.rootElement;
        if (!root) return;
        (0, $JSEe2.invariant)(!$93d6cf72e508f30e$export$d96f7f27c2e7d149.isSetUp, 'Cannot have two Touch backends at the same time.');
        $93d6cf72e508f30e$export$d96f7f27c2e7d149.isSetUp = true;
        this.addEventListener(root, 'start', this.getTopMoveStartHandler());
        this.addEventListener(root, 'start', this.handleTopMoveStartCapture, true);
        this.addEventListener(root, 'move', this.handleTopMove);
        this.addEventListener(root, 'move', this.handleTopMoveCapture, true);
        this.addEventListener(root, 'end', this.handleTopMoveEndCapture, true);
        if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.addEventListener(root, 'contextmenu', this.handleTopMoveEndCapture);
        if (this.options.enableKeyboardEvents) this.addEventListener(root, 'keydown', this.handleCancelOnEscape, true);
    }
    teardown() {
        const root = this.options.rootElement;
        if (!root) return;
        $93d6cf72e508f30e$export$d96f7f27c2e7d149.isSetUp = false;
        this._mouseClientOffset = {};
        this.removeEventListener(root, 'start', this.handleTopMoveStartCapture, true);
        this.removeEventListener(root, 'start', this.handleTopMoveStart);
        this.removeEventListener(root, 'move', this.handleTopMoveCapture, true);
        this.removeEventListener(root, 'move', this.handleTopMove);
        this.removeEventListener(root, 'end', this.handleTopMoveEndCapture, true);
        if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.removeEventListener(root, 'contextmenu', this.handleTopMoveEndCapture);
        if (this.options.enableKeyboardEvents) this.removeEventListener(root, 'keydown', this.handleCancelOnEscape, true);
        this.uninstallSourceNodeRemovalObserver();
    }
    addEventListener(subject, event, handler, capture = false) {
        const options = (0, $iyb5z.supportsPassive) ? {
            capture: capture,
            passive: false
        } : capture;
        this.listenerTypes.forEach(function(listenerType) {
            const evt = $93d6cf72e508f30e$var$eventNames[listenerType][event];
            if (evt) subject.addEventListener(evt, handler, options);
        });
    }
    removeEventListener(subject, event, handler, capture = false) {
        const options = (0, $iyb5z.supportsPassive) ? {
            capture: capture,
            passive: false
        } : capture;
        this.listenerTypes.forEach(function(listenerType) {
            const evt = $93d6cf72e508f30e$var$eventNames[listenerType][event];
            if (evt) subject.removeEventListener(evt, handler, options);
        });
    }
    connectDragSource(sourceId, node) {
        const handleMoveStart = this.handleMoveStart.bind(this, sourceId);
        this.sourceNodes.set(sourceId, node);
        this.addEventListener(node, 'start', handleMoveStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.removeEventListener(node, 'start', handleMoveStart);
        };
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDropTarget(targetId, node) {
        const root = this.options.rootElement;
        if (!this.document || !root) return ()=>{
        /* noop */ };
        const handleMove = (e)=>{
            if (!this.document || !root || !this.monitor.isDragging()) return;
            let coords;
            /**
			 * Grab the coordinates for the current mouse/touch position
			 */ switch(e.type){
                case $93d6cf72e508f30e$var$eventNames.mouse.move:
                    coords = {
                        x: e.clientX,
                        y: e.clientY
                    };
                    break;
                case $93d6cf72e508f30e$var$eventNames.touch.move:
                    var ref, ref1;
                    coords = {
                        x: ((ref = e.touches[0]) === null || ref === void 0 ? void 0 : ref.clientX) || 0,
                        y: ((ref1 = e.touches[0]) === null || ref1 === void 0 ? void 0 : ref1.clientY) || 0
                    };
                    break;
            }
            /**
			 * Use the coordinates to grab the element the drag ended on.
			 * If the element is the same as the target node (or any of it's children) then we have hit a drop target and can handle the move.
			 */ const droppedOn = coords != null ? this.document.elementFromPoint(coords.x, coords.y) : undefined;
            const childMatch = droppedOn && node.contains(droppedOn);
            if (droppedOn === node || childMatch) return this.handleMove(e, targetId);
        };
        /**
		 * Attaching the event listener to the body so that touchmove will work while dragging over multiple target elements.
		 */ this.addEventListener(this.document.body, 'move', handleMove);
        this.targetNodes.set(targetId, node);
        return ()=>{
            if (this.document) {
                this.targetNodes.delete(targetId);
                this.removeEventListener(this.document.body, 'move', handleMove);
            }
        };
    }
    getTopMoveStartHandler() {
        if (!this.options.delayTouchStart && !this.options.delayMouseStart) return this.handleTopMoveStart;
        return this.handleTopMoveStartDelay;
    }
    installSourceNodeRemovalObserver(node) {
        this.uninstallSourceNodeRemovalObserver();
        this.draggedSourceNode = node;
        this.draggedSourceNodeRemovalObserver = new MutationObserver(()=>{
            if (node && !node.parentElement) {
                this.resurrectSourceNode();
                this.uninstallSourceNodeRemovalObserver();
            }
        });
        if (!node || !node.parentElement) return;
        this.draggedSourceNodeRemovalObserver.observe(node.parentElement, {
            childList: true
        });
    }
    resurrectSourceNode() {
        if (this.document && this.draggedSourceNode) {
            this.draggedSourceNode.style.display = 'none';
            this.draggedSourceNode.removeAttribute('data-reactid');
            this.document.body.appendChild(this.draggedSourceNode);
        }
    }
    uninstallSourceNodeRemovalObserver() {
        if (this.draggedSourceNodeRemovalObserver) this.draggedSourceNodeRemovalObserver.disconnect();
        this.draggedSourceNodeRemovalObserver = undefined;
        this.draggedSourceNode = undefined;
    }
    constructor(manager, context, options){
        this.getSourceClientOffset = (sourceId)=>{
            const element = this.sourceNodes.get(sourceId);
            return element && (0, $gA3MM.getNodeClientOffset)(element);
        };
        this.handleTopMoveStartCapture = (e)=>{
            if (!(0, $jlZnl.eventShouldStartDrag)(e)) return;
            this.moveStartSourceIds = [];
        };
        this.handleMoveStart = (sourceId)=>{
            // Just because we received an event doesn't necessarily mean we need to collect drag sources.
            // We only collect start collecting drag sources on touch and left mouse events.
            if (Array.isArray(this.moveStartSourceIds)) this.moveStartSourceIds.unshift(sourceId);
        };
        this.handleTopMoveStart = (e)=>{
            if (!(0, $jlZnl.eventShouldStartDrag)(e)) return;
            // Don't prematurely preventDefault() here since it might:
            // 1. Mess up scrolling
            // 2. Mess up long tap (which brings up context menu)
            // 3. If there's an anchor link as a child, tap won't be triggered on link
            const clientOffset = (0, $gA3MM.getEventClientOffset)(e);
            if (clientOffset) {
                if ((0, $jlZnl.isTouchEvent)(e)) this.lastTargetTouchFallback = e.targetTouches[0];
                this._mouseClientOffset = clientOffset;
            }
            this.waitingForDelay = false;
        };
        this.handleTopMoveStartDelay = (e)=>{
            if (!(0, $jlZnl.eventShouldStartDrag)(e)) return;
            const delay = e.type === $93d6cf72e508f30e$var$eventNames.touch.start ? this.options.delayTouchStart : this.options.delayMouseStart;
            this.timeout = setTimeout(this.handleTopMoveStart.bind(this, e), delay);
            this.waitingForDelay = true;
        };
        this.handleTopMoveCapture = ()=>{
            this.dragOverTargetIds = [];
        };
        this.handleMove = (_evt, targetId)=>{
            if (this.dragOverTargetIds) this.dragOverTargetIds.unshift(targetId);
        };
        this.handleTopMove = (e1)=>{
            if (this.timeout) clearTimeout(this.timeout);
            if (!this.document || this.waitingForDelay) return;
            const { moveStartSourceIds: moveStartSourceIds, dragOverTargetIds: dragOverTargetIds } = this;
            const enableHoverOutsideTarget = this.options.enableHoverOutsideTarget;
            const clientOffset = (0, $gA3MM.getEventClientOffset)(e1, this.lastTargetTouchFallback);
            if (!clientOffset) return;
            // If the touch move started as a scroll, or is is between the scroll angles
            if (this._isScrolling || !this.monitor.isDragging() && (0, $foZIt.inAngleRanges)(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y, this.options.scrollAngleRanges)) {
                this._isScrolling = true;
                return;
            }
            // If we're not dragging and we've moved a little, that counts as a drag start
            if (!this.monitor.isDragging() && // eslint-disable-next-line no-prototype-builtins
            this._mouseClientOffset.hasOwnProperty('x') && moveStartSourceIds && (0, $foZIt.distance)(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y) > (this.options.touchSlop ? this.options.touchSlop : 0)) {
                this.moveStartSourceIds = undefined;
                this.actions.beginDrag(moveStartSourceIds, {
                    clientOffset: this._mouseClientOffset,
                    getSourceClientOffset: this.getSourceClientOffset,
                    publishSource: false
                });
            }
            if (!this.monitor.isDragging()) return;
            const sourceNode = this.sourceNodes.get(this.monitor.getSourceId());
            this.installSourceNodeRemovalObserver(sourceNode);
            this.actions.publishDragSource();
            if (e1.cancelable) e1.preventDefault();
            // Get the node elements of the hovered DropTargets
            const dragOverTargetNodes = (dragOverTargetIds || []).map((key)=>this.targetNodes.get(key)).filter((e)=>!!e);
            // Get the a ordered list of nodes that are touched by
            const elementsAtPoint = this.options.getDropTargetElementsAtPoint ? this.options.getDropTargetElementsAtPoint(clientOffset.x, clientOffset.y, dragOverTargetNodes) : this.document.elementsFromPoint(clientOffset.x, clientOffset.y);
            // Extend list with parents that are not receiving elementsFromPoint events (size 0 elements and svg groups)
            const elementsAtPointExtended = [];
            for(const nodeId in elementsAtPoint){
                // eslint-disable-next-line no-prototype-builtins
                if (!elementsAtPoint.hasOwnProperty(nodeId)) continue;
                let currentNode = elementsAtPoint[nodeId];
                if (currentNode != null) elementsAtPointExtended.push(currentNode);
                while(currentNode){
                    currentNode = currentNode.parentElement;
                    if (currentNode && elementsAtPointExtended.indexOf(currentNode) === -1) elementsAtPointExtended.push(currentNode);
                }
            }
            const orderedDragOverTargetIds = elementsAtPointExtended // Filter off nodes that arent a hovered DropTargets nodes
            .filter((node)=>dragOverTargetNodes.indexOf(node) > -1) // Map back the nodes elements to targetIds
            .map((node)=>this._getDropTargetId(node)) // Filter off possible null rows
            .filter((node)=>!!node).filter((id, index, ids)=>ids.indexOf(id) === index);
            // Invoke hover for drop targets when source node is still over and pointer is outside
            if (enableHoverOutsideTarget) for(const targetId in this.targetNodes){
                const targetNode = this.targetNodes.get(targetId);
                if (sourceNode && targetNode && targetNode.contains(sourceNode) && orderedDragOverTargetIds.indexOf(targetId) === -1) {
                    orderedDragOverTargetIds.unshift(targetId);
                    break;
                }
            }
            // Reverse order because dnd-core reverse it before calling the DropTarget drop methods
            orderedDragOverTargetIds.reverse();
            this.actions.hover(orderedDragOverTargetIds, {
                clientOffset: clientOffset
            });
        };
        /**
	 *
	 * visible for testing
	 */ this._getDropTargetId = (node)=>{
            const keys = this.targetNodes.keys();
            let next = keys.next();
            while(next.done === false){
                const targetId = next.value;
                if (node === this.targetNodes.get(targetId)) return targetId;
                else next = keys.next();
            }
            return undefined;
        };
        this.handleTopMoveEndCapture = (e)=>{
            this._isScrolling = false;
            this.lastTargetTouchFallback = undefined;
            if (!(0, $jlZnl.eventShouldEndDrag)(e)) return;
            if (!this.monitor.isDragging() || this.monitor.didDrop()) {
                this.moveStartSourceIds = undefined;
                return;
            }
            if (e.cancelable) e.preventDefault();
            this._mouseClientOffset = {};
            this.uninstallSourceNodeRemovalObserver();
            this.actions.drop();
            this.actions.endDrag();
        };
        this.handleCancelOnEscape = (e)=>{
            if (e.key === 'Escape' && this.monitor.isDragging()) {
                this._mouseClientOffset = {};
                this.uninstallSourceNodeRemovalObserver();
                this.actions.endDrag();
            }
        };
        this.options = new (0, $lyAq4.OptionsReader)(options, context);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.sourceNodes = new Map();
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.targetNodes = new Map();
        this.listenerTypes = [];
        this._mouseClientOffset = {};
        this._isScrolling = false;
        if (this.options.enableMouseEvents) this.listenerTypes.push((0, $frT2v.ListenerType).mouse);
        if (this.options.enableTouchEvents) this.listenerTypes.push((0, $frT2v.ListenerType).touch);
        if (this.options.enableKeyboardEvents) this.listenerTypes.push((0, $frT2v.ListenerType).keyboard);
    }
}

});
parcelRegister("frT2v", function(module, exports) {

$parcel$export(module.exports, "ListenerType", () => $b3f41253d4fdf905$export$77315d8e4e38ac8f);
var $b3f41253d4fdf905$export$77315d8e4e38ac8f;
(function(ListenerType) {
    ListenerType["mouse"] = "mouse";
    ListenerType["touch"] = "touch";
    ListenerType["keyboard"] = "keyboard";
})($b3f41253d4fdf905$export$77315d8e4e38ac8f || ($b3f41253d4fdf905$export$77315d8e4e38ac8f = {}));

});

parcelRegister("lyAq4", function(module, exports) {

$parcel$export(module.exports, "OptionsReader", () => $fb19061394eb4d63$export$2b3a268803e49e64);
class $fb19061394eb4d63$export$2b3a268803e49e64 {
    get delay() {
        var _delay;
        return (_delay = this.args.delay) !== null && _delay !== void 0 ? _delay : 0;
    }
    get scrollAngleRanges() {
        return this.args.scrollAngleRanges;
    }
    get getDropTargetElementsAtPoint() {
        return this.args.getDropTargetElementsAtPoint;
    }
    get ignoreContextMenu() {
        var _ignoreContextMenu;
        return (_ignoreContextMenu = this.args.ignoreContextMenu) !== null && _ignoreContextMenu !== void 0 ? _ignoreContextMenu : false;
    }
    get enableHoverOutsideTarget() {
        var _enableHoverOutsideTarget;
        return (_enableHoverOutsideTarget = this.args.enableHoverOutsideTarget) !== null && _enableHoverOutsideTarget !== void 0 ? _enableHoverOutsideTarget : false;
    }
    get enableKeyboardEvents() {
        var _enableKeyboardEvents;
        return (_enableKeyboardEvents = this.args.enableKeyboardEvents) !== null && _enableKeyboardEvents !== void 0 ? _enableKeyboardEvents : false;
    }
    get enableMouseEvents() {
        var _enableMouseEvents;
        return (_enableMouseEvents = this.args.enableMouseEvents) !== null && _enableMouseEvents !== void 0 ? _enableMouseEvents : false;
    }
    get enableTouchEvents() {
        var _enableTouchEvents;
        return (_enableTouchEvents = this.args.enableTouchEvents) !== null && _enableTouchEvents !== void 0 ? _enableTouchEvents : true;
    }
    get touchSlop() {
        return this.args.touchSlop || 0;
    }
    get delayTouchStart() {
        var ref, ref1;
        var ref2, ref3;
        return (ref3 = (ref2 = (ref = this.args) === null || ref === void 0 ? void 0 : ref.delayTouchStart) !== null && ref2 !== void 0 ? ref2 : (ref1 = this.args) === null || ref1 === void 0 ? void 0 : ref1.delay) !== null && ref3 !== void 0 ? ref3 : 0;
    }
    get delayMouseStart() {
        var ref, ref4;
        var ref5, ref6;
        return (ref6 = (ref5 = (ref = this.args) === null || ref === void 0 ? void 0 : ref.delayMouseStart) !== null && ref5 !== void 0 ? ref5 : (ref4 = this.args) === null || ref4 === void 0 ? void 0 : ref4.delay) !== null && ref6 !== void 0 ? ref6 : 0;
    }
    get window() {
        if (this.context && this.context.window) return this.context.window;
        else if (typeof window !== 'undefined') return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : ref.document) return this.context.document;
        if (this.window) return this.window.document;
        return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.args) === null || ref === void 0 ? void 0 : ref.rootElement) || this.document;
    }
    constructor(args, context){
        this.args = args;
        this.context = context;
    }
}

});

parcelRegister("foZIt", function(module, exports) {

$parcel$export(module.exports, "distance", () => $b368f881abf6dfd1$export$9f17032d917177de);
$parcel$export(module.exports, "inAngleRanges", () => $b368f881abf6dfd1$export$7c909de71a662f4d);
function $b368f881abf6dfd1$export$9f17032d917177de(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(Math.abs(x2 - x1), 2) + Math.pow(Math.abs(y2 - y1), 2));
}
function $b368f881abf6dfd1$export$7c909de71a662f4d(x1, y1, x2, y2, angleRanges) {
    if (!angleRanges) return false;
    const angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI + 180;
    for(let i = 0; i < angleRanges.length; ++i){
        const ar = angleRanges[i];
        if (ar && (ar.start == null || angle >= ar.start) && (ar.end == null || angle <= ar.end)) return true;
    }
    return false;
}

});

parcelRegister("gA3MM", function(module, exports) {

$parcel$export(module.exports, "getNodeClientOffset", () => $c122f1e4ae8b9628$export$8419e8612027b1d8);
$parcel$export(module.exports, "getEventClientOffset", () => $c122f1e4ae8b9628$export$710c829989c68339);

var $jlZnl = parcelRequire("jlZnl");
const $c122f1e4ae8b9628$var$ELEMENT_NODE = 1;
function $c122f1e4ae8b9628$export$8419e8612027b1d8(node) {
    const el = node.nodeType === $c122f1e4ae8b9628$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return undefined;
    const { top: top, left: left } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $c122f1e4ae8b9628$export$149d0d89063ea9ba(e, lastTargetTouchFallback) {
    if (e.targetTouches.length === 1) return $c122f1e4ae8b9628$export$710c829989c68339(e.targetTouches[0]);
    else if (lastTargetTouchFallback && e.touches.length === 1) {
        if (e.touches[0].target === lastTargetTouchFallback.target) return $c122f1e4ae8b9628$export$710c829989c68339(e.touches[0]);
    }
    return;
}
function $c122f1e4ae8b9628$export$710c829989c68339(e, lastTargetTouchFallback) {
    if ((0, $jlZnl.isTouchEvent)(e)) return $c122f1e4ae8b9628$export$149d0d89063ea9ba(e, lastTargetTouchFallback);
    else return {
        x: e.clientX,
        y: e.clientY
    };
}

});
parcelRegister("jlZnl", function(module, exports) {

$parcel$export(module.exports, "eventShouldStartDrag", () => $e16f966395360b2b$export$c64909add7c8d190);
$parcel$export(module.exports, "eventShouldEndDrag", () => $e16f966395360b2b$export$23bc6ab5d304a5);
$parcel$export(module.exports, "isTouchEvent", () => $e16f966395360b2b$export$c4dfce035d43d1e0);
// Used for MouseEvent.buttons (note the s on the end).
const $e16f966395360b2b$var$MouseButtons = {
    Left: 1,
    Right: 2,
    Center: 4
};
// Used for e.button (note the lack of an s on the end).
const $e16f966395360b2b$var$MouseButton = {
    Left: 0,
    Center: 1,
    Right: 2
};
function $e16f966395360b2b$export$c64909add7c8d190(e) {
    // For touch events, button will be undefined. If e.button is defined,
    // then it should be MouseButton.Left.
    return e.button === undefined || e.button === $e16f966395360b2b$var$MouseButton.Left;
}
function $e16f966395360b2b$export$23bc6ab5d304a5(e) {
    // Touch events will have buttons be undefined, while mouse events will have e.buttons's left button
    // bit field unset if the left mouse button has been released
    return e.buttons === undefined || (e.buttons & $e16f966395360b2b$var$MouseButtons.Left) === 0;
}
function $e16f966395360b2b$export$c4dfce035d43d1e0(e) {
    return !!e.targetTouches;
}

});


parcelRegister("iyb5z", function(module, exports) {

$parcel$export(module.exports, "supportsPassive", () => $d814010095abc201$export$a8f436d4c8f15a1f);
const $d814010095abc201$export$a8f436d4c8f15a1f = (()=>{
    // simular to jQuery's test
    let supported = false;
    try {
        addEventListener('test', ()=>{
        // do nothing
        }, Object.defineProperty({}, 'passive', {
            get () {
                supported = true;
                return true;
            }
        }));
    } catch (e) {
    // do nothing
    }
    return supported;
})();

});



parcelRegister("a3fhk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c0fa883f3a23f9b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $a3AMS = parcelRequire("a3AMS");

var $c9Z8w = parcelRequire("c9Z8w");

var $9ze7e = parcelRequire("9ze7e");

var $fKxvO = parcelRequire("fKxvO");


var $aU90w = parcelRequire("aU90w");

var $kgzQz = parcelRequire("kgzQz");
const $1c0fa883f3a23f9b$var$ValueCardCarousel = (props)=>{
    const { valueList: valueList, finalResults: finalResults, cardClassName: cardClassName, setCardClassName: setCardClassName } = props;
    const displayLearnMoreButton = true;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a3AMS.default), {
        controls: true,
        keyboard: true,
        prevLabel: "Previous Top Priority Image",
        nextLabel: "Next Top Priority Image",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3AMS.default).Item, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ze7e.default), {
                    valueStatement: (0, $fKxvO.default)(finalResults[0], valueList),
                    valueStatementId: finalResults[0],
                    learnMoreContent: (0, $aU90w.default)(finalResults[0], valueList),
                    learnMoreLinks: (0, $kgzQz.default)(finalResults[0], valueList),
                    rank: 1,
                    displayLearnMoreButton: displayLearnMoreButton,
                    cardClassName: cardClassName,
                    setCardClassName: setCardClassName
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3AMS.default).Item, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ze7e.default), {
                    valueStatement: (0, $fKxvO.default)(finalResults[1], valueList),
                    valueStatementId: finalResults[1],
                    learnMoreContent: (0, $aU90w.default)(finalResults[1], valueList),
                    learnMoreLinks: (0, $kgzQz.default)(finalResults[1], valueList),
                    rank: 2,
                    displayLearnMoreButton: displayLearnMoreButton,
                    cardClassName: cardClassName,
                    setCardClassName: setCardClassName
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3AMS.default).Item, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ze7e.default), {
                    valueStatement: (0, $fKxvO.default)(finalResults[2], valueList),
                    valueStatementId: finalResults[2],
                    learnMoreContent: (0, $aU90w.default)(finalResults[2], valueList),
                    learnMoreLinks: (0, $kgzQz.default)(finalResults[2], valueList),
                    rank: 3,
                    displayLearnMoreButton: displayLearnMoreButton,
                    cardClassName: cardClassName,
                    setCardClassName: setCardClassName
                })
            })
        ]
    });
};
$1c0fa883f3a23f9b$var$ValueCardCarousel.defaultProps = {
    cardClassName: 'value-card',
    setCardClassName: null
};
$1c0fa883f3a23f9b$var$ValueCardCarousel.propTypes = {
    valueList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    finalResults: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setCardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $1c0fa883f3a23f9b$export$2e2bcd8739ae039 = $1c0fa883f3a23f9b$var$ValueCardCarousel;

});
parcelRegister("a3AMS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7526b869f5881e7d$export$2e2bcd8739ae039);

var $dsxUx = parcelRequire("dsxUx");

var $ioJgF = parcelRequire("ioJgF");

var $eIUqb = parcelRequire("eIUqb");

var $aMKOh = parcelRequire("aMKOh");

var $dKAJt = parcelRequire("dKAJt");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
parcelRequire("4pN5t");
var $7yCAN = parcelRequire("7yCAN");

var $53NoE = parcelRequire("53NoE");

var $dLg4B = parcelRequire("dLg4B");

var $iaLOT = parcelRequire("iaLOT");

var $8rTrh = parcelRequire("8rTrh");

var $kNQyj = parcelRequire("kNQyj");

var $fN7cd = parcelRequire("fN7cd");

var $84Ser = parcelRequire("84Ser");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $7526b869f5881e7d$var$SWIPE_THRESHOLD = 40;
function $7526b869f5881e7d$var$isVisible(element) {
    if (!element || !element.style || !element.parentNode || !element.parentNode.style) return false;
    const elementStyle = getComputedStyle(element);
    return elementStyle.display !== 'none' && elementStyle.visibility !== 'hidden' && getComputedStyle(element.parentNode).display !== 'none';
}
const $7526b869f5881e7d$var$Carousel = /*#__PURE__*/ // eslint-disable-next-line react/display-name
$acw62.forwardRef(({ defaultActiveIndex: defaultActiveIndex = 0, ...uncontrolledProps }, ref)=>{
    const { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', bsPrefix: bsPrefix, slide: slide = true, fade: fade = false, controls: controls = true, indicators: indicators = true, indicatorLabels: indicatorLabels = [], activeIndex: activeIndex, onSelect: onSelect, onSlide: onSlide, onSlid: onSlid, interval: interval = 5000, keyboard: keyboard = true, onKeyDown: onKeyDown, pause: pause = 'hover', onMouseOver: onMouseOver, onMouseOut: onMouseOut, wrap: wrap = true, touch: touch = true, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, prevIcon: prevIcon = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        "aria-hidden": "true",
        className: "carousel-control-prev-icon"
    }), prevLabel: prevLabel = 'Previous', nextIcon: nextIcon = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        "aria-hidden": "true",
        className: "carousel-control-next-icon"
    }), nextLabel: nextLabel = 'Next', variant: variant, className: className, children: children, ...props } = (0, $7yCAN.default)({
        defaultActiveIndex: defaultActiveIndex,
        ...uncontrolledProps
    }, {
        activeIndex: 'onSelect'
    });
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, 'carousel');
    const isRTL = (0, $8rTrh.useIsRTL)();
    const nextDirectionRef = (0, $acw62.useRef)(null);
    const [direction, setDirection] = (0, $acw62.useState)('next');
    const [paused, setPaused] = (0, $acw62.useState)(false);
    const [isSliding, setIsSliding] = (0, $acw62.useState)(false);
    const [renderedActiveIndex, setRenderedActiveIndex] = (0, $acw62.useState)(activeIndex || 0);
    (0, $acw62.useEffect)(()=>{
        if (!isSliding && activeIndex !== renderedActiveIndex) {
            if (nextDirectionRef.current) setDirection(nextDirectionRef.current);
            else setDirection((activeIndex || 0) > renderedActiveIndex ? 'next' : 'prev');
            if (slide) setIsSliding(true);
            setRenderedActiveIndex(activeIndex || 0);
        }
    }, [
        activeIndex,
        isSliding,
        renderedActiveIndex,
        slide
    ]);
    (0, $acw62.useEffect)(()=>{
        if (nextDirectionRef.current) nextDirectionRef.current = null;
    });
    let numChildren = 0;
    let activeChildInterval;
    // Iterate to grab all of the children's interval values
    // (and count them, too)
    (0, $iaLOT.forEach)(children, (child, index)=>{
        ++numChildren;
        if (index === activeIndex) activeChildInterval = child.props.interval;
    });
    const activeChildIntervalRef = (0, $eIUqb.default)(activeChildInterval);
    const prev = (0, $acw62.useCallback)((event)=>{
        if (isSliding) return;
        let nextActiveIndex = renderedActiveIndex - 1;
        if (nextActiveIndex < 0) {
            if (!wrap) return;
            nextActiveIndex = numChildren - 1;
        }
        nextDirectionRef.current = 'prev';
        onSelect == null || onSelect(nextActiveIndex, event);
    }, [
        isSliding,
        renderedActiveIndex,
        onSelect,
        wrap,
        numChildren
    ]);
    // This is used in the setInterval, so it should not invalidate.
    const next = (0, $dsxUx.default)((event)=>{
        if (isSliding) return;
        let nextActiveIndex = renderedActiveIndex + 1;
        if (nextActiveIndex >= numChildren) {
            if (!wrap) return;
            nextActiveIndex = 0;
        }
        nextDirectionRef.current = 'next';
        onSelect == null || onSelect(nextActiveIndex, event);
    });
    const elementRef = (0, $acw62.useRef)();
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            element: elementRef.current,
            prev: prev,
            next: next
        }));
    // This is used in the setInterval, so it should not invalidate.
    const nextWhenVisible = (0, $dsxUx.default)(()=>{
        if (!document.hidden && $7526b869f5881e7d$var$isVisible(elementRef.current)) {
            if (isRTL) prev();
            else next();
        }
    });
    const slideDirection = direction === 'next' ? 'start' : 'end';
    (0, $ioJgF.default)(()=>{
        if (slide) // These callbacks will be handled by the <Transition> callbacks.
        return;
        onSlide == null || onSlide(renderedActiveIndex, slideDirection);
        onSlid == null || onSlid(renderedActiveIndex, slideDirection);
    }, [
        renderedActiveIndex
    ]);
    const orderClassName = `${prefix}-item-${direction}`;
    const directionalClassName = `${prefix}-item-${slideDirection}`;
    const handleEnter = (0, $acw62.useCallback)((node)=>{
        (0, $fN7cd.default)(node);
        onSlide == null || onSlide(renderedActiveIndex, slideDirection);
    }, [
        onSlide,
        renderedActiveIndex,
        slideDirection
    ]);
    const handleEntered = (0, $acw62.useCallback)(()=>{
        setIsSliding(false);
        onSlid == null || onSlid(renderedActiveIndex, slideDirection);
    }, [
        onSlid,
        renderedActiveIndex,
        slideDirection
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (keyboard && !/input|textarea/i.test(event.target.tagName)) switch(event.key){
            case 'ArrowLeft':
                event.preventDefault();
                if (isRTL) next(event);
                else prev(event);
                return;
            case 'ArrowRight':
                event.preventDefault();
                if (isRTL) prev(event);
                else next(event);
                return;
            default:
        }
        onKeyDown == null || onKeyDown(event);
    }, [
        keyboard,
        onKeyDown,
        prev,
        next,
        isRTL
    ]);
    const handleMouseOver = (0, $acw62.useCallback)((event)=>{
        if (pause === 'hover') setPaused(true);
        onMouseOver == null || onMouseOver(event);
    }, [
        pause,
        onMouseOver
    ]);
    const handleMouseOut = (0, $acw62.useCallback)((event)=>{
        setPaused(false);
        onMouseOut == null || onMouseOut(event);
    }, [
        onMouseOut
    ]);
    const touchStartXRef = (0, $acw62.useRef)(0);
    const touchDeltaXRef = (0, $acw62.useRef)(0);
    const touchUnpauseTimeout = (0, $aMKOh.default)();
    const handleTouchStart = (0, $acw62.useCallback)((event)=>{
        touchStartXRef.current = event.touches[0].clientX;
        touchDeltaXRef.current = 0;
        if (pause === 'hover') setPaused(true);
        onTouchStart == null || onTouchStart(event);
    }, [
        pause,
        onTouchStart
    ]);
    const handleTouchMove = (0, $acw62.useCallback)((event)=>{
        if (event.touches && event.touches.length > 1) touchDeltaXRef.current = 0;
        else touchDeltaXRef.current = event.touches[0].clientX - touchStartXRef.current;
        onTouchMove == null || onTouchMove(event);
    }, [
        onTouchMove
    ]);
    const handleTouchEnd = (0, $acw62.useCallback)((event)=>{
        if (touch) {
            const touchDeltaX = touchDeltaXRef.current;
            if (Math.abs(touchDeltaX) > $7526b869f5881e7d$var$SWIPE_THRESHOLD) {
                if (touchDeltaX > 0) prev(event);
                else next(event);
            }
        }
        if (pause === 'hover') touchUnpauseTimeout.set(()=>{
            setPaused(false);
        }, interval || undefined);
        onTouchEnd == null || onTouchEnd(event);
    }, [
        touch,
        pause,
        prev,
        next,
        touchUnpauseTimeout,
        interval,
        onTouchEnd
    ]);
    const shouldPlay = interval != null && !paused && !isSliding;
    const intervalHandleRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        var _ref, _activeChildIntervalR;
        if (!shouldPlay) return undefined;
        const nextFunc = isRTL ? prev : next;
        intervalHandleRef.current = window.setInterval(document.visibilityState ? nextWhenVisible : nextFunc, (_ref = (_activeChildIntervalR = activeChildIntervalRef.current) != null ? _activeChildIntervalR : interval) != null ? _ref : undefined);
        return ()=>{
            if (intervalHandleRef.current !== null) clearInterval(intervalHandleRef.current);
        };
    }, [
        shouldPlay,
        prev,
        next,
        activeChildIntervalRef,
        interval,
        nextWhenVisible,
        isRTL
    ]);
    const indicatorOnClicks = (0, $acw62.useMemo)(()=>indicators && Array.from({
            length: numChildren
        }, (_, index)=>(event)=>{
                onSelect == null || onSelect(index, event);
            }), [
        indicators,
        numChildren,
        onSelect
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(Component, {
        ref: elementRef,
        ...props,
        onKeyDown: handleKeyDown,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, slide && 'slide', fade && `${prefix}-fade`, variant && `${prefix}-${variant}`),
        children: [
            indicators && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `${prefix}-indicators`,
                children: (0, $iaLOT.map)(children, (_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        "data-bs-target": "" // Bootstrap requires this in their css.
                        ,
                        "aria-label": indicatorLabels != null && indicatorLabels.length ? indicatorLabels[index] : `Slide ${index + 1}`,
                        className: index === renderedActiveIndex ? 'active' : undefined,
                        onClick: indicatorOnClicks ? indicatorOnClicks[index] : undefined,
                        "aria-current": index === renderedActiveIndex
                    }, index))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `${prefix}-inner`,
                children: (0, $iaLOT.map)(children, (child, index)=>{
                    const isActive = index === renderedActiveIndex;
                    return slide ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84Ser.default), {
                        in: isActive,
                        onEnter: isActive ? handleEnter : undefined,
                        onEntered: isActive ? handleEntered : undefined,
                        addEndListener: (0, $kNQyj.default),
                        children: (status, innerProps)=>/*#__PURE__*/ $acw62.cloneElement(child, {
                                ...innerProps,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(child.props.className, isActive && status !== 'entered' && orderClassName, (status === 'entered' || status === 'exiting') && 'active', (status === 'entering' || status === 'exiting') && directionalClassName)
                            })
                    }) : /*#__PURE__*/ $acw62.cloneElement(child, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(child.props.className, isActive && 'active')
                    });
                })
            }),
            controls && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    (wrap || activeIndex !== 0) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dKAJt.default), {
                        className: `${prefix}-control-prev`,
                        onClick: prev,
                        children: [
                            prevIcon,
                            prevLabel && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "visually-hidden",
                                children: prevLabel
                            })
                        ]
                    }),
                    (wrap || activeIndex !== numChildren - 1) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dKAJt.default), {
                        className: `${prefix}-control-next`,
                        onClick: next,
                        children: [
                            nextIcon,
                            nextLabel && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "visually-hidden",
                                children: nextLabel
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
$7526b869f5881e7d$var$Carousel.displayName = 'Carousel';
var $7526b869f5881e7d$export$2e2bcd8739ae039 = Object.assign($7526b869f5881e7d$var$Carousel, {
    Caption: (0, $53NoE.default),
    Item: (0, $dLg4B.default)
});

});
parcelRegister("dsxUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc831e7fe1726fc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eIUqb = parcelRequire("eIUqb");
function $9cc831e7fe1726fc$export$2e2bcd8739ae039(fn) {
    const ref = (0, $eIUqb.default)(fn);
    return (0, $acw62.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});
parcelRegister("eIUqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab80f0daa08f2134$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $ab80f0daa08f2134$var$useCommittedRef(value) {
    const ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $ab80f0daa08f2134$export$2e2bcd8739ae039 = $ab80f0daa08f2134$var$useCommittedRef;

});


parcelRegister("ioJgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64d95269453ffdb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * Runs an effect only when the dependencies have changed, skipping the
 * initial "on mount" run. Caution, if the dependency list never changes,
 * the effect is **never run**
 *
 * ```ts
 *  const ref = useRef<HTMLInput>(null);
 *
 *  // focuses an element only if the focus changes, and not on mount
 *  useUpdateEffect(() => {
 *    const element = ref.current?.children[focusedIdx] as HTMLElement
 *
 *    element?.focus()
 *
 *  }, [focusedIndex])
 * ```
 * @param effect An effect to run on mount
 *
 * @category effects
 */ function $d64d95269453ffdb$var$useUpdateEffect(fn, deps) {
    const isFirst = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (isFirst.current) {
            isFirst.current = false;
            return;
        }
        return fn();
    }, deps);
}
var $d64d95269453ffdb$export$2e2bcd8739ae039 = $d64d95269453ffdb$var$useUpdateEffect;

});

parcelRegister("aMKOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7da2b291db98759b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $kob1U = parcelRequire("kob1U");

var $8xDUK = parcelRequire("8xDUK");
/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $7da2b291db98759b$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $7da2b291db98759b$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $7da2b291db98759b$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$7da2b291db98759b$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $7da2b291db98759b$var$MAX_DELAY_MS);
}
function $7da2b291db98759b$export$2e2bcd8739ae039() {
    const isMounted = (0, $kob1U.default)();
    // types are confused between node and web here IDK
    const handleRef = (0, $acw62.useRef)();
    (0, $8xDUK.default)(()=>clearTimeout(handleRef.current));
    return (0, $acw62.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $7da2b291db98759b$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $7da2b291db98759b$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}

});
parcelRegister("kob1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed7e9ace1ce49d9f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $ed7e9ace1ce49d9f$export$2e2bcd8739ae039() {
    const mounted = (0, $acw62.useRef)(true);
    const isMounted = (0, $acw62.useRef)(()=>mounted.current);
    (0, $acw62.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

});

parcelRegister("8xDUK", function(module, exports) {

$parcel$export(module.exports, "default", () => $63805df80cf3ca43$export$2e2bcd8739ae039);

var $8qtQJ = parcelRequire("8qtQJ");

var $acw62 = parcelRequire("acw62");
function $63805df80cf3ca43$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $8qtQJ.default)(fn);
    (0, $acw62.useEffect)(()=>()=>onUnmount.current(), []);
}

});
parcelRegister("8qtQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6227e7ea0d71afb1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $6227e7ea0d71afb1$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

});



parcelRegister("dKAJt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a02c1087963bbb34$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("4qvf7");
var $big2q = parcelRequire("big2q");

var $rldgt = parcelRequire("rldgt");

var $ayMG0 = parcelRequire("ayMG0");
const $a02c1087963bbb34$var$_excluded = [
    "onKeyDown"
];
function $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a02c1087963bbb34$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $a02c1087963bbb34$var$Anchor = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(_ref, $a02c1087963bbb34$var$_excluded);
    const [buttonProps] = (0, $rldgt.useButtonProps)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $big2q.default)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($a02c1087963bbb34$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $ayMG0.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$a02c1087963bbb34$var$Anchor.displayName = 'Anchor';
var $a02c1087963bbb34$export$2e2bcd8739ae039 = $a02c1087963bbb34$var$Anchor;

});
parcelRegister("4qvf7", function(module, exports) {

$parcel$export(module.exports, "useEventCallback", () => (parcelRequire("big2q")).default);

var $74aw3 = parcelRequire("74aw3");

var $hvpN4 = parcelRequire("hvpN4");

var $big2q = parcelRequire("big2q");

var $l9zc6 = parcelRequire("l9zc6");

var $1yYO5 = parcelRequire("1yYO5");

var $dk1qs = parcelRequire("dk1qs");

var $dMV6y = parcelRequire("dMV6y");

var $4vcMH = parcelRequire("4vcMH");

var $dKFOB = parcelRequire("dKFOB");

var $7SJuc = parcelRequire("7SJuc");

var $3q2dK = parcelRequire("3q2dK");

var $kBzSA = parcelRequire("kBzSA");

var $7A2xU = parcelRequire("7A2xU");

});
parcelRegister("74aw3", function(module, exports) {

var $acw62 = parcelRequire("acw62");
function $5251105f62ca120d$export$2e2bcd8739ae039() {
    return (0, $acw62.useState)(null);
}

});

parcelRegister("hvpN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe95659e68dd1dd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $cbe95659e68dd1dd$var$useCommittedRef(value) {
    const ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $cbe95659e68dd1dd$export$2e2bcd8739ae039 = $cbe95659e68dd1dd$var$useCommittedRef;

});

parcelRegister("big2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $838dd0f898428a09$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $hvpN4 = parcelRequire("hvpN4");
function $838dd0f898428a09$export$2e2bcd8739ae039(fn) {
    const ref = (0, $hvpN4.default)(fn);
    return (0, $acw62.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});

parcelRegister("l9zc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f665bd0f5e0a2735$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $big2q = parcelRequire("big2q");
function $f665bd0f5e0a2735$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $big2q.default)(listener);
    (0, $acw62.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}

});

parcelRegister("1yYO5", function(module, exports) {

var $l9zc6 = parcelRequire("l9zc6");

var $acw62 = parcelRequire("acw62");
function $123822626b455986$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $acw62.useCallback)(()=>document, []);
    return (0, $l9zc6.default)(documentTarget, event, handler, capture);
}

});

parcelRegister("dk1qs", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $hvpN4 = parcelRequire("hvpN4");
/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $9b2e3fbaf6312caa$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $hvpN4.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $hvpN4.default)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $acw62.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $9b2e3fbaf6312caa$export$2e2bcd8739ae039 = $9b2e3fbaf6312caa$var$useInterval;

});

parcelRegister("dMV6y", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $hvpN4 = parcelRequire("hvpN4");
function $a09c0dd7291b0177$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $hvpN4.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $hvpN4.default)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $acw62.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $a09c0dd7291b0177$export$2e2bcd8739ae039 = $a09c0dd7291b0177$var$useRafInterval;

});

parcelRegister("4vcMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3473f9615acd9416$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $3473f9615acd9416$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $acw62.useState)(initialState);
    const updater = (0, $acw62.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}

});

parcelRegister("dKFOB", function(module, exports) {

var $4vcMH = parcelRequire("4vcMH");
function $a03001e30ff1047d$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $4vcMH.default)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}

});

parcelRegister("7SJuc", function(module, exports) {

var $acw62 = parcelRequire("acw62");
function $5bd0dc278db65a7f$export$2e2bcd8739ae039() {
    const mounted = (0, $acw62.useRef)(true);
    const isMounted = (0, $acw62.useRef)(()=>mounted.current);
    (0, $acw62.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

});

parcelRegister("3q2dK", function(module, exports) {

var $acw62 = parcelRequire("acw62");
function $27d585c6d75dcd23$export$2e2bcd8739ae039(value) {
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}

});

parcelRegister("kBzSA", function(module, exports) {

var $acw62 = parcelRequire("acw62");
function $f003183c755c096a$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $acw62.useState)({
        image: null,
        error: null
    });
    (0, $acw62.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}

});

parcelRegister("7A2xU", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $9ewzd = parcelRequire("9ewzd");
const $584ddec03c2e34ed$var$targetMap = new WeakMap();
let $584ddec03c2e34ed$var$resizeObserver;
function $584ddec03c2e34ed$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $584ddec03c2e34ed$var$resizeObserver = $584ddec03c2e34ed$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $584ddec03c2e34ed$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $584ddec03c2e34ed$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $acw62.useState)(null);
    (0, $9ewzd.default)(()=>{
        if (!element) return;
        $584ddec03c2e34ed$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $584ddec03c2e34ed$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $584ddec03c2e34ed$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}

});
parcelRegister("9ewzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b8eaefeef7398a7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $6b8eaefeef7398a7$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $6b8eaefeef7398a7$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $6b8eaefeef7398a7$export$2e2bcd8739ae039 = $6b8eaefeef7398a7$var$isDOM || $6b8eaefeef7398a7$var$isReactNative ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});



parcelRegister("rldgt", function(module, exports) {

$parcel$export(module.exports, "useButtonProps", () => $0522fa2e4977c358$export$a0ee72f2c720a5c3);

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
const $0522fa2e4977c358$var$_excluded = [
    "as",
    "disabled"
];
function $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $0522fa2e4977c358$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $0522fa2e4977c358$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $0522fa2e4977c358$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $0522fa2e4977c358$var$Button = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(_ref, $0522fa2e4977c358$var$_excluded);
    const [buttonProps, { tagName: Component }] = $0522fa2e4977c358$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$0522fa2e4977c358$var$Button.displayName = 'Button';
var $0522fa2e4977c358$export$2e2bcd8739ae039 = $0522fa2e4977c358$var$Button;

});


parcelRegister("4pN5t", function(module, exports) {

$parcel$export(module.exports, "useUncontrolled", () => (parcelRequire("7yCAN")).default);

var $7yCAN = parcelRequire("7yCAN");

var $dVlN2 = parcelRequire("dVlN2");

});
parcelRegister("7yCAN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5809a50e160ad91a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $fNcGF = parcelRequire("fNcGF");
function $5809a50e160ad91a$var$_toPropertyKey(arg) {
    var key = $5809a50e160ad91a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5809a50e160ad91a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5809a50e160ad91a$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $acw62.useRef)(propValue !== undefined);
    var _useState = (0, $acw62.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $acw62.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $5809a50e160ad91a$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$fNcGF.defaultKey(fieldName)], propsValue = _ref[fieldName], rest = (0, $1En50.default)(_ref, [
            $fNcGF.defaultKey(fieldName),
            fieldName
        ].map($5809a50e160ad91a$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $5809a50e160ad91a$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $8nd05.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}

});
parcelRegister("fNcGF", function(module, exports) {

$parcel$export(module.exports, "defaultKey", () => $b7f5460541b42e0f$export$26cbf8c37e721e67);
$parcel$export(module.exports, "uncontrolledPropTypes", () => $b7f5460541b42e0f$export$8abd944bed26e726);
$parcel$export(module.exports, "isProp", () => $b7f5460541b42e0f$export$12ae2baa35bd9b8b);
$parcel$export(module.exports, "canAcceptRef", () => $b7f5460541b42e0f$export$95e5b18573b29087);
parcelRequire("aaXwj");
var $b7f5460541b42e0f$var$noop = function noop() {};
function $b7f5460541b42e0f$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $b7f5460541b42e0f$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$b7f5460541b42e0f$export$26cbf8c37e721e67(prop)] = $b7f5460541b42e0f$var$noop;
        var handler;
    });
    return propTypes;
}
function $b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $b7f5460541b42e0f$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $b7f5460541b42e0f$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

});
parcelRegister("aaXwj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $768901fea8dbe440$var$invariant;

});



parcelRegister("dVlN2", function(module, exports) {

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $hdX8Q = parcelRequire("hdX8Q");

var $aaXwj = parcelRequire("aaXwj");

var $fNcGF = parcelRequire("fNcGF");
var $a2318047db3e7b05$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $a2318047db3e7b05$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $fNcGF.canAcceptRef(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($fNcGF.defaultKey);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($aaXwj)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $g7ajw.default)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $8nd05.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$fNcGF.defaultKey(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $8nd05.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$fNcGF.isProp(props, key) && $fNcGF.isProp(prevProps, key)) nextState.values[key] = props[$fNcGF.defaultKey(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $1En50.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    (0, $hdX8Q.polyfill)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $8nd05.default)({
        innerRef: function innerRef() {}
    }, $fNcGF.uncontrolledPropTypes(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UncontrolledComponent, (0, $8nd05.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $a2318047db3e7b05$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $a2318047db3e7b05$export$2e2bcd8739ae039(newComponent, (0, $8nd05.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}

});
parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $VFVve.default)(t, o);
}

});



parcelRegister("53NoE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af38cb0ea53d823$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $3af38cb0ea53d823$var$CarouselCaption = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, 'carousel-caption');
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$3af38cb0ea53d823$var$CarouselCaption.displayName = 'CarouselCaption';
var $3af38cb0ea53d823$export$2e2bcd8739ae039 = $3af38cb0ea53d823$var$CarouselCaption;

});

parcelRegister("dLg4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $a04c21f969b5c60b$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $a04c21f969b5c60b$var$CarouselItem = /*#__PURE__*/ $acw62.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', bsPrefix: bsPrefix, className: className, ...props }, ref)=>{
    const finalClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, (0, $8rTrh.useBootstrapPrefix)(bsPrefix, 'carousel-item'));
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        ...props,
        className: finalClassName
    });
});
$a04c21f969b5c60b$var$CarouselItem.displayName = 'CarouselItem';
var $a04c21f969b5c60b$export$2e2bcd8739ae039 = $a04c21f969b5c60b$var$CarouselItem;

});

parcelRegister("kNQyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f251260f6a38a977$export$2e2bcd8739ae039);

var $2voRd = parcelRequire("2voRd");

var $4VxHp = parcelRequire("4VxHp");
function $f251260f6a38a977$var$parseDuration(node, property) {
    const str = (0, $2voRd.default)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $f251260f6a38a977$export$2e2bcd8739ae039(element, handler) {
    const duration = $f251260f6a38a977$var$parseDuration(element, 'transitionDuration');
    const delay = $f251260f6a38a977$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $4VxHp.default)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}

});
parcelRegister("2voRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d31c226dae4138f$export$2e2bcd8739ae039);

var $dtYQo = parcelRequire("dtYQo");

var $PQK9L = parcelRequire("PQK9L");

var $heeAB = parcelRequire("heeAB");
function $1d31c226dae4138f$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $PQK9L.default)(property)) || (0, $dtYQo.default)(node).getPropertyValue((0, $PQK9L.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $PQK9L.default)(key));
        else if ((0, $heeAB.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $PQK9L.default)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $1d31c226dae4138f$export$2e2bcd8739ae039 = $1d31c226dae4138f$var$style;

});
parcelRegister("dtYQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d0d2e2a013bac9c$export$2e2bcd8739ae039);

var $iJqLk = parcelRequire("iJqLk");
function $9d0d2e2a013bac9c$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $iJqLk.default)(node).getComputedStyle(node, psuedoElement);
}

});
parcelRegister("iJqLk", function(module, exports) {

$parcel$export(module.exports, "default", () => $da31306d5140b746$export$2e2bcd8739ae039);

var $lIo3y = parcelRequire("lIo3y");
function $da31306d5140b746$export$2e2bcd8739ae039(node) {
    var doc = (0, $lIo3y.default)(node);
    return doc && doc.defaultView || window;
}

});
parcelRegister("lIo3y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf05e248574eb57$export$2e2bcd8739ae039);
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $fcf05e248574eb57$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});



parcelRegister("PQK9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $09bdad49a6503060$export$2e2bcd8739ae039);
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ 
var $dFgU8 = parcelRequire("dFgU8");
var $09bdad49a6503060$var$msPattern = /^ms-/;
function $09bdad49a6503060$export$2e2bcd8739ae039(string) {
    return (0, $dFgU8.default)(string).replace($09bdad49a6503060$var$msPattern, '-ms-');
}

});
parcelRegister("dFgU8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f2c378a21ca2430$export$2e2bcd8739ae039);
var $9f2c378a21ca2430$var$rUpper = /([A-Z])/g;
function $9f2c378a21ca2430$export$2e2bcd8739ae039(string) {
    return string.replace($9f2c378a21ca2430$var$rUpper, '-$1').toLowerCase();
}

});


parcelRegister("heeAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8af0fa0e8553220$export$2e2bcd8739ae039);
var $c8af0fa0e8553220$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $c8af0fa0e8553220$export$2e2bcd8739ae039(value) {
    return !!(value && $c8af0fa0e8553220$var$supportedTransforms.test(value));
}

});


parcelRegister("4VxHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3966a04026e86a49$export$2e2bcd8739ae039);

var $2voRd = parcelRequire("2voRd");

var $7YnSj = parcelRequire("7YnSj");

var $iq7UD = parcelRequire("iq7UD");
function $3966a04026e86a49$var$parseDuration(node) {
    var str = (0, $2voRd.default)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $iq7UD.default)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $7YnSj.default)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $3966a04026e86a49$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $3966a04026e86a49$var$parseDuration(element) || 0;
    var removeEmulate = $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $7YnSj.default)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}

});
parcelRegister("7YnSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ce0a80dcc778636$export$2e2bcd8739ae039);

var $3shzr = parcelRequire("3shzr");

var $7J0wn = parcelRequire("7J0wn");
function $5ce0a80dcc778636$var$listen(node, eventName, handler, options) {
    (0, $3shzr.default)(node, eventName, handler, options);
    return function() {
        (0, $7J0wn.default)(node, eventName, handler, options);
    };
}
var $5ce0a80dcc778636$export$2e2bcd8739ae039 = $5ce0a80dcc778636$var$listen;

});
parcelRegister("3shzr", function(module, exports) {

$parcel$export(module.exports, "default", () => $28419dce7921d430$export$2e2bcd8739ae039);
/* eslint-disable no-return-assign */ 
var $7lCBb = parcelRequire("7lCBb");
var $28419dce7921d430$export$63fefd044b2bc624 = false;
var $28419dce7921d430$export$a614c6b395900f69 = false;
try {
    var $28419dce7921d430$var$options = {
        get passive () {
            return $28419dce7921d430$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $28419dce7921d430$export$a614c6b395900f69 = $28419dce7921d430$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $7lCBb.default) {
        window.addEventListener('test', $28419dce7921d430$var$options, $28419dce7921d430$var$options);
        window.removeEventListener('test', $28419dce7921d430$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $28419dce7921d430$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$28419dce7921d430$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$28419dce7921d430$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $28419dce7921d430$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $28419dce7921d430$export$2e2bcd8739ae039 = $28419dce7921d430$var$addEventListener;

});
parcelRegister("7lCBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $55986f7b0f69fd17$export$2e2bcd8739ae039);
var $55986f7b0f69fd17$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

});


parcelRegister("7J0wn", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fd23e4cc6020bf$export$2e2bcd8739ae039);
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $59fd23e4cc6020bf$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $59fd23e4cc6020bf$export$2e2bcd8739ae039 = $59fd23e4cc6020bf$var$removeEventListener;

});


parcelRegister("iq7UD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d690caf237d1909f$export$2e2bcd8739ae039);
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $d690caf237d1909f$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}

});



parcelRegister("fN7cd", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f7800ef44133eb$export$2e2bcd8739ae039);
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $02f7800ef44133eb$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}

});

parcelRegister("84Ser", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e18c3cbbc2321dd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1mPeS = parcelRequire("1mPeS");

var $dvyhD = parcelRequire("dvyhD");

var $a59eu = parcelRequire("a59eu");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $5e18c3cbbc2321dd$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $dvyhD.default)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $a59eu.default)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $acw62.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $acw62.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $acw62.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $acw62.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $acw62.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $acw62.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $acw62.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1mPeS.default), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$5e18c3cbbc2321dd$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $5e18c3cbbc2321dd$export$2e2bcd8739ae039 = $5e18c3cbbc2321dd$var$TransitionWrapper;

});
parcelRegister("1mPeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fef977f04119bf5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dIte2 = parcelRequire("dIte2");


var $6xlZQ = parcelRequire("6xlZQ");

var $4NYRH = parcelRequire("4NYRH");
var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $4NYRH.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $6xlZQ.default);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;

});
parcelRegister("dIte2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc60dfb9203246b$export$2e2bcd8739ae039);
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("6xlZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c26e32a51d8c622$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});

parcelRegister("4NYRH", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $37faf39349e00e45$export$7d26bbb1236dafd6);
var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("dvyhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d58c39545e3cedc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $9d58c39545e3cedc$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $9d58c39545e3cedc$export$c9058316764c140e(refA, refB) {
    const a = $9d58c39545e3cedc$var$toFnRef(refA);
    const b = $9d58c39545e3cedc$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $9d58c39545e3cedc$var$useMergedRefs(refA, refB) {
    return (0, $acw62.useMemo)(()=>$9d58c39545e3cedc$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $9d58c39545e3cedc$export$2e2bcd8739ae039 = $9d58c39545e3cedc$var$useMergedRefs;

});

parcelRegister("a59eu", function(module, exports) {

$parcel$export(module.exports, "default", () => $75718871ab216e51$export$2e2bcd8739ae039);

var $1u0KT = parcelRequire("1u0KT");
function $75718871ab216e51$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

});



parcelRegister("aU90w", function(module, exports) {

$parcel$export(module.exports, "default", () => $a718ef2a10612687$export$2e2bcd8739ae039);
function $a718ef2a10612687$var$getLearnMoreContent(id, valueList) {
    const statementObj = valueList.filter((valueStatement)=>valueStatement.statementId === id);
    return statementObj[0].learnMoreContent;
}
var $a718ef2a10612687$export$2e2bcd8739ae039 = $a718ef2a10612687$var$getLearnMoreContent;

});

parcelRegister("kgzQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3b123d79c3aa003$export$2e2bcd8739ae039);
function $d3b123d79c3aa003$var$getLearnMoreLinks(id, valueList) {
    const statementObj = valueList.filter((valueStatement)=>valueStatement.statementId === id);
    return statementObj[0].learnMoreLinks;
}
var $d3b123d79c3aa003$export$2e2bcd8739ae039 = $d3b123d79c3aa003$var$getLearnMoreLinks;

});


parcelRegister("86M2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b220731da6fbeff$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9ze7e = parcelRequire("9ze7e");

var $fKxvO = parcelRequire("fKxvO");


var $aU90w = parcelRequire("aU90w");

var $kgzQz = parcelRequire("kgzQz");
const $6b220731da6fbeff$var$ValueCardPodium = (props)=>{
    const { valueList: valueList, finalResults: finalResults, cardClassName: cardClassName, setCardClassName: setCardClassName } = props;
    const displayLearnMoreButton = true;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ze7e.default), {
                valueStatement: (0, $fKxvO.default)(finalResults[0], valueList),
                valueStatementId: finalResults[0],
                learnMoreContent: (0, $aU90w.default)(finalResults[0], valueList),
                learnMoreLinks: (0, $kgzQz.default)(finalResults[0], valueList),
                rank: 1,
                displayLearnMoreButton: displayLearnMoreButton,
                cardClassName: cardClassName,
                setCardClassName: setCardClassName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ze7e.default), {
                valueStatement: (0, $fKxvO.default)(finalResults[1], valueList),
                valueStatementId: finalResults[1],
                learnMoreContent: (0, $aU90w.default)(finalResults[1], valueList),
                learnMoreLinks: (0, $kgzQz.default)(finalResults[1], valueList),
                rank: 2,
                displayLearnMoreButton: displayLearnMoreButton,
                cardClassName: cardClassName,
                setCardClassName: setCardClassName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ze7e.default), {
                valueStatement: (0, $fKxvO.default)(finalResults[2], valueList),
                valueStatementId: finalResults[2],
                learnMoreContent: (0, $aU90w.default)(finalResults[2], valueList),
                learnMoreLinks: (0, $kgzQz.default)(finalResults[2], valueList),
                rank: 3,
                displayLearnMoreButton: displayLearnMoreButton,
                cardClassName: cardClassName,
                setCardClassName: setCardClassName
            })
        ]
    });
};
$6b220731da6fbeff$var$ValueCardPodium.defaultProps = {
    cardClassName: 'value-card',
    setCardClassName: null
};
$6b220731da6fbeff$var$ValueCardPodium.propTypes = {
    valueList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    finalResults: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setCardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $6b220731da6fbeff$export$2e2bcd8739ae039 = $6b220731da6fbeff$var$ValueCardPodium;

});

parcelRegister("6UZN0", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf7a6275731b3f1$export$2e2bcd8739ae039);
/**
 * @param {string} creTs - wordpower email/link creation timestamp in milliseconds
 */ const $dbf7a6275731b3f1$var$validTime = (creTs)=>{
    const dayInMilliseconds = 86400000;
    const expirationPeriod = 10; // number of days until the link should expire
    const expirationDate = new Date(parseInt(creTs, 10)).getTime() + dayInMilliseconds * expirationPeriod;
    const currentDate = Date.now();
    return currentDate <= expirationDate;
};
var $dbf7a6275731b3f1$export$2e2bcd8739ae039 = $dbf7a6275731b3f1$var$validTime;

});

parcelRegister("8cWO4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a91e8b88685ae87$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7lk71 = parcelRequire("7lk71");

var $c9Z8w = parcelRequire("c9Z8w");

var $jVt2v = parcelRequire("jVt2v");

var $lGrX9 = parcelRequire("lGrX9");

var $iJxY6 = parcelRequire("iJxY6");

var $58ODK = parcelRequire("58ODK");

var $fUEMe = parcelRequire("fUEMe");

var $9Ryut = parcelRequire("9Ryut");

var $tL0U5 = parcelRequire("tL0U5");
const $5a91e8b88685ae87$var$DownloadButton = ({ setNotificationContent: setNotificationContent, setNotificationOpen: setNotificationOpen, resultsJSON: resultsJSON, coldContactData: coldContactData, userComments: userComments, displaySendToFAButton: displaySendToFAButton, planningTopics: planningTopics, investmentInvolvementCode: investmentInvolvementCode, label: label })=>{
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const urlQuery = (0, $58ODK.default)();
    const conId = urlQuery.get('conId');
    const utmSource = urlQuery.get('utm_source');
    const utmContent = urlQuery.get('utm_content');
    const entityID = urlQuery.get('EID');
    const faNo = urlQuery.get('faNo');
    const [isDownloadBtnLoading, setDownloadBtnLoading] = (0, $acw62.useState)(false);
    function downloadResultsForUser() {
        setDownloadBtnLoading(true);
        (0, $fUEMe.default)('download-results', {});
        let byteString;
        const fileName = 'MyPriorities-Results.pdf';
        const params = {
            locale: locId,
            sysId: 'PRP',
            appName: 'MyPriorities',
            conType: (0, $jVt2v.default)(utmSource, utmContent),
            utmSource: (0, $lGrX9.default)(utmSource, entityID, faNo, conId)
        };
        const data = {
            faNo: null,
            branchNo: null,
            userComments: userComments,
            sessionId: null,
            coldContactData: null,
            contactNo: conId,
            utmSource: null,
            results: resultsJSON,
            investmentInvolvementCode: investmentInvolvementCode,
            planningTopics: planningTopics,
            contactName: coldContactData && coldContactData.firstName && coldContactData.lastName ? `${coldContactData.firstName} ${coldContactData.lastName}` : null
        };
        const responseType = 'blob';
        (0, $tL0U5.sendToDelegator)(params, data, responseType).then((res)=>{
            byteString = res;
            // IE & Edge Legacy
            if (window.navigator && Object.hasOwn(window.navigator, 'msSaveBlob')) window.navigator.msSaveBlob(byteString, fileName);
            else {
                const blob = new Blob([
                    byteString
                ], {
                    type: 'application/pdf'
                });
                const fileUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }).catch((err)=>{
            if (err.response && err.response.status === 403) (0, $tL0U5.handleAVIError)(err, locId);
            setNotificationContent({
                message: (0, $iJxY6.default)(locId, 'pdfErrorMessage', 'resultsPage'),
                type: 'error'
            });
            setNotificationOpen(true);
            /* eslint-disable no-console */ console.error(err);
        }).finally(()=>{
            setDownloadBtnLoading(false);
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
        loading: isDownloadBtnLoading,
        icon: "data-download",
        label: label,
        styleVariant: displaySendToFAButton ? 'secondary' : 'primary',
        onClick: ()=>downloadResultsForUser(),
        attributes: {
            value: '',
            id: 'download-button',
            'data-testid': 'download-button'
        }
    });
};
$5a91e8b88685ae87$var$DownloadButton.propTypes = {
    setNotificationContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    setNotificationOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    coldContactData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    userComments: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // eslint-disable-next-line react/forbid-prop-types
    resultsJSON: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    displaySendToFAButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    planningTopics: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    investmentInvolvementCode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};
$5a91e8b88685ae87$var$DownloadButton.defaultProps = {
    coldContactData: null,
    userComments: null
};
var $5a91e8b88685ae87$export$2e2bcd8739ae039 = $5a91e8b88685ae87$var$DownloadButton;

});
parcelRegister("jVt2v", function(module, exports) {

$parcel$export(module.exports, "default", () => $730bed78865bd4ac$export$2e2bcd8739ae039);
/*
If url parameters are null or undefined, conType should default to P.
*/ const $730bed78865bd4ac$var$getConType = (utmSource, utmContent)=>{
    if (utmSource === 'newsletter') {
        // don't parse utmContent if null or undefined
        // expected shape of utmContent: [Letter]_[Date]. e.g. "C_30_2021-01"
        if (utmContent && utmContent.charAt(0) === 'C') return 'C';
        return 'P';
    }
    return 'P';
};
var $730bed78865bd4ac$export$2e2bcd8739ae039 = $730bed78865bd4ac$var$getConType;

});

parcelRegister("lGrX9", function(module, exports) {

$parcel$export(module.exports, "default", () => $539c104391acc7b3$export$2e2bcd8739ae039);
/*
    Right now the logic is very simple. 
    But a separate util was created in anticipation of requirements evolving.
*/ const $539c104391acc7b3$var$getSource = (utmSource, entityID, faNo, contactId)=>{
    if (!contactId) {
        if (entityID) return 'fa_profile';
        if (faNo) return 'personalized_link';
    } else if (!utmSource) {
        if (entityID || faNo) return 'email';
    }
    return utmSource;
};
var $539c104391acc7b3$export$2e2bcd8739ae039 = $539c104391acc7b3$var$getSource;

});

parcelRegister("58ODK", function(module, exports) {

$parcel$export(module.exports, "default", () => $40d9ff78342f663c$export$2e2bcd8739ae039);
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
const $40d9ff78342f663c$var$useQuery = ()=>{
    return new URLSearchParams((0, $aphAM.useLocation)().search);
};
var $40d9ff78342f663c$export$2e2bcd8739ae039 = $40d9ff78342f663c$var$useQuery;

});


parcelRegister("aO5Es", function(module, exports) {

$parcel$export(module.exports, "default", () => $34085e30a7f12a79$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9Ryut = parcelRequire("9Ryut");

var $iJxY6 = parcelRequire("iJxY6");

const $34085e30a7f12a79$var$CopyLinkButton = ()=>{
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const [isCopied, setIsCopied] = (0, $acw62.useState)(false);
    function copyUrl() {
        navigator.clipboard.writeText((0, $iJxY6.default)(locId, 'copiedUrl', 'resultsPage'));
        setIsCopied(true);
    }
    function copyTextHandler(textCopied) {
        return textCopied ? (0, $iJxY6.default)(locId, 'linkCopiedSuccessfully', 'resultsPage') : (0, $iJxY6.default)(locId, 'copyLinkButton', 'resultsPage');
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        className: "button button--secondary",
        type: "button",
        onClick: copyUrl,
        "data-testid": "copyLink_btn",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: "/public/images/link-icon.png",
                alt: "",
                role: "presentation",
                className: "copy-icon"
            }),
            copyTextHandler(isCopied)
        ]
    });
};
var $34085e30a7f12a79$export$2e2bcd8739ae039 = $34085e30a7f12a79$var$CopyLinkButton;

});

parcelRegister("duf9k", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f1e32217c60379$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7lk71 = parcelRequire("7lk71");

var $c9Z8w = parcelRequire("c9Z8w");

var $jVt2v = parcelRequire("jVt2v");

var $lGrX9 = parcelRequire("lGrX9");

var $12BeR = parcelRequire("12BeR");

var $kmYFw = parcelRequire("kmYFw");

var $iJxY6 = parcelRequire("iJxY6");

var $58ODK = parcelRequire("58ODK");

var $fUEMe = parcelRequire("fUEMe");

var $9Ryut = parcelRequire("9Ryut");

var $tL0U5 = parcelRequire("tL0U5");
const $90f1e32217c60379$var$SendResultsButton = ({ setNotificationContent: setNotificationContent, setNotificationOpen: setNotificationOpen, sessionId: sessionId, resultsJSON: resultsJSON, coldContactData: coldContactData, setColdContactData: setColdContactData, userComments: userComments, setUserComments: setUserComments, contactName: contactName, buttonText: buttonText, faInfo: faInfo, sendResultsButtonDisabled: sendResultsButtonDisabled, setSendResultsButtonDisabled: setSendResultsButtonDisabled, planningTopics: planningTopics, investmentInvolvementCode: investmentInvolvementCode })=>{
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const urlQuery = (0, $58ODK.default)();
    const faNo = urlQuery.get('faNo') || faInfo.faNo;
    const faNoParam = urlQuery.get('faNo');
    const entityIdParam = urlQuery.get('EID');
    const conId = urlQuery.get('conId');
    const utmSource = urlQuery.get('utm_source');
    const utmContent = urlQuery.get('utm_content');
    const faFullName = `${faInfo.faFirstName} ${faInfo.faLastName}`;
    const [displayColdContactModal, setDisplayColdContactModal] = (0, $acw62.useState)(false);
    const [displayCommentModal, setDisplayCommentModal] = (0, $acw62.useState)(false);
    const [isSendResultsLoading, setSendResultsLoading] = (0, $acw62.useState)(false);
    const successNotificationContentHandler = ()=>{
        if (coldContactData) {
            if (faInfo.faFirstName && faInfo.faLastName) return (0, $iJxY6.default)(locId, 'coldContactSuccessMessage', 'resultsPage').replace('%FA_NAME%', faFullName);
            return (0, $iJxY6.default)(locId, 'coldContactSuccessMessage', 'resultsPage').replace('%FA_NAME%', (0, $iJxY6.default)(locId, 'yourFaDefaultText', 'resultsPage'));
        }
        return (0, $iJxY6.default)(locId, 'successMessage', 'resultsPage');
    };
    async function emailResultsToFA() {
        setSendResultsLoading(true);
        (0, $fUEMe.default)('email-fa', {
            faId: faNo
        });
        const params = {
            locale: locId,
            notifyFaInd: 'Y',
            storeToDbInd: 'Y',
            archiveInd: coldContactData ? 'N' : 'Y',
            sysId: 'PRP',
            appName: 'MyPriorities',
            conType: (0, $jVt2v.default)(utmSource, utmContent),
            utmSource: (0, $lGrX9.default)(utmSource, entityIdParam, faNoParam, conId)
        };
        const data = {
            faNo: faNo,
            contactNo: conId,
            contactName: contactName,
            branchNo: faInfo.branchNo,
            results: resultsJSON,
            sessionId: sessionId,
            coldContactData: coldContactData,
            userComments: userComments,
            utmSource: (0, $lGrX9.default)(utmSource, entityIdParam, faNoParam, conId),
            planningTopics: planningTopics,
            investmentInvolvementCode: investmentInvolvementCode
        };
        const responseType = 'json';
        (0, $tL0U5.sendToDelegator)(params, data, responseType).then(()=>{
            setSendResultsLoading(false);
            setNotificationContent({
                message: successNotificationContentHandler(),
                type: 'confirmation'
            });
            setNotificationOpen(true);
            setSendResultsButtonDisabled(true);
            (0, $fUEMe.default)('confirmation-visible', {});
        }).catch((error)=>{
            if (error.response && error.response.status === 403) (0, $tL0U5.handleAVIError)(error, locId);
            setSendResultsLoading(false);
            setNotificationContent({
                message: coldContactData ? (0, $iJxY6.default)(locId, 'coldContactErrorMessage', 'resultsPage').replace('%FA_FIRSTNAME%', faInfo.faFirstName) : (0, $iJxY6.default)(locId, 'errorMessage', 'resultsPage'),
                type: 'error'
            });
            setNotificationOpen(true);
            /* eslint-disable no-console */ console.error(error);
        });
    }
    const modalHandler = ()=>{
        if (contactName.firstName) setDisplayCommentModal(true);
        else setDisplayColdContactModal(true);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            sendResultsButtonDisabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                label: (0, $iJxY6.default)(locId, 'successButton', 'resultsPage'),
                styleVariant: "reversed-secondary",
                disabled: true,
                attributes: {
                    value: '',
                    id: 'email-FA-button',
                    'data-testid': 'email-FA-button'
                },
                onClick: ()=>{}
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                loading: isSendResultsLoading,
                icon: "message-send",
                label: buttonText,
                onClick: ()=>modalHandler(),
                attributes: {
                    value: '',
                    id: 'email-FA-button',
                    'data-testid': 'email-FA-button'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12BeR.default), {
                displayColdContactModal: displayColdContactModal,
                setDisplayColdContactModal: setDisplayColdContactModal,
                emailResultsToFA: emailResultsToFA,
                coldContactData: coldContactData,
                setColdContactData: setColdContactData,
                faInfo: faInfo
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kmYFw.default), {
                displayCommentModal: displayCommentModal,
                setDisplayCommentModal: setDisplayCommentModal,
                emailResultsToFA: emailResultsToFA,
                setUserComments: setUserComments,
                faInfo: faInfo,
                contactName: contactName
            })
        ]
    });
};
$90f1e32217c60379$var$SendResultsButton.propTypes = {
    setNotificationContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    setNotificationOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    setSendResultsButtonDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    sendResultsButtonDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    sessionId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    coldContactData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        firstName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        lastName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        phoneNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    setColdContactData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    contactName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    userComments: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    setUserComments: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    resultsJSON: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any).isRequired,
    faInfo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        faNo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        branchNo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        faFirstName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        faLastName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        faPrimaryEmail: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        faTeamEmail: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        faPhoto: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }).isRequired,
    buttonText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    planningTopics: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    investmentInvolvementCode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
$90f1e32217c60379$var$SendResultsButton.defaultProps = {
    coldContactData: null,
    contactName: null
};
var $90f1e32217c60379$export$2e2bcd8739ae039 = $90f1e32217c60379$var$SendResultsButton;

});
parcelRegister("12BeR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c315144eebf8118$export$2e2bcd8739ae039);
/* eslint-disable no-use-before-define */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");

var $4tHKL = parcelRequire("4tHKL");

var $iJxY6 = parcelRequire("iJxY6");

var $9Ryut = parcelRequire("9Ryut");

var $l19uC = parcelRequire("l19uC");

const $2c315144eebf8118$var$AddContactFormModal = ({ displayColdContactModal: displayColdContactModal, setDisplayColdContactModal: setDisplayColdContactModal, emailResultsToFA: emailResultsToFA, coldContactData: coldContactData, setColdContactData: setColdContactData, faInfo: faInfo })=>{
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const nameRegex = /^[a-zA-ZÀ-ÿ ‘’´'-]*$/;
    // this regex will match strings that contain all white spaces (space, tab, etc.)
    const whiteSpaceRegex = /^\s*$/;
    // this regex will match strings that contain all digits;
    const digitsRegex = /[^0-9]/g;
    const faFullName = `${faInfo.faFirstName} ${faInfo.faLastName}`;
    const defaultText = (0, $iJxY6.default)(locId, 'defaultText', 'contactFormModal');
    const faHeadshotImage = faInfo.faPhoto;
    const [firstNameError, setFirstNameError] = (0, $acw62.useState)('');
    const [lastNameError, setLastNameError] = (0, $acw62.useState)('');
    const [emailError, setEmailError] = (0, $acw62.useState)('');
    const [phoneError, setPhoneError] = (0, $acw62.useState)('');
    const [localFirst, setLocalFirst] = (0, $acw62.useState)('');
    const [localLast, setLocalLast] = (0, $acw62.useState)('');
    const [localEmail, setLocalEmail] = (0, $acw62.useState)('');
    const [localPhone, setLocalPhone] = (0, $acw62.useState)('');
    const [isConsentCheckboxSelected, setIsConsentCheckboxSelected] = (0, $acw62.useState)(false);
    const [showConsentError, setShowConsentError] = (0, $acw62.useState)(false);
    const [isEmailMeCheckboxSelected, setIsEmailMeCheckboxSelected] = (0, $acw62.useState)(false);
    const firstNameMissingError = (0, $iJxY6.default)(locId, 'missingFirstNameError', 'contactFormModal');
    const lastNameMissingError = (0, $iJxY6.default)(locId, 'missingLastNameError', 'contactFormModal');
    const invalidFirstNameError = (0, $iJxY6.default)(locId, 'validFirstNameError', 'contactFormModal') + (0, $iJxY6.default)(locId, 'validNameChars', 'contactFormModal');
    const invalidLastNameError = (0, $iJxY6.default)(locId, 'validLastNameError', 'contactFormModal') + (0, $iJxY6.default)(locId, 'validNameChars', 'contactFormModal');
    const invalidEmailError = (0, $iJxY6.default)(locId, 'emailError', 'contactFormModal');
    const missingEmailError = (0, $iJxY6.default)(locId, 'missingEmailError', 'contactFormModal');
    const invalidPhoneError = (0, $iJxY6.default)(locId, 'phoneError', 'contactFormModal');
    const customPhoneMask = (0, $iJxY6.default)(locId, 'phoneMask', 'contactFormModal');
    const customPhoneMaskHelperText = (0, $iJxY6.default)(locId, 'phoneMaskHelperText', 'contactFormModal');
    const validateFirstName = ()=>{
        if (localFirst.length === 0 || whiteSpaceRegex.test(localFirst)) {
            setFirstNameError(firstNameMissingError);
            return false;
        }
        if (!nameRegex.test(localFirst)) {
            setFirstNameError(invalidFirstNameError);
            return false;
        }
        setLocalFirst(localFirst);
        setFirstNameError('');
        setColdContactData({
            ...coldContactData,
            firstName: localFirst.trim()
        });
        return true;
    };
    const validateLastName = ()=>{
        if (localLast.length === 0 || whiteSpaceRegex.test(localLast)) {
            setLastNameError(lastNameMissingError);
            return false;
        }
        if (!nameRegex.test(localLast)) {
            setLastNameError(invalidLastNameError);
            return false;
        }
        setLocalLast(localLast);
        setLastNameError('');
        setColdContactData({
            ...coldContactData,
            lastName: localLast.trim()
        });
        return true;
    };
    const isInValidEmail = (value)=>value !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($4tHKL)))(value);
    const isInvalidPhone = (value)=>value !== '' && value.length !== 10;
    const isValidEmailAndPhoneCombination = ()=>{
        const unmaskedPhoneNumber = localPhone.replace(digitsRegex, '');
        if (localEmail === '' && unmaskedPhoneNumber === '') {
            setEmailError(invalidEmailError);
            setPhoneError(invalidPhoneError);
            return false;
        }
        if (isInValidEmail(localEmail) && unmaskedPhoneNumber === '') {
            setEmailError(invalidEmailError);
            setPhoneError('');
            return false;
        }
        if (localEmail === '' && isInvalidPhone(unmaskedPhoneNumber)) {
            setEmailError('');
            setPhoneError(invalidPhoneError);
            return false;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4tHKL)))(localEmail) && isInvalidPhone(unmaskedPhoneNumber)) {
            setEmailError('');
            setPhoneError(invalidPhoneError);
            return false;
        }
        if (isInValidEmail(localEmail) && unmaskedPhoneNumber.length === 10) {
            setEmailError(invalidEmailError);
            setPhoneError('');
            return false;
        }
        if (isInValidEmail(localEmail) && isInvalidPhone(unmaskedPhoneNumber)) {
            setEmailError(invalidEmailError);
            setPhoneError(invalidPhoneError);
            return false;
        }
        if (localEmail === '' && isEmailMeCheckboxSelected) {
            setEmailError(missingEmailError);
            setPhoneError('');
            return false;
        }
        setLocalEmail(localEmail);
        setEmailError('');
        if (localPhone === '(') setLocalPhone('');
        else setLocalPhone(localPhone);
        setPhoneError('');
        setColdContactData({
            ...coldContactData,
            email: localEmail === '' ? null : localEmail.trim(),
            phoneNumber: unmaskedPhoneNumber === '' ? null : unmaskedPhoneNumber.trim()
        });
        return true;
    };
    const isConsentChecked = ()=>{
        if (!isConsentCheckboxSelected) {
            setShowConsentError(true);
            return false;
        }
        setShowConsentError(false);
        return true;
    };
    const shareButtonHandler = ()=>{
        let isValidForm = true;
        if (!validateFirstName()) isValidForm = false;
        if (!validateLastName()) isValidForm = false;
        if (!isValidEmailAndPhoneCombination()) isValidForm = false;
        if (!isConsentChecked()) isValidForm = false;
        if (isValidForm) {
            setDisplayColdContactModal(false);
            emailResultsToFA();
        }
    };
    const consentCheckboxHandler = ()=>{
        let consentToFAContactTimestamp;
        if (!isConsentCheckboxSelected) {
            consentToFAContactTimestamp = new Date().toISOString();
            setIsConsentCheckboxSelected(true);
            setShowConsentError(false);
        } else {
            consentToFAContactTimestamp = null;
            setIsConsentCheckboxSelected(false);
        }
        setColdContactData({
            ...coldContactData,
            consentToFAContactTimestamp: consentToFAContactTimestamp
        });
    };
    const emailMeCheckboxHandler = ()=>{
        let emailResultsToContactTimestamp;
        if (!isEmailMeCheckboxSelected) {
            emailResultsToContactTimestamp = new Date().toISOString();
            setIsEmailMeCheckboxSelected(true);
        } else {
            emailResultsToContactTimestamp = null;
            setIsEmailMeCheckboxSelected(false);
        }
        setColdContactData({
            ...coldContactData,
            emailResultsToContactTimestamp: emailResultsToContactTimestamp
        });
    };
    const headerTextHandler = ()=>{
        const baseHeaderText = (0, $iJxY6.default)(locId, 'header', 'contactFormModal');
        let headerText;
        if (faInfo.faFirstName && faInfo.faLastName) headerText = baseHeaderText.replace('%FA_NAME%', faFullName);
        else headerText = baseHeaderText.replace('%FA_NAME%', defaultText);
        return headerText;
    };
    const buttons = [
        {
            text: (0, $iJxY6.default)(locId, 'cancelButton', 'contactFormModal'),
            onClick: ()=>setDisplayColdContactModal(false),
            styleVariant: 'secondary'
        },
        {
            text: (0, $iJxY6.default)(locId, 'shareResultsButton', 'contactFormModal'),
            onClick: ()=>shareButtonHandler(),
            styleVariant: 'primary'
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7lk71.Dialog), {
        title: "",
        open: displayColdContactModal,
        buttons: buttons,
        className: "contactFaModal",
        onRequestClose: ()=>setDisplayColdContactModal(false),
        children: [
            ' ',
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "title-container",
                children: [
                    faHeadshotImage ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "fa-headshot",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: `data:image/png;base64,${faHeadshotImage}`,
                            alt: "",
                            role: "presentation",
                            "data-testid": "fa-headshot"
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: headerTextHandler()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "modal-paragraph",
                    children: faInfo.faFirstName && faInfo.faLastName ? (0, $iJxY6.default)(locId, 'paragraphText', 'contactFormModal').replace('%FA_NAME%', faFullName) : (0, $iJxY6.default)(locId, 'paragraphText', 'contactFormModal').replace('%FA_NAME%', defaultText)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                onSubmit: shareButtonHandler,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.TextInput), {
                        id: "first-name",
                        label: (0, $iJxY6.default)(locId, 'firstNameLabel', 'contactFormModal'),
                        name: "first-name",
                        value: localFirst,
                        type: "text",
                        onChange: (text)=>{
                            setLocalFirst(text);
                            setColdContactData({
                                ...coldContactData,
                                firstName: text.trim()
                            });
                        },
                        onBlur: validateFirstName,
                        error: firstNameError
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.TextInput), {
                        id: "last-name",
                        label: (0, $iJxY6.default)(locId, 'lastNameLabel', 'contactFormModal'),
                        name: "last-name",
                        value: localLast,
                        type: "text",
                        onChange: (text)=>{
                            setLocalLast(text);
                            setColdContactData({
                                ...coldContactData,
                                lastName: text.trim()
                            });
                        },
                        onBlur: validateLastName,
                        error: lastNameError
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.TextInput), {
                        id: "email",
                        label: (0, $iJxY6.default)(locId, 'emailLabel', 'contactFormModal'),
                        name: "email",
                        value: localEmail,
                        type: locId.toLowerCase() === (0, $l19uC.LOCALE_FR_CA).toLowerCase() ? 'text' : 'email',
                        onChange: (text)=>{
                            setLocalEmail(text);
                            setColdContactData({
                                ...coldContactData,
                                email: text === '' ? null : text.trim()
                            });
                        },
                        onBlur: ()=>{
                            setColdContactData({
                                ...coldContactData,
                                email: localEmail === '' ? null : localEmail.trim()
                            });
                        },
                        error: emailError
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.MaskedInput), {
                        id: "phone",
                        label: (0, $iJxY6.default)(locId, 'phoneLabel', 'contactFormModal'),
                        name: "phone",
                        customMask: customPhoneMask,
                        customMaskHelperText: customPhoneMaskHelperText,
                        value: localPhone,
                        onChange: (text)=>{
                            setLocalPhone(text);
                            const unmaskedPhoneNumber = text.replace(digitsRegex, '');
                            setColdContactData({
                                ...coldContactData,
                                phoneNumber: unmaskedPhoneNumber === '' ? null : unmaskedPhoneNumber.trim()
                            });
                        },
                        onBlur: ()=>{
                            const unmaskedPhoneNumber = localPhone.replace(digitsRegex, '');
                            setColdContactData({
                                ...coldContactData,
                                phoneNumber: unmaskedPhoneNumber === '' ? null : unmaskedPhoneNumber.trim()
                            });
                        },
                        error: phoneError
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: showConsentError ? 'consent-checkbox-error' : '',
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Checkbox), {
                            checked: isConsentCheckboxSelected,
                            id: "consent",
                            name: "consent",
                            label: (0, $iJxY6.default)(locId, 'consentLabel', 'contactFormModal'),
                            onChange: ()=>{
                                consentCheckboxHandler();
                            }
                        })
                    }),
                    showConsentError ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "consent-error",
                        children: (0, $iJxY6.default)(locId, 'consentError', 'contactFormModal')
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Checkbox), {
                        checked: isEmailMeCheckboxSelected,
                        id: "emailMe",
                        name: "emailMe",
                        label: (0, $iJxY6.default)(locId, 'emailMeLabel', 'contactFormModal'),
                        onChange: ()=>{
                            emailMeCheckboxHandler();
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "add-phone-or-email-requirement",
                        children: (0, $iJxY6.default)(locId, 'requiredLabel', 'contactFormModal')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "modalFooter",
                        children: (0, $iJxY6.default)(locId, 'footerText', 'contactFormModal')
                    })
                ]
            })
        ]
    });
};
$2c315144eebf8118$var$AddContactFormModal.propTypes = {
    displayColdContactModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    setDisplayColdContactModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    emailResultsToFA: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    faInfo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        faNo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        branchNo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        faFirstName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        faLastName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        faPrimaryEmail: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        faTeamEmail: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        faPhoto: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }).isRequired,
    coldContactData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        firstName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        lastName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        phoneNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    setColdContactData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
$2c315144eebf8118$var$AddContactFormModal.defaultProps = {
    coldContactData: null
};
var $2c315144eebf8118$export$2e2bcd8739ae039 = $2c315144eebf8118$var$AddContactFormModal;

});
parcelRegister("4tHKL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $342bcf524c691bd2$var$isEmail;

var $342bcf524c691bd2$var$_assertString = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $342bcf524c691bd2$var$_checkHost = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("aMQeC")));

var $342bcf524c691bd2$var$_isByteLength = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("lIM5C")));

var $342bcf524c691bd2$var$_isFQDN = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("hNevj")));

var $342bcf524c691bd2$var$_isIP = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("k4gOC")));

var $342bcf524c691bd2$var$_merge = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $342bcf524c691bd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $342bcf524c691bd2$var$default_email_options = {
    allow_display_name: false,
    allow_underscores: false,
    require_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true,
    blacklisted_chars: '',
    ignore_max_length: false,
    host_blacklist: [],
    host_whitelist: []
};
/* eslint-disable max-len */ /* eslint-disable no-control-regex */ var $342bcf524c691bd2$var$splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var $342bcf524c691bd2$var$emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var $342bcf524c691bd2$var$gmailUserPart = /^[a-z\d]+$/;
var $342bcf524c691bd2$var$quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var $342bcf524c691bd2$var$emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var $342bcf524c691bd2$var$quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var $342bcf524c691bd2$var$defaultMaxEmailLength = 254;
/* eslint-enable max-len */ /* eslint-enable no-control-regex */ /**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */ function $342bcf524c691bd2$var$validateDisplayName(display_name) {
    var display_name_without_quotes = display_name.replace(/^"(.+)"$/, '$1');
    // display name with only spaces is not valid
    if (!display_name_without_quotes.trim()) return false;
    // check whether display name contains illegal character
    var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
    if (contains_illegal) {
        // if contains illegal characters,
        // must to be enclosed in double-quotes, otherwise it's not a valid display name
        if (display_name_without_quotes === display_name) return false;
        // the quotes in display name must start with character symbol \
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) return false;
    }
    return true;
}
function $342bcf524c691bd2$var$isEmail(str, options) {
    (0, $342bcf524c691bd2$var$_assertString.default)(str);
    options = (0, $342bcf524c691bd2$var$_merge.default)(options, $342bcf524c691bd2$var$default_email_options);
    if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match($342bcf524c691bd2$var$splitNameAddress);
        if (display_email) {
            var display_name = display_email[1];
            // Remove display name and angle brackets to get email address
            // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)
            str = str.replace(display_name, '').replace(/(^<|>$)/g, '');
            // sometimes need to trim the last space to get the display name
            // because there may be a space between display name and email address
            // eg. myname <address@gmail.com>
            // the display name is `myname` instead of `myname `, so need to trim the last space
            if (display_name.endsWith(' ')) display_name = display_name.slice(0, -1);
            if (!$342bcf524c691bd2$var$validateDisplayName(display_name)) return false;
        } else if (options.require_display_name) return false;
    }
    if (!options.ignore_max_length && str.length > $342bcf524c691bd2$var$defaultMaxEmailLength) return false;
    var parts = str.split('@');
    var domain = parts.pop();
    var lower_domain = domain.toLowerCase();
    if (options.host_blacklist.length > 0 && (0, $342bcf524c691bd2$var$_checkHost.default)(lower_domain, options.host_blacklist)) return false;
    if (options.host_whitelist.length > 0 && !(0, $342bcf524c691bd2$var$_checkHost.default)(lower_domain, options.host_whitelist)) return false;
    var user = parts.join('@');
    if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
        /*
    Previously we removed dots for gmail addresses before validating.
    This was removed because it allows `multiple..dots@gmail.com`
    to be reported as valid, but it is not.
    Gmail only normalizes single dots, removing them from here is pointless,
    should be done in normalizeEmail
    */ user = user.toLowerCase();
        // Removing sub-address from username before gmail validation
        var username = user.split('+')[0];
        // Dots are not included in gmail length restriction
        if (!(0, $342bcf524c691bd2$var$_isByteLength.default)(username.replace(/\./g, ''), {
            min: 6,
            max: 30
        })) return false;
        var _user_parts = username.split('.');
        for(var i = 0; i < _user_parts.length; i++){
            if (!$342bcf524c691bd2$var$gmailUserPart.test(_user_parts[i])) return false;
        }
    }
    if (options.ignore_max_length === false && (!(0, $342bcf524c691bd2$var$_isByteLength.default)(user, {
        max: 64
    }) || !(0, $342bcf524c691bd2$var$_isByteLength.default)(domain, {
        max: 254
    }))) return false;
    if (!(0, $342bcf524c691bd2$var$_isFQDN.default)(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length,
        allow_underscores: options.allow_underscores
    })) {
        if (!options.allow_ip_domain) return false;
        if (!(0, $342bcf524c691bd2$var$_isIP.default)(domain)) {
            if (!domain.startsWith('[') || !domain.endsWith(']')) return false;
            var noBracketdomain = domain.slice(1, -1);
            if (noBracketdomain.length === 0 || !(0, $342bcf524c691bd2$var$_isIP.default)(noBracketdomain)) return false;
        }
    }
    if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
    }
    if (user[0] === '"' && user[user.length - 1] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? $342bcf524c691bd2$var$quotedEmailUserUtf8.test(user) : $342bcf524c691bd2$var$quotedEmailUser.test(user);
    }
    var pattern = options.allow_utf8_local_part ? $342bcf524c691bd2$var$emailUserUtf8Part : $342bcf524c691bd2$var$emailUserPart;
    var user_parts = user.split('.');
    for(var _i = 0; _i < user_parts.length; _i++){
        if (!pattern.test(user_parts[_i])) return false;
    }
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("hZqWG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d18d08f8e9af886d$var$assertString;
function $d18d08f8e9af886d$var$assertString(input) {
    if (input === undefined || input === null) throw new TypeError("Expected a string but received a ".concat(input));
    if (input.constructor.name !== 'String') throw new TypeError("Expected a string but received a ".concat(input.constructor.name));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("aMQeC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7da6e7cd69c99b8c$var$checkHost;
function $7da6e7cd69c99b8c$var$isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
}
function $7da6e7cd69c99b8c$var$checkHost(host, matches) {
    for(var i = 0; i < matches.length; i++){
        var match = matches[i];
        if (host === match || $7da6e7cd69c99b8c$var$isRegExp(match) && match.test(host)) return true;
    }
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("lIM5C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd0302a416500dad$var$isByteLength;

var $fd0302a416500dad$var$_assertString = $fd0302a416500dad$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $fd0302a416500dad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $fd0302a416500dad$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fd0302a416500dad$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fd0302a416500dad$var$_typeof(o);
}
/* eslint-disable prefer-rest-params */ function $fd0302a416500dad$var$isByteLength(str, options) {
    (0, $fd0302a416500dad$var$_assertString.default)(str);
    var min;
    var max;
    if ($fd0302a416500dad$var$_typeof(options) === 'object') {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isByteLength(str, min [, max])
        min = arguments[1];
        max = arguments[2];
    }
    var len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("hNevj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cf424376bb64783b$var$isFQDN;

var $cf424376bb64783b$var$_assertString = $cf424376bb64783b$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $cf424376bb64783b$var$_merge = $cf424376bb64783b$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $cf424376bb64783b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $cf424376bb64783b$var$default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_numeric_tld: false,
    allow_wildcard: false,
    ignore_max_length: false
};
function $cf424376bb64783b$var$isFQDN(str, options) {
    (0, $cf424376bb64783b$var$_assertString.default)(str);
    options = (0, $cf424376bb64783b$var$_merge.default)(options, $cf424376bb64783b$var$default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */ if (options.allow_trailing_dot && str[str.length - 1] === '.') str = str.substring(0, str.length - 1);
    /* Remove the optional wildcard before checking validity */ if (options.allow_wildcard === true && str.indexOf('*.') === 0) str = str.substring(2);
    var parts = str.split('.');
    var tld = parts[parts.length - 1];
    if (options.require_tld) {
        // disallow fqdns without tld
        if (parts.length < 2) return false;
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) return false;
        // disallow spaces
        if (/\s/.test(tld)) return false;
    }
    // reject numeric TLDs
    if (!options.allow_numeric_tld && /^\d+$/.test(tld)) return false;
    return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) return false;
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) return false;
        // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) return false;
        // disallow parts starting or ending with hyphen
        if (/^-|-$/.test(part)) return false;
        if (!options.allow_underscores && /_/.test(part)) return false;
        return true;
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("9nDkO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d44c6112d12dafe$var$merge;
function $6d44c6112d12dafe$var$merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;
    for(var key in defaults)if (typeof obj[key] === 'undefined') obj[key] = defaults[key];
    return obj;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("k4gOC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9c1399487ce19b5$var$isIP;

var $e9c1399487ce19b5$var$_assertString = $e9c1399487ce19b5$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $e9c1399487ce19b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $e9c1399487ce19b5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e9c1399487ce19b5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e9c1399487ce19b5$var$_typeof(o);
}
/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */ var $e9c1399487ce19b5$var$IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
var $e9c1399487ce19b5$var$IPv4AddressFormat = "(".concat($e9c1399487ce19b5$var$IPv4SegmentFormat, "[.]){3}").concat($e9c1399487ce19b5$var$IPv4SegmentFormat);
var $e9c1399487ce19b5$var$IPv4AddressRegExp = new RegExp("^".concat($e9c1399487ce19b5$var$IPv4AddressFormat, "$"));
var $e9c1399487ce19b5$var$IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})';
var $e9c1399487ce19b5$var$IPv6AddressRegExp = new RegExp('^(' + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){7}(?:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){6}(?:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){5}(?::").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){4}(?:(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,1}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){3}(?:(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,2}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){2}(?:(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,3}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){1}(?:(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,4}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,5}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(?::").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,7}|:))") + ')(%[0-9a-zA-Z.]{1,})?$');
function $e9c1399487ce19b5$var$isIP(ipAddress) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $e9c1399487ce19b5$var$_assertString.default)(ipAddress);
    // accessing 'arguments' for backwards compatibility: isIP(ipAddress [, version])
    // eslint-disable-next-line prefer-rest-params
    var version = ($e9c1399487ce19b5$var$_typeof(options) === 'object' ? options.version : arguments[1]) || '';
    if (!version) return $e9c1399487ce19b5$var$isIP(ipAddress, {
        version: 4
    }) || $e9c1399487ce19b5$var$isIP(ipAddress, {
        version: 6
    });
    if (version.toString() === '4') return $e9c1399487ce19b5$var$IPv4AddressRegExp.test(ipAddress);
    if (version.toString() === '6') return $e9c1399487ce19b5$var$IPv6AddressRegExp.test(ipAddress);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});



parcelRegister("kmYFw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b20a892c98c33661$export$2e2bcd8739ae039);
/* eslint-disable no-use-before-define */ /* eslint-disable no-useless-escape */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");


var $9Ryut = parcelRequire("9Ryut");

var $iJxY6 = parcelRequire("iJxY6");
const $b20a892c98c33661$var$CommentModal = ({ displayCommentModal: displayCommentModal, setDisplayCommentModal: setDisplayCommentModal, setUserComments: setUserComments, contactName: contactName, emailResultsToFA: emailResultsToFA, faInfo: faInfo })=>{
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const commentRegex = /[`~\*\^\[\]{}]/;
    const MAX_LENGTH = 500;
    const faFullName = `${faInfo.faFirstName} ${faInfo.faLastName}`;
    const defaultText = (0, $iJxY6.default)(locId, 'defaultText', 'commentModal');
    const faHeadshotImage = faInfo.faPhoto;
    const invalidComment = (0, $iJxY6.default)(locId, 'commentError', 'commentModal') + (0, $iJxY6.default)(locId, 'invalidChars', 'commentModal');
    const [isShareButtonDisabled, setIsShareButtonDisabled] = (0, $acw62.useState)(false);
    const [commentError, setCommentError] = (0, $acw62.useState)(null);
    const [subText, setSubText] = (0, $acw62.useState)((0, $iJxY6.default)(locId, 'paragraphOneText', 'commentModal').replace('%MAX_LENGTH%', MAX_LENGTH.toString()));
    const [charsLeft, setCharsLeft] = (0, $acw62.useState)(MAX_LENGTH);
    const [localComment, setLocalComment] = (0, $acw62.useState)('');
    const buttons = [
        {
            text: (0, $iJxY6.default)(locId, 'cancelButton', 'commentModal'),
            onClick: ()=>setDisplayCommentModal(false),
            styleVariant: 'secondary'
        },
        {
            text: (0, $iJxY6.default)(locId, 'shareResultsButton', 'contactFormModal'),
            onClick: ()=>shareButtonHandler(),
            styleVariant: 'primary',
            disabled: isShareButtonDisabled
        }
    ];
    const validateComment = (input)=>{
        setLocalComment(input);
        setIsShareButtonDisabled(commentRegex.test(input));
        setCommentError(commentRegex.test(input) ? invalidComment : null);
    };
    const headerTextHandler = ()=>{
        const baseHeaderText = (0, $iJxY6.default)(locId, 'header', 'commentModal');
        let headerText;
        if (faInfo.faFirstName && faInfo.faLastName) headerText = baseHeaderText.replace('%CONTACT_FIRSTNAME%', contactName.firstName).replace('%FA_NAME%', faFullName);
        else headerText = baseHeaderText.replace('%CONTACT_FIRSTNAME%', contactName.firstName).replace('%FA_NAME%', defaultText);
        return headerText;
    };
    const shareButtonHandler = ()=>{
        if (!commentError) {
            setDisplayCommentModal(false);
            emailResultsToFA();
        }
    };
    const commentHandler = (input)=>{
        validateComment(input);
        setUserComments(input);
        setCharsLeft(MAX_LENGTH - input.length);
    };
    const handleParagraphOneFaText = ()=>{
        const paragraphOneText = (0, $iJxY6.default)(locId, 'paragraphOneText', 'commentModal');
        const faDefaultText = (0, $iJxY6.default)(locId, 'defaultText', 'commentModal');
        if (faInfo.faFirstName) return paragraphOneText.replace('%FA_NAME%', faInfo.faFirstName);
        return paragraphOneText.replace('%FA_NAME%', faDefaultText.charAt(0).toUpperCase() + faDefaultText.slice(1));
    };
    (0, $acw62.useEffect)(()=>{
        if (charsLeft === MAX_LENGTH) setSubText((0, $iJxY6.default)(locId, 'subTextOne', 'commentModal').replace('%MAX_LENGTH%', MAX_LENGTH.toString()));
        else setSubText((0, $iJxY6.default)(locId, 'subTextTwo', 'commentModal').replace('%CHARS_LEFT%', charsLeft.toString()));
    }, [
        charsLeft
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7lk71.Dialog), {
        title: "",
        open: displayCommentModal,
        buttons: buttons,
        className: "commentModal",
        onRequestClose: ()=>setDisplayCommentModal(false),
        children: [
            ' ',
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "title-container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: headerTextHandler()
                    }),
                    faHeadshotImage ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "fa-headshot",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: `data:image/png;base64,${faHeadshotImage}`,
                            alt: "",
                            role: "presentation",
                            "data-testid": "fa-headshot"
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "comment-modal-paragraph",
                        children: handleParagraphOneFaText()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "comment-modal-paragraph",
                        children: (0, $iJxY6.default)(locId, 'paragraphTwoText', 'commentModal')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.TextArea), {
                id: "user-comment",
                label: (0, $iJxY6.default)(locId, 'label', 'commentModal'),
                classes: "commentModal",
                name: "user-comment",
                value: localComment,
                maxLength: MAX_LENGTH,
                microcopy: subText,
                onChange: (text)=>commentHandler(text),
                onBlur: validateComment,
                error: commentError
            })
        ]
    });
};
$b20a892c98c33661$var$CommentModal.propTypes = {
    displayCommentModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    setDisplayCommentModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    setUserComments: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    contactName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string).isRequired,
    emailResultsToFA: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    faInfo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string).isRequired
};
var $b20a892c98c33661$export$2e2bcd8739ae039 = $b20a892c98c33661$var$CommentModal;

});


parcelRegister("kiK3k", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd64ad376ee414c8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7lk71 = parcelRequire("7lk71");

var $c9Z8w = parcelRequire("c9Z8w");

var $jVt2v = parcelRequire("jVt2v");

var $iJxY6 = parcelRequire("iJxY6");

var $58ODK = parcelRequire("58ODK");

var $fUEMe = parcelRequire("fUEMe");

var $9Ryut = parcelRequire("9Ryut");

var $tL0U5 = parcelRequire("tL0U5");
const $cd64ad376ee414c8$var$GoToFinancialFoundationsButton = ({ setNotificationContent: setNotificationContent, setNotificationOpen: setNotificationOpen, sessionId: sessionId, resultsJSON: resultsJSON, faInfo: faInfo, planningTopics: planningTopics, investmentInvolvementCode: investmentInvolvementCode })=>{
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const urlQuery = (0, $58ODK.default)();
    const faNo = urlQuery.get('faNo') || faInfo.faNo;
    const conId = urlQuery.get('conId');
    const utmSource = urlQuery.get('utm_source');
    const [isSaveResultsLoading, setIsSaveResultsLoading] = (0, $acw62.useState)(false);
    const [isSaveResultsButtonDisabled, setIsSaveResultsButtonDisabled] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        // Add when utm_source is another app that called MP
        window.addEventListener('beforeunload', ()=>{
            window.opener.postMessage({
                functionNa: 'refreshDashboard'
            }, window.FINANCIAL_FOUNDATIONS_ORIGIN);
        });
    }, []);
    async function saveResults() {
        setIsSaveResultsLoading(true);
        (0, $fUEMe.default)('email-fa', {
            faId: faNo
        });
        const params = {
            locale: locId,
            notifyFaInd: 'N',
            storeToDbInd: 'Y',
            archiveInd: 'Y',
            sysId: 'PRP',
            appName: 'MyPriorities',
            conType: (0, $jVt2v.default)(utmSource, null),
            utmSource: utmSource
        };
        const data = {
            faNo: faNo,
            contactNo: conId,
            contactName: null,
            branchNo: faInfo.branchNo,
            results: resultsJSON,
            sessionId: sessionId,
            utmSource: utmSource,
            userComments: null,
            coldContactData: null,
            planningTopics: planningTopics,
            investmentInvolvementCode: investmentInvolvementCode
        };
        const responseType = 'json';
        (0, $tL0U5.sendToDelegator)(params, data, responseType).then(()=>{
            setIsSaveResultsLoading(false);
            setIsSaveResultsButtonDisabled(true);
            (0, $fUEMe.default)('confirmation-visible', {});
            window.close();
        }).catch((error)=>{
            if (error.response && error.response.status === 403) (0, $tL0U5.handleAVIError)(error, locId);
            setIsSaveResultsLoading(false);
            setNotificationContent({
                message: (0, $iJxY6.default)(locId, 'saveResultsErrorMessage', 'resultsPage'),
                type: 'error'
            });
            setNotificationOpen(true);
            /* eslint-disable no-console */ console.error(error);
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: isSaveResultsButtonDisabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
            label: (0, $iJxY6.default)(locId, 'successButton', 'resultsPage'),
            styleVariant: "reversed-secondary",
            disabled: true,
            attributes: {
                value: '',
                id: 'save-results-button',
                'data-testid': 'save-results-button'
            },
            onClick: ()=>{}
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
            loading: isSaveResultsLoading,
            icon: "message-send",
            label: (0, $iJxY6.default)(locId, 'saveResultsFF', 'resultsPage'),
            onClick: ()=>saveResults(),
            attributes: {
                value: '',
                id: 'save-results-button',
                'data-testid': 'save-results-button'
            }
        })
    });
};
$cd64ad376ee414c8$var$GoToFinancialFoundationsButton.propTypes = {
    setNotificationContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    setNotificationOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    sessionId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    resultsJSON: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any).isRequired,
    faInfo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string).isRequired,
    planningTopics: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    investmentInvolvementCode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $cd64ad376ee414c8$export$2e2bcd8739ae039 = $cd64ad376ee414c8$var$GoToFinancialFoundationsButton;

});

parcelRegister("5W5zw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee9234591952e6ec$export$2e2bcd8739ae039);
/* eslint-disable no-shadow */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $55APJ = parcelRequire("55APJ");

var $428tW = parcelRequire("428tW");

var $dL0oN = parcelRequire("dL0oN");

var $aBuZM = parcelRequire("aBuZM");

var $fKxvO = parcelRequire("fKxvO");

const $ee9234591952e6ec$var$DnDContainer = function DnDContainer({ finalResultsStatementIds: finalResultsStatementIds, valueList: valueList, setFinalResultsStatementIds: setFinalResultsStatementIds }) {
    const CardsArray = finalResultsStatementIds.map((result)=>({
            id: result,
            text: (0, $fKxvO.default)(result, valueList)
        }));
    const [resultCards, setResultCards] = (0, $acw62.useState)(CardsArray);
    const findCard = (0, $acw62.useCallback)((id)=>{
        const card = resultCards.filter((c)=>`${c.id}` === id)[0];
        return {
            card: card,
            index: resultCards.indexOf(card)
        };
    }, [
        resultCards
    ]);
    const moveCard = (0, $acw62.useCallback)((id, atIndex)=>{
        const { card: card, index: index } = findCard(id);
        setResultCards((0, (/*@__PURE__*/$parcel$interopDefault($428tW)))(resultCards, {
            $splice: [
                [
                    index,
                    1
                ],
                [
                    atIndex,
                    0,
                    card
                ]
            ]
        }));
    }, [
        findCard,
        resultCards,
        setResultCards
    ]);
    const [, drop] = (0, $55APJ.useDrop)(()=>({
            accept: (0, $aBuZM.default).CARD
        }));
    (0, $acw62.useEffect)(()=>{
        setFinalResultsStatementIds(resultCards.map((result)=>result.id));
    }, [
        resultCards
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: drop,
        className: "results-card-container",
        children: resultCards.map((card, i)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "result-row",
                "data-testid": i,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "result-rank",
                        children: i + 1
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dL0oN.default), {
                        id: `${card.id}`,
                        text: card.text,
                        moveCard: moveCard,
                        findCard: findCard
                    }, card.id)
                ]
            }, card.id);
        })
    });
};
$ee9234591952e6ec$var$DnDContainer.propTypes = {
    finalResultsStatementIds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
    valueList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    setFinalResultsStatementIds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $ee9234591952e6ec$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($ee9234591952e6ec$var$DnDContainer);

});
parcelRegister("55APJ", function(module, exports) {

$parcel$export(module.exports, "useDrop", () => $3b49fdb4c2c45d28$export$ccdee5eaf73cf661);

var $bStjo = parcelRequire("bStjo");

var $1rYxn = parcelRequire("1rYxn");

var $8ZwyJ = parcelRequire("8ZwyJ");

var $lRRDc = parcelRequire("lRRDc");

var $4XhMK = parcelRequire("4XhMK");

var $3Bu7R = parcelRequire("3Bu7R");
function $3b49fdb4c2c45d28$export$ccdee5eaf73cf661(specArg, deps) {
    const spec = (0, $1rYxn.useOptionalFactory)(specArg, deps);
    const monitor = (0, $4XhMK.useDropTargetMonitor)();
    const connector = (0, $lRRDc.useDropTargetConnector)(spec.options);
    (0, $3Bu7R.useRegisteredDropTarget)(spec, monitor, connector);
    return [
        (0, $bStjo.useCollectedProps)(spec.collect, monitor, connector),
        (0, $8ZwyJ.useConnectDropTarget)(connector)
    ];
}

});
parcelRegister("bStjo", function(module, exports) {

$parcel$export(module.exports, "useCollectedProps", () => $8a5b7991e12da12a$export$a55a4e3c0acb6f15);

var $6GurH = parcelRequire("6GurH");
function $8a5b7991e12da12a$export$a55a4e3c0acb6f15(collector, monitor, connector) {
    return (0, $6GurH.useMonitorOutput)(monitor, collector || (()=>({})), ()=>connector.reconnect());
}

});
parcelRegister("6GurH", function(module, exports) {

$parcel$export(module.exports, "useMonitorOutput", () => $4dde4834f5d097b8$export$f34439a5e43bd79c);

var $fKaGx = parcelRequire("fKaGx");

var $hfTxv = parcelRequire("hfTxv");
function $4dde4834f5d097b8$export$f34439a5e43bd79c(monitor, collect, onCollect) {
    const [collected, updateCollected] = (0, $fKaGx.useCollector)(monitor, collect, onCollect);
    (0, $hfTxv.useIsomorphicLayoutEffect)(function subscribeToMonitorStateChange() {
        const handlerId = monitor.getHandlerId();
        if (handlerId == null) return;
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}

});
parcelRegister("fKaGx", function(module, exports) {

$parcel$export(module.exports, "useCollector", () => $b76370bfa04dc6f4$export$e32e64a4387f290a);

var $7hFx0 = parcelRequire("7hFx0");

var $acw62 = parcelRequire("acw62");

var $hfTxv = parcelRequire("hfTxv");
function $b76370bfa04dc6f4$export$e32e64a4387f290a(monitor, collect, onUpdate) {
    const [collected, setCollected] = (0, $acw62.useState)(()=>collect(monitor));
    const updateCollected = (0, $acw62.useCallback)(()=>{
        const nextValue = collect(monitor);
        // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]);
    // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    (0, $hfTxv.useIsomorphicLayoutEffect)(updateCollected);
    return [
        collected,
        updateCollected
    ];
}

});
parcelRegister("7hFx0", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("hfTxv", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $c8feeb5675da8041$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
const $c8feeb5675da8041$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});




parcelRegister("1rYxn", function(module, exports) {

$parcel$export(module.exports, "useOptionalFactory", () => $10e74584d28cd2d8$export$f16a07909151e918);

var $acw62 = parcelRequire("acw62");
function $10e74584d28cd2d8$export$f16a07909151e918(arg, deps) {
    const memoDeps = [
        ...deps || []
    ];
    if (deps == null && typeof arg !== 'function') memoDeps.push(arg);
    return (0, $acw62.useMemo)(()=>{
        return typeof arg === 'function' ? arg() : arg;
    }, memoDeps);
}

});

parcelRegister("8ZwyJ", function(module, exports) {

$parcel$export(module.exports, "useConnectDropTarget", () => $68bd46cea6afedc8$export$c914595a34b9504a);

var $acw62 = parcelRequire("acw62");
function $68bd46cea6afedc8$export$c914595a34b9504a(connector) {
    return (0, $acw62.useMemo)(()=>connector.hooks.dropTarget(), [
        connector
    ]);
}

});

parcelRegister("lRRDc", function(module, exports) {

$parcel$export(module.exports, "useDropTargetConnector", () => $feb826422e9ebf61$export$29242ded1aad6df7);

var $acw62 = parcelRequire("acw62");

var $1HCAx = parcelRequire("1HCAx");

var $apqQ9 = parcelRequire("apqQ9");

var $hfTxv = parcelRequire("hfTxv");
function $feb826422e9ebf61$export$29242ded1aad6df7(options) {
    const manager = (0, $apqQ9.useDragDropManager)();
    const connector = (0, $acw62.useMemo)(()=>new (0, $1HCAx.TargetConnector)(manager.getBackend()), [
        manager
    ]);
    (0, $hfTxv.useIsomorphicLayoutEffect)(()=>{
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return ()=>connector.disconnectDropTarget();
    }, [
        options
    ]);
    return connector;
}

});
parcelRegister("1HCAx", function(module, exports) {

$parcel$export(module.exports, "TargetConnector", () => $13d7bd75241262af$export$ed6d7b7bc55193cf);

var $eoD60 = parcelRequire("eoD60");

var $4M7Hr = parcelRequire("4M7Hr");

var $8BAAh = parcelRequire("8BAAh");
class $13d7bd75241262af$export$ed6d7b7bc55193cf {
    get connectTarget() {
        return this.dropTarget;
    }
    reconnect() {
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
        if (didChange) this.disconnectDropTarget();
        const dropTarget = this.dropTarget;
        if (!this.handlerId) return;
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    }
    receiveHandlerId(newHandlerId) {
        if (newHandlerId === this.handlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get dropTargetOptions() {
        return this.dropTargetOptionsInternal;
    }
    set dropTargetOptions(options) {
        this.dropTargetOptionsInternal = options;
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didDropTargetChange() {
        return this.lastConnectedDropTarget !== this.dropTarget;
    }
    didOptionsChange() {
        return !(0, $eoD60.shallowEqual)(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
    disconnectDropTarget() {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    }
    get dropTarget() {
        return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
    clearDropTarget() {
        this.dropTargetRef = null;
        this.dropTargetNode = null;
    }
    constructor(backend){
        this.hooks = (0, $8BAAh.wrapConnectorHooks)({
            dropTarget: (node, options)=>{
                this.clearDropTarget();
                this.dropTargetOptions = options;
                if ((0, $4M7Hr.isRef)(node)) this.dropTargetRef = node;
                else this.dropTargetNode = node;
                this.reconnect();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
}

});
parcelRegister("eoD60", function(module, exports) {

$parcel$export(module.exports, "shallowEqual", () => $a7b1a238561baa77$export$d36bdfa510afb180);
function $a7b1a238561baa77$export$d36bdfa510afb180(objA, objB, compare, compareContext) {
    let compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        const valueA = objA[key];
        const valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}

});

parcelRegister("4M7Hr", function(module, exports) {

$parcel$export(module.exports, "isRef", () => $37a19e233357eeed$export$4f9f5282de18fc69);
function $37a19e233357eeed$export$4f9f5282de18fc69(obj) {
    return obj !== null && typeof obj === 'object' && Object.prototype.hasOwnProperty.call(obj, 'current');
}

});

parcelRegister("8BAAh", function(module, exports) {

$parcel$export(module.exports, "wrapConnectorHooks", () => $643e284a0b1a7b6c$export$d8dcaf80ab4f6cb7);

var $JSEe2 = parcelRequire("JSEe2");

var $acw62 = parcelRequire("acw62");
function $643e284a0b1a7b6c$var$throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === 'string') return;
    const displayName = element.type.displayName || element.type.name || 'the component';
    throw new Error('Only native element nodes can now be passed to React DnD connectors.' + `You can either wrap ${displayName} into a <div>, or turn it into a ` + 'drag source or a drop target itself.');
}
function $643e284a0b1a7b6c$var$wrapHookToRecognizeElement(hook) {
    return (elementOrNode = null, options = null)=>{
        // When passed a node, call the hook straight away.
        if (!(0, $acw62.isValidElement)(elementOrNode)) {
            const node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        const element = elementOrNode;
        $643e284a0b1a7b6c$var$throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        const ref = options ? (node)=>hook(node, options) : hook;
        return $643e284a0b1a7b6c$var$cloneWithRef(element, ref);
    };
}
function $643e284a0b1a7b6c$export$d8dcaf80ab4f6cb7(hooks) {
    const wrappedHooks = {};
    Object.keys(hooks).forEach((key)=>{
        const hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith('Ref')) wrappedHooks[key] = hooks[key];
        else {
            const wrappedHook = $643e284a0b1a7b6c$var$wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = ()=>wrappedHook;
        }
    });
    return wrappedHooks;
}
function $643e284a0b1a7b6c$var$setRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else ref.current = node;
}
function $643e284a0b1a7b6c$var$cloneWithRef(element, newRef) {
    const previousRef = element.ref;
    (0, $JSEe2.invariant)(typeof previousRef !== 'string', "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, $acw62.cloneElement)(element, {
        ref: newRef
    });
    else return (0, $acw62.cloneElement)(element, {
        ref: (node)=>{
            $643e284a0b1a7b6c$var$setRef(previousRef, node);
            $643e284a0b1a7b6c$var$setRef(newRef, node);
        }
    });
}

});


parcelRegister("apqQ9", function(module, exports) {

$parcel$export(module.exports, "useDragDropManager", () => $79410f0f8c2c4831$export$49db7e1a057ab0fa);

var $JSEe2 = parcelRequire("JSEe2");

var $acw62 = parcelRequire("acw62");

var $jpYzs = parcelRequire("jpYzs");
function $79410f0f8c2c4831$export$49db7e1a057ab0fa() {
    const { dragDropManager: dragDropManager } = (0, $acw62.useContext)((0, $jpYzs.DndContext));
    (0, $JSEe2.invariant)(dragDropManager != null, 'Expected drag drop context');
    return dragDropManager;
}

});


parcelRegister("4XhMK", function(module, exports) {

$parcel$export(module.exports, "useDropTargetMonitor", () => $39ba77e4a718bd1b$export$f0c0ad05844dec3b);

var $acw62 = parcelRequire("acw62");

var $60w9T = parcelRequire("60w9T");

var $apqQ9 = parcelRequire("apqQ9");
function $39ba77e4a718bd1b$export$f0c0ad05844dec3b() {
    const manager = (0, $apqQ9.useDragDropManager)();
    return (0, $acw62.useMemo)(()=>new (0, $60w9T.DropTargetMonitorImpl)(manager), [
        manager
    ]);
}

});
parcelRegister("60w9T", function(module, exports) {

$parcel$export(module.exports, "DropTargetMonitorImpl", () => $45fbb0319953f34c$export$9fe8834769ae8ddf);

var $JSEe2 = parcelRequire("JSEe2");
let $45fbb0319953f34c$var$isCallingCanDrop = false;
class $45fbb0319953f34c$export$9fe8834769ae8ddf {
    receiveHandlerId(targetId) {
        this.targetId = targetId;
    }
    getHandlerId() {
        return this.targetId;
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    canDrop() {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) return false;
        (0, $JSEe2.invariant)(!$45fbb0319953f34c$var$isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
        try {
            $45fbb0319953f34c$var$isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        } finally{
            $45fbb0319953f34c$var$isCallingCanDrop = false;
        }
    }
    isOver(options) {
        if (!this.targetId) return false;
        return this.internalMonitor.isOverTarget(this.targetId, options);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
}

});


parcelRegister("3Bu7R", function(module, exports) {

$parcel$export(module.exports, "useRegisteredDropTarget", () => $29fc3222e1a69af2$export$b31a008bfacf9de1);

var $fCQkc = parcelRequire("fCQkc");

var $apqQ9 = parcelRequire("apqQ9");

var $hfTxv = parcelRequire("hfTxv");

var $dMTdk = parcelRequire("dMTdk");

var $g68Oo = parcelRequire("g68Oo");
function $29fc3222e1a69af2$export$b31a008bfacf9de1(spec, monitor, connector) {
    const manager = (0, $apqQ9.useDragDropManager)();
    const dropTarget = (0, $g68Oo.useDropTarget)(spec, monitor);
    const accept = (0, $dMTdk.useAccept)(spec);
    (0, $hfTxv.useIsomorphicLayoutEffect)(function registerDropTarget() {
        const [handlerId, unregister] = (0, $fCQkc.registerTarget)(accept, dropTarget, manager);
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map((a)=>a.toString()).join('|')
    ]);
}

});
parcelRegister("fCQkc", function(module, exports) {

$parcel$export(module.exports, "registerTarget", () => $b602fe3f55e25ca9$export$38b18180ae58b09b);
$parcel$export(module.exports, "registerSource", () => $b602fe3f55e25ca9$export$51c814b9e17958c);
function $b602fe3f55e25ca9$export$38b18180ae58b09b(type, target, manager) {
    const registry = manager.getRegistry();
    const targetId = registry.addTarget(type, target);
    return [
        targetId,
        ()=>registry.removeTarget(targetId)
    ];
}
function $b602fe3f55e25ca9$export$51c814b9e17958c(type, source, manager) {
    const registry = manager.getRegistry();
    const sourceId = registry.addSource(type, source);
    return [
        sourceId,
        ()=>registry.removeSource(sourceId)
    ];
}

});

parcelRegister("dMTdk", function(module, exports) {

$parcel$export(module.exports, "useAccept", () => $a09a966d475430b0$export$2a5cc7f0ac8651d0);

var $JSEe2 = parcelRequire("JSEe2");

var $acw62 = parcelRequire("acw62");
function $a09a966d475430b0$export$2a5cc7f0ac8651d0(spec) {
    const { accept: accept } = spec;
    return (0, $acw62.useMemo)(()=>{
        (0, $JSEe2.invariant)(spec.accept != null, 'accept must be defined');
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}

});

parcelRegister("g68Oo", function(module, exports) {

$parcel$export(module.exports, "useDropTarget", () => $bb840ab3b4f27da7$export$5967d4bb72ce3c0);

var $acw62 = parcelRequire("acw62");

var $gqKHn = parcelRequire("gqKHn");
function $bb840ab3b4f27da7$export$5967d4bb72ce3c0(spec, monitor) {
    const dropTarget = (0, $acw62.useMemo)(()=>new (0, $gqKHn.DropTargetImpl)(spec, monitor), [
        monitor
    ]);
    (0, $acw62.useEffect)(()=>{
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}

});
parcelRegister("gqKHn", function(module, exports) {

$parcel$export(module.exports, "DropTargetImpl", () => $bf634c66825a2a14$export$f26a17703f5cb233);
class $bf634c66825a2a14$export$f26a17703f5cb233 {
    canDrop() {
        const spec = this.spec;
        const monitor = this.monitor;
        return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
    hover() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.hover) spec.hover(monitor.getItem(), monitor);
    }
    drop() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.drop) return spec.drop(monitor.getItem(), monitor);
        return;
    }
    constructor(spec, monitor){
        this.spec = spec;
        this.monitor = monitor;
    }
}

});




parcelRegister("428tW", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function stringifiable(obj) {
    // Safely stringify Object.create(null)
    /* istanbul ignore next */ return typeof obj === 'object' && !('toString' in obj) ? Object.prototype.toString.call(obj).slice(8, -1) : obj;
}
var isProduction = false;
function invariant(condition, message) {
    if (!condition) {
        /* istanbul ignore next */ if (isProduction) throw new Error('Invariant failed');
        throw new Error(message());
    }
}
exports.invariant = invariant;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ function(target, source) {
    getAllKeys(source).forEach(function(key) {
        if (hasOwnProperty.call(source, key)) target[key] = source[key];
    });
    return target;
};
var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ? function(obj) {
    return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj));
} : function(obj) {
    return Object.keys(obj);
};
function copy(object) {
    return Array.isArray(object) ? assign(object.constructor(object.length), object) : type(object) === 'Map' ? new Map(object) : type(object) === 'Set' ? new Set(object) : object && typeof object === 'object' ? assign(Object.create(Object.getPrototypeOf(object)), object) : object;
}
var Context = /** @class */ function() {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function(x, y) {
            return x === y;
        };
        this.update.newContext = function() {
            return new Context().update;
        };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function() {
            return this.update.isEquals;
        },
        set: function(value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function(directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function(object, $spec) {
        var _this = this;
        var spec = typeof $spec === 'function' ? {
            $apply: $spec
        } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) invariant(!Array.isArray(spec), function() {
            return "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.";
        });
        invariant(typeof spec === 'object' && spec !== null, function() {
            return "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the " + ("following commands: " + Object.keys(_this.commands).join(', ') + ".");
        });
        var nextObject = object;
        getAllKeys(spec).forEach(function(key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) nextObject = object;
            } else {
                var nextValueForKey = type(object) === 'Map' ? _this.update(object.get(key), spec[key]) : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === 'Map' ? nextObject.get(key) : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) nextObject = copy(object);
                    if (type(nextObject) === 'Map') nextObject.set(key, nextValueForKey);
                    else nextObject[key] = nextValueForKey;
                }
            }
        });
        return nextObject;
    };
    return Context;
}();
exports.Context = Context;
var defaultCommands = {
    $push: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$push');
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$unshift');
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function(value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function(args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function(value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function(targets, nextObject) {
        invariantSpecArray(targets, '$toggle');
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function(target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function(value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, '$unset');
        value.forEach(function(key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function(values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$add');
        invariantSpecArray(values, '$add');
        if (type(nextObject) === 'Map') values.forEach(function(_a) {
            var key = _a[0], value = _a[1];
            if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
            nextObject.set(key, value);
        });
        else values.forEach(function(value) {
            if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
            nextObject.add(value);
        });
        return nextObject;
    },
    $remove: function(value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$remove');
        invariantSpecArray(value, '$remove');
        value.forEach(function(key) {
            if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function(value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function(key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function(value, original) {
        invariantApply(value);
        return value(original);
    }
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports.default = defaultContext.update;
// @ts-ignore
exports.default.default = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), function() {
        return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + ".";
    });
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), function() {
        return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " + "Did you forget to wrap your parameter in an array?";
    });
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), function() {
        return "Expected $splice target to be an array; got " + stringifiable(value);
    });
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), function() {
        return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " + "Did you forget to wrap your parameters in an array?";
    });
}
function invariantApply(fn) {
    invariant(typeof fn === 'function', function() {
        return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + ".";
    });
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, function() {
        return "Cannot have more than one key in an object with $set";
    });
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === 'object', function() {
        return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue);
    });
    invariant(target && typeof target === 'object', function() {
        return "update(): $merge expects a target of type 'object'; got " + stringifiable(target);
    });
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', function() {
        return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget);
    });
}

});

parcelRegister("dL0oN", function(module, exports) {

$parcel$export(module.exports, "default", () => $57cbf23682466231$export$2e2bcd8739ae039);
/* eslint-disable no-shadow */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $hcEa1 = parcelRequire("hcEa1");
var $55APJ = parcelRequire("55APJ");

var $aBuZM = parcelRequire("aBuZM");


var $l5VTf = parcelRequire("l5VTf");
const $57cbf23682466231$var$DnDCard = function DnDCard({ id: id, text: text, moveCard: moveCard, findCard: findCard }) {
    const originalIndex = findCard(id).index;
    const [{ isDragging: isDragging }, drag] = (0, $hcEa1.useDrag)(()=>({
            type: (0, $aBuZM.default).CARD,
            item: {
                id: id,
                originalIndex: originalIndex
            },
            collect: (monitor)=>({
                    isDragging: monitor.isDragging()
                }),
            end: (item, monitor)=>{
                const { id: droppedId, originalIndex: originalIndex } = item;
                const didDrop = monitor.didDrop();
                if (!didDrop) moveCard(droppedId, originalIndex);
            }
        }), [
        id,
        originalIndex,
        moveCard
    ]);
    const [, drop] = (0, $55APJ.useDrop)(()=>({
            accept: (0, $aBuZM.default).CARD,
            canDrop: ()=>false,
            hover ({ id: draggedId }) {
                if (draggedId !== id) {
                    const { index: overIndex } = findCard(id);
                    moveCard(draggedId, overIndex);
                }
            }
        }), [
        findCard,
        moveCard
    ]);
    const opacity = isDragging ? 0.5 : 1;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: (node)=>drag(drop(node)),
        style: {
            opacity: opacity
        },
        className: "results-card",
        "data-testid": `card-${id}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "grid-icon--container",
                "data-testid": "grid-icon--container",
                onTouchStart: (e)=>e.preventDefault(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: $l5VTf['dnd-icon'],
                    alt: "",
                    role: "presentation",
                    className: "grid-icon",
                    onContextMenu: (e)=>e.preventDefault()
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "results-card-image",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: $l5VTf[`${id}`],
                    alt: "",
                    role: "presentation"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "results-card-text",
                children: text
            })
        ]
    });
};
$57cbf23682466231$var$DnDCard.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    moveCard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    findCard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $57cbf23682466231$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($57cbf23682466231$var$DnDCard);

});
parcelRegister("hcEa1", function(module, exports) {

$parcel$export(module.exports, "useDrag", () => $c862b5bb9bfb54a7$export$7941f8aafa4b6021);

var $JSEe2 = parcelRequire("JSEe2");

var $bStjo = parcelRequire("bStjo");

var $1rYxn = parcelRequire("1rYxn");

var $f8wvp = parcelRequire("f8wvp");

var $hCgVP = parcelRequire("hCgVP");

var $3ngBJ = parcelRequire("3ngBJ");

var $hDgDi = parcelRequire("hDgDi");
function $c862b5bb9bfb54a7$export$7941f8aafa4b6021(specArg, deps) {
    const spec = (0, $1rYxn.useOptionalFactory)(specArg, deps);
    (0, $JSEe2.invariant)(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
    const monitor = (0, $3ngBJ.useDragSourceMonitor)();
    const connector = (0, $hCgVP.useDragSourceConnector)(spec.options, spec.previewOptions);
    (0, $hDgDi.useRegisteredDragSource)(spec, monitor, connector);
    return [
        (0, $bStjo.useCollectedProps)(spec.collect, monitor, connector),
        (0, $f8wvp.useConnectDragSource)(connector),
        (0, $f8wvp.useConnectDragPreview)(connector)
    ];
}

});
parcelRegister("f8wvp", function(module, exports) {

$parcel$export(module.exports, "useConnectDragSource", () => $b050d14900251945$export$90c397533e0cc6);
$parcel$export(module.exports, "useConnectDragPreview", () => $b050d14900251945$export$a66b3011bc8970d6);

var $acw62 = parcelRequire("acw62");
function $b050d14900251945$export$90c397533e0cc6(connector) {
    return (0, $acw62.useMemo)(()=>connector.hooks.dragSource(), [
        connector
    ]);
}
function $b050d14900251945$export$a66b3011bc8970d6(connector) {
    return (0, $acw62.useMemo)(()=>connector.hooks.dragPreview(), [
        connector
    ]);
}

});

parcelRegister("hCgVP", function(module, exports) {

$parcel$export(module.exports, "useDragSourceConnector", () => $cd331e8abd32ba93$export$a5dfa024c6f78e86);

var $acw62 = parcelRequire("acw62");

var $gEZsO = parcelRequire("gEZsO");

var $apqQ9 = parcelRequire("apqQ9");

var $hfTxv = parcelRequire("hfTxv");
function $cd331e8abd32ba93$export$a5dfa024c6f78e86(dragSourceOptions, dragPreviewOptions) {
    const manager = (0, $apqQ9.useDragDropManager)();
    const connector = (0, $acw62.useMemo)(()=>new (0, $gEZsO.SourceConnector)(manager.getBackend()), [
        manager
    ]);
    (0, $hfTxv.useIsomorphicLayoutEffect)(()=>{
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragSource();
    }, [
        connector,
        dragSourceOptions
    ]);
    (0, $hfTxv.useIsomorphicLayoutEffect)(()=>{
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragPreview();
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}

});
parcelRegister("gEZsO", function(module, exports) {

$parcel$export(module.exports, "SourceConnector", () => $c2100f2afc3c6fda$export$9a7176fb37ab5028);

var $eoD60 = parcelRequire("eoD60");

var $4M7Hr = parcelRequire("4M7Hr");

var $8BAAh = parcelRequire("8BAAh");
class $c2100f2afc3c6fda$export$9a7176fb37ab5028 {
    receiveHandlerId(newHandlerId) {
        if (this.handlerId === newHandlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get connectTarget() {
        return this.dragSource;
    }
    get dragSourceOptions() {
        return this.dragSourceOptionsInternal;
    }
    set dragSourceOptions(options) {
        this.dragSourceOptionsInternal = options;
    }
    get dragPreviewOptions() {
        return this.dragPreviewOptionsInternal;
    }
    set dragPreviewOptions(options) {
        this.dragPreviewOptionsInternal = options;
    }
    reconnect() {
        const didChange = this.reconnectDragSource();
        this.reconnectDragPreview(didChange);
    }
    reconnectDragSource() {
        const dragSource = this.dragSource;
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
        if (didChange) this.disconnectDragSource();
        if (!this.handlerId) return didChange;
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return didChange;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
        return didChange;
    }
    reconnectDragPreview(forceDidChange = false) {
        const dragPreview = this.dragPreview;
        // if nothing has changed then don't resubscribe
        const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
        if (didChange) this.disconnectDragPreview();
        if (!this.handlerId) return;
        if (!dragPreview) {
            this.lastConnectedDragPreview = dragPreview;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didConnectedDragSourceChange() {
        return this.lastConnectedDragSource !== this.dragSource;
    }
    didConnectedDragPreviewChange() {
        return this.lastConnectedDragPreview !== this.dragPreview;
    }
    didDragSourceOptionsChange() {
        return !(0, $eoD60.shallowEqual)(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
    didDragPreviewOptionsChange() {
        return !(0, $eoD60.shallowEqual)(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
    disconnectDragSource() {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
        }
    }
    disconnectDragPreview() {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    }
    get dragSource() {
        return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
    get dragPreview() {
        return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
    clearDragSource() {
        this.dragSourceNode = null;
        this.dragSourceRef = null;
    }
    clearDragPreview() {
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
    }
    constructor(backend){
        this.hooks = (0, $8BAAh.wrapConnectorHooks)({
            dragSource: (node, options)=>{
                this.clearDragSource();
                this.dragSourceOptions = options || null;
                if ((0, $4M7Hr.isRef)(node)) this.dragSourceRef = node;
                else this.dragSourceNode = node;
                this.reconnectDragSource();
            },
            dragPreview: (node, options)=>{
                this.clearDragPreview();
                this.dragPreviewOptions = options || null;
                if ((0, $4M7Hr.isRef)(node)) this.dragPreviewRef = node;
                else this.dragPreviewNode = node;
                this.reconnectDragPreview();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
}

});


parcelRegister("3ngBJ", function(module, exports) {

$parcel$export(module.exports, "useDragSourceMonitor", () => $275066fc5aab1532$export$82f95eab323fcd7a);

var $acw62 = parcelRequire("acw62");

var $itS1c = parcelRequire("itS1c");

var $apqQ9 = parcelRequire("apqQ9");
function $275066fc5aab1532$export$82f95eab323fcd7a() {
    const manager = (0, $apqQ9.useDragDropManager)();
    return (0, $acw62.useMemo)(()=>new (0, $itS1c.DragSourceMonitorImpl)(manager), [
        manager
    ]);
}

});
parcelRegister("itS1c", function(module, exports) {

$parcel$export(module.exports, "DragSourceMonitorImpl", () => $d744d657142203f3$export$af934094fb48ddf);

var $JSEe2 = parcelRequire("JSEe2");
let $d744d657142203f3$var$isCallingCanDrag = false;
let $d744d657142203f3$var$isCallingIsDragging = false;
class $d744d657142203f3$export$af934094fb48ddf {
    receiveHandlerId(sourceId) {
        this.sourceId = sourceId;
    }
    getHandlerId() {
        return this.sourceId;
    }
    canDrag() {
        (0, $JSEe2.invariant)(!$d744d657142203f3$var$isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $d744d657142203f3$var$isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        } finally{
            $d744d657142203f3$var$isCallingCanDrag = false;
        }
    }
    isDragging() {
        if (!this.sourceId) return false;
        (0, $JSEe2.invariant)(!$d744d657142203f3$var$isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $d744d657142203f3$var$isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        } finally{
            $d744d657142203f3$var$isCallingIsDragging = false;
        }
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    isDraggingSource(sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    }
    isOverTarget(targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    }
    getTargetIds() {
        return this.internalMonitor.getTargetIds();
    }
    isSourcePublic() {
        return this.internalMonitor.isSourcePublic();
    }
    getSourceId() {
        return this.internalMonitor.getSourceId();
    }
    subscribeToOffsetChange(listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    }
    canDragSource(sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    }
    canDropOnTarget(targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
}

});


parcelRegister("hDgDi", function(module, exports) {

$parcel$export(module.exports, "useRegisteredDragSource", () => $cd62fb1ce2b445ba$export$1bdd19ff5ac2e03c);

var $fCQkc = parcelRequire("fCQkc");

var $apqQ9 = parcelRequire("apqQ9");

var $hfTxv = parcelRequire("hfTxv");

var $gKRdl = parcelRequire("gKRdl");

var $4ObNX = parcelRequire("4ObNX");
function $cd62fb1ce2b445ba$export$1bdd19ff5ac2e03c(spec, monitor, connector) {
    const manager = (0, $apqQ9.useDragDropManager)();
    const handler = (0, $gKRdl.useDragSource)(spec, monitor, connector);
    const itemType = (0, $4ObNX.useDragType)(spec);
    (0, $hfTxv.useIsomorphicLayoutEffect)(function registerDragSource() {
        if (itemType != null) {
            const [handlerId, unregister] = (0, $fCQkc.registerSource)(itemType, handler, manager);
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
        return;
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}

});
parcelRegister("gKRdl", function(module, exports) {

$parcel$export(module.exports, "useDragSource", () => $c32a387774bedc42$export$cdddb20adb7aad5c);

var $acw62 = parcelRequire("acw62");

var $ibJIf = parcelRequire("ibJIf");
function $c32a387774bedc42$export$cdddb20adb7aad5c(spec, monitor, connector) {
    const handler = (0, $acw62.useMemo)(()=>new (0, $ibJIf.DragSourceImpl)(spec, monitor, connector), [
        monitor,
        connector
    ]);
    (0, $acw62.useEffect)(()=>{
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}

});
parcelRegister("ibJIf", function(module, exports) {

$parcel$export(module.exports, "DragSourceImpl", () => $d3dcb6a4048c2475$export$680f0a3c92f9d645);
class $d3dcb6a4048c2475$export$680f0a3c92f9d645 {
    beginDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        let result = null;
        if (typeof spec.item === 'object') result = spec.item;
        else if (typeof spec.item === 'function') result = spec.item(monitor);
        else result = {};
        return result !== null && result !== void 0 ? result : null;
    }
    canDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (typeof spec.canDrag === 'boolean') return spec.canDrag;
        else if (typeof spec.canDrag === 'function') return spec.canDrag(monitor);
        else return true;
    }
    isDragging(globalMonitor, target) {
        const spec = this.spec;
        const monitor = this.monitor;
        const { isDragging: isDragging } = spec;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
    endDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        const connector = this.connector;
        const { end: end } = spec;
        if (end) end(monitor.getItem(), monitor);
        connector.reconnect();
    }
    constructor(spec, monitor, connector){
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
}

});


parcelRegister("4ObNX", function(module, exports) {

$parcel$export(module.exports, "useDragType", () => $3804fd2097a3f21f$export$dec3a5d742510a3f);

var $JSEe2 = parcelRequire("JSEe2");

var $acw62 = parcelRequire("acw62");
function $3804fd2097a3f21f$export$dec3a5d742510a3f(spec) {
    return (0, $acw62.useMemo)(()=>{
        const result = spec.type;
        (0, $JSEe2.invariant)(result != null, 'spec.type must be defined');
        return result;
    }, [
        spec
    ]);
}

});



parcelRegister("aBuZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b83724b665fe8cc$export$2e2bcd8739ae039);
const $0b83724b665fe8cc$var$ItemTypes = {
    CARD: 'card'
};
var $0b83724b665fe8cc$export$2e2bcd8739ae039 = $0b83724b665fe8cc$var$ItemTypes;

});

parcelRegister("l5VTf", function(module, exports) {

var $j0E3x = parcelRequire("j0E3x");

var $dAgX1 = parcelRequire("dAgX1");

var $gvzSq = parcelRequire("gvzSq");

var $96XcN = parcelRequire("96XcN");

var $b31so = parcelRequire("b31so");

var $6mupl = parcelRequire("6mupl");

var $65cSr = parcelRequire("65cSr");

var $907wP = parcelRequire("907wP");

var $3PJH8 = parcelRequire("3PJH8");

var $68htO = parcelRequire("68htO");

var $gZoD5 = parcelRequire("gZoD5");

var $iWIB7 = parcelRequire("iWIB7");

var $7CXEs = parcelRequire("7CXEs");

var $7u4TD = parcelRequire("7u4TD");

var $NQSic = parcelRequire("NQSic");

var $1iHQW = parcelRequire("1iHQW");

var $gTWkC = parcelRequire("gTWkC");
module.exports = {
    "0": $j0E3x,
    "1": $dAgX1,
    "2": $gvzSq,
    "3": $96XcN,
    "4": $b31so,
    "5": $6mupl,
    "6": $65cSr,
    "7": $907wP,
    "8": $3PJH8,
    "9": $68htO,
    "10": $gZoD5,
    "11": $iWIB7,
    "12": $7CXEs,
    "13": $7u4TD,
    "14": $NQSic,
    "15": $1iHQW,
    "dnd-icon": $gTWkC
};

});



parcelRegister("jNFbw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b536dea87047f8f2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7lk71 = parcelRequire("7lk71");

var $9Ryut = parcelRequire("9Ryut");

var $iJxY6 = parcelRequire("iJxY6");
const $b536dea87047f8f2$var$ShareLinkIcon = ()=>{
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    function openEmailForUser() {
        window.open((0, $iJxY6.default)(locId, 'defaultEmailText', 'resultsPage'));
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "shareLink_icon",
        role: "button",
        "data-testid": "shareLink_icon",
        title: (0, $iJxY6.default)(locId, 'emailButtonTitle', 'resultsPage'),
        onClick: ()=>{
            openEmailForUser();
        },
        onKeyDown: (event)=>{
            if (event.keyCode === 13 || event.keyCode === 32) openEmailForUser();
        },
        tabIndex: 0,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Icon), {
            name: "message-envelope"
        })
    });
};
var $b536dea87047f8f2$export$2e2bcd8739ae039 = $b536dea87047f8f2$var$ShareLinkIcon;

});

parcelRegister("7d1HW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9abfbe418fb19fbc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

const $9abfbe418fb19fbc$var$SocialMediaButton = ({ icon: icon, socialMediaLink: socialMediaLink, title: title })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        type: "button",
        href: socialMediaLink,
        "data-testid": `${title}-button`,
        target: "_blank",
        title: title,
        rel: "noreferrer",
        className: "social-media-wrapper",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            src: icon,
            alt: "social_media_share_button",
            role: "presentation"
        })
    });
};
$9abfbe418fb19fbc$var$SocialMediaButton.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    socialMediaLink: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};
var $9abfbe418fb19fbc$export$2e2bcd8739ae039 = $9abfbe418fb19fbc$var$SocialMediaButton;

});


parcelRegister("1sS9G", function(module, exports) {

$parcel$export(module.exports, "default", () => $9949dc0b0af8f152$export$2e2bcd8739ae039);
/* eslint-disable no-use-before-define */ /* eslint-disable no-plusplus */ /* eslint-disable no-nested-ternary */ /* eslint-disable no-shadow */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $c9Z8w = parcelRequire("c9Z8w");

var $7lk71 = parcelRequire("7lk71");

var $89C3d = parcelRequire("89C3d");

var $6mQzc = parcelRequire("6mQzc");

var $145EN = parcelRequire("145EN");

var $kMrYv = parcelRequire("kMrYv");

var $8Lp6z = parcelRequire("8Lp6z");

var $fKxvO = parcelRequire("fKxvO");

var $iJxY6 = parcelRequire("iJxY6");

var $9oQIP = parcelRequire("9oQIP");

var $9Ryut = parcelRequire("9Ryut");

var $6UZN0 = parcelRequire("6UZN0");


var $fUEMe = parcelRequire("fUEMe");

var $8cWO4 = parcelRequire("8cWO4");

var $aO5Es = parcelRequire("aO5Es");

var $duf9k = parcelRequire("duf9k");

var $kiK3k = parcelRequire("kiK3k");

var $aU90w = parcelRequire("aU90w");

var $kgzQz = parcelRequire("kgzQz");

var $jcHw7 = parcelRequire("jcHw7");

var $jNFbw = parcelRequire("jNFbw");

var $7d1HW = parcelRequire("7d1HW");

var $58ODK = parcelRequire("58ODK");

var $RXYi2 = parcelRequire("RXYi2");

var $etP3u = parcelRequire("etP3u");

var $4mrbC = parcelRequire("4mrbC");

var $2DcdH = parcelRequire("2DcdH");
const $9949dc0b0af8f152$var$FPResultsPage = (props)=>{
    const { contactID: contactID, contactName: contactName, financialAdvisorID: financialAdvisorID, entityID: entityID, timestamp: timestamp, sessionId: sessionId, valueList: valueList, finalResultsIndex: finalResultsIndex, restartCallback: restartCallback, callerApp: callerApp, displaySendToFAButton: displaySendToFAButton, faInfo: faInfo, financialPlanningContent: financialPlanningContent, userPersona: userPersona } = props;
    const initialResultsStatementIds = finalResultsIndex.map((index)=>{
        const results = valueList.find((value)=>index === value.indexId);
        return results?.statementId;
    });
    const { dataLayerInfo: dataLayerInfo } = (0, $RXYi2.useDataLayerInfo)();
    const [notificationOpen, setNotificationOpen] = (0, $acw62.useState)(false);
    const [notificationContent, setNotificationContent] = (0, $acw62.useState)({
        type: 'informational',
        message: ''
    });
    const [displaySendResults, setDisplaySendResults] = (0, $acw62.useState)(false);
    const [coldContactData, setColdContactData] = (0, $acw62.useState)(null);
    const [userComments, setUserComments] = (0, $acw62.useState)('');
    const [cardClassName, setCardClassName] = (0, $acw62.useState)('value-card-fp');
    const [finalResultsStatementIds, setFinalResultsStatementIds] = (0, $acw62.useState)(initialResultsStatementIds);
    const [sendResultsButtonDisabled, setSendResultsButtonDisabled] = (0, $acw62.useState)(false);
    const topOfResults = (0, $acw62.useRef)(null);
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const resultsJSON = createResultsJSON();
    const displayFAName = !!faInfo.faFirstName && !!faInfo.faLastName;
    const faFullName = `${faInfo.faFirstName} ${faInfo.faLastName}`;
    const sendResultsToFaText = (0, $iJxY6.default)(locId, 'sendResultsToFA', 'fpResultsPage');
    const faNameDefaultText = (0, $iJxY6.default)(locId, 'faDefaultText', 'fpResultsPage');
    const whatsNextSendToFaHeadingText = (0, $iJxY6.default)(locId, 'whatNextSendToFaHeading', 'fpResultsPage');
    const whatsNextSendToFaText = (0, $iJxY6.default)(locId, 'whatNextSendToFA', 'fpResultsPage');
    const yourFaNameDefaultText = (0, $iJxY6.default)(locId, 'yourFaDefaultText', 'fpResultsPage');
    const urlQuery = (0, $58ODK.default)();
    const isTouchDevice = ()=>{
        return 'ontouchstart' in window;
    };
    const isFinancialFoundationsUser = ()=>{
        return (urlQuery.get('faNo') || faInfo.faNo) && urlQuery.get('conId') && urlQuery.get('utm_source') && urlQuery.get('utm_source')?.toUpperCase() === 'FF';
    };
    const isSendToFAButtonDisplayed = ()=>{
        return displaySendToFAButton && !isFinancialFoundationsUser() && (!contactID || contactID && (0, $6UZN0.default)(timestamp));
    };
    const isFindAnFAButtonDisplayed = ()=>{
        return callerApp === 'StartingPoint' && (!financialAdvisorID || financialAdvisorID === '0') && (!entityID || entityID === '0');
    };
    const getValueStatementHeadersString = ()=>{
        const valueStatementHeaderArray = finalResultsStatementIds.map((statementId)=>{
            const statement = valueList.find((value)=>statementId === value.statementId);
            return statementId === 15 ? 'Custom Text' : statement?.statementText;
        });
        return valueStatementHeaderArray.join('|');
    };
    (0, $acw62.useEffect)(()=>{
        (0, $fUEMe.default)('value-statements-displayed', {
            'value-statements-as-string': getValueStatementHeadersString()
        });
    }, [
        finalResultsStatementIds
    ]);
    const updatedFaInfo = {
        ...dataLayerInfo,
        page_type: 'results-page'
    };
    const { setPreviousPath: setPreviousPath, previousPath: previousPath } = (0, $2DcdH.usePreviousPath)();
    const currentLocation = (0, $aphAM.useLocation)();
    const navigate = (0, $aphAM.useNavigate)();
    const pageTitle = (0, $iJxY6.default)(locId, 'pageTitle', 'fpResultsPage');
    const pageReferrer = previousPath ? `${window.location.origin}${previousPath}${currentLocation.search}` : undefined;
    const pageURL = `${window.location.origin}${currentLocation.pathname}${currentLocation.search}`;
    const virtualPageInfo = {
        pagePath: currentLocation.pathname,
        pageTitle: pageTitle,
        page_referrer: pageReferrer,
        external_referrer: window.document.referrer && window.document.referrer.trim() !== '' ? window.document.referrer : undefined,
        page_url: pageURL
    };
    (0, $acw62.useEffect)(()=>{
        setPreviousPath(currentLocation.pathname);
        (0, $fUEMe.default)('dataLayer-initialized', updatedFaInfo);
        (0, $fUEMe.default)('VirtualPageview', virtualPageInfo);
        if (topOfResults.current !== undefined) {
            if (topOfResults.current) topOfResults.current.focus();
        }
        document.title = pageTitle;
        (0, $fUEMe.default)('view-results', {});
        if (isSendToFAButtonDisplayed()) setDisplaySendResults(true);
        setTimeout(removeFocus, 1000);
    }, []);
    function removeFocus() {
        const heading = document.getElementById('heading-no-focus');
        heading?.removeAttribute('tabIndex');
    }
    function createResultsJSON() {
        const resultsObj = {};
        finalResultsStatementIds.forEach((result, index)=>{
            const statementId = result;
            const statementText = (0, $fKxvO.default)(result, valueList);
            const learnMoreContent = (0, $aU90w.default)(result, valueList);
            const learnMoreLinks = (0, $kgzQz.default)(result, valueList);
            const keyName = (index + 1).toString();
            resultsObj[keyName] = {
                statementId: statementId,
                statementText: statementText,
                learnMoreContent: learnMoreContent,
                learnMoreLinks: learnMoreLinks
            };
        });
        return resultsObj;
    }
    const handleDefaultDisplayNameText = ()=>{
        return sendResultsToFaText.replace('%FA_NAME%', faNameDefaultText);
    };
    const handleDisplayFaNameText = ()=>{
        if (displayFAName) return sendResultsToFaText.replace('%FA_NAME%', faFullName);
        return handleDefaultDisplayNameText();
    };
    const handleWhatsNextSendToFaHeadingText = ()=>{
        if (displayFAName) return whatsNextSendToFaHeadingText.replace('%FA_NAME%', faFullName);
        return whatsNextSendToFaHeadingText.replace('%FA_NAME%', yourFaNameDefaultText);
    };
    const handleWhatsNextSendToFaText = ()=>{
        if (displayFAName) return whatsNextSendToFaText.replace('%FA_NAME%', faFullName);
        return whatsNextSendToFaText.replace('%FA_NAME%', yourFaNameDefaultText);
    };
    const handleCommentsChange = (sendComments)=>{
        setUserComments(sendComments);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "ResultsPage_fp",
        className: "FPResultsPage",
        children: [
            finalResultsStatementIds.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "youDidIt",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "banner",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    id: "heading-no-focus",
                                    className: "heading--semi-bold",
                                    ref: topOfResults,
                                    tabIndex: -1,
                                    children: contactName.firstName ? (0, $iJxY6.default)(locId, 'howYouRankedHeading', 'fpResultsPage').replace('%CONTACT_FIRSTNAME%', contactName.firstName) : (0, $iJxY6.default)(locId, 'howYouRankedHeadingContactUnkown', 'fpResultsPage')
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: (0, $iJxY6.default)(locId, 'topThreePriorities', 'fpResultsPage')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                className: "visually-hidden",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: (0, $fKxvO.default)(finalResultsStatementIds[0], valueList)
                                    }, finalResultsStatementIds[0]),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: (0, $fKxvO.default)(finalResultsStatementIds[1], valueList)
                                    }, finalResultsStatementIds[1]),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: (0, $fKxvO.default)(finalResultsStatementIds[2], valueList)
                                    }, finalResultsStatementIds[2])
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "results_topThree_fp",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "results_podium",
                                "data-testid": "results_podium_fp",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9oQIP.default), {
                                    valueList: valueList,
                                    finalResults: finalResultsStatementIds,
                                    cardClassName: cardClassName,
                                    setCardClassName: setCardClassName
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "results_carousel_fp",
                                "data-testid": "results_carousel_fp",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8Lp6z.default), {
                                    valueList: valueList,
                                    finalResults: finalResultsStatementIds,
                                    cardClassName: cardClassName,
                                    setCardClassName: setCardClassName
                                })
                            })
                        ]
                    }),
                    notificationOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "inlineNotification_container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.InlineNotification), {
                            type: notificationContent.type,
                            text: notificationContent.message,
                            onClose: ()=>{
                                setNotificationOpen(false);
                            }
                        })
                    }) : null,
                    financialPlanningContent?.planningTopics ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "planning-results",
                                children: (0, $iJxY6.default)(locId, 'selectedPlanningTopis', 'fpResultsPage')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "planning-results-cards",
                                "data-testid": "selected-planning-topics-fp",
                                children: financialPlanningContent.planningTopics.map((topic)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $etP3u.default), {
                                        topicTitle: topic.topicTitle,
                                        topicTitleId: topic.topicTitleId,
                                        color: topic.color
                                    }, topic.topicTitleId))
                            })
                        ]
                    }) : null,
                    userPersona !== (0, $kMrYv.default).DIRECT_URL ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "edit_priorities_btn",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                            label: (0, $iJxY6.default)(locId, 'editBtnLabel', 'fpResultsPage'),
                            icon: "edit-pencil",
                            onClick: ()=>{
                                navigate({
                                    pathname: (0, $iJxY6.default)(locId, 'planningPath', 'app'),
                                    search: currentLocation.search
                                });
                            },
                            attributes: {
                                'aria-label': 'Edit your financial priorities',
                                value: '',
                                id: 'edit-planning-topics-button',
                                'data-testid': 'edit-planning-topics-button'
                            }
                        })
                    }) : null,
                    financialPlanningContent?.investorInvolvementCode && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "investment-selection-title",
                                children: (0, $iJxY6.default)(locId, 'investmentSelection', 'fpResultsPage')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "investment-selection-description",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: (0, $4mrbC.default)[financialPlanningContent.investorInvolvementCode]?.decisionStatement || ''
                                })
                            })
                        ]
                    }),
                    userComments && userComments.trim() !== '' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "shared-comments",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: (0, $iJxY6.default)(locId, 'sharedComments', 'fpResultsPage')
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: userComments.split('\n').map((line)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: line
                                    }, line))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "nowWhat",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "action_btns",
                            children: [
                                displaySendResults ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $duf9k.default), {
                                    coldContactData: coldContactData,
                                    contactName: contactName,
                                    setColdContactData: setColdContactData,
                                    setNotificationContent: setNotificationContent,
                                    setNotificationOpen: setNotificationOpen,
                                    userComments: userComments,
                                    setUserComments: handleCommentsChange,
                                    faInfo: faInfo,
                                    sessionId: sessionId,
                                    resultsJSON: resultsJSON,
                                    sendResultsButtonDisabled: sendResultsButtonDisabled,
                                    setSendResultsButtonDisabled: setSendResultsButtonDisabled,
                                    buttonText: handleDisplayFaNameText(),
                                    planningTopics: financialPlanningContent?.planningTopics.map((topic)=>topic.code),
                                    investmentInvolvementCode: financialPlanningContent?.investorInvolvementCode
                                }) : null,
                                !isFinancialFoundationsUser() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8cWO4.default), {
                                    setNotificationContent: setNotificationContent,
                                    setNotificationOpen: setNotificationOpen,
                                    displaySendToFAButton: displaySendResults,
                                    resultsJSON: resultsJSON,
                                    coldContactData: coldContactData,
                                    userComments: userComments,
                                    planningTopics: financialPlanningContent?.planningTopics.map((topic)=>topic.code),
                                    investmentInvolvementCode: financialPlanningContent?.investorInvolvementCode,
                                    label: (0, $iJxY6.default)(locId, 'downloadResults', 'fpResultsPage')
                                }) : null,
                                isFinancialFoundationsUser() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kiK3k.default), {
                                    setNotificationContent: setNotificationContent,
                                    setNotificationOpen: setNotificationOpen,
                                    sessionId: sessionId,
                                    resultsJSON: resultsJSON,
                                    faInfo: faInfo,
                                    planningTopics: financialPlanningContent?.planningTopics.map((topic)=>topic.code),
                                    investmentInvolvementCode: financialPlanningContent?.investorInvolvementCode
                                }) : null,
                                isFindAnFAButtonDisplayed() ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: (0, $iJxY6.default)(locId, 'findFALink', 'fpResultsPage'),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    tabIndex: -1,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                                        label: (0, $iJxY6.default)(locId, 'findFAButton', 'fpResultsPage'),
                                        onClick: ()=>{},
                                        attributes: {
                                            value: '',
                                            id: 'find-fa',
                                            'data-testid': 'find-fa'
                                        }
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                                    label: (0, $iJxY6.default)(locId, 'restartQuiz', 'fpResultsPage'),
                                    onClick: ()=>{
                                        (0, $fUEMe.default)('restart-quiz', {});
                                        restartCallback();
                                    },
                                    attributes: {
                                        value: '',
                                        id: 'restart-button'
                                    },
                                    styleVariant: "secondary"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dnd-header",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: (0, $iJxY6.default)(locId, 'dndHeading', 'fpResultsPage')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: (0, $iJxY6.default)(locId, 'dndMessage', 'fpResultsPage')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89C3d.DndProvider), {
                        backend: isTouchDevice() ? (0, $145EN.TouchBackend) : (0, $6mQzc.HTML5Backend),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jcHw7.default), {
                            finalResultsStatementIds: finalResultsStatementIds,
                            valueList: valueList,
                            setFinalResultsStatementIds: setFinalResultsStatementIds
                        })
                    })
                ]
            }) : null,
            !isFinancialFoundationsUser() ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "whatNext",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: (0, $iJxY6.default)(locId, 'whatNext', 'fpResultsPage')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "cta_container",
                        children: [
                            displaySendResults ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "whatNext_container",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: handleWhatsNextSendToFaHeadingText()
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: handleWhatsNextSendToFaText()
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "action_btns",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $duf9k.default), {
                                            coldContactData: coldContactData,
                                            contactName: contactName,
                                            setColdContactData: setColdContactData,
                                            setNotificationContent: setNotificationContent,
                                            setNotificationOpen: setNotificationOpen,
                                            userComments: userComments,
                                            setUserComments: setUserComments,
                                            faInfo: faInfo,
                                            sessionId: sessionId,
                                            resultsJSON: resultsJSON,
                                            sendResultsButtonDisabled: sendResultsButtonDisabled,
                                            setSendResultsButtonDisabled: setSendResultsButtonDisabled,
                                            buttonText: handleDefaultDisplayNameText(),
                                            planningTopics: financialPlanningContent?.planningTopics.map((topic)=>topic.code),
                                            investmentInvolvementCode: financialPlanningContent?.investorInvolvementCode
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "whatNext_container",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: (0, $iJxY6.default)(locId, 'whatNextGetMatchedHeading', 'fpResultsPage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: (0, $iJxY6.default)(locId, 'whatNextGetMatched', 'fpResultsPage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "action_btns",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: (0, $iJxY6.default)(locId, 'whatNextMatchLink', 'fpResultsPage'),
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            tabIndex: -1,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Button), {
                                                label: (0, $iJxY6.default)(locId, 'whatNextMatchButton', 'fpResultsPage'),
                                                onClick: ()=>{
                                                    (0, $fUEMe.default)('button_click', {
                                                        button_name: 'Start_now'
                                                    });
                                                },
                                                attributes: {
                                                    value: '',
                                                    id: 'match-fa-button',
                                                    'data-testid': 'match-fa-button'
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "shareQuiz_container",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: (0, $iJxY6.default)(locId, 'shareQuizHeading', 'fpResultsPage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: (0, $iJxY6.default)(locId, 'shareQuizMessage', 'fpResultsPage')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "action_btns_container",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "copyLink_action_btn",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aO5Es.default), {})
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "shareQuiz_action_btn",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: (0, $iJxY6.default)(locId, 'shareLink', 'fpResultsPage')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1HW.default), {
                                                        icon: "/public/images/linkedin-icon.png",
                                                        socialMediaLink: (0, $iJxY6.default)(locId, 'linkedInUrl', 'fpResultsPage'),
                                                        title: (0, $iJxY6.default)(locId, 'socialMediaTitle', 'fpResultsPage').replace('%APP_NAME%', 'LinkedIn')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1HW.default), {
                                                        icon: "/public/images/facebook-icon.png",
                                                        socialMediaLink: (0, $iJxY6.default)(locId, 'faceBookUrl', 'fpResultsPage'),
                                                        title: (0, $iJxY6.default)(locId, 'socialMediaTitle', 'fpResultsPage').replace('%APP_NAME%', 'Facebook')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNFbw.default), {})
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "footer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "disclaimer",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "microcopy--2",
                        children: (0, $iJxY6.default)(locId, 'resultsPageDisclosure', 'fpResultsPage')
                    })
                })
            })
        ]
    });
};
$9949dc0b0af8f152$var$FPResultsPage.defaultProps = {
    contactID: '',
    contactName: null,
    financialAdvisorID: '',
    entityID: '',
    timestamp: '',
    callerApp: '',
    userPersona: (0, $kMrYv.default).DIRECT_URL
};
$9949dc0b0af8f152$var$FPResultsPage.propTypes = {
    contactID: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    contactName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    financialAdvisorID: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    entityID: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    timestamp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    sessionId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    valueList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    finalResultsIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
    restartCallback: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    callerApp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    displaySendToFAButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    faInfo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        environment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        sessionId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        faNo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        fa_entity_id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }).isRequired,
    financialPlanningContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        // eslint-disable-next-line react/forbid-prop-types
        planningTopics: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
        investorInvolvementCode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    userPersona: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf(Object.values((0, $kMrYv.default)))
};
var $9949dc0b0af8f152$export$2e2bcd8739ae039 = $9949dc0b0af8f152$var$FPResultsPage;

});
parcelRegister("8Lp6z", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5aa0f2fa6ccc90a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $c9Z8w = parcelRequire("c9Z8w");

var $1ovHo = parcelRequire("1ovHo");

var $fKxvO = parcelRequire("fKxvO");


var $aU90w = parcelRequire("aU90w");

var $kgzQz = parcelRequire("kgzQz");
const $f5aa0f2fa6ccc90a$var$FPValueCardCarousel = (props)=>{
    const { valueList: valueList, finalResults: finalResults, cardClassName: cardClassName, setCardClassName: setCardClassName } = props;
    const displayLearnMoreButton = false;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "results-carousel-fp",
        "data-testid": "value-cards-fp",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ovHo.default), {
                valueStatement: (0, $fKxvO.default)(finalResults[0], valueList),
                valueStatementId: finalResults[0],
                learnMoreContent: (0, $aU90w.default)(finalResults[0], valueList),
                learnMoreLinks: (0, $kgzQz.default)(finalResults[0], valueList),
                rank: 1,
                displayLearnMoreButton: displayLearnMoreButton,
                cardClassName: cardClassName,
                setCardClassName: setCardClassName
            }, "one"),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ovHo.default), {
                valueStatement: (0, $fKxvO.default)(finalResults[1], valueList),
                valueStatementId: finalResults[1],
                learnMoreContent: (0, $aU90w.default)(finalResults[1], valueList),
                learnMoreLinks: (0, $kgzQz.default)(finalResults[1], valueList),
                rank: 2,
                displayLearnMoreButton: displayLearnMoreButton,
                cardClassName: cardClassName,
                setCardClassName: setCardClassName
            }, "two"),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ovHo.default), {
                valueStatement: (0, $fKxvO.default)(finalResults[2], valueList),
                valueStatementId: finalResults[2],
                learnMoreContent: (0, $aU90w.default)(finalResults[2], valueList),
                learnMoreLinks: (0, $kgzQz.default)(finalResults[2], valueList),
                rank: 3,
                displayLearnMoreButton: displayLearnMoreButton,
                cardClassName: cardClassName,
                setCardClassName: setCardClassName
            }, "three")
        ]
    });
};
$f5aa0f2fa6ccc90a$var$FPValueCardCarousel.defaultProps = {
    cardClassName: 'value-card-fp',
    setCardClassName: null
};
$f5aa0f2fa6ccc90a$var$FPValueCardCarousel.propTypes = {
    valueList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    finalResults: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setCardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $f5aa0f2fa6ccc90a$export$2e2bcd8739ae039 = $f5aa0f2fa6ccc90a$var$FPValueCardCarousel;

});

parcelRegister("9oQIP", function(module, exports) {

$parcel$export(module.exports, "default", () => $93683652cb2cbb02$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $1ovHo = parcelRequire("1ovHo");

var $fKxvO = parcelRequire("fKxvO");


var $aU90w = parcelRequire("aU90w");

var $kgzQz = parcelRequire("kgzQz");
const $93683652cb2cbb02$var$FPValueCardPodium = (props)=>{
    const { valueList: valueList, finalResults: finalResults, cardClassName: cardClassName, setCardClassName: setCardClassName } = props;
    const displayLearnMoreButton = false;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ovHo.default), {
                valueStatement: (0, $fKxvO.default)(finalResults[0], valueList),
                valueStatementId: finalResults[0],
                learnMoreContent: (0, $aU90w.default)(finalResults[0], valueList),
                learnMoreLinks: (0, $kgzQz.default)(finalResults[0], valueList),
                rank: 1,
                displayLearnMoreButton: displayLearnMoreButton,
                cardClassName: cardClassName,
                setCardClassName: setCardClassName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ovHo.default), {
                valueStatement: (0, $fKxvO.default)(finalResults[1], valueList),
                valueStatementId: finalResults[1],
                learnMoreContent: (0, $aU90w.default)(finalResults[1], valueList),
                learnMoreLinks: (0, $kgzQz.default)(finalResults[1], valueList),
                rank: 2,
                displayLearnMoreButton: displayLearnMoreButton,
                cardClassName: cardClassName,
                setCardClassName: setCardClassName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ovHo.default), {
                valueStatement: (0, $fKxvO.default)(finalResults[2], valueList),
                valueStatementId: finalResults[2],
                learnMoreContent: (0, $aU90w.default)(finalResults[2], valueList),
                learnMoreLinks: (0, $kgzQz.default)(finalResults[2], valueList),
                rank: 3,
                displayLearnMoreButton: displayLearnMoreButton,
                cardClassName: cardClassName,
                setCardClassName: setCardClassName
            })
        ]
    });
};
$93683652cb2cbb02$var$FPValueCardPodium.defaultProps = {
    cardClassName: 'value-card-fp',
    setCardClassName: null
};
$93683652cb2cbb02$var$FPValueCardPodium.propTypes = {
    valueList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    finalResults: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setCardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $93683652cb2cbb02$export$2e2bcd8739ae039 = $93683652cb2cbb02$var$FPValueCardPodium;

});

parcelRegister("jcHw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e53060ccf91235b6$export$2e2bcd8739ae039);
/* eslint-disable no-shadow */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $55APJ = parcelRequire("55APJ");

var $428tW = parcelRequire("428tW");

var $aPsDT = parcelRequire("aPsDT");

var $i4lVW = parcelRequire("i4lVW");

var $fKxvO = parcelRequire("fKxvO");

const $e53060ccf91235b6$var$FPDnDContainer = function FPDnDContainer({ finalResultsStatementIds: finalResultsStatementIds, valueList: valueList, setFinalResultsStatementIds: setFinalResultsStatementIds }) {
    const CardsArray = finalResultsStatementIds.map((result)=>({
            id: result,
            text: (0, $fKxvO.default)(result, valueList)
        }));
    const [resultCards, setResultCards] = (0, $acw62.useState)(CardsArray);
    const findCard = (0, $acw62.useCallback)((id)=>{
        const card = resultCards.filter((c)=>`${c.id}` === id)[0];
        return {
            card: card,
            index: resultCards.indexOf(card)
        };
    }, [
        resultCards
    ]);
    const moveCard = (0, $acw62.useCallback)((id, atIndex)=>{
        const { card: card, index: index } = findCard(id);
        setResultCards((0, (/*@__PURE__*/$parcel$interopDefault($428tW)))(resultCards, {
            $splice: [
                [
                    index,
                    1
                ],
                [
                    atIndex,
                    0,
                    card
                ]
            ]
        }));
    }, [
        findCard,
        resultCards,
        setResultCards
    ]);
    const [, drop] = (0, $55APJ.useDrop)(()=>({
            accept: (0, $i4lVW.default).CARD
        }));
    (0, $acw62.useEffect)(()=>{
        setFinalResultsStatementIds(resultCards.map((result)=>result.id));
    }, [
        resultCards
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: drop,
        className: "results-card-container",
        children: resultCards.map((card, i)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "result-row",
                "data-testid": i,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "result-rank",
                        children: i + 1
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aPsDT.default), {
                        id: `${card.id}`,
                        text: card.text,
                        moveCard: moveCard,
                        findCard: findCard
                    }, card.id)
                ]
            }, card.id);
        })
    });
};
$e53060ccf91235b6$var$FPDnDContainer.propTypes = {
    finalResultsStatementIds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
    valueList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    setFinalResultsStatementIds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $e53060ccf91235b6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($e53060ccf91235b6$var$FPDnDContainer);

});
parcelRegister("aPsDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $96fe13b066a8d20b$export$2e2bcd8739ae039);
/* eslint-disable no-shadow */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $hcEa1 = parcelRequire("hcEa1");
var $55APJ = parcelRequire("55APJ");

var $i4lVW = parcelRequire("i4lVW");


var $4RHqt = parcelRequire("4RHqt");
const $96fe13b066a8d20b$var$FPDnDCard = function FPDnDCard({ id: id, text: text, moveCard: moveCard, findCard: findCard }) {
    const originalIndex = findCard(id).index;
    const [{ isDragging: isDragging }, drag] = (0, $hcEa1.useDrag)(()=>({
            type: (0, $i4lVW.default).CARD,
            item: {
                id: id,
                originalIndex: originalIndex
            },
            collect: (monitor)=>({
                    isDragging: monitor.isDragging()
                }),
            end: (item, monitor)=>{
                const { id: droppedId, originalIndex: originalIndex } = item;
                const didDrop = monitor.didDrop();
                if (!didDrop) moveCard(droppedId, originalIndex);
            }
        }), [
        id,
        originalIndex,
        moveCard
    ]);
    const [, drop] = (0, $55APJ.useDrop)(()=>({
            accept: (0, $i4lVW.default).CARD,
            canDrop: ()=>false,
            hover ({ id: draggedId }) {
                if (draggedId !== id) {
                    const { index: overIndex } = findCard(id);
                    moveCard(draggedId, overIndex);
                }
            }
        }), [
        findCard,
        moveCard
    ]);
    const opacity = isDragging ? 0.5 : 1;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: (node)=>drag(drop(node)),
        style: {
            opacity: opacity
        },
        className: "results-card",
        "data-testid": `card-${id}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "grid-icon--container",
                "data-testid": "grid-icon--container",
                onTouchStart: (e)=>e.preventDefault(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: $4RHqt['dnd-icon'],
                    alt: "",
                    role: "presentation",
                    className: "grid-icon",
                    onContextMenu: (e)=>e.preventDefault()
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "results-card-image",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: $4RHqt[`${id}`],
                    alt: "",
                    role: "presentation"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "results-card-text",
                children: text
            })
        ]
    });
};
$96fe13b066a8d20b$var$FPDnDCard.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    moveCard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    findCard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $96fe13b066a8d20b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($96fe13b066a8d20b$var$FPDnDCard);

});
parcelRegister("i4lVW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aee4e1616aebfc8$export$2e2bcd8739ae039);
const $0aee4e1616aebfc8$var$FPItemTypes = {
    CARD: 'card'
};
var $0aee4e1616aebfc8$export$2e2bcd8739ae039 = $0aee4e1616aebfc8$var$FPItemTypes;

});

parcelRegister("4RHqt", function(module, exports) {

var $7X35N = parcelRequire("7X35N");

var $dlmpu = parcelRequire("dlmpu");

var $7ODq2 = parcelRequire("7ODq2");

var $428EK = parcelRequire("428EK");

var $2AuuH = parcelRequire("2AuuH");

var $d9Yau = parcelRequire("d9Yau");

var $fTRLW = parcelRequire("fTRLW");

var $cQnS8 = parcelRequire("cQnS8");

var $57Z8j = parcelRequire("57Z8j");

var $jBAlZ = parcelRequire("jBAlZ");

var $emiSf = parcelRequire("emiSf");

var $03Vb0 = parcelRequire("03Vb0");

var $kOcb8 = parcelRequire("kOcb8");

var $ar2KL = parcelRequire("ar2KL");

var $hSA0Q = parcelRequire("hSA0Q");

var $a96nb = parcelRequire("a96nb");

var $exbDH = parcelRequire("exbDH");
module.exports = {
    "0": $7X35N,
    "1": $dlmpu,
    "2": $7ODq2,
    "3": $428EK,
    "4": $2AuuH,
    "5": $d9Yau,
    "6": $fTRLW,
    "7": $cQnS8,
    "8": $57Z8j,
    "9": $jBAlZ,
    "10": $emiSf,
    "11": $03Vb0,
    "12": $kOcb8,
    "13": $ar2KL,
    "14": $hSA0Q,
    "15": $a96nb,
    "dnd-icon": $exbDH
};

});



parcelRegister("etP3u", function(module, exports) {

$parcel$export(module.exports, "default", () => $1501bc0fcb0134c9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $c9Z8w = parcelRequire("c9Z8w");

const $1501bc0fcb0134c9$var$PlanningTopicsInfo = (props)=>{
    const { topicTitle: topicTitle, topicTitleId: topicTitleId, color: color } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "card",
        "data-testid": `planningTopicsInfoCard-${topicTitleId}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "card-header",
                style: {
                    backgroundColor: color
                },
                "data-testid": "planningTopicsInfoHeader"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "card-text",
                children: topicTitle
            })
        ]
    });
};
$1501bc0fcb0134c9$var$PlanningTopicsInfo.propTypes = {
    topicTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    topicTitleId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};
var $1501bc0fcb0134c9$export$2e2bcd8739ae039 = $1501bc0fcb0134c9$var$PlanningTopicsInfo;

});


parcelRegister("2nkQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $53523bb085a95825$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9Ryut = parcelRequire("9Ryut");


var $iJxY6 = parcelRequire("iJxY6");
/**
 * JonesFooter is the EJ Footer consistent across all screens and customized for US or Canadian users
 */ const $53523bb085a95825$var$JonesFooter = ()=>{
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const handleCopyrightText = ()=>{
        const component = locId === 'en_US' ? 'copyrightParagraph' : 'line2';
        return (0, $iJxY6.default)(locId, component, 'footer').replace('%CURRENT_YEAR%', new Date().getFullYear().toString());
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("footer", {
        role: "contentinfo",
        id: "footerBox",
        "data-testid": "jonesFooter",
        children: locId === 'en_US' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "footerContainer",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "links",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'careersLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'careersText', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'personalFinanceLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'personalFinanceText', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'feedbackLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'feedbackText', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'privacyLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'privacyText', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'revenueSharingLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'revenueSharingText', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'formCrsLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'formCrsText', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'disclosuresLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'disclosuresText', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'accessibilityLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'accessibilityText', 'footer')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "footerContent",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            handleCopyrightText(),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                title: (0, $iJxY6.default)(locId, 'sipcText', 'footer'),
                                className: "copyrightLink",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                href: (0, $iJxY6.default)(locId, 'sipcLink', 'footer'),
                                children: (0, $iJxY6.default)(locId, 'sipcText', 'footer')
                            }),
                            ".",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            (0, $iJxY6.default)(locId, 'disclaimerParagraph', 'footer')
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "footerContainer",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "links",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'careersLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'careersText', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'feedbackLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'feedbackText', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'privacyLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'privacyText', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'disclosuresLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'disclosuresText', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: (0, $iJxY6.default)(locId, 'accessibilityLink', 'footer'),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $iJxY6.default)(locId, 'accessibilityText', 'footer')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "footerContent",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            children: [
                                (0, $iJxY6.default)(locId, 'member', 'footer'),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    title: (0, $iJxY6.default)(locId, 'CIPFText', 'footer'),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: (0, $iJxY6.default)(locId, 'CIPFLink', 'footer'),
                                    children: (0, $iJxY6.default)(locId, 'CIPFText', 'footer')
                                }),
                                (0, $iJxY6.default)(locId, 'member2', 'footer'),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    title: (0, $iJxY6.default)(locId, 'IIROCText', 'footer'),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: (0, $iJxY6.default)(locId, 'IIROCLink', 'footer'),
                                    children: (0, $iJxY6.default)(locId, 'IIROCText', 'footer')
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: (0, $iJxY6.default)(locId, 'line1', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: handleCopyrightText()
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: (0, $iJxY6.default)(locId, 'line3', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: (0, $iJxY6.default)(locId, 'line4', 'footer')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: (0, $iJxY6.default)(locId, 'line5', 'footer')
                        })
                    ]
                })
            ]
        })
    });
};
var $53523bb085a95825$export$2e2bcd8739ae039 = $53523bb085a95825$var$JonesFooter;

});

parcelRegister("6Pn7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $53d50f86e43f88d6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $53d50f86e43f88d6$var$FeatureContext = (0, $acw62.createContext)(null);
var $53d50f86e43f88d6$export$2e2bcd8739ae039 = $53d50f86e43f88d6$var$FeatureContext;

});

parcelRegister("4zYrm", function(module, exports) {

$parcel$export(module.exports, "default", () => $99bb8a6251bbb739$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $i8Fxz = parcelRequire("i8Fxz");

var $7lk71 = parcelRequire("7lk71");


var $iJxY6 = parcelRequire("iJxY6");

var $l19uC = parcelRequire("l19uC");

var $9Ryut = parcelRequire("9Ryut");

var $c9Z8w = parcelRequire("c9Z8w");
const $99bb8a6251bbb739$var$LanguageSelect = (props)=>{
    const { addBeforeUnloadEventListener: addBeforeUnloadEventListener, removeBeforeUnloadEventListener: removeBeforeUnloadEventListener } = props;
    const locId = (0, $acw62.useContext)((0, $9Ryut.default));
    const [showConfirmDialog, setShowConfirmDialog] = (0, $acw62.useState)(false);
    const [url, setUrl] = (0, $acw62.useState)("");
    const initialStateStatusOptions = [
        {
            name: "select language",
            selected: true,
            value: "select",
            disabled: false
        }
    ];
    const [options, setOptions] = (0, $acw62.useState)(initialStateStatusOptions);
    const handleCancel = ()=>{
        setOptions(getOptions());
        setShowConfirmDialog(false);
    };
    const INTEG_GATEWAY_URL_REGEX = /\.apps2\.devjones\.com$/;
    const UAT_GATEWAY_URL_REGEX = /\.apps2\.uat\.edwardjones\.com$/;
    const PROD_GATEWAY_URL_REGEX = /\.apps2\.edwardjones\.com$/;
    const UAT_LANGUAGE_URL_REGEX = /\.uat\.edwardjones\.ca$/;
    const PROD_LANGUAGE_URL_REGEX = /\.edwardjones\.ca$/;
    const UAT_EXTERNAL_TEST_URL_REGEX = /-uat\.testjones\.net$/;
    const PREPROD_EXTERNAL_TEST_URL_REGEX = /\.testjones\.net$/;
    const getSelectLanguageUrls = ()=>{
        const { hostname: hostname } = window.location;
        if (INTEG_GATEWAY_URL_REGEX.test(hostname)) return `https://prp-mypriorities-gtwy.apps2.devjones.com?locale=${0, $l19uC.LOCALE_EN_CA},https://prp-mypriorities-gtwy.apps2.devjones.com?locale=${0, $l19uC.LOCALE_FR_CA}`;
        else if (UAT_GATEWAY_URL_REGEX.test(hostname)) return `https://prp-mypriorities-gtwy.apps2.uat.edwardjones.com?locale=${0, $l19uC.LOCALE_EN_CA},https://prp-mypriorities-gtwy.apps2.uat.edwardjones.com?locale=${0, $l19uC.LOCALE_FR_CA}`;
        else if (PROD_GATEWAY_URL_REGEX.test(hostname)) return `https://prp-mypriorities-gtwy.apps2.edwardjones.com?locale=${0, $l19uC.LOCALE_EN_CA},https://prp-mypriorities-gtwy.apps2.edwardjones.com?locale=${0, $l19uC.LOCALE_FR_CA}`;
        else if (UAT_LANGUAGE_URL_REGEX.test(hostname)) return 'https://mypriorities.uat.edwardjones.ca,https://mespriorites.uat.edwardjones.ca';
        else if (PROD_LANGUAGE_URL_REGEX.test(hostname)) return 'https://mypriorities.edwardjones.ca,https://mespriorites.edwardjones.ca';
        else if (UAT_EXTERNAL_TEST_URL_REGEX.test(hostname)) return `https://mypriorities-uat.testjones.net?locale=${0, $l19uC.LOCALE_EN_CA},https://mypriorities-uat.testjones.net?locale=${0, $l19uC.LOCALE_FR_CA}`;
        else if (PREPROD_EXTERNAL_TEST_URL_REGEX.test(hostname)) return `https://mypriorities.testjones.net?locale=${0, $l19uC.LOCALE_EN_CA},https://mypriorities.testjones.net?locale=${0, $l19uC.LOCALE_FR_CA}`;
        else return `http://localhost:1234/ca-en/index.html?locale=${0, $l19uC.LOCALE_EN_CA},http://localhost:1234/ca-fr/index.html?locale=${0, $l19uC.LOCALE_FR_CA}`;
    };
    const displayDialog = (value)=>{
        setShowConfirmDialog(true);
        setUrl(value);
    };
    const handleLeave = ()=>{
        setShowConfirmDialog(false);
        const queryParams = new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($i8Fxz))).sanitize(window.location.search));
        let redirectUrl = url;
        queryParams.delete('locale');
        if (Array.from(queryParams).length > 0) {
            if (url.includes('?')) redirectUrl = url.concat('&', queryParams.toString());
            else redirectUrl = url.concat('?', queryParams.toString());
        }
        window.location.replace(redirectUrl);
    };
    const getOptions = ()=>{
        const options = [];
        const languageSelectTexts = (0, $iJxY6.default)(locId, 'languageSelectTexts', 'LanguageSelect').split(',');
        const languageSelectUrls = getSelectLanguageUrls().split(',');
        const languageSelectTextDefault = (0, $iJxY6.default)(locId, 'languageSelectTextDefault', 'LanguageSelect');
        for(let index = 0; index < languageSelectTexts.length; index++){
            const languageText = languageSelectTexts[index];
            const languageUrl = languageSelectUrls[index];
            const option = {
                name: languageText,
                selected: languageText === languageSelectTextDefault,
                value: languageUrl,
                disabled: false
            };
            options.push(option);
        }
        return options;
    };
    (0, $acw62.useEffect)(()=>{
        if (locId === (0, $l19uC.LOCALE_EN_CA) || locId === (0, $l19uC.LOCALE_FR_CA)) setOptions(getOptions());
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (locId === (0, $l19uC.LOCALE_EN_CA) || locId === (0, $l19uC.LOCALE_FR_CA)) {
            if (showConfirmDialog) removeBeforeUnloadEventListener();
            else addBeforeUnloadEventListener();
        }
    }, [
        showConfirmDialog
    ]);
    return locId === (0, $l19uC.LOCALE_EN_CA) || locId === (0, $l19uC.LOCALE_FR_CA) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "language-select",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "language-select--select-input",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.SelectInput), {
                    id: "language-select-input",
                    label: (0, $iJxY6.default)(locId, 'languageSelectLabel', 'LanguageSelect'),
                    name: "language-select-input",
                    onSelect: (value)=>{
                        displayDialog(value);
                    },
                    options: options
                }),
                showConfirmDialog && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Dialog), {
                    className: "dialog",
                    ariaDescribedBy: "cancel-dialogue",
                    open: showConfirmDialog,
                    buttons: [
                        {
                            onClick: ()=>{
                                handleCancel();
                            },
                            text: (0, $iJxY6.default)(locId, 'languageDialogCancel', 'LanguageSelect')
                        },
                        {
                            attributes: {
                                value: 'continue'
                            },
                            onClick: ()=>handleLeave(),
                            styleVariant: 'primary',
                            text: (0, $iJxY6.default)(locId, 'languageDialogLeave', 'LanguageSelect')
                        }
                    ],
                    onRequestClose: ()=>{
                        handleCancel();
                    },
                    title: "",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dialog-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dialog-content--icon-container",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lk71.Icon), {
                                    name: "notice-warning"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "dialog-content--content-container",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "dialog-content--content-container--dialog-title dialog-content-title-font",
                                        children: (0, $iJxY6.default)(locId, 'languageDialogQuestion1', 'LanguageSelect')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "dialog-content--content-container--dialog-title dialog-content-font",
                                        children: (0, $iJxY6.default)(locId, 'languageDialogQuestion2', 'LanguageSelect')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "dialog-content-title-font",
                                        children: (0, $iJxY6.default)(locId, 'languageDialogTitle1', 'LanguageSelect')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "dialog-content-font",
                                        children: (0, $iJxY6.default)(locId, 'languageDialogTitle2', 'LanguageSelect')
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
};
$99bb8a6251bbb739$var$LanguageSelect.propTypes = {
    addBeforeUnloadEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    removeBeforeUnloadEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $99bb8a6251bbb739$export$2e2bcd8739ae039 = $99bb8a6251bbb739$var$LanguageSelect;

});
parcelRegister("i8Fxz", function(module, exports) {
/*! @license DOMPurify 3.3.2 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.2/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'search',
        'section',
        'select',
        'shadow',
        'slot',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'enterkeyhint',
        'exportparts',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'inputmode',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'part',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'exportparts',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inert',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'part',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'mask-type',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.3.2';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = create(null);
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Prevent function-based ADD_ATTR / ADD_TAGS from leaking across calls */ if (!objectHasOwnProperty(cfg, 'ADD_TAGS')) EXTRA_ELEMENT_HANDLING.tagCheck = null;
            if (!objectHasOwnProperty(cfg, 'ADD_ATTR')) EXTRA_ELEMENT_HANDLING.attributeCheck = null;
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (cfg.ADD_ATTR) {
                if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            if (cfg.ADD_FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName])) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === 'value' ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && stringMatch(value, 'href')) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {
                    _removeAttribute(name, currentNode);
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});


parcelRegister("7vUZe", function(module, exports) {

$parcel$export(module.exports, "default", () => $016437b1b8d14bbb$export$2e2bcd8739ae039);

var $kMrYv = parcelRequire("kMrYv");
const $016437b1b8d14bbb$var$getUserPersonaType = (faNumber, entityID, contactID, contactType, createTimeStamp, utmSource, locale)=>{
    if (locale === 'en_US') {
        if (faNumber) {
            if (contactID) {
                if (utmSource === 'ff') return (0, $kMrYv.default).FINANCIAL_FOUNDATION;
                if (contactType && createTimeStamp) {
                    if (utmSource === 'newsletter' && contactType === 'C') return (0, $kMrYv.default).NEWS_LETTER;
                    return (0, $kMrYv.default).WORD_POWER;
                }
            }
            return (0, $kMrYv.default).PERSONAL_LINK;
        }
        if (entityID) return (0, $kMrYv.default).PERSONAL_LINK_FA_PROFILE;
    }
    if (locale === 'en_CA' || locale === 'fr_CA') {
        if (faNumber) {
            if (contactID) {
                if (locale === 'en_CA' && utmSource === 'ff') return (0, $kMrYv.default).FINANCIAL_FOUNDATION_CA;
                if (contactType && createTimeStamp) {
                    if (utmSource === 'newsletter' && contactType === 'C') return (0, $kMrYv.default).NEWS_LETTER_CA;
                    return (0, $kMrYv.default).WORD_POWER_CA;
                }
            }
            return (0, $kMrYv.default).PERSONAL_LINK_CA;
        }
        if (entityID) return (0, $kMrYv.default).PERSONAL_LINK_FA_PROFILE_CA;
        return (0, $kMrYv.default).DIRECT_URL_CA;
    }
    return (0, $kMrYv.default).DIRECT_URL;
};
var $016437b1b8d14bbb$export$2e2bcd8739ae039 = $016437b1b8d14bbb$var$getUserPersonaType;

});

parcelRegister("bbCv6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b82f42bc32e91a2$export$2e2bcd8739ae039);
// Source: https://medium.com/@adames/generating-unique-ids-4c18dcf26a79
function $2b82f42bc32e91a2$var$generateUUID() {
    if (typeof globalThis.crypto !== 'undefined' && typeof globalThis.crypto.randomUUID === 'function') return globalThis.crypto.randomUUID();
    const bytes = new Uint8Array(16);
    globalThis.crypto.getRandomValues(bytes);
    // Per RFC 4122 section 4.4, set version to 4 and variant to 10xx.
    bytes[6] = bytes[6] & 0x0f | 0x40;
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const hex = Array.from(bytes, (byte)=>byte.toString(16).padStart(2, '0'));
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`;
}
var $2b82f42bc32e91a2$export$2e2bcd8739ae039 = $2b82f42bc32e91a2$var$generateUUID;

});


parcelRegister("aRPiL", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;

});


var $91ec4909ea40b136$exports = {};
$parcel$extendImportMap({
    "cZyW1": "0.ca7054a9.png",
    "9ukTJ": "1.41b045af.png",
    "7XYOj": "2.22086311.png",
    "1HMa7": "3.090113a7.png",
    "eXSkc": "4.757a1aaf.png",
    "k3pgF": "5.d1781e0d.png",
    "ggarB": "6.af702ba6.png",
    "kGZum": "7.cb4b034d.png",
    "f5fsq": "8.7f75a529.png",
    "gEHFQ": "9.19022aae.png",
    "jmD52": "10.589ce342.png",
    "7QXfa": "11.ff885a13.png",
    "fB4Nx": "12.31651f6e.png",
    "cXffW": "13.3194e124.png",
    "7WeNu": "14.49e4818b.png",
    "3MeVc": "15.5396e17c.png",
    "di0eo": "dnd-icon.22958fb7.png",
    "jTbp6": "0.253b8709.png",
    "4VsGu": "1.669869e2.png",
    "cMm2I": "2.9889149f.png",
    "2prqY": "3.b86fc98d.png",
    "jrm6c": "4.fb42dd05.png",
    "80mqb": "5.99c37529.png",
    "jOIzf": "6.0c345577.png",
    "5ZfJZ": "7.d7fc9f98.png",
    "h6teb": "8.f2e67a57.png",
    "kE3p8": "9.743a8c0e.png",
    "5YJAF": "10.9b50821e.png",
    "8kCQJ": "11.f6163619.png",
    "gW96p": "12.1fa42664.png",
    "9eLnP": "13.efe4f37e.png",
    "2w91T": "14.e877266f.png",
    "EuxKH": "15.924b9e31.png",
    "5unre": "dnd-icon.a5c28dc9.png"
});


//# sourceMappingURL=ca-en.a18e6421.js.map
